/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(6);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(7);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(345);
	
	var _redux = __webpack_require__(407);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _reduxThunk = __webpack_require__(456);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _logrocket = __webpack_require__(457);
	
	var _logrocket2 = _interopRequireDefault(_logrocket);
	
	var _crashReporter = __webpack_require__(458);
	
	var _crashReporter2 = _interopRequireDefault(_crashReporter);
	
	var _storage = __webpack_require__(460);
	
	var _reducers = __webpack_require__(461);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _analytics = __webpack_require__(473);
	
	var _gaActions = __webpack_require__(474);
	
	var _HomeScreen = __webpack_require__(488);
	
	var _HomeScreen2 = _interopRequireDefault(_HomeScreen);
	
	var _constants = __webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useLogRocket = Farmigo.serverData.isProduction && Farmigo.serverData.customerTier === 'A';
	if (useLogRocket) {
	    _logrocket2.default.init('farmigo/farms-new-ui', { shouldShowReportingButton: false, uploadTimeInterval: 10000, network: {
	            requestSanitizer: function requestSanitizer(request) {
	                if (request.url.indexOf("AuthenticationService") !== -1 || request.url.indexOf("MembersService") !== -1 || request.url.indexOf("updateMember") !== -1 || request.url.indexOf("ACH") !== -1 || request.url.indexOf("Echeck") !== -1) {
	                    request.body = null;
	                }
	                return request;
	            }
	        } });
	    if (typeof Raven !== 'undefined') Raven.setDataCallback(function (data) {
	        data.extra.sessionURL = _logrocket2.default.sessionURL;return data;
	    });
	}
	//Initi GA with farm tracking ID
	(0, _analytics.initializeGoogleAnalytics)(Farmigo.serverData.farmGATrackingID, Farmigo.serverData.farmName, Farmigo.serverData.seasonTitle, Farmigo.serverData.farmWebSiteUrl);
	
	var initialState = (0, _storage.getStateFromStorage)();
	// Add the reducer to your store on the `routing` key
	var store = (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory), _crashReporter2.default /*, deepFreezeMiddleware*/), window.devToolsExtension ? window.devToolsExtension() : function (f) {
	    return f;
	}, useLogRocket ? _logrocket2.default.reduxEnhancer() : function (f) {
	    return f;
	}));
	
	//Trigger for storing the state in storage
	store.subscribe(function () {
	    var state = store.getState();
	    if (state.storage.timestamp) (0, _storage.setStateInStorge)(store.getState(), state.storage.timestamp);
	});
	
	// Create an enhanced history that syncs navigation events with the store
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	// Send GA Pageviews
	history.listen(function (location) {
	    return store.dispatch((0, _gaActions.trackGAPageView)(location.pathname));
	});
	var storeUrl = "/" + _constants.URLs.STORE + "*";
	var joinUrl = "/" + _constants.URLs.JOIN + "*";
	var accountUrl = "/" + _constants.URLs.ACCOUNT + "*";
	var payUrl = "/" + _constants.URLs.PAY + "*";
	var chargeUrl = "/" + _constants.URLs.CHARGE + "*";
	
	_reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(
	        _reactRouter.Router,
	        { history: history },
	        _react2.default.createElement(_reactRouter.Route, { path: storeUrl, component: _HomeScreen2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: joinUrl, component: _HomeScreen2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: accountUrl, component: _HomeScreen2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: payUrl, component: _HomeScreen2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: chargeUrl, component: _HomeScreen2.default })
	    )
	), document.getElementById('root'));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(334);
	
	__webpack_require__(335);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(9);
	__webpack_require__(59);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(64);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(69);
	__webpack_require__(70);
	__webpack_require__(71);
	__webpack_require__(72);
	__webpack_require__(73);
	__webpack_require__(74);
	__webpack_require__(76);
	__webpack_require__(78);
	__webpack_require__(80);
	__webpack_require__(82);
	__webpack_require__(85);
	__webpack_require__(86);
	__webpack_require__(87);
	__webpack_require__(91);
	__webpack_require__(93);
	__webpack_require__(95);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(103);
	__webpack_require__(104);
	__webpack_require__(105);
	__webpack_require__(106);
	__webpack_require__(107);
	__webpack_require__(108);
	__webpack_require__(109);
	__webpack_require__(111);
	__webpack_require__(112);
	__webpack_require__(113);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(119);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(128);
	__webpack_require__(129);
	__webpack_require__(130);
	__webpack_require__(131);
	__webpack_require__(132);
	__webpack_require__(133);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(159);
	__webpack_require__(160);
	__webpack_require__(161);
	__webpack_require__(162);
	__webpack_require__(164);
	__webpack_require__(165);
	__webpack_require__(167);
	__webpack_require__(168);
	__webpack_require__(174);
	__webpack_require__(175);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(186);
	__webpack_require__(187);
	__webpack_require__(189);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(195);
	__webpack_require__(197);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(201);
	__webpack_require__(203);
	__webpack_require__(205);
	__webpack_require__(207);
	__webpack_require__(208);
	__webpack_require__(209);
	__webpack_require__(213);
	__webpack_require__(214);
	__webpack_require__(215);
	__webpack_require__(217);
	__webpack_require__(227);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(260);
	__webpack_require__(262);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(268);
	__webpack_require__(269);
	__webpack_require__(270);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(277);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(290);
	__webpack_require__(291);
	__webpack_require__(293);
	__webpack_require__(294);
	__webpack_require__(295);
	__webpack_require__(296);
	__webpack_require__(298);
	__webpack_require__(299);
	__webpack_require__(300);
	__webpack_require__(301);
	__webpack_require__(302);
	__webpack_require__(303);
	__webpack_require__(304);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(309);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(314);
	__webpack_require__(315);
	__webpack_require__(316);
	__webpack_require__(317);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(321);
	__webpack_require__(322);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(327);
	__webpack_require__(328);
	__webpack_require__(329);
	__webpack_require__(330);
	__webpack_require__(331);
	__webpack_require__(332);
	__webpack_require__(333);
	module.exports = __webpack_require__(15);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(10);
	var has = __webpack_require__(11);
	var DESCRIPTORS = __webpack_require__(12);
	var $export = __webpack_require__(14);
	var redefine = __webpack_require__(24);
	var META = __webpack_require__(31).KEY;
	var $fails = __webpack_require__(13);
	var shared = __webpack_require__(27);
	var setToStringTag = __webpack_require__(32);
	var uid = __webpack_require__(25);
	var wks = __webpack_require__(33);
	var wksExt = __webpack_require__(34);
	var wksDefine = __webpack_require__(35);
	var enumKeys = __webpack_require__(36);
	var isArray = __webpack_require__(51);
	var anObject = __webpack_require__(18);
	var isObject = __webpack_require__(19);
	var toObject = __webpack_require__(52);
	var toIObject = __webpack_require__(39);
	var toPrimitive = __webpack_require__(22);
	var createDesc = __webpack_require__(23);
	var _create = __webpack_require__(53);
	var gOPNExt = __webpack_require__(56);
	var $GOPD = __webpack_require__(58);
	var $GOPS = __webpack_require__(49);
	var $DP = __webpack_require__(17);
	var $keys = __webpack_require__(37);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(57).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(50).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(28)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(16)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(13)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var core = __webpack_require__(15);
	var hide = __webpack_require__(16);
	var redefine = __webpack_require__(24);
	var ctx = __webpack_require__(29);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(17);
	var createDesc = __webpack_require__(23);
	module.exports = __webpack_require__(12) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(18);
	var IE8_DOM_DEFINE = __webpack_require__(20);
	var toPrimitive = __webpack_require__(22);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(12) && !__webpack_require__(13)(function () {
	  return Object.defineProperty(__webpack_require__(21)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	var document = __webpack_require__(10).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(19);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var hide = __webpack_require__(16);
	var has = __webpack_require__(11);
	var SRC = __webpack_require__(25)('src');
	var $toString = __webpack_require__(26);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(15).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(27)('native-function-to-string', Function.toString);


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(15);
	var global = __webpack_require__(10);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(28) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(30);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(25)('meta');
	var isObject = __webpack_require__(19);
	var has = __webpack_require__(11);
	var setDesc = __webpack_require__(17).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(13)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(17).f;
	var has = __webpack_require__(11);
	var TAG = __webpack_require__(33)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(27)('wks');
	var uid = __webpack_require__(25);
	var Symbol = __webpack_require__(10).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(33);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var core = __webpack_require__(15);
	var LIBRARY = __webpack_require__(28);
	var wksExt = __webpack_require__(34);
	var defineProperty = __webpack_require__(17).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(37);
	var gOPS = __webpack_require__(49);
	var pIE = __webpack_require__(50);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(38);
	var enumBugKeys = __webpack_require__(48);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(11);
	var toIObject = __webpack_require__(39);
	var arrayIndexOf = __webpack_require__(43)(false);
	var IE_PROTO = __webpack_require__(47)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(40);
	var defined = __webpack_require__(42);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(41);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(39);
	var toLength = __webpack_require__(44);
	var toAbsoluteIndex = __webpack_require__(46);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(45);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(45);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(27)('keys');
	var uid = __webpack_require__(25);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(41);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(42);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(18);
	var dPs = __webpack_require__(54);
	var enumBugKeys = __webpack_require__(48);
	var IE_PROTO = __webpack_require__(47)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(21)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(55).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(17);
	var anObject = __webpack_require__(18);
	var getKeys = __webpack_require__(37);
	
	module.exports = __webpack_require__(12) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(10).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(39);
	var gOPN = __webpack_require__(57).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(38);
	var hiddenKeys = __webpack_require__(48).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(50);
	var createDesc = __webpack_require__(23);
	var toIObject = __webpack_require__(39);
	var toPrimitive = __webpack_require__(22);
	var has = __webpack_require__(11);
	var IE8_DOM_DEFINE = __webpack_require__(20);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(53) });


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperty: __webpack_require__(17).f });


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperties: __webpack_require__(54) });


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(39);
	var $getOwnPropertyDescriptor = __webpack_require__(58).f;
	
	__webpack_require__(63)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(14);
	var core = __webpack_require__(15);
	var fails = __webpack_require__(13);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(52);
	var $getPrototypeOf = __webpack_require__(65);
	
	__webpack_require__(63)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(11);
	var toObject = __webpack_require__(52);
	var IE_PROTO = __webpack_require__(47)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(52);
	var $keys = __webpack_require__(37);
	
	__webpack_require__(63)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(63)('getOwnPropertyNames', function () {
	  return __webpack_require__(56).f;
	});


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(19);
	var meta = __webpack_require__(31).onFreeze;
	
	__webpack_require__(63)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(19);
	var meta = __webpack_require__(31).onFreeze;
	
	__webpack_require__(63)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(19);
	var meta = __webpack_require__(31).onFreeze;
	
	__webpack_require__(63)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(19);
	
	__webpack_require__(63)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(19);
	
	__webpack_require__(63)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(19);
	
	__webpack_require__(63)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(14);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(75) });


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(12);
	var getKeys = __webpack_require__(37);
	var gOPS = __webpack_require__(49);
	var pIE = __webpack_require__(50);
	var toObject = __webpack_require__(52);
	var IObject = __webpack_require__(40);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(13)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(14);
	$export($export.S, 'Object', { is: __webpack_require__(77) });


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(14);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(79).set });


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(19);
	var anObject = __webpack_require__(18);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(29)(Function.call, __webpack_require__(58).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(81);
	var test = {};
	test[__webpack_require__(33)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(24)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(41);
	var TAG = __webpack_require__(33)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(14);
	
	$export($export.P, 'Function', { bind: __webpack_require__(83) });


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(30);
	var isObject = __webpack_require__(19);
	var invoke = __webpack_require__(84);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(17).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(12) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(19);
	var getPrototypeOf = __webpack_require__(65);
	var HAS_INSTANCE = __webpack_require__(33)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(17).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	var $parseInt = __webpack_require__(88);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(10).parseInt;
	var $trim = __webpack_require__(89).trim;
	var ws = __webpack_require__(90);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	var defined = __webpack_require__(42);
	var fails = __webpack_require__(13);
	var spaces = __webpack_require__(90);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	var $parseFloat = __webpack_require__(92);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(10).parseFloat;
	var $trim = __webpack_require__(89).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(90) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(10);
	var has = __webpack_require__(11);
	var cof = __webpack_require__(41);
	var inheritIfRequired = __webpack_require__(94);
	var toPrimitive = __webpack_require__(22);
	var fails = __webpack_require__(13);
	var gOPN = __webpack_require__(57).f;
	var gOPD = __webpack_require__(58).f;
	var dP = __webpack_require__(17).f;
	var $trim = __webpack_require__(89).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(53)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(12) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(24)(global, NUMBER, $Number);
	}


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	var setPrototypeOf = __webpack_require__(79).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var toInteger = __webpack_require__(45);
	var aNumberValue = __webpack_require__(96);
	var repeat = __webpack_require__(97);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(13)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(41);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(45);
	var defined = __webpack_require__(42);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var $fails = __webpack_require__(13);
	var aNumberValue = __webpack_require__(96);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(14);
	var _isFinite = __webpack_require__(10).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(102) });


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(19);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(14);
	var isInteger = __webpack_require__(102);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	var $parseFloat = __webpack_require__(92);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	var $parseInt = __webpack_require__(88);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(14);
	var log1p = __webpack_require__(110);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(14);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(14);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(14);
	var sign = __webpack_require__(114);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(14);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(14);
	var $expm1 = __webpack_require__(118);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', { fround: __webpack_require__(120) });


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(114);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(14);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(14);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(13)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(110) });


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', { sign: __webpack_require__(114) });


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(14);
	var expm1 = __webpack_require__(118);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(13)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(14);
	var expm1 = __webpack_require__(118);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	var toAbsoluteIndex = __webpack_require__(46);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	var toIObject = __webpack_require__(39);
	var toLength = __webpack_require__(44);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(89)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(134)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(135)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(45);
	var defined = __webpack_require__(42);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(28);
	var $export = __webpack_require__(14);
	var redefine = __webpack_require__(24);
	var hide = __webpack_require__(16);
	var Iterators = __webpack_require__(136);
	var $iterCreate = __webpack_require__(137);
	var setToStringTag = __webpack_require__(32);
	var getPrototypeOf = __webpack_require__(65);
	var ITERATOR = __webpack_require__(33)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(53);
	var descriptor = __webpack_require__(23);
	var setToStringTag = __webpack_require__(32);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(16)(IteratorPrototype, __webpack_require__(33)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var $at = __webpack_require__(134)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(14);
	var toLength = __webpack_require__(44);
	var context = __webpack_require__(140);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(142)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(141);
	var defined = __webpack_require__(42);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(19);
	var cof = __webpack_require__(41);
	var MATCH = __webpack_require__(33)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(33)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(14);
	var context = __webpack_require__(140);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(142)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(97)
	});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(14);
	var toLength = __webpack_require__(44);
	var context = __webpack_require__(140);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(142)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(147)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	var fails = __webpack_require__(13);
	var defined = __webpack_require__(42);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(147)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(147)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(147)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(147)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(147)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(147)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(147)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(147)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(147)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(147)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(147)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(147)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var toObject = __webpack_require__(52);
	var toPrimitive = __webpack_require__(22);
	
	$export($export.P + $export.F * __webpack_require__(13)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(14);
	var toISOString = __webpack_require__(163);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(13);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(24)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(33)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(16)(proto, TO_PRIMITIVE, __webpack_require__(166));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(22);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(51) });


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(29);
	var $export = __webpack_require__(14);
	var toObject = __webpack_require__(52);
	var call = __webpack_require__(169);
	var isArrayIter = __webpack_require__(170);
	var toLength = __webpack_require__(44);
	var createProperty = __webpack_require__(171);
	var getIterFn = __webpack_require__(172);
	
	$export($export.S + $export.F * !__webpack_require__(173)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(18);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(136);
	var ITERATOR = __webpack_require__(33)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(17);
	var createDesc = __webpack_require__(23);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(81);
	var ITERATOR = __webpack_require__(33)('iterator');
	var Iterators = __webpack_require__(136);
	module.exports = __webpack_require__(15).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(33)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var createProperty = __webpack_require__(171);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(13)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(14);
	var toIObject = __webpack_require__(39);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(40) != Object || !__webpack_require__(176)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(13);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var html = __webpack_require__(55);
	var cof = __webpack_require__(41);
	var toAbsoluteIndex = __webpack_require__(46);
	var toLength = __webpack_require__(44);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(13)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var aFunction = __webpack_require__(30);
	var toObject = __webpack_require__(52);
	var fails = __webpack_require__(13);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(176)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var $forEach = __webpack_require__(180)(0);
	var STRICT = __webpack_require__(176)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(29);
	var IObject = __webpack_require__(40);
	var toObject = __webpack_require__(52);
	var toLength = __webpack_require__(44);
	var asc = __webpack_require__(181);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(182);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	var isArray = __webpack_require__(51);
	var SPECIES = __webpack_require__(33)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var $map = __webpack_require__(180)(1);
	
	$export($export.P + $export.F * !__webpack_require__(176)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var $filter = __webpack_require__(180)(2);
	
	$export($export.P + $export.F * !__webpack_require__(176)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var $some = __webpack_require__(180)(3);
	
	$export($export.P + $export.F * !__webpack_require__(176)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var $every = __webpack_require__(180)(4);
	
	$export($export.P + $export.F * !__webpack_require__(176)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var $reduce = __webpack_require__(188);
	
	$export($export.P + $export.F * !__webpack_require__(176)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(30);
	var toObject = __webpack_require__(52);
	var IObject = __webpack_require__(40);
	var toLength = __webpack_require__(44);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var $reduce = __webpack_require__(188);
	
	$export($export.P + $export.F * !__webpack_require__(176)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var $indexOf = __webpack_require__(43)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(176)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var toIObject = __webpack_require__(39);
	var toInteger = __webpack_require__(45);
	var toLength = __webpack_require__(44);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(176)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(14);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(193) });
	
	__webpack_require__(194)('copyWithin');


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(52);
	var toAbsoluteIndex = __webpack_require__(46);
	var toLength = __webpack_require__(44);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(33)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(16)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(14);
	
	$export($export.P, 'Array', { fill: __webpack_require__(196) });
	
	__webpack_require__(194)('fill');


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(52);
	var toAbsoluteIndex = __webpack_require__(46);
	var toLength = __webpack_require__(44);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(14);
	var $find = __webpack_require__(180)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(194)(KEY);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(14);
	var $find = __webpack_require__(180)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(194)(KEY);


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(200)('Array');


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(10);
	var dP = __webpack_require__(17);
	var DESCRIPTORS = __webpack_require__(12);
	var SPECIES = __webpack_require__(33)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(194);
	var step = __webpack_require__(202);
	var Iterators = __webpack_require__(136);
	var toIObject = __webpack_require__(39);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(135)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var inheritIfRequired = __webpack_require__(94);
	var dP = __webpack_require__(17).f;
	var gOPN = __webpack_require__(57).f;
	var isRegExp = __webpack_require__(141);
	var $flags = __webpack_require__(204);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(12) && (!CORRECT_NEW || __webpack_require__(13)(function () {
	  re2[__webpack_require__(33)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(24)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(200)('RegExp');


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(18);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(206);
	__webpack_require__(14)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(204);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(208);
	var anObject = __webpack_require__(18);
	var $flags = __webpack_require__(204);
	var DESCRIPTORS = __webpack_require__(12);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(24)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(13)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(12) && /./g.flags != 'g') __webpack_require__(17).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(204)
	});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(18);
	var toLength = __webpack_require__(44);
	var advanceStringIndex = __webpack_require__(210);
	var regExpExec = __webpack_require__(211);
	
	// @@match logic
	__webpack_require__(212)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(134)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(81);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(205);
	var redefine = __webpack_require__(24);
	var hide = __webpack_require__(16);
	var fails = __webpack_require__(13);
	var defined = __webpack_require__(42);
	var wks = __webpack_require__(33);
	var regexpExec = __webpack_require__(206);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(18);
	var toObject = __webpack_require__(52);
	var toLength = __webpack_require__(44);
	var toInteger = __webpack_require__(45);
	var advanceStringIndex = __webpack_require__(210);
	var regExpExec = __webpack_require__(211);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(212)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(18);
	var sameValue = __webpack_require__(77);
	var regExpExec = __webpack_require__(211);
	
	// @@search logic
	__webpack_require__(212)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(141);
	var anObject = __webpack_require__(18);
	var speciesConstructor = __webpack_require__(216);
	var advanceStringIndex = __webpack_require__(210);
	var toLength = __webpack_require__(44);
	var callRegExpExec = __webpack_require__(211);
	var regexpExec = __webpack_require__(206);
	var fails = __webpack_require__(13);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(212)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(18);
	var aFunction = __webpack_require__(30);
	var SPECIES = __webpack_require__(33)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(28);
	var global = __webpack_require__(10);
	var ctx = __webpack_require__(29);
	var classof = __webpack_require__(81);
	var $export = __webpack_require__(14);
	var isObject = __webpack_require__(19);
	var aFunction = __webpack_require__(30);
	var anInstance = __webpack_require__(218);
	var forOf = __webpack_require__(219);
	var speciesConstructor = __webpack_require__(216);
	var task = __webpack_require__(220).set;
	var microtask = __webpack_require__(221)();
	var newPromiseCapabilityModule = __webpack_require__(222);
	var perform = __webpack_require__(223);
	var userAgent = __webpack_require__(224);
	var promiseResolve = __webpack_require__(225);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(33)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(226)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(32)($Promise, PROMISE);
	__webpack_require__(200)(PROMISE);
	Wrapper = __webpack_require__(15)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(173)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(29);
	var call = __webpack_require__(169);
	var isArrayIter = __webpack_require__(170);
	var anObject = __webpack_require__(18);
	var toLength = __webpack_require__(44);
	var getIterFn = __webpack_require__(172);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(29);
	var invoke = __webpack_require__(84);
	var html = __webpack_require__(55);
	var cel = __webpack_require__(21);
	var global = __webpack_require__(10);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(41)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var macrotask = __webpack_require__(220).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(41)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(30);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(18);
	var isObject = __webpack_require__(19);
	var newPromiseCapability = __webpack_require__(222);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(24);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(228);
	var validate = __webpack_require__(229);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(230)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(17).f;
	var create = __webpack_require__(53);
	var redefineAll = __webpack_require__(226);
	var ctx = __webpack_require__(29);
	var anInstance = __webpack_require__(218);
	var forOf = __webpack_require__(219);
	var $iterDefine = __webpack_require__(135);
	var step = __webpack_require__(202);
	var setSpecies = __webpack_require__(200);
	var DESCRIPTORS = __webpack_require__(12);
	var fastKey = __webpack_require__(31).fastKey;
	var validate = __webpack_require__(229);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(10);
	var $export = __webpack_require__(14);
	var redefine = __webpack_require__(24);
	var redefineAll = __webpack_require__(226);
	var meta = __webpack_require__(31);
	var forOf = __webpack_require__(219);
	var anInstance = __webpack_require__(218);
	var isObject = __webpack_require__(19);
	var fails = __webpack_require__(13);
	var $iterDetect = __webpack_require__(173);
	var setToStringTag = __webpack_require__(32);
	var inheritIfRequired = __webpack_require__(94);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(228);
	var validate = __webpack_require__(229);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(230)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(10);
	var each = __webpack_require__(180)(0);
	var redefine = __webpack_require__(24);
	var meta = __webpack_require__(31);
	var assign = __webpack_require__(75);
	var weak = __webpack_require__(233);
	var isObject = __webpack_require__(19);
	var validate = __webpack_require__(229);
	var NATIVE_WEAK_MAP = __webpack_require__(229);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(230)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(226);
	var getWeak = __webpack_require__(31).getWeak;
	var anObject = __webpack_require__(18);
	var isObject = __webpack_require__(19);
	var anInstance = __webpack_require__(218);
	var forOf = __webpack_require__(219);
	var createArrayMethod = __webpack_require__(180);
	var $has = __webpack_require__(11);
	var validate = __webpack_require__(229);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(233);
	var validate = __webpack_require__(229);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(230)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var $typed = __webpack_require__(236);
	var buffer = __webpack_require__(237);
	var anObject = __webpack_require__(18);
	var toAbsoluteIndex = __webpack_require__(46);
	var toLength = __webpack_require__(44);
	var isObject = __webpack_require__(19);
	var ArrayBuffer = __webpack_require__(10).ArrayBuffer;
	var speciesConstructor = __webpack_require__(216);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(13)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(200)(ARRAY_BUFFER);


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var hide = __webpack_require__(16);
	var uid = __webpack_require__(25);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(10);
	var DESCRIPTORS = __webpack_require__(12);
	var LIBRARY = __webpack_require__(28);
	var $typed = __webpack_require__(236);
	var hide = __webpack_require__(16);
	var redefineAll = __webpack_require__(226);
	var fails = __webpack_require__(13);
	var anInstance = __webpack_require__(218);
	var toInteger = __webpack_require__(45);
	var toLength = __webpack_require__(44);
	var toIndex = __webpack_require__(238);
	var gOPN = __webpack_require__(57).f;
	var dP = __webpack_require__(17).f;
	var arrayFill = __webpack_require__(196);
	var setToStringTag = __webpack_require__(32);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(45);
	var toLength = __webpack_require__(44);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	$export($export.G + $export.W + $export.F * !__webpack_require__(236).ABV, {
	  DataView: __webpack_require__(237).DataView
	});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(12)) {
	  var LIBRARY = __webpack_require__(28);
	  var global = __webpack_require__(10);
	  var fails = __webpack_require__(13);
	  var $export = __webpack_require__(14);
	  var $typed = __webpack_require__(236);
	  var $buffer = __webpack_require__(237);
	  var ctx = __webpack_require__(29);
	  var anInstance = __webpack_require__(218);
	  var propertyDesc = __webpack_require__(23);
	  var hide = __webpack_require__(16);
	  var redefineAll = __webpack_require__(226);
	  var toInteger = __webpack_require__(45);
	  var toLength = __webpack_require__(44);
	  var toIndex = __webpack_require__(238);
	  var toAbsoluteIndex = __webpack_require__(46);
	  var toPrimitive = __webpack_require__(22);
	  var has = __webpack_require__(11);
	  var classof = __webpack_require__(81);
	  var isObject = __webpack_require__(19);
	  var toObject = __webpack_require__(52);
	  var isArrayIter = __webpack_require__(170);
	  var create = __webpack_require__(53);
	  var getPrototypeOf = __webpack_require__(65);
	  var gOPN = __webpack_require__(57).f;
	  var getIterFn = __webpack_require__(172);
	  var uid = __webpack_require__(25);
	  var wks = __webpack_require__(33);
	  var createArrayMethod = __webpack_require__(180);
	  var createArrayIncludes = __webpack_require__(43);
	  var speciesConstructor = __webpack_require__(216);
	  var ArrayIterators = __webpack_require__(201);
	  var Iterators = __webpack_require__(136);
	  var $iterDetect = __webpack_require__(173);
	  var setSpecies = __webpack_require__(200);
	  var arrayFill = __webpack_require__(196);
	  var arrayCopyWithin = __webpack_require__(193);
	  var $DP = __webpack_require__(17);
	  var $GOPD = __webpack_require__(58);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(14);
	var aFunction = __webpack_require__(30);
	var anObject = __webpack_require__(18);
	var rApply = (__webpack_require__(10).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(13)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(14);
	var create = __webpack_require__(53);
	var aFunction = __webpack_require__(30);
	var anObject = __webpack_require__(18);
	var isObject = __webpack_require__(19);
	var fails = __webpack_require__(13);
	var bind = __webpack_require__(83);
	var rConstruct = (__webpack_require__(10).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(17);
	var $export = __webpack_require__(14);
	var anObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(22);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(13)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(14);
	var gOPD = __webpack_require__(58).f;
	var anObject = __webpack_require__(18);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(14);
	var anObject = __webpack_require__(18);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(137)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(58);
	var getPrototypeOf = __webpack_require__(65);
	var has = __webpack_require__(11);
	var $export = __webpack_require__(14);
	var isObject = __webpack_require__(19);
	var anObject = __webpack_require__(18);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(58);
	var $export = __webpack_require__(14);
	var anObject = __webpack_require__(18);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(14);
	var getProto = __webpack_require__(65);
	var anObject = __webpack_require__(18);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(14);
	var anObject = __webpack_require__(18);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(261) });


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(57);
	var gOPS = __webpack_require__(49);
	var anObject = __webpack_require__(18);
	var Reflect = __webpack_require__(10).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(14);
	var anObject = __webpack_require__(18);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(17);
	var gOPD = __webpack_require__(58);
	var getPrototypeOf = __webpack_require__(65);
	var has = __webpack_require__(11);
	var $export = __webpack_require__(14);
	var createDesc = __webpack_require__(23);
	var anObject = __webpack_require__(18);
	var isObject = __webpack_require__(19);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(14);
	var setProto = __webpack_require__(79);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(14);
	var $includes = __webpack_require__(43)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(194)('includes');


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(14);
	var flattenIntoArray = __webpack_require__(267);
	var toObject = __webpack_require__(52);
	var toLength = __webpack_require__(44);
	var aFunction = __webpack_require__(30);
	var arraySpeciesCreate = __webpack_require__(181);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(194)('flatMap');


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(51);
	var isObject = __webpack_require__(19);
	var toLength = __webpack_require__(44);
	var ctx = __webpack_require__(29);
	var IS_CONCAT_SPREADABLE = __webpack_require__(33)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(14);
	var flattenIntoArray = __webpack_require__(267);
	var toObject = __webpack_require__(52);
	var toLength = __webpack_require__(44);
	var toInteger = __webpack_require__(45);
	var arraySpeciesCreate = __webpack_require__(181);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(194)('flatten');


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(14);
	var $at = __webpack_require__(134)(true);
	var $fails = __webpack_require__(13);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(14);
	var $pad = __webpack_require__(271);
	var userAgent = __webpack_require__(224);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(44);
	var repeat = __webpack_require__(97);
	var defined = __webpack_require__(42);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(14);
	var $pad = __webpack_require__(271);
	var userAgent = __webpack_require__(224);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(89)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(89)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(14);
	var defined = __webpack_require__(42);
	var toLength = __webpack_require__(44);
	var isRegExp = __webpack_require__(141);
	var getFlags = __webpack_require__(204);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(137)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(35)('asyncIterator');


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(35)('observable');


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(14);
	var ownKeys = __webpack_require__(261);
	var toIObject = __webpack_require__(39);
	var gOPD = __webpack_require__(58);
	var createProperty = __webpack_require__(171);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(14);
	var $values = __webpack_require__(280)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(12);
	var getKeys = __webpack_require__(37);
	var toIObject = __webpack_require__(39);
	var isEnum = __webpack_require__(50).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(14);
	var $entries = __webpack_require__(280)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var toObject = __webpack_require__(52);
	var aFunction = __webpack_require__(30);
	var $defineProperty = __webpack_require__(17);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(12) && $export($export.P + __webpack_require__(283), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(28) || !__webpack_require__(13)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(10)[K];
	});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var toObject = __webpack_require__(52);
	var aFunction = __webpack_require__(30);
	var $defineProperty = __webpack_require__(17);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(12) && $export($export.P + __webpack_require__(283), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var toObject = __webpack_require__(52);
	var toPrimitive = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(65);
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(12) && $export($export.P + __webpack_require__(283), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(14);
	var toObject = __webpack_require__(52);
	var toPrimitive = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(65);
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(12) && $export($export.P + __webpack_require__(283), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(14);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(288)('Map') });


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(81);
	var from = __webpack_require__(289);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(219);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(14);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(288)('Set') });


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(292)('Map');


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(14);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(292)('Set');


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(292)('WeakMap');


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(292)('WeakSet');


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(297)('Map');


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(14);
	var aFunction = __webpack_require__(30);
	var ctx = __webpack_require__(29);
	var forOf = __webpack_require__(219);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(297)('Set');


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(297)('WeakMap');


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(297)('WeakSet');


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(14);
	
	$export($export.G, { global: __webpack_require__(10) });


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(14);
	
	$export($export.S, 'System', { global: __webpack_require__(10) });


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(14);
	var cof = __webpack_require__(41);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(14);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(14);
	var scale = __webpack_require__(308);
	var fround = __webpack_require__(120);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 308 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(14);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', { scale: __webpack_require__(308) });


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(14);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(14);
	var core = __webpack_require__(15);
	var global = __webpack_require__(10);
	var speciesConstructor = __webpack_require__(216);
	var promiseResolve = __webpack_require__(225);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(14);
	var newPromiseCapability = __webpack_require__(222);
	var perform = __webpack_require__(223);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(18);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(227);
	var $export = __webpack_require__(14);
	var shared = __webpack_require__(27)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(232))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(18);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(18);
	var getPrototypeOf = __webpack_require__(65);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(231);
	var from = __webpack_require__(289);
	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(18);
	var getPrototypeOf = __webpack_require__(65);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(18);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(18);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(18);
	var getPrototypeOf = __webpack_require__(65);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(18);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(320);
	var anObject = __webpack_require__(18);
	var aFunction = __webpack_require__(30);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(14);
	var microtask = __webpack_require__(221)();
	var process = __webpack_require__(10).process;
	var isNode = __webpack_require__(41)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(14);
	var global = __webpack_require__(10);
	var core = __webpack_require__(15);
	var microtask = __webpack_require__(221)();
	var OBSERVABLE = __webpack_require__(33)('observable');
	var aFunction = __webpack_require__(30);
	var anObject = __webpack_require__(18);
	var anInstance = __webpack_require__(218);
	var redefineAll = __webpack_require__(226);
	var hide = __webpack_require__(16);
	var forOf = __webpack_require__(219);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(200)('Observable');


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(10);
	var $export = __webpack_require__(14);
	var userAgent = __webpack_require__(224);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	var $task = __webpack_require__(220);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(201);
	var getKeys = __webpack_require__(37);
	var redefine = __webpack_require__(24);
	var global = __webpack_require__(10);
	var hide = __webpack_require__(16);
	var Iterators = __webpack_require__(136);
	var wks = __webpack_require__(33);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 334 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(336);
	module.exports = __webpack_require__(15).RegExp.escape;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(14);
	var $re = __webpack_require__(337)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(339);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(340),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 340 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(342);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(338),n=__webpack_require__(340),r=__webpack_require__(343);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(344);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),
/* 344 */
/***/ (function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(346);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(347);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(351);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(353);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(373);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(374);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(375);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(377);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(379);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(378);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(380);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(367);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(381);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(394);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(395);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(396);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(404);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(383);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(348);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(349)();
	}


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(350);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(348);
	
	var _createTransitionManager2 = __webpack_require__(356);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(366);
	
	var _RouterContext = __webpack_require__(367);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(346);
	
	var _RouterUtils = __webpack_require__(372);
	
	var _routerWarning = __webpack_require__(357);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(338);
	var factory = __webpack_require__(355);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(340);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(357);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(359);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(360);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(362);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(363);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(365);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(351);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(361);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(351);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(361);
	
	var _PromiseUtils = __webpack_require__(364);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(361);
	
	var _PromiseUtils = __webpack_require__(364);
	
	var _PatternUtils = __webpack_require__(351);
	
	var _routerWarning = __webpack_require__(357);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(346);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(348);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(368);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(348);
	
	var _getRouteParams = __webpack_require__(370);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(371);
	
	var _RouteUtils = __webpack_require__(346);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(369);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(351);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(348);
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(347);
	
	var _ContextUtils = __webpack_require__(371);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(373);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(376);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(371);
	
	var _PropTypes = __webpack_require__(347);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(348);
	
	var _routerWarning = __webpack_require__(357);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(378);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(366);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(348);
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(346);
	
	var _PatternUtils = __webpack_require__(351);
	
	var _InternalPropTypes = __webpack_require__(366);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(348);
	
	var _routerWarning = __webpack_require__(357);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(346);
	
	var _InternalPropTypes = __webpack_require__(366);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(348);
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(346);
	
	var _InternalPropTypes = __webpack_require__(366);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(382);
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(383);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(356);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(346);
	
	var _RouterUtils = __webpack_require__(372);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(384);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(390);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(391);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(385);
	
	var _runTransitionHook = __webpack_require__(387);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(388);
	
	var _PathUtils = __webpack_require__(389);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(386);
	var objectAssign = __webpack_require__(340);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 386 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(389);
	
	var _Actions = __webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(387);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(389);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(388);
	
	var _PathUtils = __webpack_require__(389);
	
	var _createHistory = __webpack_require__(392);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(393);
	
	var _PathUtils = __webpack_require__(389);
	
	var _runTransitionHook = __webpack_require__(387);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(382);
	
	var _LocationUtils = __webpack_require__(388);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(384);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(390);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(367);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(357);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(397);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(403);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(398);
	
	var _BrowserProtocol = __webpack_require__(399);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(402);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(400);
	
	var _createHistory = __webpack_require__(392);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(388);
	
	var _DOMUtils = __webpack_require__(400);
	
	var _DOMStateStorage = __webpack_require__(401);
	
	var _PathUtils = __webpack_require__(389);
	
	var _ExecutionEnvironment = __webpack_require__(398);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(399);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(388);
	
	var _PathUtils = __webpack_require__(389);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(394);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(405);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(403);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(398);
	
	var _DOMUtils = __webpack_require__(400);
	
	var _HashProtocol = __webpack_require__(406);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(392);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(399);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(388);
	
	var _DOMUtils = __webpack_require__(400);
	
	var _DOMStateStorage = __webpack_require__(401);
	
	var _PathUtils = __webpack_require__(389);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(408);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(422);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(424);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(425);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(426);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(423);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(409);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(419);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(410),
	    getPrototype = __webpack_require__(416),
	    isObjectLike = __webpack_require__(418);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(411),
	    getRawTag = __webpack_require__(414),
	    objectToString = __webpack_require__(415);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(412);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(413);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(411);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(417);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 417 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 418 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(421);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(420)(module)))

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 421 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(408);
	
	var _isPlainObject = __webpack_require__(409);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(423);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(426);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	var _interopRequireWildcard = __webpack_require__(429);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireWildcard(__webpack_require__(431));
	
	exports.Provider = _Provider.default;
	exports.createProvider = _Provider.createProvider;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(436));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _connect = _interopRequireDefault(__webpack_require__(441));
	
	exports.connect = _connect.default;

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(430)["default"];
	function _interopRequireWildcard(e, t) {
	  if ("function" == typeof WeakMap) var r = new WeakMap(),
	    n = new WeakMap();
	  return (module.exports = _interopRequireWildcard = function _interopRequireWildcard(e, t) {
	    if (!t && e && e.__esModule) return e;
	    var o,
	      i,
	      f = {
	        __proto__: null,
	        "default": e
	      };
	    if (null === e || "object" != _typeof(e) && "function" != typeof e) return f;
	    if (o = t ? n : r) {
	      if (o.has(e)) return o.get(e);
	      o.set(e, f);
	    }
	    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
	    return f;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
	}
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(429);
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(432));
	
	var _react = _interopRequireWildcard(__webpack_require__(338));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(348));
	
	var _PropTypes = __webpack_require__(434);
	
	var _warning = _interopRequireDefault(__webpack_require__(435));
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var didWarnAboutReceivingStore = false;
	
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  (0, _warning.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider(storeKey) {
	  var _Provider$childContex;
	
	  if (storeKey === void 0) {
	    storeKey = 'store';
	  }
	
	  var subscriptionKey = storeKey + "Subscription";
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inheritsLoose2.default)(Provider, _Component);
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      var _this;
	
	      _this = _Component.call(this, props, context) || this;
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    _proto.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    // Use UNSAFE_ event name where supported
	    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';
	
	    Provider.prototype[eventName] = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  return Provider;
	}
	
	var _default = createProvider();
	
	exports.default = _default;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(433);
	function _inheritsLoose(t, o) {
	  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	function _setPrototypeOf(t, e) {
	  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(348));
	
	var subscriptionShape = _propTypes.default.shape({
	  trySubscribe: _propTypes.default.func.isRequired,
	  tryUnsubscribe: _propTypes.default.func.isRequired,
	  notifyNestedSubs: _propTypes.default.func.isRequired,
	  isSubscribed: _propTypes.default.func.isRequired
	});
	
	exports.subscriptionShape = subscriptionShape;
	
	var storeShape = _propTypes.default.shape({
	  subscribe: _propTypes.default.func.isRequired,
	  dispatch: _propTypes.default.func.isRequired,
	  getState: _propTypes.default.func.isRequired
	});
	
	exports.storeShape = storeShape;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(429);
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(432));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(437));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(438));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(439));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(376));
	
	var _invariant = _interopRequireDefault(__webpack_require__(352));
	
	var _react = _interopRequireWildcard(__webpack_require__(338));
	
	var _reactIs = __webpack_require__(368);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(440));
	
	var _PropTypes = __webpack_require__(434);
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var hotReloadingVersion = 0;
	var dummyState = {};
	
	function noop() {}
	
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  var _contextTypes, _childContextTypes;
	
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
	
	      /* eslint-disable react/no-deprecated */
	
	    });
	
	    var Connect =
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(Connect, _Component);
	
	      function Connect(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	        (0, _invariant.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
	
	        _this.initSelector();
	
	        _this.initSubscription();
	
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.getChildContext = function getChildContext() {
	        var _ref3;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0
	
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      _proto.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
	        return this.wrappedInstance;
	      };
	
	      _proto.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      _proto.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      _proto.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription.default(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      _proto.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      _proto.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      _proto.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	
	        var withExtras = (0, _extends2.default)({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      _proto.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    if (prefixUnsafeLifecycleMethods) {
	      // Use UNSAFE_ event name where supported
	      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
	      delete Connect.prototype.componentWillReceiveProps;
	    }
	    /* eslint-enable react/no-deprecated */
	
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      // Use UNSAFE_ event name where supported
	      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';
	
	      Connect.prototype[eventName] = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	
	          this.initSubscription();
	
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	function _assertThisInitialized(e) {
	  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  return e;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	function _extends() {
	  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
	    for (var e = 1; e < arguments.length; e++) {
	      var t = arguments[e];
	      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
	    }
	    return n;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(r, e) {
	  if (null == r) return {};
	  var t = {};
	  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
	    if (-1 !== e.indexOf(n)) continue;
	    t[n] = r[n];
	  }
	  return t;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub, onStateChange) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(438));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(439));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(436));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(442));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(443));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(447));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(448));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(449));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(407);
	
	var _wrapMapToProps = __webpack_require__(444);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(445));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(446));
	
	var _warning = _interopRequireDefault(__webpack_require__(435));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(444);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(438));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(445));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(439));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(450));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(435));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(452);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(453);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(454);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(455);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(452);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(453);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/** A function that accepts a potential "extra argument" value to be injected later,
	 * and returns an instance of the thunk middleware that uses that value
	 */
	function createThunkMiddleware(extraArgument) {
	  // Standard Redux middleware definition pattern:
	  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
	  var middleware = function middleware(_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
	        // If this "action" is really a function, call it and return the result.
	        if (typeof action === 'function') {
	          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
	          return action(dispatch, getState, extraArgument);
	        } // Otherwise, pass the action down the middleware chain as usual
	
	
	        return next(action);
	      };
	    };
	  };
	
	  return middleware;
	}
	
	var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
	// with whatever "extra arg" they want to inject into their thunks
	
	thunk.withExtraArgument = createThunkMiddleware;
	var _default = thunk;
	exports.default = _default;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else {
			var a = factory();
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 8);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mapValues;
	function mapValues(obj, f) {
	  if (obj == null) {
	    return {};
	  }
	
	  var res = {};
	  Object.keys(obj).forEach(function (key) {
	    res[key] = f(obj[key]);
	  });
	  return res;
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setActive = setActive;
	exports.default = registerXHR;
	
	var _mapValues = __webpack_require__(0);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _enhanceFunc = __webpack_require__(2);
	
	var _enhanceFunc2 = _interopRequireDefault(_enhanceFunc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isActive = true;
	
	function setActive(shouldBeActive) {
	  isActive = shouldBeActive;
	}
	
	var currentXHRId = 0;
	function registerXHR(_ref) {
	  var addRequest = _ref.addRequest,
	      addResponse = _ref.addResponse;
	
	  var _XHR = XMLHttpRequest;
	  var xhrMap = new WeakMap();
	  var unsubscribedFromXhr = false;
	  // const LOGROCKET_XHR_LABEL = 'logrocket_xhr';
	  var LOGROCKET_XHR_LABEL = 'xhr-';
	
	  window._lrXMLHttpRequest = XMLHttpRequest;
	
	  // eslint-disable-next-line no-native-reassign
	  XMLHttpRequest = function XMLHttpRequest(mozAnon, mozSystem) {
	    var xhrObject = new _XHR(mozAnon, mozSystem);
	    if (!isActive) {
	      return xhrObject;
	    }
	
	    xhrMap.set(xhrObject, {
	      xhrId: ++currentXHRId,
	      headers: {}
	    });
	
	    // ..., 'open', (method, url, async, username, password) => {
	    (0, _enhanceFunc2.default)(xhrObject, 'open', function (method, url) {
	      if (unsubscribedFromXhr) return;
	      var currentXHR = xhrMap.get(xhrObject);
	      currentXHR.method = method;
	      currentXHR.url = url;
	    });
	
	    (0, _enhanceFunc2.default)(xhrObject, 'send', function (data) {
	      if (unsubscribedFromXhr) return;
	      var currentXHR = xhrMap.get(xhrObject);
	      if (!currentXHR) return;
	
	      var request = {
	        url: currentXHR.url,
	        method: currentXHR.method && currentXHR.method.toUpperCase(),
	        headers: (0, _mapValues2.default)(currentXHR.headers || {}, function (headerValues) {
	          return headerValues.join(', ');
	        }),
	        body: data
	      };
	      addRequest('' + LOGROCKET_XHR_LABEL + currentXHR.xhrId, request);
	    });
	
	    (0, _enhanceFunc2.default)(xhrObject, 'setRequestHeader', function (header, value) {
	      if (unsubscribedFromXhr) return;
	      var currentXHR = xhrMap.get(xhrObject);
	      if (!currentXHR) return;
	
	      currentXHR.headers = currentXHR.headers || {};
	      currentXHR.headers[header] = currentXHR.headers[header] || [];
	      currentXHR.headers[header].push(value);
	    });
	
	    var xhrListeners = {
	      readystatechange: function readystatechange() {
	        if (unsubscribedFromXhr) return;
	
	        if (xhrObject.readyState === 4) {
	          var currentXHR = xhrMap.get(xhrObject);
	          if (!currentXHR) return;
	
	          var headerString = xhrObject.getAllResponseHeaders();
	
	          var headers = headerString.split(/[\r\n]+/).reduce(function (previous, current) {
	            var next = previous;
	            var headerParts = current.split(': ');
	            if (headerParts.length > 0) {
	              var key = headerParts.shift(); // first index of the array
	              var value = headerParts.join(': '); // rest of the array repaired
	              if (previous[key]) {
	                next[key] += ', ' + value;
	              } else {
	                next[key] = value;
	              }
	            }
	            return next;
	          }, {});
	
	          var body = void 0;
	
	          // IE 11 sometimes throws when trying to access a large responses:
	          // https://connect.microsoft.com/IE/Feedback/Details/1053110
	          try {
	            switch (xhrObject.responseType) {
	              case 'json':
	              case 'arraybuffer':
	              case 'blob':
	                {
	                  body = xhrObject.response;
	                  break;
	                }
	              case 'document':
	                {
	                  body = xhrObject.responseXML;
	                  break;
	                }
	              case 'text':
	              case '':
	                {
	                  body = xhrObject.responseText;
	                  break;
	                }
	              default:
	                {
	                  body = '';
	                }
	            }
	          } catch (err) {
	            body = 'LogRocket: Error accessing response.';
	          }
	
	          var response = {
	            url: currentXHR.url,
	            status: xhrObject.status,
	            headers: headers,
	            body: body,
	            method: (currentXHR.method || '').toUpperCase()
	          };
	
	          addResponse('' + LOGROCKET_XHR_LABEL + currentXHR.xhrId, response);
	        }
	      }
	      // // Unused Event Listeners
	      // loadstart: () => {},
	      // progress: () => {},
	      // abort: () => {},
	      // error: () => {},
	      // load: () => {},
	      // timeout: () => {},
	      // loadend: () => {},
	    };
	
	    Object.keys(xhrListeners).forEach(function (key) {
	      xhrObject.addEventListener(key, xhrListeners[key]);
	    });
	
	    return xhrObject;
	  };
	
	  // this allows "instanceof XMLHttpRequest" to work
	  XMLHttpRequest.prototype = _XHR.prototype;
	
	  // Persist the static variables.
	  ['UNSENT', 'OPENED', 'HEADERS_RECEIVED', 'LOADING', 'DONE'].forEach(function (variable) {
	    XMLHttpRequest[variable] = _XHR[variable];
	  });
	
	  return function () {
	    unsubscribedFromXhr = true;
	    // eslint-disable-next-line no-native-reassign
	    XMLHttpRequest = _XHR;
	  };
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = enhanceFunc;
	/* eslint no-param-reassign: ["error", { "props": false }] */
	
	function enhanceFunc(obj, method, handler) {
	  var original = obj[method];
	
	  function shim() {
	    var res = void 0;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (original) {
	      res = original.apply(this, args);
	    }
	
	    handler.apply(this, args);
	    return res;
	  }
	
	  obj[method] = shim;
	
	  return function () {
	    obj[method] = original;
	  };
	}
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Capture = exports.registerExceptions = undefined;
	
	var _registerExceptions = __webpack_require__(16);
	
	var _registerExceptions2 = _interopRequireDefault(_registerExceptions);
	
	var _Capture = __webpack_require__(6);
	
	var Capture = _interopRequireWildcard(_Capture);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.registerExceptions = _registerExceptions2.default;
	exports.Capture = Capture;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1, eval)("this");
	} catch (e) {
		// This works if the window reference is available
		if (typeof window === "object") g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {/* eslint-disable */
	
	
	
	/*
	 TraceKit - Cross brower stack traces - github.com/occ/TraceKit
	
	 This was originally forked from github.com/occ/TraceKit, but has since been
	 largely re-written and is now maintained as part of raven-js.  Tests for
	 this are in test/vendor.
	
	 MIT license
	*/
	
	var TraceKit = {
	    collectWindowErrors: true,
	    debug: false
	};
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;
	
	function getLocationHref() {
	    if (typeof document === 'undefined' || typeof document.location === 'undefined') return '';
	
	    return document.location.href;
	}
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = function reportModuleWrapper() {
	    var handlers = [],
	        lastArgs = null,
	        lastException = null,
	        lastExceptionStack = null;
	
	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }
	
	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	    }
	
	    /**
	     * Remove all crash handlers.
	     */
	    function unsubscribeAll() {
	        uninstallGlobalHandler();
	        handlers = [];
	    }
	
	    /**
	     * Dispatch stack information to all handlers.
	     * @param {Object.<string, *>} stack
	     */
	    function notifyHandlers(stack, isWindowError) {
	        var exception = null;
	        if (isWindowError && !TraceKit.collectWindowErrors) {
	            return;
	        }
	        for (var i in handlers) {
	            if (handlers.hasOwnProperty(i)) {
	                try {
	                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }
	
	        if (exception) {
	            throw exception;
	        }
	    }
	
	    var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error
	     * occurred.
	     * @param {?(number|string)} colNo The column number at which the error
	     * occurred.
	     * @param {?Error} ex The actual Error object.
	     */
	    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
	        var stack = null;
	
	        if (lastExceptionStack) {
	            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	            processLastException();
	        } else if (ex) {
	            // New chrome and blink send along a real error object
	            // Let's just report that like a normal error.
	            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	            stack = TraceKit.computeStackTrace(ex);
	            notifyHandlers(stack, true);
	        } else {
	            var location = {
	                'url': url,
	                'line': lineNo,
	                'column': colNo
	            };
	
	            var name = undefined;
	            var msg = message; // must be new var or will modify original `arguments`
	            var groups;
	            if ({}.toString.call(message) === '[object String]') {
	                var groups = message.match(ERROR_TYPES_RE);
	                if (groups) {
	                    name = groups[1];
	                    msg = groups[2];
	                }
	            }
	
	            location.func = UNKNOWN_FUNCTION;
	
	            stack = {
	                'name': name,
	                'message': msg,
	                'url': getLocationHref(),
	                'stack': [location]
	            };
	            notifyHandlers(stack, true);
	        }
	
	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }
	
	        return false;
	    }
	
	    function installGlobalHandler() {
	        if (_onErrorHandlerInstalled) {
	            return;
	        }
	        _oldOnerrorHandler = _window.onerror;
	        _window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }
	
	    function uninstallGlobalHandler() {
	        if (!_onErrorHandlerInstalled) {
	            return;
	        }
	        _window.onerror = _oldOnerrorHandler;
	        _onErrorHandlerInstalled = false;
	        _oldOnerrorHandler = undefined;
	    }
	
	    function processLastException() {
	        var _lastExceptionStack = lastExceptionStack,
	            _lastArgs = lastArgs;
	        lastArgs = null;
	        lastExceptionStack = null;
	        lastException = null;
	        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	    }
	
	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     * @param {?boolean} rethrow If false, do not re-throw the exception.
	     * Only used for window.onerror to not cause an infinite loop of
	     * rethrowing.
	     */
	    function report(ex, rethrow) {
	        var args = _slice.call(arguments, 1);
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	                processLastException();
	            }
	        }
	
	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	        lastArgs = args;
	
	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        setTimeout(function () {
	            if (lastException === ex) {
	                processLastException();
	            }
	        }, stack.incomplete ? 2000 : 0);
	
	        if (rethrow !== false) {
	            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	        }
	    }
	
	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    report.uninstall = unsubscribeAll;
	    return report;
	}();
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = function computeStackTraceWrapper() {
	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }
	
	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }
	
	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.columnNumber = 69
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (typeof ex.stack === 'undefined' || !ex.stack) return;
	
	        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
	            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	            lines = ex.stack.split('\n'),
	            stack = [],
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);
	
	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if (parts = chrome.exec(lines[i])) {
	                var isNative = parts[2] && parts[2].indexOf('native') !== -1;
	                element = {
	                    'url': !isNative ? parts[2] : null,
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': isNative ? [parts[2]] : [],
	                    'line': parts[3] ? +parts[3] : null,
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if (parts = winjs.exec(lines[i])) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': [],
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if (parts = gecko.exec(lines[i])) {
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : [],
	                    'line': parts[4] ? +parts[4] : null,
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else {
	                continue;
	            }
	
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	
	            stack.push(element);
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
	            // FireFox uses this awesome columnNumber property for its top frame
	            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	            // so adding 1
	            stack[0].column = ex.columnNumber + 1;
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {Object.<string, *>} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };
	
	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;
	
	            if (!initial.func) {
	                initial.func = UNKNOWN_FUNCTION;
	            }
	
	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        return false;
	                    }
	                }
	            }
	
	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }
	
	        return false;
	    }
	
	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;
	
	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                // console.log('skipping internal function');
	                continue;
	            }
	
	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'line': null,
	                'column': null
	            };
	
	            if (curr.name) {
	                item.func = curr.name;
	            } else if (parts = functionName.exec(curr.toString())) {
	                item.func = parts[1];
	            }
	
	            if (typeof item.func === 'undefined') {
	                try {
	                    item.func = parts.input.substring(0, parts.input.indexOf('{'));
	                } catch (e) {}
	            }
	
	            if (funcs['' + curr]) {
	                recursion = true;
	            } else {
	                funcs['' + curr] = true;
	            }
	
	            stack.push(item);
	        }
	
	        if (depth) {
	            // console.log('depth is ' + depth);
	            // console.log('stack is ' + stack.length);
	            stack.splice(0, depth);
	        }
	
	        var result = {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }
	
	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = depth == null ? 0 : +depth;
	
	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref()
	        };
	    }
	
	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	    return computeStackTrace;
	}();
	
	module.exports = TraceKit;
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable no-param-reassign */
	
	
	exports.captureMessage = captureMessage;
	exports.captureException = captureException;
	
	var _TraceKit = __webpack_require__(5);
	
	var _TraceKit2 = _interopRequireDefault(_TraceKit);
	
	var _stackTraceFromError = __webpack_require__(18);
	
	var _stackTraceFromError2 = _interopRequireDefault(_stackTraceFromError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isScalar(value) {
	  return (/boolean|number|string/.test(typeof value === 'undefined' ? 'undefined' : _typeof(value))
	  );
	}
	
	function scrub(data, options) {
	  if (options) {
	    var optionalScalars = [
	    // Valid values for 'level' are 'fatal', 'error', 'warning', 'info',
	    // and 'debug'. Defaults to 'error'.
	    'level', 'logger'];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = optionalScalars[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var field = _step.value;
	
	        var value = options[field];
	
	        if (isScalar(value)) {
	          data[field] = value.toString();
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    var optionalMaps = ['tags', 'extra'];
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = optionalMaps[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var _field = _step2.value;
	
	        var dirty = options[_field] || {};
	        var scrubbed = {};
	
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = Object.keys(dirty)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var key = _step3.value;
	
	            var _value = dirty[key];
	
	            if (isScalar(_value)) {
	              scrubbed[key.toString()] = _value.toString();
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	
	        data[_field] = scrubbed;
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	  }
	}
	
	function captureMessage(logger, message) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var isConsole = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  var data = {
	    exceptionType: isConsole ? 'CONSOLE' : 'MESSAGE',
	    message: message,
	    browserHref: window.location.href
	  };
	
	  scrub(data, options);
	
	  logger.addEvent('lr.core.Exception', function () {
	    return data;
	  });
	}
	
	function captureException(logger, exception) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var preppedTrace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var trace = preppedTrace || _TraceKit2.default.computeStackTrace(exception);
	
	  var data = {
	    exceptionType: 'WINDOW',
	    errorType: trace.name,
	    message: trace.message,
	    browserHref: window.location.href
	  };
	
	  scrub(data, options);
	
	  var addEventOptions = {
	    _stackTrace: (0, _stackTraceFromError2.default)(trace)
	  };
	
	  logger.addEvent('lr.core.Exception', function () {
	    return data;
	  }, addEventOptions);
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports,"__esModule",{value:true});var dateNow=Date.now.bind(Date);var loadTime=dateNow();exports.default=typeof performance!=='undefined'&&performance.now?performance.now.bind(performance):function(){return dateNow()-loadTime;};module.exports=exports['default'];
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(9);
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _setup = __webpack_require__(10);
	
	var _setup2 = _interopRequireDefault(_setup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instance = (0, _setup2.default)();
	
	exports.default = instance;
	module.exports = exports['default'];
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setup;
	
	var _makeLogRocket = __webpack_require__(11);
	
	var _makeLogRocket2 = _interopRequireDefault(_makeLogRocket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function setup() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var enterpriseServer = _ref.enterpriseServer,
	      opts = _objectWithoutProperties(_ref, ['enterpriseServer']);
	
	  var sdkServer = opts.sdkServer || enterpriseServer;
	  var ingestServer = opts.ingestServer || enterpriseServer;
	
	  var instance = (0, _makeLogRocket2.default)(function () {
	    var script = document.createElement('script');
	
	    if (ingestServer) {
	      if (typeof window.__SDKCONFIG__ === 'undefined') {
	        window.__SDKCONFIG__ = {};
	      }
	
	      window.__SDKCONFIG__.serverURL = ingestServer + '/i';
	      window.__SDKCONFIG__.statsURL = ingestServer + '/s';
	    }
	
	    if (sdkServer) {
	      script.src = sdkServer + '/logger.min.js';
	    } else if (window.__SDKCONFIG__ && window.__SDKCONFIG__.loggerURL) {
	      script.src = window.__SDKCONFIG__.loggerURL;
	    } else if (window._lrAsyncScript) {
	      script.src = window._lrAsyncScript;
	    } else {
	      script.src = undefined === 'staging' ? 'https://cdn-staging.logrocket.io/logger.min.js' : 'https://cdn.logrocket.io/logger.min.js';
	    }
	
	    script.async = true;
	    document.head.appendChild(script);
	    script.onload = function () {
	      instance.onLogger(new window._LRLogger({
	        sdkVersion: "0.6.21" // eslint-disable-line no-undef
	      }));
	    };
	    script.onerror = function () {
	      console.warn('LogRocket: script could not load. Check that you have a valid network connection.');
	      instance.uninstall();
	    };
	  });
	
	  return instance;
	}
	module.exports = exports['default'];
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = makeLogRocket;
	
	var _LogRocket = __webpack_require__(12);
	
	var _LogRocket2 = _interopRequireDefault(_LogRocket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REACT_NATIVE_NOTICE = 'LogRocket does not yet support React Native.';
	var makeNoopPolyfill = function makeNoopPolyfill() {
	  return {
	    init: function init() {},
	    uninstall: function uninstall() {},
	    log: function log() {},
	    info: function info() {},
	    warn: function warn() {},
	    error: function error() {},
	    debug: function debug() {},
	    addEvent: function addEvent() {},
	    identify: function identify() {},
	    start: function start() {},
	
	
	    get threadID() {
	      return null;
	    },
	    get recordingID() {
	      return null;
	    },
	    get recordingURL() {
	      return null;
	    },
	
	    reduxEnhancer: function reduxEnhancer() {
	      return function (store) {
	        return function () {
	          return store.apply(undefined, arguments);
	        };
	      };
	    },
	    reduxMiddleware: function reduxMiddleware() {
	      return function () {
	        return function (next) {
	          return function (action) {
	            return next(action);
	          };
	        };
	      };
	    },
	    track: function track() {},
	    getSessionURL: function getSessionURL() {},
	    getVersion: function getVersion() {},
	    startNewSession: function startNewSession() {},
	    onLogger: function onLogger() {},
	    setClock: function setClock() {},
	    captureMessage: function captureMessage() {},
	    captureException: function captureException() {}
	  };
	};
	
	function makeLogRocket() {
	  var getLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    throw new Error(REACT_NATIVE_NOTICE);
	  }
	
	  if (typeof window !== 'undefined') {
	    if (window._disableLogRocket) {
	      return makeNoopPolyfill();
	    }
	
	    if (window.MutationObserver) {
	      // Save window globals that we rely on.
	      window._lrMutationObserver = window.MutationObserver;
	
	      var instance = new _LogRocket2.default();
	      getLogger(instance);
	      return instance;
	    }
	  }
	
	  return makeNoopPolyfill();
	}
	module.exports = exports['default'];
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MAX_QUEUE_SIZE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _logrocketNetwork = __webpack_require__(13);
	
	var _logrocketNetwork2 = _interopRequireDefault(_logrocketNetwork);
	
	var _logrocketExceptions = __webpack_require__(3);
	
	var _logrocketConsole = __webpack_require__(19);
	
	var _logrocketConsole2 = _interopRequireDefault(_logrocketConsole);
	
	var _logrocketRedux = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MAX_QUEUE_SIZE = exports.MAX_QUEUE_SIZE = 1000;
	
	var considerIngestServerOption = function considerIngestServerOption() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var ingestServer = _ref.ingestServer,
	      options = _objectWithoutProperties(_ref, ['ingestServer']);
	
	  if (ingestServer) {
	    return _extends({
	      serverURL: ingestServer + '/i',
	      statsURL: ingestServer + '/s'
	    }, options);
	  }
	
	  return options;
	};
	
	var LogRocket = function () {
	  function LogRocket() {
	    var _this = this;
	
	    _classCallCheck(this, LogRocket);
	
	    this._buffer = [];
	
	    // TODO: tests for these exposed methods.
	    ['log', 'info', 'warn', 'error', 'debug'].forEach(function (method) {
	      _this[method] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this.addEvent('lr.core.LogEvent', function () {
	          var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
	            _logrocketExceptions.Capture.captureMessage(_this, args[0], {}, true);
	          }
	
	          return {
	            logLevel: method.toUpperCase(),
	            args: args
	          };
	        }, { shouldCaptureStackTrace: true });
	      };
	    });
	    this._isInitialized = false;
	    this._installed = [];
	  }
	
	  _createClass(LogRocket, [{
	    key: 'addEvent',
	    value: function addEvent(type, getMessage) {
	      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var time = Date.now();
	      this._run(function (logger) {
	        logger.addEvent(type, getMessage, _extends({}, opts, {
	          timeOverride: time
	        }));
	      });
	    }
	  }, {
	    key: 'onLogger',
	    value: function onLogger(logger) {
	      this._logger = logger;
	
	      while (this._buffer.length > 0) {
	        var f = this._buffer.shift();
	        f(this._logger);
	      }
	    }
	  }, {
	    key: '_run',
	    value: function _run(f) {
	      if (this._isDisabled) {
	        return;
	      }
	
	      if (this._logger) {
	        f(this._logger);
	      } else {
	        if (this._buffer.length >= MAX_QUEUE_SIZE) {
	          this._isDisabled = true;
	          console.warn('LogRocket: script did not load. Check that you have a valid network connection.');
	          this.uninstall();
	          return;
	        }
	
	        this._buffer.push(f.bind(this));
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init(appID, opts) {
	      if (!this._isInitialized) {
	        this._installed.push((0, _logrocketExceptions.registerExceptions)(this));
	        this._installed.push((0, _logrocketNetwork2.default)(this));
	        this._installed.push((0, _logrocketConsole2.default)(this));
	
	        this._isInitialized = true;
	
	        this._run(function (logger) {
	          logger.init(appID, considerIngestServerOption(opts));
	        });
	      }
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this._run(function (logger) {
	        logger.start();
	      });
	    }
	  }, {
	    key: 'uninstall',
	    value: function uninstall() {
	      this._installed.forEach(function (f) {
	        return f();
	      });
	      this._buffer = [];
	
	      this._run(function (logger) {
	        logger.uninstall();
	      });
	    }
	  }, {
	    key: 'identify',
	    value: function identify(id, opts) {
	      this._run(function (logger) {
	        logger.identify(id, opts);
	      });
	    }
	  }, {
	    key: 'startNewSession',
	    value: function startNewSession() {
	      this._run(function (logger) {
	        logger.startNewSession();
	      });
	    }
	  }, {
	    key: 'track',
	    value: function track(customEventName) {
	      this._run(function (logger) {
	        logger.track(customEventName);
	      });
	    }
	  }, {
	    key: 'getSessionURL',
	    value: function getSessionURL(cb) {
	      if (typeof cb !== 'function') {
	        throw new Error('LogRocket: must pass callback to getSessionURL()');
	      }
	
	      this._run(function (logger) {
	        if (logger.getSessionURL) {
	          logger.getSessionURL(cb);
	        } else {
	          cb(logger.recordingURL);
	        }
	      });
	    }
	  }, {
	    key: 'getVersion',
	    value: function getVersion(cb) {
	      this._run(function (logger) {
	        cb(logger.version);
	      });
	    }
	  }, {
	    key: 'startTransaction',
	    value: function startTransaction(transactionID) {
	      this.addEvent('lr.transaction.Start', function () {
	        return { id: transactionID };
	      });
	    }
	  }, {
	    key: 'endTransaction',
	    value: function endTransaction(transactionID) {
	      this.addEvent('lr.transaction.End', function () {
	        return { id: transactionID };
	      });
	    }
	  }, {
	    key: 'captureMessage',
	    value: function captureMessage(message) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _logrocketExceptions.Capture.captureMessage(this, message, options);
	    }
	  }, {
	    key: 'captureException',
	    value: function captureException(exception) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _logrocketExceptions.Capture.captureException(this, exception, options);
	    }
	  }, {
	    key: 'reduxEnhancer',
	    value: function reduxEnhancer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return (0, _logrocketRedux.createEnhancer)(this, options);
	    }
	  }, {
	    key: 'reduxMiddleware',
	    value: function reduxMiddleware() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return (0, _logrocketRedux.createMiddleware)(this, options);
	    }
	  }, {
	    key: 'version',
	    get: function get() {
	      return this._logger && this._logger.version;
	    }
	  }, {
	    key: 'sessionURL',
	    get: function get() {
	      return this._logger && this._logger.recordingURL;
	    }
	  }, {
	    key: 'recordingURL',
	    get: function get() {
	      return this._logger && this._logger.recordingURL;
	    }
	  }, {
	    key: 'recordingID',
	    get: function get() {
	      return this._logger && this._logger.recordingID;
	    }
	  }, {
	    key: 'threadID',
	    get: function get() {
	      return this._logger && this._logger.threadID;
	    }
	  }, {
	    key: 'tabID',
	    get: function get() {
	      return this._logger && this._logger.tabID;
	    }
	  }]);
	
	  return LogRocket;
	}();
	
	exports.default = LogRocket;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	// import registerWebSocket from './registerWebSocket';
	
	
	exports.default = registerNetwork;
	
	var _registerFetch = __webpack_require__(14);
	
	var _registerFetch2 = _interopRequireDefault(_registerFetch);
	
	var _registerXHR = __webpack_require__(1);
	
	var _registerXHR2 = _interopRequireDefault(_registerXHR);
	
	var _mapValues = __webpack_require__(0);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerNetwork(logger) {
	  var ignoredNetwork = {};
	
	  // truncate if > 4MB in size
	  var truncate = function truncate(data) {
	    var limit = 1024 * 1000 * 4;
	    var str = data;
	
	    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data != null) {
	      var proto = Object.getPrototypeOf(data);
	
	      if (proto === Object.prototype || proto === null) {
	        // plain object - jsonify for the size check
	        str = JSON.stringify(data);
	      }
	    }
	
	    if (str && str.length && str.length > limit && typeof str === 'string') {
	      var beginning = str.substring(0, 1000);
	      return beginning + ' ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference#network';
	    }
	
	    return data;
	  };
	
	  var addRequest = function addRequest(reqId, request) {
	    var method = request.method;
	    logger.addEvent('lr.network.RequestEvent', function () {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$isEnabled = _ref.isEnabled,
	          isEnabled = _ref$isEnabled === undefined ? true : _ref$isEnabled,
	          _ref$requestSanitizer = _ref.requestSanitizer,
	          requestSanitizer = _ref$requestSanitizer === undefined ? function (f) {
	        return f;
	      } : _ref$requestSanitizer;
	
	      if (!isEnabled) {
	        return null;
	      }
	      var sanitized = null;
	      try {
	        // only try catch user defined functions
	        sanitized = requestSanitizer(request);
	      } catch (err) {
	        console.error(err);
	      }
	      if (sanitized) {
	        // Writing and then reading from an a tag turns a relative
	        // url into an absolute one.
	        var a = document.createElement('a');
	        a.href = sanitized.url;
	
	        return {
	          reqId: reqId, // default
	          url: a.href, // sanitized
	          headers: (0, _mapValues2.default)(sanitized.headers, function (headerValue) {
	            // sanitized
	            return '' + headerValue;
	          }),
	          body: truncate(sanitized.body), // sanitized
	          method: method, // default
	          referrer: sanitized.referrer || undefined, // sanitized
	          mode: sanitized.mode || undefined, // sanitized
	          credentials: sanitized.credentials || undefined // sanitized
	        };
	      }
	      ignoredNetwork[reqId] = true;
	      return null;
	    });
	  };
	
	  var addResponse = function addResponse(reqId, response) {
	    var method = response.method,
	        status = response.status;
	
	    logger.addEvent('lr.network.ResponseEvent', function () {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$isEnabled = _ref2.isEnabled,
	          isEnabled = _ref2$isEnabled === undefined ? true : _ref2$isEnabled,
	          _ref2$responseSanitiz = _ref2.responseSanitizer,
	          responseSanitizer = _ref2$responseSanitiz === undefined ? function (f) {
	        return f;
	      } : _ref2$responseSanitiz;
	
	      if (!isEnabled) {
	        return null;
	      } else if (ignoredNetwork[reqId]) {
	        delete ignoredNetwork[reqId];
	        return null;
	      }
	      var sanitized = null;
	
	      try {
	        // only try catch user defined functions
	        sanitized = responseSanitizer(response);
	      } catch (err) {
	        console.error(err);
	        // fall through to redacted log
	      }
	      if (sanitized) {
	        return {
	          reqId: reqId, // default
	          status: sanitized.status, // sanitized
	          headers: (0, _mapValues2.default)(sanitized.headers, function (headerValue) {
	            // sanitized
	            return '' + headerValue;
	          }),
	          body: truncate(sanitized.body), // sanitized
	          method: method // default
	        };
	      }
	      return {
	        reqId: reqId, // default
	        status: status, // default
	        headers: {}, // redacted
	        body: null, // redacted
	        method: method // default
	      };
	    });
	  };
	
	  var unsubFetch = (0, _registerFetch2.default)({ addRequest: addRequest, addResponse: addResponse });
	  var unsubXHR = (0, _registerXHR2.default)({ addRequest: addRequest, addResponse: addResponse });
	  // const unsubWebSocket = registerWebSocket(logger);
	
	  return function () {
	    unsubFetch();
	    unsubXHR();
	    // unsubWebSocket();
	  };
	}
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = registerFetch;
	
	var _mapValues = __webpack_require__(0);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _fetchIntercept = __webpack_require__(15);
	
	var _fetchIntercept2 = _interopRequireDefault(_fetchIntercept);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeObjectFromHeaders(headers) {
	  // If using real fetch, we must stringify the Headers object.
	  if (headers == null || typeof headers.forEach !== 'function') {
	    return headers;
	  }
	
	  var result = {};
	  headers.forEach(function (value, key) {
	    if (result[key]) {
	      result[key] = result[key] + ',' + value;
	    } else {
	      result[key] = '' + value;
	    }
	  });
	  return result;
	}
	
	// XHR specification is unclear of what types to allow in value so using toString method for now
	var stringifyHeaders = function stringifyHeaders(headers) {
	  return (0, _mapValues2.default)(makeObjectFromHeaders(headers), function (value) {
	    return '' + value;
	  });
	};
	
	function pluckFetchFields() {
	  var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    url: arg.url,
	    headers: stringifyHeaders(arg.headers),
	    method: arg.method && arg.method.toUpperCase(),
	    referrer: arg.referrer || undefined,
	    mode: arg.mode || undefined,
	    credentials: arg.credentials || undefined
	  };
	}
	
	function registerFetch(_ref) {
	  var addRequest = _ref.addRequest,
	      addResponse = _ref.addResponse;
	
	  var LOGROCKET_XHR_LABEL = 'fetch-';
	  var fetchMethodMap = {};
	
	  var unregister = _fetchIntercept2.default.register({
	    request: function request(fetchId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var p = void 0;
	
	      if (typeof Request !== 'undefined' && args[0] instanceof Request) {
	        p = args[0].clone().text().then(function (body) {
	          return _extends({}, pluckFetchFields(args[0]), {
	            body: body
	          });
	        });
	      } else {
	        p = Promise.resolve(_extends({}, pluckFetchFields(args[1]), {
	          url: '' + args[0],
	          body: (args[1] || {}).body
	        }));
	      }
	
	      return p.then(function (req) {
	        fetchMethodMap[fetchId] = req.method;
	        addRequest('' + LOGROCKET_XHR_LABEL + fetchId, req);
	        return args;
	      });
	    },
	    requestError: function requestError(fetchId, error) {
	      return Promise.reject(error);
	    },
	    response: function response(fetchId, _response) {
	      var clonedText = void 0;
	
	      try {
	        // TODO: enhance function on original response and future clones for:
	        // text(), json(), blob(), formdata(), arraybuffer()
	        clonedText = _response.clone().text();
	      } catch (err) {
	        // safari has a bug where cloning can fail
	        clonedText = Promise.resolve('LogRocket fetch error: ' + err.message);
	      }
	
	      return clonedText.then(function (data) {
	        var responseHash = {
	          url: _response.url,
	          status: _response.status,
	          headers: stringifyHeaders(_response.headers),
	          body: data,
	          method: fetchMethodMap[fetchId]
	        };
	        delete fetchMethodMap[fetchId];
	        addResponse('' + LOGROCKET_XHR_LABEL + fetchId, responseHash);
	        return _response;
	      });
	    },
	    responseError: function responseError(fetchId, error) {
	      var response = {
	        url: undefined,
	        status: 0,
	        headers: {},
	        body: '' + error
	      };
	      addResponse('' + LOGROCKET_XHR_LABEL + fetchId, response);
	      return Promise.reject(error);
	    }
	  });
	
	  return unregister;
	}
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _registerXHR = __webpack_require__(1);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var interceptors = [];
	
	function makeInterceptor(fetch, fetchId) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var reversedInterceptors = interceptors.reduce(function (array, interceptor) {
	    return [interceptor].concat(array);
	  }, []);
	  var promise = Promise.resolve(args);
	
	  // Register request interceptors
	  reversedInterceptors.forEach(function (_ref) {
	    var request = _ref.request,
	        requestError = _ref.requestError;
	
	    if (request || requestError) {
	      promise = promise.then(function (args) {
	        return request.apply(undefined, [fetchId].concat(_toConsumableArray(args)));
	      }, function (args) {
	        return requestError.apply(undefined, [fetchId].concat(_toConsumableArray(args)));
	      });
	    }
	  });
	
	  promise = promise.then(function (args) {
	    (0, _registerXHR.setActive)(false);
	
	    var res = void 0;
	    var err = void 0;
	    try {
	      res = fetch.apply(undefined, _toConsumableArray(args));
	    } catch (_err) {
	      err = _err;
	    }
	
	    (0, _registerXHR.setActive)(true);
	
	    if (err) {
	      throw err;
	    }
	    return res;
	  });
	
	  reversedInterceptors.forEach(function (_ref2) {
	    var response = _ref2.response,
	        responseError = _ref2.responseError;
	
	    if (response || responseError) {
	      promise = promise.then(function (res) {
	        return response(fetchId, res);
	      }, function (err) {
	        return responseError && responseError(fetchId, err);
	      });
	    }
	  });
	
	  return promise;
	}
	
	function attach(env) {
	  if (!env.fetch || !env.Promise) {
	    // Make sure fetch is avaibale in the given environment. If it's not, then
	    // default to using XHR intercept.
	    return;
	  }
	
	  var isPolyfill = env.fetch.polyfill;
	
	  // eslint-disable-next-line no-param-reassign
	  env.fetch = function (fetch) {
	    var fetchId = 0;
	
	    return function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return makeInterceptor.apply(undefined, [fetch, fetchId++].concat(args));
	    };
	  }(env.fetch);
	
	  // Forward the polyfill propery from fetch (set by github/whatwg-fetch).
	  if (isPolyfill) {
	    // eslint-disable-next-line no-param-reassign
	    env.fetch.polyfill = isPolyfill;
	  }
	}
	
	// TODO: React Native
	//   attach(global);
	
	var didAttach = false;
	
	exports.default = {
	  register: function register(interceptor) {
	    if (!didAttach) {
	      didAttach = true;
	      attach(window);
	    }
	
	    interceptors.push(interceptor);
	    return function () {
	      var index = interceptors.indexOf(interceptor);
	
	      if (index >= 0) {
	        interceptors.splice(index, 1);
	      }
	    };
	  },
	  clear: function clear() {
	    interceptors = [];
	  }
	};
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = registerCore;
	
	var _raven = __webpack_require__(17);
	
	var _raven2 = _interopRequireDefault(_raven);
	
	var _Capture = __webpack_require__(6);
	
	var Capture = _interopRequireWildcard(_Capture);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerCore(logger) {
	  var raven = new _raven2.default({
	    captureException: function captureException(errorReport) {
	      Capture.captureException(logger, null, null, errorReport);
	    }
	  });
	
	  var rejectionHandler = function rejectionHandler(evt) {
	    // http://2ality.com/2016/04/unhandled-rejections.html
	    logger.addEvent('lr.core.Exception', function () {
	      return {
	        exceptionType: 'UNHANDLED_REJECTION',
	        message: evt.reason || 'Unhandled Promise rejection'
	      };
	    });
	  };
	
	  window.addEventListener('unhandledrejection', rejectionHandler);
	
	  return function () {
	    window.removeEventListener('unhandledrejection', rejectionHandler);
	    raven.uninstall();
	  };
	}
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */
	
	var _TraceKit = __webpack_require__(5);
	
	var _TraceKit2 = _interopRequireDefault(_TraceKit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var objectPrototype = Object.prototype;
	
	function isUndefined(what) {
	  return what === void 0;
	}
	
	function isFunction(what) {
	  return typeof what === 'function';
	}
	
	function each(obj, callback) {
	  var i, j;
	
	  if (isUndefined(obj.length)) {
	    for (i in obj) {
	      if (hasKey(obj, i)) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  } else {
	    j = obj.length;
	    if (j) {
	      for (i = 0; i < j; i++) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  }
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	  return objectPrototype.hasOwnProperty.call(object, key);
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	  var orig = obj[name];
	  obj[name] = replacement(orig);
	  if (track) {
	    track.push([obj, name, orig]);
	  }
	}
	
	var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _document = _window.document;
	
	var Handler = function () {
	  function Handler(_ref) {
	    var captureException = _ref.captureException;
	
	    _classCallCheck(this, Handler);
	
	    this._errorHandler = this._errorHandler.bind(this);
	
	    this._ignoreOnError = 0;
	    this._wrappedBuiltIns = [];
	    this.captureException = captureException;
	    _TraceKit2.default.report.subscribe(this._errorHandler);
	    this._instrumentTryCatch();
	  }
	
	  _createClass(Handler, [{
	    key: 'uninstall',
	    value: function uninstall() {
	      _TraceKit2.default.report.unsubscribe(this._errorHandler);
	
	      // restore any wrapped builtins
	      var builtin;
	      while (this._wrappedBuiltIns.length) {
	        builtin = this._wrappedBuiltIns.shift();
	
	        var obj = builtin[0],
	            name = builtin[1],
	            orig = builtin[2];
	
	        obj[name] = orig;
	      }
	    }
	  }, {
	    key: '_errorHandler',
	    value: function _errorHandler(report) {
	      if (!this._ignoreOnError) {
	        this.captureException(report);
	      }
	    }
	  }, {
	    key: '_ignoreNextOnError',
	    value: function _ignoreNextOnError() {
	      var _this = this;
	
	      this._ignoreOnError += 1;
	      setTimeout(function () {
	        // onerror should trigger before setTimeout
	        _this._ignoreOnError -= 1;
	      });
	    }
	
	    /*
	     * Wrap code within a context so Handler can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	
	  }, {
	    key: 'context',
	    value: function context(options, func, args) {
	      if (isFunction(options)) {
	        args = func || [];
	        func = options;
	        options = undefined;
	      }
	
	      return this.wrap(options, func).apply(this, args);
	    }
	  }, {
	    key: 'wrap',
	
	
	    /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} func A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	    value: function wrap(options, func, _before) {
	      var self = this;
	      // 1 argument has been passed, and it's not a function
	      // so just return it
	      if (isUndefined(func) && !isFunction(options)) {
	        return options;
	      }
	
	      // options is optional
	      if (isFunction(options)) {
	        func = options;
	        options = undefined;
	      }
	
	      // At this point, we've passed along 2 arguments, and the second one
	      // is not a function either, so we'll just return the second argument.
	      if (!isFunction(func)) {
	        return func;
	      }
	
	      // We don't wanna wrap it twice!
	      try {
	        if (func.__lr__) {
	          return func;
	        }
	
	        // If this has already been wrapped in the past, return that
	        if (func.__lr_wrapper__) {
	          return func.__lr_wrapper__;
	        }
	      } catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see lr-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return func;
	      }
	
	      function wrapped() {
	        var args = [],
	            i = arguments.length,
	            deep = !options || options && options.deep !== false;
	
	        if (_before && isFunction(_before)) {
	          _before.apply(this, arguments);
	        }
	
	        // Recursively wrap all of a function's arguments that are
	        // functions themselves.
	        while (i--) {
	          args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	        }try {
	          // Attempt to invoke user-land function. This is part of the LogRocket SDK.
	          // If you're seeing this frame in a stack trace, it means that LogRocket caught
	          // an unhandled error thrown by your application code, reported it, then bubbled
	          // it up. This is expected behavior and is not a bug with LogRocket.
	          return func.apply(this, args);
	        } catch (e) {
	          self._ignoreNextOnError();
	          self.captureException(_TraceKit2.default.computeStackTrace(e), options);
	          throw e;
	        }
	      }
	
	      // copy over properties of the old function
	      for (var property in func) {
	        if (hasKey(func, property)) {
	          wrapped[property] = func[property];
	        }
	      }
	      wrapped.prototype = func.prototype;
	
	      func.__lr_wrapper__ = wrapped;
	      // Signal that this function has been wrapped already
	      // for both debugging and to prevent it to being wrapped twice
	      wrapped.__lr__ = true;
	      wrapped.__inner__ = func;
	
	      return wrapped;
	    }
	  }, {
	    key: '_instrumentTryCatch',
	
	
	    /**
	     * Install any queued plugins
	     */
	    value: function _instrumentTryCatch() {
	      var self = this;
	
	      var wrappedBuiltIns = self._wrappedBuiltIns;
	
	      function wrapTimeFn(orig) {
	        return function (fn, t) {
	          // preserve arity
	          // Make a copy of the arguments to prevent deoptimization
	          // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	          var args = new Array(arguments.length);
	          for (var i = 0; i < args.length; ++i) {
	            args[i] = arguments[i];
	          }
	          var originalCallback = args[0];
	          if (isFunction(originalCallback)) {
	            args[0] = self.wrap(originalCallback);
	          }
	
	          // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	          // also supports only two arguments and doesn't care what this is, so we
	          // can just call the original function directly.
	          if (orig.apply) {
	            return orig.apply(this, args);
	          } else {
	            return orig(args[0], args[1]);
	          }
	        };
	      }
	
	      function wrapEventTarget(global) {
	        var proto = _window[global] && _window[global].prototype;
	        if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	          fill(proto, 'addEventListener', function (orig) {
	            return function (evtName, fn, capture, secure) {
	              // preserve arity
	              try {
	                if (fn && fn.handleEvent) {
	                  fn.handleEvent = self.wrap(fn.handleEvent);
	                }
	              } catch (err) {}
	              // can sometimes get 'Permission denied to access property "handle Event'
	
	
	              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	              // so that we don't have more than one wrapper function
	              var before;
	
	              return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
	            };
	          }, wrappedBuiltIns);
	          fill(proto, 'removeEventListener', function (orig) {
	            return function (evt, fn, capture, secure) {
	              try {
	                fn = fn && (fn.__lr_wrapper__ ? fn.__lr_wrapper__ : fn);
	              } catch (e) {
	                // ignore, accessing __lr_wrapper__ will throw in some Selenium environments
	              }
	              return orig.call(this, evt, fn, capture, secure);
	            };
	          }, wrappedBuiltIns);
	        }
	      }
	
	      fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	      fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	      if (_window.requestAnimationFrame) {
	        fill(_window, 'requestAnimationFrame', function (orig) {
	          return function (cb) {
	            return orig(self.wrap(cb));
	          };
	        }, wrappedBuiltIns);
	      }
	
	      // event targets borrowed from bugsnag-js:
	      // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	      var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
	      for (var i = 0; i < eventTargets.length; i++) {
	        wrapEventTarget(eventTargets[i]);
	      }
	
	      var $ = _window.jQuery || _window.$;
	      if ($ && $.fn && $.fn.ready) {
	        fill($.fn, 'ready', function (orig) {
	          return function (fn) {
	            return orig.call(this, self.wrap(fn));
	          };
	        }, wrappedBuiltIns);
	      }
	    }
	  }]);
	
	  return Handler;
	}();
	
	exports.default = Handler;
	;
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stackTraceFromError;
	function stackTraceFromError(errorReport) {
	  function makeNotNull(val) {
	    return val === null ? undefined : val;
	  }
	
	  return errorReport.stack ? errorReport.stack.map(function (frame) {
	    return {
	      lineNumber: makeNotNull(frame.line),
	      columnNumber: makeNotNull(frame.column),
	      fileName: makeNotNull(frame.url),
	      functionName: makeNotNull(frame.func)
	    };
	  }) : undefined;
	}
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _registerConsole = __webpack_require__(20);
	
	var _registerConsole2 = _interopRequireDefault(_registerConsole);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _registerConsole2.default;
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = registerConsole;
	
	var _enhanceFunc = __webpack_require__(2);
	
	var _enhanceFunc2 = _interopRequireDefault(_enhanceFunc);
	
	var _logrocketExceptions = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerConsole(logger) {
	  var unsubFunctions = [];
	  var methods = ['log', 'warn', 'info', 'error', 'debug'];
	
	  methods.forEach(function (method) {
	    unsubFunctions.push((0, _enhanceFunc2.default)(console, method, function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      logger.addEvent('lr.core.LogEvent', function () {
	        var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var isEnabled = consoleOptions.isEnabled;
	
	        if ((typeof isEnabled === 'undefined' ? 'undefined' : _typeof(isEnabled)) === 'object' && isEnabled[method] === false || isEnabled === false) {
	          return null;
	        }
	
	        if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
	          _logrocketExceptions.Capture.captureMessage(logger, args[0], {}, true);
	        }
	
	        return {
	          logLevel: method.toUpperCase(),
	          args: args
	        };
	      });
	    }));
	  });
	
	  return function () {
	    unsubFunctions.forEach(function (unsubFunction) {
	      return unsubFunction();
	    });
	  };
	}
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createEnhancer = exports.createMiddleware = undefined;
	
	var _createEnhancer = __webpack_require__(22);
	
	var _createEnhancer2 = _interopRequireDefault(_createEnhancer);
	
	var _createMiddleware = __webpack_require__(23);
	
	var _createMiddleware2 = _interopRequireDefault(_createMiddleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createMiddleware = _createMiddleware2.default;
	exports.createEnhancer = _createEnhancer2.default;
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createEnhancer;
	
	var _now = __webpack_require__(7);
	
	var _now2 = _interopRequireDefault(_now);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storeIdCounter = 0;
	
	function createEnhancer(logger) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stateSanitizer = _ref.stateSanitizer,
	      stateSanitizer = _ref$stateSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$stateSanitizer,
	      _ref$actionSanitizer = _ref.actionSanitizer,
	      actionSanitizer = _ref$actionSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$actionSanitizer;
	
	  // an enhancer is a function that returns a Store
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var originalDispatch = store.dispatch;
	      var storeId = storeIdCounter++;
	      logger.addEvent('lr.redux.InitialState', function () {
	        var sanitizedState = void 0;
	        try {
	          // only try catch user defined functions
	          sanitizedState = stateSanitizer(store.getState());
	        } catch (err) {
	          console.error(err.toString());
	        }
	
	        return {
	          state: sanitizedState,
	          storeId: storeId
	        };
	      });
	
	      var dispatch = function dispatch(action) {
	        var start = (0, _now2.default)();
	
	        var err = void 0;
	        var res = void 0;
	        try {
	          res = originalDispatch(action);
	        } catch (_err) {
	          err = _err;
	        } finally {
	          var duration = (0, _now2.default)() - start;
	
	          logger.addEvent('lr.redux.ReduxAction', function () {
	            var sanitizedState = null;
	            var sanitizedAction = null;
	
	            try {
	              // only try catch user defined functions
	              sanitizedState = stateSanitizer(store.getState());
	              sanitizedAction = actionSanitizer(action);
	            } catch (err) {
	              console.error(err.toString());
	            }
	
	            if (sanitizedState && sanitizedAction) {
	              return {
	                storeId: storeId,
	                action: sanitizedAction,
	                duration: duration,
	                stateDelta: sanitizedState
	              };
	            }
	            return null;
	          });
	        }
	
	        if (err) {
	          throw err;
	        }
	
	        return res;
	      };
	
	      return _extends({}, store, {
	        dispatch: dispatch
	      });
	    };
	  };
	}
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMiddleware;
	
	var _now = __webpack_require__(7);
	
	var _now2 = _interopRequireDefault(_now);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storeIdCounter = 0;
	
	function createMiddleware(logger) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stateSanitizer = _ref.stateSanitizer,
	      stateSanitizer = _ref$stateSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$stateSanitizer,
	      _ref$actionSanitizer = _ref.actionSanitizer,
	      actionSanitizer = _ref$actionSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$actionSanitizer;
	
	  return function (store) {
	    var storeId = storeIdCounter++;
	    logger.addEvent('lr.redux.InitialState', function () {
	      var sanitizedState = void 0;
	      try {
	        // only try catch user defined functions
	        sanitizedState = stateSanitizer(store.getState());
	      } catch (err) {
	        console.error(err.toString());
	      }
	
	      return {
	        state: sanitizedState,
	        storeId: storeId
	      };
	    });
	
	    return function (next) {
	      return function (action) {
	        var start = (0, _now2.default)();
	
	        var err = void 0;
	        var res = void 0;
	        try {
	          res = next(action);
	        } catch (_err) {
	          err = _err;
	        } finally {
	          var duration = (0, _now2.default)() - start;
	
	          logger.addEvent('lr.redux.ReduxAction', function () {
	            var sanitizedState = null;
	            var sanitizedAction = null;
	
	            try {
	              // only try catch user defined functions
	              sanitizedState = stateSanitizer(store.getState());
	              sanitizedAction = actionSanitizer(action);
	            } catch (err) {
	              console.error(err.toString());
	            }
	
	            if (sanitizedState && sanitizedAction) {
	              return {
	                storeId: storeId,
	                action: sanitizedAction,
	                duration: duration,
	                stateDelta: sanitizedState
	              };
	            }
	            return null;
	          });
	        }
	
	        if (err) {
	          throw err;
	        }
	
	        return res;
	      };
	    };
	  };
	}
	
	/***/ })
	/******/ ]);
	});

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actionTypes = __webpack_require__(459);
	
	var crashReporter = function crashReporter(store) {
	    return function (next) {
	        return function (action) {
	            try {
	                if (action.type === _actionTypes.INIT_MEMBER_DETAILS || action.type === _actionTypes.SET_MEMBER_DATA) {
	                    var memberDetails = action.type === _actionTypes.INIT_MEMBER_DETAILS && window.Farmigo ? window.Farmigo.memberDetails : action.memberDetails;
	                    if (memberDetails) {
	                        var userContext = { email: memberDetails.email };
	                        if (memberDetails.key) userContext.key = memberDetails.key;
	                        if (typeof Raven !== 'undefined') Raven.setUserContext(userContext);
	                    }
	                }
	                return next(action);
	            } catch (err) {
	                console.error('Caught an exception!', err);
	                if (typeof Raven !== 'undefined') Raven.captureException(err, {
	                    extra: {
	                        action: action
	                    }
	                });
	                throw err;
	            }
	        };
	    };
	};
	
	exports.default = crashReporter;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//---------------------------common -----------------------
	var SET_STORAGE_TIMESTAMP = exports.SET_STORAGE_TIMESTAMP = 'SET_STORAGE_TIMESTAMP';
	var REMOVE_STORAGE = exports.REMOVE_STORAGE = 'REMOVE_STORAGE';
	var FETCHING_DATA = exports.FETCHING_DATA = 'FETCHING_DATA';
	var DATA_FETCHED = exports.DATA_FETCHED = 'DATA_FETCHED';
	var ERROR_FETCHING = exports.ERROR_FETCHING = 'ERROR_FETCHING';
	var CLEAR_ERROR = exports.CLEAR_ERROR = 'CLEAR_ERROR';
	var SHOW_DIRTY_MODAL = exports.SHOW_DIRTY_MODAL = 'SHOW_DIRTY_MODAL';
	var SET_DIRTY = exports.SET_DIRTY = 'SET_DIRTY';
	var UPDATE_CLIENT_VIEW_PORT = exports.UPDATE_CLIENT_VIEW_PORT = 'UPDATE_CLIENT_VIEW_PORT';
	var INITIAL_SERVER_DATA = exports.INITIAL_SERVER_DATA = 'INITIAL_SERVER_DATA';
	var SET_URL_PARAMS = exports.SET_URL_PARAMS = 'SET_URL_PARAMS';
	var TRACK_GA_EVENT = exports.TRACK_GA_EVENT = 'TRACK_GA_EVENT';
	var TRACK_GA_PAGEVIEW = exports.TRACK_GA_PAGEVIEW = 'TRACK_GA_PAGEVIEW';
	//---------------------------login -----------------------
	var LOG_IN_STATUS = exports.LOG_IN_STATUS = 'LOG_IN_STATUS';
	var FORGET_PASSWORD = exports.FORGET_PASSWORD = 'FORGET_PASSWORD';
	var SHOW_FACEBOOK_POPUP = exports.SHOW_FACEBOOK_POPUP = 'SHOW_FACEBOOK_POPUP';
	var CHANGE_PASSWORD = exports.CHANGE_PASSWORD = 'CHANGE_PASSWORD';
	var ENABLE_FB_BUTTON = exports.ENABLE_FB_BUTTON = 'ENABLE_FB_BUTTON';
	//---------------------------store -----------------------
	var LOAD_CATEGORIES = exports.LOAD_CATEGORIES = 'LOAD_CATEGORIES';
	var CHANGE_ITEM_QUANTITY = exports.CHANGE_ITEM_QUANTITY = 'CHANGE_ITEM_QUANTITY';
	var LOAD_ITEMS = exports.LOAD_ITEMS = 'LOAD_ITEMS';
	var SET_POST_ACTION_KEY = exports.SET_POST_ACTION_KEY = 'SET_POST_ACTION_KEY';
	var CHANGE_CATEGORY = exports.CHANGE_CATEGORY = 'CHANGE_CATEGORY';
	var SET_ACTIVE_ORDER = exports.SET_ACTIVE_ORDER = 'SET_ACTIVE_ORDER';
	var SET_SUMMARY = exports.SET_SUMMARY = 'SET_SUMMARY';
	var MESSAGE_DATA = exports.MESSAGE_DATA = 'MESSAGE_DATA';
	var SET_SHOULD_RELOAD_DATA = exports.SET_SHOULD_RELOAD_DATA = 'SET_SHOULD_RELOAD_DATA';
	var RESET_PASSWORD_EMAIL_SENT = exports.RESET_PASSWORD_EMAIL_SENT = 'RESET_PASSWORD_EMAIL_SENT';
	var RESET_STATUS = exports.RESET_STATUS = 'RESET_STATUS';
	var SET_DELIVERY_DAY_FILTER = exports.SET_DELIVERY_DAY_FILTER = 'SET_DELIVERY_DAY_FILTER';
	var ADD_ITEM = exports.ADD_ITEM = 'ADD_ITEM';
	var SELECT_PAYMENT_PLAN = exports.SELECT_PAYMENT_PLAN = 'SELECT_PAYMENT_PLAN';
	var SET_COUPON = exports.SET_COUPON = 'SET_COUPON';
	var REMOVE_COUPON = exports.REMOVE_COUPON = 'REMOVE_COUPON';
	var SET_STORE_COMMENT = exports.SET_STORE_COMMENT = 'SET_STORE_COMMENT';
	var STORE_CREDITS_DATA = exports.STORE_CREDITS_DATA = 'STORE_CREDITS_DATA';
	var SET_REMAINING_CREDITS = exports.SET_REMAINING_CREDITS = 'SET_REMAINING_CREDITS';
	var CHANGE_EXTRA_ITEM_QUANTITY = exports.CHANGE_EXTRA_ITEM_QUANTITY = 'CHANGE_EXTRA_ITEM_QUANTITY';
	var SET_UNAVAILABLE_ITEMS = exports.SET_UNAVAILABLE_ITEMS = 'SET_UNAVAILABLE_ITEMS';
	var UPDATE_ITEMS_PROPS = exports.UPDATE_ITEMS_PROPS = 'UPDATE_ITEMS_PROPS';
	var UPDATE_ITEMS_AVAILABILITY = exports.UPDATE_ITEMS_AVAILABILITY = 'UPDATE_ITEMS_AVAILABILITY';
	var CLEAR_SHARES_SELECTION = exports.CLEAR_SHARES_SELECTION = 'CLEAR_SHARES_SELECTION';
	var UPDATE_TOTALS = exports.UPDATE_TOTALS = 'UPDATE_TOTALS';
	var SET_ALLOW_ORDER_EDIT = exports.SET_ALLOW_ORDER_EDIT = 'SET_ALLOW_ORDER_EDIT';
	var SET_WEB_ORDER_COUPON = exports.SET_WEB_ORDER_COUPON = 'SET_WEB_ORDER_COUPON';
	var SET_DROPDOWN_CLOSED = exports.SET_DROPDOWN_CLOSED = 'SET_DROPDOWN_CLOSED';
	var SHOW_UPDATE_RECURRING_MODAL = exports.SHOW_UPDATE_RECURRING_MODAL = 'SHOW_UPDATE_RECURRING_MODAL';
	var SET_RECURRING_ORDER_DATA = exports.SET_RECURRING_ORDER_DATA = 'SET_RECURRING_ORDER_DATA';
	var SET_RECURRING_ITEM = exports.SET_RECURRING_ITEM = 'SET_RECURRING_ITEM';
	var SHOW_LOGIN_SIGNUP_MODAL = exports.SHOW_LOGIN_SIGNUP_MODAL = 'SHOW_LOGIN_SIGNUP_MODAL';
	//---------------------------join -----------------------
	var GOTO_STEP = exports.GOTO_STEP = 'GOTO_STEP';
	var SET_SIGNUP_DATA = exports.SET_SIGNUP_DATA = 'SET_SIGNUP_DATA';
	var CLEAR_SIGNUP_DATA = exports.CLEAR_SIGNUP_DATA = 'CLEAR_SIGNUP_DATA';
	var SET_SHARES_DATA = exports.SET_SHARES_DATA = 'SET_SHARES_DATA';
	var JOIN_CHANGE_ITEM_QUANTITY = exports.JOIN_CHANGE_ITEM_QUANTITY = 'JOIN_CHANGE_ITEM_QUANTITY';
	var JOIN_SET_ITEM_SCHEDULE = exports.JOIN_SET_ITEM_SCHEDULE = 'JOIN_SET_ITEM_SCHEDULE';
	var SET_SELECTED_METHOD = exports.SET_SELECTED_METHOD = 'SET_SELECTED_METHOD';
	var SET_MAP_PROPS = exports.SET_MAP_PROPS = 'SET_MAP_PROPS';
	var INIT_MAP_PROPS = exports.INIT_MAP_PROPS = 'INIT_MAP_PROPS';
	var SET_SIGNUP_COMMENTS = exports.SET_SIGNUP_COMMENTS = 'SET_SIGNUP_COMMENTS';
	var SET_TERMS_SELECTED = exports.SET_TERMS_SELECTED = 'SET_TERMS_SELECTED';
	var SET_HOME_DELIVERY_INSTRUCTIONS = exports.SET_HOME_DELIVERY_INSTRUCTIONS = 'SET_HOME_DELIVERY_INSTRUCTIONS';
	var SET_CREATEING_SUBSCRIPTION = exports.SET_CREATEING_SUBSCRIPTION = 'SET_CREATEING_SUBSCRIPTION';
	var SET_INVALID_OPTION_SCHEDULE_MESSAGE = exports.SET_INVALID_OPTION_SCHEDULE_MESSAGE = 'SET_INVALID_OPTION_SCHEDULE_MESSAGE';
	var SET_COUPON_STATUS = exports.SET_COUPON_STATUS = 'SET_COUPON_STATUS';
	var SET_MULTI_ORDER_EDIT = exports.SET_MULTI_ORDER_EDIT = 'SET_MULTI_ORDER_EDIT';
	//-------------------------- member details --------
	var INIT_MEMBER_DETAILS = exports.INIT_MEMBER_DETAILS = 'INIT_MEMBER_DETAILS';
	var SET_MEMBER_DATA = exports.SET_MEMBER_DATA = 'SET_MEMBER_DATA';
	var SET_MEMBER_ACTION = exports.SET_MEMBER_ACTION = 'SET_MEMBER_ACTION';
	var SET_MEMBER_KEY = exports.SET_MEMBER_KEY = 'SET_MEMBER_KEY';
	//------------------------- account ---------------
	var SET_ACCOUNT_DATA = exports.SET_ACCOUNT_DATA = 'SET_ACCOUNT_DATA';
	var SET_ACCOUNT_MODE = exports.SET_ACCOUNT_MODE = "SET_ACCOUNT_MODE";
	var SET_SUBSCRIPTION_NEXT_DELIVERY_DATE = exports.SET_SUBSCRIPTION_NEXT_DELIVERY_DATE = 'SET_SUBSCRIPTION_NEXT_DELIVERY_DATE';
	var SET_PICKUP_SITE = exports.SET_PICKUP_SITE = 'SET_PICKUP_SITE';
	var SET_WAIT_LIST_PICKUP_SITE = exports.SET_WAIT_LIST_PICKUP_SITE = 'SET_WAIT_LIST_PICKUP_SITE';
	var SET_PICKUP_SITES_DELIVERY_DATE = exports.SET_PICKUP_SITES_DELIVERY_DATE = 'SET_PICKUP_SITES_DELIVERY_DATE';
	var SET_PICKUP_SITES_DELIVERY_DATE_ACTUAL = exports.SET_PICKUP_SITES_DELIVERY_DATE_ACTUAL = 'SET_PICKUP_SITES_DELIVERY_DATE_ACTUAL';
	var SET_CAN_SAVE_DELIVERY_HOLD = exports.SET_CAN_SAVE_DELIVERY_HOLD = 'SET_CAN_SAVE_DELIVERY_HOLD';
	var SET_CUSTOM_AMOUNT = exports.SET_CUSTOM_AMOUNT = 'SET_CUSTOM_AMOUNT';
	var SET_ALLOW_CONTINUE_PAYMENT = exports.SET_ALLOW_CONTINUE_PAYMENT = 'SET_ALLOW_CONTINUE_PAYMENT';
	var SET_VACATIONS = exports.SET_VACATIONS = 'SET_VACATIONS';
	var SET_REQUIRED_MAKE_UP_DATA = exports.SET_REQUIRED_MAKE_UP_DATA = 'SET_REQUIRED_MAKE_UP_DATA';
	var SET_SHOW_ADDRESS_VALIDATION_MESSAGE = exports.SET_SHOW_ADDRESS_VALIDATION_MESSAGE = 'SET_SHOW_ADDRESS_VALIDATION_MESSAGE';
	//----------------------------- payment -------------
	var SET_PAYMENT_TYPE = exports.SET_PAYMENT_TYPE = 'SET_PAYMENT_TYPE';
	var SET_PAYMENT_PLAN = exports.SET_PAYMENT_PLAN = 'SET_PAYMENT_PLAN';
	var SET_PAYMENT_METHOD = exports.SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
	//------------------------------contact validation --------
	var SET_SHOW_PASSWORD = exports.SET_SHOW_PASSWORD = "SET_SHOW_PASSWORD";
	var CONTACT_INFO_STEP = exports.CONTACT_INFO_STEP = 'CONTACT_INFO_STEP';
	var SET_CONTACT_DETAILS = exports.SET_CONTACT_DETAILS = 'SET_CONTACT_DETAILS';
	var SET_UPDATE_MEMBER_ERROR = exports.SET_UPDATE_MEMBER_ERROR = 'SET_UPDATE_MEMBER_ERROR';
	var SET_ADDRESS_VALIDATION_ERROR = exports.SET_ADDRESS_VALIDATION_ERROR = 'SET_ADDRESS_VALIDATION_ERROR';
	var SET_LAT_LNG = exports.SET_LAT_LNG = 'SET_LAT_LNG';
	var SET_ADDRESS_VALIDATION_ERROR_NO_ACTION = exports.SET_ADDRESS_VALIDATION_ERROR_NO_ACTION = 'SET_ADDRESS_VALIDATION_ERROR_NO_ACTION';
	//-------------------------------store coupons -------------
	var SET_STORE_HAS_COUPONS = exports.SET_STORE_HAS_COUPONS = 'SET_STORE_HAS_COUPONS';
	var SET_HAS_ALREADY_COUPON = exports.SET_HAS_ALREADY_COUPON = 'SET_HAS_ALREADY_COUPON';
	//----------------------------------------------------------
	var SET_WEB_ORDER = exports.SET_WEB_ORDER = 'SET_WEB_ORDER';
	var SET_ON_PERMANENT_HOLD = exports.SET_ON_PERMANENT_HOLD = 'SET_ON_PERMANENT_HOLD';

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getStateFromStorage = getStateFromStorage;
	exports.setStateInStorge = setStateInStorge;
	exports.clearStorage = clearStorage;
	exports.setDraftOrderInStorage = setDraftOrderInStorage;
	exports.getDraftOrderFromStorage = getDraftOrderFromStorage;
	var STORAGE_STATE_KEY = 'farmigoStoreState';
	var STORAGE_TIMESTAMP_KEY = 'farmigoStoreTimestamp';
	var STORAGE_DRAFT_ORDER_KEY = 'farmigoDraftOrder';
	
	function getStateFromStorage() {
	    try {
	        var timestamp = sessionStorage.getItem(STORAGE_TIMESTAMP_KEY);
	        if (!timestamp) return {};
	
	        var now = new Date().getTime();
	
	        //Check if was set in more than 10 minutes
	        if (now - timestamp > 10 * 60 * 1000) {
	            sessionStorage.removeItem(STORAGE_STATE_KEY);
	            sessionStorage.removeItem(STORAGE_TIMESTAMP_KEY);
	            return {};
	        }
	
	        var state = sessionStorage.getItem(STORAGE_STATE_KEY);
	        if (!state) {
	            sessionStorage.removeItem(STORAGE_TIMESTAMP_KEY);
	            return {};
	        }
	
	        sessionStorage.removeItem(STORAGE_STATE_KEY);
	        sessionStorage.removeItem(STORAGE_TIMESTAMP_KEY);
	        state = JSON.parse(state);
	        state.storage.timestamp = undefined;
	        state.fetching = {};
	        //In case of thank-you page don't show the dirty message
	        if (window.location.pathname.includes("/thankyou")) state.orderStatus = {};
	        return state;
	    } catch (e) {
	        return {};
	    }
	}
	
	function setStateInStorge(state, timestamp) {
	    try {
	        //Avoid multiple calls to save
	        if (sessionStorage.getItem(STORAGE_TIMESTAMP_KEY) == timestamp) return;
	        sessionStorage.setItem(STORAGE_STATE_KEY, JSON.stringify(state));
	        sessionStorage.setItem(STORAGE_TIMESTAMP_KEY, timestamp);
	    } catch (e) {}
	}
	
	function clearStorage() {
	    try {
	        sessionStorage.removeItem(STORAGE_STATE_KEY);
	        sessionStorage.removeItem(STORAGE_TIMESTAMP_KEY);
	    } catch (e) {}
	}
	
	function setDraftOrderInStorage(order) {
	    var now = new Date().getTime();
	    sessionStorage.setItem(STORAGE_DRAFT_ORDER_KEY, JSON.stringify({ timestamp: now, order: order }));
	}
	
	function getDraftOrderFromStorage() {
	    try {
	        var draftOrder = sessionStorage.getItem(STORAGE_DRAFT_ORDER_KEY);
	        if (!draftOrder) {
	            return null;
	        }
	
	        var _JSON$parse = JSON.parse(draftOrder),
	            timestamp = _JSON$parse.timestamp,
	            order = _JSON$parse.order;
	
	        var now = new Date().getTime();
	
	        //Check if was set in more than 10 minutes
	        if (now - timestamp > 10 * 60 * 1000) {
	            sessionStorage.removeItem(STORAGE_DRAFT_ORDER_KEY);
	            return null;
	        }
	
	        sessionStorage.removeItem(STORAGE_DRAFT_ORDER_KEY);
	        return order;
	    } catch (e) {
	        return null;
	    }
	}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(407);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _storeItemsListReducer = __webpack_require__(462);
	
	var _loginReducer = __webpack_require__(467);
	
	var _storeCategoriesReducer = __webpack_require__(468);
	
	var _storeOrderStatusReducer = __webpack_require__(469);
	
	var _summaryReducer = __webpack_require__(470);
	
	var _messageReducer = __webpack_require__(471);
	
	var _gaReducer = __webpack_require__(472);
	
	var _joinReducer = __webpack_require__(475);
	
	var _staticDataReducer = __webpack_require__(476);
	
	var _storeCheckoutReducer = __webpack_require__(477);
	
	var _storeCreditsReducer = __webpack_require__(478);
	
	var _accountReducer = __webpack_require__(479);
	
	var _storageReducer = __webpack_require__(480);
	
	var _memberReducer = __webpack_require__(481);
	
	var _fetchingReducer = __webpack_require__(482);
	
	var _clientViewPortReducer = __webpack_require__(483);
	
	var _logRocketReducer = __webpack_require__(484);
	
	var _storeRecurringOrderReducer = __webpack_require__(487);
	
	var reducers = (0, _redux.combineReducers)({
	    routing: _reactRouterRedux.routerReducer,
	    itemsList: _storeItemsListReducer.storeItemsListReducer,
	    loginStatus: _loginReducer.loginReducer,
	    categories: _storeCategoriesReducer.storeCategoriesReducer,
	    orderStatus: _storeOrderStatusReducer.storeOrderStatusReducer,
	    summary: _summaryReducer.summaryReducer,
	    messageData: _messageReducer.messageReducer,
	    gaReducer: _gaReducer.gaReducer,
	    signupData: _joinReducer.joinReducer,
	    staticData: _staticDataReducer.staticDataReducer,
	    checkout: _storeCheckoutReducer.storeCheckoutReducer,
	    storeCreditsData: _storeCreditsReducer.storeCreditsReducer,
	    account: _accountReducer.accountReducer,
	    recurringOrder: _storeRecurringOrderReducer.storeRecurringOrderReducer,
	    storage: _storageReducer.storageReducer,
	    memberDetails: _memberReducer.memberReducer,
	    fetching: _fetchingReducer.fetchingReducer,
	    clientViewPort: _clientViewPortReducer.clientViewPortReducer,
	    logRocket: _logRocketReducer.logRocketReducer
	});
	
	exports.default = reducers;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.increaseItemOrder = increaseItemOrder;
	exports.storeItemsListReducer = storeItemsListReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	var _constants = __webpack_require__(463);
	
	var itemOrder = 0;
	
	function increaseItemOrder() {
	    return ++itemOrder;
	}
	function storeItemsListReducer(state, action) {
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.CHANGE_ITEM_QUANTITY:
	            {
	                //console.log("state:"+JSON.stringify(state));
	                //console.log("action:"+JSON.stringify(action));
	                var newQuantity = action.newQuantity; //state[action.key].quantity + 1;
	                var newState = Object.assign({}, state);
	                var newItem = Object.assign({}, newState[action.key]);
	                newItem[_constants.FIELD_SELECTED_ORDER] = newQuantity === 0 ? undefined : newItem[_constants.FIELD_SELECTED_ORDER] || increaseItemOrder();
	                newItem.quantity = newQuantity;
	                newState[action.key] = newItem;
	                if (newItem.variation) {
	                    var defaultBoxItem = newItem.defaultBoxItem;
	                    if (defaultBoxItem) {
	                        var newDefaultBoxItem = Object.assign({}, newState[defaultBoxItem]);
	                        newDefaultBoxItem.variations = Object.assign([], newDefaultBoxItem.variations);
	                        for (var i = 0; i < newDefaultBoxItem.variations.length; i++) {
	                            if (newDefaultBoxItem.variations[i].key === action.key) {
	                                newDefaultBoxItem.variations[i] = newItem;
	                                break;
	                            }
	                        }
	                        newState[defaultBoxItem] = newDefaultBoxItem;
	                    }
	                }
	                //console.log("new state:"+JSON.stringify(newState));
	                return newState;
	            }
	        case _actionTypes.LOAD_ITEMS:
	            return Object.assign({}, action.data);
	        case _actionTypes.UPDATE_ITEMS_PROPS:
	            {
	                var _newState = Object.assign({}, state);
	                for (var key in action.items) {
	                    if (action.items.hasOwnProperty(key)) {
	                        _newState[key] = action.items[key];
	                    }
	                }
	                return _newState;
	            }
	        case _actionTypes.UPDATE_ITEMS_AVAILABILITY:
	            {
	                var _newState2 = Object.assign({}, state);
	                for (var _key in action.items) {
	                    if (action.items.hasOwnProperty(_key)) {
	                        if (_newState2[_key]) {
	                            _newState2[_key].available = action.items[_key].available;;
	                        }
	                    }
	                }
	                return _newState2;
	            }
	        default:
	            return state;
	    }
	}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CouponStatus = exports.PaymentTypes = exports.Messages = exports.SubscriptionHoldReason = exports.SubscriptionStatuses = exports.JoinModes = exports.OverviewHistoryTypes = exports.FarmBalanceTypes = exports.AccountModes = exports.PickupSiteTypes = exports.MemberActions = exports.PickupSiteSelectionTypes = exports.JoinCreateAccountConstants = exports.JoinStepsDirections = exports.JoinSteps = exports.FetchingTypes = exports.PaymentPlanRestrictions = exports.PaymentPlansAutoPayment = exports.PaymentPlansSinglePayment = exports.PaymentPlans = exports.URLs = exports.PaymentMethodsAutoPayment = exports.PaymentMethodsSinglePayment = exports.PaymentMethod = exports.CreditTypes = exports.OLD_VERSION_MESSAGE = exports.OPERATION_ABORTED_ERROR_MESSAGE = exports.GOOGLE_UNDEFINED_ERROR_MESSAGE = exports.SUBSCRIPTION_EXISTS_ERROR_MESSAGE = exports.SUBSCRIPTION_EXISTS_ERROR = exports.INVALID_USER_AUTHENTICATION_ERROR_CODE = exports.CIM_NOT_ENABLED_ERROR_CODE = exports.CIM_NOT_ENABLED = exports.GEOCODE_ERROR = exports.UNAUTHORIZED_ACTION = exports.PICKUP_SITE_KEY_CHANGED = exports.ORDER_KEY_CHANGED = exports.NO_COOKIE_CREATE = exports.NO_COOKIE_LOGIN = exports.INVALID_ADDRESS_HOME_DELIVERY = exports.INVALID_PHONE_NUMBER = exports.INVALID_SEND_EMAIL_PARTNER_MESSAGE = exports.DELIVERY_HOLD_DATES_BLOCK_DATE_NO_BALANCE = exports.DELIVERY_HOLD_RECURRING_ORDERS_ALERT = exports.DELIVERY_HOLD_DATES_CANCEL_ORDER = exports.DELIVERY_HOLD_DATES_VACATION_CANNOT_BE_APPLIED = exports.DELIVERY_HOLD_DATES_END_BEFORE_START_DATE_ERROR = exports.DELIVERY_HOLD_DATES_IN_PAST_ERROR = exports.DELIVERY_HOLD_OVERLAP_ERROR = exports.NOT_USED_ALL_CREDITS_MESSAGE = exports.LOG_IN_MESSAGE = exports.GENERIC_ERROR_MESSAGE = exports.FIELD_ADDITIONAL_ITEM_QTY = exports.FIELD_SELECTED_ORDER = exports.ORIGIN_ITEM_SELECTED = exports.ORIGIN_CATEGORY_SELECTED = exports.CART_ITEM_QRY = exports.ITEM_QRY = exports.CATEGORY_QRY = undefined;
	
	var _translate = __webpack_require__(464);
	
	var CATEGORY_QRY = exports.CATEGORY_QRY = "#Tab";
	var ITEM_QRY = exports.ITEM_QRY = "#item";
	var CART_ITEM_QRY = exports.CART_ITEM_QRY = "#cart";
	
	var ORIGIN_CATEGORY_SELECTED = exports.ORIGIN_CATEGORY_SELECTED = 0;
	var ORIGIN_ITEM_SELECTED = exports.ORIGIN_ITEM_SELECTED = 1;
	
	var FIELD_SELECTED_ORDER = exports.FIELD_SELECTED_ORDER = "__selected_order__";
	var FIELD_ADDITIONAL_ITEM_QTY = exports.FIELD_ADDITIONAL_ITEM_QTY = "__additional_qty__";
	
	var GENERIC_ERROR_MESSAGE = exports.GENERIC_ERROR_MESSAGE = (0, _translate.translate)("FatalError.text");
	
	var LOG_IN_MESSAGE = exports.LOG_IN_MESSAGE = '_LoginToStart';
	var NOT_USED_ALL_CREDITS_MESSAGE = exports.NOT_USED_ALL_CREDITS_MESSAGE = (0, _translate.translate)("creditNotUsed");
	
	var DELIVERY_HOLD_OVERLAP_ERROR = exports.DELIVERY_HOLD_OVERLAP_ERROR = (0, _translate.translate)("enterValidVacationRangeNotOverlap");
	var DELIVERY_HOLD_DATES_IN_PAST_ERROR = exports.DELIVERY_HOLD_DATES_IN_PAST_ERROR = (0, _translate.translate)("enterFutureVacationPeriod");
	var DELIVERY_HOLD_DATES_END_BEFORE_START_DATE_ERROR = exports.DELIVERY_HOLD_DATES_END_BEFORE_START_DATE_ERROR = (0, _translate.translate)("enterValidVacationRange");
	var DELIVERY_HOLD_DATES_VACATION_CANNOT_BE_APPLIED = exports.DELIVERY_HOLD_DATES_VACATION_CANNOT_BE_APPLIED = (0, _translate.translate)("noChangeAllowedVacation");
	var DELIVERY_HOLD_DATES_CANCEL_ORDER = exports.DELIVERY_HOLD_DATES_CANCEL_ORDER = (0, _translate.translate)("_OrderScheduledDuringTheseDates");
	var DELIVERY_HOLD_RECURRING_ORDERS_ALERT = exports.DELIVERY_HOLD_RECURRING_ORDERS_ALERT = (0, _translate.translate)("deliveryHoldResetRecurringOrders");
	var DELIVERY_HOLD_DATES_BLOCK_DATE_NO_BALANCE = exports.DELIVERY_HOLD_DATES_BLOCK_DATE_NO_BALANCE = (0, _translate.translate)("cantAcceptVacationChangeActiveOrder");
	
	var INVALID_SEND_EMAIL_PARTNER_MESSAGE = exports.INVALID_SEND_EMAIL_PARTNER_MESSAGE = (0, _translate.translate)("sendEmailsRequiresFields");
	var INVALID_PHONE_NUMBER = exports.INVALID_PHONE_NUMBER = (0, _translate.translate)("INVALID_PHONE_NUMBER");
	var INVALID_ADDRESS_HOME_DELIVERY = exports.INVALID_ADDRESS_HOME_DELIVERY = (0, _translate.translate)("INVALID_ADDRESS_HOME_DELIVERY");
	
	var NO_COOKIE_LOGIN = exports.NO_COOKIE_LOGIN = "Your browser is set to block any site data and therefore you cannot log in. Please adjust your browser settings, restart the page and try again.";
	var NO_COOKIE_CREATE = exports.NO_COOKIE_CREATE = "Your browser is set to block any site data and therefore you cannot complete the process. Please adjust your browser settings, restart the page and try again.";
	var ORDER_KEY_CHANGED = exports.ORDER_KEY_CHANGED = (0, _translate.translate)("_refreshOrderDeleted");
	var PICKUP_SITE_KEY_CHANGED = exports.PICKUP_SITE_KEY_CHANGED = (0, _translate.translate)("Something went wrong. Please refresh the page.");
	var UNAUTHORIZED_ACTION = exports.UNAUTHORIZED_ACTION = "You are not authorized to take this action. Please login first";
	var GEOCODE_ERROR = exports.GEOCODE_ERROR = "Oops... <br>Something went wrong...";
	var CIM_NOT_ENABLED = exports.CIM_NOT_ENABLED = "Credit Card payments can't be processed now due to invalid configuration. Please select another payment method to complete your signup or contact the farm to set your account.";
	var CIM_NOT_ENABLED_ERROR_CODE = exports.CIM_NOT_ENABLED_ERROR_CODE = "E00044";
	var INVALID_USER_AUTHENTICATION_ERROR_CODE = exports.INVALID_USER_AUTHENTICATION_ERROR_CODE = "E00007";
	var SUBSCRIPTION_EXISTS_ERROR = exports.SUBSCRIPTION_EXISTS_ERROR = "SubscriptionExists";
	var SUBSCRIPTION_EXISTS_ERROR_MESSAGE = exports.SUBSCRIPTION_EXISTS_ERROR_MESSAGE = "You already have a subscription for this season. Please refresh the browser.";
	var GOOGLE_UNDEFINED_ERROR_MESSAGE = exports.GOOGLE_UNDEFINED_ERROR_MESSAGE = "google is not defined";
	var OPERATION_ABORTED_ERROR_MESSAGE = exports.OPERATION_ABORTED_ERROR_MESSAGE = "Operation aborted ";
	var OLD_VERSION_MESSAGE = exports.OLD_VERSION_MESSAGE = "Session ended. Please reload the browser to continue";
	
	var CreditTypes = exports.CreditTypes = {
	    'CREDIT_TYPE_REGULAR': 'RegularCredit',
	    'CREDIT_TYPE_FARMIGO': 'FarmigoCredit',
	    'CREDIT_BY_SHARE': 'shareCredit'
	};
	var PaymentMethod = exports.PaymentMethod = {
	    CHECK: { key: "CHECK", title: (0, _translate.translate)("CHECK") },
	    BALANCE: { key: "BALANCE", title: (0, _translate.translate)("BALANCE") },
	    PAYPAL_PRO: { key: "PAYPAL_PRO", title: (0, _translate.translate)("todo") },
	    PHONE: { key: "PHONE", title: (0, _translate.translate)("PHONE") },
	    PAYPAL_STANDARD: { key: "PAYPAL_STANDARD", title: (0, _translate.translate)("PAYPAL_STANDARD") },
	    PAYPAL_PREAPPROVE: { key: "PAYPAL_PREAPPROVE", title: (0, _translate.translate)("PAYPAL_PREAPPROVE"), shortTitle: (0, _translate.translate)("PayPal") },
	    ELECTRONIC_CHECK: { key: "ELECTRONIC_CHECK", title: (0, _translate.translate)("ELECTRONIC_CHECK") },
	    ELECTRONIC_CHECK_PREAPPROVE: { key: "ELECTRONIC_CHECK_PREAPPROVE", title: (0, _translate.translate)("ELECTRONIC_CHECK_PREAPPROVE"), shortTitle: (0, _translate.translate)("Electronic Check") },
	    AUTHORIZE_DOT_NET: { key: "AUTHORIZE_DOT_NET", title: (0, _translate.translate)("AUTHORIZE_DOT_NET") },
	    AUTHORIZE_DOT_NET_PREAPPROVE: { key: "AUTHORIZE_DOT_NET_PREAPPROVE", title: (0, _translate.translate)("AUTHORIZE_DOT_NET_PREAPPROVE"), shortTitle: (0, _translate.translate)("Debit/Credit Card") },
	    EBT_ONLINE: { key: "EBT_ONLINE", title: (0, _translate.translate)("EBT Online") },
	    CASH: { key: "CASH", title: (0, _translate.translate)("CASH") },
	    NONE: { key: "NONE", title: (0, _translate.translate)("NONE") }
	};
	
	var PaymentMethodsSinglePayment = exports.PaymentMethodsSinglePayment = [PaymentMethod.PAYPAL_STANDARD.key, PaymentMethod.ELECTRONIC_CHECK.key, PaymentMethod.CHECK.key, PaymentMethod.AUTHORIZE_DOT_NET.key, PaymentMethod.EBT_ONLINE.key];
	
	var PaymentMethodsAutoPayment = exports.PaymentMethodsAutoPayment = [PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key, PaymentMethod.PAYPAL_PREAPPROVE.key, PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key];
	
	var URLs = exports.URLs = {
	    'STORE': 'store',
	    'JOIN': 'join',
	    'ACCOUNT': 'account',
	    'PAY': 'pay',
	    'CHARGE': 'charge'
	};
	
	var PaymentPlans = exports.PaymentPlans = {
	    'F': 'F', //"Full Payment"
	    'P': 'P', //"Pre Payment"
	    'DynamicPrePayment': 'DynamicPrePayment',
	    'CustomPrePayment': 'CustomPrePayment',
	    'D': 'D', //"Dynamic"
	    'R': 'R', //"Recurring"
	    'AutoRecurring': 'AutoRecurring',
	    'FullWithDeposit': 'FullWithDeposit',
	    'PresetRecurring': 'PresetRecurring',
	    'OneWeekDebit': 'OneWeekDebit',
	    'DistributionDynamicPrePayment': 'DistributionDynamicPrePayment'
	};
	
	var PaymentPlansSinglePayment = exports.PaymentPlansSinglePayment = [PaymentPlans.DistributionDynamicPrePayment, PaymentPlans.CustomPrePayment, PaymentPlans.P, PaymentPlans.DynamicPrePayment];
	
	var PaymentPlansAutoPayment = exports.PaymentPlansAutoPayment = [PaymentPlans.DistributionDynamicPrePayment, PaymentPlans.P, PaymentPlans.DynamicPrePayment, PaymentPlans.OneWeekDebit];
	
	var PaymentPlanRestrictions = exports.PaymentPlanRestrictions = {
	    'F': ["PAYPAL_STANDARD", "ELECTRONIC_CHECK", "AUTHORIZE_DOT_NET", "CHECK", "PHONE", "EBT_ONLINE"],
	    'P': ["PAYPAL_STANDARD", "PAYPAL_PREAPPROVE", "ELECTRONIC_CHECK", "ELECTRONIC_CHECK_PREAPPROVE", "AUTHORIZE_DOT_NET", "AUTHORIZE_DOT_NET_PREAPPROVE", "CHECK", "PHONE", "EBT_ONLINE"],
	    'DynamicPrePayment': ["PAYPAL_STANDARD", "PAYPAL_PREAPPROVE", "ELECTRONIC_CHECK", "ELECTRONIC_CHECK_PREAPPROVE", "AUTHORIZE_DOT_NET", "AUTHORIZE_DOT_NET_PREAPPROVE", "CHECK", "PHONE", "EBT_ONLINE"],
	    'CustomPrePayment': [], //not an option in signup
	    'D': ["PAYPAL_STANDARD", "PAYPAL_PREAPPROVE", "ELECTRONIC_CHECK", "ELECTRONIC_CHECK_PREAPPROVE", "AUTHORIZE_DOT_NET", "AUTHORIZE_DOT_NET_PREAPPROVE", "CHECK", "PHONE", "EBT_ONLINE"],
	    'R': [],
	    'AutoRecurring': ["PAYPAL_PREAPPROVE", "ELECTRONIC_CHECK_PREAPPROVE", "AUTHORIZE_DOT_NET_PREAPPROVE", "CHECK", "PHONE"],
	    'PresetRecurring': ["PAYPAL_PREAPPROVE", "ELECTRONIC_CHECK_PREAPPROVE", "AUTHORIZE_DOT_NET_PREAPPROVE", "CHECK", "PHONE"],
	    'OneWeekDebit': ["CASH", "PAYPAL_PREAPPROVE", "ELECTRONIC_CHECK_PREAPPROVE", "AUTHORIZE_DOT_NET_PREAPPROVE"],
	    'DistributionDynamicPrePayment': ["PAYPAL_STANDARD", "PAYPAL_PREAPPROVE", "ELECTRONIC_CHECK", "ELECTRONIC_CHECK_PREAPPROVE", "AUTHORIZE_DOT_NET", "AUTHORIZE_DOT_NET_PREAPPROVE", "CHECK", "PHONE", "EBT_ONLINE"]
	};
	
	var FetchingTypes = exports.FetchingTypes = {
	    'LOAD_STORE_DATA': 'LoadStoreData',
	    'LOAD_SIGNUP_DATA': 'LoadSignupData',
	    'LOAD_SIGNUP_SHARES': 'LoadSignupShares',
	    'LOAD_PICKUP_DATA': 'LoadPickupData',
	    'GET_STATUS': 'GetStatus',
	    'VALIDATE_COUPON': 'ValidateCoupon',
	    'SUBMIT': 'Submit',
	    'LOG_OUT': 'Logout',
	    'LOGIN': 'Login',
	    'LOAD_ACCOUNT_DATA': 'LoadAccountData',
	    'LOAD_ORDER_DATA': 'LoadOrderData',
	    'UPDATE_VACATION': 'UPDATE_VACATION',
	    'UPDATE_PICKUP_SITE': 'UpdatePickupSite',
	    'CHANGE_SUBSCRIPTION': 'ChangeSubscription',
	    'CREATE_SUBSCRIPTION': 'CreateSubscription',
	    'VALIDATE_UPDATE_MEMBER': 'ValidateUpdateMember',
	    'UPDATE_LAT_LNG': 'UpdateLatLng',
	    'SET_RECURRING_ORDER': 'SetRecurringOrder',
	    'REMOVE_RECURRING_ORDER': 'RemoveRecurringOrder',
	    'UPDATE_ITEM_AVAILABILITY': 'UpdateItemAvailability'
	};
	
	var JoinSteps = exports.JoinSteps = {
	    'PICKUP_SITES': 'PICKUP_SITES',
	    'SHARES': 'SHARES',
	    'OPTIONS': 'OPTIONS',
	    'TERMS': 'TERMS',
	    'CONTACT_INFO': 'CONTACT_INFO',
	    'PAY': 'PAY',
	    'FINISH': 'FINISH',
	    'THANK_YOU': 'THANK_YOU'
	};
	
	var JoinStepsDirections = exports.JoinStepsDirections = {
	    'NEXT': 'NEXT',
	    "BACK": 'BACK'
	};
	
	var JoinCreateAccountConstants = exports.JoinCreateAccountConstants = {
	    'CREATE_CONTACT': "createContact",
	    'LOGIN': "login",
	    'CONTACT_DETAILS': "contactDetails"
	};
	
	var PickupSiteSelectionTypes = exports.PickupSiteSelectionTypes = {
	    'LIST': 'List',
	    'MAP': 'Map'
	};
	
	var MemberActions = exports.MemberActions = {
	    "NO_ACTION": "noAction",
	    "VALIDATE_MEMBER_DETAILS": "validateMemberDetails"
	};
	
	var PickupSiteTypes = exports.PickupSiteTypes = {
	    "HOME": "Home",
	    "REGULAR": "Regular",
	    "ZONE": "Zone"
	};
	
	var AccountModes = exports.AccountModes = {
	    "VIEW": "VIEW",
	    "CHANGE_PICKUP_SITE": "CHANGE_PICKUP_SITE",
	    "CHANGE_SUBSCRIPTION": "CHANGE_SUBSCRIPTION",
	    "CHANGE_SUBSCRIPTION_THANKYOU": "CHANGE_SUBSCRIPTION_THANKYOU"
	};
	
	var FarmBalanceTypes = exports.FarmBalanceTypes = {
	    "BALANCE_ON_ACCOUNT": "BalanceOnAccount",
	    "BALANCE_DUE": "BalanceDue"
	};
	
	var OverviewHistoryTypes = exports.OverviewHistoryTypes = {
	    "HOLD": "Hold",
	    "NEW": "New",
	    "VACATION": "Vacation",
	    "ORDER": "Order",
	    "SUBSCRIPTION": "Subscription",
	    "PAYMENT": "Payment",
	    "REJECTED_PAYMENT": "RejectedPayment",
	    "PENDING_PAYMENT": "PendingPayment",
	    "FEE": "Fee",
	    "REFUND": "Refund",
	    "FARMIGO_CREDITS": "FarmigoCredits"
	};
	
	var JoinModes = exports.JoinModes = {
	    "NEW": "New",
	    "CHANGE": "Change",
	    "ADD": "Add"
	};
	
	var SubscriptionStatuses = exports.SubscriptionStatuses = {
	    WAITLIST_SUBSCRIPTION: "WaitListSubscription",
	    SUBSCRIPTION_EXISTS: "SubscriptionExists",
	    NO_SUBSCRIPTION: "NoSubscription",
	    HOLD_SUBSCRIPTION: "HoldSubscription",
	    SUBSCRIPTION_CANCELED: "SubscriptionCanceled",
	    NO_FUTURE_DELIVERIES: "NoFutureDeliveries",
	    STORE_WAITLIST_SUBSCRIPTION: "StoreWaitListSubscription",
	    PROCESSING_ORDER: "ProcessingOrder",
	    PROCESSING_SUBSCRIPTION: "ProcessingSubscription",
	    STORE_CLOSED: "StoreClosed",
	    ROLLOVER_ENABLED: "RolloverEnabled"
	};
	var SubscriptionHoldReason = exports.SubscriptionHoldReason = {
	    ADMIN: "ADMIN",
	    NEW: "NEW",
	    VACATION: "VACATION"
	};
	var Messages = exports.Messages = {
	    WAITLIST_SUBSCRIPTION: { title: (0, _translate.translate)("_waitListSubscriptionTitle"),
	        body: (0, _translate.translate)("_waitListSubscriptionBody") },
	    SUBSCRIPTION_EXISTS: { title: (0, _translate.translate)("_subscriptionExistsTitle"),
	        body: (0, _translate.translate)("_subscriptionExistsBody") },
	    NO_SUBSCRIPTION: { title: (0, _translate.translate)("_noSubscriptionTitle"),
	        // body:"In order to process your order, you must have an active subscription with the producer.</br>Please contact the producer or visit our web site to sign-up.",
	        body: (0, _translate.translate)("_noSubscriptionBody"),
	        linkText: (0, _translate.translate)("Create Account") },
	    HOLD_SUBSCRIPTION: {
	        ADMIN: { title: (0, _translate.translate)("_holdSubscription_ADMIN_title"),
	            body: (0, _translate.translate)("_holdSubscription_ADMIN_body") },
	        NEW: { title: (0, _translate.translate)("_holdSubscription_NEW_title"),
	            body: (0, _translate.translate)("_holdSubscription_NEW_body") },
	        VACATION: { title: (0, _translate.translate)("_holdSubscription_VACATION_title"),
	            body: (0, _translate.translate)("_holdSubscription_VACATION_body"),
	            linkText: (0, _translate.translate)('My Account') },
	        VACATION_ALLOW_CHANGE: { title: (0, _translate.translate)("_holdSubscription_VACATION_AllowChangeTitle"),
	            body: (0, _translate.translate)("_holdSubscription_VACATION_AllowChangeBody"),
	            linkText: (0, _translate.translate)('My Account') }
	    },
	    SUBSCRIPTION_CANCELED: { title: (0, _translate.translate)("_subscriptionCanceledTitle"),
	        body: (0, _translate.translate)("_subscriptionCanceledBody") },
	    NO_FUTURE_DELIVERIES: { title: (0, _translate.translate)("_noFutureDeliveriesTitle"),
	        body: (0, _translate.translate)("_noFutureDeliveriesBody") },
	    STORE_WAITLIST_SUBSCRIPTION: { title: (0, _translate.translate)("_storeWaitListSubscriptionTitle"),
	        body: (0, _translate.translate)("_storeWaitListSubscriptionBody") },
	    PROCESSING_ORDER: { title: (0, _translate.translate)("_processingOrderTitle"),
	        body: (0, _translate.translate)("_processingOrderBody") },
	    STORE_CLOSED: { title: (0, _translate.translate)("Store Closed") }
	};
	var PaymentTypes = exports.PaymentTypes = {
	    SINGLE_PAYMENT: { type: "single", label: (0, _translate.translate)("Make Single Payment"), shortLabel: (0, _translate.translate)("Make Payment") },
	    AUTO_PAYMENT: { type: "auto", label: (0, _translate.translate)("Automatic Renewal Charges"), shortLabel: (0, _translate.translate)("Auto Charges") },
	    UPDATE_PAYMENT: { type: "update", label: (0, _translate.translate)("Update Details"), shortLabel: (0, _translate.translate)("Update") },
	    CHARGE: { type: "charge", label: (0, _translate.translate)("Charge"), shortLabel: (0, _translate.translate)("Charge") },
	    PAYMENT_PLAN: { type: "plan", label: (0, _translate.translate)("Payment Plan"), shortLabel: "Payment Plan" },
	    PAYMENT_TOKEN: { type: "token", label: (0, _translate.translate)("Payment Token"), shortLabel: (0, _translate.translate)("Payment Token") }
	};
	var CouponStatus = exports.CouponStatus = {
	    NONE: 'NONE',
	    VALID: 'VALID',
	    INVALID: 'INVALID',
	    VALIDATING: 'VALIDATING',
	    INVALID_COUPON: "invalidCoupon",
	    INVALID_COUPON_FIRST_USE: "NotFirstOrderOfSubscription",
	    INVALID_COUPON_ALREADY_USE: "AlreadyUsedBySubscription",
	    INVALID_COUPON_MINIMUM: "invalidSubscriptionMinCoupon",
	    INVALID_COUPON_MINIMUM_WITH_OPTIONS: "invalidSubscriptionMinCouponWithOptions"
	};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translate = translate;
	
	var _dictionary_en = __webpack_require__(465);
	
	var _dictionary_fr = __webpack_require__(466);
	
	var dictionary = void 0;
	try {
	    dictionary = (window.navigator.languages && window.navigator.languages[0] || window.navigator.language || window.navigator.userLanguage).includes('fr') ? _dictionary_fr.dictionary_fr : _dictionary_en.dictionary_en;
	} catch (err) {
	    dictionary = _dictionary_en.dictionary_en;
	}
	
	function translate(text) {
	
	    var translation = dictionary[text];
	    if (translation) return translation;
	    // Use in order to check if text exists in dictionary
	    //return "*".repeat(text.length);
	    return text;
	}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var dictionary_en = exports.dictionary_en = {
	    "_minimumPerOrder": "In order to checkout, your order needs to exceed ",
	    "_StartAddingItems": "Your cart is currently empty",
	    "_SelectVariationForItem": "Please select a variation for this item",
	    "_SelectScheduleForShare": "Please select a schedule for this share",
	    "_LoseYourChanges": "By leaving you will lose your changes",
	    "Summary_Account.join": "click to join",
	    "_LoginToStart": "Please log in to start selecting items",
	    "pickupSiteNotAvailableForSubscription": "This location is not available since there are no deliveries for your subscription shares to this location.",
	    "pickupSiteNotChangeDistributionDay": "At the moment you cannot change your distribution day to DELIVERY_DAY. Please contact us in order to change your distribution day.",
	    "guestStoreClosedSeasonEnd": "This location is not available now since we have already begun to prepare deliveries for it.",
	    "cantAcceptChangesActiveOrder": "Your request can not be completed because you currently have a scheduled distribution in process. ",
	    "pickupSiteNotAvailablePrepareDeliveries": "You may place your order for this location between ",
	    "pickupDayStepHeader": "Select an available PICKUP_SITE_LABEL from the list or map.",
	    "pickupSiteMapDetails": "Click a location on the map to view the pick-up site details",
	    "_WaitListLabel": 'Our CSA is currently full. Please add yourself to the waitlist by selecting a share.',
	    "_NoShares": "No shares are available for the selected pick up site. Please email FARM_EMAIL for more information.",
	    "_ContinueNextToCompleteSignupProcess": "Please continue to the next step in order to complete the signup process.",
	    "_AgreeToTerms": "By clicking <b>on Checkout</b> you agree to the terms of ",
	    "_ZipCodeError": "Please enter a valid zip code",
	    "_AddressError": "Please enter a valid address",
	    "_DeliveryHoldInstruction": "Please click on the 'From' and 'To' boxes to set the dates you do ",
	    "_SelectAvailableDelivery": "Select an available Delivery Option from the list or map.",
	    "_StoreOrderDistribution": "Store Order Distribution (csv)",
	    "_ScheduledDistributionInProcess": "Your request can not be completed because you currently have a scheduled distribution in process.",
	    "FatalError.text": "Sorry, but something has gone wrong.",
	    "creditNotUsed": "You have not used all your",
	    "enterValidVacationRangeNotOverlap": "Please set your delivery hold periods so that they don't overlap.",
	    "enterFutureVacationPeriod": "Please set your delivery hold period so that the dates are not in the past.",
	    "enterValidVacationRange": "Please set your delivery hold period so that the start date is before the end date.",
	    "noChangeAllowedVacation": "Vacation changes that affect upcoming delivery cannot be applied.<br />Please try again after ",
	    "storeClosedChangeVacation": "Delivery hold for the next delivery day until after ",
	    "_OrderScheduledDuringTheseDates": "You have an order scheduled during these dates. Click 'Save' to set the delivery hold dates and cancel the order or click 'Cancel' to ignore the delivery hold dates.",
	    "deliveryHoldResetRecurringOrders": "<br/>Note that any recurring orders must be reset when the delivery hold is complete.",
	    "cantAcceptVacationChangeActiveOrder": "You currently have an order scheduled during these dates. Please contact the producer to make this change.",
	    "cantUpdatePermanentHold": "You currently cannot put your subscription on hold.<br />Please try again after {0}",
	    "sendEmailsRequiresFields": "To send email to spouse/partner please enter First Name, Last Name & EMail Address fields ",
	    "INVALID_PHONE_NUMBER": "Please enter a 10 digits number",
	    "INVALID_ADDRESS_HOME_DELIVERY": "Your home address can't be verified. Please click 'Cancel' to return to your account and update your address in the Contact Info tab.",
	    "AUTHORIZE_DOT_NET": "Debit/Credit Card",
	    "CHECK": "Check",
	    "BALANCE": "Balance",
	    "EBT_ONLINE": "EBT Online",
	    "_thankYouSignUpWaitlistTitle": "Thank you for signing up for the waitlist!",
	    "_thankYouSignUpWaitlistBody": "We will be in touch with you if space becomes available.",
	    "_thankYouTitle": "Thank You!<br/>Your order is complete",
	    "_thankYouBody": "We sent you an email with a summary and confirmation of your order.",
	    "_thankYouDeclinedTitle": "This transaction has been declined",
	    "_thankYouDeclinedBody": "Please return and try again.",
	    "_thankYouUpdatePaymentDetailsTitle": "Update Payment Details",
	    "_thankYouUpdatePaymentDetailsBody": "Your payment details has been successfully updated.",
	    "_thankYouPaymentTitle": "Thank you for your payment!",
	    "_thankYouPaymentBody": "We sent you an email with a confirmation of your payment.",
	    "_thankYouChangeSubscriptionTitle": "Thank you!<br/>Your subscription was updated",
	    "_thankYouChangeSubscriptionBody": "We sent you an email with a summary and confirmation of your subscription change.",
	    "_thankYouSignUpTitle": "Thank you for becoming a member!",
	    "_thankYouSignUpBody": "We sent you an email with a summary and confirmation of your subscription.<br/>If you didn't get it please check your spam folder or promotions folder, or contact us.",
	    "_waitListSubscriptionTitle": "Already Waitlisted",
	    "_waitListSubscriptionBody": "It seems you already have a waitlist request in the system. Please log into your account to see the details of your waitlist request.",
	    "_subscriptionExistsTitle": "Already have a Subscription",
	    "_subscriptionExistsBody": "It seems you already have a subscription in the system. Please log into your account to see the details of your subscription.",
	    "_noSubscriptionTitle": "No Subscription",
	    "_noSubscriptionBody": "In order to process your order, you must have an active subscription with the producer.<br/>Please contact the producer or visit our web site to sign-up.",
	    "_holdSubscription_ADMIN_title": "Subscription on Hold",
	    "_holdSubscription_ADMIN_body": "We are sorry but your subscription is currently on hold. Please contact the producer to reinstate your subscription so that we can process your order.",
	    "_subscriptionCanceledTitle": "Subscription Canceled",
	    "_subscriptionCanceledBody": "We are sorry but your subscription has been canceled. Please contact the producer to reinstate your subscription so that we can process your order.",
	    "_holdSubscription_NEW_title": "Setting up Your Account",
	    "_holdSubscription_NEW_body": "Thanks for subscribing! We are setting up your account. Please revisit our web store in a few days. ",
	    "_holdSubscription_VACATION_AllowChangeTitle": "Scheduled for Vacation",
	    "_holdSubscription_VACATION_AllowChangeBody": "Our files indicate you are scheduled for vacation. To change your vacation settings please go to your account.",
	    "_noFutureDeliveriesTitle": "No Scheduled Distributions",
	    "_noFutureDeliveriesBody": "We are sorry but there are no scheduled distributions to your pickup site.",
	    "_holdSubscription_VACATION_title": "Scheduled for Vacation",
	    "_holdSubscription_VACATION_body": "Our files indicate that you are scheduled for vacation. Please contact the producer to change your vacation settings.",
	    "_storeWaitListSubscriptionTitle": "Waitlisted Subscription",
	    "_storeWaitListSubscriptionBody": "It seems your subscription is waitlisted.<br>In order to process your order, you must have an active subscription with the producer.",
	    "_processingOrderTitle": "Processing your Request",
	    "_processingOrderBody": "The system is currently attempting to process your request. If you do not receive an email confirmation, please try again in 15 minutes.",
	    "invalidCoupon": "The coupon you entered is invalid",
	    "invalidSubscriptionMinCoupon": "To redeem the coupon your shares value should exceed ${0}. Continue sign-up without the coupon or click back to choose another share.",
	    "invalidSubscriptionMinCouponWithOptions": "To redeem the coupon your shares and options value should exceed ${0}. Continue sign-up without the coupon or click back to choose another share or option.",
	    "NotFirstOrderOfSubscription": "Coupon is valid only for first order",
	    "AlreadyUsedBySubscription": "Coupon code was already used",
	    "PaymentPlanStep.heading": "Choose your payment plan",
	    "promotionalCode": "Optional - promotion code",
	    "PHONE": "Other",
	    "PAYPAL_STANDARD": "PayPal",
	    "PAYPAL_PREAPPROVE": "Automatically Recurring Payments - PayPal",
	    "ELECTRONIC_CHECK": "Electronic Check",
	    "ELECTRONIC_CHECK_PREAPPROVE": "Automatically Recurring Payments - Electronic Check",
	    "AUTHORIZE_DOT_NET_PREAPPROVE": "Automatically Recurring Payments - Debit/Credit Card",
	    "CASH": "Cash",
	    "NONE": "none",
	    "_paymentSuccessfullyUpdated": "Member payment details have been successfully updated.",
	    "_planSuccessfullyUpdated": "Member payment plan has been successfully updated.",
	    "_successfullyCharged": "Member was successfully charged.",
	    "_refreshTheDashboard": "Please refresh the dashboard to see the changes.",
	    "_CheckOutMessageBalance": "The amount of your order will be applied to your account. Please look for an email which will confirm your order and may include additional instructions.",
	    //"_CheckOutMessageCheck": "Click the \"\u003cb\u003ePlace Order\u003c/b\u003e\" button to place your order. Then please send a check for your order total to _FARM_NAME_.\u003c/p\u003e ",
	    "_CheckOutMessageNone": "Once you click on the \"<b>Place Order</b>\" button, _FARM_NAME_ will begin processing your selection.",
	    "ON_DELIVERY_CHARGE_hasToken": "Once you click on the \"<b>Place Order</b>\" button, we will start processing your order. You will be charged after the delivery of your order takes place using the method of payment we have on file for you.",
	    "_chargeHasTokenZeroAmount": "Once you click on the \"<b>Place Order</b>\" button, we will begin processing your order.",
	    "_ItemShort": "Due to inventory changes we could not fulfill your order for ",
	    "_returnToStoreToUpdateYourOrder": " Please return to store to update your order.",
	    "_checkoutWithTheAvailableItems": " You can checkout with the available items or return to store to update your order.",
	    "_OrderWasntCreated": "Order wasn't created",
	    "returnToStore": "Return to Store",
	    "_agreeToTerms": "you agree to the terms of ",
	    "_usingPaymentDetailsOnFile": "Charge using payment details on file",
	    "_AutomaticallyRecurringPayments": "Automatically Recurring Payments",
	    "_optionRemove": "Remove payment details",
	    "_optionRemoveAutomatic": "Remove automatic payment details",
	    "paymentMethodReuse": "We use your selection from your sign up",
	    "paymentMethodMessage": "How would you like to pay?",
	    "ON_DELIVERY_CHARGE_noToken": "You will be charged for your order after the delivery takes place. Once you click the \"<b>_BUTTON_TITLE_</b>\" button, you will be directed to a secure site to enter your payment information.",
	    "AUTHORIZE_DOT_NET_MESSAGE": "Once you click the \"<b>_BUTTON_TITLE_</b>\" button, we will direct you to a secure site to enter your payment information.",
	    "AUTHORIZE_DOT_NET_store": "Once you click the \"<b>_BUTTON_TITLE_</b>\" button, we will direct you to a secure site to enter your credit or debit card information. Your card will be charged at checkout.",
	    "AUTHORIZE_DOT_NET_PREAPPROVE_reuse": "We offer automatic payment for your convenience. Once you click on the \"<b>_BUTTON_TITLE_</b>\" button, we will debit your credit card automatically based on your selected payment plan.",
	    "MASSAGE.AUTHORIZE_DOT_NET_PREAPPROVE": "Your credit/debit card will be charged automatically, whenever your balance drops below {2}, according to the payment plan that you have selected with {1}, unless you cancel your membership.<br/>Once you click the \"<b>{0}</b>\" button, we will direct you to a secure site to enter your payment information.",
	    "AUTHORIZE_DOT_NET_PREAPPROVE_seasonal": "Based on your selected payment plan, your credit/debit card will be scheduled for automatic charges.<br/>Once you click the \"<b>{0}</b>\" button, we will direct you to a secure site to enter your payment information.",
	    "MASSAGE.CASH": "Click the \"<b>{0}</b>\" button to complete sign-up. Please prepare payment by the date of delivery. Please check your email for further instructions.",
	    "alsoSendComEmail": "Also send email communication to this contact",
	    "MASSAGE.CHECKS": "Click the \"<b>{0}</b>\" button to complete sign-up. Instructions for submitting payment will be emailed to you separately.",
	    "MASSAGE.CHECK": "Click the \"<b>{0}</b>\" button to place your order. Then please send a check for your order total to {1}.",
	    "MASSAGE.ELECTRONIC_CHECK": "Select this payment method to make a one-time payment. If you have a bank account, please support us by selecting this form of payment. The transaction fee is lower as compared to other electronic payment methods.<br/>Once you click the \"<b>{0}</b>\" button, we will direct you to a secure site to enter your payment information.",
	    "MASSAGE.ELECTRONIC_CHECK_store": "Select this payment method to make a one-time payment. Once you click the \"<b>{0}</b>\" button, we will direct you to a secure site to enter your bank account information. Your account will be charged at checkout.",
	    "ELECTRONIC_CHECK_PREAPPROVE_reuse": "We offer automatic payment for your convenience. Once you click on the \"<b>{0}</b>\" button, we will debit your bank account automatically based on your selected payment plan.",
	    "MASSAGE.ELECTRONIC_CHECK_PREAPPROVE": "You will be charged automatically, whenever your balance drops below {2}, according to the payment plan that you have selected with {1}, unless you cancel your membership. This is a preferred payment due to a lower transaction fee in comparison to other electronic payment methods.",
	    "ELECTRONIC_CHECK_PREAPPROVE_seasonal": "Based on your selected payment plan, your bank account will be scheduled for automatic charges. This is a preferred payment due to a lower transaction fee in comparison to other electronic payment methods.<br/>Once you click the \"<b>{0}</b>\" button, we will direct you to a secure site to enter your payment information.",
	    "MASSAGE.PAYPAL_STANDARD": "Once you click the \"<b>{0}</b>\" button, we will direct you to PayPal where you may set up payment.<br/>You do not need to have a PayPal account in order to set up payment.",
	    "MASSAGE.PAYPAL_STANDARD_store": "Once you click the \"<b>{0}</b>\" button, we will direct you to PayPal where you may set up payment.<br/>You do not need to have a PayPal account in order to set up payment.<br/>You will be charged at checkout.",
	    "PAYPAL_PREAPPROVE_reuse": "We offer automatic payment for your convenience. Once you click on the \"<b>{0}</b>\" button, we will debit your PayPal account automatically based on your selected payment plan.",
	    "PAYPAL_PREAPPROVE_store": "Your PayPal account will be charged automatically, whenever your balance drops below {2}, according to the payment plan that you have selected with {1}, unless you cancel your membership.<br/>Once you click the \"<b>{0}</b>\" button, we will direct you to the PayPal site to set up your payment information. You will need to have a PayPal account to complete checkout. Please note you may create a PayPal account in the next step.",
	    "PAYPAL_PREAPPROVE_seasonal": "Based on your selected payment plan, you will be scheduled for automatic charges.<br/>Once you click the \"<b>{0}</b>\" button, we will direct you to PayPal where you may set up payment. You will need to have a PayPal account to complete checkout. Please note you may create a PayPal account in the next step.",
	    "MASSAGE.PHONE": "Once you click on the \"<b>{0}</b>\" button, {1} will begin processing your selection. Please contact the producer at {2} to provide your billing information.",
	    "MASSAGE.EBT_ONLINE": "Select this payment method to make a one-time payment using EBT.<br/>Once you click the \"<b>{0}</b>\" button, we will direct you to a secure site to enter your payment information.",
	    "_contactToFarm1": "In case you want to contact the producer please send an email to ",
	    "_contactToFarm2": "or visit the web site at ",
	    "_contactToFarm3": "for more information",
	    "_haveOrderThatIsBeingProcessed": "You already have an order that is being processed. Click on \"Add Items\" to add more items.",
	    "_multiOrderStoreClosed": "We are currently preparing orders for {0}, but the store is wide open for {1}. Please send an email to {2} if you're experiencing difficulty.",
	    "_contactTheFarm": "Please contact the producer for more information",
	    "_seasonEnded": "The season {0} has already ended. ",
	    "_noSubscription": "You don't have a subscription ",
	    "_setYourSubscription": "to signup and set your subscription.",
	    "subscriptionOnHold": "Your subscription is on permanent hold.",
	    "subscriptionCanceled": "Your subscription is canceled.",
	    "storeClosed": "Sorry, the web store is closed but will reopen for you to place your order from {0}.",
	    "storeClosedNoHours": "Sorry, the web store is closed.",
	    "selectPickupSiteSummary": "Please select {0}",
	    "selectShare": "Please select at least one share.",
	    "noChangeAllowed1": "We are currently preparing your order, so self-serve account changes will be available again after {0}. However we'd love to assist you, so please send an email to {1}, or call {2} during regular business hours and we will help you out!",
	    "_assignedAutomaticPayment": "currently assigned with an automatic payment of ",
	    "removeAutomaticPaymentConfirmation": "Are you sure you want to remove automatic payment for this member?",
	    "_NoShares1": "No shares are available for the selected pick up site. Please email ",
	    "_NoShares2": " for more information.",
	    "noAccount": "No account for this email",
	    "_receiveReminders": "I would like to receive email reminders",
	    "_enterContactInfo": "Please enter your contact information",
	    "_refreshOrderDeleted": "Order does not exist, need to refresh the page",
	    "_syncOptionSchedulesValidation": "Please update the schedule selected for {0} to correspond with the schedule/s assigned to your share/s.",
	    "_setSubscriptionOnPermanentHold": "Place my subscription on permanent hold",
	    "_createAccountBottomNote": "Click above to create an account with Facebook or Email. If you already have an account click the \"Login\" tab",
	    "VacationHoldTopLine": "Please enter the date periods you wish to skip deliveries.",
	    "VacationHold2ndLine": "Your next scheduled distribution is"
	};

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var dictionary_fr = exports.dictionary_fr = {
	    "Total Credits": "Crédits totaux",
	    "Remaining Credits": "Crédits restants",
	    "Extra Fuel Charge": "Frais de carburant supplémentaires",
	    "Next": "Suivant",
	    "_minimumPerOrder": "Pour continuer à la caisse, votre commande doit être supérieure à ",
	    "Log In": "Se connecter",
	    "Delivery": "Livraison",
	    "Subtotal": "Sous-total",
	    "Tax": "Taxe",
	    "Credits": "Crédits",
	    "Total": "Total",
	    "STORE": "BOUTIQUE",
	    "CART": "PANIER",
	    "Cart": "Panier",
	    "Item": "Article",
	    "Items": "Articles",
	    "Contact Us": "Nous contacter",
	    "Log Out": "Se déconnecter",
	    "My Account": "Mon compte",
	    "Store": "Boutique",
	    "Close": "Fermer",
	    "_StartAddingItems": "Commencer l'ajout d'items",
	    "Items for": "Articles pour",
	    "Items for Purchase": "Articles en vente",
	    "Existing Order": "Commande existante",
	    "Additional Order": "Commande supplémentaire",
	    "Continue Browsing": "Continuez à naviguer",
	    "_SelectVariationForItem": "SVP sélectionner une variation",
	    "_SelectScheduleForShare": "SVP sélectionner une fréquence de livraison",
	    "Add": "Ajoutez",
	    "Try Again": "Réessayez",
	    "Something went wrong": "Quelque chose n'a pas fonctionnée",
	    "_LoseYourChanges": "En quittant vous perdrez toutes vos modifications",
	    "Leave": "Quitter",
	    "Stay": "Rester",
	    "Login with Facebook": "Se connecter avec Facebook",
	    "or": "ou",
	    "Login with Email": "Connection avec un courriel",
	    "email": "courriel",
	    "Email": "Courriel",
	    "password": "mot de passe",
	    "Password": "Mot de passe",
	    "Forgot Password": "Mot de passe oublié",
	    "Not a member yet?": "Pas encore membre ?",
	    "New Member": "Nouveau membre ?",
	    "Summary_Account.join": "cliquez pour adhérer",
	    "Create an Account": "Créer un compte",
	    "_LoginToStart": "SVP vous connecter pour sélectionner des items",
	    "Login": "Se connecter",
	    "Loading": "Chargement en cours",
	    "Sign Up": "S'inscrire",
	    "pickupSiteNotAvailableForSubscription": "Ce lieu n'est pas disponible car il n'y a pas de livraison planifi\xE9 pour vos souscriptions concernant ce lieu.",
	    "pickupSiteNotChangeDistributionDay": "Pour le moment, vous ne pouvez modifier votre jour de livraison pour DELIVERY_DAY. SVP nous contacter pour effectuer ce changement.",
	    "guestStoreClosedSeasonEnd": "Ce lieu n'est pas disponible pour l'instant car nous avons d\xE9j\xE0 commenc\xE9 \xE0 pr\xE9parer des livraisons correspondantes.",
	    "cantAcceptChangesActiveOrder": "Votre requête ne peut pas aboutir car vous avez actuellement une distribution programmée en cours. ",
	    "cantUpdatePermanentHold": "You currently cannot put your subscription on hold.<br />Please try again after {0}",
	    "pickupSiteNotAvailablePrepareDeliveries": "Vous pouvez modifier votre commande pour ce point de chute entre ",
	    "pick-up site": "Point de chute",
	    "pickupDayStepHeader": "Choisissez un point de chute disponible dans la liste ou la carte.",
	    "waitlist only": "liste d'attente uniquement",
	    "More": "Plus",
	    "more": "plus",
	    "Waitlist Locations": "Lieux sur liste d'attente",
	    "Waitlist Location": "Lieu sur liste d'attente",
	    "comments": "Commentaires",
	    "Delivery Day": "Jour de livraison",
	    "Available Location": "Lieu disponible",
	    "Available Locations": "Lieux disponibles",
	    "pickupSiteMapDetails": "Sélectionnez un lieu de collecte disponible à partir de la liste ou de la carte",
	    "Select this location": "Sélectionner ce lieu",
	    "Back": "Retour",
	    "BACK": "RETOUR",
	    "Finish": "Terminer",
	    "checkout": "Passer à la caisse",
	    "Checkout": "Paiement",
	    "SHOP": "Magasinez",
	    "_WaitListLabel": "Notre ASC est compl\xE8te actuellement. Veuillez vous ajouter \xE0 la liste d'attente en s\xE9lectionnant une part.",
	    "_NoShares": "Aucune part n''est disponible pour le lieu de collecte s\xE9lectionn\xE9. Veuillez envoyer un courriel \xE0 FARM_EMAIL pour plus d''information.",
	    "_ContinueNextToCompleteSignupProcess": "SVP procéder à l'étape suivante pour compléter votre inscription.",
	    "Existing": "existante",
	    "Additional": "supplémentaire",
	    "Select schedule": "Choisissez une option",
	    "_AgreeToTerms": "Vous acceptez les termes et conditions ",
	    "Create Account": "Créer un compte",
	    "Create account with Facebook": "Créez compte avec Facebook",
	    "Create account with Email": "Créez compte avec courriel",
	    "All": "Tout",
	    "Filter by day": "Filtrer par journ\xE9e",
	    "Filter by zip code": "Filtrer par code postal valide",
	    "Search": "search",
	    "Search by zip code": "Search par code postal valide",
	    "State": "Pays",
	    "_ZipCodeError": "SVP entrer un code postal valide",
	    "_AddressError": "SVP entrer une addresse valide",
	    "LIST": "LISTE",
	    "MAP": "CARTE",
	    "Email Address": "Adresse courriel",
	    "Choose a Password": "Choisissez un mot de passe",
	    "Retype Password": "Confirmez le mot de passe",
	    "First Name": "Prénom",
	    "Last Name": "Nom",
	    "Primary Phone": "Téléphone principal",
	    "Secondary Phone": "Téléphone secondaire",
	    "Address Line 1": "Adresse ligne 1",
	    "Address Line 2": "Adresse ligne 2",
	    "City": "Ville",
	    "Zip/Postal Code": "Code postal",
	    "Additional Contact": "Contact supplémentaire",
	    "Phone": "Téléphone",
	    "alsoSendComEmail": "Envoyer les courriels à ce contact également",
	    "Summary": "Résumé",
	    "First Distribution": "Première distribution",
	    "Delivery Option": "Option de livraison",
	    "Totals": "Totaux",
	    "Secured Payment & Privacy Protection": "Paiements sécurisés et Protection de la vie privée",
	    "Qty": "Quantité",
	    "Shares": "Paniers",
	    "Options": "Options",
	    "Terms": "Termes",
	    "Contact Info": "Coordonnées",
	    "Pay": "Payer",
	    "Total due at checkout": "Montant total dû",
	    "Manage Payments": "Gérer les paiements",
	    "Balance": "Balance",
	    "Change": "Changer",
	    "Subscription": "Abonnement",
	    "Overview": "Vue d'ensemble",
	    "Pick-up direction": "Instructions pour la collecte",
	    "Delivery Hold": "Suspendre livraisons",
	    "From": "De",
	    "To": "à",
	    "Save": "Sauvegarder",
	    "Date": "Date",
	    "Description": "Description",
	    "Debit": "Débit",
	    "Credit": "crédit",
	    "Cancel": "Annuler",
	    "_DeliveryHoldInstruction": "SVP cliquer les cases 'De' et 'À' pour choisir les dates ",
	    "want a delivery": "vous voulez une livraison",
	    "Directions to Your Site": "Indication vers votre point de chute",
	    "Your contact information": "Vos informations de contact",
	    "_SelectAvailableDelivery": "Choisissez un point de chute pour la collecte",
	    "Change Delivery Option": "Changez vos options de livraison",
	    "Select Payment Amount": "Selectionnez le montant que vous voulez payer",
	    "Automatic renewal charges": "Frais de renouvellement automatique",
	    "Update details": "Valider les informations",
	    "Update payment details": "Valider les informations de paiement",
	    "Change Subscription": "Modifier la souscription",
	    "CANCEL": "ANNULER",
	    "SAVE": "SAUVEGARDER",
	    "NOT": "NON",
	    "Pick-up Directions": "Votre Point chute",
	    "Pickup Directions": "Indications pour collecte",
	    "Site Host Contact Information": "Informations de contact du représentant de la ferme",
	    "More Info": "En savoir plus",
	    "How to Find Your Box": "Comment choisir votre format de panier",
	    "_StoreOrderDistribution": "Répartition des commandes",
	    "Next Distribution": "Distribution suivante",
	    "_ScheduledDistributionInProcess": "Votre requête ne peut être complétée car vous avez une commande active.",
	    "per delivery": "par livraison",
	    "Additions": "Ajouts",
	    "Special Discount": "Rabais spécial",
	    "Web Order": "Commande en ligne",
	    "FatalError.text": "Désolé, mais un problème est survenu.",
	    "creditNotUsed": "Vous n'avez pas utilis\xE9 l'ensemble de votre",
	    "enterValidVacationRangeNotOverlap": "Veuillez d\xE9finir vos p\xE9riodes d'arr\xEAt de livraison de sorte qu'elles ne se chevauchent pas.",
	    "enterFutureVacationPeriod": "Veuillez d\xE9finir votre p\xE9riode d'arr\xEAt de livraison afin que les dates ne soient pas dans le pass\xE9.",
	    "enterValidVacationRange": "Veuillez d\xE9finir votre p\xE9riode d'arr\xEAt de livraison de telle sorte que la date de d\xE9but soit avant la date de fin.",
	    "noChangeAllowedVacation": "Les changements aux dates de vacances affectent des livraisons \xE0 venir et ne peuvent \xEAtre accept\xE9s.<br />SVP essayez de nouveau. ",
	    "storeClosedChangeVacation": "Delivery hold for the next delivery day until after ",
	    "_OrderScheduledDuringTheseDates": "Vous avez une livraison prévue à ces dates. Cliquez 'Sauver' pour sauvegarder les dates de suspension et annuler la commande ou cliquer 'Annuler' pour ignorer les dates de suspension.",
	    "cantAcceptVacationChangeActiveOrder": "Vous avez actuellement une commande programmée dans ces dates. Veuillez contacter le producteur pour la modification.",
	    "sendEmailsRequiresFields": "Pour envoyer un message au conjoint/partenaire, veuillez compléter les champs Prénom, Nom et Adresse courriel ",
	    "INVALID_PHONE_NUMBER": "Entrer un nombre à 10 chiffres",
	    "INVALID_ADDRESS_HOME_DELIVERY": "Your home address can't be verified. Please click 'Cancel' to return to your account and update your address in the Contact Info tab.",
	    "AUTHORIZE_DOT_NET": "Carte de débit ou de crédit",
	    "Learn More": "En savoir plus",
	    "credits": "Crédits",
	    "Select variation": "Sélectionner une variation",
	    "_thankYouSignUpWaitlistTitle": "Merci de vous \xEAtre inscrit \xE0 notre liste d'attente!",
	    "_thankYouSignUpWaitlistBody": "Nous communiquerons avec vous dès que des places se libéreront.",
	    "_thankYouTitle": "Merci!",
	    "_thankYouBody": "Merci. Votre commande a été enregistrée. Vous recevrez bientôt un courriel qui confirmera votre commande et résumera votre sélection.",
	    "_thankYouDeclinedTitle": "This transaction has been declined",
	    "_thankYouDeclinedBody": "Please return and try again.",
	    "_thankYouUpdatePaymentDetailsTitle": "Update Payment Details",
	    "_thankYouUpdatePaymentDetailsBody": "Vos modalités de paiements ont été mises à jour correctement.",
	    "_thankYouPaymentTitle": "Merci pour votre paiement !",
	    "_thankYouPaymentBody": "Nous vous avons envoyés un courriel avec une confirmation de votre paiement.",
	    "_thankYouChangeSubscriptionTitle": "Merci ! Votre abonnement a été mis à jour",
	    "_thankYouChangeSubscriptionBody": "Nous vous avons envoyés un courriel avec un résumé et une confirmation du changement de votre abonnement.",
	    "_thankYouSignUpTitle": "Merci!",
	    "_thankYouSignUpBody": "Votre inscription a été enregistrée. Vous recevrez bientôt un courriel de confirmation détaillé de votre inscription.",
	    "Back to Store": "Retour à la boutique",
	    "Back to store": "Retour à la boutique",
	    "Back to Account": "Retour à mon compte",
	    "_waitListSubscriptionTitle": "D\xE9j\xE0 sur la liste d'attente",
	    "_waitListSubscriptionBody": "Il semble que vous ayez d\xE9j\xE0 une demande de liste d'attente dans notre syst\xE8me. Veuillez vous connecter \xE0 votre compte pour voir les d\xE9tails de votre demande de liste d'attente.",
	    "_subscriptionExistsTitle": "Abonnement déjà existant",
	    "_subscriptionExistsBody": "Il semble que vous soyez déjà abonné dans notre système. Veuillez vous connecter à votre compte pour voir les détails de votre abonnement.",
	    "_noSubscriptionTitle": "Aucun abonnement",
	    "_noSubscriptionBody": "Pour que votre commande puisse \xEAtre trait\xE9e, vous devez \xEAtre abonn\xE9 aupr\xE8s du producteur.<br/>Veuillez communiquer avec le producteur ou visiter notre site Web pour vous inscrire.",
	    "_holdSubscription_ADMIN_title": "Abonnement suspendu",
	    "_holdSubscription_ADMIN_body": "Désolé, mais votre abonnement est actuellement suspendu. Veuillez communiquer avec le producteur pour rétablir votre abonnement afin que nous puissions traiter votre commande.",
	    "_subscriptionCanceledTitle": "Abonnement annulé",
	    "_subscriptionCanceledBody": "Désolé, mais votre abonnement a été annulé. Veuillez communiquer avec le producteur pour rétablir votre abonnement afin que nous puissions traiter votre commande.",
	    "_holdSubscription_NEW_title": "Ouverture de votre compte",
	    "_holdSubscription_NEW_body": "Merci de vous \xEAtre abonn\xE9! Nous sommes en train d'ouvrir votre compte. Veuillez visiter notre magasin en ligne de nouveau dans quelques jours. ",
	    "_holdSubscription_VACATION_AllowChangeTitle": "Vacances prévues",
	    "_holdSubscription_VACATION_AllowChangeBody": "Nos dossiers indiquent que vous avez des vacances prévues. Pour modifier vos paramètres de vacances, veuillez accéder à votre compte.",
	    "_noFutureDeliveriesTitle": "Aucune livraison prévue",
	    "_noFutureDeliveriesBody": "D\xE9sol\xE9, mais aucune livraison n'est pr\xE9vue \xE0 votre lieu de collecte.",
	    "_holdSubscription_VACATION_title": "Vacances prévues",
	    "_holdSubscription_VACATION_body": "Nos dossiers indiquent que vous avez des vacances prévues. Veuillez communiquer avec le producteur pour changer vos paramètres de vacances.",
	    "_storeWaitListSubscriptionTitle": "Abonnement en liste d'attente",
	    "_storeWaitListSubscriptionBody": "Il semble que votre abonnement soit en liste d'attente.<br>Pour que votre commande puisse \xEAtre trait\xE9e, vous devez \xEAtre abonn\xE9 aupr\xE8s du producteur.",
	    "_processingOrderTitle": "Votre demande est en cours de traitement",
	    "_processingOrderBody": "Le système essaie actuellement de traiter votre demande. Si vous ne recevez pas un courriel de confirmation, veuillez réessayer dans 15 minutes.",
	    "Store Closed": "Magasin fermé",
	    "Make Single Payment": "Effectuez un paiement unique",
	    "Make Payment": "Effectuez un paiement",
	    "Automatic Renewal Charges": "Frais de renouvellement automatique",
	    "Auto Charges": "Frais de renouvellement",
	    "Update Details": "Valider les informations",
	    "Update": "Mettre à  jour",
	    "CHECK": "Chèque",
	    "BALANCE": "Balance",
	    "Add Coupon": "Ajouter un coupon",
	    "invalidCoupon": "Le coupon inscrit n'est pas valide",
	    "invalidSubscriptionMinCoupon": "To redeem the coupon your shares value should exceed ${0}. Continue sign-up without the coupon or click back to choose another share.",
	    "invalidSubscriptionMinCouponWithOptions": "To redeem the coupon your shares and options value should exceed ${0}. Continue sign-up without the coupon or click back to choose another share or option.",
	    "NotFirstOrderOfSubscription": "Le coupon est valide uniquement pour la première commande",
	    "AlreadyUsedBySubscription": "Ce code de coupon a déjà été utilisé",
	    "Apply": "Appliquer",
	    "PaymentPlanStep.heading": "Choisissez votre plan de paiement",
	    "Payment Plan": "Plan de paiement",
	    "Price": "Prix",
	    "Notes": "Remarques",
	    "promotionalCode": "Option - code promotionnel",
	    "Coupon Code": "Code coupon",
	    "Remove": "Supprimer",
	    "PHONE": "Autre",
	    "PAYPAL_STANDARD": "PayPal",
	    "PAYPAL_PREAPPROVE": "Paiement automatique récurrent - PayPal",
	    "ELECTRONIC_CHECK": "Chèque électronique",
	    "ELECTRONIC_CHECK_PREAPPROVE": "Paiement automatique récurrent - Chèque électronique ",
	    "AUTHORIZE_DOT_NET_PREAPPROVE": "Paiement automatique récurrent - Carte de crédit or de débit",
	    "CASH": "Comptant à la livraison",
	    "_paymentSuccessfullyUpdated": "Vos informations de paiement ont été enregistées.",
	    "NONE": "Aucun",
	    "Update Payment Plan": "Mise à jour du mode de paiement",
	    "_planSuccessfullyUpdated": "Votre mode de paiement a été mis à jour.",
	    "Charge Member": "Frais chargé au membre",
	    "_successfullyCharged": "Les frais ont été chargés au membre.",
	    "_refreshTheDashboard": "SVP rafraîchir le tableau de bord pour visualiser les changements.",
	    "Product Details": "Détails du produit",
	    "About the producer": "Au sujet du producteur",
	    "_CheckOutMessageBalance": "Le montant de votre commande sera porté sur votre compte. Veuillez regarder votre boîte de courriel pour un message qui confirmera votre commande et contenirait des directives supplémentaires.",
	    "_CheckOutMessageNone": "Apr\xE8s avoir cliqu\xE9 sur le bouton \xAB <b>Place Order</b> \xBB, _FARM_NAME_ commencera le traitement de votre s\xE9lection.",
	    "ON_DELIVERY_CHARGE_hasToken": "Apr\xE8s avoir cliqu\xE9 sur le bouton \xAB <b>Place Order</b> \xBB, nous commencerons de traiter votre commande. Vous serez factur\xE9 apr\xE8s la livraison de votre commande selon l''information de paiement qui figure d\xE9j\xE0 dans votre fichier.",
	    "_chargeHasTokenZeroAmount": "En cliquant sur le bouton \"<b>Placer commande</b>\" nous traiterons votre commande.",
	    "_ItemShort": "En raison de bris d'inventaire nous ne pouvous compléter votre commande ",
	    "_checkoutWithTheAvailableItems": " Vous pouvez terminer votre commande avec les items de la liste ou retourner dans le magasin de la liste ou retourner dans le magasin pour compléte.",
	    "_OrderWasntCreated": "La commande n'a pas été créée",
	    "returnToStore": "Retour à la boutique",
	    "Place Order": "Placer commande",
	    "Finalize Your Order": "Complétez votre commande",
	    "By clicking": "En cliquant",
	    "_agreeToTerms": "Vous acceptez les termes et conditions ",
	    "_usingPaymentDetailsOnFile": "Payer en utilisant les informations de paiement au dossier",
	    "_AutomaticallyRecurringPayments": "Paiement automatique récurrent",
	    "_optionRemove": "Supprimer les détails de paiement",
	    "_optionRemoveAutomatic": "Supprimer les détails automatiques de paiement",
	    "Payment Method": "Mode de paiement",
	    "paymentMethodReuse": "Nous utilisons la sélection de votre inscription",
	    "paymentMethodMessage": "Comment souhaitez-vous régler ?",
	    //"_CheckOutMessageCheck": "Cliquer sur le bouton « \u003cb\u003e----\u003c/b\u003e » pour passer votre commande. Ensuite veuillez envoyer un chèque pour le montant de votre commande à _FARM_NAME_.",
	    "ON_DELIVERY_CHARGE_noToken": "Vous serez factur\xE9 apr\xE8s la livraison de votre commande.  Apr\xE8s avoir cliqu\xE9 sur le bouton \xAB <b>_BUTTON_TITLE_</b> \xBB, vous serez redirig\xE9 vers un site de paiement s\xE9curis\xE9 pour entrer vos informations de paiement.",
	    "AUTHORIZE_DOT_NET_MESSAGE": "Apr\xE8s avoir cliqu\xE9 sur le bouton \xAB <b>_BUTTON_TITLE_</b> \xBB, vous serez redirig\xE9 vers un site de paiement s\xE9curis\xE9 pour entrer vos informations de cr\xE9dit et votre autorisation.",
	    "AUTHORIZE_DOT_NET_store": "Apr\xE8s avoir cliqu\xE9 sur le bouton \xAB <b>_BUTTON_TITLE_</b> \xBB, vous serez redirig\xE9 vers un site de paiement s\xE9curis\xE9 pour entrer vos informations de cr\xE9dit. Un paiement sera port\xE9 sur votre carte de cr\xE9dit/d\xE9bit pour effectuer votre commande.",
	    "AUTHORIZE_DOT_NET_PREAPPROVE_reuse": "Nous acceptons le paiement automatique pour votre commodit\xE9. Apr\xE8s avoir cliqu\xE9 sur le bouton \xAB <b>_BUTTON_TITLE_</b> \xBB, nous d\xE9biterons votre carte de cr\xE9dit automatiquement selon le plan de paiement choisi.",
	    "MASSAGE.AUTHORIZE_DOT_NET_PREAPPROVE": "Selon votre plan de paiement sélectionné, un paiement sera porté automatiquement sur votre carte de crédit/débit pour remplir votre compte avec {1}.<br/>Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers un site de paiement sécurisé pour entrer vos informations de paiement.",
	    "AUTHORIZE_DOT_NET_PREAPPROVE_seasonal": "Selon votre plan de paiement sélectionné, un paiement sera porté sur votre carte de crédit/débit selon le programme de paiements automatiques.<br/>Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers un site de paiement sécurisé pour entrer vos informations de paiement.",
	    "MASSAGE.CASH": "Cliquer sur le bouton \xAB <b>{0}</b> \xBB pour finir votre inscription. Veuillez pr\xE9parer votre paiement avant le date de livraison. Regardez votre bo\xEEte de courriel pour plus de directives.",
	    "MASSAGE.CHECKS": "Cliquer sur le bouton \"<b>{0}</b>\" pour finir votre inscription. Les directives pour la préparation du chèque vous seront envoyées par courriel.",
	    "MASSAGE.CHECK": "Cliquer sur le bouton \"<b>{0}</b>\" pour passer votre commande. Ensuite veuillez envoyer un chèque pour le montant de votre commande à {1}.",
	    "MASSAGE.ELECTRONIC_CHECK": "Si vous avez un compte bancaire, veuillez soutenir-nous en sélectionnant ce mode de paiement. Le frais de transaction est moins des autres modes de paiement électronique.<br/>Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers un site sécurisé pour entrer vos informations de paiement.",
	    "MASSAGE.ELECTRONIC_CHECK_store": "Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers un site de paiement sécurisé pour entrer vos informations de compte bancaire. Un paiement sera porté sur votre compte pour effectuer votre commande.",
	    "ELECTRONIC_CHECK_PREAPPROVE_reuse": "Nous acceptons le paiement automatique pour votre commodité. Après avoir cliqué sur le bouton \"<b>{0}</b>\", nous débiterons votre compte bancaire automatiquement selon le plan de paiement choisi.",
	    "MASSAGE.ELECTRONIC_CHECK_PREAPPROVE": "You will be charged according to the payment plan that you have selected to refill your account balance with {1}. This is a preferred payment due to a lower transaction fee in comparison to other electronic payment methods.",
	    "ELECTRONIC_CHECK_PREAPPROVE_seasonal": "Selon votre plan de paiement sélectionné, un paiement sera porté sur votre compte bancaire selon le programme de paiements automatiques<br/>Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers un site de paiement sécurisé pour entrer vos informations de paiement.",
	    "MASSAGE.PAYPAL_STANDARD": "Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers au site de PayPal où vous pouvez payer en sécurité.",
	    "MASSAGE.PAYPAL_STANDARD_store": "Après avoir cliqué sur le bouton \"<b>{0}</b>\", vous serez redirigé vers au site de PayPal où vous pouvez payer en sécurité. Un paiement sera porté sur votre compte pour effectuer votre commande.",
	    "PAYPAL_PREAPPROVE_reuse": "Nous acceptons le paiement automatique pour votre commodité. Après avoir cliqué sur le bouton \"<b>{0}</b>\", nous débiterons votre compte PayPal automatiquement selon le plan de paiement choisi.",
	    "PAYPAL_PREAPPROVE_store": "Basé sur le mode de paiement que vous avez choisi, votre compte PayPal sera chargé automatiquement pour renflouer votre compte… En cliquant sur le  bouton {0}, vous serez redirigé vers PayPal pour définir vos options de paiement. Vous aurez besoin d'un compte PayPal pour compléter la transaction. Vous pourrez créer un compte PayPal lors de la prochaine étape.",
	    "PAYPAL_PREAPPROVE_seasonal": "Basé sur le mode de paiement que vous avez choisi, votre prochain paimement récurant de .<br/> En cliquant sur le bouton \"<b>{0}</b>\" ,vous serez redirigé vers PayPal où vous pourrez configurer votre paiement. Vous aurez besoin d'un compte PayPal pour compléter la transaction. Vous pourrez créer un compte PayPal lors de la prochaine étape.",
	    "MASSAGE.PHONE": "Après avoir cliqué sur le bouton \"<b>{0}</b>\", {1} commencera le traitement de votre sélection. Veuillez communiquer avec le producteur au {2} pour obtenir des renseignements sur la facturation.",
	    "_contactToFarm1": "Si vous devez contacter la ferme, SVP envoyez un courriel à ",
	    "_contactToFarm2": "Ou visitez le site web à ",
	    "_contactToFarm3": "pour plus d'informations.",
	    "Order Exists": "Commande existante",
	    "_haveOrderThatIsBeingProcessed": "Vous avez déjà une commande en traitement. Cliquez sur \"Ajouter items\" pour ajouter de nouveaux items.",
	    "_multiOrderStoreClosed": "We are currently preparing orders for {0}, but the store is wide open for {1}. Please send an email to {2} if you're experiencing difficulty.",
	    "Add Items": "ajouter des articles",
	    "_contactTheFarm": "Veuillez contacter le producteur pour de plus amples informations.",
	    "_seasonEnded": "La saison {0} est déjà terminée. ",
	    "_noSubscription": "Vous n'avez pas d'abonnement ",
	    "Please click": "SVP cliquer",
	    "here": "ici",
	    "_setYourSubscription": "pour vous inscrire et choisir votre abonnement.",
	    "subscriptionCanceled": "Votre souscription est annulée.",
	    "storeClosed": "Désolé, mais le magasin en ligne est fermé. Il rouvrira à partir de {0} pour que vous puissiez passer votre commande.",
	    "storeClosedNoHours": "Désolé, mais le magasin en ligne est fermé.",
	    "Start Shopping": "Commencer à magasiner",
	    "Waitlist": "liste d'attente",
	    "Pick-Up Site": "Point de chute",
	    "Distributions": "Distributions",
	    "selectPickupSiteSummary": "Veuillez sélectionner {0}",
	    "selectShare": "SVP sélectionner au moins un format de panier.",
	    "Continue": "Continuer",
	    "CONTINUE": "CONTINUER",
	    "noChangeAllowed1": "Le producteur prépare actuellement votre prochaine livraison. Veuillez revenir après {0} pour faire des changements.",
	    "_assignedAutomaticPayment": "Présentement configuré pour les paiements automatiques de ",
	    "removeAutomaticPaymentConfirmation": "Souhaitez-vous vraiment supprimer le paiement automatique pour ce membre ?",
	    "Member is": "Le membre est",
	    "Preview": "Aperçu",
	    "You are": "Vous êtes",
	    "_NoShares1": "Aucune part n''est disponible pour le lieu de collecte s\xE9lectionn\xE9. Veuillez envoyer un courriel \xE0 ",
	    "_NoShares2": " pour plus d''information.",
	    "Please enter email address": "Veuillez saisir adresse courriel",
	    "Please enter first name": "Veuillez saisir prénom",
	    "Please enter last name": "Veuillez saisir nom",
	    "Please enter primary phone": "Veuillez saisir téléphone principal",
	    "Please enter address line": "Veuillez saisir adresse ligne",
	    "Please enter zip/postal code": "Veuillez saisir code postal",
	    "Please enter city": "Veuillez saisir ville",
	    "Please enter at least 6 characters": "Veuillez saisir au moins 6 caractères",
	    "Please retype your password": "Confirmez le mot de passe",
	    "Invalid email": "Veuillez saisir un email valide",
	    "The password does not match": "La confirmation ne concorde pas",
	    "Invalid zip code": "Veuillez saisir un zip code valide",
	    "Submit": "Soumettre",
	    "Back to Login": "Retour à la Se connecter",
	    "noAccount": "Aucun compte ne correspond à cette adresse courriel",
	    "Please fill Email": "Veuillez saisir adresse courriel",
	    "Incorrect password": "Le mot de passe est incorrect",
	    "Password is required": "Mot de passe requis",
	    "Jan": "Janv",
	    "Feb": "Févr",
	    "Mar": "Mars",
	    "Apr": "Avril",
	    "May": "Mai",
	    "Jun": "Juin",
	    "Jul": "Juil",
	    "Aug": "Août",
	    "Sep": "Sept",
	    "Oct": "Oct",
	    "Nov": "Nov",
	    "Dec": "Déc",
	    "Sunday": "Dimanche",
	    "Monday": "Lundi",
	    "Tuesday": "Mardi",
	    "Wednesday": "Mercredi",
	    "Thursday": "Jeudi",
	    "Friday": "Vendredi",
	    "Saturday": "Samedi",
	    "_receiveReminders": "Je souhaite recevoir des rappels par courriel",
	    "Powered By": "Fourni Par",
	    "_enterContactInfo": "Veuillez saisir vos informations de contact",
	    "_refreshOrderDeleted": "Order does not exist, need to refresh the page",
	    "_syncOptionSchedulesValidation": "Please update the schedule selected for {0} to correspond with the schedule/s assigned to your share/s.",
	    "Back to Cart": "Back to Cart",
	    "_setSubscriptionOnPermanentHold": "Place my subscription on permanent hold",
	    "_createAccountBottomNote": "Cliquez sur les liens ci-dessus pour créer un compte avec Facebook ou avec une adresse courriel. Si vous avez déjà un compte, cliquez sur l'onglet \"Se connecter\".",
	    "starts on": "Débute",
	    "VacationHoldTopLine": "Entrez les plages de dates pour lesquelles vous désirez suspendre les livraisons.",
	    "VacationHold2ndLine": "Votre prochaine livraison est prévue le"
	};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loginReducer = loginReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function loginReducer(state, action) {
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.LOG_IN_STATUS:
	            {
	                var error = getLoginError(action.status.status);
	                return Object.assign({}, state, {
	                    status: error.errorMessage,
	                    component: error.errorComponent,
	                    showCreateFBAccount: error.errorMessage !== 'Ok' && action.status.facebookId !== undefined
	                });
	            }
	        case _actionTypes.FORGET_PASSWORD:
	            return Object.assign({}, state, { isForgetPassword: action.isForgetPassword });
	        case _actionTypes.SHOW_FACEBOOK_POPUP:
	            return Object.assign({}, state, {
	                showCreateFBAccount: action.showCreateFBAccount,
	                email: action.email
	            });
	        case _actionTypes.RESET_STATUS:
	            return Object.assign({}, state, {
	                showCreateFBAccount: action.showCreateFBAccount,
	                status: null,
	                component: null,
	                email: null
	            });
	        case _actionTypes.RESET_PASSWORD_EMAIL_SENT:
	            return Object.assign({}, state, {
	                isResetPasswordEmailSent: action.isResetPasswordEmailSent
	            });
	        case _actionTypes.CHANGE_PASSWORD:
	            return Object.assign({}, state, {
	                isNeedToChangePassword: action.isNeedToChangePassword
	            });
	        case _actionTypes.ENABLE_FB_BUTTON:
	            return Object.assign({}, state, {
	                enableFBButton: action.enableFBButton
	            });
	        default:
	            return state;
	    }
	}
	
	function getLoginError(status) {
	    switch (status) {
	        case 'WrongEmail':
	            {
	                return {
	                    errorMessage: 'noAccount',
	                    errorComponent: 'email'
	                };
	            }
	        case 'InvalidEmail':
	            {
	                return {
	                    errorMessage: 'Invalid email',
	                    errorComponent: 'email'
	                };
	            }
	        case 'MissingEmail':
	            {
	                return {
	                    errorMessage: 'Please fill Email',
	                    errorComponent: 'email'
	                };
	            }
	        case 'WrongPassword':
	            {
	                return {
	                    errorMessage: 'Incorrect password',
	                    errorComponent: 'password'
	                };
	            }
	        case 'MissingPassword':
	            {
	                return {
	                    errorMessage: 'Password is required',
	                    errorComponent: 'password'
	                };
	            }
	        case 'ChangePassword':
	            {
	                return {
	                    errorMessage: 'ChangePassword',
	                    errorComponent: 'password'
	                };
	            }
	        case 'OkExistingForFarm':
	        case 'Ok':
	            {
	                return {
	                    errorMessage: 'Ok'
	                };
	            }
	    }
	}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.storeCategoriesReducer = storeCategoriesReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function storeCategoriesReducer(state, action) {
	    //FIXME replace [] with {}
	    state = state || [];
	    switch (action.type) {
	        case _actionTypes.LOAD_CATEGORIES:
	            return Object.assign([], state, action.categories);
	        case _actionTypes.CHANGE_CATEGORY:
	            {
	                var newState = Object.assign([], state);
	                newState.forEach(function (c, idx, array) {
	                    var newC = void 0;
	                    if (c.key === action.key) {
	                        newC = Object.assign({}, c);
	                        newC.selected = true;
	                    } else {
	                        if (c.selected) {
	                            newC = Object.assign({}, c);
	                            newC.selected = false;
	                        }
	                    }
	                    if (newC) {
	                        array[idx] = newC;
	                    }
	                });
	                return newState;
	            }
	        default:
	            return state;
	    }
	}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.storeOrderStatusReducer = storeOrderStatusReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function storeOrderStatusReducer(state, action) {
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.SET_ACTIVE_ORDER:
	            var activeOrder = action.activeOrder || {};
	            return Object.assign({}, state, {
	                activeOrder: activeOrder.items,
	                isChanged: false,
	                currentOrder: activeOrder.items,
	                orderKey: activeOrder.orderKey,
	                message: activeOrder.message,
	                comments: activeOrder.comments,
	                coupon: activeOrder.coupon,
	                shouldReloadData: action.shouldReloadData,
	                usedFarmigoCredits: activeOrder.usedFarmigoCredits
	            });
	        case _actionTypes.CHANGE_ITEM_QUANTITY:
	            {
	                var current = Object.assign({}, state.currentOrder || {});
	                if (action.newQuantity <= 0) {
	                    delete current[action.key];
	                } else {
	                    current[action.key] = Object.assign({}, current[action.key] || { key: action.key }, { quantity: action.newQuantity });
	                }
	                var active = Object.assign({}, state.activeOrder || {});
	                var changed = false;
	                for (var p in current) {
	                    if (!current.hasOwnProperty(p)) {
	                        continue;
	                    }
	                    var aVal = active[p];
	                    if (!aVal) {
	                        // this is new item in current order
	                        changed = true;
	                        break;
	                    }
	                    var cVal = current[p];
	                    if (aVal.quantity !== cVal.quantity) {
	                        // item quantity was changed
	                        changed = true;
	                        break;
	                    }
	                    delete active[p];
	                }
	                changed = changed || Object.keys(active).length > 0;
	                return Object.assign({}, state, { isChanged: changed, currentOrder: current });
	            }
	        case _actionTypes.SET_SHOULD_RELOAD_DATA:
	            return Object.assign({}, state, {
	                shouldReloadData: action.shouldReloadData
	            });
	        case _actionTypes.SET_STORE_COMMENT:
	            return Object.assign({}, state, {
	                comments: action.comments
	            });
	        case _actionTypes.SET_DIRTY:
	            return Object.assign({}, state, { isChanged: action.dirty });
	        case _actionTypes.UPDATE_TOTALS:
	            return Object.assign({}, state, { totals: action.totals, orderedItems: action.orderedItems });
	        case _actionTypes.SHOW_DIRTY_MODAL:
	            var showModal = action.show ? { onLeaveCallBack: action.onLeaveCallBack } : undefined;
	            return Object.assign({}, state, { showModal: showModal });
	        case _actionTypes.SET_STORE_HAS_COUPONS:
	            {
	                return Object.assign({}, state, {
	                    hasCoupons: action.hasCoupons
	                });
	            }
	        case _actionTypes.SET_WEB_ORDER_COUPON:
	            return Object.assign({}, state, { coupon: action.coupon });
	        case _actionTypes.SET_HAS_ALREADY_COUPON:
	            return Object.assign({}, state, { hasAlreadyCoupon: action.hasAlreadyCoupon });
	        case _actionTypes.SHOW_LOGIN_SIGNUP_MODAL:
	            return Object.assign({}, state, { showLoginSignupModal: action.show });
	        default:
	            return state;
	    }
	}

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.summaryReducer = summaryReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function summaryReducer(state, action) {
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.SET_SUMMARY:
	            return Object.assign({}, state, action.summary);
	        case _actionTypes.SET_ALLOW_ORDER_EDIT:
	            return Object.assign({}, state, { allowOrderEdit: action.allowOrderEdit });
	        case _actionTypes.SET_MULTI_ORDER_EDIT:
	            return Object.assign({}, state, { editMultiOrder: action.editMultiOrder });
	        case _actionTypes.SET_SUBSCRIPTION_NEXT_DELIVERY_DATE:
	            return Object.assign({}, state, { nextDeliveryDate: action.nextDeliveryDate });
	        case _actionTypes.SET_PICKUP_SITES_DELIVERY_DATE:
	            return Object.assign({}, state, {
	                pickupSite: action.pickupSite,
	                waitListSite: action.waitListSite,
	                nextDeliveryDate: action.nextDeliveryDate
	            });
	        case _actionTypes.SET_PICKUP_SITES_DELIVERY_DATE_ACTUAL:
	            return Object.assign({}, state, {
	                pickupSite: action.pickupSite,
	                nextDeliveryDate: action.nextDeliveryDate
	            });
	        case _actionTypes.SET_PICKUP_SITE:
	            return Object.assign({}, state, {
	                pickupSite: action.pickupSite
	            });
	        case _actionTypes.SET_WAIT_LIST_PICKUP_SITE:
	            return Object.assign({}, state, {
	                waitListSite: action.waitListSite
	            });
	        case _actionTypes.SET_CAN_SAVE_DELIVERY_HOLD:
	            return Object.assign({}, state, {
	                canSaveDeliveryHold: action.canSaveDeliveryHold
	            });
	        case _actionTypes.SET_PAYMENT_PLAN:
	            {
	                var obj = {};
	                obj[action.paymentType + "PaymentPlan"] = action.paymentPlan;
	                return Object.assign({}, state, obj);
	            }
	        case _actionTypes.SET_PAYMENT_METHOD:
	            {
	                var _obj = {};
	                _obj[action.paymentType + "PaymentMethod"] = action.paymentMethod;
	                return Object.assign({}, state, _obj);
	            }
	        case _actionTypes.SET_PAYMENT_TYPE:
	            return Object.assign({}, state, { paymentType: action.paymentType });
	        case _actionTypes.SET_CUSTOM_AMOUNT:
	            return Object.assign({}, state, { customAmount: action.customAmount });
	        case _actionTypes.SET_ALLOW_CONTINUE_PAYMENT:
	            return Object.assign({}, state, { allowContinuePayment: action.allowContinuePayment });
	        case _actionTypes.SET_VACATIONS:
	            return Object.assign({}, state, {
	                vacationEnd: action.vacationEnd,
	                vacationStart: action.vacationStart
	            });
	        case _actionTypes.SET_REQUIRED_MAKE_UP_DATA:
	            return Object.assign({}, state, {
	                requiredMakeUpData: action.requiredMakeUpData
	            });
	        case _actionTypes.SET_WEB_ORDER:
	            return Object.assign({}, state, {
	                activeWebOrderKey: action.webOrderKey
	            });
	        case _actionTypes.SET_CREATEING_SUBSCRIPTION:
	            return Object.assign({}, state, {
	                isCreatingSubscription: action.isCreatingSubscription
	            });
	        case _actionTypes.SET_ON_PERMANENT_HOLD:
	            return Object.assign({}, state, {
	                isSetOnPermanentHold: action.isSetOnPermanentHold
	            });
	        default:
	            return state;
	    }
	}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.messageReducer = messageReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function messageReducer(state, action) {
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.MESSAGE_DATA:
	            return action.messageData;
	        default:
	            return state;
	    }
	}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.gaReducer = gaReducer;
	
	var _analytics = __webpack_require__(473);
	
	var _actionTypes = __webpack_require__(459);
	
	var _constants = __webpack_require__(463);
	
	var _gaActions = __webpack_require__(474);
	
	var GA = _interopRequireWildcard(_gaActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function gaReducer(state, action) {
	    state = state || {};
	
	    switch (action.type) {
	        case _actionTypes.TRACK_GA_EVENT:
	            (0, _analytics.sendGAEvent)(action.category, action.action, action.label, action.value);
	            break;
	        case _actionTypes.TRACK_GA_PAGEVIEW:
	            (0, _analytics.sendGAPageView)(action.pageUrl);
	            break;
	        case _actionTypes.GOTO_STEP:
	            var step = action.step === _constants.JoinSteps.THANK_YOU ? "thankyou" : action.step;
	            (0, _analytics.sendGAPageView)(window.location.pathname + "/" + step);
	            break;
	        case _actionTypes.INIT_MEMBER_DETAILS:
	        case _actionTypes.SET_MEMBER_DATA:
	            var memberDetails = action.type === _actionTypes.INIT_MEMBER_DETAILS && window.Farmigo ? window.Farmigo.memberDetails : action.memberDetails;
	            if (memberDetails && memberDetails.key) (0, _analytics.setGAUserId)(memberDetails.key);
	            break;
	        case _actionTypes.ERROR_FETCHING:
	            (0, _analytics.sendGAEvent)(GA.GA_CATEGORIES.MESSAGES, GA.GA_ACTIONS.ERROR_FETCHING, action.error.message);
	            break;
	        case _actionTypes.MESSAGE_DATA:
	            if (action.messageData.messageTitle) (0, _analytics.sendGAEvent)(GA.GA_CATEGORIES.MESSAGES, GA.GA_ACTIONS.MESSAGE, action.messageData.messageTitle);
	            break;
	        case _actionTypes.SET_ADDRESS_VALIDATION_ERROR:
	            (0, _analytics.sendGAEvent)(GA.GA_CATEGORIES.MESSAGES, GA.GA_ACTIONS.ADDRESS_VALIDATION_ERROR, action.error);
	            break;
	    }
	    return state;
	}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// const FARMIGO_PROPERTY_ID = 'UA-8893503-13';
	var FARMIGO_GA4_ID = 'G-GRN3EZMZNW';
	
	var Dimensions = {
	    FARM_NAME: "dimension1",
	    SEASON_NAME: "dimension2",
	    USER_KEY: "dimension3",
	    MODULE: "dimension4"
	};
	
	var sendToFarm = false;
	
	var initializeGoogleAnalytics = exports.initializeGoogleAnalytics = function initializeGoogleAnalytics(farmTrackingId, farmName, seasonName, webSiteUrl) {
	    // ga('create', FARMIGO_PROPERTY_ID, 'auto');
	    gtag('config', FARMIGO_GA4_ID);
	    if (farmTrackingId && farmTrackingId !== '' && farmTrackingId.startsWith('G')) {
	        var domain = webSiteUrl.split('/')[2].split('.');
	        // ga('create', farmTrackingId, 'auto', 'farmTracker', {allowLinker: true});
	        // ga('farmTracker.require', 'linker');
	        // ga('farmTracker.linker:autoLink', [domain[domain.length - 2] + '.' + domain[domain.length - 1]]);
	        gtag('config', farmTrackingId, {
	            'linker': {
	                'domains': [[domain[domain.length - 2] + '.' + domain[domain.length - 1]]]
	            }
	        });
	        sendToFarm = true;
	    }
	    // ga('set', Dimensions.FARM_NAME, farmName);
	    // ga('set', Dimensions.SEASON_NAME, seasonName);
	    // let val1 = {};
	    // val1[Dimensions.FARM_NAME] = farmName;
	    // gtag('set', val1);
	    // let val2 = {};
	    // val2[Dimensions.SEASON_NAME] = seasonName;
	    // gtag('set', val2);
	};
	
	var sendGAEvent = exports.sendGAEvent = function sendGAEvent(category, action, label, value) {
	    // ga('send', 'event', category, action, label, value);
	    gtag('event', action, { 'event_category': category, 'event_label': label, 'value': value, 'send_to': FARMIGO_GA4_ID });
	    //For now do not send events to Farm
	    // if (sendToFarm)
	    //     ga('farmTracker.send', 'event', category, action, label, value);
	};
	
	var sendGAPageView = exports.sendGAPageView = function sendGAPageView(pageUrl) {
	    // setModule(pageUrl);
	    // ga('send', 'pageview', pageUrl);
	    gtag('event', 'page_view', { 'page_path': pageUrl });
	    // if (sendToFarm)
	    //     ga('farmTracker.send', 'pageview', pageUrl);
	};
	
	var setGAUserId = exports.setGAUserId = function setGAUserId(key) {
	    // ga('set', 'userId', key);
	    // ga('set', Dimensions.USER_KEY, key);
	    // gtag('set', {'user_id': key});
	    // let val = {};
	    // val[Dimensions.USER_KEY] = key;
	    // gtag('set', val);
	};
	
	function setModule(pageUrl) {
	    // let module = pageUrl.split('/')[1];
	    // ga('set', Dimensions.MODULE, module.charAt(0).toUpperCase() + module.slice(1));
	    // let val = {};
	    // val[Dimensions.MODULE] = module.charAt(0).toUpperCase() + module.slice(1);
	    // gtag('set', val);
	
	}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GA_ACTIONS = exports.GA_CATEGORIES = undefined;
	exports.trackCategoryChange = trackCategoryChange;
	exports.trackStoreCheckout = trackStoreCheckout;
	exports.trackGAEvent = trackGAEvent;
	exports.trackGAPageView = trackGAPageView;
	
	var _actionTypes = __webpack_require__(459);
	
	var GA_CATEGORIES = exports.GA_CATEGORIES = {
	    STORE: 'Store',
	    JOIN: 'Join',
	    MESSAGES: 'Messages'
	};
	
	var GA_ACTIONS = exports.GA_ACTIONS = {
	    CATEGORY_CLICKED: 'Category Clicked',
	    ORDER_SUBMITTED: 'Order Submitted',
	    ERROR_FETCHING: 'Error Fetching',
	    MESSAGE: 'Message Shown',
	    ADDRESS_VALIDATION_ERROR: 'Address Validation Error'
	    // ITEM_ADD_CLICKED: 'Item Add - Clicked',
	    // ITEM_QUANTITY_INCREASED: 'Item Quantity - Increased',
	    // ITEM_QUANTITY_DECREASED: 'Item Quantity - Decreased',
	    // ITEM_REMOVED: 'Item Removed',
	    // CHECKOUT_BUTTON_CLICKED: 'Checkout Button Clicked',
	};
	
	// const GA_LABELS = {
	//     ITEM: 'Item',
	//     CART: 'Cart',
	//     DETAILS: 'Details',
	//     NEW: 'New',
	//     UPDATE: 'Update',
	//     ADDITIONAL: 'Additional'
	// };
	
	function trackCategoryChange(name) {
	    return trackGAEvent(GA_CATEGORIES.STORE, GA_ACTIONS.CATEGORY_CLICKED, name);
	}
	
	function trackStoreCheckout(method) {
	    return function (dispatch) {
	        dispatch(trackGAEvent(GA_CATEGORIES.STORE, GA_ACTIONS.ORDER_SUBMITTED, method));
	        dispatch(trackGAPageView(window.location.pathname + "/submit"));
	    };
	}
	
	function trackGAEvent(category, action, label, value) {
	    return {
	        type: _actionTypes.TRACK_GA_EVENT,
	        category: category,
	        action: action,
	        label: label,
	        value: value
	    };
	}
	
	function trackGAPageView(pageUrl) {
	    return {
	        type: _actionTypes.TRACK_GA_PAGEVIEW,
	        pageUrl: pageUrl
	    };
	}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.joinReducer = joinReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function joinReducer(state, action) {
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.SET_SIGNUP_DATA:
	            return Object.assign({}, state, {
	                data: state.data ? state.data : action.signupData.data,
	                steps: state.steps ? state.steps : action.signupData.steps,
	                pickupSitesData: state.pickupSitesData ? state.pickupSitesData : action.signupData.pickupSitesData,
	                paymentMethods: state.paymentMethods ? state.paymentMethods : action.signupData.paymentMethods,
	                paymentPlans: state.paymentPlans ? state.paymentPlans : action.signupData.paymentPlans,
	                schedules: state.schedules ? state.schedules : action.signupData.schedules,
	                shareSchedules: state.shareSchedules ? state.shareSchedules : action.signupData.shareSchedules,
	                isGuestUser: state.isGuestUser ? state.isGuestUser : action.signupData.isGuestUser,
	                isAddSubscription: state.isAddSubscription ? state.isAddSubscription : action.signupData.isAddSubscription,
	                sharesData: state.sharesData ? state.data : {}
	            });
	        case _actionTypes.CLEAR_SIGNUP_DATA:
	            return {};
	        case _actionTypes.SET_SHARES_DATA:
	            var sharesData = {
	                shares: action.sharesData.shares,
	                options: action.sharesData.options,
	                items: action.sharesData.items,
	                remainingScheduleDates: action.sharesData.remainingScheduleDates,
	                pickupSiteKey: action.key
	            };
	            return Object.assign({}, state, {
	                sharesData: sharesData
	            });
	        case _actionTypes.SET_DELIVERY_DAY_FILTER:
	            var pickupSiteData = Object.assign({}, state.pickupSitesData, {});
	            pickupSiteData["deliveryDayFilter"] = action.deliveryDay;
	            return Object.assign({}, state, {
	                pickupSitesData: pickupSiteData
	            });
	        case _actionTypes.SELECT_PAYMENT_PLAN:
	            {
	                var selectedData = state.selectedData || {};
	                var selectedPaymentPlan = state.paymentPlans.find(function (plan) {
	                    return plan.key === action.key;
	                });
	                return Object.assign({}, state, {
	                    selectedData: Object.assign({}, selectedData, { selectedPaymentPlan: selectedPaymentPlan })
	                });
	            }
	        case _actionTypes.SET_COUPON:
	            {
	                var _selectedData = state.selectedData || {};
	                return Object.assign({}, state, {
	                    selectedData: Object.assign({}, _selectedData, { coupon: action.coupon })
	                });
	            }
	        case _actionTypes.SET_COUPON_STATUS:
	            {
	                var _selectedData2 = state.selectedData || {};
	                var coupon = _selectedData2.coupon;
	                if (coupon) {
	                    coupon.status = action.status;
	                    return Object.assign({}, state, {
	                        selectedData: Object.assign({}, _selectedData2, { coupon: coupon })
	                    });
	                }
	                return;
	            }
	        case _actionTypes.REMOVE_COUPON:
	            {
	                var _selectedData3 = state.selectedData || {};
	                return Object.assign({}, state, {
	                    selectedData: Object.assign({}, _selectedData3, { coupon: undefined })
	                });
	            }
	        case _actionTypes.GOTO_STEP:
	            return Object.assign({}, state, {
	                step: action.step
	            });
	        case _actionTypes.CONTACT_INFO_STEP:
	            return Object.assign({}, state, {
	                contactInfoPage: action.contactInfoPage
	            });
	        case _actionTypes.SET_CONTACT_DETAILS:
	            return Object.assign({}, state, {
	                contactDetails: action.contactDetails
	            });
	        case _actionTypes.JOIN_CHANGE_ITEM_QUANTITY:
	            {
	                var _newState = Object.assign({}, state, { sharesData: Object.assign({}, state.sharesData) });
	                var item = _newState.sharesData.shares[action.key] || _newState.sharesData.options[action.key];
	                var schedule = item.selectedSchedule ? item.selectedSchedule : item.schedules && item.schedules.length > 0 ? item.schedules[0] : undefined;
	                var newItemProps = {
	                    quantity: action.newQuantity,
	                    selectedSchedule: action.newQuantity > 0 ? schedule : undefined
	                };
	                var newItem = Object.assign({}, item, newItemProps);
	                if (!item.isAdditional) {
	                    var _newShares = Object.assign({}, _newState.sharesData.shares);
	                    _newShares[action.key] = newItem;
	                    _newState.sharesData.shares = _newShares;
	                } else {
	                    var _newOptions = Object.assign({}, _newState.sharesData.options);
	                    _newOptions[action.key] = newItem;
	                    _newState.sharesData.options = _newOptions;
	                }
	                return _newState;
	            }
	        case _actionTypes.JOIN_SET_ITEM_SCHEDULE:
	            {
	                var _newState2 = Object.assign({}, state, { sharesData: Object.assign({}, state.sharesData) });
	                var _newItemProps = { selectedSchedule: action.selectedSchedule };
	                var _item = _newState2.sharesData.shares[action.key];
	                var _newItem = void 0;
	                if (_item) {
	                    var _newShares2 = Object.assign({}, _newState2.sharesData.shares);
	                    _newItem = Object.assign({}, _item, _newItemProps);
	                    _newShares2[action.key] = _newItem;
	                    _newState2.sharesData.shares = _newShares2;
	                } else {
	                    _item = _newState2.sharesData.options[action.key];
	                    _newItem = Object.assign({}, _item, _newItemProps);
	                    var _newOptions2 = Object.assign({}, _newState2.sharesData.options);
	                    _newOptions2[action.key] = _newItem;
	                    _newState2.sharesData.options = _newOptions2;
	                }
	                return _newState2;
	            }
	        case _actionTypes.CLEAR_SHARES_SELECTION:
	            if (!state.sharesData || !state.sharesData.shares) return state;
	            var newState = Object.assign({}, state);
	            if (state.selectedData) {
	                newState.selectedData = {};
	            }
	            var newShares = {};
	            Object.keys(state.sharesData.shares).map(function (key) {
	                var newShare = Object.assign({}, state.sharesData.shares[key]);
	                newShare.quantity = 0;
	                newShare.selectedSchedule = undefined;
	                newShares[key] = newShare;
	            });
	            var newOptions = {};
	            Object.keys(newOptions).map(function (key) {
	                var newOption = Object.assign({}, state.sharesData.options[key]);
	                newOption.quantity = 0;
	                newOption.selectedSchedule = undefined;
	                newOptions[key] = newOption;
	            });
	            newState.sharesData = Object.assign({}, state.sharesData, { shares: newShares, options: newOptions });
	            return newState;
	        case _actionTypes.SET_SELECTED_METHOD:
	            {
	                var _selectedData4 = state.selectedData || {};
	                return Object.assign({}, state, {
	                    selectedData: Object.assign({}, _selectedData4, { selectedMethod: action.key })
	                });
	            }
	        case _actionTypes.SET_SIGNUP_COMMENTS:
	            {
	                var _selectedData5 = state.selectedData || {};
	                return Object.assign({}, state, {
	                    selectedData: Object.assign({}, _selectedData5, { signupComments: action.comments })
	                });
	            }
	        case _actionTypes.SET_TERMS_SELECTED:
	            {
	                var _selectedData6 = state.selectedData || {};
	                return Object.assign({}, state, {
	                    selectedData: Object.assign({}, _selectedData6, { termsSelected: action.isSelected })
	                });
	            }
	        case _actionTypes.SET_HOME_DELIVERY_INSTRUCTIONS:
	            {
	                var _selectedData7 = state.selectedData || {};
	                return Object.assign({}, state, {
	                    selectedData: Object.assign({}, _selectedData7, { homeDeliveryInstructions: action.instructions })
	                });
	            }
	        case _actionTypes.SET_MAP_PROPS:
	            var obj = Object.assign({}, state, {});
	            if (action.centerLocation) {
	                obj['centerLocation'] = action.centerLocation;
	            }
	            if (action.zoomLevel) {
	                obj['zoomLevel'] = action.zoomLevel;
	            }
	            return obj;
	        case _actionTypes.INIT_MAP_PROPS:
	            return Object.assign({}, state, {
	                zoomLevel: undefined,
	                centerLocation: undefined
	            });
	        case _actionTypes.SET_INVALID_OPTION_SCHEDULE_MESSAGE:
	            return Object.assign({}, state, {
	                invalidOptionScheduleMessage: action.invalidOptionScheduleMessage
	            });
	        default:
	            return state;
	    }
	}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.staticDataReducer = staticDataReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function staticDataReducer(state, action) {
	    state = state || {};
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.INITIAL_SERVER_DATA:
	            if (window.Farmigo) {
	                return Object.assign({}, state, window.Farmigo.serverData);
	            } else {
	                return Object.assign({}, state, {
	                    logoUrl: "",
	                    customBackgroundColor: "",
	                    webSiteUrl: "",
	                    farmUrl: "",
	                    farmKey: "",
	                    termsUrl: "",
	                    farmName: "",
	                    facebookAppId: "",
	                    isSupportGuestMembers: false,
	                    isSupportSalesTax: true,
	                    allowUpdateVacation: false,
	                    allowWebOrdersForFutureDate: false,
	                    pickupSiteLabel: 'pick-up site',
	                    country: 'US'
	                });
	            }
	        case _actionTypes.SET_URL_PARAMS:
	            return Object.assign({}, state, { params: action.params });
	        default:
	            return state;
	    }
	}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.storeCheckoutReducer = storeCheckoutReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function storeCheckoutReducer(state, action) {
		state = state || {};
		switch (action.type) {
			case _actionTypes.SET_POST_ACTION_KEY:
				return Object.assign({}, state, { postActionKey: action.postActionKey });
			case _actionTypes.SET_UNAVAILABLE_ITEMS:
				return Object.assign({}, state, { unAvailableItems: action.items });
			case _actionTypes.SET_DROPDOWN_CLOSED:
				return Object.assign({}, state, { isDropDownClosed: action.isDropDownClosed });
			default:
				return state;
		}
	}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.storeCreditsReducer = storeCreditsReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function storeCreditsReducer(state, action) {
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.STORE_CREDITS_DATA:
	            return Object.assign({}, state, {
	                creditType: action.storeCreditsData.creditType,
	                credits: action.storeCreditsData.credits,
	                deliveryDate: action.storeCreditsData.deliveryDate,
	                extraCreditItem: action.storeCreditsData.extraCreditItem,
	                remainingCredits: action.storeCreditsData.remainingCredits,
	                usedFarmigoCredits: action.storeCreditsData.usedFarmigoCredits,
	                balanceAsCredits: action.storeCreditsData.balanceAsCredits
	            });
	        case _actionTypes.SET_REMAINING_CREDITS:
	            return Object.assign({}, state, {
	                remainingCredits: action.remainingCredits
	            });
	        case _actionTypes.CHANGE_EXTRA_ITEM_QUANTITY:
	            if (state.extraCreditItem.key === action.key) {
	                return Object.assign({}, state, {
	                    extraCreditItem: Object.assign({}, state.extraCreditItem, { quantity: action.newQuantity })
	                });
	            }
	            return state;
	        default:
	            return state;
	    }
	}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.accountReducer = accountReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function accountReducer(state, action) {
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.SET_ACCOUNT_DATA:
	            return Object.assign({}, state, {
	                history: action.accountData.history
	            });
	        case _actionTypes.SET_ACCOUNT_MODE:
	            return Object.assign({}, state, {
	                mode: action.mode,
	                params: action.params
	            });
	        case _actionTypes.SET_SHOW_ADDRESS_VALIDATION_MESSAGE:
	            return Object.assign({}, state, {
	                showAddressValidationMessage: action.showAddressValidationMessage
	            });
	        default:
	            return state;
	    }
	}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.storageReducer = storageReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function storageReducer(state, action) {
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.SET_STORAGE_TIMESTAMP:
	            return Object.assign({}, state, { timestamp: action.timestamp });
	        case _actionTypes.REMOVE_STORAGE:
	            return Object.assign({}, state, { timestamp: undefined });
	        default:
	            return state;
	    }
	}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.memberReducer = memberReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function memberReducer(state, action) {
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.INIT_MEMBER_DETAILS:
	            if (window.Farmigo) {
	                return Object.assign({}, state, window.Farmigo.memberDetails);
	            }
	            return state;
	        case _actionTypes.SET_MEMBER_DATA:
	            return Object.assign({}, state, action.memberDetails);
	        case _actionTypes.SET_MEMBER_KEY:
	            return Object.assign({}, state, {
	                key: action.memberKey
	            });
	        case _actionTypes.SET_MEMBER_ACTION:
	            return Object.assign({}, state, {
	                memberAction: action.memberAction
	            });
	        case _actionTypes.SET_SHOW_PASSWORD:
	            return Object.assign({}, state, { showPassword: action.showPassword });
	        case _actionTypes.SET_UPDATE_MEMBER_ERROR:
	            return Object.assign({}, state, {
	                updateMemberError: action.error
	            });
	        case _actionTypes.SET_LAT_LNG:
	            return Object.assign({}, state, {
	                lat: action.lat,
	                lng: action.lng
	            });
	        case _actionTypes.SET_ADDRESS_VALIDATION_ERROR_NO_ACTION:
	        default:
	            return state;
	    }
	}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchingReducer = fetchingReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function fetchingReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actionTypes.FETCHING_DATA:
	            return { isFetching: true, fetchingType: action.fetchingType };
	        case _actionTypes.DATA_FETCHED:
	            //if fetchingType is not the current fetchingType on state then don't reset it
	            if (action.fetchingType) if (action.fetchingType !== state.fetchingType) return state;
	            return { isFetching: false };
	        case _actionTypes.ERROR_FETCHING:
	            return { isFetching: false,
	                error: { error: action.error, message: action.error.message, retryAction: action.retryAction } };
	        case _actionTypes.CLEAR_ERROR:
	            return {};
	        default:
	            return state;
	    }
	}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.clientViewPortReducer = clientViewPortReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function clientViewPortReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    state.lastChange = new Date().getTime(); //update state without cloing it
	    switch (action.type) {
	        case _actionTypes.UPDATE_CLIENT_VIEW_PORT:
	            return Object.assign({}, action.visible);
	
	        default:
	            return state;
	    }
	}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.logRocketReducer = logRocketReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	var _logrocket = __webpack_require__(457);
	
	var _logrocket2 = _interopRequireDefault(_logrocket);
	
	var _utils = __webpack_require__(485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function logRocketReducer(state, action) {
	    state = state || {};
	    if (!Farmigo.serverData.isProduction || Farmigo.serverData.customerTier !== 'A') return state;
	
	    if (action.type === _actionTypes.INIT_MEMBER_DETAILS || action.type === _actionTypes.SET_MEMBER_DATA) {
	        var memberDetails = action.type === _actionTypes.INIT_MEMBER_DETAILS && window.Farmigo ? window.Farmigo.memberDetails : action.memberDetails;
	        if (memberDetails && memberDetails.key) {
	            traceLogRocketSession({ memberKey: memberDetails.key });
	            _logrocket2.default.identify(memberDetails.key, { email: memberDetails.email });
	        }
	    } else if (action.type === _actionTypes.INITIAL_SERVER_DATA) {
	        if (window.Farmigo) {
	            traceLogRocketSession({ farmKey: window.Farmigo.serverData.farmKey });
	        }
	    }
	    return state;
	}
	
	function traceLogRocketSession(data) {
	    _logrocket2.default.getSessionURL(function (sessionURL) {
	        var fetchUrl = '/dispatcher/WebStoreService.traceLogRocketSession';
	        data.recordingURL = sessionURL;
	        return (0, _utils.ajax)(fetchUrl, data).then().catch();
	    });
	}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.objectUtils = exports.MAX_DATE_IN_SERVER_FORMAT = exports.PATH_IMAGES = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.ajax = ajax;
	exports.parametrize = parametrize;
	exports.checkResponseOKStatus = checkResponseOKStatus;
	exports.getPageContext = getPageContext;
	exports.getUrlParams = getUrlParams;
	exports.addPath = addPath;
	exports.removePath = removePath;
	exports.replacePath = replacePath;
	exports.redirectPage = redirectPage;
	exports.validateEmail = validateEmail;
	exports.validateZipCode = validateZipCode;
	exports.signOutPath = signOutPath;
	exports.getUsefulDate = getUsefulDate;
	exports.getUsefulDateWithYear = getUsefulDateWithYear;
	exports.formatToServerDate = formatToServerDate;
	exports.getDiffFromNow = getDiffFromNow;
	exports.addCookie = addCookie;
	exports.getCookie = getCookie;
	exports.deleteCookie = deleteCookie;
	exports.initFacebook = initFacebook;
	exports.isEmptyObj = isEmptyObj;
	exports.isEmptyString = isEmptyString;
	exports.geocodeAddress = geocodeAddress;
	exports.isValidPhoneNumber = isValidPhoneNumber;
	exports.compareArrays = compareArrays;
	exports.compareZipCodes = compareZipCodes;
	exports.setNoItemImage = setNoItemImage;
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(486);
	
	var _constants = __webpack_require__(463);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PATH_IMAGES = exports.PATH_IMAGES = "/site/store/images/";
	var MAX_DATE_IN_SERVER_FORMAT = exports.MAX_DATE_IN_SERVER_FORMAT = "3000-01-01";
	
	function ajax(fetchUrl, data) {
	    return fetch(fetchUrl, {
	        credentials: 'same-origin',
	        method: 'POST',
	        body: parametrize(data),
	        headers: {
	            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
	        }
	    }).then(checkResponseStatus).then(function (response) {
	        return new Promise(function (resolve, reject) {
	            response.json().then(function (json) {
	                if (json.error) reject(json.error);
	                resolve(json);
	            });
	        });
	    });
	}
	
	function parametrize(a) {
	    var s = [],
	        rbracket = /\[\]$/,
	        isArray = function isArray(obj) {
	        return Object.prototype.toString.call(obj) === '[object Array]';
	    },
	        add = function add(k, v) {
	        v = typeof v === 'function' ? v() : v === null ? '' : v === undefined ? '' : v;
	        s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
	    },
	        buildParams = function buildParams(prefix, obj) {
	        var i = void 0,
	            len = void 0,
	            key = void 0;
	
	        if (prefix) {
	            if (isArray(obj)) {
	                for (i = 0, len = obj.length; i < len; i++) {
	                    if (rbracket.test(prefix)) {
	                        add(prefix, obj[i]);
	                    } else {
	                        buildParams(prefix + '[' + (_typeof(obj[i]) === 'object' ? i : '') + ']', obj[i]);
	                    }
	                }
	            } else if (obj && String(obj) === '[object Object]') {
	                for (key in obj) {
	                    if (obj.hasOwnProperty(key)) {
	                        buildParams(prefix + '[' + key + ']', obj[key]);
	                    }
	                }
	            } else {
	                add(prefix, obj);
	            }
	        } else if (isArray(obj)) {
	            for (i = 0, len = obj.length; i < len; i++) {
	                add(obj[i].name, obj[i].value);
	            }
	        } else {
	            for (key in obj) {
	                if (obj.hasOwnProperty(key)) {
	                    buildParams(key, obj[key]);
	                }
	            }
	        }
	        return s;
	    };
	
	    return buildParams('', a).join('&').replace(/%20/g, '+');
	}
	
	function checkResponseStatus(response) {
	    if (response.status >= 200 && response.status < 300) {
	        return response;
	    } else {
	        var error = new Error(response.statusText);
	        error.response = response;
	        error.suppress = response.status >= 500 || response.status === 0;
	        throw error;
	    }
	}
	
	function checkResponseOKStatus(response) {
	    if (response.statusCode === "OK") return true;
	    var message = response.message ? response.message : _constants.GENERIC_ERROR_MESSAGE;
	    throw new Error(message);
	}
	
	function getPageContext() {
	    var page = location.pathname.split('/')[1];
	    for (var url in _constants.URLs) {
	        if (_constants.URLs.hasOwnProperty(url) && _constants.URLs[url] === page) return _constants.URLs[url];
	    }return undefined;
	}
	
	function getUrlParams() {
	    var searchParams = location.search.substr(1);
	    if (searchParams.length === 0) return {};
	    var params = {};
	    var paramsArr = searchParams.split("&");
	    paramsArr.map(function (p) {
	        var param = p.split("=");
	        params[param[0]] = decodeURIComponent(param[1]);
	    });
	    return params;
	}
	
	function addPath(path) {
	    if (location.pathname.endsWith(path)) return location.pathname;
	    return location.pathname + (location.pathname.endsWith('/') ? '' : '/') + path + location.hash;
	}
	
	function removePath(path, fullPath) {
	    var locationPath = fullPath ? fullPath : location.pathname;
	    return locationPath.endsWith(path) ? locationPath.replace(path, '') + location.search : locationPath + location.search;
	}
	
	function replacePath(path) {
	    var pathname = location.pathname;
	    if (pathname.endsWith('/')) {
	        pathname = pathname.slice(0, pathname.length - 1);
	    }
	    return pathname.slice(0, pathname.lastIndexOf('/') + 1) + path + location.hash;
	}
	
	function redirectPage(to, staticData, suffix) {
	    return window.location.origin + "/" + to + "/" + staticData.farmUrl + "/" + staticData.seasonUrl + (suffix ? suffix : '');
	}
	
	var objectUtils = exports.objectUtils = {
	    isNumber: function isNumber(obj) {
	        return typeof obj === 'number';
	    },
	    isString: function isString(obj) {
	        return typeof obj === 'string';
	    },
	    isArray: function isArray(obj) {
	        return Array.isArray(obj);
	    },
	    isFunction: function isFunction(obj) {
	        return typeof obj === 'function';
	    }
	};
	
	function validateEmail(email) {
	    var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return regex.test(email);
	}
	
	function validateZipCode(zipCode, country) {
	    var regex = country === 'CA' ? /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i : /^\d{5}(-\d{4})?$/;
	    return regex.test(zipCode);
	}
	
	function signOutPath() {
	    var location = window.location.pathname;
	    if (location.endsWith('/thankyou')) {
	        location = removePath('/thankyou');
	    }
	    return location;
	}
	
	var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	function getUsefulDate(usefulDate) {
	    if (usefulDate) {
	        var date = _parseFromServerDate(usefulDate);
	        var day = date.getDay();
	        var month = date.getMonth();
	
	        return (0, _translate.translate)(days[day]) + ', ' + (0, _translate.translate)(months[month]) + ' ' + date.getDate();
	    }
	}
	
	function getUsefulDateWithYear(usefulDate, isMobile) {
	    if (usefulDate) {
	        var date = _parseFromServerDate(usefulDate);
	        var fullYear = date.getFullYear();
	        if (isMobile) {
	            fullYear = fullYear - 2000;
	        }
	        return (0, _translate.translate)(months[date.getMonth()]) + ' ' + date.getDate() + ', ' + fullYear;
	    }
	}
	
	function _parseFromServerDate(serverDate) {
	    if (serverDate) {
	        var elements = serverDate.split(/-/g);
	        return new Date(elements[0], elements[1] - 1, elements[2]);
	    } else {
	        return null;
	    }
	}
	
	function formatToServerDate(date) {
	    if (!(date instanceof Date)) return '';
	
	    return date ? date.getFullYear() + '-' + _pad(date.getMonth() + 1, 2) + '-' + _pad(date.getDate(), 2) : '';
	}
	
	function getDiffFromNow(serverDate) {
	    var date = _parseFromServerDate(serverDate);
	    if (date) {
	        return date.getTime() - new Date().getTime();
	    }
	    return 0;
	}
	
	function _pad(number, length) {
	    return ('0000000000' + number).slice(-length);
	}
	
	function addCookie(name, value, expirationDate) {
	    document.cookie = name + "=" + value + "; expires=" + expirationDate + "; path=/";
	}
	
	function getCookie(cname) {
	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}
	
	function deleteCookie(cname) {
	    document.cookie = cname + "=false; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
	}
	
	function initFacebook(facebookAppId, forceReload, callback) {
	    window.fbAsyncInit = function () {
	        FB.init({
	            appId: facebookAppId,
	            cookie: true, // enable cookies to allow the server to access
	            xfbml: false, // don't parse social plugins on this page
	            version: 'v11.0' // use version 11.0
	        });
	        if (typeof callback == 'function') {
	            callback();
	        }
	        // }.bind(this);
	    };
	
	    (function (d, s, id) {
	        var js = void 0,
	            fjs = d.getElementsByTagName(s)[0];
	        if (d.getElementById(id) && !forceReload) return;
	        js = d.createElement(s);js.id = id;
	        js.src = "//connect.facebook.net/en_US/sdk.js";
	        fjs.parentNode.insertBefore(js, fjs);
	    })(document, 'script', 'facebook-jssdk');
	}
	
	function isEmptyObj(obj) {
	    if (obj) {
	        return Object.keys(obj).length === 0;
	    } else {
	        return true;
	    }
	}
	
	function isEmptyString(str) {
	    return !str || str === "";
	}
	
	function geocodeAddress(address, delay) {
	    var geoCoder = new google.maps.Geocoder();
	    var lat = void 0,
	        lng = void 0;
	    return new Promise(function (resolve) {
	        setTimeout(function () {
	            return geoCoder.geocode({ 'address': address }, function (results, status) {
	                if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
	                    lat = results[0].geometry.location.lat();
	                    lng = results[0].geometry.location.lng();
	                    resolve({
	                        lat: lat,
	                        lng: lng,
	                        status: status
	                    });
	                } else {
	                    resolve({
	                        address: address,
	                        results: results,
	                        status: status
	                    });
	                }
	            });
	        }, delay ? delay : 0);
	    });
	}
	
	function isValidPhoneNumber(phone) {
	    return (/^\s*\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})\s*$/.test(phone)
	    );
	}
	
	function compareArrays(array1, array2) {
	    if (array1.length !== array2.length) {
	        return false;
	    }
	    return array1.every(function (element, index) {
	        return element.key === array2[index].key;
	    });
	}
	
	function compareZipCodes(zipCode1, zipCode2) {
	    if (isEmptyObj(zipCode1) || isEmptyObj(zipCode2)) {
	        return zipCode1 === zipCode2;
	    } else {
	        return zipCode1.lat === zipCode2.lat && zipCode1.lng === zipCode2.lng;
	    }
	}
	
	function setNoItemImage(event) {
	    event.target.src = "/site/store/react/src/images/item-no-image.jpg";
	}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (typeof input === 'string') {
	      this.url = input
	    } else {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split('\r\n').forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.storeRecurringOrderReducer = storeRecurringOrderReducer;
	
	var _actionTypes = __webpack_require__(459);
	
	function storeRecurringOrderReducer(state, action) {
	    state = state || {};
	    switch (action.type) {
	        case _actionTypes.SET_RECURRING_ORDER_DATA:
	            return Object.assign({}, action.data);
	        case _actionTypes.SHOW_UPDATE_RECURRING_MODAL:
	            return Object.assign({}, state, { showUpdateRecurringModal: action.showUpdateRecurringModal });
	        case _actionTypes.SET_RECURRING_ITEM:
	            {
	                var items = Object.assign([], state.items, []);
	                var itemIndex = -1;
	                (items || []).find(function (item, index) {
	                    if (item && item.key === action.item.key) {
	                        itemIndex = index;
	                    }
	                });
	                var newItem = action.item;
	                if (itemIndex === -1 && newItem.quantity > 0) {
	                    items.push(action.item);
	                } else {
	                    if (newItem.quantity === 0) {
	                        items.splice(itemIndex, 1);
	                    } else {
	                        if (!action.updateSchedule) {
	                            newItem.schedule = items[itemIndex].schedule;
	                        }
	                        items[itemIndex] = newItem;
	                    }
	                }
	                return Object.assign({}, state, { items: items });
	            }
	        default:
	            return state;
	    }
	}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _Header = __webpack_require__(489);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(770);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _DirtyModal = __webpack_require__(772);
	
	var _DirtyModal2 = _interopRequireDefault(_DirtyModal);
	
	var _ErrorModal = __webpack_require__(773);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _LoginSignupModal = __webpack_require__(774);
	
	var _LoginSignupModal2 = _interopRequireDefault(_LoginSignupModal);
	
	var _ClientViewPort = __webpack_require__(775);
	
	var _ClientViewPort2 = _interopRequireDefault(_ClientViewPort);
	
	var _StoreHomeScreen = __webpack_require__(776);
	
	var _StoreHomeScreen2 = _interopRequireDefault(_StoreHomeScreen);
	
	var _JoinHomeScreen = __webpack_require__(837);
	
	var _JoinHomeScreen2 = _interopRequireDefault(_JoinHomeScreen);
	
	var _AccountHomeScreen = __webpack_require__(1103);
	
	var _AccountHomeScreen2 = _interopRequireDefault(_AccountHomeScreen);
	
	var _PayHomeScreen = __webpack_require__(1123);
	
	var _PayHomeScreen2 = _interopRequireDefault(_PayHomeScreen);
	
	var _constants = __webpack_require__(463);
	
	var _commonActions = __webpack_require__(747);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeScreen = function (_React$Component) {
	    _inherits(HomeScreen, _React$Component);
	
	    function HomeScreen() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, HomeScreen);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HomeScreen.__proto__ || Object.getPrototypeOf(HomeScreen)).call.apply(_ref, [this].concat(args))), _this), _this.getScreen = function () {
	            switch (_this.props.screen) {
	                case _constants.URLs.STORE:
	                    return _react2.default.createElement(_StoreHomeScreen2.default, { location: _this.props.location });
	                case _constants.URLs.JOIN:
	                    return _react2.default.createElement(_JoinHomeScreen2.default, { location: _this.props.location });
	                case _constants.URLs.ACCOUNT:
	                    return _react2.default.createElement(_AccountHomeScreen2.default, { location: _this.props.location });
	                case _constants.URLs.PAY:
	                case _constants.URLs.CHARGE:
	                    return _react2.default.createElement(_PayHomeScreen2.default, { location: _this.props.location });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(HomeScreen, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            window.onbeforeunload = function () {
	                if (this.props.isChanged && !this.props.isPreview) return '';
	            }.bind(this);
	            this.props.checkVersion();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_Header2.default, { clientViewPort: this.props.clientViewPort, staticData: this.props.staticData }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-container" + (this.props.showCustomFooter ? " include-custom-footer" : "") },
	                    this.getScreen()
	                ),
	                _react2.default.createElement(_Footer2.default, { clientViewPort: this.props.clientViewPort, staticData: this.props.staticData }),
	                _react2.default.createElement(_LoginSignupModal2.default, null),
	                _react2.default.createElement(_DirtyModal2.default, null),
	                _react2.default.createElement(_ErrorModal2.default, null),
	                _react2.default.createElement(_ClientViewPort2.default, null)
	            );
	        }
	    }]);
	
	    return HomeScreen;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    var screen = ownProps.location.pathname.split("/")[1];
	    return {
	        staticData: state.staticData,
	        clientViewPort: state.clientViewPort || {},
	        screen: screen,
	        isChanged: (state.orderStatus || {}).isChanged,
	        isPreview: (state.staticData || {}).isPreview,
	        showCustomFooter: state.staticData.customFooterHTML && state.staticData.customFooterHTML !== ''
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        checkVersion: function checkVersion() {
	            dispatch((0, _commonActions.checkVersion)());
	        }
	    };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HomeScreen);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserMenu = __webpack_require__(490);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	var _header = __webpack_require__(769);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	    _inherits(Header, _React$Component);
	
	    function Header() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Header);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.getCustomHeader = function (customHeaderHTML) {
	            return _react2.default.createElement("div", { className: "header", dangerouslySetInnerHTML: { __html: customHeaderHTML } });
	        }, _this.getMobileHeader = function (customHeaderHTML) {
	            var mobileCustomHTML = customHeaderHTML && _react2.default.createElement("div", { className: "farm-custom", dangerouslySetInnerHTML: { __html: customHeaderHTML } });
	            return _react2.default.createElement(
	                "div",
	                { className: "header" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "container" },
	                    _react2.default.createElement(_UserMenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "farm-name" },
	                        _this.props.staticData.farmName
	                    ),
	                    mobileCustomHTML
	                )
	            );
	        }, _this.getHeader = function () {
	            var bgColor = _this.props.staticData.farmBackgroundColor ? _this.props.staticData.farmBackgroundColor.toLowerCase() : "ffffff";
	            var addBorder = bgColor === 'ffffff' || bgColor === "fff";
	            return _react2.default.createElement(
	                "div",
	                { className: "header" + (addBorder ? " add-border" : ""), style: { backgroundColor: "#" + _this.props.staticData.farmBackgroundColor } },
	                _react2.default.createElement(
	                    "div",
	                    { className: "container" },
	                    _react2.default.createElement(
	                        "a",
	                        { className: "logo-image", href: _this.props.staticData.farmWebSiteUrl, target: "_blank" },
	                        _react2.default.createElement("img", { src: _this.props.staticData.logoUrl })
	                    )
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Header, [{
	        key: "render",
	        value: function render() {
	            var MOBILE_HEADER_TAG = '<!-- MOBILE HEADER TAG -->';
	            var customHeaderHTML = this.props.staticData.customHeaderHTML && this.props.staticData.customHeaderHTML !== '' ? this.props.staticData.customHeaderHTML.split(MOBILE_HEADER_TAG)[this.props.clientViewPort.isXs ? 1 : 0] : undefined;
	            if (this.props.clientViewPort.isXs) return this.getMobileHeader(customHeaderHTML);
	            if (customHeaderHTML) return this.getCustomHeader(customHeaderHTML);
	            return this.getHeader();
	        }
	    }]);
	
	    return Header;
	}(_react2.default.Component);
	
	exports.default = Header;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _commonActions = __webpack_require__(747);
	
	var _logInActions = __webpack_require__(750);
	
	var _ContactFarmModal = __webpack_require__(761);
	
	var _ContactFarmModal2 = _interopRequireDefault(_ContactFarmModal);
	
	var _userMenu = __webpack_require__(765);
	
	var _userMenu2 = _interopRequireDefault(_userMenu);
	
	var _translate = __webpack_require__(464);
	
	var _storeActions = __webpack_require__(766);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogInWidget = function (_React$Component) {
	    _inherits(LogInWidget, _React$Component);
	
	    function LogInWidget() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LogInWidget);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LogInWidget.__proto__ || Object.getPrototypeOf(LogInWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = { showContactUs: false,
	            showUserMenu: false }, _this.onLogInClicked = function () {
	            _this.closeUserMenuXs();
	            _this.props.goToLogin();
	        }, _this.onLogOutClick = function () {
	            _this.closeUserMenuXs();
	            _this.props.checkIsDirty(function () {
	                this.props.logOut();
	            }.bind(_this));
	        }, _this.onMyAccountClick = function () {
	            _this.props.checkIsDirty(function () {
	                this.props.goToAccount(this.props.staticData);
	            }.bind(_this));
	        }, _this.onDeliveryHoldClick = function () {
	            _this.props.checkIsDirty(function () {
	                this.props.goToDeliveryHold(this.props.staticData);
	            }.bind(_this));
	        }, _this.onStoreClick = function () {
	            _this.props.checkIsDirty(function () {
	                this.props.goToStore(this.props.staticData);
	            }.bind(_this));
	        }, _this.onWebSiteClick = function () {
	            _this.props.goToWebSite(_this.props.farmWebSiteUrl);
	        }, _this.onContactUsClick = function () {
	            _this.closeUserMenuXs();
	            _this.setState({ showContactUs: true });
	        }, _this.onContactUsClose = function () {
	            _this.setState({ showContactUs: false });
	        }, _this.showUserMenuXs = function () {
	            _this.setState({ showUserMenu: true });
	        }, _this.closeUserMenuXs = function () {
	            _this.setState({ showUserMenu: false });
	        }, _this.renderContactFarmModal = function () {
	            if (!_this.state.showContactUs) return null;
	            return _react2.default.createElement(_ContactFarmModal2.default, { farmEmail: _this.props.farmEmail,
	                farmWebSiteUrl: _this.props.farmWebSiteUrl,
	                farmName: _this.props.farmName,
	                farmPhone: _this.props.farmPhone,
	                onClose: _this.onContactUsClose });
	        }, _this.renderUserMenuXs = function () {
	            if (_this.props.memberDetails.firstName) return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'menu-title' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _this.props.memberDetails.firstName + " " + _this.props.memberDetails.lastName
	                    )
	                ),
	                _this.getLink(),
	                _react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: 'contactUs', onClick: _this.onContactUsClick },
	                    (0, _translate.translate)('Contact Us')
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: 'website', onClick: _this.onWebSiteClick },
	                    (0, _translate.translate)('Web Site')
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: 'logOut', onClick: _this.onLogOutClick },
	                    (0, _translate.translate)('Log Out')
	                )
	            );
	            return _react2.default.createElement(
	                'div',
	                null,
	                (0, _utils.getPageContext)() !== _constants.URLs.JOIN ? _react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: 'login', onClick: _this.onLogInClicked },
	                    (0, _translate.translate)('Log In')
	                ) : undefined,
	                _react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: 'contactUs', onClick: _this.onContactUsClick },
	                    (0, _translate.translate)('Contact Us')
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: 'website', onClick: _this.onWebSiteClick },
	                    (0, _translate.translate)('Web Site')
	                )
	            );
	        }, _this.renderXs = function () {
	            return _react2.default.createElement(
	                'div',
	                { className: 'user-menu' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'humburger-button', onClick: _this.showUserMenuXs },
	                    _react2.default.createElement('i', null)
	                ),
	                _this.renderContactFarmModal(),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    { className: 'user-menu-modal', show: _this.state.showUserMenu, onHide: _this.closeUserMenuXs },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _this.renderUserMenuXs()
	                    )
	                )
	            );
	        }, _this.getLink = function () {
	            if (_this.props.showGoToStore && _this.props.isStoreAvailable) {
	                return _react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: 'goto', onClick: _this.onStoreClick },
	                    (0, _translate.translate)(_this.props.staticData.storeButtonLabel)
	                );
	            } else if (!_this.props.showGoToStore) {
	                var menuItems = [_react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { key: 'myAccount', eventKey: 'myAccount', onClick: _this.onMyAccountClick },
	                    (0, _translate.translate)('My Account')
	                )];
	                if (_this.props.staticData.allowUpdateVacation) {
	                    menuItems.push(_react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { key: 'deliveryHold', eventKey: 'deliveryHold', onClick: _this.onDeliveryHoldClick },
	                        (0, _translate.translate)('Delivery Hold')
	                    ));
	                }
	                return menuItems;
	            }
	        }, _this.renderMd = function () {
	            if (_this.props.memberDetails.firstName) return _react2.default.createElement(
	                'div',
	                { className: 'user-menu' },
	                _react2.default.createElement(
	                    _reactBootstrap.DropdownButton,
	                    { className: 'menu-title hidden-xs',
	                        title: _this.props.memberDetails.firstName,
	                        id: 'member-menu' },
	                    _this.getLink(),
	                    _react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { eventKey: 'contactUs', onClick: _this.onContactUsClick },
	                        (0, _translate.translate)('Contact Us')
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { eventKey: 'logOut', onClick: _this.onLogOutClick },
	                        (0, _translate.translate)('Log Out')
	                    )
	                ),
	                _this.renderContactFarmModal()
	            );else return _react2.default.createElement(
	                'div',
	                { className: 'user-menu' },
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { className: 'no-dropdown', onClick: _this.onLogInClicked, id: 'login-button' },
	                    (0, _translate.translate)('Log In')
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LogInWidget, [{
	        key: 'render',
	        value: function render() {
	            if (this.props.clientViewPort.isXs) return this.renderXs();
	            return this.renderMd();
	        }
	    }]);
	
	    return LogInWidget;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var summary = state.summary || {};
	    return {
	        staticData: state.staticData,
	        clientViewPort: state.clientViewPort || {},
	        memberDetails: state.memberDetails || {},
	        farmName: state.staticData.farmName,
	        farmEmail: state.staticData.farmEmail,
	        farmPhone: state.staticData.farmPhone,
	        farmWebSiteUrl: state.staticData.farmWebSiteUrl,
	        showGoToStore: (0, _utils.getPageContext)() === _constants.URLs.ACCOUNT,
	        isStoreAvailable: summary.isStoreAvailable
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        checkIsDirty: function checkIsDirty(onLeaveCallBack) {
	            dispatch((0, _commonActions.checkIsDirty)(onLeaveCallBack));
	        },
	        logOut: function logOut() {
	            if (ownProps.disabled) return;
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _logInActions.logOut)());
	        },
	        goToAccount: function goToAccount(staticData) {
	            if (ownProps.disabled) return;
	            dispatch((0, _commonActions.setDirty)(false));
	            window.location.assign((0, _utils.redirectPage)(_constants.URLs.ACCOUNT, staticData));
	        },
	        goToDeliveryHold: function goToDeliveryHold(staticData) {
	            if (ownProps.disabled) return;
	            dispatch((0, _commonActions.setDirty)(false));
	            window.location.assign((0, _utils.redirectPage)(_constants.URLs.ACCOUNT, staticData, '?tab=Delivery Hold'));
	        },
	        goToStore: function goToStore(staticData) {
	            if (ownProps.disabled) return;
	            dispatch((0, _commonActions.setDirty)(false));
	            window.location.assign((0, _utils.redirectPage)(_constants.URLs.STORE, staticData));
	        },
	        goToLogin: function goToLogin() {
	            if (ownProps.disabled) return;
	            dispatch((0, _storeActions.saveDraftOrder)(true));
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _reactRouterRedux.push)((0, _utils.addPath)('login')));
	        },
	        goToWebSite: function goToWebSite(webSiteUrl) {
	            window.location.assign(webSiteUrl);
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LogInWidget);

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.ToggleButtonGroup = exports.ToggleButton = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.PaginationButton = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.CloseButton = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(492);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(586);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(591);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(592);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(593);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(597);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(598);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(600);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(601);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(603);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(606);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(607);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _CloseButton2 = __webpack_require__(590);
	
	var _CloseButton3 = _interopRequireDefault(_CloseButton2);
	
	var _ControlLabel2 = __webpack_require__(609);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(610);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(611);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(624);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(649);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(651);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(652);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(653);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(656);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(605);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(657);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(658);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(659);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(660);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(663);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(664);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(665);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(666);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(667);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(674);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(675);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(697);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(699);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(700);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(701);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(702);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(703);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(704);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(708);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(709);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(710);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(719);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(720);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(721);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(724);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(725);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _PaginationButton2 = __webpack_require__(726);
	
	var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);
	
	var _Panel2 = __webpack_require__(727);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(575);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(728);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(729);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(730);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(731);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(732);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(594);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(733);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(735);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(736);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(737);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(739);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(738);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(740);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(741);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _ToggleButton2 = __webpack_require__(742);
	
	var _ToggleButton3 = _interopRequireDefault(_ToggleButton2);
	
	var _ToggleButtonGroup2 = __webpack_require__(743);
	
	var _ToggleButtonGroup3 = _interopRequireDefault(_ToggleButtonGroup2);
	
	var _Tooltip2 = __webpack_require__(744);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(745);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(746);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Accordion = _Accordion3.default;
	exports.Alert = _Alert3.default;
	exports.Badge = _Badge3.default;
	exports.Breadcrumb = _Breadcrumb3.default;
	exports.BreadcrumbItem = _BreadcrumbItem3.default;
	exports.Button = _Button3.default;
	exports.ButtonGroup = _ButtonGroup3.default;
	exports.ButtonToolbar = _ButtonToolbar3.default;
	exports.Carousel = _Carousel3.default;
	exports.CarouselItem = _CarouselItem3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Clearfix = _Clearfix3.default;
	exports.CloseButton = _CloseButton3.default;
	exports.ControlLabel = _ControlLabel3.default;
	exports.Col = _Col3.default;
	exports.Collapse = _Collapse3.default;
	exports.Dropdown = _Dropdown3.default;
	exports.DropdownButton = _DropdownButton3.default;
	exports.Fade = _Fade3.default;
	exports.Form = _Form3.default;
	exports.FormControl = _FormControl3.default;
	exports.FormGroup = _FormGroup3.default;
	exports.Glyphicon = _Glyphicon3.default;
	exports.Grid = _Grid3.default;
	exports.HelpBlock = _HelpBlock3.default;
	exports.Image = _Image3.default;
	exports.InputGroup = _InputGroup3.default;
	exports.Jumbotron = _Jumbotron3.default;
	exports.Label = _Label3.default;
	exports.ListGroup = _ListGroup3.default;
	exports.ListGroupItem = _ListGroupItem3.default;
	exports.Media = _Media3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.Modal = _Modal3.default;
	exports.ModalBody = _ModalBody3.default;
	exports.ModalFooter = _ModalFooter3.default;
	exports.ModalHeader = _ModalHeader3.default;
	exports.ModalTitle = _ModalTitle3.default;
	exports.Nav = _Nav3.default;
	exports.Navbar = _Navbar3.default;
	exports.NavbarBrand = _NavbarBrand3.default;
	exports.NavDropdown = _NavDropdown3.default;
	exports.NavItem = _NavItem3.default;
	exports.Overlay = _Overlay3.default;
	exports.OverlayTrigger = _OverlayTrigger3.default;
	exports.PageHeader = _PageHeader3.default;
	exports.PageItem = _PageItem3.default;
	exports.Pager = _Pager3.default;
	exports.Pagination = _Pagination3.default;
	exports.PaginationButton = _PaginationButton3.default;
	exports.Panel = _Panel3.default;
	exports.PanelGroup = _PanelGroup3.default;
	exports.Popover = _Popover3.default;
	exports.ProgressBar = _ProgressBar3.default;
	exports.Radio = _Radio3.default;
	exports.ResponsiveEmbed = _ResponsiveEmbed3.default;
	exports.Row = _Row3.default;
	exports.SafeAnchor = _SafeAnchor3.default;
	exports.SplitButton = _SplitButton3.default;
	exports.Tab = _Tab3.default;
	exports.TabContainer = _TabContainer3.default;
	exports.TabContent = _TabContent3.default;
	exports.Table = _Table3.default;
	exports.TabPane = _TabPane3.default;
	exports.Tabs = _Tabs3.default;
	exports.Thumbnail = _Thumbnail3.default;
	exports.ToggleButton = _ToggleButton3.default;
	exports.ToggleButtonGroup = _ToggleButtonGroup3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.Well = _Well3.default;
	exports.utils = _utils;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(575);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3.default)(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3.default)(this, Accordion);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2.default.createElement(
	      _PanelGroup2.default,
	      (0, _extends3.default)({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2.default.Component);
	
	exports.default = Accordion;
	module.exports = exports['default'];

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(494);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(495), __esModule: true };

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(496);
	module.exports = __webpack_require__(499).Object.assign;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(497);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(513) });


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(498);
	var core = __webpack_require__(499);
	var ctx = __webpack_require__(500);
	var hide = __webpack_require__(502);
	var has = __webpack_require__(512);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 499 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(501);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 501 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(503);
	var createDesc = __webpack_require__(511);
	module.exports = __webpack_require__(507) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(504);
	var IE8_DOM_DEFINE = __webpack_require__(506);
	var toPrimitive = __webpack_require__(510);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(507) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(505);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 505 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(507) && !__webpack_require__(508)(function () {
	  return Object.defineProperty(__webpack_require__(509)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(508)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(505);
	var document = __webpack_require__(498).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(505);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 511 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 512 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(507);
	var getKeys = __webpack_require__(514);
	var gOPS = __webpack_require__(529);
	var pIE = __webpack_require__(530);
	var toObject = __webpack_require__(531);
	var IObject = __webpack_require__(517);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(508)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(515);
	var enumBugKeys = __webpack_require__(528);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(512);
	var toIObject = __webpack_require__(516);
	var arrayIndexOf = __webpack_require__(520)(false);
	var IE_PROTO = __webpack_require__(524)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(517);
	var defined = __webpack_require__(519);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(518);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 518 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 519 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(516);
	var toLength = __webpack_require__(521);
	var toAbsoluteIndex = __webpack_require__(523);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(522);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 522 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(522);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(525)('keys');
	var uid = __webpack_require__(527);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(499);
	var global = __webpack_require__(498);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(526) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 526 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 528 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 529 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(519);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 532 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(534);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(535);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(554);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(536), __esModule: true };

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(537);
	__webpack_require__(549);
	module.exports = __webpack_require__(553).f('iterator');


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(538)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(539)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(522);
	var defined = __webpack_require__(519);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(526);
	var $export = __webpack_require__(497);
	var redefine = __webpack_require__(540);
	var hide = __webpack_require__(502);
	var Iterators = __webpack_require__(541);
	var $iterCreate = __webpack_require__(542);
	var setToStringTag = __webpack_require__(546);
	var getPrototypeOf = __webpack_require__(548);
	var ITERATOR = __webpack_require__(547)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(502);


/***/ }),
/* 541 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(543);
	var descriptor = __webpack_require__(511);
	var setToStringTag = __webpack_require__(546);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(502)(IteratorPrototype, __webpack_require__(547)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(504);
	var dPs = __webpack_require__(544);
	var enumBugKeys = __webpack_require__(528);
	var IE_PROTO = __webpack_require__(524)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(509)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(545).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(503);
	var anObject = __webpack_require__(504);
	var getKeys = __webpack_require__(514);
	
	module.exports = __webpack_require__(507) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(498).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(503).f;
	var has = __webpack_require__(512);
	var TAG = __webpack_require__(547)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(525)('wks');
	var uid = __webpack_require__(527);
	var Symbol = __webpack_require__(498).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(512);
	var toObject = __webpack_require__(531);
	var IE_PROTO = __webpack_require__(524)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(550);
	var global = __webpack_require__(498);
	var hide = __webpack_require__(502);
	var Iterators = __webpack_require__(541);
	var TO_STRING_TAG = __webpack_require__(547)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(551);
	var step = __webpack_require__(552);
	var Iterators = __webpack_require__(541);
	var toIObject = __webpack_require__(516);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(539)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 551 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 552 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(547);


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(555), __esModule: true };

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(556);
	__webpack_require__(564);
	__webpack_require__(565);
	__webpack_require__(566);
	module.exports = __webpack_require__(499).Symbol;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(498);
	var has = __webpack_require__(512);
	var DESCRIPTORS = __webpack_require__(507);
	var $export = __webpack_require__(497);
	var redefine = __webpack_require__(540);
	var META = __webpack_require__(557).KEY;
	var $fails = __webpack_require__(508);
	var shared = __webpack_require__(525);
	var setToStringTag = __webpack_require__(546);
	var uid = __webpack_require__(527);
	var wks = __webpack_require__(547);
	var wksExt = __webpack_require__(553);
	var wksDefine = __webpack_require__(558);
	var enumKeys = __webpack_require__(559);
	var isArray = __webpack_require__(560);
	var anObject = __webpack_require__(504);
	var isObject = __webpack_require__(505);
	var toObject = __webpack_require__(531);
	var toIObject = __webpack_require__(516);
	var toPrimitive = __webpack_require__(510);
	var createDesc = __webpack_require__(511);
	var _create = __webpack_require__(543);
	var gOPNExt = __webpack_require__(561);
	var $GOPD = __webpack_require__(563);
	var $GOPS = __webpack_require__(529);
	var $DP = __webpack_require__(503);
	var $keys = __webpack_require__(514);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(562).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(530).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(526)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(502)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(527)('meta');
	var isObject = __webpack_require__(505);
	var has = __webpack_require__(512);
	var setDesc = __webpack_require__(503).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(508)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(498);
	var core = __webpack_require__(499);
	var LIBRARY = __webpack_require__(526);
	var wksExt = __webpack_require__(553);
	var defineProperty = __webpack_require__(503).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(514);
	var gOPS = __webpack_require__(529);
	var pIE = __webpack_require__(530);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(518);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(516);
	var gOPN = __webpack_require__(562).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(515);
	var hiddenKeys = __webpack_require__(528).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(530);
	var createDesc = __webpack_require__(511);
	var toIObject = __webpack_require__(516);
	var toPrimitive = __webpack_require__(510);
	var has = __webpack_require__(512);
	var IE8_DOM_DEFINE = __webpack_require__(506);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(507) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 564 */
/***/ (function(module, exports) {



/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(558)('asyncIterator');


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(558)('observable');


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(568);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(572);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(534);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(569), __esModule: true };

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(570);
	module.exports = __webpack_require__(499).Object.setPrototypeOf;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(497);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(571).set });


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(505);
	var anObject = __webpack_require__(504);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(500)(Function.call, __webpack_require__(563).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(573), __esModule: true };

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(574);
	var $Object = __webpack_require__(499).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(497);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(543) });


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(494);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  accordion: _propTypes2.default.bool,
	  activeKey: _propTypes2.default.any,
	  defaultActiveKey: _propTypes2.default.any,
	  onSelect: _propTypes2.default.func,
	  role: _propTypes2.default.string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3.default)(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3.default)(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2.default)(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2.default)(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2.default.Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(579);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2.default)(false, 'A `bsClass` prop is required for this component') : (0, _invariant2.default)(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2.default.string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2.default.oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = existing;
	  propType._values = existing;
	
	  Component.propTypes = (0, _extends3.default)({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2.default.oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3.default)({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2.default)(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(580), __esModule: true };

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(581);
	module.exports = __webpack_require__(499).Object.entries;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(497);
	var $entries = __webpack_require__(582)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(507);
	var getKeys = __webpack_require__(514);
	var toIObject = __webpack_require__(516);
	var isEnum = __webpack_require__(530).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 583 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports.default = createChainedFunction;
	module.exports = exports['default'];

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = void 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports.default = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(587);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	var _CloseButton = __webpack_require__(590);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onDismiss: _propTypes2.default.func,
	  closeLabel: _propTypes2.default.string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3.default)(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3.default)(this, Alert);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      dismissable && _react2.default.createElement(_CloseButton2.default, {
	        onClick: onDismiss,
	        label: closeLabel
	      }),
	      children
	    );
	  };
	
	  return Alert;
	}(_react2.default.Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(588), __esModule: true };

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(589);
	module.exports = __webpack_require__(499).Object.values;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(497);
	var $values = __webpack_require__(582)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  label: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  label: 'Close'
	};
	
	var CloseButton = function (_React$Component) {
	  (0, _inherits3.default)(CloseButton, _React$Component);
	
	  function CloseButton() {
	    (0, _classCallCheck3.default)(this, CloseButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  CloseButton.prototype.render = function render() {
	    var _props = this.props,
	        label = _props.label,
	        onClick = _props.onClick;
	
	    return _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onClick
	      },
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': 'true' },
	        '\xD7'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      )
	    );
	  };
	
	  return CloseButton;
	}(_react2.default.Component);
	
	CloseButton.propTypes = propTypes;
	CloseButton.defaultProps = defaultProps;
	
	exports.default = CloseButton;
	module.exports = exports['default'];

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3.default)(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3.default)(this, Badge);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2.default.Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(593);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3.default)(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3.default)(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('ol', (0, _extends3.default)({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2.default.Component);
	
	Breadcrumb.Item = _BreadcrumbItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(594);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes2.default.string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes2.default.node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes2.default.string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3.default)(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3.default)(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2.default.createElement(
	      'li',
	      { className: (0, _classnames2.default)(className, { active: active }) },
	      active ? _react2.default.createElement('span', props) : _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2.default.Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports.default = BreadcrumbItem;
	module.exports = exports['default'];

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3.default)(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3.default)(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (event.key === ' ') {
	      event.preventDefault();
	      this.handleClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        onKeyDown = _props2.onKeyDown,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'disabled', 'onKeyDown']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3.default)({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
	      onClick: this.handleClick,
	      onKeyDown: (0, _createChainedFunction2.default)(this.handleKeyDown, onKeyDown)
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2.default.Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports.default = SafeAnchor;
	module.exports = exports['default'];

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(368);
	
	var _createChainableTypeChecker = __webpack_require__(596);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  if (!(0, _reactIs.isValidElementType)(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	module.exports = exports['default'];

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(587);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	var _SafeAnchor = __webpack_require__(594);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  block: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  componentClass: _elementType2.default,
	  href: _propTypes2.default.string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2.default.oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3.default)(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3.default)(this, Button);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2.default.createElement(_SafeAnchor2.default, (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3.default)(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2.default.createElement(Component, (0, _extends4.default)({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2.default)(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2.default.Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(599);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(597);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  vertical: _propTypes2.default.bool,
	  justified: _propTypes2.default.bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3.default)(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3.default)(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2.default.defaultProps, 'block')] = block, _extends2));
	
	    return _react2.default.createElement('div', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2.default.Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(596);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}
	module.exports = exports['default'];

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3.default)(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3.default)(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn-toolbar', ButtonToolbar);
	module.exports = exports['default'];

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__(602);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(603);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(605);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(594);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2.default.bool,
	  indicators: _propTypes2.default.bool,
	  /**
	   * The amount of time to delay between automatically cycling an item.
	   * If `null`, carousel will not automatically cycle.
	   */
	  interval: _propTypes2.default.number,
	  controls: _propTypes2.default.bool,
	  pauseOnHover: _propTypes2.default.bool,
	  wrap: _propTypes2.default.bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2.default.func,
	  onSlideEnd: _propTypes2.default.func,
	  activeIndex: _propTypes2.default.number,
	  defaultActiveIndex: _propTypes2.default.number,
	  direction: _propTypes2.default.oneOf(['prev', 'next']),
	  prevIcon: _propTypes2.default.node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2.default.string,
	  nextIcon: _propTypes2.default.node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2.default.string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2.default.createElement(_Glyphicon2.default, { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2.default.createElement(_Glyphicon2.default, { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3.default)(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3.default)(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	
	    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
	      this.setState({
	        activeIndex: 0,
	        previousActiveIndex: null,
	        direction: null
	      });
	    }
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2.default.count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2.default.count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2.default.count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2.default.createElement(
	      _SafeAnchor2.default,
	      {
	        key: 'prev',
	        className: (0, _classnames2.default)(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2.default.createElement(
	      _SafeAnchor2.default,
	      {
	        key: 'next',
	        className: (0, _classnames2.default)(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2.default.forEach(children, function (child, index) {
	      indicators.push(_react2.default.createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2.default.createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2.default.map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2.default.Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2.default;
	Carousel.Item = _CarouselItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3.default)(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3.default)(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2.default.Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(604);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2.default.oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2.default.func,
	  active: _propTypes2.default.bool,
	  animateIn: _propTypes2.default.bool,
	  animateOut: _propTypes2.default.bool,
	  index: _propTypes2.default.number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3.default)(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3.default)(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2.default.addEndEventListener(_reactDom2.default.findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2.default.Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports.default = CarouselItem;
	module.exports = exports['default'];

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      // eslint-disable-line guard-for-in
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports.default = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes2.default.string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3.default)(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3.default)(this, Glyphicon);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2.default.createElement('span', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2.default.Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  inline: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/label-has-for */
	
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3.default)(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3.default)(this, Checkbox);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2.default.createElement('input', (0, _extends3.default)({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2.default)(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2.default.createElement(
	        'label',
	        { className: (0, _classnames2.default)(className, _classes), style: style, title: title },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(className, classes), style: style },
	      _react2.default.createElement(
	        'label',
	        { title: title },
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2.default.Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _capitalize = __webpack_require__(608);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3.default)(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3.default)(this, Clearfix);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2.default)(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2.default.Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes2.default.string,
	  srOnly: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3.default)(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3.default)(this, ControlLabel);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2.default.createElement('label', (0, _extends3.default)({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2.default.Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2.default.number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2.default.bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2.default.number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3.default)(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3.default)(this, Col);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2.default.Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(612);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(622);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(608);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2.default)(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2.default)(elem, margins[0]), 10) + parseInt((0, _style2.default)(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['height', 'width']), _propTypes2.default.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes2.default.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes2.default.string
	};
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3.default)(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3.default)(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2.default)(dimension)] + 'px';
	  };
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2.default)(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2.default)(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2.default)(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2.default)(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2.default)(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2.default.createElement(_Transition2.default, (0, _extends3.default)({}, props, {
	      'aria-expanded': props.role ? props.in : null,
	      className: (0, _classnames2.default)(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2.default.Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports.default = Collapse;
	module.exports = exports['default'];

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(613));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(615));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(617));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(618));
	
	var _properties = __webpack_require__(619);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(621));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(614));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(616));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(613));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(620));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(623);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(619);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.updateStatus = function () {
	      if (_this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        _this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(_this);
	
	        if (_this.nextStatus === ENTERING) {
	          _this.props.onEnter(node);
	
	          _this.safeSetState({ status: ENTERING }, function () {
	            _this.props.onEntering(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: ENTERED }, function () {
	                _this.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          _this.props.onExit(node);
	
	          _this.safeSetState({ status: EXITING }, function () {
	            _this.props.onExiting(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: EXITED }, function () {
	                _this.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        _this.nextStatus = null;
	      } else if (_this.props.unmountOnExit && _this.state.status === EXITED) {
	        _this.setState({ status: UNMOUNTED });
	      }
	    };
	
	    _this.cancelNextCallback = function () {
	      if (_this.nextCallback !== null) {
	        _this.nextCallback.cancel();
	        _this.nextCallback = null;
	      }
	    };
	
	    _this.safeSetState = function (nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      _this.setState(nextState, _this.setNextCallback(callback));
	    };
	
	    _this.setNextCallback = function (callback) {
	      var active = true;
	
	      _this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      _this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return _this.nextCallback;
	    };
	
	    _this.onTransitionEnd = function (node, handler) {
	      _this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, _this.nextCallback);
	        setTimeout(_this.nextCallback, _this.props.timeout);
	      } else {
	        setTimeout(_this.nextCallback, 0);
	      }
	    };
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var status = this.state.status;
	
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	    Object.keys(Transition.propTypes).forEach(function (key) {
	      return delete childProps[key];
	    });
	
	    var transitionClassName = void 0;
	    if (status === EXITED) {
	      transitionClassName = this.props.exitedClassName;
	    } else if (status === ENTERING) {
	      transitionClassName = this.props.enteringClassName;
	    } else if (status === ENTERED) {
	      transitionClassName = this.props.enteredClassName;
	    } else if (status === EXITING) {
	      transitionClassName = this.props.exitingClassName;
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, _extends({}, childProps, {
	      className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	    }));
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _propTypes2.default.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _propTypes2.default.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(620));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(625);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(627);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(628);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(599);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(629);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(630);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(598);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(633);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(647);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(648);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2.default.defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2.default.defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes2.default.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  componentClass: _elementType2.default,
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2.default)((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes2.default.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes2.default.bool,
	
	  defaultOpen: _propTypes2.default.bool,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes2.default.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _propTypes2.default.oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2.default
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3.default)(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3.default)(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2.default)(_reactDom2.default.findDOMNode(this.menu), (0, _activeElement2.default)(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu let's return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2.default.findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, { source: 'click' });
	  };
	
	  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2.default.codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, { source: 'keydown' });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.esc:
	      case _keycode2.default.codes.tab:
	        this.handleClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this2 = this;
	
	    var id = _ref.id,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['id', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this2.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2.default)(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3.default)({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2.default)(child.props.onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect, function (key, event) {
	        return _this2.handleClose(event, { source: 'select' });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this3 = this;
	
	    var ref = function ref(c) {
	      _this3.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2.default)(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3.default)({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2.default)(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2.default)(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, props, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2.default.Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2.default)(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2.default;
	UncontrolledDropdown.Menu = _DropdownMenu2.default;
	
	exports.default = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(626));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(620));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 629 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(631);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(632);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(634);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(628);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(643);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  open: _propTypes2.default.bool,
	  pullRight: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  labelledBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  onSelect: _propTypes2.default.func,
	  rootCloseEvent: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3.default)(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3.default)(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    _this.handleRootClose = _this.handleRootClose.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2.default.findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2.default)(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2.default.codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.esc:
	      case _keycode2.default.codes.tab:
	        this.props.onClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, { source: 'rootClose' });
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2.default.createElement(
	      _RootCloseWrapper2.default,
	      {
	        disabled: !open,
	        onRootClose: this.handleRootClose,
	        event: rootCloseEvent
	      },
	      _react2.default.createElement(
	        'ul',
	        (0, _extends4.default)({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2.default)(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2.default.map(children, function (child) {
	          return _react2.default.cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2.default)(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2.default.Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(635), __esModule: true };

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(537);
	__webpack_require__(636);
	module.exports = __webpack_require__(499).Array.from;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(500);
	var $export = __webpack_require__(497);
	var toObject = __webpack_require__(531);
	var call = __webpack_require__(637);
	var isArrayIter = __webpack_require__(638);
	var toLength = __webpack_require__(521);
	var createProperty = __webpack_require__(639);
	var getIterFn = __webpack_require__(640);
	
	$export($export.S + $export.F * !__webpack_require__(642)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(504);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(541);
	var ITERATOR = __webpack_require__(547)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(503);
	var createDesc = __webpack_require__(511);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(641);
	var ITERATOR = __webpack_require__(547)('iterator');
	var Iterators = __webpack_require__(541);
	module.exports = __webpack_require__(499).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(518);
	var TAG = __webpack_require__(547)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(547)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _contains = __webpack_require__(627);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(644);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(646);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.addEventListeners = function () {
	      var event = _this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(_this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);
	
	      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);
	
	      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
	    };
	
	    _this.removeEventListeners = function () {
	      if (_this.documentMouseCaptureListener) {
	        _this.documentMouseCaptureListener.remove();
	      }
	
	      if (_this.documentMouseListener) {
	        _this.documentMouseListener.remove();
	      }
	
	      if (_this.documentKeyupListener) {
	        _this.documentKeyupListener.remove();
	      }
	    };
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.disabled) {
	      this.addEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!this.props.disabled && prevProps.disabled) {
	      this.addEventListeners();
	    } else if (this.props.disabled && !prevProps.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (!this.props.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _propTypes2.default.func,
	  /**
	   * Children to render.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(623);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(645);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(620));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(626);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(597);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(594);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  noCaret: _propTypes2.default.bool,
	  open: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  useAnchor: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3.default)(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3.default)(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2.default : _Button2.default;
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, props, {
	        role: 'button',
	        className: (0, _classnames2.default)(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2.default.createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2.default.Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(596);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2.default)(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2.default.some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2.default)(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2.default.filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(624);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(650);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2.default.string,
	  bsSize: _propTypes2.default.string,
	  title: _propTypes2.default.node.isRequired,
	  noCaret: _propTypes2.default.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3.default)(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3.default)(this, DropdownButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Toggle,
	        (0, _extends3.default)({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2.default.Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports.default = DropdownButton;
	module.exports = exports['default'];

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(579);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports.default = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(622);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2.default.func
	};
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3.default)(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3.default)(this, Fade);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2.default.createElement(_Transition2.default, (0, _extends3.default)({}, this.props, {
	      className: (0, _classnames2.default)(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2.default.Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports.default = Fade;
	module.exports = exports['default'];

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3.default)(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3.default)(this, Form);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2.default.Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(654);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(655);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2.default.string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3.default)(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3.default)(this, FormControl);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2.default.Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2.default;
	FormControl.Static = _FormControlStatic2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__(605);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3.default)(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3.default)(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2.default.createElement(_Glyphicon2.default, (0, _extends3.default)({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2.default.Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3.default)(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3.default)(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2.default.Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2.default.string,
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2.default.object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3.default)(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3.default)(this, FormGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2.default.some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2.default.Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes2.default.bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3.default)(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3.default)(this, Grid);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2.default.Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3.default)(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3.default)(this, HelpBlock);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3.default)(this, Image);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2.default.createElement('img', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(661);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(662);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3.default)(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3.default)(this, InputGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2.default.Component);
	
	InputGroup.Addon = _InputGroupAddon2.default;
	InputGroup.Button = _InputGroupButton2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3.default)(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3.default)(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3.default)(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3.default)(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3.default)(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3.default)(this, Jumbotron);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2.default.Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(587);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3.default)(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3.default)(this, Label);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(666);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2.default
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2.default.some(children, function (child) {
	    return child.type !== _ListGroupItem2.default || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3.default)(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3.default)(this, ListGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2.default.every(children, function (child) {
	      return child.type === _ListGroupItem2.default;
	    });
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2.default.Component);
	
	ListGroup.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(587);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.any,
	  disabled: _propTypes2.default.any,
	  header: _propTypes2.default.node,
	  listItem: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  href: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3.default)(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3.default)(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2.default.isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2.default)(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2.default.createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2.default)(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2.default.createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2.default.createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2.default.Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(668);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(669);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(670);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(671);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(672);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(673);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3.default)(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3.default)(this, Media);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2.default.Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2.default;
	Media.Body = _MediaBody2.default;
	Media.Left = _MediaLeft2.default;
	Media.Right = _MediaRight2.default;
	Media.List = _MediaList2.default;
	Media.ListItem = _MediaListItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Media = __webpack_require__(667);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom']),
	
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3.default)(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3.default)(this, MediaBody);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2.default.Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3.default)(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3.default)(this, MediaHeading);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2.default.Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(667);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3.default)(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3.default)(this, MediaLeft);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2.default.Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3.default)(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3.default)(this, MediaList);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('ul', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3.default)(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3.default)(this, MediaListItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(667);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3.default)(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3.default)(this, MediaRight);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2.default.Component);
	
	MediaRight.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(599);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(594);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes2.default.any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2.default.func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3.default)(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2.default)(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2.default.createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2.default.Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(676);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(626);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(620);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(680);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(681);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(689);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(651);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(697);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(698);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(699);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(700);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(701);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(650);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Modal2.default.propTypes, _ModalDialog2.default.propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2.default.oneOf(['static', true, false]),
	
	  /**
	   * Add an optional extra class name to .modal-backdrop
	   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2.default.bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * @private
	   */
	  container: _Modal2.default.propTypes.container
	});
	
	var defaultProps = (0, _extends3.default)({}, _Modal2.default.defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2.default
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3.default)(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3.default)(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	    _this.setModalRef = _this.setModalRef.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.setModalRef = function setModalRef(ref) {
	    this._modal = ref;
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2.default) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2.default)(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2.default)(_reactDom2.default.findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        backdropClassName = _props.backdropClassName,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3.default)(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Modal2.default),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      (0, _extends3.default)({}, baseModalProps, {
	        ref: this.setModalRef,
	        show: show,
	        onEntering: (0, _createChainedFunction2.default)(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2.default)(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2.default)((0, _bootstrapUtils.prefix)(props, 'backdrop'), backdropClassName, inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2.default : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2.default.createElement(
	        Dialog,
	        (0, _extends3.default)({}, dialogProps, {
	          style: (0, _extends3.default)({}, this.state.style, style),
	          className: (0, _classnames2.default)(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2.default;
	Modal.Header = _ModalHeader2.default;
	Modal.Title = _ModalTitle2.default;
	Modal.Footer = _ModalFooter2.default;
	
	Modal.Dialog = _ModalDialog2.default;
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _on = _interopRequireDefault(__webpack_require__(623));
	
	exports.on = _on.default;
	
	var _off = _interopRequireDefault(__webpack_require__(645));
	
	exports.off = _off.default;
	
	var _filter = _interopRequireDefault(__webpack_require__(677));
	
	exports.filter = _filter.default;
	
	var _listen = _interopRequireDefault(__webpack_require__(679));
	
	exports.listen = _listen.default;
	var _default = {
	  on: _on.default,
	  off: _off.default,
	  filter: _filter.default,
	  listen: _listen.default
	};
	exports.default = _default;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = filterEvents;
	
	var _contains = _interopRequireDefault(__webpack_require__(627));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(678));
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll.default)(top, selector);
	    if (matches.some(function (match) {
	      return (0, _contains.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(620));
	
	var _on = _interopRequireDefault(__webpack_require__(623));
	
	var _off = _interopRequireDefault(__webpack_require__(645));
	
	var listen = function listen() {};
	
	if (_inDOM.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(620));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _activeElement = __webpack_require__(625);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(627);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(620);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(682);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _deprecated = __webpack_require__(683);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ModalManager = __webpack_require__(684);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _Portal = __webpack_require__(692);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _RefHolder = __webpack_require__(695);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _addEventListener = __webpack_require__(644);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(696);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _getContainer = __webpack_require__(693);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(646);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Modal.prototype.omitProps = function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container,
	        onRendered: this.onPortalRendered
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: this.setModalNodeRef,
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        _react2.default.createElement(
	          _RefHolder2.default,
	          { ref: this.setDialogRef },
	          dialog
	        )
	      )
	    );
	  };
	
	  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  };
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props2 = this.props,
	        show = _props2.show,
	        transition = _props2.transition;
	
	
	    this._isMounted = false;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  };
	
	  Modal.prototype.autoFocus = function autoFocus() {
	    if (!this.props.autoFocus) {
	      return;
	    }
	
	    var dialogElement = this.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      this.lastFocus = currentActiveElement;
	
	      if (!dialogElement.hasAttribute('tabIndex')) {
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');
	
	        dialogElement.setAttribute('tabIndex', -1);
	      }
	
	      dialogElement.focus();
	    }
	  };
	
	  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  };
	
	  Modal.prototype.getDialogElement = function getDialogElement() {
	    return _reactDom2.default.findDOMNode(this.dialog);
	  };
	
	  Modal.prototype.isTopModal = function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes2.default.func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	
	  /**
	   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   * @deprecated
	   */
	  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	
	  /**
	   * A style object for the backdrop component.
	   */
	  backdropStyle: _propTypes2.default.object,
	
	  /**
	   * A css class or classes for the backdrop component.
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * A `<Transition/>` component to use for the dialog and backdrop components.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * The `timeout` of the dialog transition if specified. This number is used to ensure that
	   * transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  dialogTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * The `timeout` of the backdrop transition if specified. This number is used to
	   * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  backdropTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes2.default.object.isRequired
	});
	Modal.defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  onHide: function onHide() {},
	  manager: modalManager,
	  renderBackdrop: function renderBackdrop(props) {
	    return _react2.default.createElement('div', props);
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { exited: !this.props.show };
	
	  this.renderBackdrop = function () {
	    var _props3 = _this2.props,
	        backdropStyle = _props3.backdropStyle,
	        backdropClassName = _props3.backdropClassName,
	        renderBackdrop = _props3.renderBackdrop,
	        Transition = _props3.transition,
	        backdropTransitionTimeout = _props3.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this2.backdrop = ref;
	    };
	
	    var backdrop = renderBackdrop({
	      ref: backdropRef,
	      style: backdropStyle,
	      className: backdropClassName,
	      onClick: _this2.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': _this2.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  };
	
	  this.onPortalRendered = function () {
	    _this2.autoFocus();
	
	    if (_this2.props.onShow) {
	      _this2.props.onShow();
	    }
	  };
	
	  this.onShow = function () {
	    var doc = (0, _ownerDocument2.default)(_this2);
	    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);
	
	    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
	
	    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
	
	    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
	
	    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
	  };
	
	  this.onHide = function () {
	    _this2.props.manager.remove(_this2);
	
	    _this2._onDocumentKeydownListener.remove();
	
	    _this2._onDocumentKeyupListener.remove();
	
	    _this2._onFocusinListener.remove();
	
	    if (_this2.props.restoreFocus) {
	      _this2.restoreLastFocus();
	    }
	  };
	
	  this.setMountNode = function (ref) {
	    _this2.mountNode = ref ? ref.getMountNode() : ref;
	  };
	
	  this.setModalNodeRef = function (ref) {
	    _this2.modalNode = ref;
	  };
	
	  this.setDialogRef = function (ref) {
	    _this2.dialog = ref;
	  };
	
	  this.handleHidden = function () {
	    _this2.setState({ exited: true });
	    _this2.onHide();
	
	    if (_this2.props.onExited) {
	      var _props4;
	
	      (_props4 = _this2.props).onExited.apply(_props4, arguments);
	    }
	  };
	
	  this.handleBackdropClick = function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (_this2.props.onBackdropClick) {
	      _this2.props.onBackdropClick(e);
	    }
	
	    if (_this2.props.backdrop === true) {
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyDown = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyDown) {
	        _this2.props.onEscapeKeyDown(e);
	      }
	
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyUp) {
	        _this2.props.onEscapeKeyUp(e);
	      }
	    }
	  };
	
	  this.checkForFocus = function () {
	    if (_inDOM2.default) {
	      _this2.lastFocus = (0, _activeElement2.default)();
	    }
	  };
	
	  this.enforceFocus = function () {
	    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
	      return;
	    }
	
	    var dialogElement = _this2.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      dialogElement.focus();
	    }
	  };
	};
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(596);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);
	module.exports = exports['default'];

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */
	
	module.exports = exports['default'];

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class = __webpack_require__(685);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _style = __webpack_require__(612);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(680);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(689);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(691);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	      _ref2$handleContainer = _ref2.handleContainerOverflow,
	      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	  _classCallCheck(this, ModalManager);
	
	  this.add = function (modal, container, className) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	
	      overflowing: (0, _isOverflowing2.default)(container)
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    _this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container
	    if (data.modals.length === 0) {
	      data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	    }
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  this.modals = [];
	  this.containers = [];
	  this.data = [];
	};
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(686));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(688));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(687));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(687));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(690);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(626);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ }),
/* 690 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(682);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(693);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(646);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _LegacyPortal = __webpack_require__(694);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	
	      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
	    }, _this.getMountNode = function () {
	      return _this._portalContainerNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this.setContainer();
	    this.forceUpdate(this.props.onRendered);
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.container !== this.props.container) {
	      this.setContainer(nextProps);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._portalContainerNode = null;
	  };
	
	  Portal.prototype.render = function render() {
	    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
	module.exports = exports['default'];

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(682);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(693);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(646);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
	      if (!_this._overlayTarget) {
	        _this._overlayTarget = document.createElement('div');
	        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
	        _this._portalContainerNode.appendChild(_this._overlayTarget);
	      }
	    }, _this._unmountOverlayTarget = function () {
	      if (_this._overlayTarget) {
	        _this._portalContainerNode.removeChild(_this._overlayTarget);
	        _this._overlayTarget = null;
	      }
	      _this._portalContainerNode = null;
	    }, _this._renderOverlay = function () {
	      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);
	
	      // Save reference for future access.
	      if (overlay !== null) {
	        _this._mountOverlayTarget();
	
	        var initialRender = !_this._overlayInstance;
	
	        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
	          if (initialRender && _this.props.onRendered) {
	            _this.props.onRendered();
	          }
	        });
	      } else {
	        // Unrender if the component is null for transitions to null
	        _this._unrenderOverlay();
	        _this._unmountOverlayTarget();
	      }
	    }, _this._unrenderOverlay = function () {
	      if (_this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
	        _this._overlayInstance = null;
	      }
	    }, _this.getMountNode = function () {
	      return _this._overlayTarget;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  };
	
	  Portal.prototype.render = function render() {
	    return null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = Portal;
	module.exports = exports['default'];

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.node
	};
	
	/**
	 * Internal helper component to allow attaching a non-conflicting ref to a
	 * child element that may not accept refs.
	 */
	
	var RefHolder = function (_React$Component) {
	  _inherits(RefHolder, _React$Component);
	
	  function RefHolder() {
	    _classCallCheck(this, RefHolder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RefHolder.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefHolder;
	}(_react2.default.Component);
	
	RefHolder.propTypes = propTypes;
	
	exports.default = RefHolder;
	module.exports = exports['default'];

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3.default)(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3.default)(this, ModalBody);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2.default.string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3.default)(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3.default)(this, ModalDialog);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4.default)({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2.default)(className, bsClassName)
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(dialogClassName, dialogClasses) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2.default.Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3.default)(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3.default)(this, ModalFooter);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2.default.Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _CloseButton = __webpack_require__(590);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * Provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  closeLabel: _propTypes2.default.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2.default.func
	};
	
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3.default)(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3.default)(this, ModalHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        closeLabel = _props.closeLabel,
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      closeButton && _react2.default.createElement(_CloseButton2.default, {
	        label: closeLabel,
	        onClick: (0, _createChainedFunction2.default)(modal && modal.onHide, onHide)
	      }),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2.default.Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3.default)(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3.default)(this, ModalTitle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2.default.Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(628);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(599);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2.default.any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2.default.string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2.default.bool,
	
	  justified: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2.default.bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2.default.bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    onSelect: _propTypes2.default.func
	  }),
	
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any,
	    onSelect: _propTypes2.default.func.isRequired,
	    getTabId: _propTypes2.default.func.isRequired,
	    getPaneId: _propTypes2.default.func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3.default)(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3.default)(this, Nav);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2.default.find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2.default.toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2.default.findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2.default.find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2.default)(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2.default.codes.left:
	      case _keycode2.default.codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2.default.codes.right:
	      case _keycode2.default.codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends4.default)({}, elementProps, {
	        role: role,
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2.default)(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4.default)({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2.default.Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(630);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(657);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(704);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(705);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(706);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(707);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes2.default.bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes2.default.bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes2.default.bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes2.default.bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes2.default.bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2.default,
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
	   * boolean value.
	   *
	   * @controllable expanded
	   */
	  onToggle: _propTypes2.default.func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes2.default.func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes2.default.bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes2.default.bool,
	
	  role: _propTypes2.default.string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool,
	    onToggle: _propTypes2.default.func.isRequired,
	    onSelect: _propTypes2.default.func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3.default)(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3.default)(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2.default)(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3.default)(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends4.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement(
	        _Grid2.default,
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2.default.Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2.default)(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2.default.createElement(Component, (0, _extends4.default)({}, props, {
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2.default,
	    pullRight: _propTypes2.default.bool,
	    pullLeft: _propTypes2.default.bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes2.default.shape({
	      bsClass: _propTypes2.default.string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2.default;
	UncontrollableNavbar.Header = _NavbarHeader2.default;
	UncontrollableNavbar.Toggle = _NavbarToggle2.default;
	UncontrollableNavbar.Collapse = _NavbarCollapse2.default;
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports.default = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3.default)(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3.default)(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2.default.isValidElement(children)) {
	      return _react2.default.cloneElement(children, {
	        className: (0, _classnames2.default)(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, props, { className: (0, _classnames2.default)(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2.default.Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports.default = NavbarBrand;
	module.exports = exports['default'];

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(611);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3.default)(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3.default)(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2.default.createElement(
	      _Collapse2.default,
	      (0, _extends3.default)({ 'in': navbarProps.expanded }, props),
	      _react2.default.createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2.default.Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports.default = NavbarCollapse;
	module.exports = exports['default'];

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3.default)(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3.default)(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: (0, _classnames2.default)(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2.default.Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports.default = NavbarHeader;
	module.exports = exports['default'];

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onClick: _propTypes2.default.func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes2.default.node
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool,
	    onToggle: _propTypes2.default.func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3.default)(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3.default)(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3.default)({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2.default)(onClick, navbarProps.onToggle),
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2.default.createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2.default.createElement(
	      'button',
	      buttonProps,
	      _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2.default.createElement('span', { className: 'icon-bar' }),
	      _react2.default.createElement('span', { className: 'icon-bar' }),
	      _react2.default.createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2.default.Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports.default = NavbarToggle;
	module.exports = exports['default'];

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(624);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(650);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  title: _propTypes2.default.node.isRequired,
	  noCaret: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3.default)(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3.default)(this, NavDropdown);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2.default.some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2.default)(className, { active: active }),
	        style: style
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Toggle,
	        (0, _extends3.default)({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        _ValidComponentChildren2.default.map(children, function (child) {
	          return _react2.default.cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2.default.Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports.default = NavDropdown;
	module.exports = exports['default'];

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(594);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  eventKey: _propTypes2.default.any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3.default)(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3.default)(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2.default.createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2.default.Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports.default = NavItem;
	module.exports = exports['default'];

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__(711);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(651);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Overlay2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2.default,
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3.default)(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2.default : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2.default)(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2.default.createElement(
	      _Overlay2.default,
	      (0, _extends3.default)({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(692);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(712);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(643);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleHidden = function () {
	      _this.setState({ exited: true });
	
	      if (_this.props.onExited) {
	        var _this$props;
	
	        (_this$props = _this.props).onExited.apply(_this$props, arguments);
	      }
	    };
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        container = _props.container,
	        containerPadding = _props.containerPadding,
	        target = _props.target,
	        placement = _props.placement,
	        shouldUpdatePosition = _props.shouldUpdatePosition,
	        rootClose = _props.rootClose,
	        children = _props.children,
	        Transition = _props.transition,
	        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	    // Don't un-render the overlay while it's transitioning out.
	
	
	    var mountOverlay = props.show || Transition && !this.state.exited;
	    if (!mountOverlay) {
	      // Don't bother showing anything if we don't have to.
	      return null;
	    }
	
	    var child = children;
	
	    // Position is be inner-most because it adds inline styles into the child,
	    // which the other wrappers don't forward correctly.
	    child = _react2.default.createElement(
	      _Position2.default,
	      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	      child
	    );
	
	    if (Transition) {
	      var onExit = props.onExit,
	          onExiting = props.onExiting,
	          onEnter = props.onEnter,
	          onEntering = props.onEntering,
	          onEntered = props.onEntered;
	
	      // This animates the child node by injecting props, so it must precede
	      // anything that adds a wrapping div.
	
	      child = _react2.default.createElement(
	        Transition,
	        {
	          'in': props.show,
	          transitionAppear: true,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.onHiddenListener,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        child
	      );
	    }
	
	    // This goes after everything else because it adds a wrapping div.
	    if (rootClose) {
	      child = _react2.default.createElement(
	        _RootCloseWrapper2.default,
	        { onRootClose: props.onHide },
	        child
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { container: container },
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _propTypes2.default.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(682);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _calculatePosition = __webpack_require__(713);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(693);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(646);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.getTarget = function () {
	      var target = _this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    };
	
	    _this.maybeUpdatePosition = function (placementChanged) {
	      var target = _this.getTarget();
	
	      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      _this.updatePosition(target);
	    };
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  Position.prototype.componentDidMount = function componentDidMount() {
	    this.updatePosition(this.getTarget());
	  };
	
	  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needsFlush = true;
	  };
	
	  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this._needsFlush) {
	      this._needsFlush = false;
	      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	    }
	  };
	
	  Position.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    var _state = this.state,
	        positionLeft = _state.positionLeft,
	        positionTop = _state.positionTop,
	        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	    // These should not be forwarded to the child.
	
	
	    delete props.target;
	    delete props.container;
	    delete props.containerPadding;
	    delete props.shouldUpdatePosition;
	
	    var child = _react2.default.Children.only(children);
	    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	      // and `props.style`.
	      positionLeft: positionLeft,
	      positionTop: positionTop,
	      className: (0, _classnames2.default)(className, child.props.className),
	      style: _extends({}, child.props.style, {
	        left: positionLeft,
	        top: positionTop
	      })
	    }));
	  };
	
	  Position.prototype.updatePosition = function updatePosition(target) {
	    this._lastTarget = target;
	
	    if (!target) {
	      this.setState({
	        positionLeft: 0,
	        positionTop: 0,
	        arrowOffsetLeft: null,
	        arrowOffsetTop: null
	      });
	
	      return;
	    }
	
	    var overlay = _reactDom2.default.findDOMNode(this);
	    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	  };
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _propTypes2.default.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _propTypes2.default.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(714);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(715);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(717);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(646);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(627));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(690));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(626));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(438));
	
	var _offset = _interopRequireDefault(__webpack_require__(714));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(716));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(717));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(718));
	
	var _style = _interopRequireDefault(__webpack_require__(612));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(626));
	
	var _style = _interopRequireDefault(__webpack_require__(612));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(690));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(428);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(690));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(627);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(710);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2.default.oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3.default)({}, _Overlay2.default.propTypes, {
	
	  /**
	   * Specify which action or actions trigger Overlay visibility
	   */
	  trigger: _propTypes2.default.oneOfType([triggerType, _propTypes2.default.arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2.default.number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2.default.number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2.default.number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2.default.bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2.default.node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2.default.oneOf([null]),
	  /**
	   * @private
	   */
	  onHide: _propTypes2.default.oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2.default.oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3.default)(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3.default)(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2.default.unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this2 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this2._hoverHideDelay = null;
	      _this2.hide();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this3 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this3._hoverShowDelay = null;
	      _this3.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if ((!related || related !== target) && !(0, _contains2.default)(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2.default.createElement(
	      _Overlay2.default,
	      (0, _extends3.default)({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3.default)(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2.default.Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2.default)(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2.default)(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2.default)(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2.default)(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2.default)(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2.default)(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2.default)(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2.default.Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports.default = OverlayTrigger;
	module.exports = exports['default'];

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3.default)(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3.default)(this, PageHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(722);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(723);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _deprecationWarning2.default.wrapper(_PagerItem2.default, '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(594);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  previous: _propTypes2.default.bool,
	  next: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  eventKey: _propTypes2.default.any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3.default)(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3.default)(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2.default.createElement(
	      'li',
	      {
	        className: (0, _classnames2.default)(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2.default.Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports.default = PagerItem;
	module.exports = exports['default'];

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(534);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3.default)(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2.default)(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3.default)(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3.default)(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports.default = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__(722);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2.default.func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3.default)(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3.default)(this, Pager);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2.default.Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(726);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  activePage: _propTypes2.default.number,
	  items: _propTypes2.default.number,
	  maxButtons: _propTypes2.default.number,
	
	  /**
	   * When `true`, will display the first and the last button page when
	   * displaying ellipsis.
	   */
	  boundaryLinks: _propTypes2.default.bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2.default
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3.default)(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3.default)(this, Pagination);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	
	    if (maxButtons && maxButtons < items) {
	      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
	      endPage = startPage + maxButtons - 1;
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var page = startPage; page <= endPage; ++page) {
	      pageButtons.push(_react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          key: page,
	          eventKey: page,
	          active: page === activePage
	        }),
	        page
	      ));
	    }
	
	    if (ellipsis && boundaryLinks && startPage > 1) {
	      if (startPage > 2) {
	        pageButtons.unshift(_react2.default.createElement(
	          _PaginationButton2.default,
	          {
	            key: 'ellipsisFirst',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2.default.createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      pageButtons.unshift(_react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (ellipsis && endPage < items) {
	      if (!boundaryLinks || endPage < items - 1) {
	        pageButtons.push(_react2.default.createElement(
	          _PaginationButton2.default,
	          {
	            key: 'ellipsis',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2.default.createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      if (boundaryLinks) {
	        pageButtons.push(_react2.default.createElement(
	          _PaginationButton2.default,
	          (0, _extends3.default)({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      first && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2.default.Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(594);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2.default,
	  className: _propTypes2.default.string,
	  eventKey: _propTypes2.default.any,
	  onSelect: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2.default,
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3.default)(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3.default)(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2.default) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2.default.createElement(
	      'li',
	      {
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2.default.Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports.default = PaginationButton;
	module.exports = exports['default'];

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(587);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(611);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2.default.bool,
	  onSelect: _propTypes2.default.func,
	  header: _propTypes2.default.node,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  footer: _propTypes2.default.node,
	  defaultExpanded: _propTypes2.default.bool,
	  expanded: _propTypes2.default.bool,
	  eventKey: _propTypes2.default.any,
	  headerRole: _propTypes2.default.string,
	  panelRole: _propTypes2.default.string,
	
	  // From Collapse.
	  onEnter: _propTypes2.default.func,
	  onEntering: _propTypes2.default.func,
	  onEntered: _propTypes2.default.func,
	  onExit: _propTypes2.default.func,
	  onExiting: _propTypes2.default.func,
	  onExited: _propTypes2.default.func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3.default)(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3.default)(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2.default.createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2.default.createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2.default.Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2.default.isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2.default.createElement(
	      _Collapse2.default,
	      (0, _extends3.default)({ 'in': expanded }, animationHooks),
	      _react2.default.createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2.default.isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2.default)(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2.default.isValidElement(header)) {
	      return _react2.default.createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2.default)(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3.default)(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2.default.Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(629);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes2.default.node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3.default)(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3.default)(this, Popover);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4.default)({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2.default)(className, classes),
	        style: outerStyle
	      }),
	      _react2.default.createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2.default.createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2.default.Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(587);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2.default.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes2.default.number,
	  now: _propTypes2.default.number,
	  max: _propTypes2.default.number,
	  label: _propTypes2.default.node,
	  srOnly: _propTypes2.default.bool,
	  striped: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3.default)(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3.default)(this, ProgressBar);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2.default)(className, classes),
	        style: (0, _extends4.default)({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3.default)(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3.default)(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, wrapperProps, {
	        className: (0, _classnames2.default)(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2.default.Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  inline: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/label-has-for */
	
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3.default)(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3.default)(this, Radio);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2.default.createElement('input', (0, _extends3.default)({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2.default)(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2.default.createElement(
	        'label',
	        { className: (0, _classnames2.default)(className, _classes), style: style, title: title },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(className, classes), style: style },
	      _react2.default.createElement(
	        'label',
	        { title: title },
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2.default.Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes2.default.element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes2.default.bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3.default)(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3.default)(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2.default)(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2.default.Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3.default)(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3.default)(this, Row);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2.default.Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(597);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(624);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(734);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(650);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2.default.string,
	  bsSize: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes2.default.node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes2.default.string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3.default)(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3.default)(this, SplitButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2.default.createElement(_SplitToggle2.default, {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2.default.Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2.default;
	
	exports.default = SplitButton;
	module.exports = exports['default'];

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(647);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3.default)(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3.default)(this, SplitToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2.default.createElement(_DropdownToggle2.default, (0, _extends3.default)({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2.default.Component);
	
	SplitToggle.defaultProps = _DropdownToggle2.default.defaultProps;
	
	exports.default = SplitToggle;
	module.exports = exports['default'];

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(736);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(737);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(738);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _TabPane2.default.propTypes, {
	
	  disabled: _propTypes2.default.bool,
	
	  title: _propTypes2.default.node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2.default.string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3.default)(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3.default)(this, Tab);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3.default)({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2.default.createElement(_TabPane2.default, props);
	  };
	
	  return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2.default;
	Tab.Content = _TabContent2.default;
	Tab.Pane = _TabPane2.default;
	
	exports.default = Tab;
	module.exports = exports['default'];

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(630);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2.default.func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2.default.any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any,
	    onSelect: _propTypes2.default.func.isRequired,
	    getTabId: _propTypes2.default.func.isRequired,
	    getPaneId: _propTypes2.default.func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3.default)(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3.default)(this, TabContainer);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2.default.cloneElement(_react2.default.Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2.default.Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports.default = (0, _uncontrollable2.default)(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	    activeKey: _propTypes2.default.any,
	    mountOnEnter: _propTypes2.default.bool,
	    unmountOnExit: _propTypes2.default.bool,
	    onPaneEnter: _propTypes2.default.func.isRequired,
	    onPaneExited: _propTypes2.default.func.isRequired,
	    exiting: _propTypes2.default.bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3.default)(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3.default)(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2.default.Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(595);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(358);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(651);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2.default.any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /** @private * */
	  id: _propTypes2.default.string,
	
	  /** @private * */
	  'aria-labelledby': _propTypes2.default.string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2.default.string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    getTabId: _propTypes2.default.func,
	    getPaneId: _propTypes2.default.func
	  }),
	  $bs_tabContent: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	    activeKey: _propTypes2.default.any,
	    mountOnEnter: _propTypes2.default.bool,
	    unmountOnExit: _propTypes2.default.bool,
	    onPaneEnter: _propTypes2.default.func.isRequired,
	    onPaneExited: _propTypes2.default.func.isRequired,
	    exiting: _propTypes2.default.bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2.default.oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3.default)(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3.default)(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this.in = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.in) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.in) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this.in = false;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3.default)(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2.default : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2.default.createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2.default)(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2.default)(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2.default.Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  striped: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  condensed: _propTypes2.default.bool,
	  hover: _propTypes2.default.bool,
	  responsive: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3.default)(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3.default)(this, Table);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2.default.createElement('table', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2.default.Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(629);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(630);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(702);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(709);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(736);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(737);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabContainer = _TabContainer2.default.ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2.default.any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2.default.oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2.default.bool,
	
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   *   Any eventKey,
	   *   SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2.default.forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3.default)(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3.default)(this, Tabs);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      _NavItem2.default,
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3.default)(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2.default.createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Nav2.default,
	          (0, _extends3.default)({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2.default.map(children, this.renderTab)
	        ),
	        _react2.default.createElement(
	          _TabContent2.default,
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports.default = (0, _uncontrollable2.default)(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(594);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * src property that is passed down to the image inside this component
	   */
	  src: _propTypes2.default.string,
	  /**
	   * alt property that is passed down to the image inside this component
	   */
	  alt: _propTypes2.default.string,
	  /**
	   * href property that is passed down to the image inside this component
	   */
	  href: _propTypes2.default.string,
	  /**
	   * onError callback that is passed down to the image inside this component
	   */
	  onError: _propTypes2.default.func,
	  /**
	   * onLoad callback that is passed down to the image inside this component
	   */
	  onLoad: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/alt-text */
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3.default)(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3.default)(this, Thumbnail);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        onError = _props.onError,
	        onLoad = _props.onLoad,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['src', 'alt', 'onError', 'onLoad', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2.default : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement('img', { src: src, alt: alt, onError: onError, onLoad: onLoad }),
	      children && _react2.default.createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2.default.Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(597);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * The `<input>` `type`
	   * @type {[type]}
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']),
	
	  /**
	   * The HTML input name, used to group like checkboxes or radio buttons together
	   * semantically
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
	   */
	  checked: _propTypes2.default.bool,
	
	  /**
	   * The disabled state of both the label and input
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * [onChange description]
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * The value of the input, and unique identifier in the ToggleButtonGroup
	   */
	  value: _propTypes2.default.any.isRequired
	};
	
	var ToggleButton = function (_React$Component) {
	  (0, _inherits3.default)(ToggleButton, _React$Component);
	
	  function ToggleButton() {
	    (0, _classCallCheck3.default)(this, ToggleButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ToggleButton.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        name = _props.name,
	        checked = _props.checked,
	        type = _props.type,
	        onChange = _props.onChange,
	        value = _props.value,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children', 'name', 'checked', 'type', 'onChange', 'value']);
	
	    var disabled = props.disabled;
	
	    return _react2.default.createElement(
	      _Button2.default,
	      (0, _extends3.default)({}, props, {
	        active: !!checked,
	        componentClass: 'label'
	      }),
	      _react2.default.createElement('input', {
	        name: name,
	        type: type,
	        autoComplete: 'off',
	        value: value,
	        checked: !!checked,
	        disabled: !!disabled,
	        onChange: onChange
	      }),
	      children
	    );
	  };
	
	  return ToggleButton;
	}(_react2.default.Component);
	
	ToggleButton.propTypes = propTypes;
	
	exports.default = ToggleButton;
	module.exports = exports['default'];

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(352);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _uncontrollable = __webpack_require__(630);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _createChainedFunction = __webpack_require__(584);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(585);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	var _ButtonGroup = __webpack_require__(598);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _ToggleButton = __webpack_require__(742);
	
	var _ToggleButton2 = _interopRequireDefault(_ToggleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An HTML `<input>` name for each child button.
	   *
	   * __Required if `type` is set to `'radio'`__
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * The value, or array of values, of the active (pressed) buttons
	   *
	   * @controllable onChange
	   */
	  value: _propTypes2.default.any,
	
	  /**
	   * Callback fired when a button is pressed, depending on whether the `type`
	   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
	   * array of active values
	   *
	   * @controllable values
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * The input `type` of the rendered buttons, determines the toggle behavior
	   * of the buttons
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']).isRequired
	};
	
	var defaultProps = {
	  type: 'radio'
	};
	
	var ToggleButtonGroup = function (_React$Component) {
	  (0, _inherits3.default)(ToggleButtonGroup, _React$Component);
	
	  function ToggleButtonGroup() {
	    (0, _classCallCheck3.default)(this, ToggleButtonGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ToggleButtonGroup.prototype.getValues = function getValues() {
	    var value = this.props.value;
	
	    return value == null ? [] : [].concat(value);
	  };
	
	  ToggleButtonGroup.prototype.handleToggle = function handleToggle(value) {
	    var _props = this.props,
	        type = _props.type,
	        onChange = _props.onChange;
	
	    var values = this.getValues();
	    var isActive = values.indexOf(value) !== -1;
	
	    if (type === 'radio') {
	      if (!isActive) {
	        onChange(value);
	      }
	      return;
	    }
	
	    if (isActive) {
	      onChange(values.filter(function (n) {
	        return n !== value;
	      }));
	    } else {
	      onChange([].concat(values, [value]));
	    }
	  };
	
	  ToggleButtonGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        children = _props2.children,
	        type = _props2.type,
	        name = _props2.name,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['children', 'type', 'name']);
	
	
	    var values = this.getValues();
	
	    !(type !== 'radio' || !!name) ?  false ? (0, _invariant2.default)(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : (0, _invariant2.default)(false) : void 0;
	
	    delete props.onChange;
	    delete props.value;
	
	    // the data attribute is required b/c twbs css uses it in the selector
	    return _react2.default.createElement(
	      _ButtonGroup2.default,
	      (0, _extends3.default)({}, props, { 'data-toggle': 'buttons' }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var _child$props = child.props,
	            value = _child$props.value,
	            onChange = _child$props.onChange;
	
	        var handler = function handler() {
	          return _this2.handleToggle(value);
	        };
	
	        return _react2.default.cloneElement(child, {
	          type: type,
	          name: child.name || name,
	          checked: values.indexOf(value) !== -1,
	          onChange: (0, _createChainedFunction2.default)(onChange, handler)
	        });
	      })
	    );
	  };
	
	  return ToggleButtonGroup;
	}(_react2.default.Component);
	
	ToggleButtonGroup.propTypes = propTypes;
	ToggleButtonGroup.defaultProps = defaultProps;
	
	var UncontrolledToggleButtonGroup = (0, _uncontrollable2.default)(ToggleButtonGroup, {
	  value: 'onChange'
	});
	
	UncontrolledToggleButtonGroup.Button = _ToggleButton2.default;
	
	exports.default = UncontrolledToggleButtonGroup;
	module.exports = exports['default'];

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(493);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(629);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3.default)(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3.default)(this, Tooltip);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4.default)({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2.default)(className, classes),
	        style: outerStyle
	      }),
	      _react2.default.createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2.default.Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(493);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(576);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(532);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(533);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(567);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(577);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(578);
	
	var _StyleConfig = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3.default)(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3.default)(this, Well);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(578);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(584);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(585);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3.default;
	exports.ValidComponentChildren = _ValidComponentChildren3.default;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.setShouldReloadData = setShouldReloadData;
	exports.setDirty = setDirty;
	exports.setActiveOrder = setActiveOrder;
	exports.checkIsDirty = checkIsDirty;
	exports.showDirtyModal = showDirtyModal;
	exports.updateClientViewPort = updateClientViewPort;
	exports.getCouponData = getCouponData;
	exports.parseCouponData = parseCouponData;
	exports.checkVersion = checkVersion;
	exports.setAndRemoveUrlParams = setAndRemoveUrlParams;
	exports.clearHiddenUrlParams = clearHiddenUrlParams;
	
	var _utils = __webpack_require__(485);
	
	var _actionTypes = __webpack_require__(459);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _constants = __webpack_require__(463);
	
	var _staticDataActions = __webpack_require__(749);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	function setShouldReloadData(shouldReloadData) {
	    return {
	        type: _actionTypes.SET_SHOULD_RELOAD_DATA,
	        shouldReloadData: shouldReloadData
	    };
	}
	function setDirty(dirty) {
	    return {
	        type: _actionTypes.SET_DIRTY,
	        dirty: dirty
	    };
	}
	function setActiveOrder(activeOrder, shouldReloadData) {
	    return {
	        type: _actionTypes.SET_ACTIVE_ORDER,
	        activeOrder: activeOrder,
	        shouldReloadData: shouldReloadData
	    };
	}
	function checkIsDirty(onLeaveCallBack) {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (state.orderStatus.isChanged) dispatch(showDirtyModal(true, onLeaveCallBack));else onLeaveCallBack();
	    };
	}
	function showDirtyModal(show, onLeaveCallBack) {
	    return {
	        type: _actionTypes.SHOW_DIRTY_MODAL,
	        show: show,
	        onLeaveCallBack: onLeaveCallBack
	    };
	}
	
	function updateClientViewPort(visible) {
	    return {
	        type: _actionTypes.UPDATE_CLIENT_VIEW_PORT,
	        visible: visible
	    };
	}
	function getCouponData(couponId, setCoupon) {
	    return function (dispatch, getState) {
	        var fetchUrl = '/dispatcher/WebStoreService.getCouponDiscount';
	        var state = getState();
	        var data = {
	            farmKey: state.staticData.farmKey,
	            seasonKey: state.staticData.seasonKey,
	            couponId: couponId
	        };
	        if ((state.summary || {}).key) {
	            data["subscriptionKey"] = state.summary.key;
	        }
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.VALIDATE_COUPON));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            return parseCouponData(json);
	        }).then(function (couponData) {
	            return dispatch(setCoupon(couponData));
	        }).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function parseCouponData(json, existingCoupon) {
	    if (!json || !json.id) return { valid: false };
	    return {
	        valid: true,
	        key: json.key,
	        id: json.id,
	        discount: json.discount,
	        isFixedAmount: json.isFixedAmount,
	        minimumOrder: json.minimumOrder,
	        firstOrderUse: json.firstOrderUse,
	        useMinimumOrder: json.useMinimumOrder,
	        validationType: json.validationType,
	        couponType: json.couponType,
	        calculateOptions: json.calculateOptions,
	        existingCoupon: existingCoupon
	    };
	}
	
	function checkVersion() {
	    return function (dispatch, getState) {
	        var timeout = 1000 * 60 * 60 * 6;
	        window.setTimeout(function () {
	            var state = getState();
	            var timestamp = new Date().getTime();
	            if (timestamp - state.clientViewPort.lastChange < 1000 * 60 * 30) {
	                dispatch(checkVersion());
	                return;
	            }
	            var fetchUrl = '/dispatcher/WebStoreService.getVersion';
	            var data = {
	                farmKey: state.staticData.farmKey,
	                memberKey: state.memberDetails ? state.memberDetails.key : null
	            };
	            return (0, _utils.ajax)(fetchUrl, data).then(function (version) {
	                if (version != state.staticData.version) dispatch((0, _fetchingActions.errorFetching)(new Error(_constants.OLD_VERSION_MESSAGE)));
	                dispatch(checkVersion());
	            }).catch();
	        }, timeout);
	    };
	}
	
	function setAndRemoveUrlParams(onlyHidden) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var params = (0, _utils.getUrlParams)();
	        var urlParams = (state.staticData || {}).params || {};
	        var paramsFound = false;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = Object.entries(params)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var _step$value = _slicedToArray(_step.value, 2),
	                    key = _step$value[0],
	                    value = _step$value[1];
	
	                if (!onlyHidden || ['error', 'message'].includes(key)) {
	                    urlParams[key] = value;
	                    delete params[key];
	                    paramsFound = true;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        if (paramsFound) {
	            dispatch((0, _staticDataActions.setUrlParams)(urlParams));
	            var queryString = Object.keys(params).length === 0 ? '' : '?' + Object.entries(params).map(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    key = _ref2[0],
	                    value = _ref2[1];
	
	                return key + '=' + value;
	            }).join('&');
	            dispatch((0, _reactRouterRedux.replace)(location.pathname + queryString));
	        }
	    };
	}
	
	function clearHiddenUrlParams() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var urlParams = (state.staticData || {}).params || {};
	        var hiddenFound = false;
	        ['error', 'message'].forEach(function (key) {
	            delete urlParams[key];
	            hiddenFound = true;
	        });
	        if (hiddenFound) {
	            dispatch((0, _staticDataActions.setUrlParams)(urlParams));
	        }
	    };
	}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isFetching = isFetching;
	exports.fetchingData = fetchingData;
	exports.dataFetched = dataFetched;
	exports.errorFetching = errorFetching;
	exports.retryFetching = retryFetching;
	exports.clearError = clearError;
	
	var _actionTypes = __webpack_require__(459);
	
	var _constants = __webpack_require__(463);
	
	var constants = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var suppressErrorList = [constants.GENERIC_ERROR_MESSAGE, "Out of memory", "Network request failed", "Failed to fetch", "NetworkError when attempting to fetch resource.", "Communication Error. Please Try again", constants.UNAUTHORIZED_ACTION, constants.NO_COOKIE_CREATE, constants.NO_COOKIE_LOGIN, constants.CIM_NOT_ENABLED, "failed during invocation of WebStoreService", "The Details you provided failed authentication", "Forbidden"];
	var reloadingWindowErrors = [constants.UNAUTHORIZED_ACTION, constants.ORDER_KEY_CHANGED, constants.PICKUP_SITE_KEY_CHANGED, constants.GEOCODE_ERROR, constants.SUBSCRIPTION_EXISTS_ERROR_MESSAGE, constants.GOOGLE_UNDEFINED_ERROR_MESSAGE, constants.OPERATION_ABORTED_ERROR_MESSAGE, "Can't delete order", constants.OLD_VERSION_MESSAGE];
	
	function isFetching(state, type) {
	    if (!state.fetching.isFetching) return false;
	    if (state.fetching.fetchingType === constants.FetchingTypes.LOG_OUT) return true;
	    if (type) return state.fetching.fetchingType === type;
	    return true;
	}
	function fetchingData(fetchingType) {
	    return {
	        type: _actionTypes.FETCHING_DATA,
	        fetchingType: fetchingType
	    };
	}
	
	function dataFetched(fetchingType) {
	    return {
	        type: _actionTypes.DATA_FETCHED,
	        fetchingType: fetchingType
	    };
	}
	
	function errorFetching(error, retryAction, suppressError) {
	    if (suppressErrorList.includes(error) || suppressErrorList.includes(error.message) || error.suppress) suppressError = true;
	    if (reloadingWindowErrors.includes(error) || reloadingWindowErrors.includes(error.message)) {
	        suppressError = true;
	        retryAction = { action: reloadWindow, args: [], label: "Reload" };
	    }
	    if (!suppressError) {
	        console.error(error);
	        if (typeof Raven !== 'undefined') Raven.captureException(error);
	    }
	    return {
	        type: _actionTypes.ERROR_FETCHING,
	        error: error,
	        retryAction: retryAction
	    };
	}
	
	function retryFetching() {
	    return function (dispatch, getState) {
	        var retryAction = getState().fetching.error.retryAction;
	        if (retryAction) dispatch(retryAction.action.apply(null, retryAction.args));
	    };
	}
	
	function clearError() {
	    return {
	        type: _actionTypes.CLEAR_ERROR
	    };
	}
	
	function reloadWindow() {
	    return function () {
	        window.location.reload(true);
	    };
	}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initServerStaticData = initServerStaticData;
	exports.setUrlParams = setUrlParams;
	
	var _actionTypes = __webpack_require__(459);
	
	function initServerStaticData() {
	    return {
	        type: _actionTypes.INITIAL_SERVER_DATA
	    };
	}
	
	function setUrlParams(params) {
	    return {
	        type: _actionTypes.SET_URL_PARAMS,
	        params: params
	    };
	}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setStatus = setStatus;
	exports.setForgetPassword = setForgetPassword;
	exports.setResetPasswordEmailSent = setResetPasswordEmailSent;
	exports.setShowCreateFBAccount = setShowCreateFBAccount;
	exports.resetStatus = resetStatus;
	exports.setChangePassword = setChangePassword;
	exports.login = login;
	exports.loginWithEmail = loginWithEmail;
	exports.forgetPassword = forgetPassword;
	exports.loginWithFacebook = loginWithFacebook;
	exports.logOut = logOut;
	exports.activateFacebook = activateFacebook;
	exports.changePassword = changePassword;
	exports.resetEmailSent = resetEmailSent;
	exports.createFacebookMember = createFacebookMember;
	exports.getSubscriptionStatus = getSubscriptionStatus;
	exports.showFBErrorMessage = showFBErrorMessage;
	exports.setEnableFbButton = setEnableFbButton;
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _utils = __webpack_require__(485);
	
	var _actionTypes = __webpack_require__(459);
	
	var _memberDetailsActions = __webpack_require__(751);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _constants = __webpack_require__(463);
	
	var _joinActions = __webpack_require__(752);
	
	var _messagePageActions = __webpack_require__(760);
	
	var OK_STATUSES = ['Ok', 'OkExistingForFarm'];
	function setStatus(status) {
	    return {
	        type: _actionTypes.LOG_IN_STATUS,
	        status: status
	    };
	}
	
	function setForgetPassword(isForgetPassword) {
	    return {
	        type: _actionTypes.FORGET_PASSWORD,
	        isForgetPassword: isForgetPassword
	    };
	}
	
	function setResetPasswordEmailSent(isResetPasswordEmailSent) {
	    return {
	        type: _actionTypes.RESET_PASSWORD_EMAIL_SENT,
	        isResetPasswordEmailSent: isResetPasswordEmailSent
	    };
	}
	
	function setShowCreateFBAccount(showCreateFBAccount, email) {
	    return {
	        type: _actionTypes.SHOW_FACEBOOK_POPUP,
	        showCreateFBAccount: showCreateFBAccount,
	        email: email
	    };
	}
	
	function resetStatus() {
	    return {
	        type: _actionTypes.RESET_STATUS
	    };
	}
	
	function setChangePassword(isNeedToChangePassword) {
	    return {
	        type: _actionTypes.CHANGE_PASSWORD,
	        isNeedToChangePassword: isNeedToChangePassword
	    };
	}
	
	function login() {
	    return function (dispatch) {
	        dispatch((0, _reactRouterRedux.replace)((0, _utils.addPath)('login')));
	    };
	}
	
	function loginWithEmail(email, password) {
	    return function (dispatch, getState) {
	        if (!dispatch(validateEmailInput(email))) {
	            return;
	        }
	        if (!password || password === "") {
	            dispatch(setStatus({ status: 'MissingPassword' }));
	        } else {
	            var fetchUrl = '/dispatcher/AuthenticationService.signin';
	            var data = { farmKey: getState().staticData.farmKey, email: email, password: password };
	            dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOGIN));
	            return (0, _utils.ajax)(fetchUrl, data).then(function (loginStatus) {
	                if (OK_STATUSES.includes(loginStatus.status) && !document.cookie.includes("farmigoMember")) {
	                    dispatch(recordCookie(email));
	                    throw new Error(_constants.NO_COOKIE_LOGIN);
	                }
	                dispatch(setMemberOnServerData(loginStatus));
	                dispatch(setStatus(loginStatus));
	                if (OK_STATUSES.includes(loginStatus.status)) {
	                    if (window.location.pathname.endsWith('login')) {
	                        window.location.reload();
	                    } else if (window.location.pathname.startsWith('/' + _constants.URLs.JOIN)) {
	                        dispatch((0, _memberDetailsActions.setShowPassword)(false));
	                        dispatch((0, _joinActions.setCreateAccountPage)(_constants.JoinCreateAccountConstants.CONTACT_DETAILS, true));
	                        var member = loginStatus.member;
	                        dispatch(getSubscriptionStatus(member.key));
	                    }
	                } else if (loginStatus.status === 'ChangePassword') {
	                    dispatch(resetStatus());
	                    dispatch(setChangePassword(true));
	                }
	                dispatch((0, _fetchingActions.dataFetched)(_constants.FetchingTypes.LOGIN));
	            }).catch(function (error) {
	                return dispatch((0, _fetchingActions.errorFetching)(error));
	            });
	        }
	    };
	}
	
	function recordCookie(email) {
	    return function (dispatch, getState) {
	        var fetchUrl = '/dispatcher/WebStoreService.recordCookie';
	        var data = { farmKey: getState().staticData.farmKey, email: email };
	        return (0, _utils.ajax)(fetchUrl, data);
	    };
	}
	
	function validateEmailInput(email) {
	    return function (dispatch) {
	        if (!email || email === "") {
	            dispatch(setStatus({ status: 'MissingEmail' }));
	            return false;
	        } else if (!(0, _utils.validateEmail)(email)) {
	            dispatch(setStatus({ status: 'InvalidEmail' }));
	            return false;
	        }
	        return true;
	    };
	}
	
	function forgetPassword(email) {
	    return function (dispatch, getState) {
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOGIN));
	        if (!dispatch(validateEmailInput(email))) {
	            dispatch((0, _fetchingActions.dataFetched)());
	            return;
	        }
	        var fetchUrl = '/dispatcher/MembersService.forgotPassword';
	        var data = { farmKey: getState().staticData.farmKey, email: email };
	        return (0, _utils.ajax)(fetchUrl, data).then(function (status) {
	            dispatch(setStatus(status));
	            if (OK_STATUSES.includes(status.status)) {
	                dispatch(setResetPasswordEmailSent(true));
	            }
	        }).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        });
	    };
	}
	
	function loginWithFacebook(email, facebookId, remember, sourceRequestUrl) {
	    return function (dispatch, getState) {
	        var fetchUrl = '/dispatcher/AuthenticationService.facebookAuthenticate';
	        var data = {
	            farmKey: getState().staticData.farmKey,
	            email: email,
	            facebookId: facebookId,
	            remember: remember,
	            sourceRequestUrl: sourceRequestUrl
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOGIN));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (loginStatus) {
	            if (OK_STATUSES.includes(loginStatus.status)) {
	                dispatch(setStatus(loginStatus));
	                var member = loginStatus.member;
	                member['isFBLogin'] = true;
	                loginStatus.member = member;
	                dispatch(setMemberOnServerData(loginStatus));
	                if (window.location.pathname.endsWith('login')) {
	                    window.location.reload();
	                    dispatch((0, _fetchingActions.dataFetched)());
	                } else if (window.location.pathname.startsWith('/' + _constants.URLs.JOIN)) {
	                    dispatch((0, _memberDetailsActions.setShowPassword)(false));
	                    dispatch(getSubscriptionStatus(member.key));
	                }
	            } else {
	                dispatch(setShowCreateFBAccount(true, email));
	                dispatch((0, _fetchingActions.dataFetched)());
	            }
	        });
	    };
	}
	
	function logOut(memberKey) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/AuthenticationService.signout';
	        var data = { farmKey: state.staticData.farmKey, memberKey: memberKey ? memberKey : state.memberDetails.key };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOG_OUT));
	        return (0, _utils.ajax)(fetchUrl, data).then(function () {
	            if ((0, _subscriptionSummaryActions.isAddSubscription)()) {
	                window.location.assign((0, _utils.redirectPage)(_constants.URLs.ACCOUNT, state.staticData));
	            } else {
	                dispatch((0, _reactRouterRedux.replace)((0, _utils.signOutPath)()));
	                window.location.reload();
	            }
	        });
	    };
	}
	
	function setMemberOnServerData(json) {
	    return function (dispatch) {
	        if (OK_STATUSES.includes(json.status)) {
	            dispatch((0, _memberDetailsActions.setMemberData)(json.member));
	        } else {
	            dispatch((0, _memberDetailsActions.setMemberData)(null));
	        }
	    };
	}
	
	function activateFacebook(email, password, facebookAppId) {
	    return function (dispatch) {
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOGIN));
	        if (!dispatch(validateEmailInput(email))) {
	            dispatch((0, _fetchingActions.dataFetched)());
	            return;
	        }
	        var fetchUrl = '/dispatcher/MembersService.activateFacebook';
	        var data = {
	            email: email,
	            password: password,
	            facebookId: facebookAppId, remember: true
	        };
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            json.facebookId = facebookAppId;
	            dispatch(setStatus(json));
	            dispatch(setMemberOnServerData(json));
	            if (json === 'Ok' || OK_STATUSES.includes(json.status)) {
	                window.location.reload();
	            }
	        }).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        });
	    };
	}
	
	function changePassword(email, password, newPassword) {
	    return function (dispatch, getState) {
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOGIN));
	        if (!dispatch(validateEmailInput(email))) {
	            dispatch((0, _fetchingActions.dataFetched)());
	            return;
	        }
	        var fetchUrl = '/dispatcher/AuthenticationService.changePassword';
	        var data = { farmKey: getState().staticData.farmKey, email: email, password: password, newPassword: newPassword, remember: true };
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            dispatch(setMemberOnServerData(json));
	            return json;
	        }).then(function (response) {
	            dispatch(setStatus(response));
	            if (OK_STATUSES.includes(response.status)) {
	                dispatch(setChangePassword(false));
	                if (window.location.pathname.endsWith('login')) {
	                    window.location.reload();
	                    dispatch((0, _fetchingActions.dataFetched)());
	                } else if (window.location.pathname.startsWith('/' + _constants.URLs.JOIN)) {
	                    dispatch((0, _memberDetailsActions.setShowPassword)(false));
	                    dispatch(getSubscriptionStatus(response.member.key));
	                }
	            }
	        });
	    };
	}
	function resetEmailSent() {
	    return function (dispatch) {
	        dispatch(resetStatus());
	        dispatch(setForgetPassword(false));
	        dispatch(setResetPasswordEmailSent(false));
	    };
	}
	
	function createFacebookMember(member) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/AuthenticationService.createFacebookMember';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            email: member.email,
	            firstName: member.firstName,
	            lastName: member.lastName,
	            facebookId: member.facebookId
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOGIN));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            dispatch(setMemberOnServerData(json));
	            return json;
	        }).then(function (response) {
	            if (OK_STATUSES.includes(response.status)) {
	                dispatch(getSubscriptionStatus(response.member.key, state.signupData.isGuestUser));
	                dispatch((0, _joinActions.setCreateAccountPage)(_constants.JoinCreateAccountConstants.CONTACT_DETAILS));
	            }
	        }).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        });
	    };
	}
	
	function getSubscriptionStatus(memberKey, iGuestUser) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/AuthenticationService.getSubscriptionStatus';
	        var data = {
	            seasonKey: state.staticData.seasonKey,
	            memberKey: memberKey
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.GET_STATUS));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json === 'NoSubscription') {
	                dispatch((0, _joinActions.setCreateAccountPage)(_constants.JoinCreateAccountConstants.CONTACT_DETAILS, true));
	                dispatch((0, _fetchingActions.dataFetched)());
	                return;
	            } else if (iGuestUser) {
	                var path = (0, _utils.redirectPage)(_constants.URLs.JOIN, state.staticData);
	                window.location.assign(path);
	            }
	            var messageData = (0, _messagePageActions.messageDataParser)({ status: json }, { staticData: state.staticData });
	            dispatch((0, _messagePageActions.setMessageData)(messageData));
	            dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error, { action: getSubscriptionStatus, args: [memberKey, iGuestUser] }));
	        });
	    };
	}
	
	function showFBErrorMessage() {
	    return function (dispatch) {
	        dispatch((0, _fetchingActions.errorFetching)(new Error("Failed to connect to Facebook. Please try again.")));
	    };
	}
	
	function setEnableFbButton(enableFBButton) {
	    return {
	        type: _actionTypes.ENABLE_FB_BUTTON,
	        enableFBButton: enableFBButton
	    };
	}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setMemberData = setMemberData;
	exports.initMemberData = initMemberData;
	exports.setMemberAction = setMemberAction;
	exports.setMemberKey = setMemberKey;
	exports.getMember = getMember;
	exports.updateMember = updateMember;
	exports.setAddressValidationError = setAddressValidationError;
	exports.setAddressValidationErrorNoAction = setAddressValidationErrorNoAction;
	exports.setUpdateMemberError = setUpdateMemberError;
	exports.setShowPassword = setShowPassword;
	exports.updateMemberLatLng = updateMemberLatLng;
	exports.setLatLng = setLatLng;
	
	var _utils = __webpack_require__(485);
	
	var _actionTypes = __webpack_require__(459);
	
	var _joinActions = __webpack_require__(752);
	
	var _constants = __webpack_require__(463);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _fetchingActions = __webpack_require__(748);
	
	function setMemberData(member) {
	    return {
	        type: _actionTypes.SET_MEMBER_DATA,
	        memberDetails: member
	    };
	}
	function initMemberData() {
	    return {
	        type: _actionTypes.INIT_MEMBER_DETAILS
	    };
	}
	function setMemberAction(memberAction) {
	    return {
	        type: _actionTypes.SET_MEMBER_ACTION,
	        memberAction: memberAction
	    };
	}
	function setMemberKey(memberKey) {
	    return {
	        type: _actionTypes.SET_MEMBER_KEY,
	        memberKey: memberKey
	    };
	}
	function getMember(memberKey) {
	    return function (dispatch, getState) {
	        var fetchUrl = '/dispatcher/SignupService.getMember';
	        var data = {
	            farmKey: getState().staticData.farmKey,
	            memberKey: memberKey
	        };
	        return (0, _utils.ajax)(fetchUrl, data).then(function (member) {
	            return dispatch(setMemberData(member));
	        });
	    };
	}
	function updateMember(contactDetails, step, waitListItems) {
	    return function (dispatch, getState) {
	        var state = getState();
	        if ((0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.VALIDATE_UPDATE_MEMBER)) {
	            return;
	        }
	        var memberKey = state.memberDetails ? state.memberDetails.key : null;
	        var fetchUrl = '/dispatcher/SignupService.updateMember';
	        var password = contactDetails.password;
	        delete contactDetails.password;
	        delete contactDetails.retypedPassword;
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: memberKey,
	            password: password,
	            contactDetails: JSON.stringify(contactDetails)
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.VALIDATE_UPDATE_MEMBER));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (response) {
	            if (response === "Member with this email already exists") {
	                response = "Email already exists. Switch to Login tab and use your existing email and password";
	                dispatch(setUpdateMemberError(response));
	                dispatch((0, _fetchingActions.dataFetched)());
	            } else {
	                if (!document.cookie.includes("farmigoMember")) throw new Error(_constants.NO_COOKIE_CREATE);
	                dispatch(setMemberKey(response));
	                dispatch(getMember(response));
	                if (waitListItems) {
	                    dispatch((0, _subscriptionSummaryActions.createWaitListSubscription)(response, waitListItems));
	                } else if (step) {
	                    if (step !== _constants.URLs.ACCOUNT) {
	                        dispatch((0, _joinActions.gotoStep)(step));
	                    }
	                    dispatch((0, _fetchingActions.dataFetched)());
	                }
	            }
	        }).then(function () {
	            return dispatch(setMemberAction(_constants.MemberActions.NO_ACTION));
	        }).catch(function (error) {
	            return dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	function setAddressValidationError(error) {
	    return {
	        type: _actionTypes.SET_ADDRESS_VALIDATION_ERROR,
	        error: error
	    };
	}
	function setAddressValidationErrorNoAction(error) {
	    return {
	        type: _actionTypes.SET_ADDRESS_VALIDATION_ERROR_NO_ACTION,
	        error: error
	    };
	}
	function setUpdateMemberError(error) {
	    return {
	        type: _actionTypes.SET_UPDATE_MEMBER_ERROR,
	        error: error
	    };
	}
	function setShowPassword(showPassword) {
	    return {
	        type: _actionTypes.SET_SHOW_PASSWORD,
	        showPassword: showPassword
	    };
	}
	function updateMemberLatLng(lat, lng) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/SignupService.updateMemberLatLng';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            lat: lat,
	            lng: lng
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.UPDATE_LAT_LNG));
	        return (0, _utils.ajax)(fetchUrl, data).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            return dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	function setLatLng(lat, lng) {
	    return {
	        type: _actionTypes.SET_LAT_LNG,
	        lat: lat,
	        lng: lng
	    };
	}

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setSignupData = setSignupData;
	exports.clearSignupData = clearSignupData;
	exports.setPickupSitesFilters = setPickupSitesFilters;
	exports.setMapProps = setMapProps;
	exports.initMapProps = initMapProps;
	exports.addItem = addItem;
	exports.selectPaymentPlan = selectPaymentPlan;
	exports.setPastSeasonMessage = setPastSeasonMessage;
	exports.applyCoupon = applyCoupon;
	exports.removeCoupon = removeCoupon;
	exports.setCreateAccountPage = setCreateAccountPage;
	exports.getStepLabel = getStepLabel;
	exports.navigateToStep = navigateToStep;
	exports.isValidOptionScheduleMessage = isValidOptionScheduleMessage;
	exports.setInvalidOptionSchedulesMessage = setInvalidOptionSchedulesMessage;
	exports.gotoStep = gotoStep;
	exports.getSignupData = getSignupData;
	exports.joinChangeItemQuantity = joinChangeItemQuantity;
	exports.setSelectedSchedule = setSelectedSchedule;
	exports.initGuestUser = initGuestUser;
	exports.getGuestPickupSiteData = getGuestPickupSiteData;
	exports.getWaitListShareItems = getWaitListShareItems;
	exports.clearSharesSelection = clearSharesSelection;
	exports.setSelectedMethod = setSelectedMethod;
	exports.setComments = setComments;
	exports.setTermsSelected = setTermsSelected;
	exports.setHomeDeliveryInstructions = setHomeDeliveryInstructions;
	exports.isValidateCouponMinimum = isValidateCouponMinimum;
	exports.setCouponStatus = setCouponStatus;
	
	var _utils = __webpack_require__(485);
	
	var _actionTypes = __webpack_require__(459);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _constants = __webpack_require__(463);
	
	var _joinPayActions = __webpack_require__(753);
	
	var _commonActions = __webpack_require__(747);
	
	var _utils2 = __webpack_require__(485);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _logInActions = __webpack_require__(750);
	
	var _messagePageActions = __webpack_require__(760);
	
	var _memberDetailsActions = __webpack_require__(751);
	
	var _translate = __webpack_require__(464);
	
	var _basket = __webpack_require__(757);
	
	function setSignupData(signupData) {
	    return {
	        type: _actionTypes.SET_SIGNUP_DATA,
	        signupData: signupData
	    };
	}
	
	function clearSignupData() {
	    return {
	        type: _actionTypes.CLEAR_SIGNUP_DATA
	    };
	}
	
	function setSharesData(sharesData, key) {
	    return {
	        type: _actionTypes.SET_SHARES_DATA,
	        sharesData: sharesData,
	        key: key
	    };
	}
	
	function setPickupSitesFilters(deliveryDay) {
	    return {
	        type: _actionTypes.SET_DELIVERY_DAY_FILTER,
	        deliveryDay: deliveryDay
	    };
	}
	
	function setMapProps(zoomLevel, centerLocation) {
	    return {
	        type: _actionTypes.SET_MAP_PROPS,
	        zoomLevel: zoomLevel,
	        centerLocation: centerLocation
	    };
	}
	
	function initMapProps() {
	    return {
	        type: _actionTypes.INIT_MAP_PROPS
	    };
	}
	
	function addItem(key) {
	    return {
	        type: _actionTypes.ADD_ITEM,
	        key: key
	    };
	}
	
	function selectPaymentPlan(key) {
	    return {
	        type: _actionTypes.SELECT_PAYMENT_PLAN,
	        key: key
	    };
	}
	
	function setPastSeasonMessage() {
	    return function (dispatch, getState) {
	        var messageData = (0, _messagePageActions.messageDataParser)({}, { staticData: getState().staticData, flowType: _constants.URLs.JOIN });
	        dispatch((0, _messagePageActions.setMessageData)(messageData));
	    };
	}
	
	function applyCoupon(couponId) {
	    return function (dispatch) {
	        if (couponId === "") {
	            dispatch(setCoupon(undefined));
	        } else {
	            dispatch((0, _commonActions.getCouponData)(couponId, setCoupon));
	        }
	    };
	}
	
	function setCoupon(couponData) {
	    return {
	        type: _actionTypes.SET_COUPON,
	        coupon: couponData
	    };
	}
	
	function removeCoupon() {
	    return {
	        type: _actionTypes.REMOVE_COUPON
	    };
	}
	
	function setCreateAccountPage(contactInfoPage) {
	    return {
	        type: _actionTypes.CONTACT_INFO_STEP,
	        contactInfoPage: contactInfoPage
	    };
	}
	
	function getStepLabel(step, pickupSiteLabel, isWaitListOnly, isGuestUser, joinSharesStepLabel) {
	    switch (step) {
	        case _constants.JoinSteps.PICKUP_SITES:
	            return !pickupSiteLabel || pickupSiteLabel === 'null' ? "Pick-Up Site" : pickupSiteLabel;
	        case _constants.JoinSteps.SHARES:
	            return isWaitListOnly ? " Waitlist" : !joinSharesStepLabel || joinSharesStepLabel === 'null' ? "Shares" : joinSharesStepLabel;
	        case _constants.JoinSteps.OPTIONS:
	            return "Options";
	        case _constants.JoinSteps.TERMS:
	            return "Terms";
	        case _constants.JoinSteps.CONTACT_INFO:
	            return "Contact Info";
	        case _constants.JoinSteps.PAY:
	            return "Pay";
	        case _constants.JoinSteps.FINISH:
	            return !isGuestUser ? "Finish" : "Start Shopping";
	        default:
	            return "";
	    }
	}
	
	function navigateToStep(direction) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var signupData = state.signupData;
	        var login = state.loginStatus;
	        var steps = signupData.steps;
	        var summary = state.summary || {};
	        var staticData = state.staticData;
	        var stepIndex = steps.indexOf(signupData.step);
	        var step = signupData.step;
	
	        if (step === _constants.JoinSteps.OPTIONS && direction === _constants.JoinStepsDirections.NEXT && state.staticData.syncOptionSchedules) {
	            var sharesData = Object.assign({}, signupData.sharesData, { shares: Object.assign({}, signupData.sharesData.shares),
	                options: Object.assign({}, signupData.sharesData.options) });
	            (summary.shareItems || []).map(function (sharesData, item, index) {
	                sharesData.shares[item.key] = Object.assign({}, item, { selectedSchedule: summary.shareSchedules[index] });
	            }.bind(summary, sharesData));
	            var validationMessage = isValidOptionScheduleMessage(sharesData, signupData.schedules);
	            if (validationMessage) {
	                dispatch(setInvalidOptionSchedulesMessage(validationMessage));
	                return;
	            }
	        }
	        if (step === _constants.JoinSteps.TERMS && direction === _constants.JoinStepsDirections.NEXT) {
	            var coupon = (signupData.selectedData || {}).coupon;
	            if (coupon && !isValidateCouponMinimum(coupon, signupData.sharesData, staticData)) {
	                dispatch(setCouponStatus(_constants.CouponStatus.INVALID_COUPON_MINIMUM));
	                return;
	            } else if (coupon && coupon.status) {
	                dispatch(setCouponStatus(undefined));
	            }
	        }
	        if (step === _constants.JoinSteps.PAY && direction === _constants.JoinStepsDirections.NEXT) {
	            dispatch((0, _joinPayActions.submitSubscription)());
	            if (state.clientViewPort && state.clientViewPort.isXs) scrollStepToTop();
	            return;
	        }
	        if (direction === _constants.JoinStepsDirections.BACK) {
	            if (step === _constants.JoinSteps.CONTACT_INFO) {
	                if (signupData.contactInfoPage && signupData.contactInfoPage === _constants.JoinCreateAccountConstants.LOGIN && login.isForgetPassword) {
	                    dispatch((0, _logInActions.resetEmailSent)());
	                    return;
	                }
	                if (signupData.contactInfoPage && signupData.contactInfoPage === _constants.JoinCreateAccountConstants.CONTACT_DETAILS && !(state.staticData.facebookId || state.memberDetails.key)) {
	                    dispatch(setCreateAccountPage(_constants.JoinCreateAccountConstants.CREATE_CONTACT));
	                    return;
	                } else if (stepIndex === 0) {
	                    window.location.assign((0, _utils2.redirectPage)(_constants.URLs.STORE, state.staticData));
	                    return;
	                }
	            } else if (step === _constants.JoinSteps.TERMS) {
	                dispatch(setCreateAccountPage(_constants.JoinCreateAccountConstants.CONTACT_DETAILS));
	            }
	        }
	        if (stepIndex === 0 && direction === _constants.JoinStepsDirections.BACK) {
	            //Add Subscription flow - need to get back to the store
	            window.history.back();
	            return;
	        }
	        if (direction === _constants.JoinStepsDirections.NEXT) {
	            stepIndex++;
	        } else if (direction === _constants.JoinStepsDirections.BACK) {
	            stepIndex--;
	        }
	        if (stepIndex >= 0 && stepIndex <= steps.length - 1) step = steps[stepIndex];
	        //Check if need to load shares
	        if (direction === _constants.JoinStepsDirections.NEXT) {
	            if (step === _constants.JoinSteps.SHARES && (state.summary.pickupSite || {}).key !== signupData.sharesData.pickupSiteKey) {
	                dispatch(getSharesData((state.summary.pickupSite || {}).deliveryDays, (state.summary.pickupSite || {}).key, _constants.JoinModes.NEW));
	            }
	            if (!signupData.isGuestUser && !signupData.isAddSubscription && step === _constants.JoinSteps.PAY || (signupData.data || {}).isWaitListOnly && step === _constants.JoinSteps.FINISH || signupData.isGuestUser && step === _constants.JoinSteps.PICKUP_SITES) {
	                dispatch((0, _memberDetailsActions.setMemberAction)(_constants.MemberActions.VALIDATE_MEMBER_DETAILS));
	                return;
	            } else if (signupData.isGuestUser && step === _constants.JoinSteps.FINISH) {
	                dispatch((0, _subscriptionSummaryActions.isCreatingSubscription)(true));
	                dispatch((0, _commonActions.setDirty)(false));
	                dispatch((0, _subscriptionSummaryActions.createGuestSubscription)(state.memberDetails.key, state.summary.pickupSite.key));
	                return;
	            }
	        }
	        dispatch(gotoStep(step));
	        //On mobile scroll to top of the page
	        if (state.clientViewPort && state.clientViewPort.isXs) scrollStepToTop();
	    };
	}
	function isValidOptionScheduleMessage(sharesData, schedules, storeAccessShareShare) {
	    var sharesSelectedSchedules = [];
	    for (var key in sharesData.shares) {
	        if (key === storeAccessShareShare) {
	            continue;
	        }
	        if (sharesData.shares.hasOwnProperty(key)) {
	            var share = sharesData.shares[key];
	            if (share.quantity > 0 && share.selectedSchedule) {
	                var shareSchedules = schedules[share.selectedSchedule];
	                sharesSelectedSchedules = sharesSelectedSchedules.concat(shareSchedules.dates);
	            }
	        }
	    }
	    var invalidOptions = {};
	    var hasInvalid = 0;
	    for (var _key in sharesData.options) {
	        if (sharesData.options.hasOwnProperty(_key)) {
	            var option = sharesData.options[_key];
	            if (option.quantity > 0 && option.selectedSchedule && schedules.hasOwnProperty(option.selectedSchedule)) {
	                (function () {
	                    var optionSchedules = schedules[option.selectedSchedule];
	                    var today = (0, _utils.formatToServerDate)(new Date());
	                    if (!optionSchedules.dates.every(function (date) {
	                        if (today < date) {
	                            return sharesSelectedSchedules.indexOf(date) >= 0;
	                        } else {
	                            return true;
	                        }
	                    })) {
	                        if (!invalidOptions.hasOwnProperty(option.selectedSchedule)) {
	                            invalidOptions[option.selectedSchedule] = [];
	                        }
	                        invalidOptions[option.selectedSchedule].push(option.title);
	                        hasInvalid++;
	                    }
	                })();
	            }
	        }
	    }
	    if (hasInvalid > 0) {
	        var _key2 = Object.keys(invalidOptions)[0];
	        if (schedules.hasOwnProperty(_key2)) {
	            var invalidOptionsArray = invalidOptions[_key2];
	            var options = invalidOptionsArray[0];
	            for (var i = 1; i < invalidOptionsArray.length; i++) {
	                options += ", " + invalidOptionsArray[i];
	            }
	            return (0, _translate.translate)("_syncOptionSchedulesValidation").replace("{0}", options);
	        }
	    }
	    return undefined;
	}
	
	function setInvalidOptionSchedulesMessage(invalidOptionScheduleMessage) {
	    return {
	        type: _actionTypes.SET_INVALID_OPTION_SCHEDULE_MESSAGE,
	        invalidOptionScheduleMessage: invalidOptionScheduleMessage
	    };
	}
	function scrollStepToTop() {
	    window.scrollTo(0, 0);
	}
	
	function gotoStep(step) {
	    return {
	        type: _actionTypes.GOTO_STEP,
	        step: step
	    };
	}
	
	function getSignupData(mode) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/SignupService.getSignupData';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            seasonKey: state.staticData.seasonKey
	        };
	        if (mode === _constants.JoinModes.CHANGE || mode === _constants.JoinModes.ADD) data.pickupSiteKey = state.summary.pickupSite.key;
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOAD_SIGNUP_DATA));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            return signupParser(json, mode);
	        }).then(function (signupData) {
	            dispatch(setSignupData(signupData));
	            if (signupData.data.isWaitListOnly) {
	                dispatch(getWaitListShareItems());
	            }
	            dispatch(gotoStep(signupData.steps[0]));
	            //case of change or add subscription
	            if (mode === _constants.JoinModes.CHANGE || mode === _constants.JoinModes.ADD) dispatch(getSharesData(state.summary.pickupSite.deliveryDays, state.summary.pickupSite.key, mode));else if (state.memberDetails.key) dispatch((0, _logInActions.getSubscriptionStatus)(state.memberDetails.key));else dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error, { action: getSignupData, args: [mode] }));
	        });
	    };
	}
	
	function signupParser(json, mode) {
	    var data = {
	        hasCoupons: json.hasCoupons,
	        hasOptions: json.hasOptions,
	        isFarmSeasonal: json.isFarmSeasonal,
	        isWaitListOnly: json.isWaitListOnly,
	        seasonTitle: json.seasonTitle
	    };
	    var steps = void 0;
	    if (mode === _constants.JoinModes.CHANGE) {
	        steps = data.hasOptions ? [_constants.JoinSteps.SHARES, _constants.JoinSteps.OPTIONS] : [_constants.JoinSteps.SHARES];
	    } else if (mode === _constants.JoinModes.ADD) {
	        steps = [_constants.JoinSteps.SHARES, _constants.JoinSteps.OPTIONS, _constants.JoinSteps.TERMS, _constants.JoinSteps.PAY, _constants.JoinSteps.FINISH];
	        if (!data.hasOptions) steps.splice(1, 1);
	    } else if (data.isWaitListOnly) {
	        steps = [_constants.JoinSteps.SHARES, _constants.JoinSteps.CONTACT_INFO, _constants.JoinSteps.FINISH];
	    } else {
	        steps = [_constants.JoinSteps.PICKUP_SITES, _constants.JoinSteps.SHARES, _constants.JoinSteps.OPTIONS, _constants.JoinSteps.TERMS, _constants.JoinSteps.CONTACT_INFO, _constants.JoinSteps.PAY, _constants.JoinSteps.FINISH];
	        if (!data.hasOptions) steps.splice(2, 1);
	    }
	    return {
	        data: data,
	        steps: steps,
	        pickupSitesData: parsePickupSiteData(json),
	        paymentMethods: parsePaymentMethods(json),
	        paymentPlans: parsePaymentPlans(json),
	        schedules: parseSchedules(json),
	        shareSchedules: parseShareSchedules(json),
	        isAddSubscription: mode === _constants.JoinModes.ADD
	    };
	}
	
	function parsePickupSiteData(json) {
	    return json.pickupSitesData;
	}
	
	function parsePaymentMethods(json) {
	    return json.paymentMethods;
	}
	
	function parsePaymentPlans(json) {
	    //Keep only the one relevant for signup
	    return json.paymentPlans.filter(function (plan) {
	        return plan.isActive && plan.isSignup;
	    });
	}
	
	function parseSchedules(json) {
	    return json.schedules;
	}
	
	function parseShareSchedules(json) {
	    return json.shareSchedules;
	}
	
	function getSharesData(day, pickupSiteKey, mode) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/SignupService.getShareItems';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            seasonKey: state.staticData.seasonKey,
	            day: day,
	            isSignup: mode === _constants.JoinModes.NEW
	        };
	        if (mode === _constants.JoinModes.CHANGE || mode === _constants.JoinModes.ADD) data.subscriptionKey = state.summary.key;
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOAD_SIGNUP_SHARES));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            return sharesParser(json, state);
	        }).then(function (sharesData) {
	            if (mode === _constants.JoinModes.CHANGE || mode === _constants.JoinModes.ADD) return mergeSharesDataWithSummary(sharesData, state.summary, mode);else return sharesData;
	        }).then(function (sharesData) {
	            return dispatch(setSharesData(sharesData, pickupSiteKey));
	        }).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error, { action: getSharesData, args: [day, pickupSiteKey, mode] }));
	        });
	    };
	}
	
	function sharesParser(json, state) {
	    //Create a set of all remaining dates
	    var items = {};
	    var shares = {};
	    var options = {};
	    var pickupSite = state.summary.pickupSite;
	    var isWaitListOnly = state.signupData.data.isWaitListOnly;
	    json.shareItems.map(function (item) {
	        items[item.key] = item;
	        item.quantity = 0;
	        item.orderedQuantity = 0;
	        item.waitList = item.capacity - item.usageCount <= 0;
	        item.description = item.description ? item.description.replace(/\r/g, '<br>') : '';
	        if (!isWaitListOnly) {
	            var pickupSiteKey = pickupSite.key;
	            var selectedSchedule = item.pickupSiteScheduleMap.hasOwnProperty(pickupSiteKey) ? item.pickupSiteScheduleMap[pickupSiteKey] : -1; //if -2 then no deliveries for this schedule
	            if (item.isAvailable && (item.defaultSchedulesSize <= 1 || item.weeksLeft === null)) {
	                if (selectedSchedule === -1 && item.defaultSchedulesSize === 1) {
	                    selectedSchedule = 0;
	                }
	            }
	            if (selectedSchedule >= 0) {
	                item.schedules = [item.schedules[selectedSchedule]];
	                item.weeksLeft = [item.weeksLeft[selectedSchedule]];
	            }
	            if (!item.pickupSiteNotAvailableSet.includes(pickupSiteKey) && selectedSchedule > -2) {
	                if (!item.isAdditional) shares[item.key] = item;else options[item.key] = item;
	            }
	        } else {
	            if (!item.isAdditional) shares[item.key] = item;else options[item.key] = item;
	        }
	    });
	
	    return {
	        items: items,
	        shares: shares,
	        options: options,
	        remainingScheduleDates: json.remainingScheduleDates
	    };
	}
	
	function mergeSharesDataWithSummary(sharesData, summary, mode) {
	    summary.shareItems.map(function (item) {
	        if (mode === _constants.JoinModes.ADD) {
	            if (sharesData.items[item.key]) {
	                sharesData.items[item.key].maxPerMember -= item.quantity;
	            }
	        } else if (mode === _constants.JoinModes.CHANGE) {
	            if (sharesData.items[item.key]) {
	                sharesData.items[item.key].quantity = item.quantity;
	                sharesData.items[item.key].selectedSchedule = item.selectedSchedule;
	                if (sharesData.items[item.key].price !== item.price) {
	                    sharesData.items[item.key].price = item.price;
	                    //If price was changed don't allow adding more items
	                    sharesData.items[item.key].maxPerMember = item.quantity;
	                }
	                if (sharesData.items[item.key].waitList && item.quantity > 0) {
	                    sharesData.items[item.key].waitList = false;
	                    sharesData.items[item.key].maxPerMember = item.quantity;
	                    sharesData.items[item.key].available = item.quantity;
	                    sharesData.items[item.key].capacity = sharesData.items[item.key].usageCount + item.quantity;
	                }
	            } else {
	                sharesData.items[item.key] = Object.assign({}, item);
	                sharesData.items[item.key].maxPerMember = item.quantity;
	                sharesData.items[item.key].available = item.quantity;
	                sharesData.items[item.key].capacity = sharesData.items[item.key].usageCount + item.quantity;
	                sharesData.items[item.key].weeksLeft = [999];
	                if (!item.isAdditional) sharesData.shares[item.key] = sharesData.items[item.key];else sharesData.options[item.key] = sharesData.items[item.key];
	            }
	        }
	    });
	    summary.waitListItems.map(function (item) {
	        if (mode === _constants.JoinModes.ADD) {
	            if (sharesData.items[item.key]) {
	                sharesData.items[item.key].maxPerMember -= item.quantity;
	            }
	        } else if (mode === _constants.JoinModes.CHANGE) {
	            if (sharesData.items[item.key]) {
	                sharesData.items[item.key].quantity = item.quantity;
	            } else {
	                sharesData.items[item.key] = Object.assign({}, item);
	                sharesData.items[item.key].waitList = true;
	                sharesData.items[item.key].maxPerMember = 0;
	                sharesData.items[item.key].available = 0;
	                sharesData.items[item.key].capacity = 0;
	                sharesData.items[item.key].weeksLeft = [999];
	                if (!item.isAdditional) sharesData.shares[item.key] = sharesData.items[item.key];else sharesData.options[item.key] = sharesData.items[item.key];
	            }
	        }
	    });
	    return sharesData;
	}
	
	function joinChangeItemQuantity(key, newQuantity) {
	    return {
	        type: _actionTypes.JOIN_CHANGE_ITEM_QUANTITY,
	        key: key,
	        newQuantity: newQuantity
	    };
	}
	function setSelectedSchedule(key, selectedSchedule) {
	    return {
	        type: _actionTypes.JOIN_SET_ITEM_SCHEDULE,
	        key: key,
	        selectedSchedule: selectedSchedule
	    };
	}
	
	function initGuestUser() {
	    return function (dispatch) {
	        var steps = [_constants.JoinSteps.CONTACT_INFO, _constants.JoinSteps.PICKUP_SITES, _constants.JoinSteps.FINISH];
	        var signupData = {
	            steps: steps,
	            isGuestUser: true
	        };
	        dispatch(setSignupData(signupData));
	    };
	}
	
	function getGuestPickupSiteData() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/SignupService.getGuestPickupSiteData';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            seasonKey: state.staticData.seasonKey
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOAD_PICKUP_DATA));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            return guestPickupParser(json);
	        }).then(function (signupData) {
	            dispatch(setSignupData(signupData));
	            dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	function guestPickupParser(json) {
	    return {
	        pickupSitesData: parsePickupSiteData({ pickupSitesData: json })
	    };
	}
	
	function getWaitListShareItems() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/SignupService.getWaitListShareItems';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            seasonKey: state.staticData.seasonKey
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOAD_SIGNUP_SHARES));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (response) {
	            return waitListShareItemsParser(response);
	        }).then(function (json) {
	            return sharesParser(json, state);
	        }).then(function (shareData) {
	            dispatch(setSharesData(shareData));
	            dispatch(gotoStep(_constants.JoinSteps.SHARES));
	        }).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function waitListShareItemsParser(response) {
	    return { shareItems: response };
	}
	
	function clearSharesSelection() {
	    return {
	        type: _actionTypes.CLEAR_SHARES_SELECTION
	    };
	}
	
	function setSelectedMethod(key) {
	    return {
	        type: _actionTypes.SET_SELECTED_METHOD,
	        key: key
	    };
	}
	
	function setComments(comments) {
	    return {
	        type: _actionTypes.SET_SIGNUP_COMMENTS,
	        comments: comments
	    };
	}
	
	function setTermsSelected(isSelected) {
	    return {
	        type: _actionTypes.SET_TERMS_SELECTED,
	        isSelected: isSelected
	    };
	}
	
	function setHomeDeliveryInstructions(instructions) {
	    return {
	        type: _actionTypes.SET_HOME_DELIVERY_INSTRUCTIONS,
	        instructions: instructions
	    };
	}
	
	function isValidateCouponMinimum(coupon, sharesData, staticData) {
	    if (coupon.useMinimumOrder && coupon.minimumOrder > 0) {
	        var total = getShareTotal(sharesData.shares, staticData);
	        if (coupon.calculateOptions) {
	            total += getShareTotal(sharesData.options, staticData);
	        }
	        return total >= coupon.minimumOrder;
	    }
	    return true;
	}
	
	function getShareTotal(shares, staticData) {
	    var total = 0;
	    for (var shareKey in shares) {
	        if (shares.hasOwnProperty(shareKey)) {
	            var share = shares[shareKey];
	            if (share.quantity > 0) {
	                var distributionsNumber = (0, _basket.getDistributionsNumber)(share, share.selectedSchedule);
	                total += share.quantity * getSharePrice(share, distributionsNumber, staticData) * distributionsNumber;
	            }
	        }
	    }
	    return total;
	}
	function getSharePrice(share, distributionsNumber, staticData) {
	    var sharePrice = (0, _basket.getItemPrice)(share, staticData);
	    var calcPrice = sharePrice.priceBeforeTax;
	    //Don't multiply by distributionsNumber as it is already multiplied in getShareTotal
	    // if (staticData.hideDeliveryPrice) {
	    //     calcPrice = share.selectedSchedule || share.schedules.length === 1 ? calcPrice * (distributionsNumber ? distributionsNumber : 1) : undefined;
	    // }
	    return calcPrice;
	}
	
	function setCouponStatus(status) {
	    return {
	        type: _actionTypes.SET_COUPON_STATUS,
	        status: status
	    };
	}

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitSubscription = submitSubscription;
	exports.completeSubscription = completeSubscription;
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _utils = __webpack_require__(485);
	
	var _joinActions = __webpack_require__(752);
	
	var _commonActions = __webpack_require__(747);
	
	var _paymentActions = __webpack_require__(754);
	
	var _constants = __webpack_require__(463);
	
	var _subscription = __webpack_require__(759);
	
	var _fetchingActions = __webpack_require__(748);
	
	function submitSubscription() {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (state.signupData.isAddSubscription) dispatch(addSubscription());else dispatch(createSubscription());
	    };
	}
	
	function createSubscription() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.createSubscription';
	        var subscriptionData = JSON.stringify((0, _subscription.buildSubscriptionFromState)(state));
	        var paymentMethod = state.signupData.selectedData.selectedMethod;
	        var data = {
	            farmKey: state.staticData.farmKey,
	            seasonKey: state.staticData.seasonKey,
	            memberKey: state.memberDetails.key,
	            subscription: subscriptionData,
	            paymentMethod: paymentMethod
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (response) {
	            if (response.message && response.message === "Cannot retrieve the pickup site") {
	                throw { "message": "Cannot retrieve the pickup site, Please refresh your browser and try again" };
	            }
	            if (response.message && (response.message === _constants.CIM_NOT_ENABLED_ERROR_CODE || response.message === _constants.INVALID_USER_AUTHENTICATION_ERROR_CODE)) throw { "message": _constants.CIM_NOT_ENABLED };
	            if (response.message && response.message === _constants.SUBSCRIPTION_EXISTS_ERROR) {
	                dispatch((0, _commonActions.setDirty)(false));
	                throw { message: _constants.SUBSCRIPTION_EXISTS_ERROR_MESSAGE };
	            }
	            dispatch((0, _paymentActions.handlePaymentRedirect)(response, paymentMethod, (0, _joinActions.gotoStep)(_constants.JoinSteps.THANK_YOU)));
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function addSubscription() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.addSubscription';
	        var subscription = (0, _subscription.buildSubscriptionFromState)(state);
	        var paymentMethod = state.signupData.selectedData.selectedMethod;
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            subscriptionKey: state.summary.key,
	            shareItems: JSON.stringify(subscription.shareItems),
	            shareItemQuantities: JSON.stringify(subscription.shareItemQuantities),
	            shareItemSchedules: JSON.stringify(subscription.shareItemSchedules),
	            waitListItems: JSON.stringify(subscription.waitListItems),
	            paymentPlan: subscription.paymentPlan,
	            coupon: subscription.coupon,
	            paymentMethod: paymentMethod
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (response) {
	            dispatch((0, _paymentActions.handlePaymentRedirect)(response, paymentMethod, (0, _joinActions.gotoStep)(_constants.JoinSteps.THANK_YOU)));
	        }).catch(function (error) {
	            //Ignore the error as in most cases it is a false error
	            console.error(error);
	            dispatch((0, _paymentActions.handlePaymentRedirect)({}, paymentMethod, (0, _joinActions.gotoStep)(_constants.JoinSteps.THANK_YOU)));
	        });
	    };
	}
	
	function completeSubscription() {
	    return function (dispatch, getState) {
	        var fetchUrl = '/dispatcher/SignupService.completeAuthorizeDotNetPreapprovalSignup';
	        var state = getState();
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            postAction: state.checkout.postActionKey
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            (0, _utils.checkResponseOKStatus)(json);
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.removePath)('/payments')));
	            dispatch((0, _joinActions.gotoStep)(_constants.JoinSteps.THANK_YOU));
	            dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.removePath)('/payments')));
	            dispatch((0, _fetchingActions.dataFetched)());
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAuthorizedDotNetIFrameInfo = getAuthorizedDotNetIFrameInfo;
	exports.handlePaymentRedirect = handlePaymentRedirect;
	exports.handleRedirect = handleRedirect;
	exports.makeExtraPayment = makeExtraPayment;
	exports.redirectToPaymentDetails = redirectToPaymentDetails;
	exports.updatePaymentPlan = updatePaymentPlan;
	exports.checkAuthorizeDotNetTokenAndUpdatePayments = checkAuthorizeDotNetTokenAndUpdatePayments;
	exports.processAuthorizeDotNetResponse = processAuthorizeDotNetResponse;
	exports.submitEcheck = submitEcheck;
	exports.initEBT = initEBT;
	exports.adminChargeWithToken = adminChargeWithToken;
	exports.adminChargeWithoutToken = adminChargeWithoutToken;
	exports.removeAutomaticPayment = removeAutomaticPayment;
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _commonActions = __webpack_require__(747);
	
	var _utils = __webpack_require__(485);
	
	var _constants = __webpack_require__(463);
	
	var _storageActions = __webpack_require__(755);
	
	var _storeCheckoutActions = __webpack_require__(756);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	function getAuthorizedDotNetIFrameInfo(mode) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.getAuthorizedDotNetIFrameInfo';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            subscriptionKey: state.summary.key,
	            paymentMethod: _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key,
	            mode: mode
	        };
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.error) throw new Error(json.error);
	            dispatch(handlePaymentRedirect({
	                httpMethod: json.httpMethod,
	                actionURL: json.actionURL,
	                parameters: json.parameters
	            }, _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key));
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function handlePaymentRedirect(response, paymentMethod, callback) {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (response.actionURL != null) {
	            if (paymentMethod === _constants.PaymentMethod.PHONE) {
	                //This is an workaround for BTC - real Phone cannot have redirect
	                dispatch((0, _commonActions.setDirty)(false));
	                dispatch((0, _storageActions.saveToStorage)());
	                handleRedirect('POST', '_self', response.actionURL, response.parameters);
	            } else if (paymentMethod === _constants.PaymentMethod.ELECTRONIC_CHECK.key || paymentMethod === _constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key) {
	                //ACH
	                dispatch((0, _storeCheckoutActions.setPostActionKey)((response.parameters || {}).postAction || (response.parameters || {}).webOrder));
	                dispatch((0, _reactRouterRedux.replace)((0, _utils.addPath)('echeck' + window.location.search)));
	                dispatch((0, _fetchingActions.dataFetched)());
	            } else if (paymentMethod === _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key || state.staticData.isAuthorizeDotNetAcceptHostedEnabled && paymentMethod === _constants.PaymentMethod.AUTHORIZE_DOT_NET.key) {
	                //Authorize.net proapproval or hosted form
	                dispatch((0, _storeCheckoutActions.setPostActionKey)((response.parameters || {}).postAction || (response.parameters || {}).webOrder));
	                dispatch((0, _reactRouterRedux.push)((0, _utils.addPath)("payments" + window.location.search)));
	                handleRedirect(response.httpMethod, "paymentsHostIFrame", response.actionURL, response.parameters);
	                dispatch((0, _fetchingActions.dataFetched)());
	            } else if (paymentMethod === _constants.PaymentMethod.EBT_ONLINE.key) {
	                dispatch((0, _storeCheckoutActions.setPostActionKey)((response.parameters || {}).postAction || (response.parameters || {}).webOrder));
	                dispatch((0, _subscriptionSummaryActions.setCustomAmount)((response.parameters || {}).amount || '0'));
	                dispatch((0, _reactRouterRedux.replace)((0, _utils.addPath)('ebt' + window.location.search)));
	                dispatch((0, _fetchingActions.dataFetched)());
	            } else {
	                //Paypal
	                dispatch((0, _commonActions.setDirty)(false));
	                dispatch((0, _storageActions.saveToStorage)());
	                var method = response.actionURL.includes('webscr') ? 'GET' : 'POST';
	                handleRedirect(method, '_self', response.actionURL, response.parameters);
	            }
	        } else {
	            dispatch((0, _commonActions.setDirty)(false));
	            if (callback) dispatch(callback);
	            dispatch((0, _fetchingActions.dataFetched)());
	        }
	    };
	}
	
	function handleRedirect(method, target, actionURL, parameters) {
	    if (method == 'GET') {
	        var goToUrl = actionURL + "?" + (0, _utils.parametrize)(parameters);
	        window.location = goToUrl;
	    } else {
	        var form = document.createElement("form");
	        form.setAttribute("method", method);
	        form.setAttribute("action", actionURL);
	        form.setAttribute("target", target);
	
	        for (var key in parameters) {
	            if (parameters.hasOwnProperty(key)) {
	                var field = document.createElement("input");
	                field.setAttribute("type", "hidden");
	                field.setAttribute("name", key);
	                field.setAttribute("value", parameters[key]);
	                form.appendChild(field);
	            }
	        }
	        document.body.appendChild(form);
	        form.submit();
	    }
	}
	
	function makeExtraPayment(clientMode, amount, paymentMethod, paymentPlan) {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (!(0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT)) {
	            dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        } else {
	            return;
	        }
	        var fetchUrl = '/dispatcher/WebStoreService.makeExtraPayment';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            subscriptionKey: state.summary.key,
	            clientMode: clientMode,
	            paymentPlanKey: paymentPlan.key,
	            amount: amount,
	            paymentMethod: paymentMethod
	        };
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            dispatch(handlePaymentRedirect(json, paymentMethod, (0, _reactRouterRedux.replace)((0, _utils.addPath)('thankyou'))));
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	function redirectToPaymentDetails(mode, paymentMethod, paymentPlan) {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (!(0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT)) {
	            dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        } else {
	            return;
	        }
	        //In case of auth.net preapparoval need only to create a token
	        if (paymentMethod === _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key) {
	            dispatch(getAuthorizedDotNetIFrameInfo(mode));
	            return;
	        }
	        var fetchUrl = "/dispatcher/WebStoreService.redirectToPaymentDetails";
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            subscriptionKey: state.summary.key,
	            mode: mode,
	            paymentMethod: paymentMethod
	        };
	        if (paymentPlan) {
	            data.paymentPlanKey = paymentPlan.key;
	        }
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            dispatch(handlePaymentRedirect(json, paymentMethod, (0, _reactRouterRedux.replace)((0, _utils.addPath)('thankyou'))));
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function updatePaymentPlan(paymentPlan) {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (!(0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT)) {
	            dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        } else {
	            return;
	        }
	        var fetchUrl = "/dispatcher/WebStoreService.updatePaymentPlan";
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            subscriptionKey: state.summary.key
	        };
	        if (paymentPlan) {
	            data['paymentPlanKey'] = paymentPlan.key;
	        }
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            (0, _utils.checkResponseOKStatus)(json);
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.addPath)('thankyou')));
	            dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function checkAuthorizeDotNetTokenAndUpdatePayments() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.checkAuthorizeDotNetToken';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            subscription: state.summary.key
	        };
	        if (state.checkout.postActionKey) data.postAction = state.checkout.postActionKey;
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            (0, _utils.checkResponseOKStatus)(json);
	            if (state.summary.autoPaymentPlan) {
	                dispatch(updatePaymentPlan(state.summary.autoPaymentPlan));
	            } else {
	                dispatch((0, _commonActions.setDirty)(false));
	                dispatch((0, _reactRouterRedux.replace)((0, _utils.replacePath)('thankyou')));
	                dispatch((0, _fetchingActions.dataFetched)());
	            }
	        }).catch(function (error) {
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.removePath)('/payments')));
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function processAuthorizeDotNetResponse(amount, responseCode, txnId, flow) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/PaymentsService.processHostedAuthorizeDotNetResponse';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            subscriptionKey: state.summary.key,
	            amount: amount,
	            responseCode: responseCode,
	            txnId: txnId,
	            flow: flow
	        };
	        if (state.checkout.postActionKey) {
	            if (flow === 'STORE_STANDARD') {
	                data.webOrder = state.checkout.postActionKey;
	            } else {
	                data.postAction = state.checkout.postActionKey;
	            }
	        }
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            (0, _utils.checkResponseOKStatus)(json);
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.replacePath)('thankyou')));
	            dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.removePath)('/payments')));
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function submitEcheck(echeckInfo, isChargeOnDelivery, pageContext) {
	    return function (dispatch) {
	        if (isChargeOnDelivery && pageContext === _constants.URLs.STORE) dispatch(authenticateACH(echeckInfo, pageContext, _storeCheckoutActions.updateACHPreapprovalAndSubmitOrder));else dispatch(authenticateACH(echeckInfo, pageContext, createEcheck));
	    };
	}
	
	function authenticateACH(echeckInfo, pageContext, callback) {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (!(0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT)) {
	            dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        } else {
	            return;
	        }
	        var fetchUrl = '/dispatcher/WebStoreService.authenticateACH';
	        return (0, _utils.ajax)(fetchUrl, echeckInfo).then(function (json) {
	            (0, _utils.checkResponseOKStatus)(json);
	            dispatch(callback(echeckInfo, pageContext));
	        }).catch(function (error) {
	            var suppressError = error.message.startsWith('Please double check the information you provided') || error.message.startsWith('Invalid Bank Routing Number') || error.message.startsWith('The Details you provided failed authentication') || error.message.startsWith('Timeout expired');
	            dispatch((0, _fetchingActions.errorFetching)(error, undefined, suppressError));
	        });
	    };
	}
	
	function createEcheck(echeckInfo, pageContext) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = pageContext === _constants.URLs.STORE ? '/dispatcher/WebStoreService.createEcheckSubscriptionForWebOrder' : pageContext === _constants.URLs.PAY && (state.summary.paymentType === _constants.PaymentTypes.AUTO_PAYMENT.type || state.summary.paymentType === _constants.PaymentTypes.UPDATE_PAYMENT.type || state.summary.paymentType === _constants.PaymentTypes.PAYMENT_TOKEN.type) ? '/dispatcher/WebStoreService.updateACHPreapproval' : pageContext === _constants.URLs.PAY && state.summary.paymentType === _constants.PaymentTypes.CHARGE.type ? '/dispatcher/WebStoreService.createEcheckSubscriptionWithAmount' : '/dispatcher/WebStoreService.createEcheckSubscription';
	
	        if (state.summary.paymentType === _constants.PaymentTypes.CHARGE.type) echeckInfo.amount = state.summary.chargePaymentPlan.amount;
	        return (0, _utils.ajax)(fetchUrl, echeckInfo).then(function (json) {
	            (0, _utils.checkResponseOKStatus)(json);
	            if (pageContext === _constants.URLs.PAY && state.summary.paymentType === _constants.PaymentTypes.AUTO_PAYMENT.type && state.summary.autoPaymentPlan) {
	                dispatch((0, _fetchingActions.dataFetched)());
	                dispatch(updatePaymentPlan(state.summary.autoPaymentPlan));
	            } else {
	                dispatch((0, _commonActions.setDirty)(false));
	                dispatch((0, _reactRouterRedux.replace)((0, _utils.replacePath)('thankyou')));
	                dispatch((0, _fetchingActions.dataFetched)());
	            }
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function initEBT(ebtInfo, pageContext) {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (!(0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT)) {
	            dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        } else {
	            return;
	        }
	        ebtInfo.flow = pageContext === _constants.URLs.STORE ? 'STORE_STANDARD' : window.location.href.includes('/charge/') ? 'CHARGE_FROM_MEMBER_CARD' : pageContext === 'BALANCE' ? 'BALANCE' : 'STANDARD';
	        ebtInfo.cancelUrl = window.location.href;
	        var fetchUrl = '/dispatcher/WebStoreService.initEBT';
	        return (0, _utils.ajax)(fetchUrl, ebtInfo).then(function (response) {
	            (0, _utils.checkResponseOKStatus)(response);
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _storageActions.saveToStorage)());
	            var redirectInfo = response.redirectInfo;
	            handleRedirect('POST', '_self', redirectInfo.actionURL, redirectInfo.parameters);
	        }).catch(function (error) {
	            // const suppressError = error.message && (error.message.startsWith('Please double check the information you provided') || error.message.startsWith('Timeout expired'));
	            var suppressError = false;
	            dispatch((0, _fetchingActions.errorFetching)(error, undefined, suppressError));
	        });
	    };
	}
	
	function adminChargeWithToken() {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (!(0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT)) {
	            dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        } else {
	            return;
	        }
	        var paymentMethodToken = state.summary.paymentMethodToken;
	        var amount = state.summary.chargePaymentPlan.amount;
	        var fetchUrl = paymentMethodToken === _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key ? "/dispatcher/WebStoreService.createAuthorizeDotNetTransactionWithAmount" : paymentMethodToken === _constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key ? "/dispatcher/WebStoreService.createEcheckTransactionWithAmountFromExistingConsumer" : undefined;
	        if (!fetchUrl) return;
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            subscriptionKey: state.summary.key,
	            amount: amount
	        };
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.statusCode !== "OK") {
	                dispatch((0, _fetchingActions.errorFetching)(new Error(json.message), undefined, true));
	            } else {
	                dispatch((0, _commonActions.setDirty)(false));
	                dispatch((0, _reactRouterRedux.replace)((0, _utils.replacePath)('thankyou')));
	                dispatch((0, _fetchingActions.dataFetched)());
	            }
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function adminChargeWithoutToken() {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (state.summary.chargePaymentMethod === _constants.PaymentMethod.ELECTRONIC_CHECK.key) {
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.addPath)('echeck' + window.location.search)));
	        } else if (state.summary.chargePaymentMethod === _constants.PaymentMethod.EBT_ONLINE.key) {
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.addPath)('ebt' + window.location.search)));
	        } else if (state.summary.chargePaymentMethod === _constants.PaymentMethod.AUTHORIZE_DOT_NET.key) {
	            if (!(0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT)) {
	                dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	            } else {
	                return;
	            }
	            var fetchUrl = "/dispatcher/WebStoreService.redirectAuthorizeAndCaptureAuthorizeDotNetWithAmount";
	            var data = {
	                farmKey: state.staticData.farmKey,
	                memberKey: state.memberDetails.key,
	                subscriptionKey: state.summary.key,
	                amount: state.summary.chargePaymentPlan.amount
	            };
	            return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	                if (json.error) throw new Error(json.error);
	                dispatch(handlePaymentRedirect(json, _constants.PaymentMethod.AUTHORIZE_DOT_NET.key, (0, _reactRouterRedux.replace)((0, _utils.replacePath)('thankyou'))));
	            }).catch(function (error) {
	                dispatch((0, _fetchingActions.errorFetching)(error));
	            });
	        }
	    };
	}
	
	function removeAutomaticPayment() {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (!(0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT)) {
	            dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        } else {
	            return;
	        }
	        var fetchUrl = "/dispatcher/WebStoreService.removeAutomaticPayment";
	        var data = {
	            farmKey: state.staticData.farmKey,
	            subscriptionKey: state.summary.key,
	            memberKey: state.memberDetails.key,
	            paymentMethod: state.summary.paymentMethodToken
	        };
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            (0, _utils.checkResponseOKStatus)(json);
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.replacePath)('thankyou')));
	            dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.saveToStorage = saveToStorage;
	exports.removeStorage = removeStorage;
	
	var _actionTypes = __webpack_require__(459);
	
	function saveToStorage() {
	    return {
	        type: _actionTypes.SET_STORAGE_TIMESTAMP,
	        timestamp: new Date().getTime()
	    };
	}
	
	function removeStorage() {
	    return {
	        type: _actionTypes.REMOVE_STORAGE
	    };
	}

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitOrder = submitOrder;
	exports.checkAuthorizeDotNetTokenAndSubmitOrder = checkAuthorizeDotNetTokenAndSubmitOrder;
	exports.updateACHPreapprovalAndSubmitOrder = updateACHPreapprovalAndSubmitOrder;
	exports.setPostActionKey = setPostActionKey;
	exports.setUnavailableItemsInOrder = setUnavailableItemsInOrder;
	exports.dropDownClosed = dropDownClosed;
	
	var _utils = __webpack_require__(485);
	
	var _actionTypes = __webpack_require__(459);
	
	var _basket = __webpack_require__(757);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _paymentActions = __webpack_require__(754);
	
	var _constants = __webpack_require__(463);
	
	var _gaActions = __webpack_require__(474);
	
	function submitOrder(memberKey, subscriptionKey, orderKey, items, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method, isChargeOnDelivery) {
	    return function (dispatch) {
	        dispatch((0, _gaActions.trackStoreCheckout)(hasPreapproval ? "Preapprove" : method));
	
	        //Check if need first to create a token
	        if (isChargeOnDelivery && !hasPreapproval && method === _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key) {
	            //store the store comments for later order update
	            dispatch(setStoreComment(storeComments));
	            //Get the authorize.net ifarme to embed in the page
	            dispatch((0, _paymentActions.getAuthorizedDotNetIFrameInfo)('STORE'));
	        } else {
	            //check if member already has existing order in that case we will call addToWeborder service instead of update service
	            var itemsDivided = (0, _basket.getOrderedItemsForSummary)(items, activeOrder, canEditExistingOrder);
	            var hasFixedItems = itemsDivided.fixedItems && itemsDivided.fixedItems.length > 0 || itemsDivided.creditFixedItems && itemsDivided.creditFixedItems.length > 0;
	            if (hasFixedItems) {
	                items = itemsDivided.editableItems || [];
	                if (itemsDivided.creditEditableItems && itemsDivided.creditEditableItems.length > 0) {
	                    items = items.concat(itemsDivided.creditEditableItems);
	                }
	            }
	            //addToWebOrder
	            dispatch(submit(memberKey, items, orderKey, storeComments, method, hasFixedItems, hasPreapproval, isChargeOnDelivery, subscriptionKey));
	        }
	    };
	}
	
	function submit(memberKey, items, orderKey, storeComments, method, hasFixedItems, hasPreapproval, isChargeOnDelivery, subscriptionKey) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = hasFixedItems ? '/dispatcher/WebStoreService.addToWebOrder' : '/dispatcher/WebStoreService.updateOrder';
	        //Remove uneeded data before sending to server
	        var orderedItems = (0, _basket.getOrderedItems)(items, false).map(function (item) {
	            item.description = undefined;
	            item.imageUrl = undefined;
	            item.producerTitle = undefined;
	            item.link = undefined;
	            item.producer = undefined;
	            return item;
	        });
	        if (state.staticData.hasRecurringItems && (state.recurringOrder.items || []).length > 0) {
	            var recurringOrder = state.recurringOrder;
	            var recurringItems = recurringOrder.items || [];
	            recurringItems.map(function (recurringItem) {
	                var itemIndex = -1;
	                (orderedItems || []).find(function (item, index) {
	                    if (item && item.key === recurringItem.key) {
	                        itemIndex = index;
	                    }
	                });
	                recurringItem.scheduleKey = recurringItem.schedule ? recurringItem.schedule.key : undefined;
	                if (itemIndex > -1) {
	                    orderedItems[itemIndex].scheduleKey = recurringItem.scheduleKey;
	                    orderedItems[itemIndex].isItemNotPartOfOrder = recurringItem.isItemNotPartOfOrder;
	                    orderedItems[itemIndex].isRecurring = recurringItem.isRecurring;
	                } else if (recurringItem.scheduleKey && recurringItem.quantity > 0 && state.summary.nextDeliveryDate) {
	                    recurringItem.isItemNotPartOfOrder = !recurringItem.schedule.dates.includes(state.summary.nextDeliveryDate);
	                    delete recurringItem['schedule'];
	                    orderedItems.push(recurringItem);
	                }
	            }.bind(orderedItems));
	        }
	        var coupon = (state.orderStatus || {}).coupon;
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: memberKey,
	            orderKey: orderKey,
	            paymentMethod: method ? method : "BALANCE",
	            comments: storeComments,
	            items: JSON.stringify(orderedItems),
	            pickupSiteKey: state.summary.pickupSite.key
	        };
	        if ((coupon || {}).valid) {
	            var enabledPaymentMethods = [_constants.PaymentMethod.PAYPAL_STANDARD, _constants.PaymentMethod.ELECTRONIC_CHECK, _constants.PaymentMethod.CHECK, _constants.PaymentMethod.AUTHORIZE_DOT_NET, _constants.PaymentMethod.EBT_ONLINE];
	            var storePaymentMethods = state.staticData.storePaymentMethods;
	            if ((coupon || {}).existingCoupon) {
	                var dontSendCoupon = enabledPaymentMethods.some(function (method) {
	                    return storePaymentMethods.includes(method.key);
	                });
	                if (!dontSendCoupon) {
	                    data.couponKey = coupon.key;
	                    data.couponId = coupon.id;
	                }
	            } else {
	                data.couponKey = coupon.key;
	                data.couponId = coupon.id;
	            }
	        }
	        //In case the farm has charge on delivery and the member doesn't have token already we need to call redirectToPayment
	        // service which will call payPal API to get pre-approval key and save new postAction in the datastore that will be used
	        // when we will receive paypal/ipn callback
	        if (isChargeOnDelivery && !hasPreapproval && (method === _constants.PaymentMethod.PAYPAL_PREAPPROVE.key || method === _constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key)) {
	            fetchUrl = '/dispatcher/WebStoreService.redirectToPaymentDetails';
	            data.mode = "STORE";
	            data.subscriptionKey = subscriptionKey;
	        }
	        if (state.staticData.isMultipleActiveOrdersEnabled && state.summary.secondNextDeliveryDate !== undefined) {
	            data.nextDeliveryDate = state.summary.nextDeliveryDate;
	        }
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            dispatch((0, _paymentActions.handlePaymentRedirect)(json, method, (0, _reactRouterRedux.replace)((0, _utils.replacePath)('thankyou'))));
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function checkAuthorizeDotNetTokenAndSubmitOrder() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var status = state.orderStatus || {};
	        var summary = state.summary || {};
	        var memberKey = state.memberDetails.key;
	        var subscriptionKey = summary.key;
	        var orderKey = status.orderKey;
	        var items = state.itemsList;
	        var activeOrder = status.activeOrder;
	        var canEditExistingOrder = summary.canEditExistingOrder;
	        var storeComments = status.comments;
	
	        var fetchUrl = '/dispatcher/WebStoreService.checkAuthorizeDotNetToken';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: memberKey,
	            subscription: subscriptionKey
	        };
	        if (state.checkout.postActionKey) data.postAction = state.checkout.postActionKey;
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            (0, _utils.checkResponseOKStatus)(json);
	            dispatch(submitOrder(memberKey, subscriptionKey, orderKey, items, activeOrder, canEditExistingOrder, true, storeComments, 'NONE', status.coupon));
	        }).catch(function (error) {
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.removePath)('/payments')));
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function updateACHPreapprovalAndSubmitOrder(echeckInfo) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var status = state.orderStatus || {};
	        var summary = state.summary || {};
	        var memberKey = state.memberDetails.key;
	        var subscriptionKey = summary.subscriptionKey;
	        var orderKey = status.orderKey;
	        var items = state.itemsList;
	        var activeOrder = status.activeOrder;
	        var canEditExistingOrder = summary.canEditExistingOrder;
	        var storeComments = status.comments;
	
	        var fetchUrl = '/dispatcher/WebStoreService.updateACHPreapproval';
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        return (0, _utils.ajax)(fetchUrl, echeckInfo).then(function (json) {
	            (0, _utils.checkResponseOKStatus)(json);
	            dispatch(submitOrder(memberKey, subscriptionKey, orderKey, items, activeOrder, canEditExistingOrder, true, storeComments, 'NONE'));
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function setPostActionKey(key) {
	    return {
	        type: _actionTypes.SET_POST_ACTION_KEY,
	        postActionKey: key
	    };
	}
	function setStoreComment(comments) {
	    return {
	        type: _actionTypes.SET_STORE_COMMENT,
	        comments: comments
	    };
	}
	
	function setUnavailableItemsInOrder(items) {
	    return {
	        type: _actionTypes.SET_UNAVAILABLE_ITEMS,
	        items: items
	    };
	}
	function dropDownClosed(isDropDownClosed) {
	    return {
	        type: _actionTypes.SET_DROPDOWN_CLOSED,
	        isDropDownClosed: isDropDownClosed
	    };
	}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.orderValidator = exports.formatMoney = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getOrderedItems = getOrderedItems;
	exports.getOrderedItemsForSummary = getOrderedItemsForSummary;
	exports.calculateOrderTotal = calculateOrderTotal;
	exports.calculateOrderPoints = calculateOrderPoints;
	exports.getNumOfItemsInOrderText = getNumOfItemsInOrderText;
	exports.getRemainingCredits = getRemainingCredits;
	exports.formatCredits = formatCredits;
	exports.formatPoints = formatPoints;
	exports.formatPrice = formatPrice;
	exports.getCheckoutPrice = getCheckoutPrice;
	exports.getItemKeysLists = getItemKeysLists;
	exports.getWaitlistItems = getWaitlistItems;
	exports.getItemPrice = getItemPrice;
	exports.calcTotals = calcTotals;
	exports.getAllItemsRemainingDeliveryDates = getAllItemsRemainingDeliveryDates;
	exports.getJoinSelectedItems = getJoinSelectedItems;
	exports.getDistributionsNumber = getDistributionsNumber;
	exports.getNextDeliveryDate = getNextDeliveryDate;
	exports.isEBTNonEligibleItems = isEBTNonEligibleItems;
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _constants2 = __webpack_require__(463);
	
	var _translate = __webpack_require__(464);
	
	/**
	 * Returns array of items which has quantity > 0, aka "ordered"
	 * @param items
	 * @param sort - optional param for sorting ordered items as they should appear at the order summary list
	 * @returns {Array}
	 */
	function getOrderedItems(items) {
	    var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var filteredItems = [];
	    for (var key in items) {
	        if (items.hasOwnProperty(key) && items[key].quantity) {
	            filteredItems.push(Object.assign({}, items[key]));
	        }
	    }
	    if (sort && filteredItems.length) {
	        filteredItems.sort(function (i1, i2) {
	            return i1[_constants.FIELD_SELECTED_ORDER] - i2[_constants.FIELD_SELECTED_ORDER];
	        });
	    }
	    return filteredItems;
	}
	
	function getOrderedItemsForSummary(items, activeOrder, canEditExistingOrder) {
	    var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	    var orderedItems = getOrderedItems(items, sort);
	    var filteredItems = [];
	    var creditFilteredItems = [];
	    var fixedItems = [];
	    var creditFixedItems = [];
	    var editableItems = [];
	    var creditEditableItems = [];
	    for (var index in orderedItems) {
	        var item = orderedItems[index];
	        if (item.isCredit) {
	            creditFilteredItems.push(item);
	        } else {
	            filteredItems.push(item);
	        }
	    }
	    if (canEditExistingOrder) {
	        editableItems = filteredItems;
	        creditEditableItems = creditFilteredItems;
	    } else {
	        activeOrder = activeOrder || {};
	        filteredItems.forEach(function (i) {
	            if (activeOrder[i.key]) {
	                fixedItems.push(Object.assign({}, i, {
	                    quantity: activeOrder[i.key].quantity,
	                    price: activeOrder[i.key].price
	                }));
	                if (i.quantity > activeOrder[i.key].quantity) {
	                    editableItems.push(Object.assign({}, i, {
	                        quantity: i.quantity - activeOrder[i.key].quantity,
	                        price: activeOrder[i.key].price
	                    }));
	                }
	            } else {
	                editableItems.push(i);
	            }
	        });
	        creditFilteredItems.forEach(function (i) {
	            if (activeOrder[i.key]) {
	                creditFixedItems.push(Object.assign({}, i, {
	                    quantity: activeOrder[i.key].quantity,
	                    price: activeOrder[i.key].price
	                }));
	                if (i.quantity > activeOrder[i.key].quantity) {
	                    creditEditableItems.push(Object.assign({}, i, {
	                        quantity: i.quantity - activeOrder[i.key].quantity,
	                        price: activeOrder[i.key].price
	                    }));
	                }
	            } else {
	                creditEditableItems.push(i);
	            }
	        });
	    }
	    return {
	        filteredItems: filteredItems,
	        fixedItems: fixedItems,
	        editableItems: editableItems,
	        creditFilteredItems: creditFilteredItems,
	        creditFixedItems: creditFixedItems,
	        creditEditableItems: creditEditableItems
	    };
	}
	
	function calculateOrderTotal(orderedItems, options, staticData) {
	
	    var emptyPrice = { fullPrice: 0, priceBeforeTax: 0, tax: 0, extraCreditsCost: 0 };
	    options = options || {};
	
	    function calculate() {
	        var total = orderedItems.reduce(function (prev, curr) {
	            var price = getItemPrice(curr, staticData);
	            return {
	                fullPrice: prev.fullPrice + price.fullPrice * curr.quantity,
	                priceBeforeTax: prev.priceBeforeTax + price.priceBeforeTax * curr.quantity,
	                tax: prev.tax + price.tax * curr.quantity,
	                isCredit: curr.isCredit,
	                extraCreditsCost: prev.extraCreditsCost + (curr.key === options.extraCreditItemKey ? price.fullPrice * curr.quantity : 0)
	            };
	        }, emptyPrice);
	        if (options.extraCost && options.extraCostType === "Fixed" && total.priceBeforeTax) {
	            total.extraCostAmount = options.extraCost;
	            total.extraCostLabel = staticData.extraCostLabel || (0, _translate.translate)("Extra Fuel Charge");
	            total.fullPrice += options.extraCost;
	        }
	        if (options.credits && staticData.hasFarmigoCredits) {
	            var fullPrice = Math.max(0, total.fullPrice - options.credits);
	            total.usedCredits = fullPrice - total.fullPrice;
	            total.fullPrice = fullPrice;
	            total.remainingCredits = options.credits + total.usedCredits;
	            total.creditType = _constants2.CreditTypes.CREDIT_TYPE_FARMIGO;
	        }
	        if (options.couponValue) {
	            total.couponValue = options.couponValue;
	            total.fullPrice -= options.couponValue;
	        }
	        if (options.creditsTotal && staticData.isCreditItemAsRegularItem) {
	            total.creditsTotal = options.creditsTotal > options.credits ? options.credits : options.creditsTotal;
	            total.priceBeforeTax += options.creditsTotal > options.credits ? options.credits : options.creditsTotal;
	        }
	        if (options.balanceAsCredits >= 0 && options.extraCreditItemKey) {
	            total.balanceAsCredits = Math.min(options.balanceAsCredits, total.extraCreditsCost);
	            total.remainingBalanceAsCredits = options.balanceAsCredits - total.balanceAsCredits;
	            total.fullPrice -= total.balanceAsCredits;
	        }
	        return total;
	    }
	
	    return _formatWrap(orderedItems ? calculate() : emptyPrice);
	}
	
	function calculateOrderPoints() {
	    var orderedItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return orderedItems.reduce(function (total, item) {
	        return total + (item.points || 0) * item.quantity;
	    }, 0);
	}
	
	function getNumOfItemsInOrderText(orderedItems, extraCreditItem) {
	    var itemsNum = 0;
	    if (orderedItems) {
	        orderedItems.creditEditableItems.map(function (item) {
	            return itemsNum += item.quantity;
	        });
	        orderedItems.creditFixedItems.map(function (item) {
	            return itemsNum += item.quantity;
	        });
	        orderedItems.editableItems.map(function (item) {
	            if (item.key !== extraCreditItem.key) {
	                itemsNum += item.quantity;
	            }
	        });
	        orderedItems.fixedItems.map(function (item) {
	            if (item.key !== extraCreditItem.key) {
	                itemsNum += item.quantity;
	            }
	        });
	    }
	    return itemsNum + " " + (0, _translate.translate)("Item" + (itemsNum === 1 ? "" : "s"));
	}
	
	function getRemainingCredits(creditsData, totals) {
	    var orderTotal = creditsData.creditType === _constants2.CreditTypes.CREDIT_BY_SHARE ? creditsData : totals.orderTotal || {};
	    if (creditsData.credits > 0) return { show: true, credits: orderTotal.creditType === _constants2.CreditTypes.CREDIT_BY_SHARE ? orderTotal.remainingCredits : orderTotal.format().remainingCredits };
	    return { show: false };
	}
	
	function _roundNumber(number, numOfDecimalDigits) {
	    // Default is two digits
	    numOfDecimalDigits = numOfDecimalDigits || 2;
	
	    // rounding the number and ensuring no trailing zeros
	    var powerOfTen = Math.pow(10, numOfDecimalDigits),
	        roundedNumber = Math.round((number ? number : 0) * powerOfTen) / powerOfTen;
	    return roundedNumber;
	}
	
	function _formatNumber(number, numOfDecimalDigits, keepRemainder) {
	    // Default is two digits
	    numOfDecimalDigits = numOfDecimalDigits || 2;
	
	    var roundedNumber = _roundNumber(number, numOfDecimalDigits);
	    if (keepRemainder) {
	        roundedNumber = roundedNumber.toFixed(numOfDecimalDigits);
	    }
	    // Add , for thousands
	    return roundedNumber.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
	}
	
	function formatCredits(credits) {
	    return _formatNumber(credits, 2, false);
	}
	
	function _formatMoney(number, numOfDecimalDigits, currency) {
	    if (currency == null) currency = '$';
	
	    var numberStr = _formatNumber(number, numOfDecimalDigits, true);
	    var isNegative = false;
	
	    if (_utils.objectUtils.isNumber(number)) isNegative = number <= -0.01;
	    if (_utils.objectUtils.isString(number)) {
	        number = number.trim();
	        isNegative = number.charAt(0) == '-';
	    }
	
	    return (isNegative ? '-' : '') + currency + (isNegative ? numberStr.substr(1, numberStr.length) : numberStr);
	}
	
	exports.formatMoney = _formatMoney;
	function formatPoints(points) {
	    return _formatNumber(points, 2, true);
	}
	
	function _formatWrap(price) {
	    return _extends({}, price, {
	        format: function format() {
	            var numOfDecimalDigits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
	            var keepRemainder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            return {
	                fullPrice: _formatNumber(price.fullPrice, numOfDecimalDigits, keepRemainder),
	                priceBeforeTax: _formatNumber(price.priceBeforeTax, numOfDecimalDigits, keepRemainder),
	                tax: _formatNumber(price.tax, numOfDecimalDigits, keepRemainder),
	                extraCostAmount: _formatNumber(price.extraCostAmount, numOfDecimalDigits, keepRemainder),
	                usedCredits: _formatNumber(price.usedCredits, numOfDecimalDigits, keepRemainder),
	                remainingCredits: _formatNumber(price.remainingCredits, numOfDecimalDigits, keepRemainder)
	            };
	        },
	        formatMoney: function formatMoney() {
	            return {
	                fullPrice: _formatMoney(price.fullPrice),
	                priceBeforeTax: _formatMoney(price.priceBeforeTax),
	                tax: _formatMoney(price.tax),
	                extraCostAmount: _formatMoney(price.extraCostAmount),
	                usedCredits: _formatMoney(price.usedCredits),
	                remainingCredits: _formatMoney(price.remainingCredits)
	            };
	        }
	    });
	}
	
	function formatPrice(price) {
	    return {
	        fullPrice: _formatMoney(price.fullPrice),
	        priceBeforeTax: _formatMoney(price.priceBeforeTax),
	        tax: _formatMoney(price.tax),
	        extraCostAmount: _formatMoney(price.extraCostAmount),
	        usedCredits: _formatMoney(price.usedCredits),
	        remainingCredits: _formatMoney(price.remainingCredits),
	        couponValue: "-" + _formatMoney(price.couponValue),
	        balanceAsCredits: "-" + _formatMoney(price.balanceAsCredits)
	    };
	}
	
	function getCheckoutPrice(totals) {
	    if (totals && totals.editableTotal) return formatPrice(totals.editableTotal).fullPrice;
	    return formatPrice(0).fullPrice;
	}
	
	function getItemKeysLists(items) {
	    var listItems = [];
	    var waitListItems = [];
	    var selectedItems = getJoinSelectedItems(items);
	    for (var index in selectedItems.waitlistItems) {
	        var item = selectedItems.waitlistItems[index];
	        waitListItems.push(item.key);
	    }
	    for (var _index in selectedItems.items) {
	        var _item = selectedItems.items[_index];
	        listItems.push(_item.key);
	    }
	    return {
	        waitListItems: waitListItems,
	        listItems: listItems
	    };
	}
	
	function getWaitlistItems(items) {
	    var waitListItems = [];
	    var selectedItems = getJoinSelectedItems(items);
	    for (var index in selectedItems.waitlistItems) {
	        var item = selectedItems.waitlistItems[index];
	        for (var i = 0; i < item.quantity; i++) {
	            waitListItems.push(item.key);
	        }
	    }
	    return waitListItems;
	}
	
	function getItemPrice(item, serverStaticData, pickupsite) {
	    var price = item.price || 0;
	    if (pickupsite && item.pickupSitePriceMap && item.pickupSitePriceMap.hasOwnProperty(pickupsite)) {
	        price = item.pickupSitePriceMap[pickupsite];
	    }
	    var itemPrice = serverStaticData.isSupportSalesTax ? _roundNumber(price * 100.00 / (100.00 + (item.salesTax || 0))) : price;
	    return _formatWrap({
	        fullPrice: price,
	        priceBeforeTax: itemPrice,
	        tax: serverStaticData.isSupportSalesTax ? price - itemPrice : undefined
	    });
	}
	
	var orderValidator = exports.orderValidator = {
	    validateMinimumPerOrder: function validateMinimumPerOrder(items, minimumPerOrder, extraCost, extraCostType, credits, staticData, shareItems) {
	        var orderedItems = getOrderedItems(items, false);
	        var total = calculateOrderTotal(orderedItems, { extraCost: extraCost, extraCostType: extraCostType, credits: credits }, staticData);
	        minimumPerOrder = minimumPerOrder || 0;
	        if (staticData.showItemPoints) {
	            var totalPoints = calculateOrderPoints(orderedItems);
	            if (totalPoints < minimumPerOrder) {
	                return "In order to checkout you need to reach a total of at least " + minimumPerOrder + " points. " + "Please add " + formatPoints(minimumPerOrder - totalPoints) + " points to checkout.";
	            }
	            return;
	        }
	        var price = total && (total.priceBeforeTax || 0) + (total.tax || 0) || 0;
	        var skipCheckMinimum = staticData.checkMinimumOrderOnlyForStoreAccess && shareItems.some(function (share) {
	            return share.price > 0;
	        });
	        if (!skipCheckMinimum && price < minimumPerOrder) {
	            var formattedMin = _formatMoney(minimumPerOrder);
	            if (credits) {
	                return (0, _translate.translate)("In order to checkout your sub total order needs to exceed ") + formattedMin + ".";
	            } else if (extraCost && extraCostType === "Fixed" && total.extraCostLabel) {
	                return (0, _translate.translate)("In order to checkout, your order needs to exceed ") + formattedMin + (0, _translate.translate)(" (not including ") + total.extraCostLabel.toLowerCase() + ").";
	            } else {
	                return (0, _translate.translate)("_minimumPerOrder") + formattedMin + ".";
	            }
	        }
	    },
	    validateCouponMinimum: function validateCouponMinimum(items, extraCost, extraCostType, credits, staticData, activeOrder, coupon) {
	        if (coupon) {
	            var orderedItems = getOrderedItemsForSummary(items, activeOrder, false);
	            var total = calculateOrderTotal(orderedItems.filteredItems, { extraCost: extraCost, extraCostType: extraCostType, credits: credits }, staticData);
	            var minimumOrder = coupon.minimumOrder || 0;
	            var price = total && (total.priceBeforeTax || 0) + (total.tax || 0) || 0;
	            if (coupon.useMinimumOrder && price < minimumOrder) {
	                var formattedMin = _formatMoney(minimumOrder);
	                return (0, _translate.translate)("Order more than ") + formattedMin + (0, _translate.translate)(" to redeem the coupon.");
	            } else if (coupon.discount >= price) {
	                var formattedDiscount = _formatMoney(coupon.discount);
	                return (0, _translate.translate)("Order more than ") + formattedDiscount + (0, _translate.translate)(" to redeem the coupon.");
	            }
	        }
	    }
	};
	
	function calcTotals(isSeasonal, pickupsite, items, paymentPlan, coupon, itemsRemainingDates, remainingSchedulesDates, nextDeliveryDate, isAddSubscription, subscriptionDiscount, staticData, paymentMethod) {
	
	    var totals = [];
	    var subTotal = 0;
	    var total = 0;
	    var deliveriesNum = 1;
	    var extraCost = 0;
	    var signupFee = isAddSubscription ? 0 : pickupsite.signupFee;
	    var tax = 0;
	    var paymentPlanDiscountAmount = 0;
	
	    //Don't show totals if there are no items
	    if (items.length == 0) return {};
	    //Calc subtotal based on the payment plan
	    switch (paymentPlan.type) {
	        case _constants.PaymentPlans.P:
	            //For prepay the plan amount is the total
	            subTotal = paymentPlan.amount;
	            break;
	        default:
	            //Calc total of all items for the whole season
	            // for(let key in items){
	            //     let item = items[key];
	            items.map(function (item) {
	                var itemDeliveriesNum = calcNumberOfDeliveries(isSeasonal, item, paymentPlan, item.selectedSchedule, itemsRemainingDates, remainingSchedulesDates[item.selectedSchedule], nextDeliveryDate);
	                //item.price already includes the tax
	                var price = item.pickupSitePriceMap && item.pickupSitePriceMap.hasOwnProperty(pickupsite.key) ? item.pickupSitePriceMap[pickupsite.key] : item.price;
	                var itemPriceBeforeTax = !item.salesTax ? price : price / (1 + item.salesTax / 100);
	                var itemSubTotal = itemDeliveriesNum * itemPriceBeforeTax * item.quantity;
	                var itemTax = itemDeliveriesNum * (price - itemPriceBeforeTax) * item.quantity;
	                subTotal += itemSubTotal;
	                tax += itemTax;
	                //Calc the payment plan discount only if not add-subscription and if not an option
	                if (!isAddSubscription && !(paymentPlan.type === _constants.PaymentPlans.DistributionDynamicPrePayment && item.isAdditional)) {
	                    paymentPlanDiscountAmount += itemSubTotal * (paymentPlan.discount / 100);
	                    tax -= itemTax * (paymentPlan.discount / 100);
	                }
	                deliveriesNum = Math.max(deliveriesNum, itemDeliveriesNum);
	            });
	    }
	
	    //Calc extra cost
	    if (pickupsite.extraCost > 0) {
	        if (pickupsite.extraCostType === 'Fixed') {
	            //In case of non pro-rate need to calc the actual remaining deliveries for the extra cost
	            var actualDeliveriesNum = 0;
	            var remainingAllDates = new Set();
	            items.forEach(function (item) {
	                return remainingSchedulesDates[item.selectedSchedule].forEach(function (date) {
	                    return remainingAllDates.add(date);
	                });
	            });
	            actualDeliveriesNum = calcActualRemainingDeliveries(Array.from(remainingAllDates).sort(), itemsRemainingDates, nextDeliveryDate, paymentPlan.amount);
	
	            // The max amount is being considered when calling calcActualRemainingDeliveries()
	            // if (paymentPlan.type === PaymentPlans.DistributionDynamicPrePayment) {
	            //     actualDeliveriesNum = deliveriesNum;
	            // }
	            if (!isAddSubscription) // In add subscription the fixed cost should be already calculated
	                extraCost = pickupsite.extraCost * actualDeliveriesNum;
	        } else {
	            //Apply payment plan discount before calculating extra cost
	            extraCost = (subTotal - paymentPlanDiscountAmount) * pickupsite.extraCost / 100;
	            //Add extra cost also to the signup fee
	            signupFee *= 1 + pickupsite.extraCost / 100;
	        }
	    }
	
	    //Add the tax & extra cost only if not PaymentPlans.P
	    total = subTotal + signupFee + (paymentPlan.type !== _constants.PaymentPlans.P ? tax + extraCost : 0);
	
	    //Add subtotal row only for specific payment plans
	    var isFullSeasonPaymentPlan = paymentPlan.type === _constants.PaymentPlans.F || paymentPlan.type === _constants.PaymentPlans.AutoRecurring || paymentPlan.type === _constants.PaymentPlans.PresetRecurring;
	    var applyPercentageCoupon = isFullSeasonPaymentPlan || paymentPlan.type === _constants.PaymentPlans.DistributionDynamicPrePayment || paymentPlan.type === _constants.PaymentPlans.DynamicPrePayment;
	
	    //First apply payment plan discount (before coupon)
	    total -= paymentPlanDiscountAmount;
	
	    //Calc coupon
	    var couponDiscount = 0;
	    if (coupon && coupon.valid) if (coupon.isFixedAmount) couponDiscount = coupon.discount;else couponDiscount = total * (coupon.discount / 100);
	    //Coupon should impact the total only if fixed or for seasonal payment plan
	    if (couponDiscount && (coupon.isFixedAmount || applyPercentageCoupon)) total -= couponDiscount;
	
	    //Calc the subscription discount only if  add-subscription
	    var subscriptionDiscountAmount = isAddSubscription && subscriptionDiscount ? total * (subscriptionDiscount / 100) : 0;
	    total -= subscriptionDiscountAmount;
	
	    //Show subtotal only for seasonal
	    if (isFullSeasonPaymentPlan) totals.push({ text: "Subtotal", amount: _formatMoney(subTotal) });
	
	    //Add Tax
	    if (tax > 0) totals.push({ text: "Tax", amount: _formatMoney(tax) });
	
	    //Add signup fee row
	    if (signupFee > 0) totals.push({ text: (staticData || {}).membershipFeeLabel || "Membership Fee", amount: _formatMoney(signupFee) });
	
	    //Add extra cost row
	    if (extraCost > 0) {
	        var extraCostLabel = (staticData || {}).extraCostLabel || "Extra Fuel Charge";
	        var extraCostText = pickupsite.extraCostType === 'Fixed' ? '$' + pickupsite.extraCost + " per delivery" : pickupsite.extraCost + '%';
	        var extraCostAmount = isFullSeasonPaymentPlan ? _formatMoney(extraCost) : '';
	        totals.push({ text: extraCostLabel + " (" + extraCostText + ")", amount: extraCostAmount });
	    }
	
	    //Add Coupon row
	    if (couponDiscount > 0) {
	        var couponText = 'Coupon (' + (coupon.isFixedAmount ? '$' + coupon.discount : coupon.discount + '%') + ' discount)';
	        var couponAmount = coupon.isFixedAmount || applyPercentageCoupon ? _formatMoney(-1 * couponDiscount) : '';
	        totals.push({ text: couponText, amount: couponAmount });
	    }
	
	    //Add payment plan discount row
	    if (paymentPlanDiscountAmount > 0) totals.push({
	        text: "Special Discount (" + paymentPlan.discount + "%)",
	        amount: _formatMoney(-1 * paymentPlanDiscountAmount)
	    });
	
	    //Add subscription discount row
	    if (subscriptionDiscountAmount > 0) totals.push({
	        text: "Special Discount (" + subscriptionDiscount + "%)",
	        amount: _formatMoney(-1 * subscriptionDiscountAmount)
	    });
	
	    if (staticData.applyCreditCardFee && staticData.creditCardFee > 0 && (_constants.PaymentMethod.AUTHORIZE_DOT_NET.key === paymentMethod || _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key === paymentMethod)) {
	        var creditCardFee = total * (staticData.creditCardFee / 100);
	        total += creditCardFee;
	        totals.push({ text: staticData.creditCardFeeLabel, amount: _formatMoney(creditCardFee) });
	    }
	    //Format the text of the grand total label
	    var totalLabel = paymentPlan.type === _constants.PaymentPlans.AutoRecurring || paymentPlan.type === _constants.PaymentPlans.PresetRecurring ? "Total" : "Total due at checkout";
	
	    //Format the price text
	    var priceText = "";
	    switch (paymentPlan.type) {
	        case _constants.PaymentPlans.PresetRecurring:
	        case _constants.PaymentPlans.AutoRecurring:
	            //In case of installments the signup fee is added to the first installment (after discount)
	            signupFee *= 1 - paymentPlan.discount / 100;
	            var installmentPrice = (total - signupFee) / paymentPlan.installments;
	            priceText = signupFee == 0 ? paymentPlan.installments + " * " + _formatMoney(installmentPrice) : _formatMoney(installmentPrice + signupFee) + " + " + (paymentPlan.installments - 1) + " * " + _formatMoney(installmentPrice);
	            break;
	        case _constants.PaymentPlans.OneWeekDebit:
	            //Only membership fee should be charged
	            priceText = _formatMoney(signupFee);
	            break;
	        default:
	            priceText = _formatMoney(total);
	    }
	
	    totals.push({ text: (0, _translate.translate)(totalLabel), amount: priceText, type: "TOTAL_DUE" });
	
	    return { priceText: priceText, totals: totals };
	}
	
	function getAllItemsRemainingDeliveryDates(items, remainingScheduleDates) {
	
	    //Get all dates of relevant schedules
	    var deliveryDatesSet = new Set();
	    var schedulesSet = new Set();
	    items.map(function (item) {
	        var schedule = item.selectedSchedule ? item.selectedSchedule : item.schedules[0];
	        if (!schedulesSet.has(schedule)) {
	            schedulesSet.add(schedule);
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = remainingScheduleDates[schedule][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var date = _step.value;
	
	                    deliveryDatesSet.add(date);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    });
	
	    //Sort
	    var deliveryDates = Array.from(deliveryDatesSet.values()).sort(function (d1, d2) {
	        return d1.localeCompare(d2);
	    });
	
	    return deliveryDates;
	}
	
	function calcNumberOfDeliveries(isSeasonal, item, paymentPlan, schedule, itemsRemainingDates, remainingScheduleDates, nextDeliveryDate) {
	
	    if (paymentPlan.type === _constants.PaymentPlans.DynamicPrePayment) {
	        //paymentPlan.amount is the number of deliveries
	        return paymentPlan.amount;
	    }
	    if (paymentPlan.type === _constants.PaymentPlans.DistributionDynamicPrePayment) {
	        if (paymentPlan.amount) return calcActualRemainingDeliveries(remainingScheduleDates, itemsRemainingDates, nextDeliveryDate, paymentPlan.amount);
	        //if paymentPlan.amount == 0 then get the date of end of the month of the first delivery
	        var endOfMonth = itemsRemainingDates[0].slice(0, 8) + "31";
	        var deliveries = 0;
	        //Calc how many dates are until the end of the months
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = remainingScheduleDates[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var date = _step2.value;
	
	                if (date.localeCompare(endOfMonth) <= 0) deliveries++;else break;
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        return deliveries;
	    }
	    if (isSeasonal) {
	        var scheduleIndex = -1;
	        if (!item || !item.schedules) {
	            var error = {
	                item: item,
	                schedules: item.schedules
	            };
	            Raven.captureMessage("Schedules is undefined in basket - line 522", { extra: error });
	        } else {
	            scheduleIndex = item.schedules.findIndex(function (scheduleElem) {
	                return scheduleElem == schedule;
	            });
	        }
	        return item.weeksLeft[scheduleIndex < 0 ? 0 : scheduleIndex];
	    }
	    //If ongoing
	    return 1;
	}
	
	function calcActualRemainingDeliveries(scheduleDates, remainingScheduleDates, nextDeliveryDate, maxDeliveries) {
	    //Calc number of possible deliveries
	    var deliveries = 0;
	    var deliveryDates = remainingScheduleDates;
	    //Find the first date to start from
	    var firstIndex = remainingScheduleDates.indexOf(nextDeliveryDate);
	    if (firstIndex < 0) firstIndex = 0;
	    if (maxDeliveries && maxDeliveries > 0) deliveryDates = remainingScheduleDates.slice(firstIndex, firstIndex + maxDeliveries);
	    //Calc how many dates are in the item schedule
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        for (var _iterator3 = scheduleDates[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var date = _step3.value;
	
	            if (deliveryDates.includes(date)) deliveries++;else break;
	        }
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	
	    return deliveries;
	}
	
	function getJoinSelectedItems(shares, options) {
	    var items = [];
	    var waitlistItems = [];
	    var allItems = Object.assign({}, shares, options);
	    Object.keys(allItems).map(function (key) {
	        var item = allItems[key];
	        if (item.quantity > 0) if (item.waitList) waitlistItems.push(item);else items.push(item);
	    });
	    return { items: items, waitlistItems: waitlistItems };
	}
	
	function getDistributionsNumber(item, selectedSchedule) {
	    var scheduleIndex = selectedSchedule ? item.schedules.indexOf(selectedSchedule) : 0;
	    return item.weeksLeft ? item.weeksLeft[scheduleIndex] : 0;
	}
	
	function getNextDeliveryDate(pickupSite, items, schedules, nextDeliveryDates) {
	    if (!pickupSite || !pickupSite.deliveryDaysList) return null;
	    var pickupSiteDeliveryDay = pickupSite.deliveryDaysList[0];
	    var scheduleToDate = nextDeliveryDates[pickupSiteDeliveryDay];
	    if (items) schedules = getSelectedSchedules(items, schedules);
	    if (!scheduleToDate || schedules.length === 0) {
	        return null;
	    }
	    var date = _utils.MAX_DATE_IN_SERVER_FORMAT;
	    for (var schedule in schedules) {
	        if (schedules.hasOwnProperty(schedule)) {
	            var prospectDate = scheduleToDate[schedule];
	            if (prospectDate !== null && date > prospectDate) {
	                date = prospectDate;
	            }
	        }
	    }
	    return date === _utils.MAX_DATE_IN_SERVER_FORMAT ? scheduleToDate[Object.keys(scheduleToDate)[0]] : date;
	}
	
	function getSelectedSchedules(items, schedules) {
	    var selectedItems = items || {};
	    var selectedSchedules = {};
	    for (var i = 0; i < selectedItems.length; i++) {
	        var item = selectedItems[i];
	        if (item.selectedSchedule) {
	            selectedSchedules[item.selectedSchedule] = schedules[item.selectedSchedule];
	        }
	    }
	    return Object.keys(selectedSchedules).length > 0 ? selectedSchedules : schedules;
	}
	
	function isEBTNonEligibleItems(items) {
	    var orderedItems = getOrderedItems(items);
	    return orderedItems.filter(function (item) {
	        return (item.label || '').toLowerCase().includes('snap non eligible');
	    }).length > 0;
	}

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.subscriptionSummaryParser = subscriptionSummaryParser;
	exports.setSummary = setSummary;
	exports.setPaymentType = setPaymentType;
	exports.setPaymentPlan = setPaymentPlan;
	exports.setPaymentMethod = setPaymentMethod;
	exports.setPickupSite = setPickupSite;
	exports.setWaitListPickupSite = setWaitListPickupSite;
	exports.setPickupSitesAndDeliveryDate = setPickupSitesAndDeliveryDate;
	exports.setPickupSitesAndDeliveryDateActual = setPickupSitesAndDeliveryDateActual;
	exports.setNextDeliveryDate = setNextDeliveryDate;
	exports.setAllowOrderEditToStore = setAllowOrderEditToStore;
	exports.setEditMultiOrder = setEditMultiOrder;
	exports.setCanSaveDeliveryHold = setCanSaveDeliveryHold;
	exports.createWaitListSubscription = createWaitListSubscription;
	exports.createGuestSubscription = createGuestSubscription;
	exports.getAddSubscriptionData = getAddSubscriptionData;
	exports.setCustomAmount = setCustomAmount;
	exports.setAllowContinuePayment = setAllowContinuePayment;
	exports.setVacations = setVacations;
	exports.setRequiredMakeUpData = setRequiredMakeUpData;
	exports.setWebOrder = setWebOrder;
	exports.isCreatingSubscription = isCreatingSubscription;
	exports.isAddSubscription = isAddSubscription;
	exports.setOnPermanentHold = setOnPermanentHold;
	exports.setSubscriptionOnPermanentHold = setSubscriptionOnPermanentHold;
	
	var _actionTypes = __webpack_require__(459);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _commonActions = __webpack_require__(747);
	
	var _joinActions = __webpack_require__(752);
	
	var _fetchingActions = __webpack_require__(748);
	
	function subscriptionSummaryParser(json, staticData) {
	    var subscriptionSummary = json.subscriptionSummary;
	    var store = json.store;
	    if (subscriptionSummary) {
	        if (subscriptionSummary.shareItems) {
	            for (var i = 0; i < subscriptionSummary.shareItems.length; i++) {
	                subscriptionSummary.shareItems[i].quantity = subscriptionSummary.shareItemQuantities[i];
	                subscriptionSummary.shareItems[i].selectedSchedule = subscriptionSummary.shareSchedules[i];
	            }
	        }
	        if (subscriptionSummary.waitListItems) {
	            for (var _i = 0; _i < subscriptionSummary.waitListItems.length; _i++) {
	                subscriptionSummary.waitListItems[_i].quantity = subscriptionSummary.waitListItemQuantities[_i];
	                subscriptionSummary.waitListItems[_i].waitList = true;
	            }
	        }
	        var summary = subscriptionSummary;
	        var shareItems = [];
	        for (var key in subscriptionSummary.shareSchedules) {
	            if (subscriptionSummary.shareSchedules.hasOwnProperty(key)) {
	                var schedule = subscriptionSummary.schedules[subscriptionSummary.shareSchedules[key]];
	                if (!schedule || schedule === null) {
	                    var error = {
	                        key: key,
	                        shareSchedules: subscriptionSummary.shareSchedules,
	                        schedules: subscriptionSummary.schedules
	                    };
	                    Raven.captureMessage("Schedule is undefined in subscription summary", { extra: error });
	                } else if (schedule.dates.includes(subscriptionSummary.nextDeliveryDate)) {
	                    shareItems.push(subscriptionSummary.shareItems[key]);
	                }
	            }
	        }
	        var allSharesWithZeroPrice = shareItems && !shareItems.some(function (shareItem) {
	            return shareItem.price > 0;
	        });
	        summary.nextDeliveryDate = !store || !store.deliveryDate ? subscriptionSummary.nextDeliveryDateActual : store.deliveryDate;
	        if (allSharesWithZeroPrice) {
	            summary.extraCost = (subscriptionSummary.pickupSite || {}).extraCost;
	            summary.extraCostType = (subscriptionSummary.pickupSite || {}).extraCostType;
	        }
	        summary.canEditExistingOrder = staticData.storePaymentMethods && staticData.storePaymentMethods[0] === _constants.PaymentMethod.BALANCE.key || staticData.isChargeOnDelivery;
	        if (subscriptionSummary.makePaymentPaymentPlans) {
	            subscriptionSummary.makePaymentPaymentPlans = calcPaymentPlansPrice(subscriptionSummary.makePaymentPaymentPlans, subscriptionSummary.shareItems, subscriptionSummary.pickupSite, subscriptionSummary.discount);
	            var filteredPaymentPlans = filterPaymentPlans(subscriptionSummary.makePaymentPaymentPlans, subscriptionSummary.balance);
	            summary.singlePaymentPlans = filteredPaymentPlans.singlePaymentPlans;
	            summary.autoPaymentPlans = filteredPaymentPlans.autoPaymentPlans;
	        }
	        if (subscriptionSummary.paymentMethod !== _constants.PaymentMethod.NONE.key) {
	            summary.paymentMethodToken = subscriptionSummary.paymentMethod;
	        }
	        summary.paymentMethod = _constants.PaymentMethod.NONE.key;
	        if (subscriptionSummary.makePaymentPaymentMethods) {
	            var filteredPaymentMethods = filterPaymentMethods(subscriptionSummary.makePaymentPaymentMethods);
	            summary.singlePaymentMethods = filteredPaymentMethods.singlePaymentMethods;
	            summary.autoPaymentMethods = filteredPaymentMethods.autoPaymentMethods;
	        }
	        summary.hasToken = summary.hasPreapproval && summary.paymentMethodToken !== _constants.PaymentMethod.NONE.key;
	        summary.paymentPlan = subscriptionSummary.paymentPlan;
	        // summary.paymentType = summary.singlePaymentMethods && summary.singlePaymentMethods.length > 0 && !isEmptyObj(summary.singlePaymentPlans)?
	        //     PaymentTypes.SINGLE_PAYMENT.type:PaymentTypes.AUTO_PAYMENT.type; //Fix for FS-515
	        summary.seasons.sort(function (season, season1) {
	            return season.endDateStr < season1.endDateStr;
	        });
	        summary.isSetOnPermanentHold = summary.holdReason === _constants.SubscriptionHoldReason.ADMIN;
	        summary.origPickupSite = summary.pickupSite ? { key: summary.pickupSite.key, deliveryDays: summary.pickupSite.deliveryDays } : {};
	        return summary;
	    }
	    return {
	        nextDeliveryDate: null,
	        extraCost: null,
	        extraCostType: null,
	        credits: null,
	        hasPreapproval: null,
	        subscriptionKey: null
	    };
	}
	
	function setSummary(summary) {
	    return {
	        type: _actionTypes.SET_SUMMARY,
	        summary: summary
	    };
	}
	
	function setPaymentType(paymentType) {
	    return {
	        type: _actionTypes.SET_PAYMENT_TYPE,
	        paymentType: paymentType
	    };
	}
	
	function setPaymentPlan(paymentPlan, paymentType) {
	    return {
	        type: _actionTypes.SET_PAYMENT_PLAN,
	        paymentPlan: paymentPlan,
	        paymentType: paymentType
	    };
	}
	
	function setPaymentMethod(paymentMethod, paymentType) {
	    return {
	        type: _actionTypes.SET_PAYMENT_METHOD,
	        paymentMethod: paymentMethod,
	        paymentType: paymentType
	    };
	}
	
	function setPickupSite(pickupSite) {
	    return function (dispatch, getState) {
	        var currentPickupSite = (getState().summary || {}).pickupSite;
	        //Clear selection if pickup site changed
	        if (currentPickupSite) {
	            dispatch((0, _joinActions.clearSharesSelection)());
	        }
	        dispatch(function (pickupSite) {
	            return {
	                type: _actionTypes.SET_PICKUP_SITE,
	                pickupSite: pickupSite
	            };
	        }(pickupSite));
	    };
	}
	
	function setWaitListPickupSite(waitListSite) {
	    return {
	        type: _actionTypes.SET_WAIT_LIST_PICKUP_SITE,
	        waitListSite: waitListSite
	    };
	}
	function setPickupSitesAndDeliveryDate(nextDeliveryDate, pickupSite, waitListSite) {
	    return {
	        type: _actionTypes.SET_PICKUP_SITES_DELIVERY_DATE,
	        nextDeliveryDate: nextDeliveryDate,
	        pickupSite: pickupSite,
	        waitListSite: waitListSite
	    };
	}
	
	function setPickupSitesAndDeliveryDateActual(pickupSite, nextDeliveryDate) {
	    return function (dispatch) {
	        dispatch(setPickupSite(pickupSite));
	        dispatch(setNextDeliveryDate(nextDeliveryDate));
	    };
	    // return {
	    //     type: SET_PICKUP_SITES_DELIVERY_DATE_ACTUAL,
	    //     pickupSite,
	    //     nextDeliveryDate
	    // };
	}
	
	function setNextDeliveryDate(nextDeliveryDate) {
	    return {
	        type: _actionTypes.SET_SUBSCRIPTION_NEXT_DELIVERY_DATE,
	        nextDeliveryDate: nextDeliveryDate
	    };
	}
	
	function setAllowOrderEditToStore(flag) {
	    return {
	        type: _actionTypes.SET_ALLOW_ORDER_EDIT,
	        allowOrderEdit: flag
	    };
	}
	
	function setEditMultiOrder(flag) {
	    return {
	        type: _actionTypes.SET_MULTI_ORDER_EDIT,
	        editMultiOrder: flag
	    };
	}
	
	function calcPaymentPlansPrice(paymentPlans, shareItems, pickupSite, discount) {
	    var totalPrice = 0;
	    if (shareItems) shareItems.map(function (item) {
	        totalPrice += item.price * item.quantity;
	    });
	    if (pickupSite && pickupSite.extraCost > 0) if (pickupSite.extraCostType === 'Fixed') totalPrice += pickupSite.extraCost;else totalPrice += totalPrice * (pickupSite.extraCost / 100);
	
	    if (discount) totalPrice -= totalPrice * (discount / 100);
	
	    paymentPlans.map(function (plan) {
	        if (plan.type === _constants.PaymentPlans.DynamicPrePayment) {
	            plan.totalToPay = plan.amount * totalPrice;
	        }
	    });
	    return paymentPlans;
	}
	
	function filterPaymentPlans(paymentPlans, balance) {
	    if (!paymentPlans) {
	        return [];
	    }
	    return {
	        singlePaymentPlans: paymentPlans.filter(function (paymentPlan) {
	            if (paymentPlan.isPayMyDebit && balance > -0.01) {
	                return false;
	            }
	            return _constants.PaymentPlansSinglePayment.includes(paymentPlan.type);
	        }),
	        autoPaymentPlans: paymentPlans.filter(function (paymentPlan) {
	            return _constants.PaymentPlansAutoPayment.includes(paymentPlan.type);
	        })
	    };
	}
	
	function filterPaymentMethods(paymentMethods) {
	    if (!paymentMethods) {
	        return [];
	    }
	    return {
	        singlePaymentMethods: paymentMethods.filter(function (paymentMethod) {
	            return _constants.PaymentMethodsSinglePayment.includes(paymentMethod);
	        }),
	        autoPaymentMethods: paymentMethods.filter(function (paymentMethod) {
	            return _constants.PaymentMethodsAutoPayment.includes(paymentMethod);
	        })
	    };
	}
	function setCanSaveDeliveryHold(canSaveDeliveryHold) {
	    return {
	        type: _actionTypes.SET_CAN_SAVE_DELIVERY_HOLD,
	        canSaveDeliveryHold: canSaveDeliveryHold
	    };
	}
	function createWaitListSubscription(memberKey, waitListItems) {
	    return function (dispatch, getState) {
	        var fetchUrl = '/dispatcher/SignupService.createWaitListSubscription';
	        var data = {
	            farmKey: getState().staticData.farmKey,
	            seasonKey: getState().staticData.seasonKey,
	            memberKey: memberKey,
	            waitListItems: JSON.stringify(waitListItems)
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.CREATE_SUBSCRIPTION));
	        return (0, _utils.ajax)(fetchUrl, data).then(function () {
	            dispatch((0, _joinActions.gotoStep)(_constants.JoinSteps.THANK_YOU));
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            return dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function createGuestSubscription(memberKey, pickupSiteKey) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/SignupService.createGuestSubscription';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            seasonKey: getState().staticData.seasonKey,
	            memberKey: memberKey,
	            pickupSiteKey: pickupSiteKey
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.CREATE_SUBSCRIPTION));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (response) {
	            return handleCreateGuestSubscriptionResponse(response, state.staticData);
	        }).then(dispatch((0, _fetchingActions.dataFetched)())).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function handleCreateGuestSubscriptionResponse(response, staticData) {
	    if (response.statusCode === "OK") {
	        window.location.assign((0, _utils.redirectPage)(_constants.URLs.STORE, staticData));
	    }
	}
	
	function getAddSubscriptionData(subscriptionKey) {
	    return function (dispatch, getState) {
	        var state = getState();
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOAD_SIGNUP_DATA));
	        if (!state.memberDetails.key) {
	            window.location.assign((0, _utils.redirectPage)(_constants.URLs.ACCOUNT, state.staticData));
	            return;
	        }
	        var fetchUrl = '/dispatcher/WebStoreService.getSubscriptionSummary';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            seasonKey: state.staticData.seasonKey,
	            memberKey: state.memberDetails.key,
	            subscriptionKey: subscriptionKey
	        };
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            return parseSummaryData(json);
	        }).then(function (summary) {
	            dispatch(setSummary(summary));
	            dispatch((0, _joinActions.getSignupData)(_constants.JoinModes.ADD));
	            dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error, { action: getAddSubscriptionData, args: [subscriptionKey] }));
	        });
	    };
	}
	
	function parseSummaryData(summary) {
	    if (summary.shareItems) {
	        for (var i = 0; i < summary.shareItems.length; i++) {
	            summary.shareItems[i].quantity = summary.shareItemQuantities[i];
	            summary.shareItems[i].selectedSchedule = summary.shareSchedules[i];
	        }
	    }
	    if (summary.waitListItems) {
	        for (var _i2 = 0; _i2 < summary.waitListItems.length; _i2++) {
	            summary.waitListItems[_i2].quantity = summary.waitListItemQuantities[_i2];
	            summary.waitListItems[_i2].waitList = true;
	        }
	    }
	    return summary;
	}
	
	function setCustomAmount(customAmount) {
	    return {
	        type: _actionTypes.SET_CUSTOM_AMOUNT,
	        customAmount: customAmount
	    };
	}
	function setAllowContinuePayment(allowContinuePayment) {
	    return {
	        type: _actionTypes.SET_ALLOW_CONTINUE_PAYMENT,
	        allowContinuePayment: allowContinuePayment
	    };
	}
	
	function setVacations(vacationStart, vacationEnd) {
	    return {
	        type: _actionTypes.SET_VACATIONS,
	        vacationStart: vacationStart,
	        vacationEnd: vacationEnd
	    };
	}
	
	function setRequiredMakeUpData(requiredMakeUpSchedules, requiredMakeUpSchedulesCount, requiredMakeUpSchedulesDates) {
	    var requiredMakeUpData = [];
	    if (requiredMakeUpSchedules) {
	        for (var i = 0; i < requiredMakeUpSchedules.length; i++) {
	            for (var j = 0; j < requiredMakeUpSchedulesCount[i]; j++) {
	                requiredMakeUpData.push({ schedule: requiredMakeUpSchedules[i], dates: requiredMakeUpSchedulesDates[i].sort() });
	            }
	        }
	    } else {
	        requiredMakeUpData = undefined;
	    }
	    return {
	        type: _actionTypes.SET_REQUIRED_MAKE_UP_DATA,
	        requiredMakeUpData: requiredMakeUpData
	    };
	}
	
	function setWebOrder(webOrderKey) {
	    return {
	        type: _actionTypes.SET_WEB_ORDER,
	        webOrderKey: webOrderKey
	    };
	}
	function isCreatingSubscription(isCreatingSubscription) {
	    return {
	        type: _actionTypes.SET_CREATEING_SUBSCRIPTION,
	        isCreatingSubscription: isCreatingSubscription
	    };
	}
	function isAddSubscription() {
	    var params = (0, _utils.getUrlParams)();
	    if (params.mode === 'add') {
	        var subscriptionKey = params.s;
	        if (subscriptionKey) return true;
	    }
	    return false;
	}
	
	function setOnPermanentHold(isSetOnPermanentHold) {
	    return {
	        type: _actionTypes.SET_ON_PERMANENT_HOLD,
	        isSetOnPermanentHold: isSetOnPermanentHold
	    };
	}
	
	function setSubscriptionOnPermanentHold() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.setSubscriptionOnPermanentHold';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            subscriptionKey: state.summary.key,
	            isOnPermanentHold: state.summary.isSetOnPermanentHold
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.UPDATE_VACATION));
	        return (0, _utils.ajax)(fetchUrl, data).then(function () {
	            window.location.reload(true);
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.buildSubscriptionFromState = buildSubscriptionFromState;
	function buildSubscriptionFromState(state) {
	    var signupData = state.signupData;
	    var selectedData = signupData.selectedData || {};
	    var summary = state.summary;
	    var subscription = {};
	    subscription.pickupSite = summary.pickupSite.key;
	    subscription.paymentPlan = selectedData.selectedPaymentPlan ? selectedData.selectedPaymentPlan.key : undefined;
	    subscription.pickupSiteWaitList = summary.waitListSite ? summary.waitListSite.key : undefined;
	    subscription.signupComments = selectedData.signupComments;
	    if (selectedData.homeDeliveryInstructions) {
	        subscription.signupComments = (subscription.signupComments || '') + '@@@' + selectedData.homeDeliveryInstructions;
	    }
	    if (selectedData.coupon) subscription.coupon = selectedData.coupon.id;
	
	    var shares = signupData.sharesData.shares;
	    var options = signupData.sharesData.options;
	    var sharesAndOptions = Object.assign({}, shares, options);
	    var shareItems = [];
	    var shareItemPrices = [];
	    var shareItemQuantities = [];
	    var shareItemSchedules = [];
	    var waitListItems = [];
	
	    for (var key in sharesAndOptions) {
	        var item = shares.hasOwnProperty(key) ? shares[key] : options[key];
	        if (item.quantity > 0) {
	            if (item.waitList) {
	                waitListItems.push(item.key);
	            } else {
	                shareItems.push(item.key);
	                shareItemPrices.push(item.price);
	                shareItemQuantities.push(item.quantity);
	                shareItemSchedules.push(item.selectedSchedule);
	            }
	        }
	    }
	    subscription.shareItems = shareItems;
	    subscription.shareItemPrices = shareItemPrices;
	    subscription.shareItemQuantities = shareItemQuantities;
	    subscription.shareItemSchedules = shareItemSchedules;
	    subscription.waitListItems = waitListItems;
	
	    return subscription;
	}

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setMessageData = setMessageData;
	exports.messageDataParser = messageDataParser;
	exports.getStoreCloseMessage = getStoreCloseMessage;
	
	var _actionTypes = __webpack_require__(459);
	
	var _constants = __webpack_require__(463);
	
	var _translate = __webpack_require__(464);
	
	function setMessageData(messageData) {
	    return {
	        type: _actionTypes.MESSAGE_DATA,
	        messageData: messageData
	    };
	}
	
	function messageDataParser(messageData, initialData) {
	    var flowType = initialData.flowType;
	    var isSupportGuestMembers = initialData.staticData.isSupportGuestMembers;
	    var allowUpdateVacation = initialData.staticData.allowUpdateVacation;
	    var contactMessage = (0, _translate.translate)("_contactTheFarm") + " " + " (<a href=\"mailto:" + initialData.staticData.farmEmail + "\">" + initialData.staticData.farmEmail + "</a>) " + (0, _translate.translate)("_contactToFarm2") + "<a target='_blank' href=\"" + initialData.staticData.farmWebSiteUrl + "\">" + initialData.staticData.farmWebSiteUrl + "</a>";
	    if (messageData) {
	        if (initialData.staticData.isPastSeason && flowType === _constants.URLs.JOIN) {
	            var customMessage = initialData.staticData.farmUrl === 'greengardens' ? 'To sign up for the Green Box, go to <a href="https://https://www.greengardensfarm.com/boxcsa">greengardensfarm.com/boxcsa</a><br>The To Go Box was a temporary program in quick response to Covid-19.<br>' + 'The Green Box is nearly identical with the same selections & flexibility. Questions? Email us at <a href="mailto:greenboxhelp@gmail.com">greenboxhelp@gmail.com</a>' : undefined;
	            var body = customMessage || (0, _translate.translate)("_seasonEnded").replace("{0}", initialData.staticData.seasonTitle) + contactMessage;
	            return {
	                messageTitle: initialData.staticData.seasonTitle,
	                messageBody: body
	            };
	        }
	        if (messageData.status === _constants.SubscriptionStatuses.WAITLIST_SUBSCRIPTION) {
	            return {
	                messageTitle: _constants.Messages.WAITLIST_SUBSCRIPTION.title,
	                messageBody: _constants.Messages.WAITLIST_SUBSCRIPTION.body
	            };
	        }
	        if (messageData.status === _constants.SubscriptionStatuses.SUBSCRIPTION_EXISTS && flowType !== _constants.URLs.ACCOUNT) {
	            var link = window.location.origin + "/" + _constants.URLs.ACCOUNT + "/" + initialData.staticData.farmUrl + "/" + initialData.staticData.seasonUrl;
	            return {
	                messageTitle: _constants.Messages.SUBSCRIPTION_EXISTS.title,
	                messageBody: _constants.Messages.SUBSCRIPTION_EXISTS.body + "</br></br><a class='no-subscription-join-button' href=" + link + "><button class='button btn btn-primary'>Open My Account</button></a>"
	            };
	        }
	        //Login to store with member without subscription
	        //In case farm is set without guest user
	        if (messageData.status === _constants.SubscriptionStatuses.NO_SUBSCRIPTION
	        // && !isSupportGuestMembers //Show join button to all farms
	        ) {
	                if (flowType === _constants.URLs.ACCOUNT) {
	                    if (initialData.staticData.seasonRolloverEnabled) {
	                        return {
	                            status: _constants.SubscriptionStatuses.ROLLOVER_ENABLED
	                        };
	                    }
	                    var path = window.location.origin + "/" + _constants.URLs.JOIN + "/" + initialData.staticData.farmUrl + (initialData.staticData.seasonUrl ? "/" + initialData.staticData.seasonUrl : "");
	                    var message = (0, _translate.translate)("_noSubscription");
	                    if (!initialData.staticData.isPastSeason) {
	                        message += "<a class='no-subscription-join-button' href=" + path + "><button class='button btn btn-primary'>" + (0, _translate.translate)("Summary_Account.join") + "</button></a>";
	                    }
	                    return {
	                        messageTitle: _constants.Messages.NO_SUBSCRIPTION.title,
	                        messageBody: message
	                    };
	                }
	                var _link = window.location.origin + "/" + _constants.URLs.JOIN + "/" + initialData.staticData.farmUrl + "/" + initialData.staticData.seasonUrl + (!initialData.staticData.isSupportGuestMembers ? '' : '?mode=guest');
	                return {
	                    messageTitle: _constants.Messages.NO_SUBSCRIPTION.title,
	                    messageBody: _constants.Messages.NO_SUBSCRIPTION.body + (0, _translate.translate)("Please click") + " <a href=" + _link + "><b>" + (0, _translate.translate)("here") + "</b></a> " + (0, _translate.translate)("_setYourSubscription")
	                };
	            }
	
	        if (messageData.status === _constants.SubscriptionStatuses.HOLD_SUBSCRIPTION) {
	            //Login with Member on permanent hold
	            if (messageData.holdReason === _constants.SubscriptionHoldReason.ADMIN) {
	                if (flowType === _constants.URLs.ACCOUNT) {
	                    var _message = initialData.staticData.accountPermanentHoldMessage || (0, _translate.translate)("subscriptionOnHold") + "<br/>" + (initialData.staticData.allowChangePermanentHold ? 'You can reactivate it from the Delivery Hold tab.' : contactMessage);
	                    return {
	                        messageTitle: _constants.Messages.HOLD_SUBSCRIPTION.ADMIN.title,
	                        messageBody: _message
	                    };
	                }
	                return {
	                    messageTitle: _constants.Messages.HOLD_SUBSCRIPTION.ADMIN.title,
	                    messageBody: _constants.Messages.HOLD_SUBSCRIPTION.ADMIN.body
	                };
	            }
	            //Login with member on temporary hold from type new (due to signup during order delay)
	            if (messageData.holdReason === _constants.SubscriptionHoldReason.NEW && flowType === _constants.URLs.STORE && (!initialData.staticData.allowWebOrdersForFutureDate || initialData.creditType === _constants.CreditTypes.CREDIT_BY_SHARE && initialData.credits === 0)) {
	                return {
	                    messageTitle: _constants.Messages.HOLD_SUBSCRIPTION.NEW.title,
	                    messageBody: _constants.Messages.HOLD_SUBSCRIPTION.NEW.body
	                };
	            }
	            //Login with member scheduled on hold for next delivery date
	            // and farm is not set with Allow web order for future dates
	            if (messageData.holdReason === _constants.SubscriptionHoldReason.VACATION) {
	                if (!allowUpdateVacation) {
	                    return {
	                        messageTitle: _constants.Messages.HOLD_SUBSCRIPTION.VACATION.title,
	                        messageBody: _constants.Messages.HOLD_SUBSCRIPTION.VACATION.body
	                    };
	                } else {
	                    return {
	                        messageTitle: _constants.Messages.HOLD_SUBSCRIPTION.VACATION_ALLOW_CHANGE.title,
	                        messageBody: _constants.Messages.HOLD_SUBSCRIPTION.VACATION_ALLOW_CHANGE.body
	                    };
	                }
	            }
	        }
	        //Login with Member with canceled subscription
	        if (messageData.status === _constants.SubscriptionStatuses.SUBSCRIPTION_CANCELED) {
	            if (flowType === _constants.URLs.ACCOUNT) {
	                var _message2 = (0, _translate.translate)("subscriptionCanceled") + "<br/>" + contactMessage;
	                return {
	                    messageTitle: _constants.Messages.SUBSCRIPTION_CANCELED.title,
	                    messageBody: _message2
	                };
	            }
	            return {
	                messageTitle: _constants.Messages.SUBSCRIPTION_CANCELED.title,
	                messageBody: _constants.Messages.SUBSCRIPTION_CANCELED.body
	            };
	        }
	        //Member subscription doesn’t have next delivery date as
	        // the schedule doesn’t have defined future dates.
	        if (messageData.status === _constants.SubscriptionStatuses.NO_FUTURE_DELIVERIES) {
	            return {
	                messageTitle: _constants.Messages.NO_FUTURE_DELIVERIES.title,
	                messageBody: _constants.Messages.NO_FUTURE_DELIVERIES.body
	            };
	        }
	        //Subscription canceled but in wait list
	        if (messageData.status === _constants.SubscriptionStatuses.STORE_WAITLIST_SUBSCRIPTION) {
	            return {
	                messageTitle: _constants.Messages.STORE_WAITLIST_SUBSCRIPTION.title,
	                messageBody: _constants.Messages.STORE_WAITLIST_SUBSCRIPTION.body
	            };
	        }
	        // Load webstore when payment is processing
	        // The WebOrder.state=INCOMPLETE
	        if (messageData.status === _constants.SubscriptionStatuses.PROCESSING_ORDER || messageData.status === _constants.SubscriptionStatuses.PROCESSING_SUBSCRIPTION) {
	            return {
	                messageTitle: _constants.Messages.PROCESSING_ORDER.title,
	                messageBody: _constants.Messages.PROCESSING_ORDER.body
	            };
	        }
	        // Store is closed ­ Based on store open close hours
	        if (messageData.status === _constants.SubscriptionStatuses.STORE_CLOSED) {
	            if (!initialData.staticData.isMultipleActiveOrdersEnabled) {
	                var _body = messageData.openingHours ? (0, _translate.translate)("storeClosed").replace("{0}", messageData.openingHours) : (0, _translate.translate)("storeClosedNoHours");
	                if (initialData.staticData.storeCloseAdditionalMessage) {
	                    _body += '<br/>' + initialData.staticData.storeCloseAdditionalMessage;
	                }
	                return {
	                    messageTitle: _constants.Messages.STORE_CLOSED.title,
	                    messageBody: _body
	                };
	            } else {
	                return { isStoreClosedWithMultiOrders: true };
	            }
	        } else {
	            return {};
	        }
	    }
	}
	
	function getStoreCloseMessage(storeData, storeCloseAdditionalMessage) {
	    if (storeData.status === _constants.SubscriptionStatuses.STORE_CLOSED) {
	        var body = storeData.openingHours ? 'Sorry, the web store is closed but will reopen for you to place your order from ' + storeData.openingHours + '.' : 'Sorry, the web store is closed.';
	        if (storeCloseAdditionalMessage) {
	            body += '<br/>' + storeCloseAdditionalMessage;
	        }
	        return {
	            messageTitle: 'Store Closed',
	            messageBody: body
	        };
	    }
	}

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactFarmModal = function (_React$Component) {
	    _inherits(ContactFarmModal, _React$Component);
	
	    function ContactFarmModal() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ContactFarmModal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactFarmModal.__proto__ || Object.getPrototypeOf(ContactFarmModal)).call.apply(_ref, [this].concat(args))), _this), _this.closeModal = function () {
	            _this.props.onClose();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ContactFarmModal, [{
	        key: "render",
	        value: function render() {
	            var message = "<div>To contact " + this.props.farmName + "</div><div>email <a href=\"mailto:" + this.props.farmEmail + "\">" + this.props.farmEmail + "</a></div>" + "<div>visit the website at <a target=\"_blank\" href=\"" + this.props.farmWebSiteUrl + "\">" + this.props.farmWebSiteUrl + "</a></div>" + "<div>or reach them by phone " + this.props.farmPhone + "</div>";
	            return _react2.default.createElement(_ModalPopup2.default, {
	                onClose: this.closeModal,
	                message: message,
	                middle: { text: (0, _translate.translate)('Close'), callback: this.closeModal } });
	        }
	    }]);
	
	    return ContactFarmModal;
	}(_react2.default.Component);
	
	exports.default = ContactFarmModal;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	var _popup = __webpack_require__(763);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalPopup = function (_React$Component) {
	    _inherits(ModalPopup, _React$Component);
	
	    function ModalPopup() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ModalPopup);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalPopup.__proto__ || Object.getPrototypeOf(ModalPopup)).call.apply(_ref, [this].concat(args))), _this), _this.closeModal = function () {
	            if (_this.props.onClose) _this.props.onClose.apply();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ModalPopup, [{
	        key: "render",
	        value: function render() {
	            if (!this.props.middle && !this.props.right) return null;
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { className: "modal-popup", show: true, onHide: this.closeModal },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    this.props.title ? _react2.default.createElement("div", { className: "modal-title", dangerouslySetInnerHTML: { __html: (0, _translate.translate)(this.props.title) } }) : undefined,
	                    _react2.default.createElement("div", { className: "modal-message", dangerouslySetInnerHTML: { __html: (0, _translate.translate)(this.props.message) } }),
	                    this.props.middle ? _react2.default.createElement(
	                        "div",
	                        { className: "one-button" },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { id: "modalButton", className: "button", bsStyle: "primary",
	                                onClick: this.props.middle.callback },
	                            (0, _translate.translate)(this.props.middle.text)
	                        )
	                    ) : _react2.default.createElement(
	                        "div",
	                        { className: "two-buttons" },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { id: "modalPopupRightButton", className: "button pull-right", bsStyle: "primary",
	                                onClick: this.props.right.callback },
	                            (0, _translate.translate)(this.props.right.text)
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { id: "modalPopupLeftButton", className: "button pull-left leave",
	                                onClick: this.props.left.callback },
	                            (0, _translate.translate)(this.props.left.text)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalPopup;
	}(_react2.default.Component);
	
	exports.default = ModalPopup;

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */,
/* 765 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.loadItems = loadItems;
	exports.loadCategories = loadCategories;
	exports.setStoreCreditsData = setStoreCreditsData;
	exports.setStoreCreditsRemaining = setStoreCreditsRemaining;
	exports.changeItemQuantityAction = changeItemQuantityAction;
	exports.changeExtraItemQuantityAction = changeExtraItemQuantityAction;
	exports.showLoginSignupModal = showLoginSignupModal;
	exports.saveDraftOrder = saveDraftOrder;
	exports.loadData = loadData;
	exports.setAllowOrderEditFlag = setAllowOrderEditFlag;
	exports.setEditMultiOrderFlag = setEditMultiOrderFlag;
	exports.checkRemovePath = checkRemovePath;
	exports.getStoreDataAndSubmit = getStoreDataAndSubmit;
	exports.updateStoreDataAvailability = updateStoreDataAvailability;
	exports.updateStoreItemAvailability = updateStoreItemAvailability;
	exports.updateItems = updateItems;
	exports.updateItemsAvailability = updateItemsAvailability;
	exports.activeOrderParser = activeOrderParser;
	exports.calculateAllTotals = calculateAllTotals;
	exports.calculateOrdersTotals = calculateOrdersTotals;
	exports.updateTotals = updateTotals;
	exports.updateItemsAvailabilityFromOrder = updateItemsAvailabilityFromOrder;
	exports.hasCoupons = hasCoupons;
	exports.hasAlreadyCoupon = hasAlreadyCoupon;
	exports.applyCoupon = applyCoupon;
	exports.setCouponAndUpdateSummary = setCouponAndUpdateSummary;
	exports.setCoupon = setCoupon;
	
	var _utils = __webpack_require__(485);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _actionTypes = __webpack_require__(459);
	
	var _commonActions = __webpack_require__(747);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _storeCheckoutActions = __webpack_require__(756);
	
	var _messagePageActions = __webpack_require__(760);
	
	var _storeItemsListReducer = __webpack_require__(462);
	
	var _constants = __webpack_require__(463);
	
	var _basket = __webpack_require__(757);
	
	var _recurringOrderActions = __webpack_require__(767);
	
	var _itemCardActions = __webpack_require__(768);
	
	var _storage = __webpack_require__(460);
	
	function loadItems(data) {
	    return {
	        type: _actionTypes.LOAD_ITEMS,
	        data: data
	    };
	}
	
	function loadCategories(categories) {
	    return {
	        type: _actionTypes.LOAD_CATEGORIES,
	        categories: categories
	    };
	}
	
	function setStoreCreditsData(storeCreditsData) {
	    return {
	        type: _actionTypes.STORE_CREDITS_DATA,
	        storeCreditsData: storeCreditsData
	    };
	}
	
	function setStoreCreditsRemaining(remainingCredits) {
	    return {
	        type: _actionTypes.SET_REMAINING_CREDITS,
	        remainingCredits: remainingCredits
	    };
	}
	
	function changeItemQuantityAction(key, newQuantity) {
	    return {
	        type: _actionTypes.CHANGE_ITEM_QUANTITY,
	        key: key,
	        newQuantity: newQuantity
	    };
	}
	
	function changeExtraItemQuantityAction(key, newQuantity) {
	    return {
	        type: _actionTypes.CHANGE_EXTRA_ITEM_QUANTITY,
	        key: key,
	        newQuantity: newQuantity
	    };
	}
	
	function showLoginSignupModal(show) {
	    return {
	        type: _actionTypes.SHOW_LOGIN_SIGNUP_MODAL,
	        show: show
	    };
	}
	
	function saveDraftOrder() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var orderStatus = state.orderStatus || {};
	        var currentOrder = orderStatus.currentOrder || {};
	        var itemsList = state.itemsList;
	        var draftOrder = {};
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = Object.values(currentOrder)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var draftItem = _step.value;
	
	                var item = itemsList[draftItem.key] || {};
	                draftOrder[draftItem.key] = Object.assign({}, item, { quantity: draftItem.quantity });
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        (0, _storage.setDraftOrderInStorage)(draftOrder);
	    };
	}
	
	function loadDraftItems(store) {
	    return function (dispatch) {
	        if ((store.messageData || {}).messageTitle) {
	            return;
	        }
	        var draftOrder = (0, _storage.getDraftOrderFromStorage)();
	        if (draftOrder) {
	            if (store.activeOrder) {
	                dispatch((0, _messagePageActions.setMessageData)({
	                    messageTitle: 'Order already exists',
	                    messageBody: 'You already have an existing order. Click continue to make changes to it. The recent items you have added to the cart were not saved.',
	                    allowContinue: true
	                }));
	                return;
	            }
	            var unavailableItems = {};
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = Object.values(draftOrder)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var draftItem = _step2.value;
	
	                    var item = store.items[draftItem.key];
	                    if (item) {
	                        dispatch((0, _itemCardActions.changeItemQuantity)(item, draftItem.quantity, 0));
	                    } else {
	                        unavailableItems[draftItem.key] = draftItem.title;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            if (Object.keys(unavailableItems).length > 0) {
	                dispatch((0, _messagePageActions.setMessageData)({
	                    messageTitle: 'Unavailable items',
	                    messageBody: 'Due to inventory changes we could not restore the following items in your cart - ' + Object.values(unavailableItems).join(', '),
	                    allowContinue: true
	                }));
	            }
	        }
	    };
	}
	
	function loadData(initialData) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = getFetchUrl(initialData.memberKey);
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: initialData.memberKey,
	            seasonKey: state.staticData.seasonKey
	        };
	        if (state.staticData.params && state.staticData.params.segment) data["segment"] = state.staticData.params.segment;
	        if (state.staticData.params && state.staticData.params.p) data["pickupSiteKey"] = state.staticData.params.p;
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOAD_STORE_DATA));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.error) throw json.error;
	            initialData["staticData"] = state.staticData;
	            return storeParser(json, initialData);
	        }).then(function (store) {
	            dispatch(setStoreCreditsData(store.creditsData));
	            dispatch((0, _subscriptionSummaryActions.setSummary)(store.summary));
	            dispatch((0, _commonActions.setActiveOrder)(store.activeOrder, false));
	            dispatch(loadCategories(store.categories));
	            dispatch(loadItems(store.items));
	            dispatch(setAllowOrderEditFlag());
	            dispatch(hasCoupons(store.hasCoupons));
	            dispatch(updateItemsAvailabilityFromOrder(store.activeOrder, store.items));
	            dispatch(calculateAllTotals());
	            dispatch((0, _messagePageActions.setMessageData)(store.messageData));
	            dispatch(setEditMultiOrderFlag());
	            if (store.recurringOrder) {
	                dispatch((0, _recurringOrderActions.setRecurringOrderData)(store.recurringOrder));
	            }
	            dispatch(loadDraftItems(store));
	            dispatch(checkRemovePath(store));
	            dispatch((0, _commonActions.setShouldReloadData)(false));
	            dispatch((0, _fetchingActions.dataFetched)());
	            if (state.staticData.isSupportGuestMembers && store.summary.status === _constants.SubscriptionStatuses.NO_SUBSCRIPTION) {
	                var path = (0, _utils.redirectPage)(_constants.URLs.JOIN, state.staticData) + "?mode=guest";
	                window.location.assign(path);
	            }
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error, { action: function action() {
	                    return function (dispatch) {
	                        window.location.reload(true);
	                    };
	                }, args: [] }));
	        });
	    };
	}
	
	function setAllowOrderEditFlag() {
	    return function (dispatch, getStore) {
	        var state = getStore();
	        var orderStatus = state.orderStatus || {};
	        var canEditExisitingOrder = state.staticData.confirmEditExistingOrder ? false : (state.summary || {}).canEditExistingOrder;
	        var flag = canEditExisitingOrder === false && orderStatus.activeOrder && Object.keys(orderStatus.activeOrder).length > 0 && !state.orderStatus.isChanged ? false : true;
	        dispatch((0, _subscriptionSummaryActions.setAllowOrderEditToStore)(flag));
	    };
	}
	
	function setEditMultiOrderFlag() {
	    return function (dispatch, getStore) {
	        var state = getStore();
	        var flag = !(state.staticData.isMultipleActiveOrdersEnabled && state.summary.secondNextDeliveryDate !== undefined);
	        dispatch((0, _subscriptionSummaryActions.setEditMultiOrder)(flag));
	    };
	}
	
	//TODO clean path to not include payments nor echeck
	function checkRemovePath() {
	    return function (dispatch) {
	        var endPath = '';
	        if (window.location.pathname.endsWith('pay')) {
	            endPath = 'pay';
	        } else if (window.location.pathname.endsWith('checkout')) {
	            endPath = 'checkout';
	        } else if (window.location.pathname.endsWith('thankyou')) {
	            endPath = 'thankyou';
	        }
	        var removedPath = (0, _utils.removePath)(endPath);
	        if (removedPath.startsWith('/store/') && window.location.hash) removedPath += window.location.hash;
	        dispatch((0, _reactRouterRedux.replace)(removedPath));
	    };
	}
	
	function getStoreDataAndSubmit(staticData, memberKey, subscriptionKey, orderKey, items, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method, isChargeOnDelivery) {
	    return function (dispatch, getState) {
	        var state = getState();
	        if ((0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT)) {
	            return;
	        }
	        var activeOrder = (state.orderStatus || {}).activeOrder;
	        var fetchUrl = '/dispatcher/WebStoreService.getStoreDataMember';
	        var data = {
	            farmKey: staticData.farmKey,
	            memberKey: memberKey,
	            seasonKey: staticData.seasonKey
	        };
	        if (state.staticData.params && state.staticData.params.p) data["pickupSiteKey"] = state.staticData.params.p;
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        var skipUnavailableItemsCheck = staticData.updateItemAvailabilityOnItemQuantityChange;
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.error) throw json.error;
	            //check store hours if ok then continue else show store close message
	            var storeMessageData = (0, _messagePageActions.getStoreCloseMessage)(json.store, state.staticData.storeCloseAdditionalMessage);
	            if (storeMessageData && !state.staticData.isMultipleActiveOrdersEnabled && !state.summary.secondNextDeliveryDate) {
	                dispatch((0, _commonActions.setDirty)(false));
	                dispatch((0, _messagePageActions.setMessageData)(storeMessageData));
	                dispatch((0, _fetchingActions.dataFetched)());
	            } else {
	                var extraCreditItem = state.storeCreditsData.extraCreditItem || {};
	                var storeItems = itemsParser(json.store);
	                var itemsDivided = (0, _basket.getOrderedItemsForSummary)(items, activeOrder, canEditExistingOrder);
	                var editableItems = itemsDivided.editableItems.concat(itemsDivided.creditEditableItems);
	                var unAvailableItems = {};
	                var itemsRemoved = 0;
	                var returnedCredits = 0;
	
	                if (!skipUnavailableItemsCheck) {
	                    for (var i = 0; i < editableItems.length; i++) {
	                        var orderItem = editableItems[i];
	                        if (orderItem.key === extraCreditItem.key) continue;
	                        var storeItem = storeItems[orderItem.key];
	                        if (storeItem && storeItem.available < 0) {
	                            storeItem.available = 0;
	                        }
	                        var originItemOrderQuantity = orderItem.quantity;
	                        if (!storeItem) {
	                            if (activeOrder && activeOrder.hasOwnProperty(orderItem.key)) {
	                                orderItem.quantity = activeOrder[orderItem.key].quantity;
	                            } else {
	                                orderItem.quantity = 0;
	                                dispatch((0, _recurringOrderActions.setRecurringItem)(orderItem));
	                            }
	                            orderItem.available = 0;
	                            if (originItemOrderQuantity > orderItem.quantity) {
	                                unAvailableItems[orderItem.key] = orderItem;
	                                if (orderItem.isCredit) returnedCredits += originItemOrderQuantity * orderItem.price - orderItem.quantity * orderItem.price;
	                                itemsRemoved++;
	                            }
	                        } else if (storeItem.available - orderItem.quantity < 0) {
	                            if (activeOrder && activeOrder[orderItem.key]) {
	                                if (orderItem.quantity > activeOrder[orderItem.key].quantity + storeItem.available) {
	                                    orderItem.quantity = activeOrder[orderItem.key].quantity + storeItem.available;
	                                }
	                            } else {
	                                orderItem.quantity = storeItem.available;
	                            }
	
	                            orderItem.available = storeItem.available;
	                            if (originItemOrderQuantity !== orderItem.quantity) {
	                                unAvailableItems[orderItem.key] = orderItem;
	                                if (orderItem.isCredit) returnedCredits += originItemOrderQuantity * orderItem.price - orderItem.quantity * orderItem.price;
	                            }
	                            //storeItem.quantity = storeItem.available
	                        }
	                    }
	                }
	                if (state.summary.pickupSite.key !== json.subscriptionSummary.pickupSite.key) {
	                    dispatch((0, _commonActions.setDirty)(false));
	                    dispatch((0, _fetchingActions.errorFetching)({ message: _constants.PICKUP_SITE_KEY_CHANGED }));
	                } else if (orderKey !== (json.subscriptionSummary || {}).activeWebOrderKey) {
	                    dispatch((0, _commonActions.setDirty)(false));
	                    dispatch((0, _fetchingActions.errorFetching)({ message: _constants.ORDER_KEY_CHANGED }));
	                } else if (Object.keys(unAvailableItems).length === 0) {
	                    //all items in the order are available and in store hours store is still open
	                    dispatch((0, _storeCheckoutActions.submitOrder)(memberKey, subscriptionKey, orderKey, items, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method, isChargeOnDelivery));
	                } else {
	                    dispatch(updateItems(unAvailableItems));
	                    dispatch(returnCredits(returnedCredits));
	                    dispatch(calculateAllTotals());
	                    if (editableItems.length === itemsRemoved) {
	                        //all of the ordered items became unavailable
	                        dispatch((0, _commonActions.setDirty)(false));
	                    }
	                    //dispatch action to show message of unavailable items with their titles do you want to go back to store or confirm the order.
	                    dispatch((0, _storeCheckoutActions.setUnavailableItemsInOrder)(unAvailableItems));
	                    dispatch((0, _fetchingActions.dataFetched)());
	                }
	            }
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function updateStoreDataAvailability(staticData, categoryKey, items, activeOrder, skipItem) {
	    return function (dispatch) {
	        var fetchUrl = '/dispatcher/WebStoreService.getStoreDataForCategory';
	        var data = {
	            farmKey: staticData.farmKey,
	            categoryKey: categoryKey
	        };
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.error) return;
	            var itemsDivided = (0, _basket.getOrderedItemsForSummary)(items, activeOrder, true);
	            var orderItems = Object.entries(itemsDivided).reduce(function (acc, _ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    key = _ref2[0],
	                    values = _ref2[1];
	
	                values.forEach(function (item) {
	                    if (!acc[item.key]) {
	                        acc[item.key] = item.quantity;
	                    }
	                });
	                return acc;
	            }, {});
	            var storeItems = itemsParser(json.store);
	            var itemsAvailability = {};
	
	            for (var itemKey in storeItems) {
	                var storeItem = storeItems[itemKey];
	                if (itemKey === skipItem) {
	                    continue;
	                }
	                itemsAvailability[storeItem.key] = storeItem;
	                if (orderItems[itemKey]) {
	                    itemsAvailability[storeItem.key].available += orderItems[itemKey];
	                }
	            }
	            dispatch(updateItemsAvailability(itemsAvailability));
	        }).catch();
	    };
	}
	
	function updateStoreItemAvailability(staticData, itemKey, newQuantity, oldQuantity, onComplete) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.updateStoreItemAvailability';
	        var memberKey = (state.memberDetails || {}).key;
	        var data = {
	            farmKey: staticData.farmKey,
	            memberKey: memberKey,
	            itemKey: itemKey,
	            availabilityChange: oldQuantity - newQuantity
	        };
	        return (0, _utils.ajax)(fetchUrl, data).then(function (available) {
	            var itemsAvailability = {};
	            if (available < 0) {
	                // Return the current availability
	                itemsAvailability[itemKey] = { available: oldQuantity };
	            } else {
	                // Need to include the items in the order in the availability
	                itemsAvailability[itemKey] = { available: available + newQuantity };
	            }
	            dispatch(updateItemsAvailability(itemsAvailability));
	            onComplete(available);
	        }).catch(function () {
	            onComplete(-1);
	        });
	    };
	}
	
	function updateItems(items) {
	    return {
	        type: _actionTypes.UPDATE_ITEMS_PROPS,
	        items: items
	    };
	}
	
	function updateItemsAvailability(items) {
	    return {
	        type: _actionTypes.UPDATE_ITEMS_AVAILABILITY,
	        items: items
	    };
	}
	
	function getFetchUrl(memberKey) {
	    if (!memberKey) {
	        return '/dispatcher/WebStoreService.getStoreDataGuest';
	    } else {
	        return '/dispatcher/WebStoreService.getStoreDataMember';
	    }
	}
	
	function storeParser(json, initialData) {
	    var items = itemsParser(json.store);
	    var creditsData = creditsDataParser(json.store);
	    initialData["creditType"] = creditsData.creditType;
	    initialData["credits"] = creditsData.credits;
	    var subscriptionSummary = (0, _subscriptionSummaryActions.subscriptionSummaryParser)(json, initialData.staticData);
	    var activeOrder = void 0;
	    var creditQuantity = 0;
	    if ((json.activeWebOrder || {}).items) {
	        activeOrder = activeOrderParser(json.activeWebOrder, json.activeWebOrder.coupon !== undefined);
	        Object.keys(activeOrder.items).forEach(function (key) {
	            var i = activeOrder.items[key];
	            var item = items[i.key];
	            if (item) {
	                item.orderedQuantity = i.quantity;
	                item.quantity = i.quantity;
	                item[_constants.FIELD_SELECTED_ORDER] = i[_constants.FIELD_SELECTED_ORDER];
	                item[_constants.FIELD_ADDITIONAL_ITEM_QTY] = i[_constants.FIELD_ADDITIONAL_ITEM_QTY];
	                item.minQuantity = subscriptionSummary.canEditExistingOrder ? 0 : i.quantity;
	                items[i.key].price = i.price;
	            } else {
	                items[i.key] = i;
	            }
	            if (i.isCredit && i.quantity) {
	                creditQuantity += i.quantity * i.price;
	            }
	        });
	        if (creditQuantity > 0) {
	            var qty = creditsData.credits - creditQuantity;
	            if (qty < 0) {
	                if (creditsData.extraCreditItem) {
	                    items[creditsData.extraCreditItem.key]['quantity'] = -qty;
	                }
	                creditsData.remainingCredits = 0;
	            } else {
	                creditsData.remainingCredits = qty;
	            }
	        }
	    }
	    //In case the item is not published
	    if (initialData.itemKey && !items[initialData.itemKey]) initialData.itemKey = undefined;
	    return {
	        items: items,
	        categories: json.store.categories ? categoriesParser(json.store, items, initialData.category, initialData.itemKey) : {},
	        summary: subscriptionSummary,
	        activeOrder: activeOrder,
	        messageData: (0, _messagePageActions.messageDataParser)(json.store, initialData),
	        itemKey: initialData.itemKey,
	        creditsData: creditsData,
	        hasCoupons: json.store.hasCoupons,
	        recurringOrder: (0, _recurringOrderActions.recurringOrderParser)(json.recurringOrder, subscriptionSummary.nextDeliveryDate)
	    };
	}
	
	function activeOrderParser(activeWebOrder, existingCoupon) {
	    function sort(items) {
	        return (items || []).sort(function (i1, i2) {
	            return i1.title < i2.title ? -1 : i1.title > i2.title ? 1 : 0;
	        });
	    }
	    if (activeWebOrder) {
	        var items = sort(activeWebOrder.items).reduce(function (prev, curr) {
	            prev[curr.key] = curr;
	            curr[_constants.FIELD_SELECTED_ORDER] = (0, _storeItemsListReducer.increaseItemOrder)();
	            return prev;
	        }, {});
	        sort(activeWebOrder.additionalItems).forEach(function (i) {
	            if (!items[i.key]) {
	                items[i.key] = i;
	                i[_constants.FIELD_SELECTED_ORDER] = (0, _storeItemsListReducer.increaseItemOrder)();
	            } else {
	                items[i.key].quantity += i.quantity;
	            }
	            items[i.key][_constants.FIELD_ADDITIONAL_ITEM_QTY] = i.quantity;
	        });
	        return {
	            items: items,
	            orderKey: activeWebOrder.key,
	            comments: activeWebOrder.comments,
	            coupon: (0, _commonActions.parseCouponData)(activeWebOrder.coupon, existingCoupon),
	            usedFarmigoCredits: activeWebOrder.usedFarmigoCredits
	        };
	    }
	    return undefined;
	}
	
	function categoriesParser(json, items, initialCategory, initialItem) {
	    if (initialItem) {
	        initialCategory = items[initialItem].category;
	    }
	    var nonEmptyCategories = {};
	    var extraCreditItemKey = (json.extraCreditItem || {}).key;
	    for (var key in items) {
	        if (items.hasOwnProperty(key) && key !== extraCreditItemKey) {
	            nonEmptyCategories[items[key].category] = true;
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = (items[key].additionalCategories || [])[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var category = _step3.value;
	
	                    nonEmptyCategories[category] = true;
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                        _iterator3.return();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	        }
	    }
	    var categories = json.categories.map(function (c) {
	        return {
	            key: c.key,
	            title: c.title,
	            order: c.order,
	            selected: c.key === initialCategory
	        };
	    }).filter(function (c) {
	        return nonEmptyCategories[c.key];
	    }).sort(function (c1, c2) {
	        return c1.order - c2.order;
	    });
	    if (!initialCategory && categories.length > 0) categories[0].selected = true;
	    return categories;
	}
	
	function itemsParser(json) {
	    var items = {};
	    if (!json.items) {
	        return items;
	    }
	    json.items.map(function (item) {
	        var itemProp = {};
	        itemProp['key'] = item.key;
	        itemProp['quantity'] = 0;
	        itemProp['orderedQuantity'] = /*item.unitQuantity*/0;
	        itemProp['title'] = item.title;
	        itemProp['label'] = item.label;
	        itemProp['points'] = item.points;
	        itemProp['price'] = item.price;
	        itemProp['salesTax'] = item.salesTax;
	        itemProp['imageUrl'] = item.imageUrl;
	        itemProp['producerTitle'] = item.producer ? item.producer.title : "";
	        itemProp['producerKey'] = item.producer ? item.producer.key : undefined;
	        itemProp['unit'] = item.unit;
	        itemProp['unitQuantity'] = item.unitQuantity;
	        itemProp['discount'] = item.discount;
	        itemProp['isCredit'] = item.isCredit;
	        itemProp['description'] = item.description ? item.description.replace(/\r/g, '<br>') : '';
	        itemProp['category'] = item.category;
	        itemProp['additionalCategories'] = item.additionalCategories || [];
	        itemProp['producer'] = item.producer;
	        itemProp['maxPerMember'] = item.maxPerMember;
	        itemProp['available'] = item.available;
	        if (item.variations && item.variations.length) {
	            var variations = [];
	            if (item.variations.length === 1) {
	                if (itemProp["key"] !== item.variations[0].key) {
	                    itemProp = Object.assign(itemProp, item.variations[0]);
	                }
	            } else {
	                itemProp['key'] = itemProp['key'] + '_parent';
	                itemProp['available'] = itemProp['available'] || 1;
	                item.variations.forEach(function (v) {
	                    var variation = Object.assign({ variation: true, defaultBoxItem: itemProp['key'] }, itemProp, v);
	                    variations.push(variation);
	                    items[v.key] = variation;
	                });
	                itemProp['variations'] = variations;
	            }
	        }
	        items[itemProp.key] = itemProp;
	    });
	    if (json.extraCreditItem) {
	        var item = json.extraCreditItem;
	        item['quantity'] = 0;
	        item['orderedQuantity'] = 0;
	        item['available'] = false;
	        items[item.key] = item;
	    }
	    return items;
	}
	
	function creditsDataParser(json) {
	    var store = json || {};
	    var creditType = store.creditType;
	    if ((creditType === _constants.CreditTypes.CREDIT_TYPE_REGULAR || store.holdReason === _constants.SubscriptionHoldReason.NEW) && json.items.filter(function (item) {
	        return item.isCredit;
	    }).length > 0) {
	        creditType = _constants.CreditTypes.CREDIT_BY_SHARE;
	    }
	    return {
	        creditType: creditType,
	        credits: store.credits,
	        deliveryDate: store.deliveryDate,
	        extraCreditItem: store.extraCreditItem,
	        remainingCredits: store.credits,
	        usedFarmigoCredits: store.usedFarmigoCredits,
	        balanceAsCredits: store.balanceAsCredits
	    };
	}
	
	function calculateAllTotals() {
	    return function (dispatch, getState) {
	        dispatch(calculateOrdersTotals(getState().itemsList));
	    };
	}
	
	function calculateOrdersTotals(items) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var orderStatus = state.orderStatus || {};
	        var summary = state.summary || {};
	        var activeOrder = orderStatus.activeOrder;
	        var canEditExistingOrder = summary.canEditExistingOrder;
	        var extraCost = summary.extraCost;
	        var extraCostType = summary.extraCostType;
	        var totalUsedFarmigoCredits = (state.storeCreditsData || {}).usedFarmigoCredits;
	        var balanceAsCredits = (state.storeCreditsData || {}).balanceAsCredits;
	        var credits = (state.storeCreditsData || {}).credits;
	        var extraCreditItemKey = ((state.storeCreditsData || {}).extraCreditItem || {}).key;
	        var staticData = state.staticData;
	        var couponValue = (orderStatus.coupon || {}).discount;
	        var hasAlreadyCoupon = orderStatus.existingCoupon;
	        var totals = {};
	
	        var orderedItems = (0, _basket.getOrderedItemsForSummary)(items, activeOrder, canEditExistingOrder) || {
	            filteredItems: [],
	            fixedItems: [],
	            editableItems: [],
	            creditFilteredItems: [],
	            creditFixedItems: [],
	            creditEditableItems: []
	        };
	
	        var hasFixedItems = orderedItems.fixedItems.length;
	        if (orderedItems.creditFilteredItems.length) {
	            totals.creditsTotal = orderedItems.creditFilteredItems.reduce(function (total, item) {
	                return total + item.price * item.quantity;
	            }, 0);
	            if (hasFixedItems) {
	                totals.creditFixedItems = orderedItems.creditFixedItems.reduce(function (total, item) {
	                    return total + item.price * item.quantity;
	                }, 0);
	            }
	            if (orderedItems.creditEditableItems && orderedItems.creditEditableItems.length > 0) {
	                totals.creditEditableItems = orderedItems.creditEditableItems.reduce(function (total, item) {
	                    return total + item.price * item.quantity;
	                }, 0);
	            }
	        }
	        totals.orderTotal = (0, _basket.calculateOrderTotal)(orderedItems.filteredItems, { extraCost: extraCost, extraCostType: extraCostType,
	            credits: credits && totalUsedFarmigoCredits ? credits - totalUsedFarmigoCredits : credits,
	            couponValue: couponValue, balanceAsCredits: balanceAsCredits, extraCreditItemKey: extraCreditItemKey,
	            creditsTotal: totals.creditsTotal }, staticData);
	        if (hasFixedItems) {
	            totals.fixedTotal = (0, _basket.calculateOrderTotal)(orderedItems.fixedItems, { extraCost: extraCost, extraCostType: extraCostType,
	                credits: credits && orderStatus.usedFarmigoCredits ? credits - orderStatus.usedFarmigoCredits : credits,
	                couponValue: hasAlreadyCoupon ? couponValue : undefined, balanceAsCredits: balanceAsCredits, extraCreditItemKey: extraCreditItemKey,
	                creditsTotal: totals.creditsTotal }, staticData);
	        }
	        if (orderedItems.editableItems.length) {
	            totals.editableTotal = (0, _basket.calculateOrderTotal)(orderedItems.editableItems, { extraCost: hasFixedItems ? undefined : extraCost,
	                extraCostType: hasFixedItems ? undefined : extraCostType,
	                credits: credits && totalUsedFarmigoCredits ? credits - totalUsedFarmigoCredits : credits,
	                couponValue: (!hasFixedItems || !hasAlreadyCoupon) && couponValue ? couponValue : undefined,
	                balanceAsCredits: balanceAsCredits, extraCreditItemKey: extraCreditItemKey,
	                creditsTotal: totals.creditsTotal
	            }, staticData);
	        }
	        if (staticData.showItemPoints) {
	            totals.points = (0, _basket.calculateOrderPoints)(orderedItems.filteredItems);
	        }
	        dispatch(updateTotals(orderedItems, totals));
	    };
	}
	
	function updateTotals(orderedItems, totals) {
	    return {
	        type: _actionTypes.UPDATE_TOTALS,
	        orderedItems: orderedItems,
	        totals: totals
	    };
	}
	
	function updateItemsAvailabilityFromOrder(activeOrder, items) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var staticData = state.staticData;
	        if (staticData.updateItemAvailabilityOnItemQuantityChange && activeOrder) {
	            var extraCreditItem = state.storeCreditsData.extraCreditItem || {};
	            var itemsAvailability = {};
	            var orderItems = activeOrder.items || [];
	            for (var itemKey in orderItems) {
	                var orderItem = orderItems[itemKey];
	                itemsAvailability[itemKey] = items[itemKey];
	                if (items[itemKey] && itemKey !== extraCreditItem.key) {
	                    itemsAvailability[itemKey].available += orderItem.quantity;
	                }
	            }
	            dispatch(updateItemsAvailability(itemsAvailability));
	        }
	    };
	}
	
	function returnCredits(returnedCredits) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var creditsData = state.storeCreditsData || {};
	        var extraCreditsCount = creditsData.extraCreditItem ? creditsData.extraCreditItem.quantity : 0;
	
	        if (returnedCredits === 0) return;
	
	        if (extraCreditsCount > 0) {
	            //First reduce credits from extra credit item
	            var extraCreditsNewQuantity = extraCreditsCount - returnedCredits >= 0 ? extraCreditsCount - returnedCredits : 0;
	            dispatch(changeItemQuantityAction(creditsData.extraCreditItem.key, extraCreditsNewQuantity));
	            dispatch(changeExtraItemQuantityAction(creditsData.extraCreditItem.key, extraCreditsNewQuantity));
	        }
	
	        if (extraCreditsCount - returnedCredits < 0) {
	            //Then increase the remaining credits balance
	            var remainingCredits = creditsData.remainingCredits + returnedCredits - extraCreditsCount;
	            dispatch(setStoreCreditsRemaining(remainingCredits));
	        }
	    };
	}
	function hasCoupons(hasCoupons) {
	    return {
	        type: _actionTypes.SET_STORE_HAS_COUPONS,
	        hasCoupons: hasCoupons
	    };
	}
	function hasAlreadyCoupon(hasAlreadyCoupon) {
	    return {
	        type: _actionTypes.SET_HAS_ALREADY_COUPON,
	        hasAlreadyCoupon: hasAlreadyCoupon
	    };
	}
	function applyCoupon(couponId) {
	    return function (dispatch) {
	        if (couponId === "") {
	            dispatch(setCoupon(undefined));
	        } else {
	            dispatch((0, _commonActions.getCouponData)(couponId, setCouponAndUpdateSummary));
	        }
	    };
	}
	function setCouponAndUpdateSummary(coupon) {
	    return function (dispatch) {
	        dispatch(setCoupon(coupon));
	        dispatch(calculateAllTotals());
	    };
	}
	function setCoupon(coupon) {
	    return {
	        type: _actionTypes.SET_WEB_ORDER_COUPON,
	        coupon: coupon
	    };
	}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setShowUpdateRecurringModal = setShowUpdateRecurringModal;
	exports.setRecurringOrderData = setRecurringOrderData;
	exports.recurringOrderParser = recurringOrderParser;
	exports.setRecurringOrderItemService = setRecurringOrderItemService;
	exports.removeRecurringOrderItemService = removeRecurringOrderItemService;
	exports.setRecurringItem = setRecurringItem;
	exports.addRecurringItemsToOrder = addRecurringItemsToOrder;
	
	var _utils = __webpack_require__(485);
	
	var _actionTypes = __webpack_require__(459);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _constants = __webpack_require__(463);
	
	var _itemCardActions = __webpack_require__(768);
	
	function setShowUpdateRecurringModal(showUpdateRecurringModal) {
	    return {
	        type: _actionTypes.SHOW_UPDATE_RECURRING_MODAL,
	        showUpdateRecurringModal: showUpdateRecurringModal
	    };
	}
	
	function setRecurringOrderData(data) {
	    return {
	        type: _actionTypes.SET_RECURRING_ORDER_DATA,
	        data: data
	    };
	}
	function recurringOrderParser(recurringOrder, nextDeliveryDate) {
	    if (!recurringOrder) {
	        return null;
	    }
	    var items = [];
	    var boxItems = recurringOrder.boxItems || [];
	    for (var i = 0; i < boxItems.length; i++) {
	        var item = recurringOrder.items[i];
	        var schedule = recurringOrder.farmSchedules[recurringOrder.boxItemsSchedules[i]];
	        item["schedule"] = schedule;
	        item["quantity"] = recurringOrder.boxItemsQuantities[i];
	        item["isItemNotPartOfOrder"] = !schedule.dates.includes(nextDeliveryDate);
	        item["isRecurring"] = true;
	        items.push(item);
	    }
	    recurringOrder["items"] = items;
	    return recurringOrder;
	}
	
	function setRecurringOrderItemService(recurringOrderItem) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/RecurringOrderItemService.setRecurringOrderItemService';
	        var data = {
	            memberKey: state.memberDetails.key,
	            recurringOrderItem: recurringOrderItem
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SET_RECURRING_ORDER));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.error) {
	                throw json.error;
	            }
	            dispatch(setShowUpdateRecurringModal(false));
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function removeRecurringOrderItemService(recurringOrderItemKey) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/RecurringOrderItemService.setRecurringOrderItemService';
	        var data = {
	            memberKey: state.memberDetails.key,
	            recurringOrderItemKey: recurringOrderItemKey
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SET_RECURRING_ORDER));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.error) {
	                throw json.error;
	            }
	            dispatch(setShowUpdateRecurringModal(false));
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function setRecurringItem(item, updateSchedule) {
	    return {
	        type: _actionTypes.SET_RECURRING_ITEM,
	        item: item,
	        updateSchedule: updateSchedule
	    };
	}
	
	function addRecurringItemsToOrder(deliveryDate) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var recurringOrder = state.recurringOrder;
	        var activeOrder = state.orderStatus.activeOrder;
	        if (!activeOrder && recurringOrder) {
	            recurringOrder.items.map(function (item) {
	                var itemExists = (getState().itemsList || {}).hasOwnProperty(item.key);
	                if (itemExists && item.schedule.dates.includes(deliveryDate)) {
	                    dispatch((0, _itemCardActions.changeItemQuantity)(item, item.quantity, 0, state.creditsData));
	                }
	            });
	        }
	    };
	}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.changeItemQuantity = changeItemQuantity;
	
	var _storeActions = __webpack_require__(766);
	
	var _recurringOrderActions = __webpack_require__(767);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _constants = __webpack_require__(463);
	
	function changeItemQuantity(item, newQuantity, oldQuantity, creditData, updateSchedule) {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (newQuantity === -1) {
	            newQuantity = 0;
	        }
	        if (state.staticData.updateItemAvailabilityOnItemQuantityChange) {
	            dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.UPDATE_ITEM_AVAILABILITY));
	            dispatch((0, _storeActions.updateStoreItemAvailability)(state.staticData, item.key, newQuantity, oldQuantity, function (available) {
	                if (available < 0) {
	                    dispatch((0, _fetchingActions.errorFetching)({ message: item.title + " cannot be added as it has sold out." }, undefined, true));
	                } else {
	                    dispatch(doChangeItemQuantity(item, newQuantity, oldQuantity, creditData, updateSchedule));
	                    dispatch((0, _fetchingActions.dataFetched)());
	                }
	            }));
	        } else {
	            dispatch(doChangeItemQuantity(item, newQuantity, oldQuantity, creditData, updateSchedule));
	        }
	    };
	}
	
	function doChangeItemQuantity(item, newQuantity, oldQuantity, creditData, updateSchedule) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var schedule = item.schedule;
	        var changeRecurringQuantity = true;
	        if (newQuantity === -1) {
	            changeRecurringQuantity = false;
	            newQuantity = 0;
	        }
	        if (creditData && item.isCredit) {
	            var qty = item.price * (newQuantity - oldQuantity);
	            var remainingCredits = creditData.remainingCredits - (creditData.extraCreditItem ? creditData.extraCreditItem.quantity : 0) - qty;
	            if (creditData.extraCreditItem) {
	                dispatch((0, _storeActions.changeItemQuantityAction)(creditData.extraCreditItem.key, remainingCredits < 0 ? -remainingCredits : 0));
	                dispatch((0, _storeActions.changeExtraItemQuantityAction)(creditData.extraCreditItem.key, remainingCredits < 0 ? -remainingCredits : 0));
	            }
	            dispatch((0, _storeActions.setStoreCreditsRemaining)(remainingCredits < 0 ? 0 : remainingCredits));
	        }
	        dispatch((0, _storeActions.changeItemQuantityAction)(item.key, newQuantity));
	        if (state.staticData.hasRecurringItems) {
	            item.schedule = schedule;
	            if (changeRecurringQuantity) {
	                item.quantity = newQuantity;
	            }
	            dispatch((0, _recurringOrderActions.setRecurringItem)(item, updateSchedule || state.itemsList.hasOwnProperty(item.key)));
	        }
	        dispatch((0, _storeActions.calculateAllTotals)());
	    };
	}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _translate = __webpack_require__(464);
	
	var _footer = __webpack_require__(771);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	    _inherits(Footer, _React$Component);
	
	    function Footer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Footer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Footer.__proto__ || Object.getPrototypeOf(Footer)).call.apply(_ref, [this].concat(args))), _this), _this.getCustomFooter = function () {
	            return _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: _this.props.staticData.customFooterHTML } });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Footer, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "footer" },
	                this.props.staticData.customFooterHTML && this.props.staticData.customFooterHTML !== '' && !this.props.clientViewPort.isXs ? this.getCustomFooter() : undefined,
	                _react2.default.createElement(
	                    "div",
	                    { className: "footer-strip" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "farmigo-footer" },
	                        _react2.default.createElement(
	                            "a",
	                            { href: "http://www.farmigo.com", target: "_new" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "farmigo-text" },
	                                (0, _translate.translate)("Powered By"),
	                                " "
	                            ),
	                            _react2.default.createElement("i", { className: "farmigo-logo" })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _commonActions = __webpack_require__(747);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _popup = __webpack_require__(763);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DirtyModal = function (_React$Component) {
	    _inherits(DirtyModal, _React$Component);
	
	    function DirtyModal() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DirtyModal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DirtyModal.__proto__ || Object.getPrototypeOf(DirtyModal)).call.apply(_ref, [this].concat(args))), _this), _this.closeModal = function () {
	            _this.props.closeModal();
	        }, _this.leave = function () {
	            if (_this.props.showModal.onLeaveCallBack) {
	                _this.props.showModal.onLeaveCallBack();
	                _this.closeModal();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DirtyModal, [{
	        key: "render",
	        value: function render() {
	            if (!this.props.showModal) return null;
	            var message = this.props.message ? this.props.message : "_LoseYourChanges";
	            var leaveText = this.props.leaveText ? this.props.leaveText : "Leave";
	            var stayText = this.props.stayText ? this.props.stayText : "Stay";
	
	            return _react2.default.createElement(_ModalPopup2.default, {
	                onClose: this.closeModal,
	                message: (0, _translate.translate)(message),
	                right: { text: (0, _translate.translate)(stayText), callback: this.closeModal },
	                left: { text: (0, _translate.translate)(leaveText), callback: this.leave } });
	        }
	    }]);
	
	    return DirtyModal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        showModal: (state.orderStatus || {}).showModal
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        closeModal: function closeModal() {
	            dispatch((0, _commonActions.showDirtyModal)(false));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DirtyModal);

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorModal = function (_React$Component) {
	    _inherits(ErrorModal, _React$Component);
	
	    function ErrorModal() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ErrorModal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorModal.__proto__ || Object.getPrototypeOf(ErrorModal)).call.apply(_ref, [this].concat(args))), _this), _this.onRetry = function () {
	            if (_this.props.retryAction) _this.props.retry();
	            _this.props.clearError();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ErrorModal, [{
	        key: "render",
	        value: function render() {
	            if (!this.props.error) return null;
	            var message = this.props.error.message ? this.props.error.message : (0, _translate.translate)("Something went wrong") + ".";
	            var buttonText = this.props.retryAction ? this.props.retryAction.label ? this.props.retryAction.label : "Try Again" : "Close";
	            return _react2.default.createElement(_ModalPopup2.default, {
	                message: (0, _translate.translate)(message),
	                middle: { text: (0, _translate.translate)(buttonText), callback: this.onRetry } });
	        }
	    }]);
	
	    return ErrorModal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var error = (state.fetching || {}).error;
	    return {
	        error: error,
	        message: error ? error.message : undefined,
	        retryAction: error ? error.retryAction : undefined
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        retry: function retry() {
	            dispatch((0, _fetchingActions.retryFetching)());
	        },
	        clearError: function clearError() {
	            dispatch((0, _fetchingActions.clearError)());
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ErrorModal);

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _utils = __webpack_require__(485);
	
	var _constants = __webpack_require__(463);
	
	var _storeActions = __webpack_require__(766);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginSignupModal = function (_React$Component) {
	    _inherits(LoginSignupModal, _React$Component);
	
	    function LoginSignupModal() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LoginSignupModal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginSignupModal.__proto__ || Object.getPrototypeOf(LoginSignupModal)).call.apply(_ref, [this].concat(args))), _this), _this.closePopup = function () {
	            _this.props.closePopup();
	        }, _this.goToLogin = function () {
	            _this.closePopup();
	            _this.props.goToLogin();
	        }, _this.goToCreateAccount = function () {
	            _this.closePopup();
	            _this.props.goToCreateAccount(_this.props.staticData);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LoginSignupModal, [{
	        key: 'render',
	        value: function render() {
	            if (!this.props.showPopup) {
	                return null;
	            }
	            var isSupportGuestMembers = (this.props.staticData || {}).isSupportGuestMembers;
	            if (isSupportGuestMembers) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    { className: 'modal-popup', show: true, onHide: this.closePopup },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement('button', { className: 'modal-close-button', onClick: this.closePopup }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'modal-message modal-message-horizontal' },
	                            'Ready to Checkout?'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'one-button buttons-horizontal' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { id: 'modalButton', className: 'button', bsStyle: 'primary',
	                                    onClick: this.goToCreateAccount },
	                                'Create Account'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'modal-message modal-message-horizontal' },
	                            'Already Have an Account?'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'one-button buttons-horizontal' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { id: 'modalButton', className: 'button', bsStyle: 'primary',
	                                    onClick: this.goToLogin },
	                                'Log In'
	                            )
	                        )
	                    )
	                );
	            }
	            return _react2.default.createElement(_ModalPopup2.default, {
	                onClose: this.closePopup,
	                message: (0, _translate.translate)(_constants.LOG_IN_MESSAGE),
	                right: { text: (0, _translate.translate)('Log In'), callback: this.goToLogin },
	                left: { text: (0, _translate.translate)('Continue Browsing'), callback: this.closePopup } });
	        }
	    }]);
	
	    return LoginSignupModal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var orderStatus = state.orderStatus || {};
	    return {
	        staticData: state.staticData,
	        showPopup: orderStatus.showLoginSignupModal
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        closePopup: function closePopup() {
	            dispatch((0, _storeActions.showLoginSignupModal)(false));
	        },
	        goToLogin: function goToLogin() {
	            dispatch((0, _reactRouterRedux.push)((0, _utils.addPath)('login')));
	        },
	        goToCreateAccount: function goToCreateAccount(staticData) {
	            var joinURL = (0, _utils.redirectPage)(_constants.URLs.JOIN, staticData) + "?mode=guest";
	            dispatch(function () {
	                return window.location.assign(joinURL);
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoginSignupModal);

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _commonActions = __webpack_require__(747);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientViewPort = function (_React$Component) {
	    _inherits(ClientViewPort, _React$Component);
	
	    function ClientViewPort() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ClientViewPort);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClientViewPort.__proto__ || Object.getPrototypeOf(ClientViewPort)).call.apply(_ref, [this].concat(args))), _this), _this.updateClientViewPort = function () {
	            var visible = {
	                isXs: _this.isVisible("xs"),
	                isSm: _this.isVisible("sm"),
	                isMd: _this.isVisible("md"),
	                isLg: _this.isVisible("lg")
	            };
	            if (_this.props.clientViewPort.isXs !== visible.isXs || _this.props.clientViewPort.isSm !== visible.isSm || _this.props.clientViewPort.isMd !== visible.isMd || _this.props.clientViewPort.isLg !== visible.isLg) _this.props.updateClientViewPort(visible);
	        }, _this.isVisible = function (size) {
	            var indicator = document.getElementById(size + "-indicator");
	            if (indicator && indicator !== null) {
	                var computed = window.getComputedStyle(indicator);
	                return computed === null ? false : computed.display !== "none";
	            }
	            return false;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ClientViewPort, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            window.onresize = function () {
	                this.updateClientViewPort();
	            }.bind(this);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.updateClientViewPort();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('span', { id: 'xs-indicator', className: 'visible-xs' }),
	                _react2.default.createElement('span', { id: 'sm-indicator', className: 'visible-sm' }),
	                _react2.default.createElement('span', { id: 'md-indicator', className: 'visible-md' }),
	                _react2.default.createElement('span', { id: 'lg-indicator', className: 'visible-lg' })
	            );
	        }
	    }]);
	
	    return ClientViewPort;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        clientViewPort: state.clientViewPort || {}
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        updateClientViewPort: function updateClientViewPort(visible) {
	            dispatch((0, _commonActions.updateClientViewPort)(visible));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClientViewPort);

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _storeActions = __webpack_require__(766);
	
	var _StoreItemsScreen = __webpack_require__(777);
	
	var _StoreItemsScreen2 = _interopRequireDefault(_StoreItemsScreen);
	
	var _StoreCheckOutScreen = __webpack_require__(819);
	
	var _StoreCheckOutScreen2 = _interopRequireDefault(_StoreCheckOutScreen);
	
	var _LogInScreen = __webpack_require__(823);
	
	var _LogInScreen2 = _interopRequireDefault(_LogInScreen);
	
	var _EcheckForm = __webpack_require__(829);
	
	var _EcheckForm2 = _interopRequireDefault(_EcheckForm);
	
	var _EBTForm = __webpack_require__(831);
	
	var _EBTForm2 = _interopRequireDefault(_EBTForm);
	
	var _commonActions = __webpack_require__(747);
	
	var _staticDataActions = __webpack_require__(749);
	
	var _constants = __webpack_require__(463);
	
	var _MessagePage = __webpack_require__(815);
	
	var _MessagePage2 = _interopRequireDefault(_MessagePage);
	
	var _ThankYouPage = __webpack_require__(832);
	
	var _ThankYouPage2 = _interopRequireDefault(_ThankYouPage);
	
	var _PaymentsHost = __webpack_require__(833);
	
	var _PaymentsHost2 = _interopRequireDefault(_PaymentsHost);
	
	var _memberDetailsActions = __webpack_require__(751);
	
	var _LoadingAnimation = __webpack_require__(834);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _utils = __webpack_require__(485);
	
	var _messagePageActions = __webpack_require__(760);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreHomeScreen = function (_React$Component) {
	    _inherits(StoreHomeScreen, _React$Component);
	
	    function StoreHomeScreen() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreHomeScreen);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreHomeScreen.__proto__ || Object.getPrototypeOf(StoreHomeScreen)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            page: "LoadingAnimation"
	        }, _this.getInitialDataForLoad = function (nextProps) {
	            return {
	                category: _this._getCategoryFromLocation(nextProps),
	                itemKey: _this._getItemFromLocation(nextProps),
	                staticData: nextProps.staticData,
	                location: nextProps.location,
	                memberKey: nextProps.memberDetails.key,
	                flowType: _constants.URLs.STORE
	            };
	        }, _this._getOrigin = function () {
	            if (_this.props.location.hash.startsWith(_constants.ITEM_QRY)) {
	                return _constants.ORIGIN_ITEM_SELECTED;
	            } else {
	                return _constants.ORIGIN_CATEGORY_SELECTED;
	            }
	        }, _this._getCategoryFromLocation = function (nextProps) {
	            if (nextProps.location.hash.startsWith(_constants.CATEGORY_QRY)) {
	                return nextProps.location.hash.slice((_constants.CATEGORY_QRY + "=").length);
	            }
	            if (nextProps.location.hash.startsWith(_constants.CART_ITEM_QRY)) {
	                var categoryStart = location.hash.indexOf(_constants.CATEGORY_QRY);
	                return nextProps.location.hash.slice(categoryStart + (_constants.CATEGORY_QRY + "=").length);
	            }
	        }, _this._getItemFromLocation = function (nextProps) {
	            if (nextProps.location.hash.startsWith(_constants.ITEM_QRY)) {
	                return nextProps.location.hash.slice((_constants.ITEM_QRY + "=").length);
	            }
	            if (nextProps.location.hash.startsWith(_constants.CART_ITEM_QRY)) {
	                var categoryStart = location.hash.indexOf(_constants.CATEGORY_QRY);
	                return nextProps.location.hash.slice((_constants.CART_ITEM_QRY + "=").length, categoryStart);
	            }
	        }, _this.getPath = function (staticData) {
	            window.location.replace((0, _utils.redirectPage)(_constants.URLs.STORE, staticData));
	        }, _this.getPage = function (props) {
	            var path = props.location.pathname;
	            if (props.errorFetching) _this.setState({ page: "ErrorFetching" });else if (props.isLoadingStoreData) {
	                _this.setState({ page: "LoadingAnimation" });
	            } else if ((props.messageData || {}).messageTitle && !(props.messageData || {}).isStoreClosedWithMultiOrders) {
	                _this.setState({ page: "MessagePage" });
	            } else if (path.endsWith('/checkout')) {
	                if (props.orderStatus.currentOrder) {
	                    _this.setState({ page: "StoreCheckOutScreen" });
	                } else {
	                    _this.getPath(props.staticData);
	                }
	            } else if (path.endsWith('/login')) {
	                if (props.memberDetails.key) {
	                    _this.getPath(props.staticData);
	                } else {
	                    _this.setState({ page: "LogInScreen" });
	                }
	            } else if (path.endsWith('/thankyou')) {
	                _this.setState({ page: "ThankYouPage", shouldReloadPage: true });
	            } else if (path.endsWith('/echeck')) {
	                if (props.orderStatus.currentOrder) {
	                    _this.setState({ page: "EcheckForm" });
	                } else {
	                    _this.getPath(props.staticData);
	                }
	            } else if (path.endsWith('/ebt')) {
	                if (props.orderStatus.currentOrder) {
	                    _this.setState({ page: "EBTForm" });
	                } else {
	                    _this.getPath(props.staticData);
	                }
	            } else if (path.endsWith('/payments')) {
	                if (props.orderStatus.currentOrder) {
	                    _this.setState({ page: "PaymentsHost" });
	                } else {
	                    _this.getPath(props.staticData);
	                }
	            } else if (_this.state.shouldReloadPage) {
	                window.location.reload();
	            } else if (props.staticData.showStoreOnlyForMembers && !props.memberDetails.key) {
	                _this.setState({ page: "LogInScreen" });
	            } else {
	                if (props.shouldReloadData) {
	                    props.onLoad(_this.getInitialDataForLoad(props));
	                } else _this.setState({ page: "StoreItemsScreen" });
	            }
	        }, _this.getScreen = function () {
	            switch (_this.state.page) {
	                case "ErrorFetching":
	                    return _react2.default.createElement("div", null);
	                case "MessagePage":
	                    return _react2.default.createElement(_MessagePage2.default, {
	                        messageData: _this.props.messageData,
	                        memberKey: _this.props.memberDetails.key,
	                        action: _this.props.messageData.allowContinue ? { text: "Continue", callback: _this.props.closeMessage, type: 'button' } : undefined
	                    });
	                case "StoreCheckOutScreen":
	                    return _react2.default.createElement(_StoreCheckOutScreen2.default, { staticData: _this.props.staticData });
	                case "LogInScreen":
	                    return _react2.default.createElement(_LogInScreen2.default, null);
	                case "ThankYouPage":
	                    return _react2.default.createElement(_ThankYouPage2.default, { farmUrl: _this.props.staticData.farmUrl, seasonUrl: _this.props.staticData.seasonUrl,
	                        thankYouMessage: _this.props.thankYouMessage,
	                        extraMessage: (_this.props.staticData.params || {}).message,
	                        goBack: _this.getPath, pageContext: _constants.URLs.STORE,
	                        memberKey: _this.props.memberDetails.key });
	                case "EcheckForm":
	                    return _react2.default.createElement(_EcheckForm2.default, { pageContext: _constants.URLs.STORE });
	                case "EBTForm":
	                    return _react2.default.createElement(_EBTForm2.default, { pageContext: _constants.URLs.STORE });
	                case "PaymentsHost":
	                    return _react2.default.createElement(_PaymentsHost2.default, { pageContext: _constants.URLs.STORE });
	                case "LoadingAnimation":
	                    return _react2.default.createElement(_LoadingAnimation2.default, null);
	                case "StoreItemsScreen":
	                    return _react2.default.createElement(_StoreItemsScreen2.default, { category: _this._getCategoryFromLocation(_this.props),
	                        itemKey: _this._getItemFromLocation(_this.props),
	                        enterBy: _this._getOrigin(),
	                        staticData: _this.props.staticData,
	                        isStoreClosedWithMultiOrders: (_this.props.messageData || {}).isStoreClosedWithMultiOrders });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreHomeScreen, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            var params = (0, _utils.getUrlParams)();
	            this.props.initServerStaticData();
	            if (params.mode !== 'preview') this.props.initMemberData();
	            this.props.setAndRemoveUrlParams(false);
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            //If the order is restored from the storage
	            if (this.props.orderStatus.currentOrder) this.props.restoreOrder();else this.props.setShouldReloadData(!this.props.orderStatus.currentOrder);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            this.getPage(nextProps);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return this.getScreen();
	        }
	    }]);
	
	    return StoreHomeScreen;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        staticData: state.staticData,
	        isLoadingStoreData: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOAD_STORE_DATA),
	        errorFetching: (state.fetching || {}).error,
	        memberDetails: state.memberDetails || {},
	        shouldReloadData: (state.orderStatus || {}).shouldReloadData,
	        currentOrder: (state.orderStatus || {}).currentOrder,
	        orderStatus: state.orderStatus || {},
	        messageData: state.messageData,
	        thankYouMessage: (state.orderStatus || {}).message
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        initServerStaticData: function initServerStaticData() {
	            dispatch((0, _staticDataActions.initServerStaticData)());
	        },
	        initMemberData: function initMemberData() {
	            dispatch((0, _memberDetailsActions.initMemberData)());
	        },
	        setAndRemoveUrlParams: function setAndRemoveUrlParams(onlyHidden) {
	            dispatch((0, _commonActions.setAndRemoveUrlParams)(onlyHidden));
	        },
	        onLoad: function onLoad(initialData) {
	            dispatch((0, _storeActions.loadData)(initialData));
	        },
	        setShouldReloadData: function setShouldReloadData(shouldReloadData) {
	            dispatch((0, _commonActions.setShouldReloadData)(shouldReloadData));
	        },
	        restoreOrder: function restoreOrder() {
	            dispatch((0, _commonActions.setDirty)(true));
	        },
	        closeMessage: function closeMessage() {
	            dispatch((0, _messagePageActions.setMessageData)({}));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StoreHomeScreen);

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _StoreItemsList = __webpack_require__(778);
	
	var _StoreItemsList2 = _interopRequireDefault(_StoreItemsList);
	
	var _StoreCategoriesList = __webpack_require__(788);
	
	var _StoreCategoriesList2 = _interopRequireDefault(_StoreCategoriesList);
	
	var _StoreTabsWrapper = __webpack_require__(791);
	
	var _StoreCart = __webpack_require__(813);
	
	var _StoreCart2 = _interopRequireDefault(_StoreCart);
	
	var _UserMenu = __webpack_require__(490);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	var _SegmentsMenu = __webpack_require__(814);
	
	var _SegmentsMenu2 = _interopRequireDefault(_SegmentsMenu);
	
	var _MessagePage = __webpack_require__(815);
	
	var _MessagePage2 = _interopRequireDefault(_MessagePage);
	
	var _RecurringOrderItems = __webpack_require__(798);
	
	var _RecurringOrderItems2 = _interopRequireDefault(_RecurringOrderItems);
	
	var _StoreSearch = __webpack_require__(801);
	
	var _StoreSearch2 = _interopRequireDefault(_StoreSearch);
	
	var _storeCategoriesActions = __webpack_require__(817);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _constants = __webpack_require__(463);
	
	var _basket = __webpack_require__(757);
	
	var _storeCheckoutActions = __webpack_require__(756);
	
	var _translate = __webpack_require__(464);
	
	var _recurringOrderActions = __webpack_require__(767);
	
	var _utils = __webpack_require__(485);
	
	var _storeItemsScreen = __webpack_require__(818);
	
	var _storeItemsScreen2 = _interopRequireDefault(_storeItemsScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreItemsScreen = function (_React$Component) {
	    _inherits(StoreItemsScreen, _React$Component);
	
	    function StoreItemsScreen() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreItemsScreen);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreItemsScreen.__proto__ || Object.getPrototypeOf(StoreItemsScreen)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            category: null
	        }, _this._loadLocation = function () {
	            if (_this.props.enterBy === _constants.ORIGIN_CATEGORY_SELECTED) {
	                var cKey = _this.props.category || ((_this.props.categories || [])[0] || {}).key;
	                if (cKey) {
	                    if (_this.state.category !== cKey) {
	                        _this.setState({ category: cKey });
	                        _this.props.changeCategory(cKey);
	                    }
	                }
	            }
	            if (_this.props.enterBy === _constants.ORIGIN_ITEM_SELECTED) {
	                var itemKey = _this.props.itemKey;
	                if (itemKey && itemKey !== _this.state.itemKey) {
	                    _this.setState({ itemKey: itemKey });
	                }
	            }
	        }, _this._allowAddingItems = function () {
	            _this.props.setAllowOrderEditToStore(true);
	        }, _this._allowEditMultiOrder = function () {
	            _this.props.setNextDeliveryDate(_this.props.secondNextDeliveryDate);
	            if (_this.props.staticData.hasRecurringItems && !_this.props.activeOrder) {
	                _this.props.addRecurringItemsToOrder(_this.props.secondNextDeliveryDate);
	            }
	            _this.props.setEditMultiOrder(true);
	        }, _this._shouldAllowOrderEdit = function () {
	            return _this.props.allowOrderEdit;
	        }, _this._getItemsNumberInRow = function () {
	            if (_this.props.clientViewPort.isMd || _this.props.clientViewPort.isLg) {
	                return 4; //desktop
	            } else if (_this.props.clientViewPort.isSm) {
	                return 3; //desktop or tablet landscape
	            } else if (_this.props.clientViewPort.isXs) {
	                return 1; //mobile
	            } else {
	                return 2; //tablet portrait
	            }
	        }, _this.getUpdateRecurringModal = function () {
	            if (_this.props.showUpdateRecurringModal) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    { show: true, dialogClassName: 'update-recurring-items' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(_RecurringOrderItems2.default, null)
	                    )
	                );
	            }
	        }, _this.getPickupSiteForUpcomingDeliveryDate = function (multiplePickupSitesDates) {
	            var pickupSite = void 0;
	            var date = "3000-01-01";
	            for (var pickupSiteDate in multiplePickupSitesDates) {
	                if (multiplePickupSitesDates.hasOwnProperty(pickupSiteDate)) if (multiplePickupSitesDates[pickupSiteDate] < date) {
	                    date = multiplePickupSitesDates[pickupSiteDate];
	                    pickupSite = pickupSiteDate;
	                }
	            }
	            return { key: pickupSite, date: date };
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreItemsScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._loadLocation();
	
	            if (this.props.hasMultiplePickupSites) {
	                if (this.props.isStoreClosedWithMultiOrders && this.props.pickupSiteParam) {
	                    //In case of multiple delivery days don't show store close message - Show the next date
	                    this._allowEditMultiOrder();
	                } else {
	                    var nextPickupSite = this.getPickupSiteForUpcomingDeliveryDate(this.props.multiplePickupSitesDates);
	                    if (this.props.isStoreClosedWithMultiOrders && !this.props.pickupSiteParam || this.props.nextDeliveryDate !== nextPickupSite.date && !this.props.pickupSiteParam) {
	                        //Redirect to the the upcoming pickup site
	                        this.setState({ redirecting: true });
	                        window.location.assign(location.pathname + "?p=" + nextPickupSite.key);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this._loadLocation();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var itemsList = this.props.itemsList;
	            var itemsInCategory = this.props.itemsInCategory;
	            var itemsInRow = this._getItemsNumberInRow();
	            var allowOrderEdit = this._shouldAllowOrderEdit();
	            if (this.state.redirecting) {
	                return _react2.default.createElement('div', null);
	            }
	            if (itemsList) {
	                if (this.props.staticData.confirmEditExistingOrder && !allowOrderEdit) {
	                    var messageData = {
	                        messageTitle: 'Add on to Your Existing Order',
	                        messageBody: 'To add-on to your order leave existing items in the cart. After adding new items, click check-out to finalize your order'
	                    };
	                    return _react2.default.createElement(_MessagePage2.default, {
	                        messageData: messageData,
	                        memberKey: this.props.memberDetails.memberKey,
	                        action: { text: (0, _translate.translate)('Continue To Store'), callback: this._allowAddingItems, type: 'button' } });
	                }
	                if (this.props.isStoreClosedWithMultiOrders && !this.props.editMultiOrder) {
	                    //In case of multiple delivery days don't show store close message
	                    if (this.props.hasMultiplePickupSites) return _react2.default.createElement('div', null);
	                    var _messageData = {
	                        messageTitle: _constants.Messages.STORE_CLOSED.title,
	                        messageBody: (0, _translate.translate)("_multiOrderStoreClosed").replace('{0}', (0, _utils.getUsefulDate)(this.props.nextDeliveryDates[0])).replace('{1}', (0, _utils.getUsefulDate)(this.props.nextDeliveryDates[1])).replace('{2}', this.props.staticData.farmEmail)
	                    };
	                    var linkText = (this.props.activeOrder ? 'Click to update your order for ' : 'Click to place order for ') + (0, _utils.getUsefulDate)(this.props.secondNextDeliveryDate);
	                    return _react2.default.createElement(_MessagePage2.default, {
	                        messageData: _messageData,
	                        memberKey: this.props.memberDetails.memberKey,
	                        action: { text: linkText, callback: this._allowEditMultiOrder, type: 'button' } });
	                }
	                if (!allowOrderEdit) {
	                    var _messageData2 = {
	                        messageTitle: (0, _translate.translate)("Order Exists"),
	                        messageBody: (0, _translate.translate)("_haveOrderThatIsBeingProcessed")
	                    };
	
	                    return _react2.default.createElement(_MessagePage2.default, {
	                        messageData: _messageData2,
	                        memberKey: this.props.memberDetails.memberKey,
	                        action: { text: (0, _translate.translate)('Add Items'), callback: this._allowAddingItems } });
	                }
	                if (this.props.clientViewPort.isXs) {
	                    return _react2.default.createElement(_StoreTabsWrapper.StoreTabsWrapper, { itemsList: itemsInCategory, allItems: itemsList, itemsInRow: itemsInRow,
	                        categories: this.props.categories,
	                        itemKey: this.props.itemKey, activeOrder: this.props.activeOrder,
	                        orderedItems: this.props.orderedItems,
	                        extraCreditItem: this.props.extraCreditItem,
	                        remainingCredits: (0, _basket.getRemainingCredits)(this.props.creditsData, this.props.totals),
	                        remainingBalanceAsCredits: this.props.totals.orderTotal && this.props.totals.orderTotal.remainingBalanceAsCredits,
	                        nextDeliveryDate: this.props.nextDeliveryDate,
	                        staticData: this.props.staticData,
	                        totals: this.props.totals,
	                        isCreditItemAsRegularItem: this.props.isCreditItemAsRegularItem,
	                        creditItemLabel: this.props.creditItemLabel,
	                        multiplePickupSitesDates: this.props.multiplePickupSitesDates,
	                        showUpdateRecurringModal: this.props.showUpdateRecurringModal });
	                }
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { md: 2, sm: 2, className: 'categories-wrapper' },
	                        _react2.default.createElement(_StoreCategoriesList2.default, { categories: this.props.categories })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { md: 10, sm: 10 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'items-list-header' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { lg: 6, md: 7, sm: 12, className: 'user-and-cart-wrapper' },
	                                !this.props.preview ? _react2.default.createElement(_UserMenu2.default, null) : this.props.staticData.segments.length > 0 ? _react2.default.createElement(_SegmentsMenu2.default, null) : undefined,
	                                _react2.default.createElement(_StoreCart2.default, { items: itemsList,
	                                    orderedItems: this.props.orderedItems,
	                                    extraCreditItem: this.props.extraCreditItem,
	                                    remainingCredits: (0, _basket.getRemainingCredits)(this.props.creditsData, this.props.totals),
	                                    totals: this.props.totals,
	                                    staticData: this.props.staticData,
	                                    isDropDownClosed: this.props.isDropDownClosed,
	                                    isCreditItemAsRegularItem: this.props.isCreditItemAsRegularItem,
	                                    creditItemLabel: this.props.creditItemLabel,
	                                    showUpdateRecurringModal: this.props.showUpdateRecurringModal
	                                })
	                            ),
	                            _react2.default.createElement(_StoreSearch2.default, null),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { lg: 6, md: 5, sm: 12, className: 'category-title' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'categoryTitle', className: 'category-title-inner' },
	                                    this.props.categoryName
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_StoreItemsList2.default, { className: 'items-container', itemsList: itemsInCategory,
	                            itemsInRow: itemsInRow, itemKey: this.props.itemKey,
	                            activeOrder: this.props.activeOrder,
	                            staticData: this.props.staticData })
	                    ),
	                    this.getUpdateRecurringModal()
	                );
	            } else {
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'No Items'
	                    )
	                );
	            }
	        }
	    }]);
	
	    return StoreItemsScreen;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    var selectedCategory = (state.categories.find(function (c) {
	        return c.selected;
	    }) || {}).key;
	    var categoryName = (state.categories.find(function (c) {
	        return c.selected;
	    }) || { title: '' }).title;
	    var extraCreditItem = (state.storeCreditsData || {}).extraCreditItem || {};
	    var itemsInCategory = {};
	    for (var key in state.itemsList) {
	        if (state.itemsList.hasOwnProperty(key)) {
	            var item = state.itemsList[key];
	            if (!item.variation && (state.staticData.showUnavailableItemsInStore && item.key !== extraCreditItem.key || item.available > 0) && (item.category === selectedCategory || (item.additionalCategories || []).includes(selectedCategory))) itemsInCategory[key] = Object.assign({}, _extends({}, item, { category: selectedCategory }));
	        }
	    }
	    var summary = state.summary || {};
	    var orderStatus = state.orderStatus || {};
	    var multiplePickupSitesDates = (state.summary || {}).multiplePickupSitesDates;
	    return {
	        clientViewPort: state.clientViewPort || {},
	        itemsList: state.itemsList,
	        itemsInCategory: itemsInCategory,
	        categories: state.categories,
	        categoryName: categoryName,
	        allowOrderEdit: summary.allowOrderEdit,
	        orderedItems: orderStatus.orderedItems,
	        activeOrder: orderStatus.activeOrder,
	        isOrderChanged: orderStatus.isChanged,
	        memberDetails: state.memberDetails || {},
	        staticData: state.staticData,
	        nextDeliveryDate: summary.nextDeliveryDate,
	        totals: orderStatus.totals || {},
	        creditsData: state.storeCreditsData || {},
	        extraCreditItem: extraCreditItem,
	        isCreditItemAsRegularItem: state.staticData.isCreditItemAsRegularItem,
	        isMultipleActiveOrdersEnabled: state.staticData.isMultipleActiveOrdersEnabled,
	        creditItemLabel: state.staticData.creditItemLabel,
	        showUpdateRecurringModal: (state.recurringOrder || {}).showUpdateRecurringModal,
	        preview: ((state.staticData || {}).params || {}).mode === 'preview',
	        secondNextDeliveryDate: summary.secondNextDeliveryDate,
	        editMultiOrder: summary.editMultiOrder,
	        nextDeliveryDates: summary.nextDeliveryDates,
	        hasClosedOrder: summary.hasClosedOrder,
	        multiplePickupSitesDates: multiplePickupSitesDates,
	        hasMultiplePickupSites: (state.summary || {}).hasMultiplePickupSites,
	        pickupSiteParam: (state.staticData.params || {}).p
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        changeCategory: function changeCategory(key) {
	            dispatch((0, _storeCategoriesActions.changeCategory)(key));
	        },
	        setAllowOrderEditToStore: function setAllowOrderEditToStore(flag) {
	            dispatch((0, _subscriptionSummaryActions.setAllowOrderEditToStore)(flag));
	        },
	        isDropDownClosed: function isDropDownClosed(_isDropDownClosed) {
	            dispatch((0, _storeCheckoutActions.dropDownClosed)(_isDropDownClosed));
	        },
	        setShowUpdateRecurringModal: function setShowUpdateRecurringModal(showUpdateRecurringModal) {
	            dispatch((0, _recurringOrderActions.setShowUpdateRecurringModal)(showUpdateRecurringModal));
	        },
	        setEditMultiOrder: function setEditMultiOrder(edit) {
	            dispatch((0, _subscriptionSummaryActions.setEditMultiOrder)(edit));
	        },
	        setNextDeliveryDate: function setNextDeliveryDate(nextDeliveryDate) {
	            dispatch((0, _subscriptionSummaryActions.setNextDeliveryDate)(nextDeliveryDate));
	        },
	        addRecurringItemsToOrder: function addRecurringItemsToOrder(deliveryDate) {
	            dispatch((0, _recurringOrderActions.addRecurringItemsToOrder)(deliveryDate));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StoreItemsScreen);

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _ItemCard = __webpack_require__(779);
	
	var _ItemCard2 = _interopRequireDefault(_ItemCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreItemsList = function (_React$Component) {
	    _inherits(StoreItemsList, _React$Component);
	
	    function StoreItemsList() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreItemsList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreItemsList.__proto__ || Object.getPrototypeOf(StoreItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.getComponentsPerRow = function (subArray, itemsList, itemsInRow, startIndex) {
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                { key: startIndex },
	                subArray.map(function (key) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'item-card-wrapper', key: key, xs: 12 / itemsInRow },
	                        _react2.default.createElement(_ItemCard2.default, { item: itemsList[key], key: key, selectedItem: _this.props.itemKey, staticData: _this.props.staticData })
	                    );
	                })
	            );
	        }, _this.renderByCategory = function (itemsList, itemsInRow) {
	            var categories = {};
	            _this.props.categories.map(function (category) {
	                categories[category.key] = { items: [], title: category.title, key: category.key };
	            });
	            for (var key in itemsList) {
	                if (itemsList.hasOwnProperty(key)) {
	                    var item = itemsList[key];
	                    if (!item.variation && (_this.props.staticData.showUnavailableItemsInStore || item.available > 0)) {
	                        categories[item.category].items.push(Object.assign({}, item));
	                    }
	                }
	            }
	            return Object.values(categories).filter(function (category) {
	                return category.items.length > 0;
	            }).map(function (category) {
	                return [_react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'item-card-wrapper', key: category.key, xs: 12 / itemsInRow },
	                    category.title
	                ), _this.renderItems(category.items, itemsInRow, 'i-' + category.key)];
	            });
	        }, _this.renderItems = function (itemsList, itemsInRow) {
	            var category = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'items';
	
	            var keys = Object.keys(itemsList);
	            return _react2.default.createElement(
	                'div',
	                { className: 'items', id: 'items', key: category },
	                keys.map(function (key, index) {
	                    if (index % itemsInRow === 0) {
	                        var subKeysArray = keys.slice(index, index + itemsInRow);
	                        return _this.getComponentsPerRow(subKeysArray, itemsList, itemsInRow, index);
	                    }
	                })
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreItemsList, [{
	        key: 'render',
	        value: function render() {
	            var itemsInRow = this.props.itemsInRow;
	            var itemsList = this.props.itemsList;
	            if (this.props.categories) {
	                return this.renderByCategory(itemsList, itemsInRow);
	            }
	            return this.renderItems(itemsList, itemsInRow);
	        }
	    }]);
	
	    return StoreItemsList;
	}(_react2.default.Component);
	
	exports.default = StoreItemsList;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _reactTooltip = __webpack_require__(780);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _ItemDetails = __webpack_require__(781);
	
	var _ItemDetails2 = _interopRequireDefault(_ItemDetails);
	
	var _ItemUnitOrVariants = __webpack_require__(782);
	
	var _ItemUnitOrVariants2 = _interopRequireDefault(_ItemUnitOrVariants);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _storeActions = __webpack_require__(766);
	
	var _itemCard = __webpack_require__(787);
	
	var _itemCard2 = _interopRequireDefault(_itemCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VariantSelectionPubSub = function VariantSelectionPubSub() {
	    this.subscribers = [];
	    this.subscribe = function (subscriberCallback) {
	        if (subscriberCallback) {
	            this.subscribers.push(subscriberCallback);
	        }
	    };
	
	    this.unSubscribe = function (subscriberCallback) {
	        var idx = this.subscribers.indexOf(subscriberCallback);
	        if (idx > -1) {
	            this.subscribers.splice(idx, 1);
	        }
	    };
	
	    this.publish = function (newVariantItem) {
	        this.variant = newVariantItem;
	        this.subscribers.forEach(function (sc) {
	            return sc(newVariantItem);
	        });
	    };
	};
	
	var ItemCard = function (_React$Component) {
	    _inherits(ItemCard, _React$Component);
	
	    function ItemCard() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ItemCard);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemCard.__proto__ || Object.getPrototypeOf(ItemCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            variantSelectionPubSub: new VariantSelectionPubSub(),
	            shouldShowQuantityUpdater: _this.props.item.quantity == 0 }, _this.openDetails = function () {
	            _this.props.openDetailsAction(_this.props.item.key, _this.props.item.category, _this.props.staticData, _this.props.itemsList, _this.props.activeOrder);
	        }, _this.closeDetails = function () {
	            _this.props.closeDetailsAction(_this.props.item.category);
	        }, _this.getItemDetails = function () {
	            if (_this.props.selectedItem === _this.props.item.key) {
	                return _react2.default.createElement(_ItemDetails2.default, { item: _this.props.item,
	                    staticData: _this.props.staticData,
	                    variantsPubSub: _this.state.variantSelectionPubSub,
	                    clientViewPort: _this.props.clientViewPort,
	                    shouldShowQuantityUpdater: true,
	                    closeDetails: _this.closeDetails });
	            } else {
	                return '';
	            }
	        }, _this.showQuantityUpdater = function () {
	            _this.setState({ shouldShowQuantityUpdater: true });
	        }, _this.hideQuantityUpdater = function () {
	            _this.setState({ shouldShowQuantityUpdater: false });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ItemCard, [{
	        key: 'render',
	        value: function render() {
	            var itemClassName = "item-card";
	            if (this.props.clientViewPort.isXs) {
	                itemClassName = "item-card-mobile row";
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: itemClassName, name: 'item-card', onMouseEnter: this.showQuantityUpdater, onMouseLeave: this.hideQuantityUpdater },
	                _react2.default.createElement(
	                    'div',
	                    { className: this.props.clientViewPort.isXs ? "item-image" : "", 'data-tip': 'Click for more details' },
	                    _react2.default.createElement('img', { src: this.props.item.imageUrl, onClick: this.openDetails, onError: _utils.setNoItemImage }),
	                    _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', offset: { top: -50 } }),
	                    this.props.item.label && _react2.default.createElement(
	                        'div',
	                        { className: 'item-label' },
	                        this.props.item.label
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'details', name: 'details' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'details-top' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item-title', name: 'item-title', onClick: this.openDetails },
	                            this.props.item.title
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'producer-title', name: 'producer-title' },
	                            this.props.item.producerTitle
	                        )
	                    ),
	                    _react2.default.createElement(_ItemUnitOrVariants2.default, {
	                        clientViewPort: this.props.clientViewPort,
	                        item: this.props.item,
	                        staticData: this.props.staticData,
	                        variantsPubSub: this.state.variantSelectionPubSub,
	                        shouldShowQuantityUpdater: this.state.shouldShowQuantityUpdater })
	                ),
	                this.getItemDetails()
	            );
	        }
	    }]);
	
	    return ItemCard;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var status = state.orderStatus || {};
	    return {
	        clientViewPort: state.clientViewPort || {},
	        itemsList: state.itemsList,
	        activeOrder: status.activeOrder
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        openDetailsAction: function openDetailsAction(key, category, staticData, itemsList, activeOrder) {
	            if (staticData.updateItemsAvailabilityOnCategoryChange) {
	                dispatch((0, _storeActions.updateStoreDataAvailability)(staticData, category, itemsList, activeOrder));
	            }
	            dispatch((0, _reactRouterRedux.push)(location.pathname + _constants.ITEM_QRY + "=" + key));
	        },
	        closeDetailsAction: function closeDetailsAction(key) {
	            dispatch((0, _reactRouterRedux.push)(location.pathname + _constants.CATEGORY_QRY + "=" + key));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ItemCard);

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	
	function ___$insertStyle(css) {
	  if (!css) {
	    return;
	  }
	  if (typeof window === 'undefined') {
	    return;
	  }
	
	  var style = document.createElement('style');
	
	  style.setAttribute('type', 'text/css');
	  style.innerHTML = css;
	  document.head.appendChild(style);
	  return css;
	}
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(338));
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	var emptyFunction_1 = emptyFunction;
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var invariant_1 = invariant;
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction_1;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	var warning_1 = warning;
	
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	var ReactPropTypesSecret_1 = ReactPropTypesSecret;
	
	if (false) {
	  var invariant$1 = invariant_1;
	  var warning$1 = warning_1;
	  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
	        } catch (ex) {
	          error = ex;
	        }
	        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	var checkPropTypes_1 = checkPropTypes;
	
	var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret_1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant_1(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning_1(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning_1(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction_1.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = objectAssign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret_1) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant_1(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  }  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var propTypes = createCommonjsModule(function (module) {
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = factoryWithThrowingShims();
	}
	});
	
	var CONSTANT = {
	  GLOBAL: {
	    HIDE: "__react_tooltip_hide_event",
	    REBUILD: "__react_tooltip_rebuild_event",
	    SHOW: "__react_tooltip_show_event"
	  }
	};
	
	/**
	 * Static methods for react-tooltip
	 */
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatible with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event;
	
	  if (typeof window.CustomEvent === "function") {
	    event = new window.CustomEvent(eventName, {
	      detail: opts
	    });
	  } else {
	    event = document.createEvent("Event");
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	};
	
	function staticMethods (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
	      target: target
	    });
	  };
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	
	
	  target.rebuild = function () {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
	  };
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	
	
	  target.show = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
	      target: target
	    });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = {
	        currentTarget: event.detail.target
	      };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({
	        currentTarget: hasTarget && event.detail.target
	      }, hasTarget);
	    }
	  };
	}
	
	/**
	 * Events that should be bound to the window
	 */
	function windowListener (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild
	
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show
	
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize
	
	    if (resizeHide) {
	      window.removeEventListener("resize", this.onWindowResize);
	      window.addEventListener("resize", this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener("resize", this.onWindowResize);
	  };
	  /**
	   * invoked by resize event of window
	   */
	
	
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	}
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	  var isCapture = this.isCapture(e.currentTarget);
	  var currentItem = e.currentTarget.getAttribute("currentItem");
	  if (!isCapture) e.stopPropagation();
	
	  if (show && currentItem === "true") {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute("currentItem", "true");
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute("currentItem", "false");
	    } else {
	      targetArray[i].setAttribute("currentItem", "true");
	    }
	  }
	};
	
	var customListeners = {
	  id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
	  set: function set(target, event, listener) {
	    if (this.id in target) {
	      var map = target[this.id];
	      map[event] = listener;
	    } else {
	      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
	      Object.defineProperty(target, this.id, {
	        configurable: true,
	        value: _defineProperty({}, event, listener)
	      });
	    }
	  },
	  get: function get(target, event) {
	    var map = target[this.id];
	
	    if (map !== undefined) {
	      return map[event];
	    }
	  }
	};
	function customEvent (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	    return event || !!ele.getAttribute("data-event");
	  };
	  /* Bind listener for custom event */
	
	
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _this$state = this.state,
	        event = _this$state.event,
	        eventOff = _this$state.eventOff;
	    var dataEvent = ele.getAttribute("data-event") || event;
	    var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
	    dataEvent.split(" ").forEach(function (event) {
	      ele.removeEventListener(event, customListeners.get(ele, event));
	      var customListener = checkStatus.bind(_this, dataEventOff);
	      customListeners.set(ele, event, customListener);
	      ele.addEventListener(event, customListener, false);
	    });
	
	    if (dataEventOff) {
	      dataEventOff.split(" ").forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	  /* Unbind listener for custom event */
	
	
	  target.prototype.customUnbindListener = function (ele) {
	    var _this$state2 = this.state,
	        event = _this$state2.event,
	        eventOff = _this$state2.eventOff;
	    var dataEvent = event || ele.getAttribute("data-event");
	    var dataEventOff = eventOff || ele.getAttribute("data-event-off");
	    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	}
	
	/**
	 * Util method to judge if it should follow capture model
	 */
	function isCapture (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	function getEffect (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute("data-effect");
	    return dataEffect || this.props.effect || "float";
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	
	var makeProxy = function makeProxy(e) {
	  var proxy = {};
	
	  for (var key in e) {
	    if (typeof e[key] === "function") {
	      proxy[key] = e[key].bind(e);
	    } else {
	      proxy[key] = e[key];
	    }
	  }
	
	  return proxy;
	};
	
	var bodyListener = function bodyListener(callback, options, e) {
	  var _options$respectEffec = options.respectEffect,
	      respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
	      _options$customEvent = options.customEvent,
	      customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
	  var id = this.props.id;
	  var tip = e.target.getAttribute("data-tip") || null;
	  var forId = e.target.getAttribute("data-for") || null;
	  var target = e.target;
	
	  if (this.isCustomEvent(target) && !customEvent) {
	    return;
	  }
	
	  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
	
	  if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
	    var proxy = makeProxy(e);
	    proxy.currentTarget = target;
	    callback(proxy);
	  }
	};
	
	var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
	  var events = {};
	  targetArray.forEach(function (target) {
	    var event = target.getAttribute(dataAttribute);
	    if (event) event.split(" ").forEach(function (event) {
	      return events[event] = true;
	    });
	  });
	  return events;
	};
	
	var getBody = function getBody() {
	  return document.getElementsByTagName("body")[0];
	};
	
	function bodyMode (target) {
	  target.prototype.isBodyMode = function () {
	    return !!this.props.bodyMode;
	  };
	
	  target.prototype.bindBodyListener = function (targetArray) {
	    var _this = this;
	
	    var _this$state = this.state,
	        event = _this$state.event,
	        eventOff = _this$state.eventOff,
	        possibleCustomEvents = _this$state.possibleCustomEvents,
	        possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
	    var body = getBody();
	    var customEvents = findCustomEvents(targetArray, "data-event");
	    var customEventsOff = findCustomEvents(targetArray, "data-event-off");
	    if (event != null) customEvents[event] = true;
	    if (eventOff != null) customEventsOff[eventOff] = true;
	    possibleCustomEvents.split(" ").forEach(function (event) {
	      return customEvents[event] = true;
	    });
	    possibleCustomEventsOff.split(" ").forEach(function (event) {
	      return customEventsOff[event] = true;
	    });
	    this.unbindBodyListener(body);
	    var listeners = this.bodyModeListeners = {};
	
	    if (event == null) {
	      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
	      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
	        respectEffect: true
	      });
	      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
	    }
	
	    for (var _event in customEvents) {
	      listeners[_event] = bodyListener.bind(this, function (e) {
	        var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
	        checkStatus.call(_this, targetEventOff, e);
	      }, {
	        customEvent: true
	      });
	    }
	
	    for (var _event2 in customEventsOff) {
	      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
	        customEvent: true
	      });
	    }
	
	    for (var _event3 in listeners) {
	      body.addEventListener(_event3, listeners[_event3]);
	    }
	  };
	
	  target.prototype.unbindBodyListener = function (body) {
	    body = body || getBody();
	    var listeners = this.bodyModeListeners;
	
	    for (var event in listeners) {
	      body.removeEventListener(event, listeners[event]);
	    }
	  };
	}
	
	/**
	 * Tracking target removing from DOM.
	 * It's necessary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};
	
	function trackRemoval (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	
	            return;
	          }
	        }
	      }
	    });
	    observer.observe(window.document, {
	      childList: true,
	      subtree: true
	    });
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	}
	
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object}
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {Object} {left: {Number}, top: {Number}}
	 */
	function getPosition (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	      tipWidth = _getDimensions.width,
	      tipHeight = _getDimensions.height;
	
	  var _getDimensions2 = getDimensions(target),
	      targetWidth = _getDimensions2.width,
	      targetHeight = _getDimensions2.height;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  }; //
	  // Functions to test whether the tooltip's sides are inside
	  // the client window for a given orientation p
	  //
	  //  _____________
	  // |             | <-- Right side
	  // | p = 'left'  |\
	  // |             |/  |\
	  // |_____________|   |_\  <-- Mouse
	  //      / \           |
	  //       |
	  //       |
	  //  Bottom side
	  //
	
	
	  var outsideLeft = function outsideLeft(p) {
	    return getTipOffsetLeft(p) < 0;
	  };
	
	  var outsideRight = function outsideRight(p) {
	    return getTipOffsetRight(p) > windowWidth;
	  };
	
	  var outsideTop = function outsideTop(p) {
	    return getTipOffsetTop(p) < 0;
	  };
	
	  var outsideBottom = function outsideBottom(p) {
	    return getTipOffsetBottom(p) > windowHeight;
	  }; // Check whether the tooltip with orientation p is completely inside the client window
	
	
	  var outside = function outside(p) {
	    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
	  };
	
	  var inside = function inside(p) {
	    return !outside(p);
	  };
	
	  var placesList = ["top", "bottom", "left", "right"];
	  var insideList = [];
	
	  for (var i = 0; i < 4; i++) {
	    var p = placesList[i];
	
	    if (inside(p)) {
	      insideList.push(p);
	    }
	  }
	
	  var isNewState = false;
	  var newPlace;
	  var shouldUpdatePlace = desiredPlace !== place;
	
	  if (inside(desiredPlace) && shouldUpdatePlace) {
	    isNewState = true;
	    newPlace = desiredPlace;
	  } else if (insideList.length > 0 && shouldUpdatePlace && outside(desiredPlace) && outside(place)) {
	    isNewState = true;
	    newPlace = insideList[0];
	  }
	
	  if (isNewState) {
	    return {
	      isNewState: true,
	      newState: {
	        place: newPlace
	      }
	    };
	  }
	
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	}
	
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	      height = _node$getBoundingClie.height,
	      width = _node$getBoundingClie.width;
	
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	}; // Get current mouse offset
	
	
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	
	  var _getDimensions3 = getDimensions(currentTarget),
	      targetWidth = _getDimensions3.width,
	      targetHeight = _getDimensions3.height;
	
	  if (effect === "float") {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	}; // List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	
	
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top;
	  var right;
	  var bottom;
	  var left;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === "float") {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === "solid") {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return {
	    top: top,
	    bottom: bottom,
	    left: left,
	    right: right
	  };
	}; // Consider additional offset into position calculation
	
	
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === "[object String]") {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '"'));
	  }
	
	  for (var key in offset) {
	    if (key === "top") {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === "bottom") {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === "left") {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === "right") {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return {
	    extraOffset_X: extraOffset_X,
	    extraOffset_Y: extraOffset_Y
	  };
	}; // Get the offset of the parent elements
	
	
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue("transform") !== "none") break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	  return {
	    parentTop: parentTop,
	    parentLeft: parentLeft
	  };
	};
	
	/**
	 * To get the tooltip content
	 * it may comes from data-tip or this.props.children
	 * it should support multiline
	 *
	 * @params
	 * - `tip` {String} value of data-tip
	 * - `children` {ReactElement} this.props.children
	 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
	 *
	 * @return
	 * - String or react component
	 */
	function getTipContent (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	
	  if (getContent === null) return null; // Tip not exist and children is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	
	  if (!multiline || multiline === "false" || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  } // Multiline tooltip content
	
	
	  return tip.split(regexp).map(function (d, i) {
	    return React.createElement("span", {
	      key: i,
	      className: "multi-line"
	    }, d);
	  });
	}
	
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return /(^aria-\w+$|^role$)/.test(prop);
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	  return ariaObj;
	}
	
	/**
	 * Convert nodelist to array
	 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
	 * NodeLists are functions in Safari
	 */
	function nodeListToArray (nodeList) {
	  var length = nodeList.length;
	
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	}
	
	___$insertStyle(".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip:before, .__react_component_tooltip:after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0px;\n  margin-left: 0px;\n  visibility: visible;\n}\n.__react_component_tooltip.type-dark {\n  color: #fff;\n  background-color: #222;\n}\n.__react_component_tooltip.type-dark.place-top:after {\n  border-top-color: #222;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-bottom:after {\n  border-bottom-color: #222;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-left:after {\n  border-left-color: #222;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-right:after {\n  border-right-color: #222;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-dark.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-success {\n  color: #fff;\n  background-color: #8DC572;\n}\n.__react_component_tooltip.type-success.place-top:after {\n  border-top-color: #8DC572;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-success.place-bottom:after {\n  border-bottom-color: #8DC572;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-success.place-left:after {\n  border-left-color: #8DC572;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-success.place-right:after {\n  border-right-color: #8DC572;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-success.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning {\n  color: #fff;\n  background-color: #F0AD4E;\n}\n.__react_component_tooltip.type-warning.place-top:after {\n  border-top-color: #F0AD4E;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-bottom:after {\n  border-bottom-color: #F0AD4E;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-left:after {\n  border-left-color: #F0AD4E;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-right:after {\n  border-right-color: #F0AD4E;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-warning.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-error {\n  color: #fff;\n  background-color: #BE6464;\n}\n.__react_component_tooltip.type-error.place-top:after {\n  border-top-color: #BE6464;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-error.place-bottom:after {\n  border-bottom-color: #BE6464;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-error.place-left:after {\n  border-left-color: #BE6464;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-error.place-right:after {\n  border-right-color: #BE6464;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-error.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-info {\n  color: #fff;\n  background-color: #337AB7;\n}\n.__react_component_tooltip.type-info.place-top:after {\n  border-top-color: #337AB7;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-info.place-bottom:after {\n  border-bottom-color: #337AB7;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-info.place-left:after {\n  border-left-color: #337AB7;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-info.place-right:after {\n  border-right-color: #337AB7;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-info.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-light {\n  color: #222;\n  background-color: #fff;\n}\n.__react_component_tooltip.type-light.place-top:after {\n  border-top-color: #fff;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-light.place-bottom:after {\n  border-bottom-color: #fff;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-light.place-left:after {\n  border-left-color: #fff;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-light.place-right:after {\n  border-right-color: #fff;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-light.border {\n  border: 1px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-top:before {\n  border-top: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-bottom:before {\n  border-bottom: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-left:before {\n  border-left: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-right:before {\n  border-right: 8px solid #222;\n}\n.__react_component_tooltip.place-top {\n  margin-top: -10px;\n}\n.__react_component_tooltip.place-top:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-top:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  bottom: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-bottom {\n  margin-top: 10px;\n}\n.__react_component_tooltip.place-bottom:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  top: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-left {\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-left:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  right: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip.place-right {\n  margin-left: 10px;\n}\n.__react_component_tooltip.place-right:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  left: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0px;\n  text-align: center;\n}");
	
	var _class, _class2, _temp;
	
	var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	
	  function ReactTooltip(props) {
	    var _this;
	
	    _classCallCheck(this, ReactTooltip);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip).call(this, props));
	    _this.state = {
	      place: props.place || "top",
	      // Direction of tooltip
	      desiredPlace: props.place || "top",
	      type: "dark",
	      // Color theme of tooltip
	      effect: "float",
	      // float or fixed
	      show: false,
	      border: false,
	      offset: {},
	      extraClass: "",
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null,
	      // Current mouse event
	      currentTarget: null,
	      // Current target of mouse event
	      ariaProps: parseAria(props),
	      // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      possibleCustomEvents: props.possibleCustomEvents || "",
	      possibleCustomEventsOff: props.possibleCustomEventsOff || "",
	      originTooltip: null,
	      isMultiline: false
	    };
	
	    _this.bind(["showTooltip", "updateTooltip", "hideTooltip", "hideTooltipOnScroll", "getTooltipContent", "globalRebuild", "globalShow", "globalHide", "onWindowResize", "mouseOnToolTip"]);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.delayReshow = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: "bind",
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          insecure = _this$props.insecure,
	          resizeHide = _this$props.resizeHide;
	
	      this.bindListener(); // Bind listener for tooltip
	
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mount = false;
	      this.clearTimer();
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	    /**
	     * Return if the mouse is on the tooltip.
	     * @returns {boolean} true - mouse is on the tooltip
	     */
	
	  }, {
	    key: "mouseOnToolTip",
	    value: function mouseOnToolTip() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        /* old IE or Firefox work around */
	        if (!this.tooltipRef.matches) {
	          /* old IE work around */
	          if (this.tooltipRef.msMatchesSelector) {
	            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
	          } else {
	            /* old Firefox work around */
	            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
	          }
	        }
	
	        return this.tooltipRef.matches(":hover");
	      }
	
	      return false;
	    }
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: "getTargetArray",
	    value: function getTargetArray(id) {
	      var targetArray;
	
	      if (!id) {
	        targetArray = document.querySelectorAll("[data-tip]:not([data-for])");
	      } else {
	        var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll("[data-tip][data-for=\"".concat(escaped, "\"]"));
	      } // targetArray is a NodeList, convert it to a real array
	
	
	      return nodeListToArray(targetArray);
	    }
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: "bindListener",
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          id = _this$props2.id,
	          globalEventOff = _this$props2.globalEventOff,
	          isCapture = _this$props2.isCapture;
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        if (target.getAttribute("currentItem") === null) {
	          target.setAttribute("currentItem", "false");
	        }
	
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customUnbindListener(target);
	        }
	      });
	
	      if (this.isBodyMode()) {
	        this.bindBodyListener(targetArray);
	      } else {
	        targetArray.forEach(function (target) {
	          var isCaptureMode = _this3.isCapture(target);
	
	          var effect = _this3.getEffect(target);
	
	          if (_this3.isCustomEvent(target)) {
	            _this3.customBindListener(target);
	
	            return;
	          }
	
	          target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
	
	          if (effect === "float") {
	            target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
	          }
	
	          target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
	        });
	      } // Global event to hide tooltip
	
	
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
	      } // Track removal of targetArray elements from DOM
	
	
	      this.bindRemovalTracker();
	    }
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: "unbindListener",
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _this$props3 = this.props,
	          id = _this$props3.id,
	          globalEventOff = _this$props3.globalEventOff;
	
	      if (this.isBodyMode()) {
	        this.unbindBodyListener();
	      } else {
	        var targetArray = this.getTargetArray(id);
	        targetArray.forEach(function (target) {
	          _this4.unbindBasicListener(target);
	
	          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	        });
	      }
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	    /**
	     * Invoke this before bind listener and unmount the component
	     * it is necessary to invoke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: "unbindBasicListener",
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
	      target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
	      target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: "getTooltipContent",
	    value: function getTooltipContent() {
	      var _this$props4 = this.props,
	          getContent = _this$props4.getContent,
	          children = _this$props4.children; // Generate tooltip content
	
	      var content;
	
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	
	      return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: "isEmptyTip",
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === "string" && placeholder === "" || placeholder === null;
	    }
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: "showTooltip",
	    value: function showTooltip(e, isGlobalCall) {
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      } // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	
	
	      var _this$props5 = this.props,
	          multiline = _this$props5.multiline,
	          getContent = _this$props5.getContent;
	      var originTooltip = e.currentTarget.getAttribute("data-tip");
	      var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll
	
	      var scrollHide = true;
	
	      if (e.currentTarget.getAttribute("data-scroll-hide")) {
	        scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      } // Make sure the correct place is set
	
	
	      var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
	      var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
	      var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
	      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	      }
	
	      var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering
	
	      this.clearTimer();
	      var target = e.currentTarget;
	      var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
	      var self = this;
	
	      var updateState = function updateState() {
	        self.setState({
	          originTooltip: originTooltip,
	          isMultiline: isMultiline,
	          desiredPlace: desiredPlace,
	          place: place,
	          type: target.getAttribute("data-type") || self.props.type || "dark",
	          effect: effect,
	          offset: offset,
	          html: target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self.props.html || false,
	          delayShow: target.getAttribute("data-delay-show") || self.props.delayShow || 0,
	          delayHide: target.getAttribute("data-delay-hide") || self.props.delayHide || 0,
	          delayUpdate: target.getAttribute("data-delay-update") || self.props.delayUpdate || 0,
	          border: target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self.props.border || false,
	          extraClass: target.getAttribute("data-class") || self.props["class"] || self.props.className || "",
	          disable: target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self.props.disable || false,
	          currentTarget: target
	        }, function () {
	          if (scrollHide) self.addScrollListener(self.state.currentTarget);
	          self.updateTooltip(e);
	
	          if (getContent && Array.isArray(getContent)) {
	            self.intervalUpdateContent = setInterval(function () {
	              if (self.mount) {
	                var _getContent = self.props.getContent;
	                var placeholder = getTipContent(originTooltip, "", _getContent[0](), isMultiline);
	                var isEmptyTip = self.isEmptyTip(placeholder);
	                self.setState({
	                  isEmptyTip: isEmptyTip
	                });
	                self.updatePosition();
	              }
	            }, getContent[1]);
	          }
	        });
	      }; // If there is no delay call immediately, don't allow events to get in first.
	
	
	      if (reshowDelay) {
	        this.delayReshow = setTimeout(updateState, reshowDelay);
	      } else {
	        updateState();
	      }
	    }
	    /**
	     * When mouse hover, update tool tip
	     */
	
	  }, {
	    key: "updateTooltip",
	    value: function updateTooltip(e) {
	      var _this5 = this;
	
	      var _this$state = this.state,
	          delayShow = _this$state.delayShow,
	          disable = _this$state.disable;
	      var afterShow = this.props.afterShow;
	      var placeholder = this.getTooltipContent();
	      var delayTime = parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	
	      if (this.mouseOnToolTip()) {
	        return;
	      }
	
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this5.state.show;
	
	          _this5.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this5.updatePosition();
	
	            if (isInvisible && afterShow) afterShow(e);
	          });
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	    /*
	     * If we're mousing over the tooltip remove it when we leave.
	     */
	
	  }, {
	    key: "listenForTooltipExit",
	    value: function listenForTooltipExit() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
	      }
	    }
	  }, {
	    key: "removeListenerForTooltipExit",
	    value: function removeListenerForTooltipExit() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
	      }
	    }
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: "hideTooltip",
	    value: function hideTooltip(e, hasTarget) {
	      var _this6 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	        isScroll: false
	      };
	      var disable = this.state.disable;
	      var isScroll = options.isScroll;
	      var delayHide = isScroll ? 0 : this.state.delayHide;
	      var afterHide = this.props.afterHide;
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	
	      var resetState = function resetState() {
	        var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	
	        if (_this6.mouseOnToolTip()) {
	          _this6.listenForTooltipExit();
	
	          return;
	        }
	
	        _this6.removeListenerForTooltipExit();
	
	        _this6.setState({
	          show: false
	        }, function () {
	          _this6.removeScrollListener();
	
	          if (isVisible && afterHide) afterHide(e);
	        });
	      };
	
	      this.clearTimer();
	
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	    /**
	     * When scroll, hide tooltip
	     */
	
	  }, {
	    key: "hideTooltipOnScroll",
	    value: function hideTooltipOnScroll(event, hasTarget) {
	      this.hideTooltip(event, hasTarget, {
	        isScroll: true
	      });
	    }
	    /**
	     * Add scroll event listener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: "addScrollListener",
	    value: function addScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
	    }
	  }, {
	    key: "removeScrollListener",
	    value: function removeScrollListener() {
	      window.removeEventListener("scroll", this.hideTooltipOnScroll);
	    } // Calculation the position
	
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      var _this7 = this;
	
	      var _this$state2 = this.state,
	          currentEvent = _this$state2.currentEvent,
	          currentTarget = _this$state2.currentTarget,
	          place = _this$state2.place,
	          desiredPlace = _this$state2.desiredPlace,
	          effect = _this$state2.effect,
	          offset = _this$state2.offset;
	      var node = this.tooltipRef;
	      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	      }
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this7.updatePosition();
	        });
	      } // Set tooltip position
	
	
	      node.style.left = result.position.left + "px";
	      node.style.top = result.position.top + "px";
	    }
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	    /* setStyleHeader() {
	      const head = document.getElementsByTagName("head")[0];
	      if (!head.querySelector('style[id="react-tooltip"]')) {
	        const tag = document.createElement("style");
	        tag.id = "react-tooltip";
	        tag.innerHTML = cssStyle; */
	
	    /* eslint-disable */
	
	    /*      if (typeof __webpack_nonce__ !== 'undefined' && __webpack_nonce__) {
	            tag.setAttribute('nonce', __webpack_nonce__)
	          }*/
	
	    /* eslint-enable */
	
	    /*    head.insertBefore(tag, head.firstChild);
	      }
	    } */
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: "clearTimer",
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearTimeout(this.delayReshow);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var _this$state3 = this.state,
	          extraClass = _this$state3.extraClass,
	          html = _this$state3.html,
	          ariaProps = _this$state3.ariaProps,
	          disable = _this$state3.disable;
	      var placeholder = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(placeholder);
	      var tooltipClass = "__react_component_tooltip" + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " border" : "") + " place-".concat(this.state.place) + // top, bottom, left, right
	      " type-".concat(this.state.type) + ( // dark, success, warning, error, info, light
	      this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
	      var Wrapper = this.props.wrapper;
	
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(" ");
	
	      if (html) {
	        return React.createElement(Wrapper, _extends({
	          className: wrapperClassName,
	          id: this.props.id,
	          ref: function ref(_ref) {
	            return _this8.tooltipRef = _ref;
	          }
	        }, ariaProps, {
	          "data-id": "tooltip",
	          dangerouslySetInnerHTML: {
	            __html: placeholder
	          }
	        }));
	      } else {
	        return React.createElement(Wrapper, _extends({
	          className: wrapperClassName,
	          id: this.props.id
	        }, ariaProps, {
	          ref: function ref(_ref2) {
	            return _this8.tooltipRef = _ref2;
	          },
	          "data-id": "tooltip"
	        }), placeholder);
	      }
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var ariaProps = prevState.ariaProps;
	      var newAriaProps = parseAria(nextProps);
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	
	      if (!isChanged) {
	        return null;
	      }
	
	      return _objectSpread2({}, prevState, {
	        ariaProps: newAriaProps
	      });
	    }
	  }]);
	
	  return ReactTooltip;
	}(React.Component), _defineProperty(_class2, "propTypes", {
	  children: propTypes.any,
	  place: propTypes.string,
	  type: propTypes.string,
	  effect: propTypes.string,
	  offset: propTypes.object,
	  multiline: propTypes.bool,
	  border: propTypes.bool,
	  insecure: propTypes.bool,
	  "class": propTypes.string,
	  className: propTypes.string,
	  id: propTypes.string,
	  html: propTypes.bool,
	  delayHide: propTypes.number,
	  delayUpdate: propTypes.number,
	  delayShow: propTypes.number,
	  event: propTypes.string,
	  eventOff: propTypes.string,
	  watchWindow: propTypes.bool,
	  isCapture: propTypes.bool,
	  globalEventOff: propTypes.string,
	  getContent: propTypes.any,
	  afterShow: propTypes.func,
	  afterHide: propTypes.func,
	  overridePosition: propTypes.func,
	  disable: propTypes.bool,
	  scrollHide: propTypes.bool,
	  resizeHide: propTypes.bool,
	  wrapper: propTypes.string,
	  bodyMode: propTypes.bool,
	  possibleCustomEvents: propTypes.string,
	  possibleCustomEventsOff: propTypes.string,
	  clickable: propTypes.bool
	}), _defineProperty(_class2, "defaultProps", {
	  insecure: true,
	  resizeHide: true,
	  wrapper: "div",
	  clickable: false
	}), _defineProperty(_class2, "supportedWrappers", ["div", "span"]), _defineProperty(_class2, "displayName", "ReactTooltip"), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;
	
	module.exports = ReactTooltip;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _ItemUnitOrVariants = __webpack_require__(782);
	
	var _ItemUnitOrVariants2 = _interopRequireDefault(_ItemUnitOrVariants);
	
	var _JoinScheduleSelector = __webpack_require__(785);
	
	var _JoinScheduleSelector2 = _interopRequireDefault(_JoinScheduleSelector);
	
	var _translate = __webpack_require__(464);
	
	var _utils = __webpack_require__(485);
	
	var _itemDetails = __webpack_require__(786);
	
	var _itemDetails2 = _interopRequireDefault(_itemDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemDetails = function (_React$Component) {
	    _inherits(ItemDetails, _React$Component);
	
	    function ItemDetails() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ItemDetails);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemDetails.__proto__ || Object.getPrototypeOf(ItemDetails)).call.apply(_ref, [this].concat(args))), _this), _this.getProducerLink = function (item) {
	            if (item.producer.link) {
	                return _react2.default.createElement(
	                    'a',
	                    { className: 'producer-link', href: item.producer.link, target: '_blank' },
	                    (0, _translate.translate)("Learn More")
	                );
	            }
	        }, _this.getMobileViewDetails = function () {
	            var item = _this.props.item;
	            return _react2.default.createElement(
	                'div',
	                { className: 'mobile-details-full' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mobile-details scroll' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item-title', id: 'modal-item-title' },
	                            _this.props.item.title
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'producer-title', id: 'modal-producer-title' },
	                            _this.props.item.producerTitle
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'price-and-buttons' },
	                        _react2.default.createElement(_ItemUnitOrVariants2.default, { item: _this.props.item,
	                            clientViewPort: _this.props.clientViewPort,
	                            staticData: _this.props.staticData,
	                            forDetails: true,
	                            schedules: _this.getSchedules(),
	                            variantsPubSub: _this.props.variantsPubSub,
	                            isJoinFlow: _this.props.isJoinFlow,
	                            isFarmSeasonal: _this.props.isFarmSeasonal,
	                            pickupSite: _this.props.pickupSite,
	                            hideQuantityUpdater: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _this.props.item.label && _react2.default.createElement(
	                            'div',
	                            { className: 'item-label' },
	                            _this.props.item.label
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement('img', { src: _this.props.item.imageUrl, onError: _utils.setNoItemImage })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12, className: 'title' },
	                            (0, _translate.translate)("Product Details")
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(_reactBootstrap.Col, { sm: 12, className: 'description', id: 'modal-description', dangerouslySetInnerHTML: { __html: item.description } })
	                    ),
	                    function () {
	                        if (_this.props.staticData.hideProducer) {
	                            return null;
	                        }
	                        if (item.producer.imageUrl && item.producer.imageUrl !== "http://") {
	                            return _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'producer' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12, className: 'title' },
	                                        (0, _translate.translate)("About the producer")
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12, className: 'producer-img' },
	                                        _react2.default.createElement('img', { src: item.producer.imageUrl, className: 'producer-img-src', onError: function onError(event) {
	                                                return event.target.style.display = 'none';
	                                            } })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12, className: 'description', id: 'modal-producer-description' },
	                                        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: item.producer.description } }),
	                                        _this.getProducerLink(item)
	                                    )
	                                )
	                            );
	                        }
	                        return _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'producer' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12, className: 'title' },
	                                    (0, _translate.translate)("About the producer")
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12, className: 'description', id: 'modal-producer-description' },
	                                    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: item.producer.description } }),
	                                    _this.getProducerLink(item)
	                                )
	                            )
	                        );
	                    }()
	                ),
	                _react2.default.createElement(_ItemUnitOrVariants2.default, { item: _this.props.item,
	                    clientViewPort: _this.props.clientViewPort,
	                    staticData: _this.props.staticData,
	                    forDetails: true,
	                    schedules: _this.getSchedules(),
	                    variantsPubSub: _this.props.variantsPubSub,
	                    isJoinFlow: _this.props.isJoinFlow,
	                    isFarmSeasonal: _this.props.isFarmSeasonal,
	                    pickupSite: _this.props.pickupSite,
	                    bottom: true,
	                    onlyShowQuantityUpdater: true,
	                    shouldShowQuantityUpdater: _this.props.shouldShowQuantityUpdater })
	            );
	        }, _this.getTopDetails = function () {
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'top-details' },
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 3 },
	                    _react2.default.createElement('img', { src: _this.props.item.imageUrl, onError: _utils.setNoItemImage })
	                ),
	                _this.props.item.label && _react2.default.createElement(
	                    'div',
	                    { className: 'item-label' },
	                    _this.props.item.label
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 9, className: 'details' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item-title', id: 'modal-item-title' },
	                        _this.props.item.title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'producer-title', id: 'modal-producer-title' },
	                        _this.props.item.producerTitle
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'price-and-buttons' },
	                        _react2.default.createElement(_ItemUnitOrVariants2.default, { item: _this.props.item,
	                            clientViewPort: _this.props.clientViewPort,
	                            staticData: _this.props.staticData,
	                            forDetails: true,
	                            schedules: _this.getSchedules(),
	                            variantsPubSub: _this.props.variantsPubSub,
	                            isJoinFlow: _this.props.isJoinFlow,
	                            isFarmSeasonal: _this.props.isFarmSeasonal,
	                            pickupSite: _this.props.pickupSite,
	                            shouldShowQuantityUpdater: _this.props.shouldShowQuantityUpdater })
	                    )
	                )
	            );
	        }, _this.getBottomDetails = function () {
	            var item = _this.props.item;
	            return _react2.default.createElement(
	                'div',
	                { className: 'bottom-details' },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, className: 'title' },
	                        (0, _translate.translate)("Product Details")
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(_reactBootstrap.Col, { sm: 12, className: 'description', id: 'modal-description', dangerouslySetInnerHTML: { __html: item.description } })
	                ),
	                function () {
	                    if (_this.props.staticData.hideProducer) {
	                        return null;
	                    }
	                    if (item.producer.imageUrl && item.producer.imageUrl !== "http://") {
	                        return _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'producer' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12, className: 'title' },
	                                    (0, _translate.translate)("About the producer")
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'producer-description-row' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 3, className: 'producer-img' },
	                                    _react2.default.createElement('img', { src: item.producer.imageUrl, onError: _utils.setNoItemImage })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 9, className: 'description', id: 'modal-producer-description' },
	                                    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: item.producer.description } }),
	                                    _this.getProducerLink(item)
	                                )
	                            )
	                        );
	                    }
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'producer' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 12, className: 'title' },
	                                (0, _translate.translate)("About the producer")
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 12, className: 'description', id: 'modal-producer-description' },
	                                _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: item.producer.description } }),
	                                _this.getProducerLink(item)
	                            )
	                        )
	                    );
	                }()
	            );
	        }, _this.getSchedules = function () {
	            if (_this.props.isJoinFlow) {
	                return _react2.default.createElement(_JoinScheduleSelector2.default, { item: _this.props.item, schedules: _this.props.schedules, isFarmSeasonal: _this.props.isFarmSeasonal });
	            }
	            return undefined;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ItemDetails, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { className: 'item-details-modal', show: true, onHide: this.props.closeDetails, backdrop: true },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item-details' },
	                        _react2.default.createElement('button', { id: 'close-button', className: 'close-button', onClick: this.props.closeDetails }),
	                        this.props.clientViewPort && this.props.clientViewPort.isXs ? this.getMobileViewDetails() : _react2.default.createElement(
	                            'div',
	                            null,
	                            this.getTopDetails(),
	                            _react2.default.createElement('hr', { className: 'details-divider' }),
	                            this.getBottomDetails()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ItemDetails;
	}(_react2.default.Component);
	
	exports.default = ItemDetails;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _basket = __webpack_require__(757);
	
	var _QuantityUpdater = __webpack_require__(783);
	
	var _QuantityUpdater2 = _interopRequireDefault(_QuantityUpdater);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemUnitOrVariants = function (_React$Component) {
		_inherits(ItemUnitOrVariants, _React$Component);
	
		function ItemUnitOrVariants(props) {
			_classCallCheck(this, ItemUnitOrVariants);
	
			var _this = _possibleConstructorReturn(this, (ItemUnitOrVariants.__proto__ || Object.getPrototypeOf(ItemUnitOrVariants)).call(this, props));
	
			_this.variantChangedSubscription = function (v) {
				if (v !== _this.state.selectedVariation) {
					_this.setState({
						selectedVariation: v
					});
				}
			};
	
			_this.setSelectedVariation = function (selectedVariation) {
				_this.setState({
					selectedVariation: selectedVariation
				});
				var pubSub = _this.props.variantsPubSub;
				if (pubSub) {
					pubSub.publish(selectedVariation);
				}
			};
	
			_this.getUnit = function (item) {
				var creditItemLabel = _this.props.staticData.creditItemLabel;
				var itemPrice = (0, _basket.getItemPrice)(item, _this.props.staticData, _this.props.pickupSite);
				var realPrice = (0, _utils.getPageContext)() === _constants.URLs.ACCOUNT ? itemPrice.fullPrice : itemPrice.priceBeforeTax;
				var calcPrice = !item.isCredit ? (0, _basket.formatMoney)(realPrice) : !_this.props.staticData.isCreditItemAsRegularItem ? (0, _basket.formatCredits)(item.price) : (0, _basket.formatMoney)(item.price);
				if (_this.props.isJoinFlow && _this.props.isFarmSeasonal && _this.props.staticData.hideDeliveryPrice) {
					var distributionsNumber = (0, _basket.getDistributionsNumber)(item, _this.props.selectedSchedule);
					calcPrice = _this.props.selectedSchedule || item.schedules.length === 1 ? (0, _basket.formatMoney)(realPrice * (distributionsNumber ? distributionsNumber : 1)) : undefined;
				}
				var price = calcPrice;
				if (_this.props.isJoinFlow && price && item.price > 0 || !_this.props.isJoinFlow) {
					return _react2.default.createElement(
						'span',
						{ className: 'price-row' },
						price,
						' ',
						item.isCredit && !_this.props.staticData.isCreditItemAsRegularItem ? ' ' + creditItemLabel.toLocaleLowerCase() : "",
						" / ",
						_this.props.staticData.showItemPoints && item.points && _react2.default.createElement(
							'span',
							{ className: 'points', name: 'points' },
							item.points,
							' p.',
							" / "
						),
						_react2.default.createElement(
							'span',
							{ className: 'unit', name: 'unit' },
							_this.props.isJoinFlow && item.unitQuantity === 1 ? '' : item.unitQuantity,
							' ',
							item.unit ? item.unit.replace("credits", creditItemLabel.toLocaleLowerCase()) : item.unit
						)
					);
				} else {
					return _react2.default.createElement('span', { className: 'price-row-empty' });
				}
			};
	
			_this.changeVariation = function (eventKey) {
				_this.setSelectedVariation(eventKey === "none" ? undefined : _this.props.item.variations.find(function (i) {
					return i.key === eventKey;
				}));
			};
	
			_this.getUnitOrVariant = function (item) {
				if (item.variations && item.variations.length) {
					var title = _this.state.selectedVariation ? _this.getUnit(_this.state.selectedVariation) : (0, _translate.translate)("Select variation");
					return _react2.default.createElement(
						_reactBootstrap.DropdownButton,
						{ name: 'btnItemVariation', className: 'item-variation', title: title, onSelect: _this.changeVariation, id: "variation-" + item.key },
						item.variations.sort(function (a, b) {
							return a.price > b.price;
						}).map(function (i) {
							return _react2.default.createElement(
								_reactBootstrap.MenuItem,
								{ eventKey: i.key, key: i.key, onClick: _this.onContactUsClick },
								_this.getUnit(i)
							);
						})
					);
				} else {
					return _this.getUnit(item);
				}
			};
	
			_this.getQuantityUpdater = function (item, details) {
				return _react2.default.createElement(_QuantityUpdater2.default, { item: _this.state.selectedVariation || item,
					details: details,
					variantSelected: item.variations && item.variations.length && !_this.state.selectedVariation,
					isJoinFlow: _this.props.isJoinFlow,
					selectedSchedule: _this.props.selectedSchedule,
					shouldShowQuantityUpdater: _this.props.shouldShowQuantityUpdater,
					staticData: _this.props.staticData
				});
			};
	
			var variations = props.item.variations;
			if (variations && variations.length) {
				var pubSub = props.variantsPubSub;
				var selected = (pubSub || {}).variant;
	
				_this.state = {
					selectedVariation: selected || variations.find(function (i) {
						return i.quantity > (i.minQuantity || 0);
					})
				};
	
				return _possibleConstructorReturn(_this);
			} else {
				_this.state = {
					selectedVariation: undefined
				};
	
				return _possibleConstructorReturn(_this);
			}
			return _this;
		}
	
		_createClass(ItemUnitOrVariants, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.props.item.variations && this.props.item.variations.length) {
					var pubSub = this.props.variantsPubSub;
					if (pubSub) {
						pubSub.subscribe(this.variantChangedSubscription);
					}
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (this.props.item.variations && this.props.item.variations.length) {
					var pubSub = this.props.variantsPubSub;
					if (pubSub) {
						pubSub.unSubscribe(this.variantChangedSubscription);
					}
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var item = nextProps.item;
				if (item.variations && item.variations.length) {
					var selectedVariation = (this.props.variantsPubSub || {}).variant;
					if (!selectedVariation) {
						var variations = item.variations;
						selectedVariation = variations.find(function (i) {
							return i.quantity > (i.minQuantity || 0);
						});
					}
					if (selectedVariation) {
						// refresh it
						var key = selectedVariation.key;
						selectedVariation = item.variations.find(function (i) {
							return i.key === key;
						});
					}
					this.setSelectedVariation(selectedVariation);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var item = this.props.item;
				var isXs = this.props.clientViewPort && this.props.clientViewPort.isXs;
				//Hide schedules if waitlist on mobile
				var schedules = item.waitList && isXs ? undefined : this.props.schedules;
				return _react2.default.createElement(
					'div',
					null,
					this.props.onlyShowQuantityUpdater ? undefined : _react2.default.createElement(
						'div',
						{ className: 'price-wrapper', name: 'price-wrapper' },
						this.getUnitOrVariant(item),
						schedules,
						item.waitList ? _react2.default.createElement(
							'div',
							{ className: 'waitlist' },
							(0, _translate.translate)("waitlist only")
						) : undefined
					),
					this.props.hideQuantityUpdater ? undefined : _react2.default.createElement(
						'div',
						{ className: isXs && this.props.forDetails ? "qty-mobile-wrapper" : "" },
						this.getQuantityUpdater(item, this.props.forDetails)
					)
				);
			}
		}]);
	
		return ItemUnitOrVariants;
	}(_react2.default.Component);
	
	exports.default = ItemUnitOrVariants;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _itemCardActions = __webpack_require__(768);
	
	var _joinActions = __webpack_require__(752);
	
	var _commonActions = __webpack_require__(747);
	
	var _translate = __webpack_require__(464);
	
	var _storeActions = __webpack_require__(766);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _constants = __webpack_require__(463);
	
	var _QuantityUpdater = __webpack_require__(784);
	
	var _QuantityUpdater2 = _interopRequireDefault(_QuantityUpdater);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuantityUpdater = function (_React$Component) {
	    _inherits(QuantityUpdater, _React$Component);
	
	    function QuantityUpdater() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, QuantityUpdater);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuantityUpdater.__proto__ || Object.getPrototypeOf(QuantityUpdater)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showPopup: false,
	            showSchedulePopup: false,
	            showItemVariationPopup: false
	        }, _this.getMinOrderAddAmount = function () {
	            return _this.props.isOrderSummary && _this.props.item.minQuantity || 0;
	        }, _this.onAddButtonClick = function () {
	            if (!_this.props.isJoinFlow && !_this.props.memberDetails.key && !_this.props.staticData.allowDraftOrderBeforeLogin) {
	                _this.props.openLoginSignupPopup();
	                return;
	            }
	            if (_this.props.variantSelected) {
	                _this.setState({ showItemVariationPopup: true });
	                return;
	            }
	            var isItemHasSchedules = _this.props.item.schedules && _this.props.item.schedules.length > 1;
	            if (_this.props.isJoinFlow && isItemHasSchedules && !_this.props.item.selectedSchedule && !_this.props.item.waitList) {
	                _this.setState({ showSchedulePopup: true });
	                return;
	            }
	            _this.props.changeItemQuantity(_this.props.item, _this.props.item.quantity + 1 + _this.getMinOrderAddAmount(), _this.props.isJoinFlow, _this.props.creditsData, _this.props.staticData, _this.props.itemsList, _this.props.activeOrder);
	        }, _this.onMinusButtonClick = function () {
	            _this.props.changeItemQuantity(_this.props.item, Math.max(_this.props.item.quantity - 1 + _this.getMinOrderAddAmount(), 0), _this.props.isJoinFlow, _this.props.creditsData, _this.props.staticData, _this.props.itemsList, _this.props.activeOrder);
	        }, _this.onPlusButtonClick = function () {
	            //if(!this.props.item.moreAvailable)
	            //    return;
	            _this.props.changeItemQuantity(_this.props.item, _this.props.item.quantity + 1 + _this.getMinOrderAddAmount(), _this.props.isJoinFlow, _this.props.creditsData, _this.props.staticData, _this.props.itemsList, _this.props.activeOrder);
	        }, _this.closePopup = function () {
	            _this.setState({ showPopup: false });
	        }, _this.closeSchedulePopup = function () {
	            _this.setState({ showSchedulePopup: false });
	        }, _this.closeItemVariationPopup = function () {
	            _this.setState({ showItemVariationPopup: false });
	        }, _this.getSelectItemVariationPopup = function () {
	            if (_this.state.showItemVariationPopup) {
	                return _react2.default.createElement(_ModalPopup2.default, {
	                    onClose: _this.closeItemVariationPopup,
	                    message: (0, _translate.translate)("_SelectVariationForItem"),
	                    middle: { text: (0, _translate.translate)('Close'), callback: _this.closeItemVariationPopup } });
	            }
	        }, _this.getSchedulePopUp = function () {
	            if (!_this.state.showSchedulePopup) return null;
	            return _react2.default.createElement(_ModalPopup2.default, {
	                onClose: _this.closeSchedulePopup,
	                message: (0, _translate.translate)("_SelectScheduleForShare"),
	                middle: { text: (0, _translate.translate)('Close'), callback: _this.closeSchedulePopup } });
	        }, _this.getOrderSummaryQuantityUpdater = function (quantity, moreAvailable) {
	            if (_this.props.clientViewPort.isXs) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'qty-update' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _this.props.clientViewPort.isXs ? "minus-wrapper" : "" },
	                        ' ',
	                        _react2.default.createElement('button', { className: 'button btn-primary qtn-btn minus-button', name: 'btnMinusOrderSummary', onClick: _this.onMinusButtonClick, disabled: !_this.props.allowChange })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _this.props.clientViewPort.isXs ? "quantity-wrapper" : "" },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'quantity', name: 'quantityOrderSummary' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                quantity
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _this.props.clientViewPort.isXs ? "plus-wrapper" : "" },
	                        _react2.default.createElement('button', { className: 'button btn-primary qtn-btn plus-button', name: 'btnPlusOrderSummary', disabled: !moreAvailable || !_this.props.allowChange, onClick: _this.onPlusButtonClick })
	                    )
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'qty-update' },
	                _react2.default.createElement('button', { className: 'button btn-primary qtn-btn minus-button', name: 'btnMinusOrderSummary', onClick: _this.onMinusButtonClick, disabled: !_this.props.allowChange }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'quantity', name: 'quantityOrderSummary' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        quantity
	                    )
	                ),
	                _react2.default.createElement('button', { className: 'button qtn-btn plus-button', name: 'btnPlusOrderSummary', disabled: !moreAvailable || !_this.props.allowChange, onClick: _this.onPlusButtonClick })
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(QuantityUpdater, [{
	        key: 'render',
	        value: function render() {
	            var item = this.props.item;
	            var quantity = item.quantity;
	            var minQuantity = item.minQuantity;
	            var fullQuantity = quantity + this.getMinOrderAddAmount();
	            var availability = this.props.isJoinFlow ? item.capacity - item.usageCount : item.available;
	            // const moreAvailable = (fullQuantity < item.maxPerMember) && (item.waitList || (fullQuantity - item.orderedQuantity < availability)); //In case of waitlist should not check availability
	            var moreAvailable = this.props.staticData.updateItemAvailabilityOnItemQuantityChange ? fullQuantity <= item.maxPerMember - 1 && (item.waitList || fullQuantity < availability) : //availability already includes the ordered quantity
	            fullQuantity <= item.maxPerMember - 1 && (item.waitList || fullQuantity - item.orderedQuantity < availability); //In case of waitlist should not check availability
	            var soldOut = !item.waitList && availability <= 0;
	            var disableUpdates = this.props.isUpdatingItemAvailability;
	            if (!quantity || quantity === 0) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'qty-update' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: "button btn-primary not-available" + (this.props.details ? " details" : "") + (!soldOut ? " add-button" : " sold-out") + (disableUpdates ? " button loading" : ""), name: 'btnAdd',
	                            onClick: this.onAddButtonClick, disabled: !moreAvailable || this.props.item.schedules && this.props.item.schedules.length < 1 },
	                        soldOut ? (0, _translate.translate)("Sold Out") : !this.props.clientViewPort.isXs || this.props.details ? (0, _translate.translate)("Add") : ''
	                    ),
	                    this.getSelectItemVariationPopup(),
	                    this.getSchedulePopUp()
	                );
	            } else {
	                if (this.props.isOrderSummary || this.props.isReucrring) {
	                    return this.getOrderSummaryQuantityUpdater(quantity, moreAvailable);
	                } else {
	                    var classname = this.props.isJoinFlow || this.props.shouldShowQuantityUpdater || this.props.clientViewPort.isXs ? "qty-update plus-minus" : "qty-update off";
	                    return _react2.default.createElement(
	                        'div',
	                        { className: classname },
	                        _react2.default.createElement(
	                            'div',
	                            { className: this.props.clientViewPort.isXs ? "" : "row" },
	                            _react2.default.createElement(
	                                'div',
	                                { className: this.props.clientViewPort.isXs ? "minus-wrapper" : "minus-wrapper col-sm-4" },
	                                _react2.default.createElement('button', { className: 'button btn-primary qtn-btn minus-button', name: 'btnMinus', onClick: this.onMinusButtonClick, disabled: quantity === minQuantity || disableUpdates })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: this.props.clientViewPort.isXs ? "quantity-wrapper" : "quantity-wrapper col-sm-4" },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'quantity' },
	                                    quantity
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: this.props.clientViewPort.isXs ? "plus-wrapper" : "plus-wrapper col-sm-4" },
	                                _react2.default.createElement('button', { className: "button btn-primary qtn-btn plus-button" + (disableUpdates ? " loading" : ""), name: 'btnPlus', disabled: !moreAvailable || disableUpdates, onClick: this.onPlusButtonClick })
	                            )
	                        )
	                    );
	                }
	            }
	        }
	    }]);
	
	    return QuantityUpdater;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var status = state.orderStatus || {};
	    var staticData = state.staticData || {};
	    return {
	        clientViewPort: state.clientViewPort || {},
	        creditsData: state.storeCreditsData || {},
	        memberDetails: state.memberDetails || {},
	        itemsList: state.itemsList,
	        activeOrder: status.activeOrder,
	        isUpdatingItemAvailability: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.UPDATE_ITEM_AVAILABILITY),
	        staticData: staticData
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        changeItemQuantity: function changeItemQuantity(item, newQuantity, isJoinFlow, creditsData, staticData, itemsList, activeOrder) {
	            if (!ownProps.changeItemQuantity) {
	                var oldQuantity = ownProps.item.quantity;
	                if (isJoinFlow) {
	                    dispatch((0, _joinActions.joinChangeItemQuantity)(item.key, newQuantity));
	                    dispatch((0, _commonActions.setDirty)(true));
	                } else {
	                    dispatch((0, _itemCardActions.changeItemQuantity)(item, newQuantity, oldQuantity, creditsData));
	                }
	            } else {
	                ownProps.changeItemQuantity(item, newQuantity);
	            }
	
	            if (staticData.updateItemsAvailabilityOnCategoryChange) {
	                dispatch((0, _storeActions.updateStoreDataAvailability)(staticData, item.category, itemsList, activeOrder, item.key));
	            }
	            // if (oldQuantity == newQuantity)
	            //     return;
	            // let source = ownProps.isOrderSummary ? GA.GA_LABELS.CART :
	            //     ownProps.details ? GA.GA_LABELS.DETAILS :
	            //         GA.GA_LABELS.ITEM;
	            // let action = (newQuantity < oldQuantity) ?
	            //     ((newQuantity > 0 ) ? GA.GA_ACTIONS.ITEM_QUANTITY_DECREASED : GA.GA_ACTIONS.ITEM_REMOVED) :
	            //     ((oldQuantity > 0) ? GA.GA_ACTIONS.ITEM_QUANTITY_INCREASED : GA.GA_ACTIONS.ITEM_ADD_CLICKED);
	
	            //            dispatch(GA.trackGAEvent(GA.GA_CATEGORIES.STORE, action, source));
	        },
	        openLoginSignupPopup: function openLoginSignupPopup() {
	            dispatch((0, _storeActions.showLoginSignupModal)(true));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QuantityUpdater);

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _joinActions = __webpack_require__(752);
	
	var _translate = __webpack_require__(464);
	
	var _utils = __webpack_require__(485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinScheduleSelector = function (_React$Component) {
	    _inherits(JoinScheduleSelector, _React$Component);
	
	    function JoinScheduleSelector() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinScheduleSelector);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinScheduleSelector.__proto__ || Object.getPrototypeOf(JoinScheduleSelector)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeSchedule = function (eventKey) {
	            _this.props.setSelectedSchedule(_this.props.item.key, eventKey);
	        }, _this.sortSchedules = function (schedule1, schedule2) {
	            if (schedule1.props.scheduleweeksleft === schedule2.props.scheduleweeksleft) {
	                return schedule1.props.scheduletitle.localeCompare(schedule2.props.scheduletitle);
	            }
	            return schedule2.props.scheduleweeksleft - schedule1.props.scheduleweeksleft;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    //Sort the menu items first by the number of deliveries and then alphabetically
	
	
	    _createClass(JoinScheduleSelector, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var allSchedules = this.props.schedules || {};
	            var itemSchedules = this.props.item.schedules;
	            var distributions = this.props.item.weeksLeft[0];
	            if (itemSchedules.length === 0) {
	                return null;
	            } else if (itemSchedules.length === 1) {
	                if (this.props.isFarmSeasonal && distributions && distributions > 1) return _react2.default.createElement(
	                    'div',
	                    { className: 'item-distributions' },
	                    this.props.item.weeksLeft[0] + " " + (0, _translate.translate)("Distributions")
	                );else return null;
	            } else {
	                var title = (0, _translate.translate)("Select schedule");
	                if (this.props.item.selectedSchedule) {
	                    title = allSchedules[this.props.item.selectedSchedule].title;
	                    var distributionsNumber = 0;
	                    itemSchedules.map(function (schedule, index) {
	                        if (_this2.props.item.selectedSchedule === schedule) distributionsNumber = _this2.props.item.weeksLeft[index];
	                    });
	                    if (this.props.isFarmSeasonal && distributionsNumber > 1) title += ' (' + distributionsNumber + " " + (0, _translate.translate)("Distributions") + ')';
	                }
	                if (this.props.item.quantity > 0) return _react2.default.createElement(
	                    'div',
	                    { className: 'item-distributions' },
	                    title
	                );
	                var scheduleAddBtnMessage = this.props.clientViewPort && this.props.clientViewPort.isXs ? 'Click \'+\' button to subscribe' : 'Click \'Add\' to subscribe';
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.DropdownButton,
	                        { name: 'btnItemSchedule', className: 'item-schedule', title: title, onSelect: this.onChangeSchedule, id: "schedule-" + this.props.item.key },
	                        itemSchedules.map(function (schedule, index) {
	                            var distributionsNumber = _this2.props.item.weeksLeft[index];
	                            var nextDeliveryDateText = allSchedules[schedule].nextDeliveryDate ? ' - ' + (0, _translate.translate)('starts on') + ' ' + (0, _utils.getUsefulDate)(allSchedules[schedule].nextDeliveryDate) : '';
	                            return _react2.default.createElement(
	                                _reactBootstrap.MenuItem,
	                                { eventKey: schedule, scheduletitle: allSchedules[schedule].title, scheduleweeksleft: distributionsNumber,
	                                    key: index },
	                                allSchedules[schedule].title,
	                                ' ',
	                                _this2.props.isFarmSeasonal && distributionsNumber > 1 ? '(' + distributionsNumber + " " + (0, _translate.translate)("Distributions") + ')' : '',
	                                nextDeliveryDateText
	                            );
	                        }).sort(this.sortSchedules)
	                    ),
	                    this.props.item.selectedSchedule ? _react2.default.createElement(
	                        'div',
	                        { className: 'item-schedule-add-message' },
	                        scheduleAddBtnMessage
	                    ) : undefined
	                );
	            }
	        }
	    }]);
	
	    return JoinScheduleSelector;
	}(_react2.default.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setSelectedSchedule: function setSelectedSchedule(itemKey, scheduleKey) {
	            dispatch((0, _joinActions.setSelectedSchedule)(itemKey, scheduleKey));
	        }
	    };
	};
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(JoinScheduleSelector);

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _StoreCategoryItem = __webpack_require__(789);
	
	var _StoreCategoryItem2 = _interopRequireDefault(_StoreCategoryItem);
	
	var _constants = __webpack_require__(463);
	
	var _gaActions = __webpack_require__(474);
	
	var _storeActions = __webpack_require__(766);
	
	var _storeCategories = __webpack_require__(790);
	
	var _storeCategories2 = _interopRequireDefault(_storeCategories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreCategoriesList = function (_React$Component) {
	    _inherits(StoreCategoriesList, _React$Component);
	
	    function StoreCategoriesList() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreCategoriesList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreCategoriesList.__proto__ || Object.getPrototypeOf(StoreCategoriesList)).call.apply(_ref, [this].concat(args))), _this), _this.onCategorySelected = function (event) {
	            var selectedCategoryKey = event.target.value;
	            var category = _this.props.categories.find(function (category) {
	                return category.key === selectedCategoryKey;
	            });
	            _this.props.changeCategory(selectedCategoryKey, category.title, _this.props.staticData, _this.props.itemsList, _this.props.activeOrder);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreCategoriesList, [{
	        key: 'render',
	        value: function render() {
	            var categories = this.props.categories;
	            if (this.props.clientViewPort.isXs) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'categories-select-wrapper' },
	                    _react2.default.createElement(
	                        'select',
	                        { className: 'categories-select', onChange: this.onCategorySelected },
	                        categories.map(function (category) {
	                            return _react2.default.createElement(
	                                'option',
	                                { className: 'category-title', key: category.key, value: category.key },
	                                category.title
	                            );
	                        })
	                    )
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'categories-list', id: 'categories' },
	                categories.map(function (c) {
	                    return _react2.default.createElement(_StoreCategoryItem2.default, { category: c, key: c.key });
	                })
	            );
	        }
	    }]);
	
	    return StoreCategoriesList;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var status = state.orderStatus || {};
	    var staticData = state.staticData || {};
	    return {
	        clientViewPort: state.clientViewPort || {},
	        itemsList: state.itemsList,
	        activeOrder: status.activeOrder,
	        staticData: staticData
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        changeCategory: function changeCategory(key, name, staticData, itemsList, activeOrder) {
	            dispatch((0, _gaActions.trackCategoryChange)(name));
	            if (staticData.updateItemsAvailabilityOnCategoryChange) {
	                dispatch((0, _storeActions.updateStoreDataAvailability)(staticData, key, itemsList, activeOrder));
	            }
	            dispatch((0, _reactRouterRedux.push)(location.pathname + _constants.CATEGORY_QRY + "=" + key));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StoreCategoriesList);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _constants = __webpack_require__(463);
	
	var _gaActions = __webpack_require__(474);
	
	var _storeActions = __webpack_require__(766);
	
	var _storeCategories = __webpack_require__(790);
	
	var _storeCategories2 = _interopRequireDefault(_storeCategories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreCategoryItem = function (_React$Component) {
	    _inherits(StoreCategoryItem, _React$Component);
	
	    function StoreCategoryItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreCategoryItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreCategoryItem.__proto__ || Object.getPrototypeOf(StoreCategoryItem)).call.apply(_ref, [this].concat(args))), _this), _this.onCategorySelected = function () {
	            _this.props.changeCategory(_this.props.category.key, _this.props.category.title, _this.props.staticData, _this.props.itemsList, _this.props.activeOrder);
	            document.body.scrollTop = 0; // For Safari
	            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreCategoryItem, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'category-wrapper' },
	                _react2.default.createElement(
	                    'span',
	                    { className: "category" + (this.props.category.selected ? " selected" : ""), name: 'category', onClick: this.onCategorySelected, key: this.props.category.key },
	                    this.props.category.title
	                )
	            );
	        }
	    }]);
	
	    return StoreCategoryItem;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var status = state.orderStatus || {};
	    var staticData = state.staticData || {};
	    return {
	        itemsList: state.itemsList,
	        activeOrder: status.activeOrder,
	        staticData: staticData
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        changeCategory: function changeCategory(key, name, staticData, itemsList, activeOrder) {
	            dispatch((0, _gaActions.trackCategoryChange)(name));
	            if (staticData.updateItemsAvailabilityOnCategoryChange) {
	                dispatch((0, _storeActions.updateStoreDataAvailability)(staticData, key, itemsList, activeOrder));
	            }
	            dispatch((0, _reactRouterRedux.push)(location.pathname + _constants.CATEGORY_QRY + "=" + key));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StoreCategoryItem);

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.StoreTabsWrapper = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _basket = __webpack_require__(757);
	
	var _StoreItemsList = __webpack_require__(778);
	
	var _StoreItemsList2 = _interopRequireDefault(_StoreItemsList);
	
	var _StoreOrderSummary = __webpack_require__(792);
	
	var _StoreOrderSummary2 = _interopRequireDefault(_StoreOrderSummary);
	
	var _StoreCartDeliveryDate = __webpack_require__(795);
	
	var _StoreCartDeliveryDate2 = _interopRequireDefault(_StoreCartDeliveryDate);
	
	var _StoreCategoriesList = __webpack_require__(788);
	
	var _StoreCategoriesList2 = _interopRequireDefault(_StoreCategoriesList);
	
	var _RecurringOrderItems = __webpack_require__(798);
	
	var _RecurringOrderItems2 = _interopRequireDefault(_RecurringOrderItems);
	
	var _translate = __webpack_require__(464);
	
	var _StoreSearch = __webpack_require__(801);
	
	var _StoreSearch2 = _interopRequireDefault(_StoreSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STORE_TAB = "STORE";
	var CART = "CART";
	
	var StoreTabsWrapper = exports.StoreTabsWrapper = function (_React$Component) {
	    _inherits(StoreTabsWrapper, _React$Component);
	
	    function StoreTabsWrapper() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreTabsWrapper);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreTabsWrapper.__proto__ || Object.getPrototypeOf(StoreTabsWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            activeKey: STORE_TAB
	        }, _this.getTabsOrRecurring = function () {
	            if (_this.props.showUpdateRecurringModal) {
	                return _react2.default.createElement(_RecurringOrderItems2.default, null);
	            }
	            var showAllItems = _this.props.staticData.storeNoCategories;
	            var numOfItems = (0, _basket.getNumOfItemsInOrderText)(_this.props.orderedItems, _this.props.extraCreditItem);
	            return _react2.default.createElement(
	                _reactBootstrap.Tabs,
	                { defaultActiveKey: _this.state.activeKey, animation: false, className: 'store-mobile-tabs', id: 'store-mobile-tabs' },
	                _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: STORE_TAB, title: (0, _translate.translate)(_this.props.staticData.storeButtonLabel.toUpperCase()) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'categories-mobile' },
	                        _react2.default.createElement(_StoreSearch2.default, null),
	                        !showAllItems ? _react2.default.createElement(_StoreCategoriesList2.default, { categories: _this.props.categories }) : _react2.default.createElement('div', { className: 'no-categories' }),
	                        _react2.default.createElement(_StoreItemsList2.default, { className: 'items-container', itemsList: showAllItems ? _this.props.allItems : _this.props.itemsList, itemsInRow: _this.props.itemsInRow,
	                            itemKey: _this.props.itemKey, activeOrder: _this.props.activeOrder,
	                            categories: _this.props.allItems ? _this.props.categories : undefined,
	                            staticData: _this.props.staticData })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: CART, title: (0, _translate.translate)('CART') + "(" + numOfItems + ")" },
	                    _react2.default.createElement(_StoreOrderSummary2.default, { items: _this.props.allItems })
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreTabsWrapper, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!nextProps.showUpdateRecurringModal && this.props.showUpdateRecurringModal !== nextProps.showUpdateRecurringModal) {
	                this.setState({ activeKey: CART });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_StoreCartDeliveryDate2.default, { nextDeliveryDate: this.props.nextDeliveryDate,
	                    remainingCredits: this.props.remainingCredits,
	                    remainingBalanceAsCredits: this.props.remainingBalanceAsCredits,
	                    isCreditItemAsRegularItem: this.props.isCreditItemAsRegularItem,
	                    creditItemLabel: this.props.creditItemLabel,
	                    multiplePickupSitesDates: this.props.multiplePickupSitesDates,
	                    staticData: this.props.staticData,
	                    totals: this.props.totals,
	                    isXs: true }),
	                this.getTabsOrRecurring()
	            );
	        }
	    }]);
	
	    return StoreTabsWrapper;
	}(_react2.default.Component);

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	var _basket = __webpack_require__(757);
	
	var _utils = __webpack_require__(485);
	
	var _constants = __webpack_require__(463);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _OrderSummary = __webpack_require__(793);
	
	var _OrderSummary2 = _interopRequireDefault(_OrderSummary);
	
	var _storeActions = __webpack_require__(766);
	
	var _storeOrderSummary = __webpack_require__(797);
	
	var _storeOrderSummary2 = _interopRequireDefault(_storeOrderSummary);
	
	var _commonActions = __webpack_require__(747);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreOrderSummary = function (_React$Component) {
	    _inherits(StoreOrderSummary, _React$Component);
	
	    function StoreOrderSummary() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreOrderSummary);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreOrderSummary.__proto__ || Object.getPrototypeOf(StoreOrderSummary)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            couponChanged: false
	        }, _this.validateCheckout = function () {
	            if (_this.props.staticData.minimumPerOrder) {
	                var validationMsg = _basket.orderValidator.validateMinimumPerOrder(_this.props.items, _this.props.staticData.minimumPerOrder, _this.props.extraCost, _this.props.extraCostType, _this.props.creditsData.credits, _this.props.staticData, _this.props.shareItems);
	                if (validationMsg) {
	                    _this.setState({ popup: {
	                            message: validationMsg,
	                            allowContinue: false
	                        } });
	                    return false;
	                }
	            }
	            if (_this.props.coupon) {
	                var _validationMsg = _basket.orderValidator.validateCouponMinimum(_this.props.items, _this.props.extraCost, _this.props.extraCostType, _this.props.creditsData.credits, _this.props.staticData, _this.props.activeOrder, _this.props.coupon);
	                if (_validationMsg) {
	                    _this.setState({ popup: {
	                            message: _validationMsg,
	                            allowContinue: true,
	                            couponMinimumValidation: true
	                        } });
	                    return false;
	                }
	            }
	            if (_this.props.creditsData.remainingCredits > 0 && _this.props.creditsData.creditType === _constants.CreditTypes.CREDIT_BY_SHARE) {
	                var _validationMsg2 = (0, _translate.translate)(_constants.NOT_USED_ALL_CREDITS_MESSAGE + " " + _this.props.creditItemLabel.toLocaleLowerCase());
	                if (_validationMsg2) {
	                    _this.setState({ popup: {
	                            message: _validationMsg2,
	                            allowContinue: true
	                        } });
	                    return false;
	                }
	            }
	            return true;
	        }, _this.onCheckoutButtonClick = function () {
	            if (_this.props.memberLoggedIn) {
	                if (_this.validateCheckout()) {
	                    _this.props.checkout(_this.editableTotal);
	                }
	            } else {
	                _this.props.saveDraftOrderAndShowModal();
	            }
	        }, _this.onCheckoutButtonPopupClick = function () {
	            _this.props.checkout(_this.editableTotal);
	        }, _this.closePopup = function () {
	            _this.setState({ popup: undefined });
	        }, _this.checkoutAndRemoveCoupon = function () {
	            _this.props.removeCouponAndUpdateSummary();
	            _this.onCheckoutButtonPopupClick();
	        }, _this.popupMessage = function () {
	            if (_this.state.popup.allowContinue && _this.state.popup.couponMinimumValidation) {
	                return _react2.default.createElement(_ModalPopup2.default, {
	                    message: (0, _translate.translate)("The changes to your order have made the coupon invalid." + "</br>" + (0, _translate.translate)("To redeem the coupon, please order $") + _this.props.coupon.minimumOrder + (0, _translate.translate)(" or more. Click 'Cancel' to return to the store or 'Checkout' to proceed without the coupon.")),
	                    right: { text: (0, _translate.translate)('Checkout'), callback: _this.checkoutAndRemoveCoupon },
	                    left: { text: (0, _translate.translate)('Cancel'), callback: _this.closePopup } });
	            }
	            if (_this.state.popup.allowContinue) return _react2.default.createElement(_ModalPopup2.default, {
	                onClose: _this.closePopup,
	                message: _this.state.popup.message,
	                right: { text: (0, _translate.translate)('Checkout'), callback: _this.onCheckoutButtonPopupClick },
	                left: { text: (0, _translate.translate)('Back'), callback: _this.closePopup } });
	            return _react2.default.createElement(_ModalPopup2.default, {
	                onClose: _this.closePopup,
	                message: _this.state.popup.message,
	                middle: { text: (0, _translate.translate)('Close'), callback: _this.closePopup } });
	        }, _this.isEnabledCheckout = function () {
	            return _this.props.orderChanged || _this.props.activeOrder && _this.state.couponChanged;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreOrderSummary, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ((nextProps.coupon || {}).id !== (this.props.coupon || {}).id) {
	                this.setState({ couponChanged: true });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.popup) {
	                return this.popupMessage();
	            }
	            var checkoutLabel = (this.props.staticData.storeCheckoutButtonLabel || (0, _translate.translate)(this.props.memberLoggedIn ? "Checkout" : 'Proceed')).split('|')[0];
	            return _react2.default.createElement(
	                'div',
	                { className: 'order-summary-container' },
	                _react2.default.createElement(_OrderSummary2.default, { readonly: this.props.readonly }),
	                this.props.readonly ? undefined : _react2.default.createElement(
	                    'div',
	                    { className: 'checkout-button-wrapper' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: 'primary', className: 'order-summary-checkout button', id: 'orderSummaryCheckoutButton', disabled: !this.isEnabledCheckout(),
	                            onClick: this.onCheckoutButtonClick },
	                        checkoutLabel,
	                        ' ',
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            (0, _basket.getCheckoutPrice)(this.props.totals)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StoreOrderSummary;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var summary = state.summary || {};
	    var orderStatus = state.orderStatus || {};
	    return {
	        staticData: state.staticData || {},
	        creditsData: state.storeCreditsData || {},
	        activeOrder: orderStatus.activeOrder,
	        orderChanged: orderStatus.isChanged,
	        extraCost: summary.extraCost,
	        extraCostType: summary.extraCostType,
	        totals: orderStatus.totals,
	        coupon: orderStatus.coupon,
	        creditItemLabel: state.staticData.creditItemLabel,
	        memberLoggedIn: Boolean((state.memberDetails || {}).key),
	        shareItems: summary.shareItems
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        saveDraftOrderAndShowModal: function saveDraftOrderAndShowModal() {
	            dispatch((0, _storeActions.saveDraftOrder)(true));
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _storeActions.showLoginSignupModal)(true));
	        },
	        checkout: function checkout() {
	            dispatch((0, _reactRouterRedux.push)((0, _utils.addPath)('checkout')));
	        },
	        removeCouponAndUpdateSummary: function removeCouponAndUpdateSummary() {
	            dispatch((0, _storeActions.setCouponAndUpdateSummary)(undefined));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StoreOrderSummary);

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _StoreOrderSummaryItem = __webpack_require__(794);
	
	var _StoreOrderSummaryItem2 = _interopRequireDefault(_StoreOrderSummaryItem);
	
	var _StoreCartDeliveryDate = __webpack_require__(795);
	
	var _StoreCartDeliveryDate2 = _interopRequireDefault(_StoreCartDeliveryDate);
	
	var _StoreOrderSummaryTotal = __webpack_require__(796);
	
	var _StoreOrderSummaryTotal2 = _interopRequireDefault(_StoreOrderSummaryTotal);
	
	var _translate = __webpack_require__(464);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _recurringOrderActions = __webpack_require__(767);
	
	var _storeOrderSummary = __webpack_require__(797);
	
	var _storeOrderSummary2 = _interopRequireDefault(_storeOrderSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderSummary = function (_React$Component) {
	    _inherits(OrderSummary, _React$Component);
	
	    function OrderSummary() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, OrderSummary);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderSummary.__proto__ || Object.getPrototypeOf(OrderSummary)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.getCreditTitle = function (items, title) {
	            if (items && items.length && _this.props.creditsData.creditType === _constants.CreditTypes.CREDIT_BY_SHARE) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'order-summary-fixed-items', id: 'orderSummaryCreditFixedItemsTitle' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'items-group-title' },
	                        (0, _translate.translate)(title)
	                    ),
	                    _react2.default.createElement('hr', { className: 'summary-item-divider' })
	                );
	            }
	        }, _this.onClickUpdateRecurring = function () {
	            _this.props.setShowUpdateRecurringModal(true);
	        }, _this.isEnableUpdateRecurring = function () {
	            var orderedItems = _this.props.orderedItems || {};
	            return _this.props.staticData.hasRecurringItems && !_this.props.hideRecurring && (((_this.props.recurringOrder || {}).items || []).length > 0 || orderedItems.creditFixedItems && orderedItems.creditFixedItems.length > 0 || orderedItems.fixedItems && orderedItems.fixedItems.length > 0 || orderedItems.creditEditableItems && orderedItems.creditEditableItems.length > 0 || orderedItems.editableItems && orderedItems.editableItems.length > 0);
	        }, _this.getRecurringLink = function (readOnly) {
	            if (_this.isEnableUpdateRecurring() && _this.props.clientViewPort.isXs) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'update-recurring-link-mobile', onClick: _this.onClickUpdateRecurring },
	                    (!readOnly ? "Update" : "View") + " Recurring"
	                );
	            }
	        }, _this.isCheckoutScreen = function () {
	            return window.location.pathname.includes("checkout");
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(OrderSummary, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var orderedItems = this.props.orderedItems || {};
	            var totals = this.props.totals || {};
	            var fixedTotal = totals.fixedTotal;
	            var editableTotal = totals.editableTotal;
	            var isCreditItemAsRegularItem = this.props.isCreditItemAsRegularItem;
	            if (this.state.popup) {
	                return this.popupMessage();
	            }
	            if ((0, _utils.isEmptyObj)(this.props.orderStatus)) {
	                return null;
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    !this.props.clientViewPort.isXs ? _react2.default.createElement(_StoreCartDeliveryDate2.default, { orderDate: this.props.orderDate,
	                        nextDeliveryDate: this.props.nextDeliveryDate,
	                        multiplePickupSitesDates: this.props.multiplePickupSitesDates,
	                        creditItemLabel: this.props.creditItemLabel,
	                        enableRecurringLink: this.isEnableUpdateRecurring(),
	                        onClickUpdateRecurring: this.onClickUpdateRecurring,
	                        isCheckoutScreen: this.isCheckoutScreen(),
	                        isXs: this.props.clientViewPort.isXs }) : undefined,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'scroll' },
	                        orderedItems.creditFixedItems && orderedItems.creditFixedItems.length || orderedItems.fixedItems && orderedItems.fixedItems.length ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h4',
	                                { className: 'items-group-title existing-order' },
	                                (0, _translate.translate)("Existing Order")
	                            ),
	                            _react2.default.createElement('hr', { className: 'summary-item-divider existing-order' })
	                        ) : undefined,
	                        orderedItems.creditFixedItems && orderedItems.creditFixedItems.length ? _react2.default.createElement(
	                            'div',
	                            { className: 'order-summary-fixed-items', id: 'orderSummaryCreditFixedItems' },
	                            !this.props.isCreditItemAsRegularItem ? _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'h4',
	                                    { className: 'items-group-title' },
	                                    (0, _translate.translate)("Items for") + " " + this.props.creditItemLabel
	                                ),
	                                _react2.default.createElement('hr', { className: 'summary-item-divider' })
	                            ) : undefined,
	                            !this.props.isCreditItemAsRegularItem ? orderedItems.creditFixedItems.map(function (item) {
	                                return _react2.default.createElement(_StoreOrderSummaryItem2.default, { key: item.key, item: item, readonly: true,
	                                    creditsData: _this2.props.creditsData });
	                            }) : undefined,
	                            orderedItems.fixedItems && orderedItems.fixedItems.length && this.props.isCreditItemAsRegularItem ? undefined : _react2.default.createElement(
	                                'div',
	                                null,
	                                this.getRecurringLink(true),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Grid,
	                                    { className: 'order-summary-total', id: 'orderSummaryTotal' },
	                                    _react2.default.createElement(_StoreOrderSummaryTotal2.default, { isCredit: !isCreditItemAsRegularItem,
	                                        orderTotal: isCreditItemAsRegularItem ? totals.orderTotal : { creditsTotal: totals.creditFixedItems },
	                                        readonly: true })
	                                )
	                            )
	                        ) : undefined,
	                        !this.props.isCreditItemAsRegularItem ? this.getCreditTitle(orderedItems.fixedItems, "Items for Purchase") : undefined,
	                        orderedItems.fixedItems && orderedItems.fixedItems.length ? _react2.default.createElement(
	                            'div',
	                            { className: 'order-summary-fixed-items', id: 'orderSummaryFixedItems' },
	                            this.props.isCreditItemAsRegularItem && orderedItems.creditFixedItems && orderedItems.creditFixedItems.length ? _react2.default.createElement(
	                                'div',
	                                null,
	                                orderedItems.creditFixedItems.map(function (item) {
	                                    return _react2.default.createElement(_StoreOrderSummaryItem2.default, { key: item.key, item: item, readonly: true,
	                                        creditsData: _this2.props.creditsData });
	                                })
	                            ) : undefined,
	                            orderedItems.fixedItems.map(function (item) {
	                                return _react2.default.createElement(_StoreOrderSummaryItem2.default, { key: item.key, item: item, readonly: true,
	                                    creditsData: _this2.props.creditsData
	                                });
	                            }),
	                            this.getRecurringLink(true),
	                            _react2.default.createElement(
	                                _reactBootstrap.Grid,
	                                { className: 'order-summary-total', id: 'orderSummaryTotal' },
	                                _react2.default.createElement(_StoreOrderSummaryTotal2.default, { orderTotal: fixedTotal,
	                                    readonly: true })
	                            )
	                        ) : undefined,
	                        (orderedItems.creditFixedItems && orderedItems.creditFixedItems.length || orderedItems.fixedItems && orderedItems.fixedItems.length) && (orderedItems.creditEditableItems && orderedItems.creditEditableItems.length || orderedItems.editableItems && orderedItems.editableItems.length) ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h4',
	                                { className: 'items-group-title' },
	                                (0, _translate.translate)("Additional Order")
	                            ),
	                            _react2.default.createElement('hr', { className: 'summary-item-divider' })
	                        ) : undefined,
	                        orderedItems.creditEditableItems && orderedItems.creditEditableItems.length ? _react2.default.createElement(
	                            'div',
	                            { className: 'order-summary-items', id: 'orderSummaryCreditItems' },
	                            !this.props.isCreditItemAsRegularItem ? _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'h4',
	                                    { className: 'items-group-title' },
	                                    (0, _translate.translate)("Items for") + " " + this.props.creditItemLabel
	                                ),
	                                _react2.default.createElement('hr', { className: 'summary-item-divider' })
	                            ) : undefined,
	                            orderedItems.creditEditableItems.map(function (item) {
	                                return _react2.default.createElement(_StoreOrderSummaryItem2.default, { key: item.key, item: item, readonly: _this2.props.readonly,
	                                    creditsData: _this2.props.creditsData });
	                            }),
	                            orderedItems.editableItems && orderedItems.editableItems.length && this.props.isCreditItemAsRegularItem ? undefined : _react2.default.createElement(
	                                'div',
	                                null,
	                                this.getRecurringLink(this.props.readonly),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Grid,
	                                    { className: 'order-summary-total', id: 'orderSummaryTotal' },
	                                    _react2.default.createElement(_StoreOrderSummaryTotal2.default, { isCredit: !isCreditItemAsRegularItem,
	                                        orderTotal: isCreditItemAsRegularItem ? totals.orderTotal : { creditsTotal: totals.creditEditableItems },
	                                        readonly: this.props.readonly })
	                                )
	                            )
	                        ) : undefined,
	                        !this.props.isCreditItemAsRegularItem ? this.getCreditTitle(orderedItems.editableItems, "Items for Purchase") : undefined,
	                        orderedItems.editableItems && orderedItems.editableItems.length ? _react2.default.createElement(
	                            'div',
	                            { className: 'order-summary-items', id: 'orderSummaryItems' },
	                            orderedItems.editableItems.map(function (item) {
	                                return _react2.default.createElement(_StoreOrderSummaryItem2.default, { key: item.key, item: item, readonly: _this2.props.readonly,
	                                    creditsData: _this2.props.creditsData });
	                            }),
	                            this.getRecurringLink(this.props.readonly),
	                            _react2.default.createElement(
	                                _reactBootstrap.Grid,
	                                { id: 'orderSummaryTotal', className: editableTotal.extraCostAmount ? "order-summary-total has-extra-cost" : "order-summary-total" },
	                                _react2.default.createElement(_StoreOrderSummaryTotal2.default, { orderTotal: editableTotal,
	                                    totalPoints: totals.points,
	                                    readonly: this.props.readonly })
	                            )
	                        ) : undefined,
	                        (!orderedItems.fixedItems || !orderedItems.fixedItems.length) && (!orderedItems.editableItems || !orderedItems.editableItems.length) && (!orderedItems.creditFixedItems || !orderedItems.creditFixedItems.length) && (!orderedItems.creditEditableItems || !orderedItems.creditEditableItems.length) ? _react2.default.createElement(
	                            'div',
	                            { className: 'order-summary-empty-items',
	                                id: 'orderSummaryEmptyItems' },
	                            (0, _translate.translate)('_StartAddingItems'),
	                            _react2.default.createElement('div', { className: 'cart-img' })
	                        ) : undefined
	                    )
	                );
	            }
	        }
	    }]);
	
	    return OrderSummary;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var summary = state.summary || {};
	    var orderStatus = state.orderStatus || {};
	    return {
	        clientViewPort: state.clientViewPort || {},
	        staticData: state.staticData,
	        activeOrder: orderStatus.activeOrder,
	        canEditExistingOrder: summary.canEditExistingOrder,
	        orderChanged: orderStatus.isChanged,
	        nextDeliveryDate: summary.nextDeliveryDate,
	        multiplePickupSitesDates: summary.multiplePickupSitesDates,
	        extraCost: summary.extraCost,
	        creditsData: state.storeCreditsData || {},
	        orderedItems: orderStatus.orderedItems,
	        totals: orderStatus.totals,
	        orderStatus: orderStatus,
	        isCreditItemAsRegularItem: state.staticData.isCreditItemAsRegularItem,
	        creditItemLabel: state.staticData.creditItemLabel,
	        recurringOrder: state.recurringOrder || {}
	    };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setShowUpdateRecurringModal: function setShowUpdateRecurringModal(showUpdateRecurringModal) {
	            dispatch((0, _recurringOrderActions.setShowUpdateRecurringModal)(showUpdateRecurringModal));
	        }
	    };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OrderSummary);

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _itemCardActions = __webpack_require__(768);
	
	var _QuantityUpdater = __webpack_require__(783);
	
	var _QuantityUpdater2 = _interopRequireDefault(_QuantityUpdater);
	
	var _basket = __webpack_require__(757);
	
	var _utils = __webpack_require__(485);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _constants = __webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreOrderSummaryItem = function (_React$Component) {
	    _inherits(StoreOrderSummaryItem, _React$Component);
	
	    function StoreOrderSummaryItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreOrderSummaryItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreOrderSummaryItem.__proto__ || Object.getPrototypeOf(StoreOrderSummaryItem)).call.apply(_ref, [this].concat(args))), _this), _this.onRemoveButtonClick = function () {
	            _this.props.changeItemQuantity(_this.props.item, _this.props.item.minQuantity || 0, _this.props.item.quantity, _this.props.creditsData);
	        }, _this.getDetails = function (item, price, extraCreditItem) {
	            var itemTitle = item.key !== extraCreditItem.key ? item.title : item.title ? item.title.replace("Credit", _this.props.serverStaticData.creditItemLabel) : item.title;
	            var points = _this.props.serverStaticData.showItemPoints && item.points ? _react2.default.createElement(
	                'span',
	                { className: 'points' },
	                ' / ',
	                item.points,
	                ' p. '
	            ) : '';
	            return _react2.default.createElement(
	                'div',
	                { className: 'item-details', onClick: function onClick() {
	                        return _this.openDetails(item);
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'title', name: 'orderSummaryItemName' },
	                    itemTitle
	                ),
	                item.key !== extraCreditItem.key ? _react2.default.createElement(
	                    'div',
	                    { className: 'price', name: 'orderSummaryItemPrice' },
	                    price,
	                    ' ',
	                    points,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'unit' },
	                        item.unit ? " / " + item.unitQuantity + " " + item.unit.replace("credits", _this.props.serverStaticData.creditItemLabel) : undefined,
	                        ' '
	                    )
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'price', name: 'orderSummaryItemPrice' },
	                    price,
	                    ' '
	                )
	            );
	        }, _this.openDetails = function (item) {
	            var itemObj = _this.props.allItems[item.key];
	            _this.props.openDetailsBox(item.category, itemObj.defaultBoxItem || item.key);
	        }, _this.isExisting = function (propsReadonly, itemKey, extraCreditItemKey) {
	            return propsReadonly || itemKey === extraCreditItemKey;
	        }, _this.getQuantityAndTotal = function (item, price, extraCreditItem) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'quantity-and-total-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: _this.isExisting(_this.props.readonly, item.key, extraCreditItem.key) ? 'item-exist' : 'item-not-exist' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'order-summary-item-qty', name: 'orderSummaryItemQty' },
	                        _this.props.readonly || item.key === extraCreditItem.key ? (0, _basket.formatCredits)(item.quantity) : _react2.default.createElement(_QuantityUpdater2.default, { item: item, isOrderSummary: true, allowChange: true, staticData: _this.props.serverStaticData })
	                    )
	                ),
	                !item.isCredit ? _react2.default.createElement(
	                    'div',
	                    { className: 'order-summary-item-total',
	                        name: 'orderSummaryItemTotal' },
	                    (0, _basket.formatMoney)(item.quantity * (0, _basket.getItemPrice)(item, _this.props.serverStaticData).priceBeforeTax)
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'order-summary-item-total',
	                        name: 'orderSummaryItemTotal' },
	                    !_this.props.serverStaticData.isCreditItemAsRegularItem ? (0, _basket.formatCredits)(item.quantity * item.price) : (0, _basket.formatMoney)(item.quantity * item.price)
	                )
	            );
	        }, _this.getRecurringIcon = function (item) {
	            if (!_this.props.serverStaticData.hasRecurringItems || !_this.props.recurringOrderItems) {
	                return null;
	            }
	            var recurringItem = _this.props.recurringOrderItems.find(function (i) {
	                return item.key === i.key;
	            });
	            if (!recurringItem || !recurringItem.schedule) {
	                return null;
	            }
	            return _react2.default.createElement(
	                'svg',
	                { className: 'recurring-item-icon', version: '1.0', xmlns: 'http://www.w3.org/2000/svg',
	                    width: '16.000000px', height: '16.000000px', viewBox: '0 0 714.639 595.281',
	                    enableBackground: 'new 0 0 714.639 595.281' },
	                _react2.default.createElement(
	                    'g',
	                    null,
	                    _react2.default.createElement('path', { d: 'M486.796,483.129c-39.451,27.563-85.475,41.473-132.51,40.715c-6.322,0-12.391-0.506-18.46-1.012 c-2.529-0.252-5.058-0.506-7.586-1.012c-4.806-0.76-9.61-1.266-14.415-2.275c-2.782-0.506-5.816-1.264-8.598-2.023 c-4.553-1.012-9.104-2.275-13.657-3.541c-2.276-0.758-4.299-1.516-6.322-2.021c-5.058-1.771-10.368-3.541-15.426-5.564 c-1.265-0.506-2.276-1.012-3.288-1.518c-5.816-2.527-11.632-5.311-17.196-8.344c-0.253-0.254-0.506-0.254-0.759-0.506 c-18.966-10.369-36.162-23.518-51.334-38.438c-0.253-0.254-0.506-0.506-0.759-0.76c-4.805-4.807-9.104-9.609-13.402-14.92 c-1.012-1.014-1.771-2.275-2.782-3.287c-30.852-38.691-49.565-87.75-49.565-140.855h59.427l-94.83-142.877L0.001,297.768h59.427 c0,62.713,19.472,120.623,52.599,168.67c0.506,0.762,0.759,1.52,1.264,2.023c3.541,4.805,7.334,9.357,10.874,14.162 c1.265,1.77,2.782,3.539,4.046,5.311c5.311,6.574,11.127,12.645,17.196,18.713c0.505,0.508,1.011,1.266,1.517,1.771 c19.978,19.977,42.484,36.668,66.76,50.07c0.759,0.252,1.265,0.758,2.023,1.012c7.081,3.793,14.161,7.08,21.748,10.367 c1.77,0.76,3.54,1.77,5.563,2.527c6.322,2.529,12.644,4.807,19.219,7.08c3.035,1.014,6.069,2.023,9.356,3.035 c5.563,1.771,11.38,3.035,17.449,4.553c3.793,1.014,7.839,1.771,11.633,2.527c1.518,0.254,3.287,0.76,4.805,1.012 c5.563,1.014,11.127,1.52,16.69,2.277c2.022,0.252,4.046,0.504,6.069,0.758c9.861,1.012,19.725,1.52,29.586,1.52 c60.438,0,119.612-18.461,170.188-53.863c16.185-11.381,19.978-33.633,8.853-49.818C525.234,475.543,502.98,471.75,486.796,483.129' }),
	                    _react2.default.createElement('path', { d: 'M654.708,297.768c0-62.461-19.473-120.371-52.348-168.166c-0.504-0.758-0.759-1.77-1.265-2.529 c-4.047-5.816-8.598-11.379-13.149-16.69c-0.506-0.759-1.011-1.265-1.517-2.023c-30.094-36.667-68.024-64.99-111.016-83.451 c-1.264-0.506-2.275-1.011-3.539-1.517c-6.828-2.782-13.91-5.311-20.99-7.839c-2.528-0.759-5.057-1.77-7.586-2.529 c-6.067-1.77-12.391-3.288-18.713-4.805c-3.541-0.759-7.082-1.77-10.369-2.276c-1.77-0.253-3.287-0.759-5.057-1.265 c-4.805-0.758-9.357-1.264-14.162-1.77c-3.287-0.253-6.574-1.012-9.861-1.264c-7.84-0.759-15.68-1.012-23.518-1.265 c-1.518,0-2.783-0.253-4.301-0.253c-0.252,0-0.504,0-0.759,0c-60.438,0-119.358,18.208-169.936,53.611 c-16.184,11.379-19.978,33.633-8.851,49.817c11.379,16.184,33.633,19.978,49.817,8.851c38.943-27.311,84.716-41.219,131.244-40.713 c6.828,0,13.402,0.505,19.979,1.011c2.022,0.253,4.045,0.506,6.067,0.759c5.312,0.758,10.621,1.517,15.933,2.529 c2.274,0.506,4.553,1.011,6.827,1.517c5.058,1.265,10.367,2.529,15.427,4.046c1.518,0.505,3.035,1.011,4.805,1.517 c5.816,1.77,11.379,3.793,16.943,6.322c0.506,0.253,1.264,0.506,1.77,0.759c33.381,14.414,62.461,36.415,85.221,63.979 c0.253,0.253,0.253,0.506,0.507,0.506c32.114,38.944,51.334,89.014,51.334,143.383H524.22l95.336,142.877l95.082-142.877 L654.708,297.768L654.708,297.768z' })
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreOrderSummaryItem, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var item = this.props.item || {};
	            var extraCreditItem = (this.props.creditsData || {}).extraCreditItem || {};
	            var price = item.isCredit && !this.props.serverStaticData.isCreditItemAsRegularItem ? item.price + " " + this.props.serverStaticData.creditItemLabel : (0, _basket.formatMoney)((0, _basket.getItemPrice)(item, this.props.serverStaticData).priceBeforeTax);
	            if (item.key === extraCreditItem.key && this.props.serverStaticData.isCreditItemAsRegularItem) {
	                return null;
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'order-summary-item-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: this.props.clientViewPort.isXs ? "order-summary-item" : "order-summary-item" },
	                    this.getRecurringIcon(item),
	                    _react2.default.createElement('img', { src: item.imageUrl, onError: _utils.setNoItemImage, onClick: function onClick() {
	                            return _this2.openDetails(item);
	                        } }),
	                    this.props.clientViewPort.isXs ? _react2.default.createElement(
	                        'div',
	                        { className: 'details-wrapper' },
	                        this.getDetails(item, price, extraCreditItem),
	                        this.getQuantityAndTotal(item, price, extraCreditItem)
	                    ) : this.getDetails(item, price, extraCreditItem),
	                    !this.props.clientViewPort.isXs ? this.getQuantityAndTotal(item, price, extraCreditItem) : "",
	                    this.props.readonly || item.key === extraCreditItem.key ? undefined : _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('button', { className: 'delete-button order-summary-item-remove hidden-xs',
	                            name: 'btnOrderSummaryItemRemove', onClick: this.onRemoveButtonClick })
	                    )
	                ),
	                _react2.default.createElement('hr', { className: 'summary-item-divider' })
	            );
	        }
	    }]);
	
	    return StoreOrderSummaryItem;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        serverStaticData: state.staticData,
	        clientViewPort: state.clientViewPort || {},
	        recurringOrderItems: (state.recurringOrder || {}).items,
	        allItems: state.itemsList || {}
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        changeItemQuantity: function changeItemQuantity(item, newQuantity, oldQuantity, creditData) {
	            dispatch((0, _itemCardActions.changeItemQuantity)(item, newQuantity, oldQuantity, creditData));
	            // dispatch(GA.trackGAEvent(GA.GA_CATEGORIES.STORE, GA.GA_ACTIONS.ITEM_REMOVED, GA.GA_LABELS.CART));
	        },
	        openDetailsBox: function openDetailsBox(category, item) {
	            dispatch((0, _reactRouterRedux.push)(location.pathname + _constants.CART_ITEM_QRY + "=" + item + _constants.CATEGORY_QRY + "=" + category));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StoreOrderSummaryItem);

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _utils = __webpack_require__(485);
	
	var _basket = __webpack_require__(757);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreCartDeliveryDate = function (_React$Component) {
	    _inherits(StoreCartDeliveryDate, _React$Component);
	
	    function StoreCartDeliveryDate() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreCartDeliveryDate);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreCartDeliveryDate.__proto__ || Object.getPrototypeOf(StoreCartDeliveryDate)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeDate = function (pickupSite) {
	            window.location.assign(location.pathname + "?p=" + pickupSite);
	        }, _this.onChangeDateMobile = function (event) {
	            _this.onChangeDate(event.target.value);
	        }, _this.renderDatesSelector = function (deliveryDateStr, multiplePickupSitesDates) {
	            if (_this.props.isXs) {
	                return _react2.default.createElement(
	                    'select',
	                    { id: 'deliveryDateSelector', className: 'delivery-date-selector', onChange: _this.onChangeDateMobile, defaultValue: deliveryDateStr },
	                    multiplePickupSitesDates.map(function (date) {
	                        return _react2.default.createElement(
	                            'option',
	                            { key: date.key, value: date.key },
	                            date.dateStr
	                        );
	                    })
	                );
	            }
	            return _react2.default.createElement(
	                _reactBootstrap.DropdownButton,
	                { name: 'deliveryDateSelector', className: 'delivery-date-selector', title: deliveryDateStr, onSelect: _this.onChangeDate, id: 'deliveryDateSelector' },
	                multiplePickupSitesDates.map(function (date) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { eventKey: date.key, key: date.key },
	                        date.dateStr
	                    );
	                })
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreCartDeliveryDate, [{
	        key: 'render',
	        value: function render() {
	            var showPoints = (this.props.staticData || {}).showItemPoints && this.props.nextDeliveryDate;
	            var credits = this.props.remainingCredits && this.props.remainingCredits.credits ? (0, _basket.formatCredits)(this.props.remainingCredits.credits) : 0;
	            var remainingBalanceAsCredits = this.props.remainingBalanceAsCredits;
	            var enableRecurringLink = this.props.enableRecurringLink;
	            var deliveryDateStr = !this.props.orderDate ? this.props.nextDeliveryDate ? (0, _utils.getUsefulDate)(this.props.nextDeliveryDate) : '' : (0, _utils.getUsefulDateWithYear)(this.props.orderDate);
	            var multiplePickupSitesDates = [];
	            for (var pickupSiteDate in this.props.multiplePickupSitesDates) {
	                if (this.props.multiplePickupSitesDates.hasOwnProperty(pickupSiteDate)) multiplePickupSitesDates.push({ key: pickupSiteDate, date: this.props.multiplePickupSitesDates[pickupSiteDate], dateStr: (0, _utils.getUsefulDate)(this.props.multiplePickupSitesDates[pickupSiteDate]) });
	            }
	            var hasMultipleDeliveryDates = multiplePickupSitesDates.length > 1;
	            var missingPoints = showPoints ? (this.props.staticData || {}).minimumPerOrder - this.props.totals.points : 0;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'order-summary-delivery', id: 'orderSummaryDelivery' },
	                _react2.default.createElement('i', { className: 'truck-icon' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: "delivery-title" + (hasMultipleDeliveryDates && this.props.isXs ? " multiple-dates" : "") },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'delivery-date-title' },
	                        (0, _translate.translate)('Delivery'),
	                        ': '
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'delivery-date' },
	                        hasMultipleDeliveryDates ? this.renderDatesSelector(deliveryDateStr, multiplePickupSitesDates.sort(function (a, b) {
	                            return a.date > b.date;
	                        })) : deliveryDateStr
	                    ),
	                    enableRecurringLink ? _react2.default.createElement(
	                        'div',
	                        { className: "pull-right update-recurring-link" + (!this.props.isCheckoutScreen ? "" : " checkout"),
	                            onClick: this.props.onClickUpdateRecurring },
	                        (!this.props.isCheckoutScreen ? "Update" : "View") + " Recurring"
	                    ) : undefined
	                ),
	                missingPoints > 0 && _react2.default.createElement(
	                    'div',
	                    { className: 'remaining-credits' },
	                    'Add ',
	                    (0, _basket.formatPoints)(missingPoints),
	                    ' p. to Checkout'
	                ),
	                !showPoints && this.props.remainingCredits && this.props.remainingCredits.show ? _react2.default.createElement(
	                    'div',
	                    { className: 'remaining-credits' },
	                    (remainingBalanceAsCredits > 0 ? "Balance: " + (0, _basket.formatCredits)(remainingBalanceAsCredits) + " / " : "") + this.props.creditItemLabel + ": " + credits
	                ) : undefined,
	                _react2.default.createElement('hr', { className: 'summary-item-divider' })
	            );
	        }
	    }]);
	
	    return StoreCartDeliveryDate;
	}(_react2.default.Component);
	
	exports.default = StoreCartDeliveryDate;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	var _basket = __webpack_require__(757);
	
	var _storeActions = __webpack_require__(766);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreOrderSummaryTotal = function (_React$Component) {
	    _inherits(StoreOrderSummaryTotal, _React$Component);
	
	    function StoreOrderSummaryTotal() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreOrderSummaryTotal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreOrderSummaryTotal.__proto__ || Object.getPrototypeOf(StoreOrderSummaryTotal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            disabledApply: true,
	            couponLinkClicked: false
	        }, _this.validateCoupon = function (props) {
	            if (props.couponStatus === _constants.CouponStatus.INVALID) {
	                return (0, _translate.translate)(_constants.CouponStatus.INVALID_COUPON);
	            }if (props.coupon) {
	                var message = void 0;
	
	                if (props.coupon.couponType !== "WebStore") {
	                    message = (0, _translate.translate)(_constants.CouponStatus.INVALID_COUPON);
	                } else if (props.coupon.validationType === _constants.CouponStatus.INVALID_COUPON_FIRST_USE) {
	                    message = (0, _translate.translate)(_constants.CouponStatus.INVALID_COUPON_FIRST_USE);
	                } else if (props.coupon.validationType === _constants.CouponStatus.INVALID_COUPON_ALREADY_USE) {
	                    message = (0, _translate.translate)(_constants.CouponStatus.INVALID_COUPON_ALREADY_USE);
	                } else {
	                    message = _basket.orderValidator.validateCouponMinimum(props.itemsList, props.extraCost, props.extraCostType, props.creditsData.credits, props.staticData, props.activeOrder, props.coupon);
	                }
	                if (message) {
	                    _this.props.removeCoupon();
	                }
	                return message;
	            }
	        }, _this.onApplyCouponClicked = function () {
	            if (!_this.state.disabledApply) {
	                _this.props.applyCoupon(_this.refs.couponId.value);
	            }
	        }, _this.onChangeCouponId = function (event) {
	            var couponId = event.target.value;
	            var invalidStatus = _this.state.invalidStatus;
	            if (invalidStatus && (0, _utils.isEmptyString)(couponId)) {
	                invalidStatus = undefined;
	            }
	            _this.setState({ disabledApply: (0, _utils.isEmptyString)(couponId), invalidStatus: invalidStatus });
	        }, _this.isDisabledCouponButton = function () {
	            var enabledPaymentMethods = [_constants.PaymentMethod.PAYPAL_STANDARD, _constants.PaymentMethod.ELECTRONIC_CHECK, _constants.PaymentMethod.CHECK, _constants.PaymentMethod.AUTHORIZE_DOT_NET, _constants.PaymentMethod.EBT_ONLINE.key];
	            var storePaymentMethods = _this.props.storePaymentMethods;
	            if (_this.props.coupon && _this.props.coupon.existingCoupon) {
	                return enabledPaymentMethods.some(function (method) {
	                    return storePaymentMethods.includes(method.key);
	                });
	            }
	            return false;
	        }, _this.getCoupon = function (couponValue) {
	            if (_this.props.hasCoupons) {
	                if ((_this.props.coupon || {}).id && !couponValue) {
	                    return;
	                }
	                if (!(_this.props.coupon || {}).valid && !_this.state.couponLinkClicked && !_this.props.readonly) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'store-coupon' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12, className: 'total-title coupon-title', onClick: function onClick() {
	                                    _this.setState({ couponLinkClicked: true });
	                                } },
	                            "+ " + (0, _translate.translate)("Add Coupon")
	                        )
	                    );
	                } else if (_this.props.coupon && _this.props.couponStatus === _constants.CouponStatus.VALID && !_this.state.invalidStatus) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'store-coupon' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'total-title' },
	                            _this.props.coupon.id
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'coupon-remove-col' },
	                            _this.props.readonly ? undefined : _react2.default.createElement('div', { className: 'coupon-remove',
	                                name: 'btnRemoveStoreCoupon',
	                                disabled: _this.props.isFetching,
	                                onClick: _this.props.removeCoupon }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'order-summary-sub-total order-summary-coupon',
	                                    name: 'orderSummaryCoupon' },
	                                "-" + (0, _basket.formatMoney)(_this.props.coupon.discount)
	                            )
	                        )
	                    );
	                } else if (!_this.props.readonly) {
	                    var submitLoadingClass = _this.props.couponStatus === _constants.CouponStatus.VALIDATING ? " loading" : "";
	                    var submitClasses = "submit-order coupon-btn button" + submitLoadingClass;
	                    var inputClass = _this.state.invalidStatus ? "coupon-code-input coupon-code-input-error" : "coupon-code-input";
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'store-coupon' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'total-title input-coupon-col' },
	                            _react2.default.createElement('input', { type: 'text', ref: 'couponId', id: 'inpCouponCode', onChange: _this.onChangeCouponId,
	                                className: inputClass })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'total-title coupon-btn-col' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { disabled: _this.state.disabledApply, bsStyle: 'primary', className: submitClasses,
	                                    id: 'btnApplyCoupon',
	                                    onClick: _this.onApplyCouponClicked },
	                                (0, _translate.translate)("Apply")
	                            )
	                        ),
	                        _this.state.invalidStatus ? _react2.default.createElement(
	                            'div',
	                            { className: 'coupon-code-validation' },
	                            _this.state.invalidStatus
	                        ) : undefined
	                    );
	                }
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreOrderSummaryTotal, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.couponStatus !== this.props.couponStatus && this.props.couponStatus === _constants.CouponStatus.VALIDATING) {
	                var status = this.validateCoupon(nextProps);
	                this.setState({ invalidStatus: status });
	            }
	            if (this.props.isDropDownClosed !== nextProps.isDropDownClosed && !nextProps.isDropDownClosed) {
	                this.setState({ couponLinkClicked: false, invalidStatus: undefined });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var orderTotal = this.props.orderTotal;
	            if (this.props.isCredit && !this.props.isCreditItemAsRegularItem) {
	                var usedCredits = orderTotal.creditsTotal;
	                if (isNaN(usedCredits)) usedCredits = 0;
	                var totalCredits = !this.props.isCreditItemAsRegularItem ? (0, _basket.formatCredits)(usedCredits) : "-" + (0, _basket.formatMoney)(usedCredits);
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7, className: 'total-title' },
	                        (0, _translate.translate)("Total") + " " + this.props.creditItemLabel,
	                        ':'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 5, className: 'order-summary-credits-col' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'order-summary-credits', name: 'orderSummaryTotalCredits' },
	                            totalCredits
	                        )
	                    )
	                );
	            } else {
	                var orderTotalFormatted = (0, _basket.formatPrice)(orderTotal);
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    orderTotal.priceBeforeTax ? _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'total-title' },
	                            (0, _translate.translate)("Subtotal"),
	                            ': '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'order-summary-sub-total',
	                                    name: 'orderSummarySubTotal' },
	                                orderTotalFormatted.priceBeforeTax
	                            )
	                        )
	                    ) : undefined,
	                    orderTotal.creditsTotal && this.props.isCreditItemAsRegularItem ? _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'total-title' },
	                            this.props.creditItemLabel,
	                            ':'
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'order-summary-credits-col' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'order-summary-credits', name: 'orderSummaryTotalCredits' },
	                                "-" + (0, _basket.formatMoney)(orderTotal.creditsTotal)
	                            )
	                        )
	                    ) : undefined,
	                    orderTotal.tax ? _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'total-title' },
	                            (0, _translate.translate)("Tax"),
	                            ': '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'order-summary-tax',
	                                    name: 'orderSummaryTax' },
	                                orderTotalFormatted.tax
	                            )
	                        )
	                    ) : undefined,
	                    orderTotal.extraCostAmount ? _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8, className: 'total-title' },
	                            orderTotal.extraCostLabel
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'order-summary-sub-total order-summary-extra-cost',
	                                    name: 'orderSummaryExtraCost' },
	                                orderTotalFormatted.extraCostAmount
	                            )
	                        )
	                    ) : undefined,
	                    orderTotal.usedCredits ? _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'total-title' },
	                            (0, _translate.translate)("Credits"),
	                            ':'
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'order-summary-sub-total order-summary-used-credits',
	                                    name: 'orderSummaryUsedCredits' },
	                                orderTotalFormatted.usedCredits
	                            )
	                        )
	                    ) : undefined,
	                    orderTotal.balanceAsCredits ? _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'total-title' },
	                            (0, _translate.translate)("Credit Applied"),
	                            ':'
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'order-summary-sub-total order-summary-used-credits',
	                                    name: 'orderSummaryUsedCredits' },
	                                orderTotalFormatted.balanceAsCredits
	                            )
	                        )
	                    ) : undefined,
	                    this.getCoupon(this.props.orderTotal.couponValue),
	                    _react2.default.createElement('hr', { className: 'summary-item-divider' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'total-title' },
	                            (0, _translate.translate)("Total"),
	                            ': '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'order-summary-grand-total',
	                                    name: 'orderSummaryGrandTotal' },
	                                orderTotalFormatted.fullPrice
	                            )
	                        )
	                    ),
	                    this.props.staticData.showItemPoints && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6, className: 'total-title' },
	                            (0, _translate.translate)("Total Points"),
	                            ': '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'order-summary-grand-total',
	                                    name: 'orderSummaryPointsTotal' },
	                                (0, _basket.formatPoints)(this.props.totalPoints)
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return StoreOrderSummaryTotal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var orderStatus = state.orderStatus || {};
	    var staticData = state.staticData || {};
	    var summary = state.summary || {};
	    var couponStatus = state.fetching.isFetching && state.fetching.fetchingType === _constants.FetchingTypes.VALIDATE_COUPON ? _constants.CouponStatus.VALIDATING : !orderStatus.coupon ? _constants.CouponStatus.NONE : orderStatus.coupon.valid ? _constants.CouponStatus.VALID : _constants.CouponStatus.INVALID;
	    return {
	        staticData: state.staticData,
	        hasCoupons: orderStatus.hasCoupons,
	        coupon: orderStatus.coupon,
	        couponStatus: couponStatus,
	        storePaymentMethods: staticData.storePaymentMethods,
	        creditsData: state.storeCreditsData || {},
	        extraCost: (state.summary || {}).extraCost,
	        itemsList: state.itemsList,
	        extraCostType: summary.extraCostType,
	        activeOrder: orderStatus.activeOrder,
	        isDropDownClosed: (state.checkout || {}).isDropDownClosed,
	        isCreditItemAsRegularItem: state.staticData.isCreditItemAsRegularItem,
	        creditItemLabel: state.staticData.creditItemLabel
	    };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        applyCoupon: function applyCoupon(couponId) {
	            dispatch((0, _storeActions.applyCoupon)(couponId));
	        },
	        removeCoupon: function removeCoupon() {
	            dispatch((0, _storeActions.setCouponAndUpdateSummary)(undefined));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StoreOrderSummaryTotal);

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _recurringOrderActions = __webpack_require__(767);
	
	var _translate = __webpack_require__(464);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _constants = __webpack_require__(463);
	
	var _RecurringItem = __webpack_require__(799);
	
	var _RecurringItem2 = _interopRequireDefault(_RecurringItem);
	
	var _itemCardActions = __webpack_require__(768);
	
	var _commonActions = __webpack_require__(747);
	
	var _utils = __webpack_require__(485);
	
	var _recurringOrederItems = __webpack_require__(800);
	
	var _recurringOrederItems2 = _interopRequireDefault(_recurringOrederItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecurringOrderItems = function (_React$Component) {
	    _inherits(RecurringOrderItems, _React$Component);
	
	    function RecurringOrderItems() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RecurringOrderItems);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RecurringOrderItems.__proto__ || Object.getPrototypeOf(RecurringOrderItems)).call.apply(_ref, [this].concat(args))), _this), _this.getItems = function () {
	            var recurringOrderItems = _this.props.recurringOrder.items || [];
	            var recurringItems = {};
	            var recurringKeys = [];
	            recurringOrderItems.map(function (recurringItem) {
	                recurringItems[recurringItem.key] = recurringItem.schedule;
	            });
	            var editableItems = _this.props.webOrderItems.editableItems;
	            var fixedItems = _this.props.webOrderItems.fixedItems;
	            var creditEditableItems = _this.props.webOrderItems.creditEditableItems;
	            var creditFixedItems = _this.props.webOrderItems.creditFixedItems;
	            var extraCreditKey = _this.props.extraCreditKey;
	            var currentRecurringItems = [].concat(editableItems).concat(creditEditableItems).filter(function (item) {
	                return item.key !== extraCreditKey;
	            });
	            currentRecurringItems.map(function (item) {
	                item.schedule = recurringItems[item.key];
	                recurringKeys.push(item.key);
	            });
	            var fixedCurrentRecurringItems = [].concat(fixedItems).concat(creditFixedItems).filter(function (item) {
	                return item.key !== extraCreditKey;
	            });
	            fixedCurrentRecurringItems.map(function (item) {
	                item.schedule = recurringItems[item.key];
	                recurringKeys.push(item.key);
	            });
	
	            var notInOrderRecurringOrders = [];
	            recurringOrderItems.map(function (item) {
	                if (!recurringKeys.includes(item.key) && item.schedule !== undefined) {
	                    notInOrderRecurringOrders.push(item);
	                }
	            });
	
	            var that = _this;
	            return _react2.default.createElement(
	                'div',
	                null,
	                fixedCurrentRecurringItems.length > 0 ? _react2.default.createElement(
	                    'div',
	                    null,
	                    fixedCurrentRecurringItems.map(function (item) {
	                        return that.getItem(item, true);
	                    })
	                ) : undefined,
	                currentRecurringItems.length > 0 ? _react2.default.createElement(
	                    'div',
	                    null,
	                    currentRecurringItems.map(function (item) {
	                        return that.getItem(item, _this.props.readOnly);
	                    })
	                ) : undefined,
	                notInOrderRecurringOrders.length > 0 ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'recurring-order-items-title not-in-order' },
	                        "Recurring items not in " + (0, _utils.getUsefulDate)(_this.props.nextDeliveryDate) + " order"
	                    ),
	                    notInOrderRecurringOrders.map(function (item) {
	                        return that.getItem(item, _this.props.readOnly);
	                    })
	                ) : undefined
	            );
	        }, _this.updateWebOrder = function (item, remove) {
	            _this.props.changeItemQuantity(item, remove ? -1 : item.quantity, remove ? item.quantity : 0, _this.props.creditsData, true);
	            _this.props.setDirty(true);
	        }, _this.getItem = function (item, disabled) {
	            if (item.quantity > 0) {
	                return _react2.default.createElement(_RecurringItem2.default, { item: item, clientViewPort: _this.props.clientViewPort,
	                    key: item.key, disabled: disabled, staticData: _this.props.staticData,
	                    farmSchedules: _this.props.recurringOrder.farmSchedules,
	                    nextDeliveryDate: _this.props.nextDeliveryDate,
	                    updateWebOrder: _this.updateWebOrder,
	                    setRecurringItem: _this.props.setRecurringItem
	                });
	            }
	        }, _this.continueButtonClicked = function () {
	            _this.props.setShowUpdateRecurringModal(false);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(RecurringOrderItems, [{
	        key: 'render',
	        value: function render() {
	            if (!(this.props.recurringOrder || {}).items) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    'There are not any recurring items to show'
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'recurring-items-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'recurring-order-items-title' },
	                    'Please set schedule for items you would like to receive as a recurring order'
	                ),
	                this.props.clientViewPort.isXs ? _react2.default.createElement('hr', { className: 'summary-item-divider' }) : undefined,
	                this.getItems(),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'recurring-setting-footer' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { onClick: this.continueButtonClicked,
	                            type: 'submit',
	                            className: "submit-order button recurring-continue-btn" + (this.props.showLoading ? " loading" : ""),
	                            bsStyle: 'primary' },
	                        (0, _translate.translate)("Back to Order")
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RecurringOrderItems;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var webOrderItems = (state.orderStatus || {}).orderedItems;
	    var extraCreditKey = ((state.storeCreditsData || {}).extraCreditItem || {}).key;
	    return {
	        recurringOrder: state.recurringOrder || {},
	        showLoading: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.VALIDATE_UPDATE_MEMBER),
	        clientViewPort: state.clientViewPort || {},
	        staticData: state.staticData,
	        nextDeliveryDate: (state.summary || {}).nextDeliveryDate,
	        creditsData: state.storeCreditsData || {},
	        webOrderItems: webOrderItems,
	        extraCreditKey: extraCreditKey
	
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setShowUpdateRecurringModal: function setShowUpdateRecurringModal(isShowRecurringModal) {
	            dispatch((0, _recurringOrderActions.setShowUpdateRecurringModal)(isShowRecurringModal));
	        },
	        changeItemQuantity: function changeItemQuantity(item, newQuantity, oldQuantity, creditData, updateSchedule) {
	            dispatch((0, _itemCardActions.changeItemQuantity)(item, newQuantity, oldQuantity, creditData, updateSchedule));
	        },
	        setRecurringItem: function setRecurringItem(item, updateSchedule) {
	            dispatch((0, _recurringOrderActions.setRecurringItem)(item, updateSchedule));
	        },
	        setDirty: function setDirty(isDirty) {
	            dispatch((0, _commonActions.setDirty)(isDirty));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RecurringOrderItems);

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _utils = __webpack_require__(485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecurringItem = function (_React$Component) {
	    _inherits(RecurringItem, _React$Component);
	
	    function RecurringItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RecurringItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RecurringItem.__proto__ || Object.getPrototypeOf(RecurringItem)).call.apply(_ref, [this].concat(args))), _this), _this.onSelectionSchedule = function (scheduleKey) {
	            var schedule = scheduleKey !== "Once" ? _this.props.farmSchedules[scheduleKey] : undefined;
	            var item = _this.props.item;
	            if (schedule !== undefined) {
	                item.isRecurring = true;
	                if (schedule.dates.includes(_this.props.nextDeliveryDate)) {
	                    item.isItemNotPartOfOrder = false;
	                    if (!item.schedule) {
	                        item.schedule = schedule;
	                        _this.props.setRecurringItem(item, true);
	                    } else {
	                        item.schedule = schedule;
	                        _this.props.updateWebOrder(item);
	                    }
	                } else {
	                    item.schedule = schedule;
	                    item.isItemNotPartOfOrder = true;
	                    _this.props.updateWebOrder(item, true);
	                }
	            } else if (item.schedule !== undefined) {
	                item.schedule = undefined;
	                item.isItemNotPartOfOrder = false;
	                _this.props.updateWebOrder(item);
	            }
	        }, _this.getSchedules = function (item) {
	            var schedules = [];
	            var index = 0;
	            for (var schedulesKey in _this.props.farmSchedules) {
	                if (_this.props.farmSchedules.hasOwnProperty(schedulesKey)) {
	                    schedules.push(_react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { key: schedulesKey, eventKey: schedulesKey, id: index++ },
	                        _this.props.farmSchedules[schedulesKey].title
	                    ));
	                }
	            }
	            schedules.unshift(_react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { key: 'Once', eventKey: 'Once', id: -1 },
	                'Once'
	            ));
	            return _react2.default.createElement(
	                _reactBootstrap.DropdownButton,
	                { className: 'recurring-schedules-selection', noCaret: true,
	                    disabled: _this.props.disabled || item.available <= 0,
	                    id: 'state-selection', onSelect: _this.onSelectionSchedule,
	                    title: item.schedule ? _this.props.farmSchedules[item.schedule.key].title : "Once" },
	                schedules
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(RecurringItem, [{
	        key: 'render',
	        value: function render() {
	            var item = this.props.item;
	            return _react2.default.createElement(
	                'div',
	                { className: 'order-summary-item-wrapper' },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'order-summary-item' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 2, md: 2, className: 'order-summary-item-img' },
	                        _react2.default.createElement('img', { src: item.imageUrl, onError: _utils.setNoItemImage })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 5, md: 3, className: 'recurring-item-details' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'recurring-item-name' },
	                            item.title
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'price', name: 'recurringItemPrice' },
	                            (item.isCredit ? "" : "$") + item.price,
	                            item.isCredit && !this.props.staticData.isCreditItemAsRegularItem ? ' ' + this.props.staticData.creditItemLabel.toLocaleLowerCase() : "",
	                            _react2.default.createElement(
	                                'span',
	                                {
	                                    className: 'unit' },
	                                item.unit ? " / " + item.unitQuantity + " " + item.unit.replace("credits", this.props.staticData.creditItemLabel) : undefined,
	                                ' '
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 4, md: 5, className: 'schedules-and-quantity-wrapper' },
	                        this.getSchedules(item)
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 1, md: 2, className: 'order-summary-item-qty' },
	                        item.quantity
	                    )
	                ),
	                _react2.default.createElement('hr', { className: 'recurring-item-divider' })
	            );
	        }
	    }]);
	
	    return RecurringItem;
	}(_react2.default.Component);
	
	exports.default = RecurringItem;

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _reactAutosuggest = __webpack_require__(802);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _constants = __webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreSearch = function (_React$Component) {
	    _inherits(StoreSearch, _React$Component);
	
	    function StoreSearch() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreSearch);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreSearch.__proto__ || Object.getPrototypeOf(StoreSearch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            value: '',
	            suggestions: [],
	            show: false
	        }, _this.getSuggestions = function (value) {
	            var inputValue = value.trim().toLowerCase();
	            var inputLength = inputValue.length;
	            return inputLength === 0 ? [] : _this.props.itemsList.filter(function (item) {
	                return item.title.toLowerCase().includes(inputValue);
	            }).slice(0, 10);
	        }, _this.getSuggestionValue = function (suggestion) {
	            return suggestion.title;
	        }, _this.renderSuggestion = function (suggestion, _ref2) {
	            var isHighlighted = _ref2.isHighlighted;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'search-item-row' + (isHighlighted ? ' highlighted' : '') },
	                _react2.default.createElement('img', { src: suggestion.imageUrl, className: 'search-item-img' }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'search-item-text' },
	                    suggestion.title
	                )
	            );
	        }, _this.onSuggestionSelected = function (_, _ref3) {
	            var suggestion = _ref3.suggestion;
	
	            _this.setState({ show: false });
	            _this.props.openItem(suggestion.key, suggestion.category);
	        }, _this.onChange = function (event, _ref4) {
	            var newValue = _ref4.newValue;
	
	            _this.setState({
	                value: newValue
	            });
	        }, _this.onSuggestionsFetchRequested = function (_ref5) {
	            var value = _ref5.value;
	
	            _this.setState({
	                suggestions: _this.getSuggestions(value)
	            });
	        }, _this.onSuggestionsClearRequested = function () {
	            _this.setState({
	                suggestions: [],
	                show: false,
	                value: ''
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreSearch, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                show = _state.show,
	                value = _state.value,
	                suggestions = _state.suggestions;
	
	
	            var inputProps = {
	                placeholder: 'Search Items',
	                value: value,
	                onChange: this.onChange,
	                className: 'search-input',
	                autoFocus: 'autofocus'
	            };
	
	            var toggleSearch = function toggleSearch() {
	                _this2.setState({ show: !show });
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'header-search ' + (show ? 'show-input' : 'hide-input') },
	                show && _react2.default.createElement(_reactAutosuggest2.default, {
	                    suggestions: suggestions,
	                    onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	                    onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	                    getSuggestionValue: this.getSuggestionValue,
	                    renderSuggestion: this.renderSuggestion,
	                    onSuggestionSelected: this.onSuggestionSelected,
	                    inputProps: inputProps,
	                    focusInputOnSuggestionClick: false
	                }),
	                _react2.default.createElement(_reactBootstrap.Button, { className: 'search-btn', onClick: toggleSearch })
	            );
	        }
	    }]);
	
	    return StoreSearch;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var itemsList = [];
	    for (var key in state.itemsList) {
	        if (state.itemsList.hasOwnProperty(key)) {
	            var item = state.itemsList[key];
	            if (!item.variation && (state.staticData.showUnavailableItemsInStore || item.available > 0)) {
	                var title = item.title,
	                    imageUrl = item.imageUrl,
	                    category = item.category;
	
	                itemsList.push({ key: key, title: title, imageUrl: imageUrl, category: category });
	            }
	        }
	    }
	    return {
	        itemsList: itemsList
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        openItem: function openItem(key, category) {
	            dispatch((0, _reactRouterRedux.push)('' + location.pathname + _constants.CART_ITEM_QRY + '=' + key + _constants.CATEGORY_QRY + '=' + category));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StoreSearch);

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(803)["default"];

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(338));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(348));
	
	var _arrays = _interopRequireDefault(__webpack_require__(804));
	
	var _Autowhatever = _interopRequireDefault(__webpack_require__(805));
	
	var _theme = __webpack_require__(812);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alwaysTrue = function alwaysTrue() {
	  return true;
	};
	
	var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
	  return value.trim().length > 0;
	};
	
	var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
	  var containerProps = _ref.containerProps,
	      children = _ref.children;
	  return /*#__PURE__*/_react["default"].createElement("div", containerProps, children);
	};
	
	var REASON_SUGGESTIONS_REVEALED = 'suggestions-revealed';
	var REASON_SUGGESTIONS_UPDATED = 'suggestions-updated';
	var REASON_SUGGESTION_SELECTED = 'suggestion-selected';
	var REASON_INPUT_FOCUSED = 'input-focused';
	var REASON_INPUT_CHANGED = 'input-changed';
	var REASON_INPUT_BLURRED = 'input-blurred';
	var REASON_ESCAPE_PRESSED = 'escape-pressed';
	
	var Autosuggest = /*#__PURE__*/function (_Component) {
	  _inherits(Autosuggest, _Component);
	
	  var _super = _createSuper(Autosuggest);
	
	  function Autosuggest(_ref2) {
	    var _this;
	
	    var _alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;
	
	    _classCallCheck(this, Autosuggest);
	
	    _this = _super.call(this);
	
	    _defineProperty(_assertThisInitialized(_this), "onDocumentMouseDown", function (event) {
	      _this.justClickedOnSuggestionsContainer = false;
	      var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
	      event.target;
	
	      while (node !== null && node !== document) {
	        if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) {
	          // Suggestion was clicked
	          return;
	        }
	
	        if (node === _this.suggestionsContainer) {
	          // Something else inside suggestions container was clicked
	          _this.justClickedOnSuggestionsContainer = true;
	          return;
	        }
	
	        node = node.parentNode;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "storeAutowhateverRef", function (autowhatever) {
	      if (autowhatever !== null) {
	        _this.autowhatever = autowhatever;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseEnter", function (event, _ref3) {
	      var sectionIndex = _ref3.sectionIndex,
	          itemIndex = _ref3.itemIndex;
	
	      _this.updateHighlightedSuggestion(sectionIndex, itemIndex);
	
	      if (event.target === _this.pressedSuggestion) {
	        _this.justSelectedSuggestion = true;
	      }
	
	      _this.justMouseEntered = true;
	      setTimeout(function () {
	        _this.justMouseEntered = false;
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "highlightFirstSuggestion", function () {
	      _this.updateHighlightedSuggestion(_this.props.multiSection ? 0 : null, 0);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDocumentMouseUp", function () {
	      if (_this.pressedSuggestion && !_this.justSelectedSuggestion) {
	        _this.input.focus();
	      }
	
	      _this.pressedSuggestion = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseDown", function (event) {
	      // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
	      // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
	      if (!_this.justSelectedSuggestion) {
	        _this.justSelectedSuggestion = true;
	        _this.pressedSuggestion = event.target;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionsClearRequested", function () {
	      var onSuggestionsClearRequested = _this.props.onSuggestionsClearRequested;
	      onSuggestionsClearRequested && onSuggestionsClearRequested();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionSelected", function (event, data) {
	      var _this$props = _this.props,
	          alwaysRenderSuggestions = _this$props.alwaysRenderSuggestions,
	          onSuggestionSelected = _this$props.onSuggestionSelected,
	          onSuggestionsFetchRequested = _this$props.onSuggestionsFetchRequested;
	      onSuggestionSelected && onSuggestionSelected(event, data);
	
	      var keepSuggestionsOnSelect = _this.props.shouldKeepSuggestionsOnSelect(data.suggestion);
	
	      if (alwaysRenderSuggestions || keepSuggestionsOnSelect) {
	        onSuggestionsFetchRequested({
	          value: data.suggestionValue,
	          reason: REASON_SUGGESTION_SELECTED
	        });
	      } else {
	        _this.onSuggestionsClearRequested();
	      }
	
	      _this.resetHighlightedSuggestion();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionClick", function (event) {
	      var _this$props2 = _this.props,
	          alwaysRenderSuggestions = _this$props2.alwaysRenderSuggestions,
	          focusInputOnSuggestionClick = _this$props2.focusInputOnSuggestionClick;
	
	      var _this$getSuggestionIn = _this.getSuggestionIndices(_this.findSuggestionElement(event.target)),
	          sectionIndex = _this$getSuggestionIn.sectionIndex,
	          suggestionIndex = _this$getSuggestionIn.suggestionIndex;
	
	      var clickedSuggestion = _this.getSuggestion(sectionIndex, suggestionIndex);
	
	      var clickedSuggestionValue = _this.props.getSuggestionValue(clickedSuggestion);
	
	      _this.maybeCallOnChange(event, clickedSuggestionValue, 'click');
	
	      _this.onSuggestionSelected(event, {
	        suggestion: clickedSuggestion,
	        suggestionValue: clickedSuggestionValue,
	        suggestionIndex: suggestionIndex,
	        sectionIndex: sectionIndex,
	        method: 'click'
	      });
	
	      var keepSuggestionsOnSelect = _this.props.shouldKeepSuggestionsOnSelect(clickedSuggestion);
	
	      if (!(alwaysRenderSuggestions || keepSuggestionsOnSelect)) {
	        _this.closeSuggestions();
	      }
	
	      if (focusInputOnSuggestionClick === true) {
	        _this.input.focus();
	      } else {
	        _this.onBlur();
	      }
	
	      setTimeout(function () {
	        _this.justSelectedSuggestion = false;
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
	      var _this$props3 = _this.props,
	          inputProps = _this$props3.inputProps,
	          shouldRenderSuggestions = _this$props3.shouldRenderSuggestions;
	      var value = inputProps.value,
	          onBlur = inputProps.onBlur;
	
	      var highlightedSuggestion = _this.getHighlightedSuggestion();
	
	      var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_BLURRED);
	
	      _this.setState({
	        isFocused: false,
	        highlightedSectionIndex: null,
	        highlightedSuggestionIndex: null,
	        highlightedSuggestion: null,
	        valueBeforeUpDown: null,
	        isCollapsed: !shouldRender
	      });
	
	      onBlur && onBlur(_this.blurEvent, {
	        highlightedSuggestion: highlightedSuggestion
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseLeave", function (event) {
	      _this.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown
	
	
	      if (_this.justSelectedSuggestion && event.target === _this.pressedSuggestion) {
	        _this.justSelectedSuggestion = false;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionTouchStart", function () {
	      _this.justSelectedSuggestion = true; // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
	      // todo: gets released so onSuggestionMouseDown won't fire in chrome
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionTouchMove", function () {
	      _this.justSelectedSuggestion = false;
	      _this.pressedSuggestion = null;
	
	      _this.input.focus();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "itemProps", function (_ref4) {
	      var sectionIndex = _ref4.sectionIndex,
	          itemIndex = _ref4.itemIndex;
	      return {
	        'data-section-index': sectionIndex,
	        'data-suggestion-index': itemIndex,
	        onMouseEnter: _this.onSuggestionMouseEnter,
	        onMouseLeave: _this.onSuggestionMouseLeave,
	        onMouseDown: _this.onSuggestionMouseDown,
	        onTouchStart: _this.onSuggestionTouchStart,
	        onTouchMove: _this.onSuggestionTouchMove,
	        onClick: _this.onSuggestionClick
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderSuggestionsContainer", function (_ref5) {
	      var containerProps = _ref5.containerProps,
	          children = _ref5.children;
	      var renderSuggestionsContainer = _this.props.renderSuggestionsContainer;
	      return renderSuggestionsContainer({
	        containerProps: containerProps,
	        children: children,
	        query: _this.getQuery()
	      });
	    });
	
	    _this.state = {
	      isFocused: false,
	      isCollapsed: !_alwaysRenderSuggestions,
	      highlightedSectionIndex: null,
	      highlightedSuggestionIndex: null,
	      highlightedSuggestion: null,
	      valueBeforeUpDown: null
	    };
	    _this.justPressedUpDown = false;
	    _this.justMouseEntered = false;
	    _this.pressedSuggestion = null;
	    return _this;
	  }
	
	  _createClass(Autosuggest, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.onDocumentMouseDown);
	      document.addEventListener('mouseup', this.onDocumentMouseUp);
	      this.input = this.autowhatever.input;
	      this.suggestionsContainer = this.autowhatever.itemsContainer;
	    } // eslint-disable-next-line camelcase, react/sort-comp
	
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      // When highlightFirstSuggestion becomes deactivated, if the first suggestion was
	      // set, we should reset the suggestion back to the unselected default state.
	      var shouldResetHighlighting = this.state.highlightedSuggestionIndex === 0 && this.props.highlightFirstSuggestion && !nextProps.highlightFirstSuggestion;
	
	      if ((0, _arrays["default"])(nextProps.suggestions, this.props.suggestions)) {
	        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
	          this.highlightFirstSuggestion();
	        } else if (shouldResetHighlighting) {
	          this.resetHighlightedSuggestion();
	        }
	      } else {
	        if (this.willRenderSuggestions(nextProps, REASON_SUGGESTIONS_UPDATED)) {
	          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
	            this.revealSuggestions();
	          }
	
	          if (shouldResetHighlighting) {
	            this.resetHighlightedSuggestion();
	          }
	        } else {
	          this.resetHighlightedSuggestion();
	        }
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this$props4 = this.props,
	          suggestions = _this$props4.suggestions,
	          onSuggestionHighlighted = _this$props4.onSuggestionHighlighted,
	          highlightFirstSuggestion = _this$props4.highlightFirstSuggestion;
	
	      if (!(0, _arrays["default"])(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
	        this.highlightFirstSuggestion();
	        return;
	      }
	
	      if (onSuggestionHighlighted) {
	        var highlightedSuggestion = this.getHighlightedSuggestion();
	        var prevHighlightedSuggestion = prevState.highlightedSuggestion;
	
	        if (highlightedSuggestion != prevHighlightedSuggestion) {
	          onSuggestionHighlighted({
	            suggestion: highlightedSuggestion
	          });
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.onDocumentMouseDown);
	      document.removeEventListener('mouseup', this.onDocumentMouseUp);
	    }
	  }, {
	    key: "updateHighlightedSuggestion",
	    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
	      var _this2 = this;
	
	      this.setState(function (state) {
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	
	        if (suggestionIndex === null) {
	          valueBeforeUpDown = null;
	        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
	          valueBeforeUpDown = prevValue;
	        }
	
	        return {
	          highlightedSectionIndex: sectionIndex,
	          highlightedSuggestionIndex: suggestionIndex,
	          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
	          valueBeforeUpDown: valueBeforeUpDown
	        };
	      });
	    }
	  }, {
	    key: "resetHighlightedSuggestion",
	    value: function resetHighlightedSuggestion() {
	      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      this.setState(function (state) {
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	        return {
	          highlightedSectionIndex: null,
	          highlightedSuggestionIndex: null,
	          highlightedSuggestion: null,
	          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
	        };
	      });
	    }
	  }, {
	    key: "revealSuggestions",
	    value: function revealSuggestions() {
	      this.setState({
	        isCollapsed: false
	      });
	    }
	  }, {
	    key: "closeSuggestions",
	    value: function closeSuggestions() {
	      this.setState({
	        highlightedSectionIndex: null,
	        highlightedSuggestionIndex: null,
	        highlightedSuggestion: null,
	        valueBeforeUpDown: null,
	        isCollapsed: true
	      });
	    }
	  }, {
	    key: "getSuggestion",
	    value: function getSuggestion(sectionIndex, suggestionIndex) {
	      var _this$props5 = this.props,
	          suggestions = _this$props5.suggestions,
	          multiSection = _this$props5.multiSection,
	          getSectionSuggestions = _this$props5.getSectionSuggestions;
	
	      if (multiSection) {
	        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
	      }
	
	      return suggestions[suggestionIndex];
	    }
	  }, {
	    key: "getHighlightedSuggestion",
	    value: function getHighlightedSuggestion() {
	      var _this$state = this.state,
	          highlightedSectionIndex = _this$state.highlightedSectionIndex,
	          highlightedSuggestionIndex = _this$state.highlightedSuggestionIndex;
	
	      if (highlightedSuggestionIndex === null) {
	        return null;
	      }
	
	      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
	    }
	  }, {
	    key: "getSuggestionValueByIndex",
	    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
	      var getSuggestionValue = this.props.getSuggestionValue;
	      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
	    }
	  }, {
	    key: "getSuggestionIndices",
	    value: function getSuggestionIndices(suggestionElement) {
	      var sectionIndex = suggestionElement.getAttribute('data-section-index');
	      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');
	      return {
	        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
	        suggestionIndex: parseInt(suggestionIndex, 10)
	      };
	    }
	  }, {
	    key: "findSuggestionElement",
	    value: function findSuggestionElement(startNode) {
	      var node = startNode;
	
	      do {
	        if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) {
	          return node;
	        }
	
	        node = node.parentNode;
	      } while (node !== null);
	
	      console.error('Clicked element:', startNode); // eslint-disable-line no-console
	
	      throw new Error("Couldn't find suggestion element");
	    }
	  }, {
	    key: "maybeCallOnChange",
	    value: function maybeCallOnChange(event, newValue, method) {
	      var _this$props$inputProp = this.props.inputProps,
	          value = _this$props$inputProp.value,
	          onChange = _this$props$inputProp.onChange;
	
	      if (newValue !== value) {
	        onChange(event, {
	          newValue: newValue,
	          method: method
	        });
	      }
	    }
	  }, {
	    key: "willRenderSuggestions",
	    value: function willRenderSuggestions(props, reason) {
	      var suggestions = props.suggestions,
	          inputProps = props.inputProps,
	          shouldRenderSuggestions = props.shouldRenderSuggestions;
	      var value = inputProps.value;
	      return suggestions.length > 0 && shouldRenderSuggestions(value, reason);
	    }
	  }, {
	    key: "getQuery",
	    value: function getQuery() {
	      var inputProps = this.props.inputProps;
	      var value = inputProps.value;
	      var valueBeforeUpDown = this.state.valueBeforeUpDown;
	      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _this$props6 = this.props,
	          suggestions = _this$props6.suggestions,
	          renderInputComponent = _this$props6.renderInputComponent,
	          onSuggestionsFetchRequested = _this$props6.onSuggestionsFetchRequested,
	          renderSuggestion = _this$props6.renderSuggestion,
	          inputProps = _this$props6.inputProps,
	          multiSection = _this$props6.multiSection,
	          renderSectionTitle = _this$props6.renderSectionTitle,
	          id = _this$props6.id,
	          getSectionSuggestions = _this$props6.getSectionSuggestions,
	          theme = _this$props6.theme,
	          getSuggestionValue = _this$props6.getSuggestionValue,
	          alwaysRenderSuggestions = _this$props6.alwaysRenderSuggestions,
	          highlightFirstSuggestion = _this$props6.highlightFirstSuggestion,
	          containerProps = _this$props6.containerProps;
	      var _this$state2 = this.state,
	          isFocused = _this$state2.isFocused,
	          isCollapsed = _this$state2.isCollapsed,
	          highlightedSectionIndex = _this$state2.highlightedSectionIndex,
	          highlightedSuggestionIndex = _this$state2.highlightedSuggestionIndex,
	          valueBeforeUpDown = _this$state2.valueBeforeUpDown;
	      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
	      var value = inputProps.value,
	          _onFocus = inputProps.onFocus,
	          _onKeyDown = inputProps.onKeyDown;
	      var willRenderSuggestions = this.willRenderSuggestions(this.props, 'render');
	      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
	      var items = isOpen ? suggestions : [];
	
	      var autowhateverInputProps = _objectSpread({}, inputProps, {
	        onFocus: function onFocus(event) {
	          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
	            var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_FOCUSED);
	
	            _this3.setState({
	              isFocused: true,
	              isCollapsed: !shouldRender
	            });
	
	            _onFocus && _onFocus(event);
	
	            if (shouldRender) {
	              onSuggestionsFetchRequested({
	                value: value,
	                reason: REASON_INPUT_FOCUSED
	              });
	            }
	          }
	        },
	        onBlur: function onBlur(event) {
	          if (_this3.justClickedOnSuggestionsContainer) {
	            _this3.input.focus();
	
	            return;
	          }
	
	          _this3.blurEvent = event;
	
	          if (!_this3.justSelectedSuggestion) {
	            _this3.onBlur();
	
	            _this3.onSuggestionsClearRequested();
	          }
	        },
	        onChange: function onChange(event) {
	          var value = event.target.value;
	          var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_CHANGED);
	
	          _this3.maybeCallOnChange(event, value, 'type');
	
	          if (_this3.suggestionsContainer) {
	            _this3.suggestionsContainer.scrollTop = 0;
	          }
	
	          _this3.setState(_objectSpread({}, highlightFirstSuggestion ? {} : {
	            highlightedSectionIndex: null,
	            highlightedSuggestionIndex: null,
	            highlightedSuggestion: null
	          }, {
	            valueBeforeUpDown: null,
	            isCollapsed: !shouldRender
	          }));
	
	          if (shouldRender) {
	            onSuggestionsFetchRequested({
	              value: value,
	              reason: REASON_INPUT_CHANGED
	            });
	          } else {
	            _this3.onSuggestionsClearRequested();
	          }
	        },
	        onKeyDown: function onKeyDown(event, data) {
	          var keyCode = event.keyCode;
	
	          switch (keyCode) {
	            case 40: // ArrowDown
	
	            case 38:
	              // ArrowUp
	              if (isCollapsed) {
	                if (shouldRenderSuggestions(value, REASON_SUGGESTIONS_REVEALED)) {
	                  onSuggestionsFetchRequested({
	                    value: value,
	                    reason: REASON_SUGGESTIONS_REVEALED
	                  });
	
	                  _this3.revealSuggestions();
	
	                  event.preventDefault(); // We act on the key.
	                }
	              } else if (suggestions.length > 0) {
	                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
	                    newHighlightedItemIndex = data.newHighlightedItemIndex;
	                var newValue;
	
	                if (newHighlightedItemIndex === null) {
	                  // valueBeforeUpDown can be null if, for example, user
	                  // hovers on the first suggestion and then pressed Up.
	                  // If that happens, use the original input value.
	                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
	                } else {
	                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
	                }
	
	                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
	
	                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
	
	                event.preventDefault(); // We act on the key.
	              }
	
	              _this3.justPressedUpDown = true;
	              setTimeout(function () {
	                _this3.justPressedUpDown = false;
	              });
	              break;
	            // Enter
	
	            case 13:
	              {
	                // See #388
	                if (event.keyCode === 229) {
	                  break;
	                }
	
	                var highlightedSuggestion = _this3.getHighlightedSuggestion();
	
	                if (isOpen && !alwaysRenderSuggestions) {
	                  _this3.closeSuggestions();
	                }
	
	                if (highlightedSuggestion != null) {
	                  event.preventDefault();
	
	                  var _newValue = getSuggestionValue(highlightedSuggestion);
	
	                  _this3.maybeCallOnChange(event, _newValue, 'enter');
	
	                  _this3.onSuggestionSelected(event, {
	                    suggestion: highlightedSuggestion,
	                    suggestionValue: _newValue,
	                    suggestionIndex: highlightedSuggestionIndex,
	                    sectionIndex: highlightedSectionIndex,
	                    method: 'enter'
	                  });
	
	                  _this3.justSelectedSuggestion = true;
	                  setTimeout(function () {
	                    _this3.justSelectedSuggestion = false;
	                  });
	                }
	
	                break;
	              }
	            // Escape
	
	            case 27:
	              {
	                if (isOpen) {
	                  // If input.type === 'search', the browser clears the input
	                  // when Escape is pressed. We want to disable this default
	                  // behaviour so that, when suggestions are shown, we just hide
	                  // them, without clearing the input.
	                  event.preventDefault();
	                }
	
	                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;
	
	                if (valueBeforeUpDown === null) {
	                  // Didn't interact with Up/Down
	                  if (!willCloseSuggestions) {
	                    var _newValue2 = '';
	
	                    _this3.maybeCallOnChange(event, _newValue2, 'escape');
	
	                    if (shouldRenderSuggestions(_newValue2, REASON_ESCAPE_PRESSED)) {
	                      onSuggestionsFetchRequested({
	                        value: _newValue2,
	                        reason: REASON_ESCAPE_PRESSED
	                      });
	                    } else {
	                      _this3.onSuggestionsClearRequested();
	                    }
	                  }
	                } else {
	                  // Interacted with Up/Down
	                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
	                }
	
	                if (willCloseSuggestions) {
	                  _this3.onSuggestionsClearRequested();
	
	                  _this3.closeSuggestions();
	                } else {
	                  _this3.resetHighlightedSuggestion();
	                }
	
	                break;
	              }
	          }
	
	          _onKeyDown && _onKeyDown(event);
	        }
	      });
	
	      var renderSuggestionData = {
	        query: this.getQuery()
	      };
	      return /*#__PURE__*/_react["default"].createElement(_Autowhatever["default"], {
	        multiSection: multiSection,
	        items: items,
	        renderInputComponent: renderInputComponent,
	        renderItemsContainer: this.renderSuggestionsContainer,
	        renderItem: renderSuggestion,
	        renderItemData: renderSuggestionData,
	        renderSectionTitle: renderSectionTitle,
	        getSectionItems: getSectionSuggestions,
	        highlightedSectionIndex: highlightedSectionIndex,
	        highlightedItemIndex: highlightedSuggestionIndex,
	        containerProps: containerProps,
	        inputProps: autowhateverInputProps,
	        itemProps: this.itemProps,
	        theme: (0, _theme.mapToAutowhateverTheme)(theme),
	        id: id,
	        ref: this.storeAutowhateverRef
	      });
	    }
	  }]);
	
	  return Autosuggest;
	}(_react.Component);
	
	exports["default"] = Autosuggest;
	
	_defineProperty(Autosuggest, "propTypes", {
	  suggestions: _propTypes["default"].array.isRequired,
	  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
	    var onSuggestionsFetchRequested = props[propName];
	
	    if (typeof onSuggestionsFetchRequested !== 'function') {
	      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
	    }
	  },
	  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
	    var onSuggestionsClearRequested = props[propName];
	
	    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
	      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
	    }
	  },
	  shouldKeepSuggestionsOnSelect: _propTypes["default"].func,
	  onSuggestionSelected: _propTypes["default"].func,
	  onSuggestionHighlighted: _propTypes["default"].func,
	  renderInputComponent: _propTypes["default"].func,
	  renderSuggestionsContainer: _propTypes["default"].func,
	  getSuggestionValue: _propTypes["default"].func.isRequired,
	  renderSuggestion: _propTypes["default"].func.isRequired,
	  inputProps: function inputProps(props, propName) {
	    var inputProps = props[propName];
	
	    if (!inputProps) {
	      throw new Error("'inputProps' must be passed.");
	    }
	
	    if (!Object.prototype.hasOwnProperty.call(inputProps, 'value')) {
	      throw new Error("'inputProps' must have 'value'.");
	    }
	
	    if (!Object.prototype.hasOwnProperty.call(inputProps, 'onChange')) {
	      throw new Error("'inputProps' must have 'onChange'.");
	    }
	  },
	  shouldRenderSuggestions: _propTypes["default"].func,
	  alwaysRenderSuggestions: _propTypes["default"].bool,
	  multiSection: _propTypes["default"].bool,
	  renderSectionTitle: function renderSectionTitle(props, propName) {
	    var renderSectionTitle = props[propName];
	
	    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
	      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
	    }
	  },
	  getSectionSuggestions: function getSectionSuggestions(props, propName) {
	    var getSectionSuggestions = props[propName];
	
	    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
	      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
	    }
	  },
	  focusInputOnSuggestionClick: _propTypes["default"].bool,
	  highlightFirstSuggestion: _propTypes["default"].bool,
	  theme: _propTypes["default"].object,
	  id: _propTypes["default"].string,
	  containerProps: _propTypes["default"].object // Arbitrary container props
	
	});
	
	_defineProperty(Autosuggest, "defaultProps", {
	  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
	  shouldRenderSuggestions: defaultShouldRenderSuggestions,
	  alwaysRenderSuggestions: false,
	  multiSection: false,
	  shouldKeepSuggestionsOnSelect: function shouldKeepSuggestionsOnSelect() {
	    return false;
	  },
	  focusInputOnSuggestionClick: true,
	  highlightFirstSuggestion: false,
	  theme: _theme.defaultTheme,
	  id: '1',
	  containerProps: {}
	});

/***/ }),
/* 804 */
/***/ (function(module, exports) {

	'use strict';
	
	function shallowEqualArrays(arrA, arrB) {
	  if (arrA === arrB) {
	    return true;
	  }
	
	  if (!arrA || !arrB) {
	    return false;
	  }
	
	  var len = arrA.length;
	
	  if (arrB.length !== len) {
	    return false;
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (arrA[i] !== arrB[i]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqualArrays;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(338));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(348));
	
	var _sectionIterator = _interopRequireDefault(__webpack_require__(806));
	
	var _reactThemeable = _interopRequireDefault(__webpack_require__(807));
	
	var _SectionTitle = _interopRequireDefault(__webpack_require__(808));
	
	var _ItemList = _interopRequireDefault(__webpack_require__(810));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var emptyObject = {};
	
	var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
	  return /*#__PURE__*/_react["default"].createElement("input", props);
	};
	
	var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
	  var containerProps = _ref.containerProps,
	      children = _ref.children;
	  return /*#__PURE__*/_react["default"].createElement("div", containerProps, children);
	};
	
	var defaultTheme = {
	  container: 'react-autowhatever__container',
	  containerOpen: 'react-autowhatever__container--open',
	  input: 'react-autowhatever__input',
	  inputOpen: 'react-autowhatever__input--open',
	  inputFocused: 'react-autowhatever__input--focused',
	  itemsContainer: 'react-autowhatever__items-container',
	  itemsContainerOpen: 'react-autowhatever__items-container--open',
	  itemsList: 'react-autowhatever__items-list',
	  item: 'react-autowhatever__item',
	  itemFirst: 'react-autowhatever__item--first',
	  itemHighlighted: 'react-autowhatever__item--highlighted',
	  sectionContainer: 'react-autowhatever__section-container',
	  sectionContainerFirst: 'react-autowhatever__section-container--first',
	  sectionTitle: 'react-autowhatever__section-title'
	};
	
	var Autowhatever = /*#__PURE__*/function (_Component) {
	  _inherits(Autowhatever, _Component);
	
	  var _super = _createSuper(Autowhatever);
	
	  function Autowhatever(props) {
	    var _this;
	
	    _classCallCheck(this, Autowhatever);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "storeInputReference", function (input) {
	      if (input !== null) {
	        _this.input = input;
	      }
	
	      var userRef = _this.props.inputProps.ref;
	
	      if (userRef) {
	        if (typeof userRef === 'function') {
	          userRef(input);
	        } else if (_typeof(userRef) === 'object' && Object.prototype.hasOwnProperty.call(userRef, 'current')) {
	          userRef.current = input;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "storeItemsContainerReference", function (itemsContainer) {
	      if (itemsContainer !== null) {
	        _this.itemsContainer = itemsContainer;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onHighlightedItemChange", function (highlightedItem) {
	      _this.highlightedItem = highlightedItem;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getItemId", function (sectionIndex, itemIndex) {
	      if (itemIndex === null) {
	        return null;
	      }
	
	      var id = _this.props.id;
	      var section = sectionIndex === null ? '' : "section-".concat(sectionIndex);
	      return "react-autowhatever-".concat(id, "-").concat(section, "-item-").concat(itemIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
	      var inputProps = _this.props.inputProps;
	
	      _this.setState({
	        isInputFocused: true
	      });
	
	      inputProps.onFocus && inputProps.onFocus(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
	      var inputProps = _this.props.inputProps;
	
	      _this.setState({
	        isInputFocused: false
	      });
	
	      inputProps.onBlur && inputProps.onBlur(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
	      var _this$props = _this.props,
	          inputProps = _this$props.inputProps,
	          highlightedSectionIndex = _this$props.highlightedSectionIndex,
	          highlightedItemIndex = _this$props.highlightedItemIndex;
	      var keyCode = event.keyCode;
	
	      switch (keyCode) {
	        case 40: // ArrowDown
	
	        case 38:
	          {
	            // ArrowUp
	            var nextPrev = keyCode === 40 ? 'next' : 'prev';
	
	            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
	                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
	                newHighlightedSectionIndex = _this$sectionIterator2[0],
	                newHighlightedItemIndex = _this$sectionIterator2[1];
	
	            inputProps.onKeyDown(event, {
	              newHighlightedSectionIndex: newHighlightedSectionIndex,
	              newHighlightedItemIndex: newHighlightedItemIndex
	            });
	            break;
	          }
	
	        default:
	          inputProps.onKeyDown(event, {
	            highlightedSectionIndex: highlightedSectionIndex,
	            highlightedItemIndex: highlightedItemIndex
	          });
	      }
	    });
	
	    _this.highlightedItem = null;
	    _this.state = {
	      isInputFocused: false
	    };
	
	    _this.setSectionsItems(props);
	
	    _this.setSectionIterator(props);
	
	    _this.setTheme(props);
	
	    return _this;
	  }
	
	  _createClass(Autowhatever, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.ensureHighlightedItemIsVisible();
	    } // eslint-disable-next-line camelcase, react/sort-comp
	
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (nextProps.items !== this.props.items) {
	        this.setSectionsItems(nextProps);
	      }
	
	      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
	        this.setSectionIterator(nextProps);
	      }
	
	      if (nextProps.theme !== this.props.theme) {
	        this.setTheme(nextProps);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.ensureHighlightedItemIsVisible();
	    }
	  }, {
	    key: "setSectionsItems",
	    value: function setSectionsItems(props) {
	      if (props.multiSection) {
	        this.sectionsItems = props.items.map(function (section) {
	          return props.getSectionItems(section);
	        });
	        this.sectionsLengths = this.sectionsItems.map(function (items) {
	          return items.length;
	        });
	        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
	          return itemsCount === 0;
	        });
	      }
	    }
	  }, {
	    key: "setSectionIterator",
	    value: function setSectionIterator(props) {
	      this.sectionIterator = (0, _sectionIterator["default"])({
	        multiSection: props.multiSection,
	        data: props.multiSection ? this.sectionsLengths : props.items.length
	      });
	    }
	  }, {
	    key: "setTheme",
	    value: function setTheme(props) {
	      this.theme = (0, _reactThemeable["default"])(props.theme);
	    }
	  }, {
	    key: "renderSections",
	    value: function renderSections() {
	      var _this2 = this;
	
	      if (this.allSectionsAreEmpty) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _this$props2 = this.props,
	          id = _this$props2.id,
	          items = _this$props2.items,
	          renderItem = _this$props2.renderItem,
	          renderItemData = _this$props2.renderItemData,
	          renderSectionTitle = _this$props2.renderSectionTitle,
	          highlightedSectionIndex = _this$props2.highlightedSectionIndex,
	          highlightedItemIndex = _this$props2.highlightedItemIndex,
	          itemProps = _this$props2.itemProps;
	      return items.map(function (section, sectionIndex) {
	        var keyPrefix = "react-autowhatever-".concat(id, "-");
	        var sectionKeyPrefix = "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
	        var isFirstSection = sectionIndex === 0; // `key` is provided by theme()
	
	        /* eslint-disable react/jsx-key */
	
	        return /*#__PURE__*/_react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "container"), 'sectionContainer', isFirstSection && 'sectionContainerFirst'), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
	          section: section,
	          renderSectionTitle: renderSectionTitle,
	          theme: theme,
	          sectionKeyPrefix: sectionKeyPrefix
	        }), /*#__PURE__*/_react["default"].createElement(_ItemList["default"], {
	          items: _this2.sectionsItems[sectionIndex],
	          itemProps: itemProps,
	          renderItem: renderItem,
	          renderItemData: renderItemData,
	          sectionIndex: sectionIndex,
	          highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
	          onHighlightedItemChange: _this2.onHighlightedItemChange,
	          getItemId: _this2.getItemId,
	          theme: theme,
	          keyPrefix: keyPrefix,
	          ref: _this2.storeItemsListReference
	        }));
	        /* eslint-enable react/jsx-key */
	      });
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var items = this.props.items;
	
	      if (items.length === 0) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _this$props3 = this.props,
	          id = _this$props3.id,
	          renderItem = _this$props3.renderItem,
	          renderItemData = _this$props3.renderItemData,
	          highlightedSectionIndex = _this$props3.highlightedSectionIndex,
	          highlightedItemIndex = _this$props3.highlightedItemIndex,
	          itemProps = _this$props3.itemProps;
	      return /*#__PURE__*/_react["default"].createElement(_ItemList["default"], {
	        items: items,
	        itemProps: itemProps,
	        renderItem: renderItem,
	        renderItemData: renderItemData,
	        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
	        onHighlightedItemChange: this.onHighlightedItemChange,
	        getItemId: this.getItemId,
	        theme: theme,
	        keyPrefix: "react-autowhatever-".concat(id, "-")
	      });
	    }
	  }, {
	    key: "ensureHighlightedItemIsVisible",
	    value: function ensureHighlightedItemIsVisible() {
	      var highlightedItem = this.highlightedItem;
	
	      if (!highlightedItem) {
	        return;
	      }
	
	      var itemsContainer = this.itemsContainer;
	      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;
	      var scrollTop = itemsContainer.scrollTop; // Top of the visible area
	
	      if (itemOffsetRelativeToContainer < scrollTop) {
	        // Item is off the top of the visible area
	        scrollTop = itemOffsetRelativeToContainer;
	      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
	        // Item is off the bottom of the visible area
	        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
	      }
	
	      if (scrollTop !== itemsContainer.scrollTop) {
	        itemsContainer.scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var theme = this.theme;
	      var _this$props4 = this.props,
	          id = _this$props4.id,
	          multiSection = _this$props4.multiSection,
	          renderInputComponent = _this$props4.renderInputComponent,
	          renderItemsContainer = _this$props4.renderItemsContainer,
	          highlightedSectionIndex = _this$props4.highlightedSectionIndex,
	          highlightedItemIndex = _this$props4.highlightedItemIndex;
	      var isInputFocused = this.state.isInputFocused;
	      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
	      var isOpen = renderedItems !== null;
	      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
	      var itemsContainerId = "react-autowhatever-".concat(id);
	
	      var containerProps = _objectSpread({
	        role: 'combobox',
	        'aria-haspopup': 'listbox',
	        'aria-owns': itemsContainerId,
	        'aria-expanded': isOpen
	      }, theme("react-autowhatever-".concat(id, "-container"), 'container', isOpen && 'containerOpen'), {}, this.props.containerProps);
	
	      var inputComponent = renderInputComponent(_objectSpread({
	        type: 'text',
	        value: '',
	        autoComplete: 'off',
	        'aria-autocomplete': 'list',
	        'aria-controls': itemsContainerId,
	        'aria-activedescendant': ariaActivedescendant
	      }, theme("react-autowhatever-".concat(id, "-input"), 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), {}, this.props.inputProps, {
	        onFocus: this.onFocus,
	        onBlur: this.onBlur,
	        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
	        ref: this.storeInputReference
	      }));
	      var itemsContainer = renderItemsContainer({
	        containerProps: _objectSpread({
	          id: itemsContainerId,
	          role: 'listbox'
	        }, theme("react-autowhatever-".concat(id, "-items-container"), 'itemsContainer', isOpen && 'itemsContainerOpen'), {
	          ref: this.storeItemsContainerReference
	        }),
	        children: renderedItems
	      });
	      return /*#__PURE__*/_react["default"].createElement("div", containerProps, inputComponent, itemsContainer);
	    }
	  }]);
	
	  return Autowhatever;
	}(_react.Component);
	
	exports["default"] = Autowhatever;
	
	_defineProperty(Autowhatever, "propTypes", {
	  id: _propTypes["default"].string,
	  // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
	  multiSection: _propTypes["default"].bool,
	  // Indicates whether a multi section layout should be rendered.
	  renderInputComponent: _propTypes["default"].func,
	  // When specified, it is used to render the input element.
	  renderItemsContainer: _propTypes["default"].func,
	  // Renders the items container.
	  items: _propTypes["default"].array.isRequired,
	  // Array of items or sections to render.
	  renderItem: _propTypes["default"].func,
	  // This function renders a single item.
	  renderItemData: _propTypes["default"].object,
	  // Arbitrary data that will be passed to renderItem()
	  renderSectionTitle: _propTypes["default"].func,
	  // This function gets a section and renders its title.
	  getSectionItems: _propTypes["default"].func,
	  // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
	  containerProps: _propTypes["default"].object,
	  // Arbitrary container props
	  inputProps: _propTypes["default"].object,
	  // Arbitrary input props
	  itemProps: _propTypes["default"].oneOfType([// Arbitrary item props
	  _propTypes["default"].object, _propTypes["default"].func]),
	  highlightedSectionIndex: _propTypes["default"].number,
	  // Section index of the highlighted item
	  highlightedItemIndex: _propTypes["default"].number,
	  // Highlighted item index (within a section)
	  theme: _propTypes["default"].oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
	  _propTypes["default"].object, _propTypes["default"].array])
	});
	
	_defineProperty(Autowhatever, "defaultProps", {
	  id: '1',
	  multiSection: false,
	  renderInputComponent: defaultRenderInputComponent,
	  renderItemsContainer: defaultRenderItemsContainer,
	  renderItem: function renderItem() {
	    throw new Error('`renderItem` must be provided');
	  },
	  renderItemData: emptyObject,
	  renderSectionTitle: function renderSectionTitle() {
	    throw new Error('`renderSectionTitle` must be provided');
	  },
	  getSectionItems: function getSectionItems() {
	    throw new Error('`getSectionItems` must be provided');
	  },
	  containerProps: emptyObject,
	  inputProps: emptyObject,
	  itemProps: emptyObject,
	  highlightedSectionIndex: null,
	  highlightedItemIndex: null,
	  theme: defaultTheme
	});

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	module.exports = function (_ref) {
	  var data = _ref.data;
	  var multiSection = _ref.multiSection;
	
	  function nextNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = 0;
	    } else {
	      sectionIndex++;
	    }
	
	    while (sectionIndex < data.length && data[sectionIndex] === 0) {
	      sectionIndex++;
	    }
	
	    return sectionIndex === data.length ? null : sectionIndex;
	  }
	
	  function prevNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = data.length - 1;
	    } else {
	      sectionIndex--;
	    }
	
	    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
	      sectionIndex--;
	    }
	
	    return sectionIndex === -1 ? null : sectionIndex;
	  }
	
	  function next(position) {
	    var _position = _slicedToArray(position, 2);
	
	    var sectionIndex = _position[0];
	    var itemIndex = _position[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
	        sectionIndex = nextNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, 0];
	      }
	
	      return [sectionIndex, itemIndex + 1];
	    }
	
	    if (data === 0 || itemIndex === data - 1) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, 0];
	    }
	
	    return [null, itemIndex + 1];
	  }
	
	  function prev(position) {
	    var _position2 = _slicedToArray(position, 2);
	
	    var sectionIndex = _position2[0];
	    var itemIndex = _position2[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === 0) {
	        sectionIndex = prevNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, data[sectionIndex] - 1];
	      }
	
	      return [sectionIndex, itemIndex - 1];
	    }
	
	    if (data === 0 || itemIndex === 0) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, data - 1];
	    }
	
	    return [null, itemIndex - 1];
	  }
	
	  function isLast(position) {
	    return next(position)[1] === null;
	  }
	
	  return {
	    next: next,
	    prev: prev,
	    isLast: isLast
	  };
	};


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _objectAssign = __webpack_require__(340);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var truthy = function truthy(x) {
	  return x;
	};
	
	exports['default'] = function (input) {
	  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];
	
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var theme = _ref2[0];
	  var classNameDecorator = _ref2[1];
	
	  return function (key) {
	    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      names[_key - 1] = arguments[_key];
	    }
	
	    var styles = names.map(function (name) {
	      return theme[name];
	    }).filter(truthy);
	
	    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(338));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(348));
	
	var _compareObjects = _interopRequireDefault(__webpack_require__(809));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SectionTitle = /*#__PURE__*/function (_Component) {
	  _inherits(SectionTitle, _Component);
	
	  var _super = _createSuper(SectionTitle);
	
	  function SectionTitle() {
	    _classCallCheck(this, SectionTitle);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(SectionTitle, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects["default"])(nextProps, this.props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          section = _this$props.section,
	          renderSectionTitle = _this$props.renderSectionTitle,
	          theme = _this$props.theme,
	          sectionKeyPrefix = _this$props.sectionKeyPrefix;
	      var sectionTitle = renderSectionTitle(section);
	
	      if (!sectionTitle) {
	        return null;
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "title"), 'sectionTitle'), sectionTitle);
	    }
	  }]);
	
	  return SectionTitle;
	}(_react.Component);
	
	exports["default"] = SectionTitle;
	
	_defineProperty(SectionTitle, "propTypes", {
	  section: _propTypes["default"].any.isRequired,
	  renderSectionTitle: _propTypes["default"].func.isRequired,
	  theme: _propTypes["default"].func.isRequired,
	  sectionKeyPrefix: _propTypes["default"].string.isRequired
	});

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = compareObjects;
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function compareObjects(objA, objB) {
	  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  if (objA === objB) {
	    return false;
	  }
	
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (aKeys.length !== bKeys.length) {
	    return true;
	  }
	
	  var keysMap = {};
	  var i, len;
	
	  for (i = 0, len = keys.length; i < len; i++) {
	    keysMap[keys[i]] = true;
	  }
	
	  for (i = 0, len = aKeys.length; i < len; i++) {
	    var key = aKeys[i];
	    var aValue = objA[key];
	    var bValue = objB[key];
	
	    if (aValue === bValue) {
	      continue;
	    }
	
	    if (!keysMap[key] || aValue === null || bValue === null || _typeof(aValue) !== 'object' || _typeof(bValue) !== 'object') {
	      return true;
	    }
	
	    var aValueKeys = Object.keys(aValue);
	    var bValueKeys = Object.keys(bValue);
	
	    if (aValueKeys.length !== bValueKeys.length) {
	      return true;
	    }
	
	    for (var n = 0, length = aValueKeys.length; n < length; n++) {
	      var aValueKey = aValueKeys[n];
	
	      if (aValue[aValueKey] !== bValue[aValueKey]) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(338));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(348));
	
	var _Item = _interopRequireDefault(__webpack_require__(811));
	
	var _compareObjects = _interopRequireDefault(__webpack_require__(809));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ItemsList = /*#__PURE__*/function (_Component) {
	  _inherits(ItemsList, _Component);
	
	  var _super = _createSuper(ItemsList);
	
	  function ItemsList() {
	    var _this;
	
	    _classCallCheck(this, ItemsList);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "storeHighlightedItemReference", function (highlightedItem) {
	      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
	    });
	
	    return _this;
	  }
	
	  _createClass(ItemsList, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects["default"])(nextProps, this.props, ['itemProps']);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          items = _this$props.items,
	          itemProps = _this$props.itemProps,
	          renderItem = _this$props.renderItem,
	          renderItemData = _this$props.renderItemData,
	          sectionIndex = _this$props.sectionIndex,
	          highlightedItemIndex = _this$props.highlightedItemIndex,
	          getItemId = _this$props.getItemId,
	          theme = _this$props.theme,
	          keyPrefix = _this$props.keyPrefix;
	      var sectionPrefix = sectionIndex === null ? keyPrefix : "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
	      var isItemPropsFunction = typeof itemProps === 'function';
	      return /*#__PURE__*/_react["default"].createElement("ul", _extends({
	        role: "listbox"
	      }, theme("".concat(sectionPrefix, "items-list"), 'itemsList')), items.map(function (item, itemIndex) {
	        var isFirst = itemIndex === 0;
	        var isHighlighted = itemIndex === highlightedItemIndex;
	        var itemKey = "".concat(sectionPrefix, "item-").concat(itemIndex);
	        var itemPropsObj = isItemPropsFunction ? itemProps({
	          sectionIndex: sectionIndex,
	          itemIndex: itemIndex
	        }) : itemProps;
	
	        var allItemProps = _objectSpread({
	          id: getItemId(sectionIndex, itemIndex),
	          'aria-selected': isHighlighted
	        }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), {}, itemPropsObj);
	
	        if (isHighlighted) {
	          allItemProps.ref = _this2.storeHighlightedItemReference;
	        } // `key` is provided by theme()
	
	        /* eslint-disable react/jsx-key */
	
	
	        return /*#__PURE__*/_react["default"].createElement(_Item["default"], _extends({}, allItemProps, {
	          sectionIndex: sectionIndex,
	          isHighlighted: isHighlighted,
	          itemIndex: itemIndex,
	          item: item,
	          renderItem: renderItem,
	          renderItemData: renderItemData
	        }));
	        /* eslint-enable react/jsx-key */
	      }));
	    }
	  }]);
	
	  return ItemsList;
	}(_react.Component);
	
	exports["default"] = ItemsList;
	
	_defineProperty(ItemsList, "propTypes", {
	  items: _propTypes["default"].array.isRequired,
	  itemProps: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
	  renderItem: _propTypes["default"].func.isRequired,
	  renderItemData: _propTypes["default"].object.isRequired,
	  sectionIndex: _propTypes["default"].number,
	  highlightedItemIndex: _propTypes["default"].number,
	  onHighlightedItemChange: _propTypes["default"].func.isRequired,
	  getItemId: _propTypes["default"].func.isRequired,
	  theme: _propTypes["default"].func.isRequired,
	  keyPrefix: _propTypes["default"].string.isRequired
	});
	
	_defineProperty(ItemsList, "defaultProps", {
	  sectionIndex: null
	});

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(338));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(348));
	
	var _compareObjects = _interopRequireDefault(__webpack_require__(809));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Item = /*#__PURE__*/function (_Component) {
	  _inherits(Item, _Component);
	
	  var _super = _createSuper(Item);
	
	  function Item() {
	    var _this;
	
	    _classCallCheck(this, Item);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "storeItemReference", function (item) {
	      if (item !== null) {
	        _this.item = item;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (event) {
	      var _this$props = _this.props,
	          sectionIndex = _this$props.sectionIndex,
	          itemIndex = _this$props.itemIndex;
	
	      _this.props.onMouseEnter(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (event) {
	      var _this$props2 = _this.props,
	          sectionIndex = _this$props2.sectionIndex,
	          itemIndex = _this$props2.itemIndex;
	
	      _this.props.onMouseLeave(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
	      var _this$props3 = _this.props,
	          sectionIndex = _this$props3.sectionIndex,
	          itemIndex = _this$props3.itemIndex;
	
	      _this.props.onMouseDown(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
	      var _this$props4 = _this.props,
	          sectionIndex = _this$props4.sectionIndex,
	          itemIndex = _this$props4.itemIndex;
	
	      _this.props.onClick(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	
	    return _this;
	  }
	
	  _createClass(Item, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects["default"])(nextProps, this.props, ['renderItemData']);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          isHighlighted = _this$props5.isHighlighted,
	          item = _this$props5.item,
	          renderItem = _this$props5.renderItem,
	          renderItemData = _this$props5.renderItemData,
	          restProps = _objectWithoutProperties(_this$props5, ["isHighlighted", "item", "renderItem", "renderItemData"]);
	
	      delete restProps.sectionIndex;
	      delete restProps.itemIndex;
	
	      if (typeof restProps.onMouseEnter === 'function') {
	        restProps.onMouseEnter = this.onMouseEnter;
	      }
	
	      if (typeof restProps.onMouseLeave === 'function') {
	        restProps.onMouseLeave = this.onMouseLeave;
	      }
	
	      if (typeof restProps.onMouseDown === 'function') {
	        restProps.onMouseDown = this.onMouseDown;
	      }
	
	      if (typeof restProps.onClick === 'function') {
	        restProps.onClick = this.onClick;
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("li", _extends({
	        role: "option"
	      }, restProps, {
	        ref: this.storeItemReference
	      }), renderItem(item, _objectSpread({
	        isHighlighted: isHighlighted
	      }, renderItemData)));
	    }
	  }]);
	
	  return Item;
	}(_react.Component);
	
	exports["default"] = Item;
	
	_defineProperty(Item, "propTypes", {
	  sectionIndex: _propTypes["default"].number,
	  isHighlighted: _propTypes["default"].bool.isRequired,
	  itemIndex: _propTypes["default"].number.isRequired,
	  item: _propTypes["default"].any.isRequired,
	  renderItem: _propTypes["default"].func.isRequired,
	  renderItemData: _propTypes["default"].object.isRequired,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onMouseDown: _propTypes["default"].func,
	  onClick: _propTypes["default"].func
	});

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapToAutowhateverTheme = exports.defaultTheme = void 0;
	var defaultTheme = {
	  container: 'react-autosuggest__container',
	  containerOpen: 'react-autosuggest__container--open',
	  input: 'react-autosuggest__input',
	  inputOpen: 'react-autosuggest__input--open',
	  inputFocused: 'react-autosuggest__input--focused',
	  suggestionsContainer: 'react-autosuggest__suggestions-container',
	  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
	  suggestionsList: 'react-autosuggest__suggestions-list',
	  suggestion: 'react-autosuggest__suggestion',
	  suggestionFirst: 'react-autosuggest__suggestion--first',
	  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
	  sectionContainer: 'react-autosuggest__section-container',
	  sectionContainerFirst: 'react-autosuggest__section-container--first',
	  sectionTitle: 'react-autosuggest__section-title'
	};
	exports.defaultTheme = defaultTheme;
	
	var mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
	  var result = {};
	
	  for (var key in theme) {
	    switch (key) {
	      case 'suggestionsContainer':
	        result['itemsContainer'] = theme[key];
	        break;
	
	      case 'suggestionsContainerOpen':
	        result['itemsContainerOpen'] = theme[key];
	        break;
	
	      case 'suggestion':
	        result['item'] = theme[key];
	        break;
	
	      case 'suggestionFirst':
	        result['itemFirst'] = theme[key];
	        break;
	
	      case 'suggestionHighlighted':
	        result['itemHighlighted'] = theme[key];
	        break;
	
	      case 'suggestionsList':
	        result['itemsList'] = theme[key];
	        break;
	
	      default:
	        result[key] = theme[key];
	    }
	  }
	
	  return result;
	};
	
	exports.mapToAutowhateverTheme = mapToAutowhateverTheme;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _basket = __webpack_require__(757);
	
	var _StoreOrderSummary = __webpack_require__(792);
	
	var _StoreOrderSummary2 = _interopRequireDefault(_StoreOrderSummary);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreCart = function (_React$Component) {
	    _inherits(StoreCart, _React$Component);
	
	    function StoreCart() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreCart);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreCart.__proto__ || Object.getPrototypeOf(StoreCart)).call.apply(_ref, [this].concat(args))), _this), _this.isDropDownClosed = function (isOpen) {
	            _this.props.isDropDownClosed(!isOpen && !_this.props.showUpdateRecurringModal);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreCart, [{
	        key: 'render',
	        value: function render() {
	            var showPoints = (this.props.staticData || {}).showItemPoints && (this.props.orderedItems.filteredItems || []).length > 0;
	            var itemsNumText = (0, _basket.getNumOfItemsInOrderText)(this.props.orderedItems, this.props.extraCreditItem);
	            var itemsClassName = "cart-items" + (this.props.remainingCredits.show || showPoints ? "-credits" : "");
	            var remainingBalanceAsCredits = this.props.totals.orderTotal && this.props.totals.orderTotal.remainingBalanceAsCredits;
	            var showRemainingBalanceAsCredits = remainingBalanceAsCredits > 0;
	            var credits = (0, _basket.formatCredits)(this.props.remainingCredits.credits);
	            var missingPoints = showPoints ? this.props.staticData.minimumPerOrder - this.props.totals.points : 0;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'order-summary-header-container' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('i', { className: 'cart-icon' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: itemsClassName },
	                            itemsNumText
	                        ),
	                        missingPoints > 0 && _react2.default.createElement(
	                            'div',
	                            { className: 'cart-credits' },
	                            'Add ',
	                            (0, _basket.formatPoints)(missingPoints),
	                            ' p. to Checkout'
	                        ),
	                        !showPoints && this.props.remainingCredits.show ? showRemainingBalanceAsCredits ? _react2.default.createElement(
	                            'div',
	                            { className: 'cart-credits balance-as-credit' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                credits + " Credits"
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'balance-as-credit' },
	                                "Balance " + (0, _basket.formatMoney)(remainingBalanceAsCredits)
	                            )
	                        ) : _react2.default.createElement(
	                            'div',
	                            { className: 'cart-credits' },
	                            credits + " " + (0, _translate.translate)("Remaining") + " " + this.props.creditItemLabel
	                        ) : undefined,
	                        _react2.default.createElement(
	                            'div',
	                            { className: "cart-price" + (showRemainingBalanceAsCredits ? " balance-as-credit" : "") },
	                            (0, _basket.getCheckoutPrice)(this.props.totals)
	                        )
	                    ),
	                    !this.props.readonly ? _react2.default.createElement(
	                        'div',
	                        { className: 'cart-button' },
	                        _react2.default.createElement(
	                            _reactBootstrap.DropdownButton,
	                            { title: (0, _translate.translate)('Cart'), id: 'cart-dropdown-btn', pullRight: true
	                                // noCaret={true}
	                                , bsStyle: 'default', onToggle: this.isDropDownClosed },
	                            _react2.default.createElement(_StoreOrderSummary2.default, { items: this.props.items })
	                        )
	                    ) : undefined
	                ),
	                this.props.readonly ? _react2.default.createElement(_StoreOrderSummary2.default, { items: this.props.items, readonly: true }) : undefined
	            );
	        }
	    }]);
	
	    return StoreCart;
	}(_react2.default.Component);
	
	exports.default = StoreCart;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _userMenu = __webpack_require__(765);
	
	var _userMenu2 = _interopRequireDefault(_userMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SegmentsMenu = function (_React$Component) {
	    _inherits(SegmentsMenu, _React$Component);
	
	    function SegmentsMenu() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SegmentsMenu);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SegmentsMenu.__proto__ || Object.getPrototypeOf(SegmentsMenu)).call.apply(_ref, [this].concat(args))), _this), _this.changeSegment = function (eventKey) {
	            _this.props.changeSegment(_this.props.staticData, eventKey);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SegmentsMenu, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'user-menu hidden-xs' },
	                _react2.default.createElement(
	                    _reactBootstrap.DropdownButton,
	                    { className: 'menu-title hidden-xs',
	                        title: this.props.segmentTitle,
	                        id: 'segments-menu',
	                        onSelect: this.changeSegment },
	                    this.props.segments.map(function (segment) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            { eventKey: segment.key, key: segment.key },
	                            segment.name
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SegmentsMenu;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var segments = (state.staticData || {}).segments || [];
	    var segmentKey = ((state.staticData || {}).params || {}).segment;
	    var segmentTitle = "";
	    segments.map(function (segment) {
	        if (segmentKey && segment.key === segmentKey || !segmentKey && segment.isDefault) segmentTitle = segment.name;
	    });
	    return {
	        staticData: state.staticData,
	        segmentTitle: segmentTitle,
	        segments: segments
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	    return {
	        changeSegment: function changeSegment(staticData, segment) {
	            window.location.assign((0, _utils.redirectPage)(_constants.URLs.STORE, staticData) + "?mode=preview&segment=" + segment);
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SegmentsMenu);

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserMenu = __webpack_require__(490);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	var _messagePage = __webpack_require__(816);
	
	var _messagePage2 = _interopRequireDefault(_messagePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessagePage = function (_React$Component) {
	    _inherits(MessagePage, _React$Component);
	
	    function MessagePage() {
	        _classCallCheck(this, MessagePage);
	
	        return _possibleConstructorReturn(this, (MessagePage.__proto__ || Object.getPrototypeOf(MessagePage)).apply(this, arguments));
	    }
	
	    _createClass(MessagePage, [{
	        key: "render",
	        value: function render() {
	            var messageData = this.props.messageData;
	            if (!messageData) {
	                return null;
	            }
	            var messageBody = messageData.messageBody;
	            if (messageData.messageExtra) {
	                messageBody += '<br>' + messageData.messageExtra;
	            }
	
	            var showMemberMenu = this.props.memberKey !== undefined;
	            var bodyClassName = "message-body" + (messageData.messageExtra ? ' message-extra' : '');
	            return _react2.default.createElement(
	                "div",
	                { className: "message-main-container" },
	                showMemberMenu ? _react2.default.createElement(
	                    "div",
	                    { className: "member-dropdown" },
	                    _react2.default.createElement(_UserMenu2.default, null)
	                ) : undefined,
	                _react2.default.createElement(
	                    "div",
	                    { className: "message-container" + (showMemberMenu ? " show-member-menu" : "") },
	                    _react2.default.createElement("div", { className: "message-title", id: "messageTitle", dangerouslySetInnerHTML: { __html: messageData.messageTitle } }),
	                    _react2.default.createElement("div", { className: bodyClassName, id: "messageBody", dangerouslySetInnerHTML: { __html: messageBody } }),
	                    this.props.link ? _react2.default.createElement(
	                        "div",
	                        { className: "link-back" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "link-back-a", href: this.props.link.url },
	                            this.props.link.text
	                        )
	                    ) : undefined,
	                    this.props.action ? this.props.action.type === 'button' ? _react2.default.createElement(
	                        "div",
	                        { className: "action" },
	                        _react2.default.createElement(
	                            "button",
	                            { className: "button btn btn-primary", onClick: this.props.action.callback },
	                            this.props.action.text
	                        )
	                    ) : _react2.default.createElement(
	                        "div",
	                        { className: "action", onClick: this.props.action.callback },
	                        this.props.action.text
	                    ) : undefined
	                )
	            );
	        }
	    }]);
	
	    return MessagePage;
	}(_react2.default.Component);
	
	exports.default = MessagePage;

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.changeCategory = changeCategory;
	
	var _actionTypes = __webpack_require__(459);
	
	function changeCategory(key) {
	
	    return {
	        type: _actionTypes.CHANGE_CATEGORY,
	        key: key
	    };
	}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _StoreCart = __webpack_require__(813);
	
	var _StoreCart2 = _interopRequireDefault(_StoreCart);
	
	var _UserMenu = __webpack_require__(490);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	var _PaymentMethods = __webpack_require__(820);
	
	var _PaymentMethods2 = _interopRequireDefault(_PaymentMethods);
	
	var _translate = __webpack_require__(464);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _basket = __webpack_require__(757);
	
	var _storeCheckoutActions = __webpack_require__(756);
	
	var _storeActions = __webpack_require__(766);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _RecurringOrderItems = __webpack_require__(798);
	
	var _RecurringOrderItems2 = _interopRequireDefault(_RecurringOrderItems);
	
	var _storeCheckout = __webpack_require__(822);
	
	var _storeCheckout2 = _interopRequireDefault(_storeCheckout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreCheckOutScreen = function (_React$Component) {
	    _inherits(StoreCheckOutScreen, _React$Component);
	
	    function StoreCheckOutScreen() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StoreCheckOutScreen);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreCheckOutScreen.__proto__ || Object.getPrototypeOf(StoreCheckOutScreen)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            storeComments: _this.props.storeComments,
	            showModal: true
	        }, _this.handleStoreCommentsChange = function (event) {
	            _this.setState({ storeComments: event.target.value });
	        }, _this.getStorePaymentMethodText = function (usedCreditsOnly) {
	            if (_this.hasBalanceMethod()) return _this.props.staticData.storeCheckoutMessageBalance || (0, _translate.translate)("_CheckOutMessageBalance");
	
	            if (_this.props.creditsData.credits > 0 && usedCreditsOnly) return (0, _translate.translate)("_CheckOutMessageNone").replace("_FARM_NAME_", _this.props.staticData.farmName);
	
	            if (_this.props.staticData.storePaymentMethods.includes(_this.props.isZeroAmount || _this.hasPreapprovalForCheckout() && _this.isAutoRenewalMethods() ? _this.props.paymentMethodToken : _this.state.selectedMethod)) return (0, _translate.translate)('ON_DELIVERY_CHARGE_hasToken');
	
	            if (_this.props.isZeroAmount) return (0, _translate.translate)('_chargeHasTokenZeroAmount');
	
	            return "";
	        }, _this.onSubmitButtonClick = function () {
	            _this.setState({ placeOrderClicked: true });
	            var selectedMethod = _this.props.isZeroAmount || _this.hasPreapprovalForCheckout() && _this.isAutoRenewalMethods() ? _constants.PaymentMethod.NONE.key : _this.state.selectedMethod;
	            _this.props.getStoreDataAndSubmit(_this.props.staticData, _this.props.memberKey, _this.props.subscriptionKey, _this.props.orderKey, _this.props.itemsList, _this.props.activeOrder, _this.props.canEditExistingOrder, _this.props.hasPreapproval, _this.state.storeComments, selectedMethod);
	        }, _this.setSelectedMethod = function (key) {
	            _this.setState({ selectedMethod: key });
	        }, _this.isPlaceOrderButtonDisabled = function () {
	            var isBalance = _this.props.staticData.storePaymentMethods.length === 1 && _this.props.staticData.storePaymentMethods.includes("BALANCE");
	            var selectedMethod = _this.props.isZeroAmount || _this.hasPreapprovalForCheckout() && _this.isAutoRenewalMethods() ? _this.props.paymentMethodToken : _this.state.selectedMethod;
	            return _this.state.placeOrderClicked || _this.props.showLoading || !_this.props.staticData.storePaymentMethods.includes(selectedMethod) && !_this.props.isZeroAmount && !isBalance || _this.props.isNegativeAmount;
	        }, _this.getUnAvailableMessage = function () {
	            var itemsTitles = "";
	            var unAvailableItems = _this.props.unAvailableItems;
	            Object.keys(unAvailableItems).forEach(function (key, index) {
	                if (index === Object.keys(unAvailableItems).length - 1) {
	                    itemsTitles += unAvailableItems[key].title + ".";
	                } else {
	                    itemsTitles += unAvailableItems[key].title + ", ";
	                }
	            });
	            var validationMessage = _basket.orderValidator.validateMinimumPerOrder(_this.props.itemsList, _this.props.staticData.minimumPerOrder, _this.props.extraCost, _this.props.extraCostType, _this.props.creditsData.credits, _this.props.staticData, _this.props.shareItems);
	            //User can continue if there are still items and no message
	            var canCheckout = _this.props.isOrderChanged && !validationMessage;
	            var message = !canCheckout ? (0, _translate.translate)("_ItemShort") + itemsTitles + (validationMessage ? validationMessage : "") + (0, _translate.translate)("_returnToStoreToUpdateYourOrder") : (0, _translate.translate)("_ItemShort") + itemsTitles + (0, _translate.translate)("_checkoutWithTheAvailableItems");
	
	            if (_this.state.showModal) {
	                return _react2.default.createElement(_ModalPopup2.default, {
	                    onClose: _this.closeModal,
	                    title: !_this.props.isOrderChanged ? "_OrderWasntCreated" : undefined,
	                    message: message,
	                    middle: !canCheckout ? { text: 'returnToStore', callback: _this.goBackUnAvailableFlow } : undefined,
	                    right: canCheckout ? { text: 'Checkout', callback: _this.continueToPayment } : undefined,
	                    left: canCheckout ? { text: 'returnToStore', callback: _this.goBackUnAvailableFlow } : undefined });
	            }
	        }, _this.continueToPayment = function () {
	            _this.props.unsetUnavailableItems();
	            _this.props.submitOrder(_this.props.staticData, _this.props.memberKey, _this.props.subscriptionKey, _this.props.orderKey, _this.props.itemsList, _this.props.activeOrder, _this.props.canEditExistingOrder, _this.props.hasPreapproval, _this.state.storeComments, _this.state.selectedMethod);
	        }, _this.goBackUnAvailableFlow = function () {
	            _this.props.unsetUnavailableItems();
	            _this.props.goBack();
	        }, _this.hasPreapprovalForCheckout = function () {
	            return _this.props.hasPreapproval;
	        }, _this.isAutoRenewalMethods = function () {
	            var methods = _this.props.staticData.storePaymentMethods.filter(function (method) {
	                return method === _constants.PaymentMethod.PAYPAL_PREAPPROVE.key || method === _constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key || method === _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key;
	            });
	            return methods.length > 0;
	        }, _this.hasBalanceMethod = function () {
	            var methods = _this.props.staticData.storePaymentMethods.filter(function (method) {
	                return method === _constants.PaymentMethod.BALANCE.key;
	            });
	            return methods.length > 0;
	        }, _this.getUpdateRecurringModal = function () {
	            if (_this.props.showUpdateRecurringModal) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    { show: true, dialogClassName: "update-recurring-items" },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(_RecurringOrderItems2.default, { readOnly: true })
	                    )
	                );
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StoreCheckOutScreen, [{
	        key: "render",
	        value: function render() {
	            var staticData = this.props.staticData;
	            var itemsList = this.props.itemsList;
	            var placeOrderText = (this.props.staticData.storeCheckoutButtonLabel || '|' + (0, _translate.translate)("Place Order") + '|').split('|')[1];
	            var finalizeOrderText = (this.props.staticData.storeCheckoutButtonLabel || '||' + (0, _translate.translate)("Finalize Your Order")).split('|')[2];
	            var submitLoadingClass = this.props.showLoading ? " loading" : "";
	            var submitClasses = "submit-order button" + submitLoadingClass;
	            var usedCreditsOnly = this.props.creditsData.credits > 0 && this.props.isZeroAmount;
	            return _react2.default.createElement(
	                _reactBootstrap.Form,
	                null,
	                _react2.default.createElement(
	                    "fieldset",
	                    { disabled: this.props.showLoading, className: "container-fluid" },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: "checkout-wrapper", md: 8, xs: 12, sm: 12 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: "checkout-header" },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { md: 5, sm: 5 },
	                                    _react2.default.createElement(
	                                        "h1",
	                                        null,
	                                        finalizeOrderText
	                                    ),
	                                    _react2.default.createElement(
	                                        "a",
	                                        { className: "back-to-store hidden-sm hidden-md hidden-lg",
	                                            onClick: this.props.goBack },
	                                        _react2.default.createElement("i", null)
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { md: 7, className: "actions-col hidden-xs" },
	                                    _react2.default.createElement(
	                                        "a",
	                                        { className: "back-to-store", disabled: this.props.showLoading,
	                                            onClick: this.props.showLoading ? function () {} : this.props.goBack },
	                                        (0, _translate.translate)("Back to store")
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        { bsStyle: "primary", className: submitClasses, onClick: this.onSubmitButtonClick,
	                                            disabled: this.isPlaceOrderButtonDisabled(this.props.isZeroAmount) },
	                                        placeOrderText
	                                    ),
	                                    _react2.default.createElement(_UserMenu2.default, null)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "checkout-content" },
	                                    !this.hasBalanceMethod() && !this.props.isZeroAmount && (!this.hasPreapprovalForCheckout() || this.hasPreapprovalForCheckout() && !this.isAutoRenewalMethods()) ? _react2.default.createElement(_PaymentMethods2.default, { paymentMethods: this.props.staticData.storePaymentMethods,
	                                        setSelectedMethod: this.setSelectedMethod,
	                                        selectedMethod: this.state.selectedMethod,
	                                        pageContext: _constants.URLs.STORE }) : _react2.default.createElement("span", { className: "store-payment-method-text",
	                                        dangerouslySetInnerHTML: { __html: this.getStorePaymentMethodText(usedCreditsOnly) } }),
	                                    staticData.storeCommentsLabel && staticData.storeCommentsLabel != 'null' ? _react2.default.createElement(
	                                        "div",
	                                        { className: "text-area" },
	                                        _react2.default.createElement("div", { className: "store-comment-label",
	                                            dangerouslySetInnerHTML: { __html: staticData.storeCommentsLabel } }),
	                                        _react2.default.createElement("textarea", { className: "input-text", type: "text", rows: "3",
	                                            value: this.state.storeComments,
	                                            onChange: this.handleStoreCommentsChange })
	                                    ) : undefined,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        { className: "checkout-bottom" },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { md: 8, sm: 12, xs: 12, className: "terms-wrapper" },
	                                            _react2.default.createElement(
	                                                "span",
	                                                {
	                                                    className: "terms-agreement" },
	                                                (0, _translate.translate)("By clicking "),
	                                                _react2.default.createElement(
	                                                    "b",
	                                                    null,
	                                                    placeOrderText
	                                                ),
	                                                " ",
	                                                (0, _translate.translate)("_agreeToTerms") + " ",
	                                                _react2.default.createElement(
	                                                    "a",
	                                                    { href: staticData.termsUrl, target: "_blank" },
	                                                    staticData.farmName
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { md: 4, sm: 12, xs: 12, className: "submit-wrapper" },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                { bsStyle: "primary", className: submitClasses,
	                                                    onClick: this.onSubmitButtonClick,
	                                                    disabled: this.isPlaceOrderButtonDisabled(this.props.isZeroAmount) },
	                                                placeOrderText
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { md: 4, className: "summary-order-wrapper hidden-xs hidden-sm" },
	                            _react2.default.createElement(_StoreCart2.default, { items: itemsList,
	                                orderedItems: this.props.orderedItems,
	                                extraCreditItem: this.props.extraCreditItem,
	                                totals: this.props.totals,
	                                remainingCredits: (0, _basket.getRemainingCredits)(this.props.creditsData, this.props.totals),
	                                staticData: this.props.staticData,
	                                creditsData: this.props.creditsData,
	                                creditItemLabel: this.props.creditItemLabel,
	                                readonly: true })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { md: 12 },
	                            this.props.unAvailableItems && Object.keys(this.props.unAvailableItems).length > 0 ? this.getUnAvailableMessage() : undefined
	                        )
	                    )
	                ),
	                this.getUpdateRecurringModal()
	            );
	        }
	    }]);
	
	    return StoreCheckOutScreen;
	}(_react2.default.Component);
	
	//export default StoreItemsScreen;
	
	var mapStateToProps = function mapStateToProps(state) {
	    var status = state.orderStatus || {};
	    var summary = state.summary || {};
	    var staticData = state.staticData || {};
	    return {
	        showLoading: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT),
	        itemsList: state.itemsList,
	        shareItems: summary.shareItems,
	        orderKey: status.orderKey,
	        subscriptionKey: summary.key,
	        hasPreapproval: summary.hasPreapproval,
	        storeComments: status.comments,
	        canEditExistingOrder: summary.canEditExistingOrder,
	        activeOrder: status.activeOrder,
	        memberKey: (state.memberDetails || {}).key,
	        staticData: staticData,
	        unAvailableItems: (state.checkout || {}).unAvailableItems,
	        isOrderChanged: (state.orderStatus || {}).isChanged,
	        isZeroAmount: ((status.totals || {}).orderTotal || {}).fullPrice === 0,
	        isNegativeAmount: ((status.totals || {}).orderTotal || {}).fullPrice < 0,
	        totals: status.totals || {},
	        extraCost: summary.extraCost,
	        extraCostType: summary.extraCostType,
	        paymentMethodToken: summary.paymentMethodToken,
	        creditsData: state.storeCreditsData || {},
	        orderedItems: status.orderedItems,
	        extraCreditItem: (state.storeCreditsData || {}).extraCreditItem || {},
	        creditItemLabel: staticData.creditItemLabel,
	        showUpdateRecurringModal: (state.recurringOrder || {}).showUpdateRecurringModal
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        getStoreDataAndSubmit: function getStoreDataAndSubmit(staticData, memberKey, subscriptionKey, orderKey, itemsList, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method) {
	            dispatch((0, _storeActions.getStoreDataAndSubmit)(staticData, memberKey, subscriptionKey, orderKey, itemsList, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method, ownProps.staticData.isChargeOnDelivery));
	        },
	        submitOrder: function submitOrder(staticData, memberKey, subscriptionKey, orderKey, itemsList, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method) {
	            dispatch((0, _storeCheckoutActions.submitOrder)(memberKey, subscriptionKey, orderKey, itemsList, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method, ownProps.staticData.isChargeOnDelivery));
	        },
	        goBack: function goBack() {
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.removePath)("checkout")));
	        },
	        unsetUnavailableItems: function unsetUnavailableItems() {
	            dispatch((0, _storeCheckoutActions.setUnavailableItemsInOrder)(undefined));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StoreCheckOutScreen);

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _paymentMethodsData = __webpack_require__(821);
	
	var _constants = __webpack_require__(463);
	
	var _translate = __webpack_require__(464);
	
	var _basket = __webpack_require__(757);
	
	var _utils = __webpack_require__(485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentMethods = function (_React$Component) {
	    _inherits(PaymentMethods, _React$Component);
	
	    function PaymentMethods() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PaymentMethods);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentMethods.__proto__ || Object.getPrototypeOf(PaymentMethods)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
	            if (event.target.value === 'on') {
	                var dataKey = event.target.attributes["data-key"];
	                var key = dataKey.nodeValue;
	                _this.props.setSelectedMethod(key);
	            }
	        }, _this.getPaymentTitle = function (paymentKey) {
	            var title = "";
	            if (paymentKey === _constants.PaymentMethod.CHECK.key && _this.props.staticData.farmCountry === 'CA') {
	                title = "Cheque";
	            } else if (paymentKey === _constants.PaymentMethod.CASH.key && _this.props.staticData.cashPaymentMethodTitle && _this.props.staticData.cashPaymentMethodTitle.length > 0) {
	                title = _this.props.staticData.cashPaymentMethodTitle;
	            } else if (paymentKey === _constants.PaymentMethod.PHONE.key && _this.props.staticData.otherPaymentMethodTitle && _this.props.staticData.otherPaymentMethodTitle.length > 0) {
	                title = _this.props.staticData.otherPaymentMethodTitle;
	            } else if (paymentKey === _constants.PaymentMethod.EBT_ONLINE.key && _this.props.staticData.ebtOnlinePaymentMethodTitle && _this.props.staticData.ebtOnlinePaymentMethodTitle.length > 0) {
	                title = _this.props.staticData.ebtOnlinePaymentMethodTitle;
	            } else {
	                title = _constants.PaymentMethod[paymentKey].title;
	            }
	
	            var shortTitle = _constants.PaymentMethod[paymentKey].shortTitle ? _constants.PaymentMethod[paymentKey].shortTitle : title;
	            var isAutomatic = paymentKey === _constants.PaymentMethod.PAYPAL_PREAPPROVE.key || paymentKey === _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key || paymentKey === _constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key;
	            return { title: title, shortTitle: shortTitle, isAutomatic: isAutomatic };
	        }, _this._getPayment = function (paymentKey) {
	            var description = (0, _paymentMethodsData.getPaymentMethodDescription)(paymentKey, _this.props.staticData, _this.props.pageContext, _this.props.isAddSubscription ? _constants.JoinModes.ADD : undefined);
	            if (_this.props.isAdmin) if (_this.props.paymentType === _constants.PaymentTypes.CHARGE.type && _this.props.hasToken && _constants.PaymentMethod[paymentKey].key !== _constants.PaymentMethod.PAYPAL_PREAPPROVE.key) description = (0, _translate.translate)("_usingPaymentDetailsOnFile");else description = undefined;
	            var selected = paymentKey === _this.props.selectedMethod;
	            var disableMethod = false;
	            var title = _this.getPaymentTitle(paymentKey);
	            var className = paymentKey;
	            if (paymentKey === _constants.PaymentMethod.PHONE.key && _this.props.staticData.otherPaymentMethodTitle && _this.props.staticData.otherPaymentMethodTitle === "Bitcoin") {
	                className = "BITCOIN";
	            }
	            var checkMethodCustomDetails = _this.props.staticData.checkMethodCustomDetails;
	            if (checkMethodCustomDetails && paymentKey === _constants.PaymentMethod.CHECK.key) {
	                var checkDetails = checkMethodCustomDetails.split('|');
	                title = { title: checkDetails[0], shortTitle: checkDetails[0] };
	                description = checkDetails[1];
	            }
	            var authorizeDotNetPreapproveMethodCustomDetailsMethodCustomDetails = _this.props.staticData.authorizeDotNetPreapproveMethodCustomDetailsMethodCustomDetails;
	            if (authorizeDotNetPreapproveMethodCustomDetailsMethodCustomDetails && paymentKey === _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key) {
	                var details = authorizeDotNetPreapproveMethodCustomDetailsMethodCustomDetails.split('|');
	                title = { title: details[0], shortTitle: details[0] };
	                description = details[1];
	            }
	            var ebtMethodCustomDetails = _this.props.staticData.ebtMethodCustomDetails;
	            if (paymentKey === _constants.PaymentMethod.EBT_ONLINE.key) {
	                if (ebtMethodCustomDetails) {
	                    var ebtDetails = ebtMethodCustomDetails.split('|');
	                    if (ebtDetails.length === 1 || _this.props.pageContext === _constants.URLs.JOIN) {
	                        description += '<br/>' + ebtDetails[0];
	                    } else {
	                        description += '<br/>' + ebtDetails[1];
	                    }
	                }
	                if (_this.props.disableEBT) {
	                    disableMethod = true;
	                    if (_this.props.pageContext === _constants.URLs.STORE) {
	                        description = 'Your order includes SNAP non eligible items. If you wish to pay using EBT please remove those items.';
	                    }
	                }
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { name: "paymentMethod", className: "payment-method", key: paymentKey },
	                _react2.default.createElement(
	                    _reactBootstrap.Radio,
	                    { name: "methodType", onChange: _this.handleChange, "data-key": paymentKey, checked: selected, disabled: disableMethod },
	                    _this.props.isAdmin || _this.props.clientViewPort.isXs ? _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "b",
	                            { className: className },
	                            title.shortTitle
	                        ),
	                        !_this.props.isAdmin && title.isAutomatic ? _react2.default.createElement(
	                            "span",
	                            null,
	                            (0, _translate.translate)("_AutomaticallyRecurringPayments")
	                        ) : undefined
	                    ) : _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "b",
	                            { className: className },
	                            title.title
	                        )
	                    ),
	                    description ? _react2.default.createElement("div", { className: "description", dangerouslySetInnerHTML: { __html: description } }) : undefined
	                )
	            );
	        }, _this.getRemoveToken = function () {
	            if (_this.props.hasToken && (_this.props.paymentType === _constants.PaymentTypes.PAYMENT_TOKEN.type || _this.props.paymentType === _constants.PaymentTypes.UPDATE_PAYMENT.type && _this.props.staticData.allowMemberToRemoveToken)) return _react2.default.createElement(
	                "div",
	                { className: "payment-method" },
	                _react2.default.createElement(
	                    "h4",
	                    null,
	                    (0, _translate.translate)("_optionRemove")
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Radio,
	                    { name: "methodPlan", "data-key": _constants.PaymentMethod.NONE.key, checked: _this.props.selectedMethod === _constants.PaymentMethod.NONE.key, onChange: _this.handleChange },
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "b",
	                            { className: "remove-token" },
	                            (0, _translate.translate)("_optionRemoveAutomatic")
	                        )
	                    )
	                )
	            );
	            return null;
	        }, _this.filterRelevantMethods = function () {
	            return (_this.props.paymentMethods || []).filter(function (paymentMethodKey) {
	                return !(paymentMethodKey === _constants.PaymentMethod.EBT_ONLINE.key && _this.props.hideEBT);
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PaymentMethods, [{
	        key: "render",
	        value: function render() {
	            var methods = this.filterRelevantMethods();
	            if (methods && (methods.length > 1 || methods.length === 1 && methods[0] !== "BALANCE")) {
	                return _react2.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    null,
	                    _react2.default.createElement(
	                        "h4",
	                        null,
	                        this.props.paymentType === _constants.PaymentTypes.CHARGE.type ? (0, _translate.translate)("Payment Method") : this.props.paymentType === _constants.PaymentTypes.UPDATE_PAYMENT.type || this.props.paymentType === _constants.PaymentTypes.PAYMENT_TOKEN.type ? (0, _translate.translate)("Update payment details") : this.props.isAddSubscription && this.props.hasPreapproval ? (0, _translate.translate)("paymentMethodReuse") : (0, _translate.translate)("Select Payment Method")
	                    ),
	                    methods.map(this._getPayment),
	                    this.getRemoveToken()
	                );
	            } else if (this.props.paymentType === _constants.PaymentTypes.PAYMENT_TOKEN.type) {
	                //For case there are no defined payment methods but still there is a token
	                return this.getRemoveToken();
	            } else {
	                return null;
	            }
	        }
	    }]);
	
	    return PaymentMethods;
	}(_react2.default.Component);
	
	//FIXME : move to containers
	
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    var staticData = state.staticData || {};
	    var hideEBT = false;
	    var disableEBT = false;
	    if (ownProps.pageContext === _constants.URLs.JOIN) {
	        var summary = state.summary || {};
	        var signupData = state.signupData || {};
	        var orderStatus = state.orderStatus || {};
	        var pickupSite = summary.pickupSite || {};
	        var selectedItems = signupData.sharesData ? (0, _basket.getJoinSelectedItems)(signupData.sharesData.shares, signupData.sharesData.options).items : [];
	        var orderTotal = (orderStatus.totals || {}).orderTotal || {};
	        var selectedData = (signupData || {}).selectedData;
	        var selectedPaymentPlan = (selectedData || {}).selectedPaymentPlan;
	        var nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
	        var schedules = signupData.schedules || {};
	        var exceptionalPickupSites = (signupData.pickupSitesData || {}).exceptionalPickupSites;
	        var summaryItems = summary.shareItems ? summary.shareItems.concat(summary.waitListItems) : [];
	        var nextDeliveryDate = void 0;
	        if (pickupSite && nextDeliveryDates) {
	            nextDeliveryDate = (0, _basket.getNextDeliveryDate)(summary.pickupSite, selectedItems.concat(summaryItems), schedules, nextDeliveryDates);
	            if (exceptionalPickupSites && exceptionalPickupSites.hasOwnProperty(summary.pickupSite.key)) {
	                nextDeliveryDate = exceptionalPickupSites[summary.pickupSite.key];
	            }
	        }
	        var hideEBTOnExtraCharges = staticData.hideEBTOnExtraCharges && (pickupSite.extraCost > 0 || pickupSite.signupFee > 0 || selectedItems.filter(function (item) {
	            return item.salesTax;
	        }).length > 0 || orderTotal.tax > 0);
	        var hideEBTByPaymentMethod = !selectedPaymentPlan || selectedPaymentPlan.type === _constants.PaymentPlans.F || (selectedPaymentPlan.type === _constants.PaymentPlans.DistributionDynamicPrePayment || selectedPaymentPlan.type === _constants.PaymentPlans.DynamicPrePayment) && selectedPaymentPlan.amount > 1;
	        var hideEBTDueToNextDeliveryDate = (0, _utils.getDiffFromNow)(nextDeliveryDate) > 14 * 24 * 60 * 60 * 1000; //Next delivery date is more than 2 weeks ahead
	        hideEBT = hideEBTOnExtraCharges || hideEBTByPaymentMethod || hideEBTDueToNextDeliveryDate;
	    } else if (ownProps.pageContext === _constants.URLs.STORE) {
	        var _orderStatus = state.orderStatus || {};
	        disableEBT = (0, _basket.isEBTNonEligibleItems)(_orderStatus.orderedItems.editableItems);
	    }
	    return {
	        staticData: staticData,
	        clientViewPort: state.clientViewPort || {},
	        isAdmin: ownProps.paymentType === _constants.PaymentTypes.CHARGE.type || ownProps.paymentType === _constants.PaymentTypes.PAYMENT_TOKEN.type,
	        hideEBT: hideEBT,
	        disableEBT: disableEBT,
	        pageContext: ownProps.pageContext
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(PaymentMethods);

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPaymentMethodDescription = getPaymentMethodDescription;
	
	var _constants = __webpack_require__(463);
	
	var _translate = __webpack_require__(464);
	
	//TODO Pass the new parameters
	function getPaymentMethodDescription(methodKey, staticData, pageContext, mode) {
	    var buttonTitle = (0, _translate.translate)(pageContext == _constants.URLs.STORE ? "Place Order" : pageContext == _constants.URLs.JOIN ? "Checkout" : pageContext == _constants.URLs.PAY ? "Continue" : "Next");
	    var isFarmSeasonal = staticData.isFarmSeasonal;
	    var farmName = staticData.farmName;
	    var preapprovalChargeLimit = Math.round(staticData.preapprovalChargeLimit);
	    var preapprovalChargeLimitDollar = preapprovalChargeLimit < 0 ? '-$' + Math.abs(preapprovalChargeLimit) : '$' + preapprovalChargeLimit;
	    var farmPhone = staticData.farmPhone;
	    if (pageContext == _constants.URLs.STORE && staticData.isChargeOnDelivery && (methodKey == _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key || methodKey == _constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key || methodKey == _constants.PaymentMethod.PAYPAL_PREAPPROVE.key)) {
	        return (0, _translate.translate)("ON_DELIVERY_CHARGE_noToken").replace("_BUTTON_TITLE_", buttonTitle);
	    }
	    switch (methodKey) {
	        case _constants.PaymentMethod.AUTHORIZE_DOT_NET.key:
	            return pageContext == _constants.URLs.JOIN ? (0, _translate.translate)("AUTHORIZE_DOT_NET_MESSAGE").replace("_BUTTON_TITLE_", buttonTitle) : (0, _translate.translate)("AUTHORIZE_DOT_NET_store").replace("_BUTTON_TITLE_", buttonTitle);
	        case _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key:
	            if (pageContext == _constants.URLs.JOIN && mode == _constants.JoinModes.ADD) return (0, _translate.translate)("AUTHORIZE_DOT_NET_PREAPPROVE_reuse").replace("_BUTTON_TITLE_", buttonTitle);
	            return !isFarmSeasonal ? (0, _translate.translate)("MASSAGE.AUTHORIZE_DOT_NET_PREAPPROVE").replace("{0}", buttonTitle).replace("{1}", farmName).replace("{2}", preapprovalChargeLimitDollar) : (0, _translate.translate)("AUTHORIZE_DOT_NET_PREAPPROVE_seasonal").replace("{0}", buttonTitle);
	        case _constants.PaymentMethod.CASH.key:
	            return (0, _translate.translate)("MASSAGE.CASH").replace("{0}", buttonTitle);
	        case _constants.PaymentMethod.CHECK.key:
	            return pageContext == _constants.URLs.JOIN && mode != _constants.JoinModes.ADD ? (0, _translate.translate)("MASSAGE.CHECKS").replace("{0}", buttonTitle) : (0, _translate.translate)("MASSAGE.CHECK").replace("{0}", buttonTitle).replace("{1}", farmName);
	        case _constants.PaymentMethod.ELECTRONIC_CHECK.key:
	            return pageContext == _constants.URLs.JOIN ? (0, _translate.translate)("MASSAGE.ELECTRONIC_CHECK").replace("{0}", buttonTitle) : (0, _translate.translate)("MASSAGE.ELECTRONIC_CHECK_store").replace("{0}", buttonTitle);
	        case _constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key:
	            if (pageContext == _constants.URLs.JOIN && mode == _constants.JoinModes.ADD) return (0, _translate.translate)("ELECTRONIC_CHECK_PREAPPROVE_reuse").replace("{0}", buttonTitle);
	            return !isFarmSeasonal ? (0, _translate.translate)("MASSAGE.ELECTRONIC_CHECK_PREAPPROVE").replace("{1}", farmName).replace("{2}", preapprovalChargeLimitDollar) : (0, _translate.translate)("ELECTRONIC_CHECK_PREAPPROVE_seasonal").replace("{0}", buttonTitle);
	        case _constants.PaymentMethod.PAYPAL_STANDARD.key:
	            return pageContext == _constants.URLs.JOIN ? (0, _translate.translate)("MASSAGE.PAYPAL_STANDARD").replace("{0}", buttonTitle) : (0, _translate.translate)("MASSAGE.PAYPAL_STANDARD_store").replace("{0}", buttonTitle);
	        case _constants.PaymentMethod.PAYPAL_PREAPPROVE.key:
	            if (pageContext == _constants.URLs.JOIN && mode == _constants.JoinModes.ADD) return (0, _translate.translate)("PAYPAL_PREAPPROVE_reuse").replace("{0}", buttonTitle);
	            return !isFarmSeasonal ? (0, _translate.translate)("PAYPAL_PREAPPROVE_store").replace("{1}", farmName).replace("{0}", buttonTitle).replace("{2}", preapprovalChargeLimitDollar) : (0, _translate.translate)("PAYPAL_PREAPPROVE_seasonal").replace("{0}", buttonTitle);
	        case _constants.PaymentMethod.PHONE.key:
	            return staticData.checkInstructions || staticData.checkInstructions.length > 0 ? staticData.checkInstructions : (0, _translate.translate)("MASSAGE.PHONE").replace("{1}", farmName).replace("{0}", buttonTitle).replace("{2}", farmPhone);
	        case _constants.PaymentMethod.EBT_ONLINE.key:
	            return (0, _translate.translate)("MASSAGE.EBT_ONLINE").replace("{0}", buttonTitle);
	    }
	}
	
	//TODO Use for Add subscription / make payment / on-week-debit
	//ELECTRONIC_CHECK Make Payment
	// "Select this payment method to make a one-time payment. Once you click the \"<b>" + buttonTitle + "</b>\" button, we will direct you to a secure site to enter your payment information.";
	
	//ON_DELIVERY_CHARGE + preapproval + store + hasToken
	// "Once you click on the \"<b>" + buttonTitle + "</b>\" button, we will start processing your order. You will be charged after the delivery of your order takes place using the method of payment we have on file for you.";
	
	//ON_DELIVERY_CHARGE + preapproval + store + noToken
	// "You will be charged for your order after the delivery takes place. Once you click the \"<b>" + buttonTitle + "</b>\" button, you will be directed to a secure site to enter your payment information.";

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _logInActions = __webpack_require__(750);
	
	var _translate = __webpack_require__(464);
	
	var _utils = __webpack_require__(485);
	
	var _LoginLinkFBAccount = __webpack_require__(824);
	
	var _LoginLinkFBAccount2 = _interopRequireDefault(_LoginLinkFBAccount);
	
	var _LoginForgetPassword = __webpack_require__(825);
	
	var _LoginForgetPassword2 = _interopRequireDefault(_LoginForgetPassword);
	
	var _LoginChangePassword = __webpack_require__(827);
	
	var _LoginChangePassword2 = _interopRequireDefault(_LoginChangePassword);
	
	var _constants = __webpack_require__(463);
	
	var _staticDataActions = __webpack_require__(749);
	
	var _LoginInputField = __webpack_require__(826);
	
	var _LoginInputField2 = _interopRequireDefault(_LoginInputField);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _login = __webpack_require__(828);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogInScreen = function (_React$Component) {
	    _inherits(LogInScreen, _React$Component);
	
	    function LogInScreen(props) {
	        _classCallCheck(this, LogInScreen);
	
	        var _this = _possibleConstructorReturn(this, (LogInScreen.__proto__ || Object.getPrototypeOf(LogInScreen)).call(this, props));
	
	        _this.enableFBButton = function () {
	            if (!_this.unmounted) {
	                _this.props.setEnableFbButton(true);
	            }
	        };
	
	        _this.statusChangeCallback = function (response, logOut, shouldNotLogin) {
	            console.log(response);
	            if (response.status === 'connected') {
	                if (logOut && _this.props.memberDetails.key) FB.logout(function (response) {
	                    console.log("Facebook log out");
	                });else if (response.authResponse) {
	                    FB.api('/me', { fields: 'id,first_name,last_name,email' }, function (response) {
	                        this.setState({ facebookId: response.id, email: response.email });
	                        this.props.loginWithFacebook(response.email, response.id, true, "");
	                    }.bind(_this));
	                } else {
	                    console.log('User cancelled login or did not fully authorize.');
	                }
	            } else if (!shouldNotLogin) {
	                FB.login(function (response) {
	                    this.statusChangeCallback(response, false, true);
	                }.bind(_this));
	            }
	        };
	
	        _this.checkLoginState = function () {
	            if (!_this.isFBLoaded()) return;
	            FB.getLoginStatus(function (response) {
	                this.statusChangeCallback(response);
	            }.bind(_this));
	        };
	
	        _this.isFBLoaded = function () {
	            if (typeof FB === 'undefined') {
	                (0, _utils.initFacebook)(_this.props.facebookAppId, true, _this.enableFBButton);
	                _this.props.showFBErrorMessage();
	                return false;
	            }
	            return true;
	        };
	
	        _this.handleChangeEmail = function (value) {
	            _this.setState({ email: value });
	        };
	
	        _this.handleChangePassword = function (value) {
	            _this.setState({ password: value });
	        };
	
	        _this.emailLoginClicked = function () {
	            _this.props.loginWithEmail(_this.state.email, _this.state.password);
	        };
	
	        _this.forgetPasswordClicked = function () {
	            _this.props.resetStatus();
	            _this.props.setForgetPassword(true);
	        };
	
	        _this.closeCreateFBAccount = function () {
	            _this.props.setShowCreateFBAccount(false);
	        };
	
	        _this.getCreateFBLogInPopup = function () {
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { show: _this.props.loginStatus.showCreateFBAccount, onHide: _this.closeCreateFBAccount },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        "button",
	                        { className: "close", onClick: _this.closeCreateFBAccount },
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "x"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_LoginLinkFBAccount2.default, { email: _this.props.loginStatus.email, facebookId: _this.state.facebookId,
	                        component: _this.props.loginStatus.component,
	                        status: _this.props.loginStatus.status,
	                        createFBAccount: _this.props.createFBAccount,
	                        showLoading: _this.props.showLoading })
	                )
	            );
	        };
	
	        _this.getLoginPage = function () {
	            var className = "border-container";
	            if (_constants.URLs.JOIN == _this.props.flowType) {
	                className += " border-container-join";
	            }
	            return _react2.default.createElement(
	                "div",
	                { className: className },
	                _react2.default.createElement(
	                    "div",
	                    { className: "inner-container login-container" },
	                    _react2.default.createElement(
	                        "form",
	                        null,
	                        _react2.default.createElement(
	                            "fieldset",
	                            { className: "form-container container-fluid", disabled: _this.props.showLoading },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: "sign-in-fb" },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { className: "button fb-login-button" + (_this.props.showLoading ? " loading" : ""), onClick: _this.checkLoginState,
	                                        disabled: !_this.props.fbButtonEnabled },
	                                    _react2.default.createElement("div", { className: "fb-img" }),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "btn-fb-text" },
	                                        (0, _translate.translate)('Login with Facebook')
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "or-sign-in" },
	                                    (0, _translate.translate)('or')
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: "email-form-title" },
	                                _react2.default.createElement("div", { className: "email-img" }),
	                                (0, _translate.translate)('Login with Email')
	                            ),
	                            _react2.default.createElement(_LoginInputField2.default, { id: "email", type: "email", value: _this.state.email, label: (0, _translate.translate)("email"), placeholder: (0, _translate.translate)("Email"),
	                                error: !_this.props.loginStatus.showCreateFBAccount && _this.props.loginStatus.component === "email" ? _this.props.loginStatus.status : undefined, update: _this.handleChangeEmail, validate: _this.validateEmail, ref: "email" }),
	                            _react2.default.createElement(_LoginInputField2.default, { id: "password", type: "password", value: _this.state.password, label: (0, _translate.translate)("password"), placeholder: (0, _translate.translate)("Password"),
	                                error: !_this.props.loginStatus.showCreateFBAccount && _this.props.loginStatus.component === "password" ? _this.props.loginStatus.status : undefined, update: _this.handleChangePassword, ref: "password" }),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: "email-log-in" },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { bsStyle: "primary", className: "button email-login-button" + (_this.props.showLoading ? " loading" : ""), id: "btnlogin", onClick: _this.emailLoginClicked },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "btn-email-text" },
	                                        (0, _translate.translate)('Login')
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: "forget-password-row" },
	                                _react2.default.createElement(
	                                    "a",
	                                    { className: "forget-password",
	                                        onClick: _this.forgetPasswordClicked },
	                                    (0, _translate.translate)('Forgot Password')
	                                )
	                            )
	                        )
	                    ),
	                    _this.props.clientViewPort.isXs && _this.props.flowType === _constants.URLs.JOIN ? undefined : _react2.default.createElement(
	                        "div",
	                        { className: "bottom-container" },
	                        _this.props.flowType !== _constants.URLs.JOIN ? _react2.default.createElement(
	                            "span",
	                            { className: "not-member-join" },
	                            _react2.default.createElement(
	                                "span",
	                                {
	                                    className: "not-member-yet" },
	                                " ",
	                                !_this.props.isSupportGuestMembers ? (0, _translate.translate)('Not a member yet?') : (0, _translate.translate)('New Member?'),
	                                " "
	                            ),
	                            _react2.default.createElement(
	                                "a",
	                                { className: "click-join",
	                                    href: "/" + _constants.URLs.JOIN + "/" + _this.props.farmUrl + (!_this.props.isSupportGuestMembers ? '' : '?mode=guest') },
	                                " ",
	                                !_this.props.isSupportGuestMembers ? (0, _translate.translate)("Summary_Account.join") : (0, _translate.translate)('Create an Account')
	                            )
	                        ) : undefined
	                    ),
	                    _this.getCreateFBLogInPopup()
	                )
	            );
	        };
	
	        if ((0, _utils.isEmptyObj)(props.staticData)) {
	            (0, _staticDataActions.initServerStaticData)();
	        }
	
	        _this.state = {
	            email: '',
	            password: '',
	            facebookId: ''
	        };
	        return _this;
	    }
	
	    _createClass(LogInScreen, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            (0, _utils.initFacebook)(this.props.facebookAppId, false, this.enableFBButton);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            this.unmounted = true;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (this.props.loginStatus.isForgetPassword) {
	                return _react2.default.createElement(_LoginForgetPassword2.default, { loginStatus: this.props.loginStatus,
	                    forgetPassword: this.props.forgetPassword, email: this.state.email,
	                    resetEmailSent: this.props.resetEmailSent,
	                    showLoading: this.props.showLoading,
	                    flowType: this.props.flowType,
	                    clientViewPort: this.props.clientViewPort });
	            } else if (this.props.loginStatus.isNeedToChangePassword) {
	                return _react2.default.createElement(_LoginChangePassword2.default, { changePassword: this.props.changePassword, email: this.state.email,
	                    loginStatus: this.props.loginStatus,
	                    showLoading: this.props.showLoading,
	                    flowType: this.props.flowType });
	            } else {
	                return this.getLoginPage();
	            }
	        }
	    }]);
	
	    return LogInScreen;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        clientViewPort: state.clientViewPort || {},
	        loginStatus: state.loginStatus || {},
	        facebookAppId: (state.staticData || {}).facebookAppId,
	        isSupportGuestMembers: (state.staticData || {}).isSupportGuestMembers,
	        farmUrl: (state.staticData || {}).farmUrl,
	        seasonUrl: (state.staticData || {}).seasonUrl,
	        memberDetails: state.memberDetails || {},
	        showLoading: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOGIN),
	        fbButtonEnabled: (state.loginStatus || {}).enableFBButton
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        loginWithEmail: function loginWithEmail(email, password) {
	            dispatch((0, _logInActions.loginWithEmail)(email, password));
	        },
	        forgetPassword: function forgetPassword(email) {
	            dispatch((0, _logInActions.forgetPassword)(email));
	        },
	        logOut: function logOut(memberKey) {
	            dispatch((0, _logInActions.logOut)(memberKey));
	        },
	        loginWithFacebook: function loginWithFacebook(email, facebookId, remember, sourceRequestUrl) {
	            dispatch((0, _logInActions.loginWithFacebook)(email, facebookId, remember, sourceRequestUrl));
	        },
	        setShowCreateFBAccount: function setShowCreateFBAccount(showCreateFBAccount) {
	            dispatch((0, _logInActions.setShowCreateFBAccount)(showCreateFBAccount));
	        },
	        setForgetPassword: function setForgetPassword(forgetPassword) {
	            dispatch((0, _logInActions.setForgetPassword)(forgetPassword));
	        },
	        changePassword: function changePassword(email, password, newPassword) {
	            dispatch((0, _logInActions.changePassword)(email, password, newPassword));
	        },
	        showChangePassword: function showChangePassword(isNeedToChangePassword) {
	            dispatch((0, _logInActions.setChangePassword)(isNeedToChangePassword));
	        },
	        resetStatus: function resetStatus() {
	            dispatch((0, _logInActions.resetStatus)());
	        },
	        setResetPasswordEmailSent: function setResetPasswordEmailSent(isResetPasswordEmailSent) {
	            dispatch((0, _logInActions.setResetPasswordEmailSent)(isResetPasswordEmailSent));
	        },
	        createFBAccount: function createFBAccount(email, password, facebookAppId) {
	            dispatch((0, _logInActions.activateFacebook)(email, password, facebookAppId));
	        },
	        fetchingData: function fetchingData(fetchingType) {
	            dispatch((0, _fetchingActions.fetchingData)(fetchingType));
	        },
	        dataFetched: function dataFetched() {
	            dispatch((0, _fetchingActions.dataFetched)());
	        },
	        resetEmailSent: function resetEmailSent() {
	            dispatch((0, _logInActions.resetEmailSent)());
	        },
	        showFBErrorMessage: function showFBErrorMessage() {
	            dispatch((0, _logInActions.showFBErrorMessage)());
	        },
	        setEnableFbButton: function setEnableFbButton(fbButtonEnabled) {
	            dispatch((0, _logInActions.setEnableFbButton)(fbButtonEnabled));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LogInScreen);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginLinkFBAccount = function (_React$Component) {
	    _inherits(LoginLinkFBAccount, _React$Component);
	
	    function LoginLinkFBAccount() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LoginLinkFBAccount);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginLinkFBAccount.__proto__ || Object.getPrototypeOf(LoginLinkFBAccount)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            email: _this.props.email,
	            password: ''
	        }, _this.handleChangeEmail = function (event) {
	            _this.setState({ email: event.target.value });
	        }, _this.handleChangePassword = function (event) {
	            _this.setState({ password: event.target.value });
	        }, _this.createFBAccountClicked = function () {
	            _this.props.createFBAccount(_this.state.email, _this.state.password, _this.props.facebookId);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LoginLinkFBAccount, [{
	        key: 'render',
	        value: function render() {
	            var styleClassEmail = this.props.component === "email" ? "sign-in-email error" : "sign-in-email";
	            var styleClassPassword = this.props.component === "password" ? "sign-in-email error" : "sign-in-email";
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Form,
	                    { className: 'message-details' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _translate.translate)('We were unable to recognize your facebook account: ') + this.props.email
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _translate.translate)('To activate Facebook login please enter the email and password you ' + 'normally use to access your account')
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner-container inner-container-fb' },
	                    _react2.default.createElement(
	                        'fieldset',
	                        { className: 'form-container container-fluid', disabled: this.props.showLoading },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'sign-in-email-row' },
	                            _react2.default.createElement(_reactBootstrap.FormControl, { bsSize: 'sm', className: styleClassEmail, type: 'email', value: this.state.email,
	                                placeholder: 'Email',
	                                onChange: this.handleChangeEmail, ref: 'email' }),
	                            this.props.component === "email" ? _react2.default.createElement(
	                                'label',
	                                { className: 'validation-error' },
	                                (0, _translate.translate)(this.props.status)
	                            ) : undefined
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'sign-in-email-row' },
	                            _react2.default.createElement(_reactBootstrap.FormControl, { className: styleClassPassword + " _lr-hide", type: 'password', value: this.state.password,
	                                placeholder: 'Password', onChange: this.handleChangePassword, ref: 'password' }),
	                            this.props.component === "password" ? _react2.default.createElement(
	                                'label',
	                                { className: 'validation-error' },
	                                (0, _translate.translate)(this.props.status)
	                            ) : undefined
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'sign-in-fb' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { className: 'button fb-login-button', onClick: this.createFBAccountClicked },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'btn-fb-text' },
	                                    _react2.default.createElement('div', { className: 'fb-img' }),
	                                    (0, _translate.translate)('Create Account with Facebook')
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LoginLinkFBAccount;
	}(_react2.default.Component);
	
	exports.default = LoginLinkFBAccount;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	var _LoginInputField = __webpack_require__(826);
	
	var _LoginInputField2 = _interopRequireDefault(_LoginInputField);
	
	var _constants = __webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginForgetPassword = function (_React$Component) {
	    _inherits(LoginForgetPassword, _React$Component);
	
	    function LoginForgetPassword() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LoginForgetPassword);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginForgetPassword.__proto__ || Object.getPrototypeOf(LoginForgetPassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            email: _this.props.email,
	            password: ''
	        }, _this.handleChangeEmail = function (value) {
	            _this.setState({ email: value });
	        }, _this.backToSignInClicked = function () {
	            _this.props.resetEmailSent();
	        }, _this.emailSubmitClicked = function () {
	            _this.props.forgetPassword(_this.state.email);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LoginForgetPassword, [{
	        key: "render",
	        value: function render() {
	            var component = (this.props.loginStatus || {}).component;
	            var status = (this.props.loginStatus || {}).status;
	            var className = "border-container";
	            if (_constants.URLs.JOIN === this.props.flowType) {
	                className += " border-container-join";
	            }
	            var styleTitle = _constants.URLs.JOIN === this.props.flowType && this.props.clientViewPort.isXs ? "forget-password-title" : "log-in-title-row";
	            return _react2.default.createElement(
	                "div",
	                { className: className },
	                _react2.default.createElement(
	                    "fieldset",
	                    { className: "inner-container forgot-password-container", disabled: this.props.showLoading },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "form-container container-fluid" },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: styleTitle },
	                            _constants.URLs.JOIN === this.props.flowType ? undefined : _react2.default.createElement("i", { className: "back-sign-in-arrow hidden-sm hidden-md hidden-lg",
	                                onClick: this.backToSignInClicked }),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "log-in-title" },
	                                (0, _translate.translate)('Forgot Password')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                "div",
	                                { className: "reset-password-text" },
	                                "To reset your password, enter your email address and we'll send you instructions on how to create a new password."
	                            )
	                        ),
	                        _react2.default.createElement(_LoginInputField2.default, { type: "email", placeholder: "Email", value: this.state.email, label: "email", ref: "email",
	                            error: component === 'email' ? status : undefined, update: this.handleChangeEmail,
	                            fieldName: "email" }),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: "email-log-in" },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { bsStyle: "primary", className: "button email-login-button" + (this.props.showLoading ? " loading" : ""), onClick: this.emailSubmitClicked },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "btn-email-text" },
	                                    (0, _translate.translate)('Submit')
	                                )
	                            ),
	                            this.props.clientViewPort.isXs && this.props.flowType === _constants.URLs.JOIN && this.props.loginStatus.isResetPasswordEmailSent ? _react2.default.createElement(
	                                "div",
	                                { className: "email-sent-message mobile-login-forget-password-text" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "email-sent-message-text" },
	                                    "We just emailed you a link you can use to reset your password."
	                                )
	                            ) : undefined
	                        ),
	                        this.props.clientViewPort.isXs ? undefined : _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: "forget-password-row" },
	                            _react2.default.createElement(
	                                "a",
	                                { className: "back-sign-in",
	                                    onClick: this.backToSignInClicked },
	                                (0, _translate.translate)('Back to Login')
	                            )
	                        )
	                    ),
	                    this.props.clientViewPort.isXs && this.props.flowType === _constants.URLs.JOIN ? undefined : _react2.default.createElement(
	                        "div",
	                        { className: "bottom-container" },
	                        this.props.loginStatus.isResetPasswordEmailSent ? _react2.default.createElement(
	                            "div",
	                            { className: "email-sent-message" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "email-sent-message-text" },
	                                "We just emailed you a link you can use to reset your password."
	                            )
	                        ) : undefined
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LoginForgetPassword;
	}(_react2.default.Component);
	
	exports.default = LoginForgetPassword;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginInput = function (_React$Component) {
	    _inherits(LoginInput, _React$Component);
	
	    function LoginInput(props) {
	        _classCallCheck(this, LoginInput);
	
	        return _possibleConstructorReturn(this, (LoginInput.__proto__ || Object.getPrototypeOf(LoginInput)).call(this, props));
	    }
	
	    _createClass(LoginInput, [{
	        key: "update",
	        value: function update(event) {
	            this.props.update(event.target.value);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var styleClass = !this.props.error ? "sign-in-email" : "sign-in-email error";
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: "sign-in-email-row" },
	                _react2.default.createElement(_reactBootstrap.FormControl, { id: this.props.id, className: styleClass + " _lr-hide", type: this.props.type, value: this.props.value, placeholder: (0, _translate.translate)(this.props.placeholder),
	                    onChange: this.update.bind(this), ref: "inp" }),
	                this.props.error ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "label",
	                        { className: "validation-error" },
	                        (0, _translate.translate)(this.props.error)
	                    )
	                ) : undefined
	            );
	        }
	    }]);
	
	    return LoginInput;
	}(_react2.default.Component);
	
	exports.default = LoginInput;
	;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	var _LoginInputField = __webpack_require__(826);
	
	var _LoginInputField2 = _interopRequireDefault(_LoginInputField);
	
	var _utils = __webpack_require__(485);
	
	var _constants = __webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginChangePassword = function (_React$Component) {
	    _inherits(LoginChangePassword, _React$Component);
	
	    function LoginChangePassword() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LoginChangePassword);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginChangePassword.__proto__ || Object.getPrototypeOf(LoginChangePassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            password: '',
	            newPassword: '',
	            retypedPassword: ''
	        }, _this.handleFieldChange = function (isValid, fieldName, value, errorFieldName, error) {
	            var invalid = void 0;
	            if (!isValid) {
	                invalid = error;
	            } else {
	                invalid = undefined;
	            }
	            _this.state[errorFieldName] = invalid;
	            if (value !== undefined) {
	                _this.state[fieldName] = value;
	            }
	            _this.setState(_this.state);
	        }, _this.handleChangePassword = function (value) {
	            _this.setState({ password: value });
	        }, _this.handleChangeNewPassword = function (value) {
	            _this.setState({ newPassword: value });
	        }, _this.handleChangeRetypedPassword = function (value) {
	            _this.setState({ retypedPassword: value });
	        }, _this.validateInputs = function () {
	            var isValid = true;
	            var errorMessage = '';
	            var password = _this.state.password;
	            if ((0, _utils.isEmptyString)(password)) {
	                isValid = false;
	                errorMessage = 'Please enter your old password';
	            }
	            _this.handleFieldChange(isValid, "password", password, "invalidPassword", errorMessage);
	            var newPassword = _this.state.newPassword;
	            if ((0, _utils.isEmptyString)(newPassword)) {
	                isValid = false;
	                errorMessage = 'Please enter your new password';
	            } else if (newPassword.length < 6) {
	                isValid = false;
	                errorMessage = 'Your password must be at least 6 characters long';
	            } else if (newPassword === _this.state.password) {
	                isValid = false;
	                errorMessage = 'You cannot use your old password';
	            }
	            _this.handleFieldChange(isValid, "newPassword", newPassword, "invalidNewPassword", errorMessage);
	            var retypedPassword = _this.state.retypedPassword;
	            var newPasswordValidation = retypedPassword === newPassword;
	            if ((0, _utils.isEmptyString)(retypedPassword)) {
	                newPasswordValidation = false;
	                errorMessage = 'Please retype new password';
	                _this.handleFieldChange(newPasswordValidation, 'retypedPassword', retypedPassword, 'invalidRetypedPassword', errorMessage);
	            } else {
	                _this.handleFieldChange(newPasswordValidation, 'retypedPassword', retypedPassword, 'invalidRetypedPassword', 'The password does not match');
	            }
	            return isValid && newPasswordValidation;
	        }, _this.changeClicked = function () {
	            if (_this.validateInputs()) {
	                _this.props.changePassword(_this.props.email, _this.state.password, _this.state.newPassword, true);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LoginChangePassword, [{
	        key: "render",
	        value: function render() {
	            var className = "border-container";
	            if (_constants.URLs.JOIN === this.props.flowType) {
	                className += " border-container-join";
	            }
	            return _react2.default.createElement(
	                "div",
	                { className: className },
	                _react2.default.createElement(
	                    "fieldset",
	                    { className: "inner-container reset-password-container", disabled: this.props.showLoading },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "change-password-title" },
	                        (0, _translate.translate)('Your password is a temporary one. Please change your password now.')
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "form-container container-fluid" },
	                        _react2.default.createElement(_LoginInputField2.default, { id: "oldPassword", type: "password", value: this.state.password, label: "password", placeholder: "Old Password",
	                            error: this.state.invalidPassword, update: this.handleChangePassword, ref: "password", fieldName: "password" }),
	                        _react2.default.createElement(_LoginInputField2.default, { id: "newPassword", type: "password", value: this.state.newPassword, label: "password", placeholder: "New Password",
	                            error: this.state.invalidNewPassword, update: this.handleChangeNewPassword, ref: "newPassword", fieldName: "newPassword" }),
	                        _react2.default.createElement(_LoginInputField2.default, { id: "passwordAgain", type: "password", value: this.state.retypedPassword, label: "password", placeholder: "Password Again",
	                            error: this.state.invalidRetypedPassword, update: this.handleChangeRetypedPassword, ref: "retypedPassword", fieldName: "retypedPassword" }),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: "email-log-in" },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { bsStyle: "primary", className: "button email-login-button" + (this.props.showLoading ? " loading" : ""), id: "btnChange", onClick: this.changeClicked },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "btn-email-text" },
	                                    (0, _translate.translate)('Change')
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LoginChangePassword;
	}(_react2.default.Component);
	
	exports.default = LoginChangePassword;

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _utils = __webpack_require__(485);
	
	var _basket = __webpack_require__(757);
	
	var _paymentActions = __webpack_require__(754);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _constants = __webpack_require__(463);
	
	var _paymentDetailsForm = __webpack_require__(830);
	
	var _paymentDetailsForm2 = _interopRequireDefault(_paymentDetailsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EcheckForm = function (_React$Component) {
	    _inherits(EcheckForm, _React$Component);
	
	    function EcheckForm(props, context) {
	        _classCallCheck(this, EcheckForm);
	
	        var _this = _possibleConstructorReturn(this, (EcheckForm.__proto__ || Object.getPrototypeOf(EcheckForm)).call(this, props, context));
	
	        _this.getTodayStr = function () {
	            var date = new Date();
	            var dateArr = date.toDateString().split(" ");
	            var today = dateArr[1] + " " + dateArr[2] + "," + dateArr[3];
	            return today;
	        };
	
	        _this.checkBankAccount = function () {
	            var reg = /^[0-9]{3,17}$/;
	            var res = reg.test(_this.state.bankAccountNo);
	            _this.setState({ "isValidBankAccountNo": res });
	            return res;
	        };
	
	        _this.checkBankRoutingNumber = function () {
	            var reg = /^[0-9]{9}$/;
	            var res = reg.test(_this.state.bankRoutingNumber);
	            _this.setState({ "isValidBankRoutingNumber": res });
	            return res;
	        };
	
	        _this.checkSSN = function () {
	            var reg = /^[0-9]{4}$/;
	            var res = reg.test(_this.state.ssn);
	            _this.setState({ "isValidSsn": res });
	            return res;
	        };
	
	        _this.checkName = function () {
	            var reg = /^[A-Za-z ]+$/;
	            var resFirstName = _this.state.firstName && reg.test(_this.state.firstName);
	            var resLastName = _this.state.lastName && reg.test(_this.state.lastName);
	            _this.setState({ "isValidFirstName": resFirstName });
	            _this.setState({ "isValidLastName": resLastName });
	            return resFirstName && resLastName;
	        };
	
	        _this.isValidForm = function () {
	            var res1 = _this.checkBankAccount();
	            var res2 = _this.checkBankRoutingNumber();
	            var res3 = _this.checkSSN();
	            var res4 = _this.checkName();
	            return res1 && res2 && res3 && res4;
	        };
	
	        _this.onSubmitClick = function () {
	            if (_this.isValidForm()) {
	                var echeckInfo = {
	                    farmKey: _this.props.serverStaticData.farmKey,
	                    memberKey: _this.props.memberDetails.key,
	                    subscriptionKey: _this.props.subscriptionKey,
	                    postActionKeyString: _this.props.postActionKey,
	                    name: _this.state.firstName + " " + _this.state.lastName,
	                    bankRoutingNumber: _this.state.bankRoutingNumber,
	                    bankAccountNo: _this.state.bankAccountNo,
	                    refNumber: 0,
	                    ssn: _this.state.ssn,
	                    time: 0
	                };
	                _this.props.submitEcheck(echeckInfo, _this.props.serverStaticData.isChargeOnDelivery, _this.props.pageContext);
	            }
	        };
	
	        _this.onBackClick = function () {
	            _this.props.onBackClick();
	        };
	
	        _this.updateValueToState = function (event) {
	            var newState = {};
	            newState[event.target.id] = event.target.value;
	            _this.setState(newState);
	        };
	
	        _this.openBankNumberHelp = function () {
	            _this.setState({ showBankNumberModal: true });
	        };
	
	        _this.openBankRoutingHelp = function () {
	            _this.setState({ showBankRoutingModal: true });
	        };
	
	        _this.onCloseClick = function () {
	            _this.setState({ showBankNumberModal: false, showBankRoutingModal: false });
	        };
	
	        _this.getHelpModals = function () {
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    { show: _this.state.showBankNumberModal, className: "form-modal", onHide: _this.onCloseClick },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { onClick: _this.onCloseClick },
	                        _react2.default.createElement("img", { className: "close-icon", src: "/site/store/react/src/images/close.svg" })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement("img", { src: "/site/store/images/account-number-help.png", className: "gwt-Image" })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    { show: _this.state.showBankRoutingModal, className: "form-modal", onHide: _this.onCloseClick },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { onClick: _this.onCloseClick },
	                        _react2.default.createElement("img", { className: "close-icon", src: "/site/store/react/src/images/close.svg" })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement("img", { src: "/site/store/images/routing-number-help.png", className: "gwt-Image" })
	                    )
	                )
	            );
	        };
	
	        var params = (0, _utils.getUrlParams)();
	
	        _this.state = {
	            firstName: props.memberDetails.firstName || params.firstName,
	            lastName: props.memberDetails.lastName || params.lastName,
	            isValidBankAccountNo: true,
	            isValidBankRoutingNumber: true,
	            isValidSsn: true,
	            isValidFirstName: true,
	            isValidLastName: true,
	            today: _this.getTodayStr(),
	            showBankNumberModal: false,
	            showBankRoutingModal: false
	        };
	        return _this;
	    }
	
	    _createClass(EcheckForm, [{
	        key: "render",
	        value: function render() {
	            var farmName = this.props.serverStaticData.farmName;
	            var amount = this.props.total;
	            var farmPhone = this.props.serverStaticData.farmPhone;
	            var farmEmail = this.props.serverStaticData.farmEmail;
	            var submitLoadingClass = this.props.showLoading ? " loading" : "";
	            var submitClasses = "submit-order button" + submitLoadingClass;
	            return _react2.default.createElement(
	                "div",
	                { className: "form _lr-hide" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "title" },
	                    _react2.default.createElement("i", { className: "back-sign-in-arrow hidden-sm hidden-md hidden-lg", onClick: this.onBackClick, disabled: this.props.showLoading }),
	                    _react2.default.createElement(
	                        "h1",
	                        null,
	                        "Electronic Check Payment"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "buttons" },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { bsStyle: "primary", className: "back button hidden-xs", onClick: this.onBackClick, disabled: this.props.showLoading },
	                            "Back"
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { bsStyle: "primary", className: submitClasses + " hidden-xs", onClick: this.onSubmitClick, disabled: this.props.showLoading },
	                            "Submit"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h5",
	                    null,
	                    "Please enter your bank account details you use for this payment"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "border-container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "inner-container" },
	                        _react2.default.createElement(
	                            "fieldset",
	                            { disabled: this.props.showLoading, className: "form-container container-fluid" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "inner-form" },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Form,
	                                    { horizontal: true },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.FormGroup,
	                                        { validationState: !this.state.isValidFirstName ? "error" : null },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            "First Name"
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            _react2.default.createElement(_reactBootstrap.FormControl, { id: "firstName", type: "text", placeholder: "First Name", onChange: this.updateValueToState, value: this.state.firstName })
	                                        ),
	                                        !this.state.isValidFirstName ? _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.ControlLabel,
	                                                null,
	                                                "Please enter a valid name (Only alphabetic)"
	                                            )
	                                        ) : undefined
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.FormGroup,
	                                        { validationState: !this.state.isValidLastName ? "error" : null },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            "Last Name"
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            _react2.default.createElement(_reactBootstrap.FormControl, { id: "lastName", type: "text", placeholder: "Last Name", onChange: this.updateValueToState, value: this.state.lastName })
	                                        ),
	                                        !this.state.isValidLastName ? _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.ControlLabel,
	                                                null,
	                                                "Please enter a valid last name (Only alphabetic)"
	                                            )
	                                        ) : undefined
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.FormGroup,
	                                        { validationState: !this.state.isValidBankAccountNo ? "error" : null },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            "Bank Account Number"
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3, className: "bank-field" },
	                                            _react2.default.createElement(_reactBootstrap.FormControl, { id: "bankAccountNo", type: "text", onChange: this.updateValueToState, className: "_lr-hide" }),
	                                            _react2.default.createElement("img", { onClick: this.openBankNumberHelp, className: "help-icon", src: "/site/store/react/src/images/echeck_info.svg" })
	                                        ),
	                                        !this.state.isValidBankAccountNo ? _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.ControlLabel,
	                                                null,
	                                                "Please enter a valid bank account number (only digits)"
	                                            )
	                                        ) : undefined
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.FormGroup,
	                                        { validationState: !this.state.isValidBankRoutingNumber ? "error" : null },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            "Bank Routing Number"
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3, className: "bank-field" },
	                                            _react2.default.createElement(_reactBootstrap.FormControl, { id: "bankRoutingNumber", type: "text", onChange: this.updateValueToState, className: "_lr-hide" }),
	                                            _react2.default.createElement("img", { onClick: this.openBankRoutingHelp, className: "help-icon", src: "/site/store/react/src/images/echeck_info.svg" })
	                                        ),
	                                        !this.state.isValidBankRoutingNumber ? _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.ControlLabel,
	                                                null,
	                                                "Please enter a valid bank routing number (9 digits)"
	                                            )
	                                        ) : undefined
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.FormGroup,
	                                        { validationState: !this.state.isValidSsn ? "error" : null },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            "Last 4 digits of Social Security Number"
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            _react2.default.createElement(_reactBootstrap.FormControl, { id: "ssn", type: "text", onChange: this.updateValueToState, className: "_lr-hide" })
	                                        ),
	                                        !this.state.isValidSsn ? _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.ControlLabel,
	                                                null,
	                                                "Please enter the last 4 digits of the bank holder's social security number"
	                                            )
	                                        ) : undefined
	                                    )
	                                ),
	                                amount !== '$0.00' ? _react2.default.createElement(
	                                    "div",
	                                    { className: "description" },
	                                    _react2.default.createElement(
	                                        "p",
	                                        null,
	                                        "I authorize ",
	                                        farmName,
	                                        " to initiate (debit/credit) entries to the above listed bank account in the amount of ",
	                                        amount,
	                                        " on or after ",
	                                        this.state.today,
	                                        "."
	                                    ),
	                                    _react2.default.createElement(
	                                        "p",
	                                        null,
	                                        "If you have questions and/or need to revoke this authorization, please contact us at ",
	                                        farmPhone,
	                                        " or by email ",
	                                        farmEmail,
	                                        "."
	                                    )
	                                ) : undefined
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "bottom-container" },
	                            _react2.default.createElement(
	                                "a",
	                                { href: "https://en.wikipedia.org/wiki/Payment_Card_Industry_Data_Security_Standard", target: "_blank" },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "bottom-title" },
	                                    "Storage of your billing information is 100% PCI compliant"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { bsStyle: "primary", className: submitClasses + " visible-xs", onClick: this.onSubmitClick, disabled: this.props.showLoading },
	                                "Submit"
	                            )
	                        )
	                    )
	                ),
	                this.getHelpModals()
	            );
	        }
	    }]);
	
	    return EcheckForm;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    var checkout = state.checkout || {};
	    var returnObject = {
	        showLoading: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT),
	        serverStaticData: state.staticData,
	        subscriptionKey: state.summary.key,
	        orderKey: state.orderStatus.orderKey,
	        postActionKey: checkout.postActionKey,
	        memberDetails: state.memberDetails || {}
	    };
	    if (ownProps.pageContext === _constants.URLs.JOIN) {
	        var signupData = state.signupData;
	        var summary = state.summary;
	        var pickupSite = summary.pickupSite || {};
	        var selectedData = signupData.selectedData || {};
	        var selectedItems = (0, _basket.getJoinSelectedItems)(signupData.sharesData.shares, signupData.sharesData.options);
	        var itemsRemainingDates = (0, _basket.getAllItemsRemainingDeliveryDates)(selectedItems.items, signupData.sharesData.remainingScheduleDates);
	        var nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
	        var schedules = signupData.schedules || {};
	        var nextDeliveryDate = (0, _basket.getNextDeliveryDate)(pickupSite, selectedItems.items, schedules, nextDeliveryDates);
	        var totals = (0, _basket.calcTotals)(signupData.data.isFarmSeasonal, pickupSite, selectedItems.items, selectedData.selectedPaymentPlan, selectedData.coupon, itemsRemainingDates, signupData.sharesData.remainingScheduleDates, nextDeliveryDate, signupData.isAddSubscription, summary.discount, state.staticData).totals;
	        var totalDue = totals.find(function (total) {
	            return total.type === "TOTAL_DUE";
	        });
	        returnObject.total = totalDue.amount;
	    } else if (ownProps.pageContext === _constants.URLs.PAY) {
	        returnObject.total = ownProps.totalToPay === 0 ? (0, _basket.formatMoney)(ownProps.amount) : (0, _basket.formatMoney)(ownProps.totalToPay);
	    } else {
	        returnObject.total = (0, _basket.formatMoney)((state.orderStatus.totals.editableTotal || {}).fullPrice);
	    }
	    return returnObject;
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        submitEcheck: function submitEcheck(echeckInfo, isChargeOnDelivery, pageContext) {
	            dispatch((0, _paymentActions.submitEcheck)(echeckInfo, isChargeOnDelivery, pageContext));
	        },
	        onBackClick: function onBackClick() {
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.removePath)('/echeck')));
	        }
	    };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EcheckForm);

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _utils = __webpack_require__(485);
	
	var _paymentActions = __webpack_require__(754);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _commonActions = __webpack_require__(747);
	
	var _basket = __webpack_require__(757);
	
	var _constants = __webpack_require__(463);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _paymentDetailsForm = __webpack_require__(830);
	
	var _paymentDetailsForm2 = _interopRequireDefault(_paymentDetailsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EBTForm = function (_React$Component) {
	    _inherits(EBTForm, _React$Component);
	
	    function EBTForm(props, context) {
	        _classCallCheck(this, EBTForm);
	
	        var _this = _possibleConstructorReturn(this, (EBTForm.__proto__ || Object.getPrototypeOf(EBTForm)).call(this, props, context));
	
	        _this.checkName = function () {
	            var reg = /^[A-Za-z ]+$/;
	            var resFirstName = _this.state.firstName && reg.test(_this.state.firstName);
	            var resLastName = _this.state.lastName && reg.test(_this.state.lastName);
	            _this.setState({ "isValidFirstName": resFirstName });
	            _this.setState({ "isValidLastName": resLastName });
	            return resFirstName && resLastName;
	        };
	
	        _this.checkCardNumber = function () {
	            var reg = /^[0-9]{16}$|^[0-9]{19}$/;
	            var res = reg.test(_this.state.cardNumber);
	            _this.setState({ "isValidCardNumber": res });
	            return res;
	        };
	
	        _this.checkPartialAmount = function () {
	            if (_this.state.fullAmount) {
	                _this.setState({ "partialAmountValidationMessage": null });
	                return true;
	            }
	            var partialAmount = parseFloat(_this.state.partialAmount);
	            if (isNaN(partialAmount)) {
	                _this.setState({ "partialAmountValidationMessage": 'Please enter an amount' });
	                return false;
	            }
	            if (partialAmount > _this.props.total) {
	                _this.setState({ "partialAmountValidationMessage": 'Please enter an amount smaller than $' + _this.props.total });
	                return false;
	            }
	            return true;
	        };
	
	        _this.isValidForm = function () {
	            var res1 = _this.checkName();
	            var res2 = _this.checkCardNumber();
	            var res3 = _this.checkPartialAmount();
	            return res1 && res2 && res3;
	        };
	
	        _this.onSubmitClick = function () {
	            if (_this.isValidForm()) {
	                var ebtInfo = {
	                    farmKey: _this.props.serverStaticData.farmKey,
	                    memberKey: _this.props.memberDetails.key,
	                    subscriptionKey: _this.props.subscriptionKey,
	                    postActionKey: _this.props.postActionKey,
	                    cardNumber: _this.state.cardNumber,
	                    firstName: _this.state.firstName,
	                    lastName: _this.state.lastName,
	                    amount: _this.state.fullAmount ? _this.props.total : Number(_this.state.partialAmount),
	                    totalAmount: _this.props.total + _this.props.feeAmount
	                };
	                _this.props.initEBT(ebtInfo, _this.props.pageContext);
	            }
	        };
	
	        _this.onCheckBalanceClick = function () {
	            if (_this.isValidForm()) {
	                var ebtInfo = {
	                    farmKey: _this.props.serverStaticData.farmKey,
	                    memberKey: _this.props.memberDetails.key,
	                    subscriptionKey: _this.props.subscriptionKey,
	                    postActionKey: _this.props.postActionKey,
	                    cardNumber: _this.state.cardNumber,
	                    firstName: _this.state.firstName,
	                    lastName: _this.state.lastName,
	                    amount: 0
	                };
	                _this.props.initEBT(ebtInfo, 'BALANCE');
	            }
	        };
	
	        _this.onBackClick = function () {
	            //workaround for back
	            document.getElementById('cardNumber').value = '';
	            _this.props.onBackClick();
	        };
	
	        _this.updateValueToState = function (event) {
	            var newState = {};
	            newState[event.target.id] = event.target.value;
	            _this.setState(newState);
	        };
	
	        _this.handleAmountSelectorChange = function (event) {
	            if (event.target.value === 'on') {
	                _this.setState({ fullAmount: event.target.id === 'amountFullSelection' });
	            }
	        };
	
	        _this.handlePartialAmountChange = function (event) {
	            var amount = event.target.value;
	            if (!/^\d+(?:[.]\d*?)?$/.test(amount) && amount !== "") {
	                return;
	            }
	            if (amount === '0') {
	                amount = '';
	            }
	            _this.setState({ partialAmount: amount });
	        };
	
	        _this.isError = function () {
	            return _this.props.errorMessage && !_this.state.dismissErrorMessage;
	        };
	
	        _this.showErrorMessage = function () {
	            var buttonText = "Close";
	            var errorMessage = decodeURIComponent(_this.props.errorMessage).replace(/\+/g, ' ');
	            return _react2.default.createElement(_ModalPopup2.default, {
	                message: errorMessage,
	                middle: { text: buttonText, callback: function callback() {
	                        return _this.setState({ dismissErrorMessage: true });
	                    } } });
	        };
	
	        var params = (0, _utils.getUrlParams)();
	        _this.state = {
	            firstName: props.memberDetails.firstName || params.firstName,
	            lastName: props.memberDetails.lastName || params.lastName,
	            cardNumber: '',
	            isValidFirstName: true,
	            isValidLastName: true,
	            isValidCardNumber: true,
	            partialAmountValidationMessage: null,
	            dismissErrorMessage: false,
	            fullAmount: true,
	            partialAmount: ''
	        };
	        return _this;
	    }
	
	    _createClass(EBTForm, [{
	        key: "render",
	        value: function render() {
	            var submitLoadingClass = this.props.showLoading ? " loading" : "";
	            var submitClasses = "submit-order button" + submitLoadingClass;
	            return _react2.default.createElement(
	                "div",
	                { className: "form _lr-hide" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "title" },
	                    _react2.default.createElement("i", { className: "back-sign-in-arrow hidden-sm hidden-md hidden-lg", onClick: this.onBackClick, disabled: this.props.showLoading }),
	                    _react2.default.createElement(
	                        "h1",
	                        null,
	                        "EBT Online"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "buttons" },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { bsStyle: "primary", className: "back button hidden-xs", onClick: this.onBackClick, disabled: this.props.showLoading },
	                            "Back"
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { bsStyle: "primary", className: submitClasses + " hidden-xs", onClick: this.onSubmitClick, disabled: this.props.showLoading || this.isError() },
	                            "Submit"
	                        )
	                    )
	                ),
	                this.isError() && this.showErrorMessage(),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "h5",
	                        null,
	                        "Please enter your EBT card number you use for this payment. Then you will be redirected to Fiserv PIN pad to enter your PIN."
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "border-container" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "inner-container" },
	                            _react2.default.createElement(
	                                "fieldset",
	                                { disabled: this.props.showLoading, className: "form-container container-fluid" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "inner-form" },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Form,
	                                        { horizontal: true },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.FormGroup,
	                                            { validationState: !this.state.isValidFirstName ? "error" : null },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                "First Name"
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(_reactBootstrap.FormControl, { id: "firstName", type: "text", placeholder: "First Name", onChange: this.updateValueToState, value: this.state.firstName })
	                                            ),
	                                            !this.state.isValidFirstName ? _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.ControlLabel,
	                                                    null,
	                                                    "Please enter a valid name (Only alphabetic)"
	                                                )
	                                            ) : undefined
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.FormGroup,
	                                            { validationState: !this.state.isValidLastName ? "error" : null },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                "Last Name"
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(_reactBootstrap.FormControl, { id: "lastName", type: "text", placeholder: "Last Name", onChange: this.updateValueToState, value: this.state.lastName })
	                                            ),
	                                            !this.state.isValidLastName ? _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.ControlLabel,
	                                                    null,
	                                                    "Please enter a valid last name (Only alphabetic)"
	                                                )
	                                            ) : undefined
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.FormGroup,
	                                            { validationState: !this.state.isValidCardNumber ? "error" : null },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                "Card Number"
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3, className: "card-number" },
	                                                _react2.default.createElement(_reactBootstrap.FormControl, { id: "cardNumber", type: "text", onChange: this.updateValueToState, className: "_lr-hide" })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2 },
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Button,
	                                                    { bsStyle: "primary", className: "submit-order button", onClick: this.onCheckBalanceClick },
	                                                    "Check Balance"
	                                                )
	                                            ),
	                                            !this.state.isValidCardNumber ? _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 4 },
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.ControlLabel,
	                                                    null,
	                                                    "Please enter a valid EBT card number (16 or 19 digits)"
	                                                )
	                                            ) : undefined
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.FormGroup,
	                                            { validationState: this.state.partialAmountValidationMessage ? "error" : null },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                "Amount to pay"
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Radio,
	                                                    { name: "amountFullSelection", id: "amountFullSelection", checked: this.state.fullAmount, onChange: this.handlePartialAmountChange, className: "amount-full-radio" },
	                                                    _react2.default.createElement(
	                                                        "div",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            "div",
	                                                            { className: "payment-amount-description" },
	                                                            "Pay full amount of ",
	                                                            (0, _basket.formatMoney)(this.props.total),
	                                                            " using SNAP EBT"
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Radio,
	                                                    { name: "amountPartialSelection", id: "amountPartialSelection", checked: !this.state.fullAmount, onChange: this.handleAmountSelectorChange, className: "amount-partial-radio" },
	                                                    _react2.default.createElement(
	                                                        "div",
	                                                        { className: "amount-partial-div" },
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { md: 4, xs: 7 },
	                                                            _react2.default.createElement(
	                                                                "div",
	                                                                { className: "payment-amount-description amount-partial-text" },
	                                                                "Pay only partial amount using SNAP EBT"
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { md: 2, xs: 5 },
	                                                            " ",
	                                                            _react2.default.createElement("input", { id: "partialAmount", type: "text", className: "payment-amount-input amount-partial-input", disabled: this.state.fullAmount,
	                                                                placeholder: "Enter Amount", onChange: this.handlePartialAmountChange, value: this.state.partialAmount })
	                                                        ),
	                                                        this.state.partialAmountValidationMessage && _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { md: 6, xs: 12 },
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.ControlLabel,
	                                                                { className: "amount-partial-error" },
	                                                                this.state.partialAmountValidationMessage
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "payment-amount-description amount-partial-note" },
	                                                    "You must pay the remainder of the order by contacting ",
	                                                    this.props.serverStaticData.farmName,
	                                                    " or from your member account. Please be advised that only fully paid orders will be processed."
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "bottom-container" },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { bsStyle: "primary", className: submitClasses + " visible-xs", onClick: this.onSubmitClick, disabled: this.props.showLoading },
	                                    "Submit"
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EBTForm;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    var checkout = state.checkout || {};
	    var returnObject = {
	        showLoading: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT),
	        serverStaticData: state.staticData,
	        subscriptionKey: state.summary.key,
	        orderKey: state.orderStatus.orderKey,
	        postActionKey: checkout.postActionKey,
	        memberDetails: state.memberDetails || {},
	        errorMessage: (state.staticData.params || {}).error
	    };
	    if (ownProps.pageContext === _constants.URLs.JOIN || ownProps.pageContext === _constants.URLs.STORE) {
	        var summary = state.summary;
	        var customAmount = summary.customAmount.split("|");
	        returnObject.total = parseFloat(customAmount[0]);
	        returnObject.feeAmount = customAmount.length > 1 ? parseFloat(customAmount[1]) : 0;
	    } else if (ownProps.pageContext === _constants.URLs.PAY) {
	        returnObject.total = ownProps.totalToPay && ownProps.totalToPay > 0 ? ownProps.totalToPay : ownProps.amount;
	    } else {
	        returnObject.total = (state.orderStatus.totals.editableTotal || {}).fullPrice;
	    }
	    return returnObject;
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        initEBT: function initEBT(ebtInfo, pageContext) {
	            dispatch((0, _commonActions.clearHiddenUrlParams)());
	            dispatch((0, _paymentActions.initEBT)(ebtInfo, pageContext));
	        },
	        onBackClick: function onBackClick() {
	            dispatch((0, _commonActions.clearHiddenUrlParams)());
	            dispatch((0, _reactRouterRedux.replace)((0, _utils.removePath)('/ebt')));
	        }
	    };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EBTForm);

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(463);
	
	var _MessagePage = __webpack_require__(815);
	
	var _MessagePage2 = _interopRequireDefault(_MessagePage);
	
	var _utils = __webpack_require__(485);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThankYouPage = function (_React$Component) {
	    _inherits(ThankYouPage, _React$Component);
	
	    function ThankYouPage() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ThankYouPage);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThankYouPage.__proto__ || Object.getPrototypeOf(ThankYouPage)).call.apply(_ref, [this].concat(args))), _this), _this.getThankYouMessage = function () {
	            var messageTitle = '';
	            var messageBody = '';
	            if (_this.props.isWaitListOnly) {
	                messageTitle = (0, _translate.translate)('_thankYouSignUpWaitlistTitle');
	                messageBody = (0, _translate.translate)('_thankYouSignUpWaitlistBody');
	            } else if ((0, _utils.getUrlParams)().transaction === 'declined') {
	                //Transaction was declined
	                messageTitle = (0, _translate.translate)('_thankYouDeclinedTitle');
	                messageBody = (0, _translate.translate)('_thankYouDeclinedBody');
	            } else if (_this.props.pageContext === _constants.URLs.STORE) {
	                //Store
	                if ((_this.props.extraMessage || '').includes('_PAY_SINGLE_LINK_')) {
	                    messageTitle = 'Order partially paid';
	                    messageBody = '';
	                } else {
	                    messageTitle = (0, _translate.translate)('_thankYouTitle');
	                    messageBody = (0, _translate.translate)('_thankYouBody');
	                }
	            } else if (_this.props.pageContext === _constants.URLs.PAY && _this.props.mode !== _constants.PaymentTypes.SINGLE_PAYMENT.type) {
	                //Update payment details
	                messageTitle = (0, _translate.translate)('_thankYouUpdatePaymentDetailsTitle');
	                messageBody = (0, _translate.translate)('_thankYouUpdatePaymentDetailsBody');
	            } else if (_this.props.pageContext === _constants.URLs.PAY) {
	                //Make Payment
	                messageTitle = (0, _translate.translate)('_thankYouPaymentTitle');
	                messageBody = (0, _translate.translate)('_thankYouPaymentBody');
	            } else if (_this.props.pageContext === _constants.URLs.CHARGE && _this.props.mode === _constants.PaymentTypes.PAYMENT_TOKEN.type) {
	                //Admin: Update payment details
	                messageTitle = (0, _translate.translate)("_thankYouUpdatePaymentDetailsTitle");
	                messageBody = (0, _translate.translate)('_paymentSuccessfullyUpdated');
	            } else if (_this.props.pageContext === _constants.URLs.CHARGE && _this.props.mode === _constants.PaymentTypes.PAYMENT_PLAN.type) {
	                //Admin: Update payment plan
	                messageTitle = (0, _translate.translate)('Update Payment Plan');
	                messageBody = (0, _translate.translate)('_planSuccessfullyUpdated');
	            } else if (_this.props.pageContext === _constants.URLs.CHARGE) {
	                //Admin: Charge member
	                messageTitle = (0, _translate.translate)('Charge Member');
	                messageBody = (0, _translate.translate)('_successfullyCharged');
	            } else if (_this.props.pageContext === _constants.URLs.JOIN && _this.props.mode === _constants.JoinModes.ADD) {
	                //Add Subscription
	                messageTitle = (0, _translate.translate)('_thankYouChangeSubscriptionTitle');
	                messageBody = (0, _translate.translate)('_thankYouChangeSubscriptionBody');
	            } else if (_this.props.pageContext === _constants.URLs.JOIN) {
	                //Signup
	                messageTitle = (0, _translate.translate)('_thankYouSignUpTitle');
	                messageBody = (_this.props.extraMessage || '').includes('_PAY_SINGLE_LINK_') ? '' : (0, _translate.translate)('_thankYouSignUpBody');
	                if (_this.props.staticData && _this.props.staticData.joinThankYouMessageLinkToStore) {
	                    var path = '/' + _constants.URLs.STORE + '/' + _this.props.farmUrl;
	                    messageBody += "<br><br><a class='no-subscription-join-button' href=" + path + "><button class='button btn btn-primary'>Add one time orders</button></a>";
	                }
	            }
	            if (_this.props.pageContext === _constants.URLs.CHARGE) messageBody += "<br>" + (0, _translate.translate)("_refreshTheDashboard");
	
	            //If sold out
	            if (_this.props.thankYouMessage) {
	                messageBody += '<br>' + (0, _translate.translate)(_this.props.thankYouMessage);
	            }
	            return {
	                messageTitle: messageTitle,
	                messageBody: messageBody,
	                messageExtra: (_this.props.extraMessage || '').replace("_PAY_SINGLE_LINK_", 'class="link-action" target="_blank" href="' + "/" + _constants.URLs.PAY + "/" + _this.props.farmUrl + "/" + _this.props.seasonUrl + '/?source=account&type=single"')
	            };
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ThankYouPage, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            if (this.props.pageContext === _constants.URLs.JOIN && this.props.mode === _constants.JoinModes.NEW && this.props.customConfirmationScript && (0, _utils.getUrlParams)().transaction !== 'declined') {
	                var initialScript = "";
	                if (this.props.amountText) {
	                    initialScript = 'var amount = "' + this.props.amountText + '"; ';
	                }
	                var script = document.createElement('script');
	                script.type = 'text/javascript';
	                script.async = true;
	                script.innerHTML = initialScript + this.props.customConfirmationScript;
	                document.body.appendChild(script);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var messageData = this.getThankYouMessage();
	            var backUrl = undefined;
	            var backText = '';
	            if (this.props.pageContext === _constants.URLs.STORE) {
	                backUrl = "/" + _constants.URLs.STORE + "/" + this.props.farmUrl;
	                backText = (0, _translate.translate)('Back to Store');
	            } else if (this.props.pageContext === _constants.URLs.PAY) {
	                backUrl = "/" + _constants.URLs.ACCOUNT + "/" + this.props.farmUrl + "/" + this.props.seasonUrl;
	                backText = (0, _translate.translate)('Back to Account');
	            }
	
	            return _react2.default.createElement(_MessagePage2.default, {
	                messageData: messageData,
	                memberKey: this.props.pageContext === _constants.URLs.CHARGE ? undefined : this.props.memberKey,
	                link: this.props.pageContext === _constants.URLs.CHARGE ? {} : { text: backText, url: backUrl } });
	        }
	    }]);
	
	    return ThankYouPage;
	}(_react2.default.Component);
	
	exports.default = ThankYouPage;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _constants = __webpack_require__(463);
	
	var _commonActions = __webpack_require__(747);
	
	var _storeCheckoutActions = __webpack_require__(756);
	
	var _joinPayActions = __webpack_require__(753);
	
	var _paymentActions = __webpack_require__(754);
	
	var _LoadingAnimation = __webpack_require__(834);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _payments = __webpack_require__(836);
	
	var _payments2 = _interopRequireDefault(_payments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (!window.HostCommunicator) window.HostCommunicator = {};
	
	var PaymentsHost = function (_React$Component) {
	    _inherits(PaymentsHost, _React$Component);
	
	    function PaymentsHost() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PaymentsHost);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentsHost.__proto__ || Object.getPrototypeOf(PaymentsHost)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showLoading: 'Loading'
	        }, _this.__parseQueryString = function (str) {
	            var vars = [];
	            var arr = str.split('&');
	            var pair = void 0;
	            for (var i = 0; i < arr.length; i++) {
	                pair = arr[i].split('=');
	                vars.push(pair[0]);
	                vars[pair[0]] = unescape(pair[1]);
	            }
	            return vars;
	        }, _this.resizeIFrame = function (iframe, height, width) {
	            iframe.style.height = height.toString() + "px";
	            iframe.style.width = width.toString() + "px";
	            iframe.style.visibility = 'visible';
	            _this.setState({ showLoading: undefined });
	        }, _this.onPaymentDetailsCanceled = function () {
	            if (_this.props.pageContext === _constants.URLs.CHARGE) {
	                _this.props.closeWindow();
	            } else {
	                window.history.back();
	            }
	        }, _this.onPaymentDone = function (amount, responseCode, txId) {
	            _this.setState({ showLoading: "Please don't close the browser. Processing" });
	            document.getElementById("paymentsHostIFrame").style.visibility = 'hidden';
	            var flow = _this.props.pageContext === _constants.URLs.JOIN || _this.props.pageContext === _constants.URLs.PAY ? 'STANDARD' : _this.props.pageContext === _constants.URLs.STORE ? 'STORE_STANDARD' : _this.props.pageContext === _constants.URLs.CHARGE ? 'CHARGE_FROM_MEMBER_CARD' : '';
	            _this.props.processAuthorizeDotNetResponse(amount, responseCode, txId, flow);
	        }, _this.onPaymentDetailsSaved = function () {
	            _this.setState({ showLoading: "Please don't close the browser. Processing" });
	            document.getElementById("paymentsHostIFrame").style.visibility = 'hidden';
	            if (_this.props.pageContext === _constants.URLs.JOIN) {
	                _this.props.completeSubscription();
	            } else if (_this.props.pageContext === _constants.URLs.PAY || _this.props.pageContext === _constants.URLs.CHARGE) {
	                _this.props.checkAuthorizeDotNetTokenAndUpdatePayments();
	            } else if (_this.props.pageContext === _constants.URLs.STORE) {
	                _this.props.checkAuthorizeDotNetTokenAndSubmitOrder();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PaymentsHost, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            HostCommunicator.onReceiveCommunication = function (querystr) {
	                var params = this.__parseQueryString(querystr);
	                switch (params["action"]) {
	                    case "transactResponse":
	                        var response = JSON.parse(params['response']);
	                        this.onPaymentDone(response.totalAmount, response.responseCode, response.transId);
	                        break;
	                    case "successfulSave":
	                        this.onPaymentDetailsSaved();
	                        break;
	                    case "cancel":
	                        this.onPaymentDetailsCanceled();
	                        break;
	                    case "resizeWindow":
	                        var height = parseInt(params["height"]).toString();
	                        var width = parseInt(params["width"]).toString();
	                        var iframe = document.getElementById("paymentsHostIFrame");
	                        this.resizeIFrame(iframe, height, width);
	                        break;
	                }
	            }.bind(this);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                null,
	                this.state.showLoading ? _react2.default.createElement(_LoadingAnimation2.default, { message: this.state.showLoading }) : undefined,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement("iframe", { id: "paymentsHostIFrame", name: "paymentsHostIFrame", width: "100%", height: "100%", className: "payments-iframe-center" })
	                )
	            );
	        }
	    }]);
	
	    return PaymentsHost;
	}(_react2.default.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        completeSubscription: function completeSubscription() {
	            dispatch((0, _joinPayActions.completeSubscription)());
	        },
	        checkAuthorizeDotNetTokenAndUpdatePayments: function checkAuthorizeDotNetTokenAndUpdatePayments() {
	            dispatch((0, _paymentActions.checkAuthorizeDotNetTokenAndUpdatePayments)());
	        },
	        checkAuthorizeDotNetTokenAndSubmitOrder: function checkAuthorizeDotNetTokenAndSubmitOrder() {
	            dispatch((0, _storeCheckoutActions.checkAuthorizeDotNetTokenAndSubmitOrder)());
	        },
	        processAuthorizeDotNetResponse: function processAuthorizeDotNetResponse(amount, responseCode, txnId, flow) {
	            dispatch((0, _paymentActions.processAuthorizeDotNetResponse)(amount, responseCode, txnId, flow));
	        },
	        closeWindow: function closeWindow() {
	            dispatch((0, _commonActions.setDirty)(false));
	            window.close();
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(PaymentsHost);

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _translate = __webpack_require__(464);
	
	var _loadingAnimation = __webpack_require__(835);
	
	var _loadingAnimation2 = _interopRequireDefault(_loadingAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingAnimation = function (_React$Component) {
	    _inherits(LoadingAnimation, _React$Component);
	
	    function LoadingAnimation() {
	        _classCallCheck(this, LoadingAnimation);
	
	        return _possibleConstructorReturn(this, (LoadingAnimation.__proto__ || Object.getPrototypeOf(LoadingAnimation)).apply(this, arguments));
	    }
	
	    _createClass(LoadingAnimation, [{
	        key: "render",
	        value: function render() {
	            var message = this.props.message ? this.props.message : (0, _translate.translate)('Loading') + '...';
	            return _react2.default.createElement(
	                "div",
	                { className: "loading-animation-container" },
	                _react2.default.createElement("div", { className: "loading-animation" }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "loading-text" },
	                    message
	                )
	            );
	        }
	    }]);
	
	    return LoadingAnimation;
	}(_react2.default.Component);
	
	exports.default = LoadingAnimation;

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _utils = __webpack_require__(485);
	
	var _LoadingAnimation = __webpack_require__(834);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _joinActions = __webpack_require__(752);
	
	var _commonActions = __webpack_require__(747);
	
	var _JoinWizardSteps = __webpack_require__(838);
	
	var _JoinWizardSteps2 = _interopRequireDefault(_JoinWizardSteps);
	
	var _JoinNavigationButtons = __webpack_require__(839);
	
	var _JoinNavigationButtons2 = _interopRequireDefault(_JoinNavigationButtons);
	
	var _PickupSiteSelection = __webpack_require__(841);
	
	var _PickupSiteSelection2 = _interopRequireDefault(_PickupSiteSelection);
	
	var _JoinSharesOptionsStep = __webpack_require__(1075);
	
	var _JoinSharesOptionsStep2 = _interopRequireDefault(_JoinSharesOptionsStep);
	
	var _JoinTermsStep = __webpack_require__(1079);
	
	var _JoinTermsStep2 = _interopRequireDefault(_JoinTermsStep);
	
	var _JoinContactInfoStep = __webpack_require__(1083);
	
	var _JoinContactInfoStep2 = _interopRequireDefault(_JoinContactInfoStep);
	
	var _JoinPayStep = __webpack_require__(1091);
	
	var _JoinPayStep2 = _interopRequireDefault(_JoinPayStep);
	
	var _JoinSummary = __webpack_require__(1093);
	
	var _JoinSummary2 = _interopRequireDefault(_JoinSummary);
	
	var _PaymentsHost = __webpack_require__(833);
	
	var _PaymentsHost2 = _interopRequireDefault(_PaymentsHost);
	
	var _constants = __webpack_require__(463);
	
	var _staticDataActions = __webpack_require__(749);
	
	var _ThankYouPage = __webpack_require__(832);
	
	var _ThankYouPage2 = _interopRequireDefault(_ThankYouPage);
	
	var _EcheckForm = __webpack_require__(829);
	
	var _EcheckForm2 = _interopRequireDefault(_EcheckForm);
	
	var _EBTForm = __webpack_require__(831);
	
	var _EBTForm2 = _interopRequireDefault(_EBTForm);
	
	var _MessagePage = __webpack_require__(815);
	
	var _MessagePage2 = _interopRequireDefault(_MessagePage);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _memberDetailsActions = __webpack_require__(751);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _UserMenu = __webpack_require__(490);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	var _translate = __webpack_require__(464);
	
	var _joinHomeScreen = __webpack_require__(1102);
	
	var _joinHomeScreen2 = _interopRequireDefault(_joinHomeScreen);
	
	var _basket = __webpack_require__(757);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinHomeScreen = (0, _createReactClass2.default)({
	    displayName: "JoinHomeScreen",
	    getInitialState: function getInitialState() {
	        if (this.props.staticData.farmUrl)
	            //Module is already initialized
	            return {};
	        this.props.initServerStaticData();
	        var isGuestUser = this.isGuestUser();
	        if (!isGuestUser) {
	            this.props.initMemberData();
	        }
	        var isAddSubscription = this.isAddSubscription();
	
	        if (this.props.location.pathname.includes('/thankyou'))
	            //No need to load data
	            return {};
	
	        if (!isGuestUser) {
	            if (isAddSubscription) this.props.getAddSubscriptionData((0, _utils.getUrlParams)().s);else this.props.getSignupData(_constants.JoinModes.NEW);
	        }
	        return {};
	    },
	    isPastSeason: function isPastSeason() {
	        return window.Farmigo.serverData.isPastSeason;
	    },
	    isGuestUser: function isGuestUser() {
	        if ((0, _utils.getUrlParams)().mode === 'guest') {
	            this.props.initGuestUser();
	            this.props.gotoStep(_constants.JoinSteps.CONTACT_INFO);
	            if (this.isPastSeason()) {
	                this.props.setPastSeasonMessage();
	            }
	            return true;
	        }
	        return false;
	    },
	    componentWillMount: function componentWillMount() {
	        this.props.setAndRemoveUrlParams(true);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (!this.props.data && nextProps.data && !nextProps.isWaitListOnly && this.isPastSeason()) {
	            this.props.setPastSeasonMessage();
	        }
	    },
	    isAddSubscription: function isAddSubscription() {
	        return (0, _subscriptionSummaryActions.isAddSubscription)();
	    },
	    showSummaryModal: function showSummaryModal() {
	        this.setState({ showSummary: true });
	    },
	    closeSummaryModal: function closeSummaryModal() {
	        this.setState({ showSummary: false });
	    },
	    getJoinHeader: function getJoinHeader() {
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: "join-header" },
	                _react2.default.createElement(
	                    "div",
	                    {
	                        className: "join-header-title" },
	                    (this.props.staticData.joinWizardSignupLabel || (0, _translate.translate)("Sign Up")) + (this.props.seasonTitle ? " : " + this.props.seasonTitle : "")
	                ),
	                _react2.default.createElement(_JoinNavigationButtons2.default, null)
	            ),
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_JoinWizardSteps2.default, { step: this.props.step, steps: this.props.steps, isGuestUser: this.props.isGuestUser,
	                    staticData: this.props.staticData, isWaitListOnly: this.props.isWaitListOnly })
	            )
	        );
	    },
	    getJoinHeaderMobile: function getJoinHeaderMobile() {
	        return _react2.default.createElement(
	            "div",
	            { className: "join-header-mobile" },
	            _react2.default.createElement(
	                _JoinNavigationButtons2.default,
	                null,
	                _react2.default.createElement(_JoinWizardSteps2.default, { step: this.props.step, steps: this.props.steps, isGuestUser: this.props.isGuestUser,
	                    staticData: this.props.staticData, isWaitListOnly: this.props.isWaitListOnly,
	                    hideLabel: true })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "title-container" },
	                this.props.seasonTitle ? _react2.default.createElement(
	                    "div",
	                    { className: "join-header-title" },
	                    this.props.seasonTitle
	                ) : undefined,
	                _react2.default.createElement(
	                    "div",
	                    { id: "joinHeaderSubtitle",
	                        className: "join-header-subtitle" + (!this.props.seasonTitle ? " no-title" : "") },
	                    (0, _joinActions.getStepLabel)(this.props.step, this.props.staticData.pickupSiteLabel, this.props.isWaitListOnly, this.props.isGuestUser, this.props.staticData.joinSharesStepLabel)
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                { id: "btnSummary", bsStyle: "primary", className: "join-header-summary-button navigation-btn",
	                    onClick: this.showSummaryModal },
	                "Summary"
	            )
	        );
	    },
	    getStepScreen: function getStepScreen(step) {
	        switch (step) {
	            case _constants.JoinSteps.PICKUP_SITES:
	                return _react2.default.createElement(_PickupSiteSelection2.default, { flowType: _constants.URLs.JOIN });
	            case _constants.JoinSteps.SHARES:
	            case _constants.JoinSteps.OPTIONS:
	                return _react2.default.createElement(_JoinSharesOptionsStep2.default, { isAddSubscription: this.props.isAddSubscription });
	            case _constants.JoinSteps.TERMS:
	                return _react2.default.createElement(_JoinTermsStep2.default, null);
	            case _constants.JoinSteps.CONTACT_INFO:
	                return _react2.default.createElement(_JoinContactInfoStep2.default, { staticData: this.props.staticData });
	            case _constants.JoinSteps.PAY:
	                return _react2.default.createElement(_JoinPayStep2.default, null);
	            case _constants.JoinSteps.THANK_YOU:
	                return _react2.default.createElement(_ThankYouPage2.default, { pageContext: _constants.URLs.JOIN, seasonUrl: this.props.staticData.seasonUrl,
	                    customConfirmationScript: this.props.staticData.customConfirmationScript,
	                    isWaitListOnly: this.props.isWaitListOnly,
	                    farmUrl: this.props.staticData.farmUrl,
	                    memberKey: this.props.memberDetails.key,
	                    staticData: this.props.staticData,
	                    extraMessage: (this.props.staticData.params || {}).message,
	                    amountText: this.props.amountText,
	                    mode: this.props.isAddSubscription ? _constants.JoinModes.ADD : _constants.JoinModes.NEW });
	        }
	    },
	    getPath: function getPath() {
	        window.location.replace((0, _utils.redirectPage)(_constants.URLs.JOIN, this.props.staticData));
	    },
	    getScreen: function getScreen() {
	        if (this.props.showLoading) return _react2.default.createElement(_LoadingAnimation2.default, null);
	        var path = this.props.location.pathname;
	        if (path.includes('/thankyou') || this.props.step === _constants.JoinSteps.THANK_YOU) {
	            return this.getStepScreen(_constants.JoinSteps.THANK_YOU);
	        }
	        if (path.endsWith('/echeck')) {
	            if (!this.props.selectedPickupSite) {
	                this.getPath();
	                return _react2.default.createElement(_LoadingAnimation2.default, null);
	            } else {
	                return _react2.default.createElement(_EcheckForm2.default, { pageContext: _constants.URLs.JOIN });
	            }
	        }
	        if (path.endsWith('/ebt')) {
	            if (!this.props.selectedPickupSite) {
	                this.getPath();
	                return _react2.default.createElement(_LoadingAnimation2.default, null);
	            } else {
	                return _react2.default.createElement(_EBTForm2.default, { pageContext: _constants.URLs.JOIN });
	            }
	        }
	        if (path.endsWith('/payments')) {
	            if (!this.props.selectedPickupSite) {
	                this.getPath();
	                return _react2.default.createElement(_LoadingAnimation2.default, null);
	            } else {
	                return _react2.default.createElement(_PaymentsHost2.default, { pageContext: _constants.URLs.JOIN });
	            }
	        }
	        if (this.props.messageData.messageTitle) return _react2.default.createElement(_MessagePage2.default, { messageData: this.props.messageData,
	            staticData: this.props.staticData,
	            memberKey: this.props.memberDetails.key });
	        if (this.props.clientViewPort.isXs) return _react2.default.createElement(
	            "div",
	            null,
	            this.getJoinHeaderMobile(),
	            _react2.default.createElement(
	                "div",
	                { className: "steps-wrapper" },
	                this.getStepScreen(this.props.step)
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { show: this.state.showSummary, onHide: this.closeSummaryModal, className: "summary-modal" },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_JoinSummary2.default, { step: this.props.step, isAddSubscription: this.props.isAddSubscription })
	                ),
	                _react2.default.createElement("button", { id: "btnCloseSummaryPopup", className: "close-button order-summary-popup visible-xs",
	                    onClick: this.closeSummaryModal })
	            )
	        );
	        return _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { className: "join-container" },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 8, md: 10, sm: 10 },
	                    this.getJoinHeader(),
	                    this.getStepScreen(this.props.step)
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: "summary-col", lg: 4, md: 2, sm: 2 },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "user-menu-wrapper" },
	                        this.props.memberDetails.key ? _react2.default.createElement(_UserMenu2.default, null) : _react2.default.createElement("div", { className: "user-menu-space" })
	                    ),
	                    this.props.clientViewPort.isLg ? _react2.default.createElement(_JoinSummary2.default, { step: this.props.step, isAddSubscription: this.props.isAddSubscription }) : _react2.default.createElement(
	                        _reactBootstrap.DropdownButton,
	                        { id: "summary-dropdown", title: "Summary", pullRight: true, noCaret: true,
	                            bsStyle: "default" },
	                        _react2.default.createElement(_JoinSummary2.default, { step: this.props.step, isAddSubscription: this.props.isAddSubscription })
	                    )
	                )
	            )
	        );
	    },
	    render: function render() {
	        if (!this.props.staticData.farmUrl)
	            //static data was not loaded yet
	            return null;
	        return this.getScreen();
	    }
	});
	
	var mapStateToProps = function mapStateToProps(state) {
	    var signupData = state.signupData || {};
	    var clientViewPort = state.clientViewPort || {};
	    var amountText = "";
	
	    if (state.staticData.addAmountToSignupConfirmationScript && (signupData.step === _constants.JoinSteps.THANK_YOU || signupData.step === _constants.JoinSteps.PAY)) {
	        try {
	            var summary = state.summary || {};
	            var sharesData = signupData.sharesData || {};
	            var selectedItems = (0, _basket.getJoinSelectedItems)(sharesData.shares, sharesData.options);
	            var selectedData = signupData.selectedData || {};
	            var nextDeliveryDate = (0, _basket.getNextDeliveryDate)(summary.pickupSite, selectedItems, signupData.schedules, signupData.pickupSitesData.nextDeliveryDates);
	            var itemsRemainingDates = (0, _basket.getAllItemsRemainingDeliveryDates)(selectedItems.items, signupData.sharesData.remainingScheduleDates);
	            amountText = (0, _basket.calcTotals)(signupData.data.isFarmSeasonal, summary.pickupSite, selectedItems.items, selectedData.selectedPaymentPlan, selectedData.coupon, itemsRemainingDates, signupData.sharesData.remainingScheduleDates, nextDeliveryDate, signupData.isAddSubscription, summary.discount, state.staticData, selectedData.selectedMethod).priceText;
	        } catch (e) {}
	    }
	    return {
	        clientViewPort: clientViewPort,
	        staticData: state.staticData,
	        showLoading: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOAD_SIGNUP_DATA) || (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.GET_STATUS) || (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.CREATE_SUBSCRIPTION),
	        data: signupData.data,
	        pickupSitesData: signupData.pickupSitesData,
	        steps: signupData.steps || [],
	        step: signupData.step,
	        isWaitListOnly: (signupData.data || {}).isWaitListOnly,
	        isGuestUser: signupData.isGuestUser,
	        isAddSubscription: signupData.isAddSubscription,
	        messageData: state.messageData || {},
	        memberDetails: state.memberDetails || {},
	        seasonTitle: state.staticData.isFarmSeasonal || !clientViewPort.isXs ? (signupData.data || {}).seasonTitle : undefined,
	        selectedPickupSite: (state.summary || {}).pickupSite,
	        amountText: amountText
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        initServerStaticData: function initServerStaticData() {
	            dispatch((0, _staticDataActions.initServerStaticData)());
	        },
	        initMemberData: function initMemberData() {
	            dispatch((0, _memberDetailsActions.initMemberData)());
	        },
	        setAndRemoveUrlParams: function setAndRemoveUrlParams(onlyHidden) {
	            dispatch((0, _commonActions.setAndRemoveUrlParams)(onlyHidden));
	        },
	        setPastSeasonMessage: function setPastSeasonMessage() {
	            dispatch((0, _joinActions.setPastSeasonMessage)());
	        },
	        getSignupData: function getSignupData(mode) {
	            dispatch((0, _joinActions.getSignupData)(mode));
	        },
	        initGuestUser: function initGuestUser() {
	            dispatch((0, _joinActions.initGuestUser)());
	        },
	        getAddSubscriptionData: function getAddSubscriptionData(subscriptionKey) {
	            dispatch((0, _subscriptionSummaryActions.getAddSubscriptionData)(subscriptionKey));
	        },
	        gotoStep: function gotoStep(step) {
	            dispatch((0, _joinActions.gotoStep)(step));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JoinHomeScreen);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _joinActions = __webpack_require__(752);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinWizardSteps = function (_React$Component) {
	    _inherits(JoinWizardSteps, _React$Component);
	
	    function JoinWizardSteps() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinWizardSteps);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinWizardSteps.__proto__ || Object.getPrototypeOf(JoinWizardSteps)).call.apply(_ref, [this].concat(args))), _this), _this.getLabel = function (step) {
	            if (_this.props.hideLabel) return "";
	            return (0, _joinActions.getStepLabel)(step, _this.props.staticData.pickupSiteLabel, _this.props.isWaitListOnly, _this.props.isGuestUser, _this.props.staticData.joinSharesStepLabel);
	        }, _this.getStepIndex = function (step) {
	            if (step) {
	                return _this.props.steps.indexOf(step);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(JoinWizardSteps, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var activeStepIndex = this.getStepIndex(this.props.step);
	            return _react2.default.createElement(
	                'div',
	                { className: 'join-steps' },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'progress-indicator', id: 'progressIndicator' },
	                    this.props.steps.map(function (step) {
	                        var classOfDoneStep = _this2.getStepIndex(step) < activeStepIndex ? 'done' : '';
	                        return _react2.default.createElement(
	                            'li',
	                            { key: step, className: _this2.props.step === step ? 'completed' : classOfDoneStep },
	                            ' ',
	                            _react2.default.createElement('span', { className: 'bubble' }),
	                            (0, _translate.translate)(_this2.getLabel(step))
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return JoinWizardSteps;
	}(_react2.default.Component);
	
	exports.default = JoinWizardSteps;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _joinActions = __webpack_require__(752);
	
	var _constants = __webpack_require__(463);
	
	var _basket = __webpack_require__(757);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	var _JoinNavigationButtons = __webpack_require__(840);
	
	var _JoinNavigationButtons2 = _interopRequireDefault(_JoinNavigationButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinNavigationButtons = function (_React$Component) {
	    _inherits(JoinNavigationButtons, _React$Component);
	
	    function JoinNavigationButtons() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinNavigationButtons);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinNavigationButtons.__proto__ || Object.getPrototypeOf(JoinNavigationButtons)).call.apply(_ref, [this].concat(args))), _this), _this.nextClicked = function () {
	            _this.props.navigateToStep(_constants.JoinStepsDirections.NEXT);
	        }, _this.backClicked = function () {
	            _this.props.navigateToStep(_constants.JoinStepsDirections.BACK);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(JoinNavigationButtons, [{
	        key: 'render',
	        value: function render() {
	            var showArrow = this.props.buttonsState.nextText === (0, _translate.translate)("Next");
	            var nextClassName = "navigation-btn" + (showArrow ? " show-arrow" : "") + (this.props.isProcessing ? " button loading" : "");
	            return _react2.default.createElement(
	                'div',
	                { className: 'join-navigation-header' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'join-navigation-next' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: 'primary', className: nextClassName, hidden: !this.props.buttonsState.nextVisible,
	                            disabled: !this.props.buttonsState.nextEnabled, onClick: this.nextClicked },
	                        this.props.buttonsState.nextText
	                    )
	                ),
	                this.props.children ? this.props.children : undefined,
	                _react2.default.createElement(
	                    'span',
	                    { className: 'join-navigation-back' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: 'primary', className: 'navigation-btn', hidden: !this.props.buttonsState.backVisible,
	                            disabled: !this.props.buttonsState.backEnabled, onClick: this.backClicked },
	                        (0, _translate.translate)("Back")
	                    )
	                )
	            );
	        }
	    }]);
	
	    return JoinNavigationButtons;
	}(_react2.default.Component);
	
	var getButtonsState = function getButtonsState(signupData, summary, isProcessing, staticData) {
	    var backVisible = false;
	    var backEnabled = true;
	    var nextVisible = true;
	    var nextEnabled = false;
	    var nextText = (0, _translate.translate)("Next");
	    var selectedData = signupData.selectedData || {};
	    switch (signupData.step) {
	        case _constants.JoinSteps.PICKUP_SITES:
	            backEnabled = backVisible = signupData.isGuestUser;
	            nextEnabled = summary.pickupSite !== undefined && summary.pickupSite !== null && !summary.isCreatingSubscription;
	            if (signupData.isGuestUser) {
	                nextText = (0, _translate.translate)("SHOP");
	            }
	            break;
	        case _constants.JoinSteps.SHARES:
	            var isWaitList = (signupData.data || {}).isWaitListOnly;
	            backVisible = !isWaitList;
	            var selectedShares = (0, _basket.getJoinSelectedItems)(signupData.sharesData.shares, {});
	            var items = !isWaitList ? selectedShares.items : selectedShares.waitlistItems;
	            //In add subscription can skip selecting shares
	            if (signupData.isAddSubscription && (signupData.data || {}).hasOptions) nextEnabled = true;else nextEnabled = items.length > 0;
	            break;
	        case _constants.JoinSteps.OPTIONS:
	            backVisible = true;
	            //In add subscription can skip selecting shares
	            if (signupData.isAddSubscription) nextEnabled = (0, _basket.getJoinSelectedItems)(signupData.sharesData.shares, signupData.sharesData.options).items.length > 0;else nextEnabled = true;
	            break;
	        case _constants.JoinSteps.TERMS:
	            backVisible = true;
	            nextEnabled = selectedData.selectedPaymentPlan !== undefined;
	            break;
	        case _constants.JoinSteps.CONTACT_INFO:
	            backVisible = true;
	            nextEnabled = !isProcessing && signupData.contactInfoPage === _constants.JoinCreateAccountConstants.CONTACT_DETAILS;
	            backEnabled = !isProcessing;
	            nextVisible = signupData.contactInfoPage === _constants.JoinCreateAccountConstants.CONTACT_DETAILS;
	            if ((signupData.data || {}).isWaitListOnly) {
	                nextText = (0, _translate.translate)("Finish");
	            }
	            break;
	        case _constants.JoinSteps.PAY:
	            backVisible = true;
	            nextEnabled = !isProcessing && selectedData.selectedMethod !== undefined && selectedData.selectedMethod !== _constants.PaymentMethod.NONE.key && (selectedData.termsSelected || staticData.joinTermsAgreement);
	            if (staticData.mandatorySignupComments && !selectedData.signupComments) {
	                nextEnabled = false;
	            }
	            nextText = (0, _translate.translate)("Checkout");
	            backEnabled = !isProcessing;
	            break;
	    }
	    return { backVisible: backVisible, backEnabled: backEnabled, nextVisible: nextVisible, nextEnabled: nextEnabled, nextText: nextText };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var signupData = state.signupData || {};
	    var summary = state.summary || {};
	    var isProcessing = (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT) || (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.VALIDATE_UPDATE_MEMBER) || state.memberDetails.memberAction === _constants.MemberActions.VALIDATE_MEMBER_DETAILS;
	    return {
	        staticData: state.staticData,
	        signupData: signupData,
	        summary: summary,
	        isProcessing: isProcessing,
	        buttonsState: getButtonsState(signupData, summary, isProcessing, state.staticData)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        navigateToStep: function navigateToStep(direction) {
	            dispatch((0, _joinActions.navigateToStep)(direction));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JoinNavigationButtons);

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _SelectionTabs = __webpack_require__(842);
	
	var _SelectionTabs2 = _interopRequireDefault(_SelectionTabs);
	
	var _SelectionPane = __webpack_require__(844);
	
	var _SelectionPane2 = _interopRequireDefault(_SelectionPane);
	
	var _JoinPickupSiteList = __webpack_require__(845);
	
	var _JoinPickupSiteList2 = _interopRequireDefault(_JoinPickupSiteList);
	
	var _JoinPickupSiteMap = __webpack_require__(847);
	
	var _JoinPickupSiteMap2 = _interopRequireDefault(_JoinPickupSiteMap);
	
	var _LoadingAnimation = __webpack_require__(834);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _joinActions = __webpack_require__(752);
	
	var _constants = __webpack_require__(463);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _utils = __webpack_require__(485);
	
	var _commonActions = __webpack_require__(747);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _translate = __webpack_require__(464);
	
	var _pickupSiteListSelection = __webpack_require__(1074);
	
	var _pickupSiteListSelection2 = _interopRequireDefault(_pickupSiteListSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PICKUP_SITE_LIST_TAB = (0, _translate.translate)("LIST");
	var PICKUP_SITE_MAP_TAB = (0, _translate.translate)("MAP");
	
	var PickupSiteSelection = function (_React$Component) {
	    _inherits(PickupSiteSelection, _React$Component);
	
	    function PickupSiteSelection() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PickupSiteSelection);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PickupSiteSelection.__proto__ || Object.getPrototypeOf(PickupSiteSelection)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            availablePickupSites: [],
	            waitListPickupSites: [],
	            selectionError: undefined
	        }, _this.getPickupSites = function () {
	            var pickupSites = _this.props.pickupSitesData.pickupSites;
	            var deliveryDayFilter = _this.props.deliveryDay ? _this.props.deliveryDay : null;
	            if (pickupSites) {
	                var availablePickupSites = [];
	                for (var i = 0; i < pickupSites.length; i++) {
	                    var pickupSite = pickupSites[i];
	                    if (pickupSite.type !== _constants.PickupSiteTypes.ZONE && pickupSite.type !== _constants.PickupSiteTypes.REGULAR) {
	                        continue;
	                    }
	                    if (deliveryDayFilter !== null && pickupSite.deliveryDays !== deliveryDayFilter) {
	                        continue;
	                    }
	                    if (_this.props.staticData.joinHideRegularPickupSiteHours && pickupSite.type === _constants.PickupSiteTypes.REGULAR) {
	                        pickupSite.deliveryHours = "";
	                    }
	
	                    availablePickupSites.push(Object.assign({}, pickupSite, { isNonSelectable: !_this.isSelectable(pickupSite) }));
	                }
	                return availablePickupSites;
	            }
	        }, _this.isSelectable = function (pickupSite) {
	            var nextDeliveryDates = _this.props.pickupSitesData.nextDeliveryDates;
	            var exceptionalPickupSites = _this.props.pickupSitesData.exceptionalPickupSites;
	            var pickupSiteDeliveryDay = pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null ? pickupSite.deliveryDaysList[0] : null;
	            var hasDelivery = nextDeliveryDates.hasOwnProperty(pickupSiteDeliveryDay) && !(0, _utils.isEmptyObj)(nextDeliveryDates[pickupSiteDeliveryDay]) || exceptionalPickupSites.hasOwnProperty(pickupSite.key);
	
	            var selectable = _this.isInAvailableDays(pickupSite) && hasDelivery;
	            if (selectable && _this.props.flowType === _constants.URLs.ACCOUNT && !_this.isPickupSiteAvailableForSubscription(pickupSite)) {
	                return false;
	            }
	            return selectable;
	        }, _this.isInAvailableDays = function (pickupSite) {
	            var availableDays = _this.props.pickupSitesData.availableDays;
	            var exceptionsDaysAndHours = _this.props.pickupSitesData.exceptionsDaysAndHours;
	            var exceptionalPickupSites = _this.props.pickupSitesData.exceptionalPickupSites;
	            var pickupSiteDeliveryDay = pickupSite.deliveryDaysList ? pickupSite.deliveryDaysList[0] : null;
	            var exceptionDeliveryDate = exceptionalPickupSites[pickupSite.key];
	            return availableDays === undefined || availableDays.includes(pickupSiteDeliveryDay) || exceptionDeliveryDate && exceptionsDaysAndHours.hasOwnProperty(exceptionDeliveryDate) && exceptionsDaysAndHours[exceptionDeliveryDate]["second"];
	        }, _this.isVisibleToMember = function (pickupSite, scheduledShareItem) {
	            return _this.isVisibleForPickupSite(pickupSite, scheduledShareItem.shareItem) && (!scheduledShareItem.shareItem.isAvailable || scheduledShareItem.selectedSchedule != -2 && (scheduledShareItem.selectedSchedule == -1 && scheduledShareItem.shareItem.defaultSchedulesSize > 1 || _this.isDeliveriesLeft(scheduledShareItem)));
	        }, _this.isVisibleForPickupSite = function (pickupSite, shareItem) {
	            return pickupSite == null || shareItem.pickupSiteNotAvailableSet && !shareItem.pickupSiteNotAvailableSet.includes(pickupSite.key);
	        }, _this.isDeliveriesLeft = function (scheduledShareItem) {
	            return scheduledShareItem.selectedSchedule >= 0 && scheduledShareItem.selectedSchedule < scheduledShareItem.shareItem.isDeliveriesLeft.length ? scheduledShareItem.shareItem.isDeliveriesLeft[scheduledShareItem.selectedSchedule] : false;
	        }, _this.isPickupSiteAvailableForSubscription = function (pickupSite) {
	            var pickupSiteDeliveryDay = pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null ? pickupSite.deliveryDaysList[0] : null;
	            var shareItemData = _this.props.pickupSitesData.shareItemDataMap[pickupSiteDeliveryDay];
	
	            // If at least one share becomes unavailable for this pick up site don't allow to select this pick up site
	            var summaryShareItems = _this.props.shareItems;
	            for (var i in summaryShareItems) {
	                if (summaryShareItems.hasOwnProperty(i)) {
	                    var scheduledShareItem = void 0;
	                    var shareKey = summaryShareItems[i].key;
	                    if (shareItemData && shareItemData.shareItems.length) {
	                        var shareItems = shareItemData.shareItems;
	                        for (var j in shareItems) {
	                            if (shareItems.hasOwnProperty(j)) {
	                                var shareItem = shareItems[j];
	                                if (shareItem.key === shareKey) {
	                                    scheduledShareItem = _this.getSelectionIndex(shareItem, _this.props.shareSchedules[i]);
	                                    _this.updateSelectedSchedule(pickupSite, scheduledShareItem);
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                    if (scheduledShareItem && !_this.isVisibleToMember(pickupSite, scheduledShareItem)) {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        }, _this.updateSelectedSchedule = function (pickupSite, scheduledShareItem) {
	            var item = scheduledShareItem.shareItem;
	            if (_this.isVisibleForPickupSite(pickupSite, item) && item.defaultSchedulesSize <= 1) {
	                scheduledShareItem.selectedSchedule = pickupSite && item.pickupSiteScheduleMap && item.pickupSiteScheduleMap.hasOwnProperty(pickupSite.key) && item.pickupSiteScheduleMap[pickupSite.key] !== -1 ? item.pickupSiteScheduleMap[pickupSite.key] : item.defaultSchedulesSize - 1;
	            }
	        }, _this.getSelectionIndex = function (shareItem, scheduleKey) {
	            var selectedSchedule = -1;
	
	            if (scheduleKey !== null) {
	
	                for (var i = 0; i < shareItem.schedules.length; i++) {
	
	                    if (shareItem.schedules[i] === scheduleKey) {
	                        selectedSchedule = i;
	                        break;
	                    }
	                }
	            }
	            return {
	                shareItem: shareItem,
	                selectedSchedule: selectedSchedule
	            };
	        }, _this.isValidChangeWhenWebOrderExists = function (pickupSite) {
	            var pickupSiteDeliveryDay = pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null ? pickupSite.deliveryDaysList[0] : null;
	            var subscriptionPickupSiteDeliveryDay = _this.props.pickupSite.deliveryDaysList || _this.props.pickupSite.deliveryDaysList !== null ? _this.props.pickupSite.deliveryDaysList[0] : null;
	            return pickupSiteDeliveryDay === subscriptionPickupSiteDeliveryDay;
	        }, _this.getStoreHours = function (pickupSite) {
	            var pickupSiteDeliveryDay = pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null ? pickupSite.deliveryDaysList[0] : null;
	            if (_this.props.pickupSitesData.storeHours && _this.props.pickupSitesData.storeHours.hasOwnProperty(pickupSiteDeliveryDay)) return _this.props.pickupSitesData.storeHours[pickupSiteDeliveryDay];
	            var deliveryDate = _this.props.pickupSitesData.exceptionalPickupSites[pickupSite.key];
	            return deliveryDate && _this.props.pickupSitesData.exceptionsDaysAndHours[deliveryDate] ? _this.props.pickupSitesData.exceptionsDaysAndHours[deliveryDate] : "";
	        }, _this.isValidPickupSiteSelection = function (pickupSite) {
	            if (_this.props.flowType === _constants.URLs.ACCOUNT && !_this.isPickupSiteAvailableForSubscription(pickupSite)) {
	                _this.setState({ selectionError: (0, _translate.translate)("pickupSiteNotAvailableForSubscription") });
	                return false;
	            }
	            if (pickupSite.isNonSelectable) {
	                if (_this.props.flowType === _constants.URLs.ACCOUNT) {
	                    var pickupSiteDeliveryDay = pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null ? pickupSite.deliveryDaysList[0] : null;
	                    _this.setState({ selectionError: (0, _translate.translate)("pickupSiteNotChangeDistributionDay").replace("DELIVERY_DAY", pickupSiteDeliveryDay) });
	                    return false;
	                } else if (_this.props.flowType === _constants.URLs.JOIN) {
	                    var storeHours = _this.getStoreHours(pickupSite);
	                    if (storeHours) {
	                        _this.setState({ selectionError: (0, _translate.translate)("guestStoreClosedSeasonEnd") + "</br></br>" + (0, _translate.translate)("pickupSiteNotAvailablePrepareDeliveries") + storeHours + "." });
	                        return false;
	                    } else {
	                        _this.setState({ selectionError: (0, _translate.translate)("guestStoreClosedSeasonEnd") });
	                        return false;
	                    }
	                }
	                return false;
	            } else if (_this.props.flowType === _constants.URLs.ACCOUNT && _this.props.activeWebOrderKey && !_this.isValidChangeWhenWebOrderExists(pickupSite)) {
	                _this.setState({ selectionError: (0, _translate.translate)("cantAcceptChangesActiveOrder") });
	                return false;
	            }
	            _this.setState({ selectionError: undefined });
	            return true;
	        }, _this.showPopupError = function () {
	            return _react2.default.createElement(_ModalPopup2.default, {
	                onClose: function onClose() {
	                    _this.setState({ selectionError: undefined });
	                },
	                title: "",
	                message: _this.state.selectionError,
	                middle: { text: (0, _translate.translate)('Close'), callback: function callback() {
	                        _this.setState({ selectionError: undefined });
	                    } } });
	        }, _this.setPickupSite = function (pickupSite, isWaitList) {
	            var nextDeliveryDate = _this.props.nextDeliveryDate;
	            var pickupSiteDeliveryDay = pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null ? pickupSite.deliveryDaysList[0] : null;
	            if (_this.props.pickupSitesData && _this.props.pickupSitesData.nextDeliveryDates.hasOwnProperty(pickupSiteDeliveryDay)) {
	                var deliveryDates = _this.props.pickupSitesData.nextDeliveryDates[pickupSiteDeliveryDay];
	                for (var key in deliveryDates) {
	                    if (deliveryDates.hasOwnProperty(key)) {
	                        nextDeliveryDate = deliveryDates[key];
	                        break;
	                    }
	                }
	            }
	            _this.props.updatePickupSitesAndDeliveryDate(pickupSite, isWaitList, nextDeliveryDate);
	        }, _this.getPickupSiteListView = function () {
	            return _react2.default.createElement(_JoinPickupSiteList2.default, { clientViewPort: _this.props.clientViewPort,
	                availablePickupSites: _this.getPickupSites(),
	                setPickupSite: _this.setPickupSite,
	                pickupSiteKey: _this.props.pickupSite.key,
	                pickupSiteWaitListKey: _this.props.pickupSiteWaitListKey,
	                deliveryDayFilter: _this.props.deliveryDay,
	                setDeliveryDayFilter: _this.props.setDeliveryDayFilter,
	                pickupSites: _this.props.pickupSitesData.pickupSites,
	                overrideSignupDaysColumnLabel: _this.props.staticData.overrideSignupDaysColumnLabel,
	                joinWaitListLocationLabel: _this.props.staticData.joinWaitListLocationLabel,
	                isValidPickupSiteSelection: _this.isValidPickupSiteSelection });
	        }, _this.getPickupSiteMapView = function () {
	            return _react2.default.createElement(_JoinPickupSiteMap2.default, { clientViewPort: _this.props.clientViewPort,
	                availablePickupSites: _this.getPickupSites(),
	                setPickupSite: _this.setPickupSite,
	                setMapProps: _this.props.setMapProps,
	                centerLocation: _this.props.centerLocation,
	                deliveryDayFilter: _this.props.deliveryDay,
	                setDeliveryDayFilter: _this.props.setDeliveryDayFilter,
	                pickupSites: _this.props.pickupSitesData.pickupSites,
	                zoomLevel: _this.props.zoomLevel,
	                isValidPickupSiteSelection: _this.isValidPickupSiteSelection,
	                errorFetching: _this.props.errorFetching });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PickupSiteSelection, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            if (this.props.isGuestUser) {
	                this.props.getGuestPickupSiteData();
	            }
	            var pickupSiteKey = (0, _utils.getUrlParams)().location;
	            if (pickupSiteKey) {
	                this.props.removePath();
	                var pickupSites = this.props.pickupSitesData.pickupSites.find(function (pickupSite) {
	                    return pickupSite.key === pickupSiteKey;
	                });
	                if (pickupSites && pickupSites.isAvailable) {
	                    this.setPickupSite(pickupSites, false);
	                    this.props.navigateToSharesStep();
	                }
	            }
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.deliveryDay !== nextProps.deliveryDay) {
	                this.props.initMapProps();
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (this.props.showLoading) return _react2.default.createElement(_LoadingAnimation2.default, null);
	            var pickupSiteLabel = !this.props.staticData.pickupSiteLabel || this.props.staticData.pickupSiteLabel === 'null' ? (0, _translate.translate)("pick-up site") : this.props.staticData.pickupSiteLabel;
	            var title = (0, _translate.translate)("pickupDayStepHeader").replace("PICKUP_SITE_LABEL", pickupSiteLabel);
	            var showMapFirst = this.props.staticData.joinShowMapFirst;
	            if (this.props.clientViewPort.isXs) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "pickup-site-select-container pickup-site-selection-mobile" + (this.props.flowType === _constants.URLs.ACCOUNT ? " account" : "") },
	                    _react2.default.createElement(
	                        _reactBootstrap.Tabs,
	                        { className: "join-mobile-tab", id: "pickup-sites-tabs", defaultActiveKey: PICKUP_SITE_LIST_TAB, animation: false, unmountOnExit: true },
	                        _react2.default.createElement(
	                            _reactBootstrap.Tab,
	                            { title: PICKUP_SITE_LIST_TAB, eventKey: PICKUP_SITE_LIST_TAB },
	                            this.getPickupSiteListView()
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Tab,
	                            { title: PICKUP_SITE_MAP_TAB, eventKey: PICKUP_SITE_MAP_TAB },
	                            this.getPickupSiteMapView()
	                        )
	                    ),
	                    !this.state.selectionError ? undefined : this.showPopupError()
	                );
	            } else {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "table-container-selector pickup-site-select-container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "select-title" },
	                        title
	                    ),
	                    _react2.default.createElement(
	                        _SelectionTabs2.default,
	                        { className: "pickup-sites-tabs", id: "pickup-sites-tabs" },
	                        _react2.default.createElement(
	                            _SelectionPane2.default,
	                            { label: showMapFirst ? PICKUP_SITE_MAP_TAB : PICKUP_SITE_LIST_TAB },
	                            showMapFirst ? this.getPickupSiteMapView() : this.getPickupSiteListView()
	                        ),
	                        _react2.default.createElement(
	                            _SelectionPane2.default,
	                            { label: showMapFirst ? PICKUP_SITE_LIST_TAB : PICKUP_SITE_MAP_TAB },
	                            showMapFirst ? this.getPickupSiteListView() : this.getPickupSiteMapView()
	                        )
	                    ),
	                    !this.state.selectionError ? undefined : this.showPopupError()
	                );
	            }
	        }
	    }]);
	
	    return PickupSiteSelection;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var pickupSiteData = state.signupData.pickupSitesData || {};
	    var signupData = state.signupData || {};
	    var summary = state.summary || {};
	    return {
	        staticData: state.staticData,
	        clientViewPort: state.clientViewPort || {},
	        showLoading: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOAD_SIGNUP_DATA) || (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOAD_PICKUP_DATA) || !state.signupData.pickupSitesData,
	        memberDetails: state.memberDetails || {},
	        isGuestUser: signupData.isGuestUser,
	        zoomLevel: signupData.zoomLevel,
	        centerLocation: signupData.centerLocation,
	        pickupSitesData: pickupSiteData,
	        pickupSite: summary.pickupSite || {},
	        pickupSiteWaitListKey: (summary.waitListSite || {}).key,
	        shareItems: summary.shareItems,
	        shareSchedules: summary.shareSchedules,
	        activeWebOrderKey: summary.activeWebOrderKey,
	        nextDeliveryDate: summary.nextDeliveryDate,
	        deliveryDay: pickupSiteData.deliveryDayFilter
	    };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        updatePickupSitesAndDeliveryDate: function updatePickupSitesAndDeliveryDate(pickupSite, isWaitList, nextDeliveryDate) {
	            if (!isWaitList) {
	                dispatch((0, _subscriptionSummaryActions.setPickupSitesAndDeliveryDateActual)(pickupSite, nextDeliveryDate));
	            } else {
	                dispatch((0, _subscriptionSummaryActions.setWaitListPickupSite)(pickupSite));
	            }
	            dispatch((0, _commonActions.setDirty)(true));
	        },
	        setDeliveryDayFilter: function setDeliveryDayFilter(deliveryDay) {
	            dispatch((0, _joinActions.setPickupSitesFilters)(deliveryDay));
	        },
	        getGuestPickupSiteData: function getGuestPickupSiteData() {
	            dispatch((0, _joinActions.getGuestPickupSiteData)());
	        },
	        setMapProps: function setMapProps(zoomLevel, centerLocation) {
	            dispatch((0, _joinActions.setMapProps)(zoomLevel, centerLocation));
	        },
	        initMapProps: function initMapProps() {
	            dispatch((0, _joinActions.initMapProps)());
	        },
	        errorFetching: function errorFetching(error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        },
	        removePath: function removePath() {
	            dispatch((0, _reactRouterRedux.replace)(location.pathname));
	        },
	        navigateToSharesStep: function navigateToSharesStep() {
	            dispatch((0, _joinActions.navigateToStep)(_constants.JoinStepsDirections.NEXT));
	        }
	    };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PickupSiteSelection);

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _commonActions = __webpack_require__(747);
	
	var _selectionTabs = __webpack_require__(843);
	
	var _selectionTabs2 = _interopRequireDefault(_selectionTabs);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var selectionTabs = function (_React$Component) {
	    _inherits(selectionTabs, _React$Component);
	
	    function selectionTabs(props, context) {
	        _classCallCheck(this, selectionTabs);
	
	        var _this = _possibleConstructorReturn(this, (selectionTabs.__proto__ || Object.getPrototypeOf(selectionTabs)).call(this, props, context));
	
	        _this._renderTitles = function () {
	            function labels(child, index) {
	                var activeClass = "select-tab" + (this.state.selected === index ? ' active' : '');
	                return _react2.default.createElement(
	                    "li",
	                    { key: index },
	                    _react2.default.createElement(
	                        "div",
	                        {
	                            className: activeClass,
	                            onClick: this.handleClick.bind(this, index) },
	                        (0, _translate.translate)(child.props.label)
	                    )
	                );
	            }
	            return _react2.default.createElement(
	                "ul",
	                { id: "selectionTab", className: "tabs__labels" },
	                _this.state.children.map(labels.bind(_this))
	            );
	        };
	
	        _this._renderContent = function () {
	            return _react2.default.createElement(
	                "div",
	                { className: "tabs__content" },
	                _this.state.children[_this.state.selected]
	            );
	        };
	
	        _this.handleClick = function (index, event) {
	            if (_this.props.checkDirty) {
	                _this.props.checkIsDirty(function () {
	                    this.clickActions(index, event);
	                }.bind(_this));
	            } else {
	                _this.clickActions(index, event);
	            }
	        };
	
	        _this.clickActions = function (index, event) {
	            if (!_this.props.disableCheckDirty) {
	                _this.props.setDirty(false);
	            }
	            event.preventDefault();
	            _this.setState({
	                selected: index
	            });
	            if (_this.props.update) {
	                _this.props.update(_this.state.children[index].props.label);
	            }
	        };
	
	        var children = props.children.filter(function (child) {
	            return child && !child.props.invisible;
	        });
	        var selectedIndex = void 0;
	        if (props.selectedTabTitle) {
	            children.forEach(function (child, index) {
	                if (child.props.label === props.selectedTabTitle) {
	                    selectedIndex = index;
	                }
	            }.bind(_this));
	        }
	
	        _this.state = {
	            selected: selectedIndex ? selectedIndex : props.selected,
	            children: children
	        };
	        return _this;
	    }
	
	    _createClass(selectionTabs, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            if (this.props.update !== undefined) {
	                this.props.update(this.state.children[this.state.selected].props.label);
	            }
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            var children = nextProps.children.filter(function (child) {
	                return child && !child.props.invisible;
	            });
	            this.setState({ children: children });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var styleClass = this.props.styleClass ? "tabs " + " " + this.props.styleClass : "tabs";
	            return _react2.default.createElement(
	                "div",
	                { className: styleClass },
	                this._renderTitles(),
	                this._renderContent()
	            );
	        }
	    }]);
	
	    return selectionTabs;
	}(_react2.default.Component);
	
	selectionTabs.displayName = 'Tabs';
	selectionTabs.defaultProps = {
	    selected: 0
	};
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        checkIsDirty: function checkIsDirty(onLeaveCallBack) {
	            dispatch((0, _commonActions.checkIsDirty)(onLeaveCallBack));
	        },
	        setDirty: function setDirty(isDirty) {
	            dispatch((0, _commonActions.setDirty)(isDirty));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(selectionTabs);

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectionPane = function (_React$Component) {
	    _inherits(SelectionPane, _React$Component);
	
	    function SelectionPane() {
	        _classCallCheck(this, SelectionPane);
	
	        return _possibleConstructorReturn(this, (SelectionPane.__proto__ || Object.getPrototypeOf(SelectionPane)).apply(this, arguments));
	    }
	
	    _createClass(SelectionPane, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: this.props.styleClass ? this.props.styleClass : "" },
	                this.props.children
	            );
	        }
	    }]);
	
	    return SelectionPane;
	}(_react2.default.Component);
	
	SelectionPane.displayName = 'Pane';
	SelectionPane.propTypes = {
	    label: _propTypes2.default.string.isRequired,
	    invisible: _propTypes2.default.bool,
	    children: _propTypes2.default.element.isRequired
	};
	exports.default = SelectionPane;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _JoinPickupSiteFilter = __webpack_require__(846);
	
	var _JoinPickupSiteFilter2 = _interopRequireDefault(_JoinPickupSiteFilter);
	
	var _constants = __webpack_require__(463);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var waitListLabel = function waitListLabel(isWaitList, waitListCustomLabel) {
	    if (isWaitList) {
	        return _react2.default.createElement(
	            "div",
	            { className: "pick-up-site-waitList-comment" },
	            waitListCustomLabel || (0, _translate.translate)("waitlist only")
	        );
	    }
	};
	
	var JoinPickupSiteList = function (_React$Component) {
	    _inherits(JoinPickupSiteList, _React$Component);
	
	    function JoinPickupSiteList() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinPickupSiteList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinPickupSiteList.__proto__ || Object.getPrototypeOf(JoinPickupSiteList)).call.apply(_ref, [this].concat(args))), _this), _this.expendComment = function (e) {
	            var id = e.target.id;
	            _this.refs[id].style.display = "none";
	            id = id.replace("more_", "comment_");
	            _this.refs[id].style.maxHeight = "initial";
	        }, _this.pickupSiteSelected = function (pickupSite, isWaitList) {
	            if (_this.props.isValidPickupSiteSelection(pickupSite)) {
	                _this.props.setPickupSite(pickupSite, isWaitList);
	            }
	        }, _this.getComment = function (pickupSite, isWaitList) {
	            if (_this.props.clientViewPort.isXs) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: "pick-up-site-comment-container", name: "pickupSiteComments", xs: 11 },
	                    _react2.default.createElement("div", { className: "list-row-comment", id: "comment_" + pickupSite.key,
	                        ref: "comment_" + pickupSite.key,
	                        dangerouslySetInnerHTML: { __html: pickupSite.comment } })
	                );
	            } else {
	                return _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: "pick-up-site-comment-container", name: "pickupSiteComments", sm: 5 },
	                    waitListLabel(isWaitList, _this.props.joinWaitListLocationLabel),
	                    _react2.default.createElement("div", { className: "comment", dangerouslySetInnerHTML: { __html: pickupSite.comment } })
	                );
	            }
	        }, _this.createPickupSiteLine = function (pickupSite, isWaitList) {
	            var styleClass = "list-row pickup-site-row" + (pickupSite.isNonSelectable ? " list-row-not-selectable" : "");
	            var selectedWaitListSite = pickupSite.key === _this.props.pickupSiteWaitListKey;
	            var selectedSite = pickupSite.key === _this.props.pickupSiteKey;
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                { name: "pickupSiteRow", className: styleClass, key: pickupSite.key },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { onClick: _this.pickupSiteSelected.bind(_this, pickupSite, isWaitList), className: "pickup-site-row-click-container" },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: "pick-up-site-title-radio", sm: 5, xs: 11 },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "list-item-title" },
	                            isWaitList ? _react2.default.createElement("input", { type: "radio", className: "radio-select", name: "waitListSite",
	                                checked: selectedWaitListSite,
	                                value: pickupSite.key,
	                                onChange: _this.pickupSiteSelected.bind(_this, pickupSite, isWaitList)
	                            }) : _react2.default.createElement("input", { type: "radio", className: "radio-select", name: "pickupSite", checked: selectedSite,
	                                value: pickupSite.key,
	                                onChange: _this.pickupSiteSelected.bind(_this, pickupSite, isWaitList)
	                            }),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "item-title pickup-site-title", name: "pickupSiteTitle" },
	                                pickupSite.title
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "pickup-site-address", name: "pickupSiteAddress" },
	                                pickupSite.shortAddress
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: "pick-up-site-delivery-day", sm: 2, xs: 12, name: "pickupSiteDeliveryDay" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "delivery-day" },
	                            (0, _translate.translate)(pickupSite.deliveryDays)
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "delivery-hours" },
	                            pickupSite.deliveryHours
	                        ),
	                        _this.props.clientViewPort.isXs ? waitListLabel(isWaitList, _this.props.joinWaitListLocationLabel) : undefined
	                    ),
	                    _this.getComment(pickupSite, isWaitList)
	                ),
	                _this.props.clientViewPort.isXs ? _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: "pick-up-site-comment-container", name: "pickupSiteCommentsMore", xs: 11 },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "read-more-comment", id: "more_" + pickupSite.key, ref: "more_" + pickupSite.key,
	                            onClick: _this.expendComment },
	                        (0, _translate.translate)("More") + "..."
	                    )
	                ) : undefined
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(JoinPickupSiteList, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            for (var ref in this.refs) {
	                if (this.refs.hasOwnProperty(ref)) {
	                    var elem = this.refs[ref];
	                    if (elem.className == "list-row-comment") if (elem.scrollHeight > 42) {
	                        ref = ref.replace("comment_", "more_");
	                        this.refs[ref].style.display = "block";
	                    }
	                }
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var pickupSites = this.props.availablePickupSites;
	            if (pickupSites) {
	                var sites = [];
	                var waitListSites = [];
	                pickupSites.forEach(function (pickupSite) {
	                    if (pickupSite.isAvailable) {
	                        sites.push(this.createPickupSiteLine(pickupSite, false));
	                    } else if (!pickupSite.isAvailable && pickupSite.isWaitListAllowed) {
	                        waitListSites.push(this.createPickupSiteLine(pickupSite, true));
	                    }
	                }.bind(this));
	                return _react2.default.createElement(
	                    "div",
	                    { id: "pickupSiteListContainer", className: "table-container-selector" },
	                    _react2.default.createElement(
	                        _reactBootstrap.Form,
	                        { horizontal: true, className: "list-container" },
	                        _react2.default.createElement(_JoinPickupSiteFilter2.default, { clientViewPort: this.props.clientViewPort,
	                            deliveryDayFilter: this.props.deliveryDayFilter,
	                            setDeliveryDayFilter: this.props.setDeliveryDayFilter,
	                            pickupSiteSelectionType: _constants.PickupSiteSelectionTypes.LIST,
	                            pickupSites: this.props.pickupSites }),
	                        this.props.clientViewPort.isXs ? undefined : _react2.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { className: "columns-title", controlId: "pickupSiteTitles" },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { componentClass: _reactBootstrap.ControlLabel, className: "title-column", sm: 5 },
	                                (0, _translate.translate)("Available Location")
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { componentClass: _reactBootstrap.ControlLabel, className: "title-column", md: 2, sm: 2 },
	                                this.props.overrideSignupDaysColumnLabel ? "Pick-up" : (0, _translate.translate)("Delivery Day")
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { componentClass: _reactBootstrap.ControlLabel, className: "title-column", md: 5, sm: 5 },
	                                (0, _translate.translate)("Comments")
	                            )
	                        ),
	                        sites
	                    ),
	                    waitListSites.length > 0 ? _react2.default.createElement(
	                        _reactBootstrap.Form,
	                        { horizontal: true, className: "list-container" },
	                        !this.props.clientViewPort.isXs ? _react2.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { className: "columns-title", controlId: "pickupSiteWaitListTitles" },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { componentClass: _reactBootstrap.ControlLabel, className: "title-column", sm: 5 },
	                                (0, _translate.translate)("Waitlist Location"),
	                                " "
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { componentClass: _reactBootstrap.ControlLabel, className: "title-column", md: 2, sm: 2 },
	                                (0, _translate.translate)("Delivery Day")
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { componentClass: _reactBootstrap.ControlLabel, className: "title-column", md: 5, sm: 5 },
	                                (0, _translate.translate)("Comments")
	                            )
	                        ) : _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: "waitlist-title-header" },
	                            _react2.default.createElement(
	                                "label",
	                                { className: "waitlist-title" },
	                                (0, _translate.translate)("Waitlist Locations")
	                            )
	                        ),
	                        waitListSites
	                    ) : undefined
	                );
	            }
	            return false;
	        }
	    }]);
	
	    return JoinPickupSiteList;
	}(_react2.default.Component);
	
	exports.default = JoinPickupSiteList;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinPickupSiteFilter = function (_React$Component) {
	    _inherits(JoinPickupSiteFilter, _React$Component);
	
	    function JoinPickupSiteFilter() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinPickupSiteFilter);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinPickupSiteFilter.__proto__ || Object.getPrototypeOf(JoinPickupSiteFilter)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            deliveryDay: _this.props.deliveryDayFilter
	        }, _this.onChangeDeliveryDay = function (value) {
	            var deliveryDay = value === 'All' ? null : value;
	            _this.setState({ deliveryDay: deliveryDay });
	            _this.props.setDeliveryDayFilter(deliveryDay);
	        }, _this.createSelection = function () {
	            var days = [];
	            var selectedDays = [];
	            if (_this.props.pickupSites) {
	                for (var i in _this.props.pickupSites) {
	                    if (_this.props.pickupSites.hasOwnProperty(i)) {
	                        var pickupSite = _this.props.pickupSites[i];
	                        var deliveryDay = pickupSite.deliveryDaysList ? pickupSite.deliveryDaysList[0] : undefined;
	                        if (!days.includes(deliveryDay)) {
	                            days.push(deliveryDay);
	                        }
	                    }
	                }
	                if (days) {
	                    _this.sortDays(days).forEach(function (deliveryDay) {
	                        selectedDays.push(_react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            { key: deliveryDay, eventKey: deliveryDay },
	                            (0, _translate.translate)(deliveryDay)
	                        ));
	                    });
	                }
	                return _react2.default.createElement(
	                    _reactBootstrap.DropdownButton,
	                    { title: (0, _translate.translate)(!_this.state.deliveryDay ? 'All' : _this.state.deliveryDay), className: "select-day",
	                        id: "delivery-day-menu", onSelect: _this.onChangeDeliveryDay },
	                    _react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { key: "All", eventKey: "All" },
	                        (0, _translate.translate)("All")
	                    ),
	                    selectedDays
	                );
	            }
	        }, _this.sortDays = function (days) {
	            var weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	            return days.sort(function (a, b) {
	                return weekDays.indexOf(a) - weekDays.indexOf(b);
	            }.bind(days));
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(JoinPickupSiteFilter, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.deliveryDayFilter !== this.props.deliveryDayFilter) {
	                this.setState({ deliveryDayFilter: nextProps.deliveryDayFilter });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (this.props.clientViewPort.isXs) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: "pickup-site-filter-container" },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 4, className: "pickup-site-filter-col" },
	                        _react2.default.createElement(
	                            "label",
	                            { className: "pickup-site-filter-label" },
	                            (0, _translate.translate)("Filter by day")
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 8, className: "pickup-site-filter-col" },
	                        this.createSelection()
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: "pickup-site-filter-container" },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, className: "pickup-site-filter-day" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "pickup-site-filter-label" },
	                            (0, _translate.translate)("Filter by day")
	                        ),
	                        this.createSelection()
	                    )
	                );
	            }
	        }
	    }]);
	
	    return JoinPickupSiteFilter;
	}(_react2.default.Component);
	
	exports.default = JoinPickupSiteFilter;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleMaps = __webpack_require__(848);
	
	var _JoinPickupSiteFilter = __webpack_require__(846);
	
	var _JoinPickupSiteFilter2 = _interopRequireDefault(_JoinPickupSiteFilter);
	
	var _utils = __webpack_require__(485);
	
	var _constants = __webpack_require__(463);
	
	var _PickupSitesMap = __webpack_require__(1071);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinPickupSiteMap = function (_React$Component) {
	    _inherits(JoinPickupSiteMap, _React$Component);
	
	    function JoinPickupSiteMap() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinPickupSiteMap);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinPickupSiteMap.__proto__ || Object.getPrototypeOf(JoinPickupSiteMap)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            center: _this.props.centerLocation,
	            markers: [],
	            bounds: {},
	            zoom: _this.props.zoomLevel
	        }, _this.createMarker = function (pickupSite, icon, type) {
	            var lat = void 0;
	            var lng = void 0;
	            if (pickupSite.type === _constants.PickupSiteTypes.ZONE) {
	                lat = pickupSite.privateLat;
	                lng = pickupSite.privateLng;
	            } else {
	                lat = pickupSite.lat;
	                lng = pickupSite.lng;
	            }
	            return {
	                position: new google.maps.LatLng(lat, lng),
	                showInfo: false,
	                icon: icon,
	                title: pickupSite.title,
	                key: pickupSite.key,
	                pickupSite: pickupSite,
	                type: type
	            };
	        }, _this.getPickupSites = function (nextProps) {
	            var markers = [];
	            var bounds = void 0;
	            try {
	                bounds = new google.maps.LatLngBounds();
	            } catch (error) {
	                _this.props.errorFetching(_constants.GOOGLE_UNDEFINED_ERROR_MESSAGE);
	                return;
	            }
	            var availablePickupSites = nextProps.availablePickupSites || _this.props.availablePickupSites || [];
	            var waitListIcon = _utils.PATH_IMAGES + "site-waitlist-large.png";
	            var availableIcon = _utils.PATH_IMAGES + "site-large.png";
	            var siteNotSelectable = _utils.PATH_IMAGES + "site-not-selectable-large.png";
	
	            for (var i = 0; i < availablePickupSites.length; i++) {
	                var pickupSite = availablePickupSites[i];
	                var marker = void 0;
	                if (pickupSite.isAvailable) {
	                    marker = _this.createMarker(pickupSite, pickupSite.isNonSelectable ? siteNotSelectable : availableIcon, pickupSite.isNonSelectable ? 'notSelectable' : 'available');
	                } else if (!pickupSite.isAvailable && pickupSite.isWaitListAllowed) {
	                    marker = _this.createMarker(pickupSite, pickupSite.isNonSelectable ? siteNotSelectable : waitListIcon, pickupSite.isNonSelectable ? 'notSelectable' : 'waitList');
	                }
	                if (marker) {
	                    bounds.extend(marker.position);
	                    markers.push(marker);
	                }
	            }
	            if (_this.map) {
	                _this.map.fitBounds(bounds);
	            }
	            _this.setState({ markers: markers, bounds: bounds });
	        }, _this.handleMarkerClick = function (marker) {
	            var markers = _this.state.markers;
	            for (var i = 0; i < markers.length; i++) {
	                if (markers[i].showInfo) {
	                    markers[i].showInfo = false;
	                }
	            }
	            marker.showInfo = true;
	            _this.setState(_this.state);
	        }, _this.handleMarkerClose = function (marker) {
	            marker.showInfo = false;
	            _this.setState(_this.state);
	        }, _this.pickupSiteSelected = function (pickupSite, marker, isWaitList) {
	            if (_this.props.isValidPickupSiteSelection(pickupSite)) {
	                _this.props.setPickupSite(pickupSite, isWaitList);
	            }
	            _this.handleMarkerClose(marker);
	        }, _this.renderDeliveryDetails = function (pickupSite) {
	            if (pickupSite.deliveryHours && pickupSite.deliveryHours.length > 0) {
	                return (0, _translate.translate)(pickupSite.deliveryDays) + ', ' + pickupSite.deliveryHours;
	            }
	            return (0, _translate.translate)(pickupSite.deliveryDays);
	        }, _this.renderInfoWindow = function (index, marker) {
	            var pickupSite = marker.pickupSite;
	            var deliveryDetails = _this.renderDeliveryDetails(pickupSite);
	            return _react2.default.createElement(
	                _reactGoogleMaps.InfoWindow,
	                { key: index, onCloseClick: _this.handleMarkerClose.bind(_this, marker) },
	                _react2.default.createElement(
	                    "div",
	                    { className: "pick-up-site-info-window-container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "pick-up-site-info-window-title" },
	                        pickupSite.title
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "pick-up-site-info-window-address" },
	                        pickupSite.shortAddress
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "pick-up-site-info-window-day-hour" },
	                        deliveryDetails
	                    ),
	                    marker.type !== 'notSelectable' ? _react2.default.createElement(
	                        "div",
	                        { className: "select-location-map-link",
	                            onClick: _this.pickupSiteSelected.bind(_this, pickupSite, marker, marker.type === 'waitList'),
	                            id: pickupSite.key },
	                        (0, _translate.translate)("Select this location")
	                    ) : undefined
	                )
	            );
	        }, _this.handleMapCenterChanged = function () {
	            if (_this.map) {
	                var center = _this.map.getCenter();
	                if (center === _this.state.center) {
	                    return;
	                }
	                _this.setState({ center: center });
	                _this.props.setMapProps(undefined, center);
	            }
	        }, _this.handleMapZoomChanged = function () {
	            if (_this.map) {
	                var zoom = _this.map.getZoom();
	                if (zoom === _this.state.zoom) {
	                    return;
	                }
	                _this.setState({ zoom: zoom });
	                _this.props.setMapProps(zoom);
	            }
	        }, _this.handleMapMounted = function (map) {
	            if (map && !_this.props.zoomLevel) {
	                map.fitBounds(_this.state.bounds);
	                var zoom = map.getZoom();
	                _this.props.setMapProps(zoom);
	            }
	            _this.map = map;
	        }, _this.handleSearchBoxMounted = function (searchBox) {
	            _this._searchBox = searchBox;
	        }, _this.handlePlacesChanged = function () {
	            var places = _this._searchBox.getPlaces();
	
	            // Add a marker for each place returned from search bar
	            var markers = places.map(function (place) {
	                return {
	                    position: place.geometry.location
	                };
	            });
	
	            // Set markers; set map center to first search result
	            var mapCenter = markers.length > 0 ? markers[0].position : _this.state.center;
	
	            _this.setState({
	                center: mapCenter, zoom: 12
	            });
	        }, _this.handleBoundsChanged = function () {
	            _this.setState({
	                bounds: _this.map.getBounds(),
	                center: _this.map.getCenter()
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(JoinPickupSiteMap, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.getPickupSites({});
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (!(0, _utils.compareArrays)(nextProps.availablePickupSites, this.props.availablePickupSites)) {
	                this.setState({ zoom: undefined, center: undefined });
	                this.getPickupSites(nextProps);
	            }
	        }
	
	        //Toggle to 'true' to show InfoWindow and re-renders component
	
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_JoinPickupSiteFilter2.default, { clientViewPort: this.props.clientViewPort,
	                    deliveryDayFilter: this.props.deliveryDayFilter,
	                    setDeliveryDayFilter: this.props.setDeliveryDayFilter,
	                    pickupSiteSelectionType: _constants.PickupSiteSelectionTypes.MAP,
	                    pickupSites: this.props.pickupSites }),
	                this.props.clientViewPort.isXs ? undefined : _react2.default.createElement(
	                    "div",
	                    { className: "map-instructions" },
	                    (0, _translate.translate)("pickupSiteMapDetails")
	                ),
	                _react2.default.createElement(_PickupSitesMap.PickupSitesMap, { containerElement: _react2.default.createElement("div", { className: "google-map-container" }),
	                    mapElement: _react2.default.createElement("div", { style: { height: "100%" } }),
	                    options: this.props.options,
	                    center: this.state.center,
	                    markers: this.state.markers,
	                    zoom: this.state.zoom,
	                    bounds: this.state.bounds,
	                    handleMarkerClick: this.handleMarkerClick,
	                    handleMarkerClose: this.handleMarkerClose,
	                    renderInfoWindow: this.renderInfoWindow,
	                    handleMapZoomChanged: this.handleMapZoomChanged,
	                    handleMapCenterChanged: this.handleMapCenterChanged,
	                    onMapMounted: this.handleMapMounted,
	                    onSearchBoxMounted: this.handleSearchBoxMounted,
	                    onPlacesChanged: this.handlePlacesChanged,
	                    onBoundsChanged: this.handleBoundsChanged,
	                    isXs: this.props.clientViewPort.isXs }),
	                "/>"
	            );
	        }
	    }]);
	
	    return JoinPickupSiteMap;
	}(_react2.default.Component);
	
	exports.default = JoinPickupSiteMap;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	
	var _withScriptjs = __webpack_require__(849)
	
	Object.defineProperty(exports, "withScriptjs", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withScriptjs).default
	  },
	})
	
	var _withGoogleMap = __webpack_require__(929)
	
	Object.defineProperty(exports, "withGoogleMap", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withGoogleMap).default
	  },
	})
	
	var _GoogleMap = __webpack_require__(932)
	
	Object.defineProperty(exports, "GoogleMap", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GoogleMap).default
	  },
	})
	
	var _Circle = __webpack_require__(1048)
	
	Object.defineProperty(exports, "Circle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default
	  },
	})
	
	var _Marker = __webpack_require__(1049)
	
	Object.defineProperty(exports, "Marker", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Marker).default
	  },
	})
	
	var _Polyline = __webpack_require__(1050)
	
	Object.defineProperty(exports, "Polyline", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Polyline).default
	  },
	})
	
	var _Polygon = __webpack_require__(1051)
	
	Object.defineProperty(exports, "Polygon", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Polygon).default
	  },
	})
	
	var _Rectangle = __webpack_require__(1052)
	
	Object.defineProperty(exports, "Rectangle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rectangle).default
	  },
	})
	
	var _InfoWindow = __webpack_require__(1053)
	
	Object.defineProperty(exports, "InfoWindow", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InfoWindow).default
	  },
	})
	
	var _OverlayView = __webpack_require__(1054)
	
	Object.defineProperty(exports, "OverlayView", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OverlayView).default
	  },
	})
	
	var _GroundOverlay = __webpack_require__(1064)
	
	Object.defineProperty(exports, "GroundOverlay", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroundOverlay).default
	  },
	})
	
	var _DirectionsRenderer = __webpack_require__(1065)
	
	Object.defineProperty(exports, "DirectionsRenderer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DirectionsRenderer).default
	  },
	})
	
	var _FusionTablesLayer = __webpack_require__(1066)
	
	Object.defineProperty(exports, "FusionTablesLayer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FusionTablesLayer).default
	  },
	})
	
	var _KmlLayer = __webpack_require__(1067)
	
	Object.defineProperty(exports, "KmlLayer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_KmlLayer).default
	  },
	})
	
	var _TrafficLayer = __webpack_require__(1068)
	
	Object.defineProperty(exports, "TrafficLayer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TrafficLayer).default
	  },
	})
	
	var _StreetViewPanorama = __webpack_require__(1069)
	
	Object.defineProperty(exports, "StreetViewPanorama", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StreetViewPanorama).default
	  },
	})
	
	var _BicyclingLayer = __webpack_require__(1070)
	
	Object.defineProperty(exports, "BicyclingLayer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BicyclingLayer).default
	  },
	})
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	
	var _objectWithoutProperties2 = __webpack_require__(576)
	
	var _objectWithoutProperties3 = _interopRequireDefault(
	  _objectWithoutProperties2
	)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _bind2 = __webpack_require__(858)
	
	var _bind3 = _interopRequireDefault(_bind2)
	
	exports.withScriptjs = withScriptjs
	
	var _invariant = __webpack_require__(352)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _canUseDom = __webpack_require__(924)
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom)
	
	var _recompose = __webpack_require__(925)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	var LOADING_STATE_NONE = "NONE"
	var LOADING_STATE_BEGIN = "BEGIN"
	var LOADING_STATE_LOADED = "LOADED"
	
	function withScriptjs(BaseComponent) {
	  var factory = _react2.default.createFactory(BaseComponent)
	
	  var Container = (function(_React$PureComponent) {
	    ;(0, _inherits3.default)(Container, _React$PureComponent)
	
	    function Container() {
	      var _ref
	
	      var _temp, _this, _ret
	
	      ;(0, _classCallCheck3.default)(this, Container)
	
	      for (
	        var _len = arguments.length, args = Array(_len), _key = 0;
	        _key < _len;
	        _key++
	      ) {
	        args[_key] = arguments[_key]
	      }
	
	      return (
	        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
	          this,
	          (_ref =
	            Container.__proto__ ||
	            (0, _getPrototypeOf2.default)(Container)).call.apply(
	            _ref,
	            [this].concat(args)
	          )
	        )),
	        _this)),
	        (_this.state = {
	          loadingState: LOADING_STATE_NONE,
	        }),
	        (_this.isUnmounted = false),
	        (_this.handleLoaded = (0, _bind3.default)(_this.handleLoaded, _this)),
	        _temp)),
	        (0, _possibleConstructorReturn3.default)(_this, _ret)
	      )
	    }
	
	    ;(0, _createClass3.default)(Container, [
	      {
	        key: "handleLoaded",
	        value: function handleLoaded() {
	          if (this.isUnmounted) {
	            return
	          }
	          this.setState({
	            loadingState: LOADING_STATE_LOADED,
	          })
	        },
	      },
	      {
	        key: "componentWillMount",
	        value: function componentWillMount() {
	          var _props = this.props,
	            loadingElement = _props.loadingElement,
	            googleMapURL = _props.googleMapURL
	
	          ;(0, _invariant2.default)(
	            !!loadingElement && !!googleMapURL,
	            "Required props loadingElement or googleMapURL is missing. You need to provide both of them."
	          )
	        },
	      },
	      {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          var loadingState = this.state.loadingState
	
	          if (loadingState !== LOADING_STATE_NONE || !_canUseDom2.default) {
	            return
	          }
	          this.setState({
	            loadingState: LOADING_STATE_BEGIN,
	          })
	          // Don't load scriptjs as a dependency since we do not want this module be used on server side.
	          // eslint-disable-next-line global-require
	          var scriptjs = __webpack_require__(928)
	          var googleMapURL = this.props.googleMapURL
	
	          scriptjs(googleMapURL, this.handleLoaded)
	        },
	      },
	      {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          this.isUnmounted = true
	        },
	      },
	      {
	        key: "render",
	        value: function render() {
	          var _props2 = this.props,
	            loadingElement = _props2.loadingElement,
	            googleMapURL = _props2.googleMapURL,
	            restProps = (0, _objectWithoutProperties3.default)(_props2, [
	              "loadingElement",
	              "googleMapURL",
	            ])
	          var loadingState = this.state.loadingState
	
	          if (loadingState === LOADING_STATE_LOADED) {
	            return factory(restProps)
	          } else {
	            return loadingElement
	          }
	        },
	      },
	    ])
	    return Container
	  })(_react2.default.PureComponent)
	
	  Container.displayName =
	    "withScriptjs(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
	  Container.propTypes = {
	    loadingElement: _propTypes2.default.node.isRequired,
	    googleMapURL: _propTypes2.default.string.isRequired,
	  }
	
	  return Container
	}
	
	exports.default = withScriptjs


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(851), __esModule: true };

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(852);
	module.exports = __webpack_require__(499).Object.getPrototypeOf;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(531);
	var $getPrototypeOf = __webpack_require__(548);
	
	__webpack_require__(853)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(497);
	var core = __webpack_require__(499);
	var fails = __webpack_require__(508);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(855);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(856), __esModule: true };

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(857);
	var $Object = __webpack_require__(499).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(497);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(507), 'Object', { defineProperty: __webpack_require__(503).f });


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(859),
	    createWrap = __webpack_require__(876),
	    getHolder = __webpack_require__(912),
	    replaceHolders = __webpack_require__(915);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of `thisArg`
	 * and `partials` prepended to the arguments it receives.
	 *
	 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	 * property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * function greet(greeting, punctuation) {
	 *   return greeting + ' ' + this.user + punctuation;
	 * }
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * var bound = _.bind(greet, object, 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bind(greet, object, _, '!');
	 * bound('hi');
	 * // => 'hi fred!'
	 */
	var bind = baseRest(function(func, thisArg, partials) {
	  var bitmask = WRAP_BIND_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getHolder(bind));
	    bitmask |= WRAP_PARTIAL_FLAG;
	  }
	  return createWrap(func, bitmask, thisArg, partials, holders);
	});
	
	// Assign default placeholders.
	bind.placeholder = {};
	
	module.exports = bind;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(860),
	    overRest = __webpack_require__(861),
	    setToString = __webpack_require__(863);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 860 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(862);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 862 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(864),
	    shortOut = __webpack_require__(875);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(865),
	    defineProperty = __webpack_require__(866),
	    identity = __webpack_require__(860);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 865 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(867);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(868),
	    getValue = __webpack_require__(874);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(869),
	    isMasked = __webpack_require__(871),
	    isObject = __webpack_require__(870),
	    toSource = __webpack_require__(873);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(410),
	    isObject = __webpack_require__(870);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 870 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(872);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(412);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 873 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 874 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 875 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(877),
	    createBind = __webpack_require__(880),
	    createCurry = __webpack_require__(883),
	    createHybrid = __webpack_require__(884),
	    createPartial = __webpack_require__(916),
	    getData = __webpack_require__(892),
	    mergeData = __webpack_require__(917),
	    setData = __webpack_require__(901),
	    setWrapToString = __webpack_require__(902),
	    toInteger = __webpack_require__(918);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(860),
	    metaMap = __webpack_require__(878);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(879);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(867),
	    root = __webpack_require__(412);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(881),
	    root = __webpack_require__(412);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(882),
	    isObject = __webpack_require__(870);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(870);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(862),
	    createCtor = __webpack_require__(881),
	    createHybrid = __webpack_require__(884),
	    createRecurry = __webpack_require__(888),
	    getHolder = __webpack_require__(912),
	    replaceHolders = __webpack_require__(915),
	    root = __webpack_require__(412);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(885),
	    composeArgsRight = __webpack_require__(886),
	    countHolders = __webpack_require__(887),
	    createCtor = __webpack_require__(881),
	    createRecurry = __webpack_require__(888),
	    getHolder = __webpack_require__(912),
	    reorder = __webpack_require__(913),
	    replaceHolders = __webpack_require__(915),
	    root = __webpack_require__(412);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ }),
/* 885 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ }),
/* 886 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ }),
/* 887 */
/***/ (function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(889),
	    setData = __webpack_require__(901),
	    setWrapToString = __webpack_require__(902);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(890),
	    getData = __webpack_require__(892),
	    getFuncName = __webpack_require__(894),
	    lodash = __webpack_require__(896);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(882),
	    baseLodash = __webpack_require__(891);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ }),
/* 891 */
/***/ (function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(878),
	    noop = __webpack_require__(893);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ }),
/* 893 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(895);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ }),
/* 895 */
/***/ (function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(890),
	    LodashWrapper = __webpack_require__(897),
	    baseLodash = __webpack_require__(891),
	    isArray = __webpack_require__(898),
	    isObjectLike = __webpack_require__(418),
	    wrapperClone = __webpack_require__(899);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(882),
	    baseLodash = __webpack_require__(891);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ }),
/* 898 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(890),
	    LodashWrapper = __webpack_require__(897),
	    copyArray = __webpack_require__(900);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ }),
/* 900 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(877),
	    shortOut = __webpack_require__(875);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(903),
	    insertWrapDetails = __webpack_require__(904),
	    setToString = __webpack_require__(863),
	    updateWrapDetails = __webpack_require__(905);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ }),
/* 903 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ }),
/* 904 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(906),
	    arrayIncludes = __webpack_require__(907);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ }),
/* 906 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(908);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(909),
	    baseIsNaN = __webpack_require__(910),
	    strictIndexOf = __webpack_require__(911);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 909 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 910 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 911 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 912 */
/***/ (function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(900),
	    isIndex = __webpack_require__(914);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ }),
/* 914 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 915 */
/***/ (function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(862),
	    createCtor = __webpack_require__(881),
	    root = __webpack_require__(412);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(885),
	    composeArgsRight = __webpack_require__(886),
	    replaceHolders = __webpack_require__(915);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(919);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(920);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(921),
	    isObject = __webpack_require__(870),
	    isSymbol = __webpack_require__(923);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(922);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 922 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(410),
	    isObjectLike = __webpack_require__(418);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 924 */
/***/ (function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(338);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(926));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(376));
	var changeEmitter = __webpack_require__(927);
	var $$observable = _interopDefault(__webpack_require__(419));
	
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	var setDisplayName = function setDisplayName(displayName) {
	  return setStatic('displayName', displayName);
	};
	
	var getDisplayName = function getDisplayName(Component$$1) {
	  if (typeof Component$$1 === 'string') {
	    return Component$$1;
	  }
	
	  if (!Component$$1) {
	    return undefined;
	  }
	
	  return Component$$1.displayName || Component$$1.name || 'Component';
	};
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + getDisplayName(BaseComponent) + ')';
	};
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var MapProps = function MapProps(props) {
	      return factory(propsMapper(props));
	    };
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
	    }
	    return MapProps;
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var withProps = function withProps(input) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var pick = function pick(obj, keys) {
	  var result = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	  return result;
	};
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !shallowEqual(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
	    };
	
	    var WithPropsOnChange = function (_Component) {
	      inherits(WithPropsOnChange, _Component);
	
	      function WithPropsOnChange() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithPropsOnChange);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (shouldMap(this.props, nextProps)) {
	          this.computedProps = propsMapper(nextProps);
	        }
	      };
	
	      WithPropsOnChange.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.computedProps));
	      };
	
	      return WithPropsOnChange;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
	    }
	    return WithPropsOnChange;
	  };
	};
	
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	  return result;
	};
	
	/* eslint-disable no-console */
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithHandlers = function (_Component) {
	      inherits(WithHandlers, _Component);
	
	      function WithHandlers() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithHandlers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	        this.cachedHandlers = {};
	      };
	
	      WithHandlers.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return WithHandlers;
	    }(React.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.cachedHandlers = {};
	      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
	        return function () {
	          var cachedHandler = _this2.cachedHandlers[handlerName];
	          if (cachedHandler) {
	            return cachedHandler.apply(undefined, arguments);
	          }
	
	          var handler = createHandler(_this2.props);
	          _this2.cachedHandlers[handlerName] = handler;
	
	          if (false) {
	            console.error(
	            // eslint-disable-line no-console
	            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	          }
	
	          return handler.apply(undefined, arguments);
	        };
	      });
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
	    }
	    return WithHandlers;
	  };
	};
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	    DefaultProps.defaultProps = props;
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
	    }
	    return DefaultProps;
	  };
	};
	
	var omit = function omit(obj, keys) {
	  var rest = objectWithoutProperties(obj, []);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	  return rest;
	};
	
	var renameProp = function renameProp(oldName, newName) {
	  var hoc = mapProps(function (props) {
	    var _babelHelpers$extends;
	
	    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var keys = Object.keys;
	
	
	var mapKeys = function mapKeys(obj, func) {
	  return keys(obj).reduce(function (result, key) {
	    var val = obj[key];
	    /* eslint-disable no-param-reassign */
	    result[func(val, key)] = val;
	    /* eslint-enable no-param-reassign */
	    return result;
	  }, {});
	};
	
	var renameProps = function renameProps(nameMap) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
	      return nameMap[oldName];
	    }));
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var flattenProp = function flattenProp(propName) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var FlattenProp = function FlattenProp(props) {
	      return factory(_extends({}, props, props[propName]));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
	    }
	    return FlattenProp;
	  };
	};
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithState = function (_Component) {
	      inherits(WithState, _Component);
	
	      function WithState() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithState);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        }, _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithState.prototype.render = function render() {
	        var _babelHelpers$extends;
	
	        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
	      };
	
	      return WithState;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
	    }
	    return WithState;
	  };
	};
	
	var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithStateHandlers = function (_Component) {
	      inherits(WithStateHandlers, _Component);
	
	      function WithStateHandlers() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithStateHandlers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        var propsChanged = nextProps !== this.props;
	        // the idea is to skip render if stateUpdater handler return undefined
	        // this allows to create no state update handlers with access to state and props
	        var stateChanged = !shallowEqual(nextState, this.state);
	        return propsChanged || stateChanged;
	      };
	
	      WithStateHandlers.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
	      };
	
	      return WithStateHandlers;
	    }(React.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
	      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
	        return function (mayBeEvent) {
	          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          // Having that functional form of setState can be called async
	          // we need to persist SyntheticEvent
	          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
	            mayBeEvent.persist();
	          }
	
	          _this2.setState(function (state, props) {
	            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
	          });
	        };
	      });
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
	    }
	    return WithStateHandlers;
	  };
	};
	
	var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithReducer = function (_Component) {
	      inherits(WithReducer, _Component);
	
	      function WithReducer() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithReducer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: _this.initializeStateValue()
	        }, _this.dispatch = function (action) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: reducer(stateValue, action)
	            };
	          });
	        }, _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
	        if (initialState !== undefined) {
	          return typeof initialState === 'function' ? initialState(this.props) : initialState;
	        }
	        return reducer(undefined, { type: '@@recompose/INIT' });
	      };
	
	      WithReducer.prototype.render = function render() {
	        var _babelHelpers$extends;
	
	        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
	      };
	
	      return WithReducer;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
	    }
	    return WithReducer;
	  };
	};
	
	var identity = function identity(Component$$1) {
	  return Component$$1;
	};
	
	var branch = function branch(test, left) {
	  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
	  return function (BaseComponent) {
	    var leftFactory = void 0;
	    var rightFactory = void 0;
	    var Branch = function Branch(props) {
	      if (test(props)) {
	        leftFactory = leftFactory || React.createFactory(left(BaseComponent));
	        return leftFactory(props);
	      }
	      rightFactory = rightFactory || React.createFactory(right(BaseComponent));
	      return rightFactory(props);
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
	    }
	    return Branch;
	  };
	};
	
	var renderComponent = function renderComponent(Component$$1) {
	  return function (_) {
	    var factory = React.createFactory(Component$$1);
	    var RenderComponent = function RenderComponent(props) {
	      return factory(props);
	    };
	    if (false) {
	      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
	    }
	    return RenderComponent;
	  };
	};
	
	var Nothing = function (_Component) {
	  inherits(Nothing, _Component);
	
	  function Nothing() {
	    classCallCheck(this, Nothing);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Nothing.prototype.render = function render() {
	    return null;
	  };
	
	  return Nothing;
	}(React.Component);
	
	var renderNothing = function renderNothing(_) {
	  return Nothing;
	};
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        classCallCheck(this, ShouldUpdate);
	        return possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	var pure = function pure(BaseComponent) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(props, nextProps);
	  });
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(pick(nextProps, propKeys), pick(props, propKeys));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
	  var propTypes = BaseComponent.propTypes;
	
	  if (false) {
	    if (!propTypes) {
	      /* eslint-disable */
	      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
	      /* eslint-enable */
	    }
	  }
	
	  var propKeys = Object.keys(propTypes || {});
	  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
	  }
	  return OnlyUpdateForPropTypes;
	};
	
	var withContext = function withContext(childContextTypes, getChildContext) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithContext = function (_Component) {
	      inherits(WithContext, _Component);
	
	      function WithContext() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithContext);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
	          return getChildContext(_this.props);
	        }, _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithContext.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return WithContext;
	    }(React.Component);
	
	    WithContext.childContextTypes = childContextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
	    }
	    return WithContext;
	  };
	};
	
	var getContext = function getContext(contextTypes) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var GetContext = function GetContext(ownerProps, context) {
	      return factory(_extends({}, ownerProps, context));
	    };
	
	    GetContext.contextTypes = contextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
	    }
	    return GetContext;
	  };
	};
	
	/* eslint-disable no-console */
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    var Lifecycle = function (_Component) {
	      inherits(Lifecycle, _Component);
	
	      function Lifecycle() {
	        classCallCheck(this, Lifecycle);
	        return possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      Lifecycle.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state));
	      };
	
	      return Lifecycle;
	    }(React.Component);
	
	    Object.keys(spec).forEach(function (hook) {
	      return Lifecycle.prototype[hook] = spec[hook];
	    });
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
	    }
	    return Lifecycle;
	  };
	};
	
	var isClassComponent = function isClassComponent(Component$$1) {
	  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
	};
	
	var toClass = function toClass(baseComponent) {
	  if (isClassComponent(baseComponent)) {
	    return baseComponent;
	  }
	
	  var ToClass = function (_Component) {
	    inherits(ToClass, _Component);
	
	    function ToClass() {
	      classCallCheck(this, ToClass);
	      return possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ToClass.prototype.render = function render() {
	      if (typeof baseComponent === 'string') {
	        return React__default.createElement(baseComponent, this.props);
	      }
	      return baseComponent(this.props, this.context);
	    };
	
	    return ToClass;
	  }(React.Component);
	
	  ToClass.displayName = getDisplayName(baseComponent);
	  ToClass.propTypes = baseComponent.propTypes;
	  ToClass.contextTypes = baseComponent.contextTypes;
	  ToClass.defaultProps = baseComponent.defaultProps;
	
	  return ToClass;
	};
	
	var setPropTypes = function setPropTypes(propTypes) {
	  return setStatic('propTypes', propTypes);
	};
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	var createSink = function createSink(callback) {
	  return function (_Component) {
	    inherits(Sink, _Component);
	
	    function Sink() {
	      classCallCheck(this, Sink);
	      return possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Sink.prototype.componentWillMount = function componentWillMount() {
	      callback(this.props);
	    };
	
	    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      callback(nextProps);
	    };
	
	    Sink.prototype.render = function render() {
	      return null;
	    };
	
	    return Sink;
	  }(React.Component);
	};
	
	var componentFromProp = function componentFromProp(propName) {
	  var Component$$1 = function Component$$1(props) {
	    return React.createElement(props[propName], omit(props, [propName]));
	  };
	  Component$$1.displayName = 'componentFromProp(' + propName + ')';
	  return Component$$1;
	};
	
	var nest = function nest() {
	  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
	    Components[_key] = arguments[_key];
	  }
	
	  var factories = Components.map(React.createFactory);
	  var Nest = function Nest(_ref) {
	    var props = objectWithoutProperties(_ref, []),
	        children = _ref.children;
	    return factories.reduceRight(function (child, factory) {
	      return factory(props, child);
	    }, children);
	  };
	
	  if (false) {
	    var displayNames = Components.map(getDisplayName);
	    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
	  }
	
	  return Nest;
	};
	
	var hoistStatics = function hoistStatics(higherOrderComponent) {
	  return function (BaseComponent) {
	    var NewComponent = higherOrderComponent(BaseComponent);
	    hoistNonReactStatics(NewComponent, BaseComponent);
	    return NewComponent;
	  };
	};
	
	var _config = {
	  fromESObservable: null,
	  toESObservable: null
	};
	
	var configureObservable = function configureObservable(c) {
	  _config = c;
	};
	
	var config = {
	  fromESObservable: function fromESObservable(observable) {
	    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
	  },
	  toESObservable: function toESObservable(stream) {
	    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
	  }
	};
	
	var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
	  return function (propsToVdom) {
	    return function (_Component) {
	      inherits(ComponentFromStream, _Component);
	
	      function ComponentFromStream() {
	        var _config$fromESObserva;
	
	        var _temp, _this, _ret;
	
	        classCallCheck(this, ComponentFromStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = changeEmitter.createChangeEmitter(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
	          subscribe: function subscribe(observer) {
	            var unsubscribe = _this.propsEmitter.listen(function (props) {
	              if (props) {
	                observer.next(props);
	              } else {
	                observer.complete();
	              }
	            });
	            return { unsubscribe: unsubscribe };
	          }
	        }, _config$fromESObserva[$$observable] = function () {
	          return this;
	        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      // Stream of props
	
	
	      // Stream of vdom
	
	
	      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        // Subscribe to child prop changes so we know when to re-render
	        this.subscription = this.vdom$.subscribe({
	          next: function next(vdom) {
	            _this2.setState({ vdom: vdom });
	          }
	        });
	        this.propsEmitter.emit(this.props);
	      };
	
	      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        // Receive new props from the owner
	        this.propsEmitter.emit(nextProps);
	      };
	
	      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        return nextState.vdom !== this.state.vdom;
	      };
	
	      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
	        // Call without arguments to complete stream
	        this.propsEmitter.emit();
	
	        // Clean-up subscription before un-mounting
	        this.subscription.unsubscribe();
	      };
	
	      ComponentFromStream.prototype.render = function render() {
	        return this.state.vdom;
	      };
	
	      return ComponentFromStream;
	    }(React.Component);
	  };
	};
	
	var componentFromStream = function componentFromStream(propsToVdom) {
	  return componentFromStreamWithConfig(config)(propsToVdom);
	};
	
	var identity$1 = function identity(t) {
	  return t;
	};
	
	var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
	  var componentFromStream = componentFromStreamWithConfig({
	    fromESObservable: identity$1,
	    toESObservable: identity$1
	  });
	  return function (transform) {
	    return function (BaseComponent) {
	      var factory = React.createFactory(BaseComponent);
	      var fromESObservable = config$$1.fromESObservable,
	          toESObservable = config$$1.toESObservable;
	
	      return componentFromStream(function (props$) {
	        var _ref;
	
	        return _ref = {
	          subscribe: function subscribe(observer) {
	            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
	              next: function next(childProps) {
	                return observer.next(factory(childProps));
	              }
	            });
	            return {
	              unsubscribe: function unsubscribe() {
	                return subscription.unsubscribe();
	              }
	            };
	          }
	        }, _ref[$$observable] = function () {
	          return this;
	        }, _ref;
	      });
	    };
	  };
	};
	
	var mapPropsStream = function mapPropsStream(transform) {
	  var hoc = mapPropsStreamWithConfig(config)(transform);
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
	  return function () {
	    var _config$fromESObserva;
	
	    var emitter = changeEmitter.createChangeEmitter();
	    var stream = config$$1.fromESObservable((_config$fromESObserva = {
	      subscribe: function subscribe(observer) {
	        var unsubscribe = emitter.listen(function (value) {
	          return observer.next(value);
	        });
	        return { unsubscribe: unsubscribe };
	      }
	    }, _config$fromESObserva[$$observable] = function () {
	      return this;
	    }, _config$fromESObserva));
	    return {
	      handler: emitter.emit,
	      stream: stream
	    };
	  };
	};
	
	var createEventHandler = createEventHandlerWithConfig(config);
	
	// Higher-order component helpers
	
	exports.mapProps = mapProps;
	exports.withProps = withProps;
	exports.withPropsOnChange = withPropsOnChange;
	exports.withHandlers = withHandlers;
	exports.defaultProps = defaultProps;
	exports.renameProp = renameProp;
	exports.renameProps = renameProps;
	exports.flattenProp = flattenProp;
	exports.withState = withState;
	exports.withStateHandlers = withStateHandlers;
	exports.withReducer = withReducer;
	exports.branch = branch;
	exports.renderComponent = renderComponent;
	exports.renderNothing = renderNothing;
	exports.shouldUpdate = shouldUpdate;
	exports.pure = pure;
	exports.onlyUpdateForKeys = onlyUpdateForKeys;
	exports.onlyUpdateForPropTypes = onlyUpdateForPropTypes;
	exports.withContext = withContext;
	exports.getContext = getContext;
	exports.lifecycle = lifecycle;
	exports.toClass = toClass;
	exports.setStatic = setStatic;
	exports.setPropTypes = setPropTypes;
	exports.setDisplayName = setDisplayName;
	exports.compose = compose;
	exports.getDisplayName = getDisplayName;
	exports.wrapDisplayName = wrapDisplayName;
	exports.shallowEqual = shallowEqual;
	exports.isClassComponent = isClassComponent;
	exports.createSink = createSink;
	exports.componentFromProp = componentFromProp;
	exports.nest = nest;
	exports.hoistStatics = hoistStatics;
	exports.componentFromStream = componentFromStream;
	exports.componentFromStreamWithConfig = componentFromStreamWithConfig;
	exports.mapPropsStream = mapPropsStream;
	exports.mapPropsStreamWithConfig = mapPropsStreamWithConfig;
	exports.createEventHandler = createEventHandler;
	exports.createEventHandlerWithConfig = createEventHandlerWithConfig;
	exports.setObservableConfig = configureObservable;


/***/ }),
/* 926 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 927 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  function listen(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function () {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  function emit() {
	    currentListeners = nextListeners;
	    var listeners = currentListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i].apply(listeners, arguments);
	    }
	  }
	
	  return {
	    listen: listen,
	    emit: emit
	  };
	};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      fn(el)
	      return 1
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	
	var _objectWithoutProperties2 = __webpack_require__(576)
	
	var _objectWithoutProperties3 = _interopRequireDefault(
	  _objectWithoutProperties2
	)
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _bind2 = __webpack_require__(858)
	
	var _bind3 = _interopRequireDefault(_bind2)
	
	exports.withGoogleMap = withGoogleMap
	
	var _warning = __webpack_require__(358)
	
	var _warning2 = _interopRequireDefault(_warning)
	
	var _invariant = __webpack_require__(352)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _recompose = __webpack_require__(925)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/* global google */
	function withGoogleMap(BaseComponent) {
	  var factory = _react2.default.createFactory(BaseComponent)
	
	  var Container = (function(_React$PureComponent) {
	    ;(0, _inherits3.default)(Container, _React$PureComponent)
	
	    function Container() {
	      var _ref
	
	      var _temp, _this, _ret
	
	      ;(0, _classCallCheck3.default)(this, Container)
	
	      for (
	        var _len = arguments.length, args = Array(_len), _key = 0;
	        _key < _len;
	        _key++
	      ) {
	        args[_key] = arguments[_key]
	      }
	
	      return (
	        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
	          this,
	          (_ref =
	            Container.__proto__ ||
	            (0, _getPrototypeOf2.default)(Container)).call.apply(
	            _ref,
	            [this].concat(args)
	          )
	        )),
	        _this)),
	        (_this.state = {
	          map: null,
	        }),
	        (_this.handleComponentMount = (0, _bind3.default)(
	          _this.handleComponentMount,
	          _this
	        )),
	        _temp)),
	        (0, _possibleConstructorReturn3.default)(_this, _ret)
	      )
	    }
	
	    ;(0, _createClass3.default)(Container, [
	      {
	        key: "getChildContext",
	        value: function getChildContext() {
	          return (0, _defineProperty3.default)(
	            {},
	            _constants.MAP,
	            this.state.map
	          )
	        },
	      },
	      {
	        key: "componentWillMount",
	        value: function componentWillMount() {
	          var _props = this.props,
	            containerElement = _props.containerElement,
	            mapElement = _props.mapElement
	
	          ;(0, _invariant2.default)(
	            !!containerElement && !!mapElement,
	            "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized."
	          )
	        },
	      },
	      {
	        key: "handleComponentMount",
	        value: function handleComponentMount(node) {
	          if (this.state.map || node === null) {
	            return
	          }
	          ;(0, _warning2.default)(
	            "undefined" !== typeof google,
	            "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168"
	          )
	          // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	          var map = new google.maps.Map(node)
	          this.setState({ map: map })
	        },
	      },
	      {
	        key: "render",
	        value: function render() {
	          var _props2 = this.props,
	            containerElement = _props2.containerElement,
	            mapElement = _props2.mapElement,
	            restProps = (0, _objectWithoutProperties3.default)(_props2, [
	              "containerElement",
	              "mapElement",
	            ])
	          var map = this.state.map
	
	          if (map) {
	            return _react2.default.cloneElement(
	              containerElement,
	              {},
	              _react2.default.cloneElement(mapElement, {
	                ref: this.handleComponentMount,
	              }),
	              _react2.default.createElement("div", null, factory(restProps))
	            )
	          } else {
	            return _react2.default.cloneElement(
	              containerElement,
	              {},
	              _react2.default.cloneElement(mapElement, {
	                ref: this.handleComponentMount,
	              }),
	              _react2.default.createElement("div", null)
	            )
	          }
	        },
	      },
	    ])
	    return Container
	  })(_react2.default.PureComponent)
	
	  Container.displayName =
	    "withGoogleMap(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
	  Container.propTypes = {
	    containerElement: _propTypes2.default.node.isRequired,
	    mapElement: _propTypes2.default.node.isRequired,
	  }
	  Container.childContextTypes = (0, _defineProperty3.default)(
	    {},
	    _constants.MAP,
	    _propTypes2.default.object
	  )
	
	  return Container
	}
	
	exports.default = withGoogleMap


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(855);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 931 */
/***/ (function(module, exports) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	var MAP = (exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;
	
	var MARKER = (exports.MARKER =
	  "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var MARKER_WITH_LABEL = (exports.MARKER_WITH_LABEL =
	  "__SECRET_MARKER_WITH_LABEL_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var RECTANGLE = (exports.RECTANGLE =
	  "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var POLYLINE = (exports.POLYLINE =
	  "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var POLYGON = (exports.POLYGON =
	  "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var CIRCLE = (exports.CIRCLE =
	  "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var KML_LAYER = (exports.KML_LAYER =
	  "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var DIRECTIONS_RENDERER = (exports.DIRECTIONS_RENDERER =
	  "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var HEATMAP_LAYER = (exports.HEATMAP_LAYER =
	  "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var FUSION_TABLES_LAYER = (exports.FUSION_TABLES_LAYER =
	  "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var ANCHOR = (exports.ANCHOR =
	  "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var INFO_WINDOW = (exports.INFO_WINDOW =
	  "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var OVERLAY_VIEW = (exports.OVERLAY_VIEW =
	  "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var GROUND_LAYER = (exports.GROUND_LAYER =
	  "__SECRET_GROUND_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var DRAWING_MANAGER = (exports.DRAWING_MANAGER =
	  "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var SEARCH_BOX = (exports.SEARCH_BOX =
	  "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var MARKER_CLUSTERER = (exports.MARKER_CLUSTERER =
	  "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var INFO_BOX = (exports.INFO_BOX =
	  "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var TRAFFIC_LAYER = (exports.TRAFFIC_LAYER =
	  "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var STREET_VIEW_PANORAMA = (exports.STREET_VIEW_PANORAMA =
	  "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var BICYCLING_LAYER = (exports.BICYCLING_LAYER =
	  "__SECRET_BICYCLING_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.GoogleMap = exports.Map = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _toConsumableArray2 = __webpack_require__(933)
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _invariant = __webpack_require__(352)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Map`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	 */
	var Map = (exports.Map = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Map, _React$PureComponent)
	  ;(0, _createClass3.default)(Map, [
	    {
	      key: "fitBounds",
	
	      /**
	     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	     * @public 
	     */
	      value: function fitBounds() {
	        var _context$MAP
	
	        return (_context$MAP = this.context[_constants.MAP]).fitBounds.apply(
	          _context$MAP,
	          arguments
	        )
	      },
	
	      /**
	     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	     * @public 
	     */
	    },
	    {
	      key: "panBy",
	      value: function panBy() {
	        var _context$MAP2
	
	        return (_context$MAP2 = this.context[_constants.MAP]).panBy.apply(
	          _context$MAP2,
	          arguments
	        )
	      },
	
	      /**
	     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	     * @public 
	     */
	    },
	    {
	      key: "panTo",
	      value: function panTo() {
	        var _context$MAP3
	
	        return (_context$MAP3 = this.context[_constants.MAP]).panTo.apply(
	          _context$MAP3,
	          arguments
	        )
	      },
	
	      /**
	     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	     * @public 
	     */
	    },
	    {
	      key: "panToBounds",
	      value: function panToBounds() {
	        var _context$MAP4
	
	        return (_context$MAP4 = this.context[_constants.MAP]).panToBounds.apply(
	          _context$MAP4,
	          arguments
	        )
	      },
	
	      /*
	     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	     */
	    },
	  ])
	
	  function Map(props, context) {
	    ;(0, _classCallCheck3.default)(this, Map)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    ;(0, _invariant2.default)(
	      !!_this.context[_constants.MAP],
	      "Did you wrap <GoogleMap> component with withGoogleMap() HOC?"
	    )
	    ;(0, _MapChildHelper.construct)(
	      GoogleMap.propTypes,
	      updaterMap,
	      _this.props,
	      _this.context[_constants.MAP]
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Map, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.context[_constants.MAP],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.context[_constants.MAP],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        var children = this.props.children
	
	        return _react2.default.createElement("div", null, children)
	      },
	
	      /**
	     * Returns the lat/lng bounds of the current viewport. If more than one copy of the world is visible, the bounds range in longitude from -180 to 180 degrees inclusive. If the map is not yet initialized (i.e. the mapType is still null), or center and zoom have not been set then the result is `null` or `undefined`.
	     * @type LatLngBoundsnullundefined
	     * @public 
	     */
	    },
	    {
	      key: "getBounds",
	      value: function getBounds() {
	        return this.context[_constants.MAP].getBounds()
	      },
	
	      /**
	     * Returns the position displayed at the center of the map. Note that this `LatLng` object is _not_ wrapped. See `[LatLng](#LatLng)` for more information.
	     * @type LatLngLatLngLatLng
	     * @public 
	     */
	    },
	    {
	      key: "getCenter",
	      value: function getCenter() {
	        return this.context[_constants.MAP].getCenter()
	      },
	
	      /**
	     * Returns the clickability of the map icons. A map icon represents a point of interest, also known as a POI. If the returned value is true, then the icons are clickable on the map.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getClickableIcons",
	      value: function getClickableIcons() {
	        return this.context[_constants.MAP].getClickableIcons()
	      },
	
	      /**
	     * 
	     * @type Element
	     * @public 
	     */
	    },
	    {
	      key: "getDiv",
	      value: function getDiv() {
	        return this.context[_constants.MAP].getDiv()
	      },
	
	      /**
	     * Returns the compass heading of aerial imagery. The heading value is measured in degrees (clockwise) from cardinal direction North.
	     * @type number
	     * @public 
	     */
	    },
	    {
	      key: "getHeading",
	      value: function getHeading() {
	        return this.context[_constants.MAP].getHeading()
	      },
	
	      /**
	     * 
	     * @type MapTypeId|string
	     * @public 
	     */
	    },
	    {
	      key: "getMapTypeId",
	      value: function getMapTypeId() {
	        return this.context[_constants.MAP].getMapTypeId()
	      },
	
	      /**
	     * Returns the current `Projection`. If the map is not yet initialized (i.e. the mapType is still null) then the result is null. Listen to `projection_changed` and check its value to ensure it is not null.
	     * @type ProjectionProjectionprojection_changed
	     * @public 
	     */
	    },
	    {
	      key: "getProjection",
	      value: function getProjection() {
	        return this.context[_constants.MAP].getProjection()
	      },
	
	      /**
	     * Returns the default `StreetViewPanorama` bound to the map, which may be a default panorama embedded within the map, or the panorama set using `setStreetView()`. Changes to the map's `streetViewControl` will be reflected in the display of such a bound panorama.
	     * @type StreetViewPanoramaStreetViewPanoramasetStreetView()streetViewControl
	     * @public 
	     */
	    },
	    {
	      key: "getStreetView",
	      value: function getStreetView() {
	        return this.context[_constants.MAP].getStreetView()
	      },
	
	      /**
	     * Returns the current angle of incidence of the map, in degrees from the viewport plane to the map plane. The result will be `0` for imagery taken directly overhead or `45` for 45° imagery. 45° imagery is only available for `satellite` and `hybrid` map types, within some locations, and at some zoom levels. **Note:** This method does not return the value set by `setTilt`. See `setTilt` for details.
	     * @type number045satellitehybridsetTiltsetTilt
	     * @public 
	     */
	    },
	    {
	      key: "getTilt",
	      value: function getTilt() {
	        return this.context[_constants.MAP].getTilt()
	      },
	
	      /**
	     * 
	     * @type number
	     * @public 
	     */
	    },
	    {
	      key: "getZoom",
	      value: function getZoom() {
	        return this.context[_constants.MAP].getZoom()
	      },
	    },
	  ])
	  return Map
	})(
	  _react2.default.PureComponent
	)) /*
	                                   * -----------------------------------------------------------------------------
	                                   * This file is auto-generated from the corresponding file at `src/macros/`.
	                                   * Please **DO NOT** edit this file directly when creating PRs.
	                                   * -----------------------------------------------------------------------------
	                                   */
	
	Map.displayName = "GoogleMap"
	Map.propTypes = {
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapTypeRegistry
	   * @type Array<[id:string, mapType:MapType|*]>
	   */
	  defaultExtraMapTypes: _propTypes2.default.arrayOf(
	    _propTypes2.default.arrayOf(_propTypes2.default.any)
	  ),
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  defaultCenter: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultClickableIcons: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  defaultHeading: _propTypes2.default.number,
	
	  /**
	   * @type MapTypeId|string
	   */
	  defaultMapTypeId: _propTypes2.default.any,
	
	  /**
	   * @type MapOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type StreetViewPanorama
	   */
	  defaultStreetView: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  defaultTilt: _propTypes2.default.number,
	
	  /**
	   * @type number
	   */
	  defaultZoom: _propTypes2.default.number,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  center: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  clickableIcons: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  heading: _propTypes2.default.number,
	
	  /**
	   * @type MapTypeId|string
	   */
	  mapTypeId: _propTypes2.default.any,
	
	  /**
	   * @type MapOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type StreetViewPanorama
	   */
	  streetView: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  tilt: _propTypes2.default.number,
	
	  /**
	   * @type number
	   */
	  zoom: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMapTypeIdChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onTilesLoaded: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onBoundsChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onCenterChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onHeadingChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onIdle: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onProjectionChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onResize: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onTiltChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onZoomChanged: _propTypes2.default.func,
	}
	Map.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	var GoogleMap = (exports.GoogleMap = Map)
	
	exports.default = Map
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMapTypeIdChanged: "maptypeid_changed",
	  onMouseMove: "mousemove",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onRightClick: "rightclick",
	  onTilesLoaded: "tilesloaded",
	  onBoundsChanged: "bounds_changed",
	  onCenterChanged: "center_changed",
	  onClick: "click",
	  onDrag: "drag",
	  onHeadingChanged: "heading_changed",
	  onIdle: "idle",
	  onProjectionChanged: "projection_changed",
	  onResize: "resize",
	  onTiltChanged: "tilt_changed",
	  onZoomChanged: "zoom_changed",
	}
	
	var updaterMap = {
	  extraMapTypes: function extraMapTypes(instance, extra) {
	    extra.forEach(function(it) {
	      var _instance$mapTypes
	
	      return (_instance$mapTypes = instance.mapTypes).set.apply(
	        _instance$mapTypes,
	        (0, _toConsumableArray3.default)(it)
	      )
	    })
	  },
	  center: function center(instance, _center) {
	    instance.setCenter(_center)
	  },
	  clickableIcons: function clickableIcons(instance, _clickableIcons) {
	    instance.setClickableIcons(_clickableIcons)
	  },
	  heading: function heading(instance, _heading) {
	    instance.setHeading(_heading)
	  },
	  mapTypeId: function mapTypeId(instance, _mapTypeId) {
	    instance.setMapTypeId(_mapTypeId)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  streetView: function streetView(instance, _streetView) {
	    instance.setStreetView(_streetView)
	  },
	  tilt: function tilt(instance, _tilt) {
	    instance.setTilt(_tilt)
	  },
	  zoom: function zoom(instance, _zoom) {
	    instance.setZoom(_zoom)
	  },
	}


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(634);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	
	var _bind2 = __webpack_require__(858)
	
	var _bind3 = _interopRequireDefault(_bind2)
	
	var _isFunction2 = __webpack_require__(869)
	
	var _isFunction3 = _interopRequireDefault(_isFunction2)
	
	var _reduce3 = __webpack_require__(935)
	
	var _reduce4 = _interopRequireDefault(_reduce3)
	
	var _forEach2 = __webpack_require__(1036)
	
	var _forEach3 = _interopRequireDefault(_forEach2)
	
	var _lowerFirst2 = __webpack_require__(1038)
	
	var _lowerFirst3 = _interopRequireDefault(_lowerFirst2)
	
	var _has2 = __webpack_require__(1046)
	
	var _has3 = _interopRequireDefault(_has2)
	
	exports.construct = construct
	exports.componentDidMount = componentDidMount
	exports.componentDidUpdate = componentDidUpdate
	exports.componentWillUnmount = componentWillUnmount
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/* global google */
	/* eslint-disable no-param-reassign */
	function rdcUncontrolledAndControlledProps(acc, value, key) {
	  if ((0, _has3.default)(acc.prevProps, key)) {
	    var match = key.match(/^default(\S+)/)
	    if (match) {
	      var unprefixedKey = (0, _lowerFirst3.default)(match[1])
	      if (!(0, _has3.default)(acc.nextProps, unprefixedKey)) {
	        acc.nextProps[unprefixedKey] = acc.prevProps[key]
	      }
	    } else {
	      acc.nextProps[key] = acc.prevProps[key]
	    }
	  }
	  return acc
	}
	
	function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
	  ;(0, _forEach3.default)(updaterMap, function(fn, key) {
	    var nextValue = nextProps[key]
	    if (nextValue !== prevProps[key]) {
	      fn(instance, nextValue)
	    }
	  })
	}
	
	function construct(propTypes, updaterMap, prevProps, instance) {
	  var _reduce2 = (0, _reduce4.default)(
	      propTypes,
	      rdcUncontrolledAndControlledProps,
	      {
	        nextProps: {},
	        prevProps: prevProps,
	      }
	    ),
	    nextProps = _reduce2.nextProps
	
	  applyUpdaterToNextProps(
	    updaterMap,
	    {
	      /* empty prevProps for construct */
	    },
	    nextProps,
	    instance
	  )
	}
	
	function componentDidMount(component, instance, eventMap) {
	  registerEvents(component, instance, eventMap)
	}
	
	function componentDidUpdate(
	  component,
	  instance,
	  eventMap,
	  updaterMap,
	  prevProps
	) {
	  component.unregisterAllEvents()
	  applyUpdaterToNextProps(updaterMap, prevProps, component.props, instance)
	  registerEvents(component, instance, eventMap)
	}
	
	function componentWillUnmount(component) {
	  component.unregisterAllEvents()
	}
	
	function registerEvents(component, instance, eventMap) {
	  var registeredList = (0, _reduce4.default)(
	    eventMap,
	    function(acc, googleEventName, onEventName) {
	      if ((0, _isFunction3.default)(component.props[onEventName])) {
	        acc.push(
	          google.maps.event.addListener(
	            instance,
	            googleEventName,
	            component.props[onEventName]
	          )
	        )
	      }
	      return acc
	    },
	    []
	  )
	
	  component.unregisterAllEvents = (0, _bind3.default)(
	    _forEach3.default,
	    null,
	    registeredList,
	    unregisterEvent
	  )
	}
	
	function unregisterEvent(registered) {
	  google.maps.event.removeListener(registered)
	}


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(936),
	    baseEach = __webpack_require__(937),
	    baseIteratee = __webpack_require__(958),
	    baseReduce = __webpack_require__(1035),
	    isArray = __webpack_require__(898);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),
/* 936 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(938),
	    createBaseEach = __webpack_require__(957);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(939),
	    keys = __webpack_require__(941);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(940);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 940 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(942),
	    baseKeys = __webpack_require__(953),
	    isArrayLike = __webpack_require__(956);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(943),
	    isArguments = __webpack_require__(944),
	    isArray = __webpack_require__(898),
	    isBuffer = __webpack_require__(946),
	    isIndex = __webpack_require__(914),
	    isTypedArray = __webpack_require__(948);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 943 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(945),
	    isObjectLike = __webpack_require__(418);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(410),
	    isObjectLike = __webpack_require__(418);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(412),
	    stubFalse = __webpack_require__(947);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(420)(module)))

/***/ }),
/* 947 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(949),
	    baseUnary = __webpack_require__(951),
	    nodeUtil = __webpack_require__(952);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(410),
	    isLength = __webpack_require__(950),
	    isObjectLike = __webpack_require__(418);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 950 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 951 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(413);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(420)(module)))

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(954),
	    nativeKeys = __webpack_require__(955);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 954 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(417);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(869),
	    isLength = __webpack_require__(950);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(956);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(959),
	    baseMatchesProperty = __webpack_require__(1017),
	    identity = __webpack_require__(860),
	    isArray = __webpack_require__(898),
	    property = __webpack_require__(1032);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(960),
	    getMatchData = __webpack_require__(1014),
	    matchesStrictComparable = __webpack_require__(1016);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(961),
	    baseIsEqual = __webpack_require__(991);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(962),
	    stackClear = __webpack_require__(970),
	    stackDelete = __webpack_require__(971),
	    stackGet = __webpack_require__(972),
	    stackHas = __webpack_require__(973),
	    stackSet = __webpack_require__(974);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(963),
	    listCacheDelete = __webpack_require__(964),
	    listCacheGet = __webpack_require__(967),
	    listCacheHas = __webpack_require__(968),
	    listCacheSet = __webpack_require__(969);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 963 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(965);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(966);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 966 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(965);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(965);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(965);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(962);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 971 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 972 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 973 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(962),
	    Map = __webpack_require__(975),
	    MapCache = __webpack_require__(976);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(867),
	    root = __webpack_require__(412);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(977),
	    mapCacheDelete = __webpack_require__(985),
	    mapCacheGet = __webpack_require__(988),
	    mapCacheHas = __webpack_require__(989),
	    mapCacheSet = __webpack_require__(990);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(978),
	    ListCache = __webpack_require__(962),
	    Map = __webpack_require__(975);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(979),
	    hashDelete = __webpack_require__(981),
	    hashGet = __webpack_require__(982),
	    hashHas = __webpack_require__(983),
	    hashSet = __webpack_require__(984);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(980);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(867);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 981 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(980);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(980);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(980);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(986);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(987);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 987 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(986);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(986);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(986);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(992),
	    isObjectLike = __webpack_require__(418);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(961),
	    equalArrays = __webpack_require__(993),
	    equalByTag = __webpack_require__(999),
	    equalObjects = __webpack_require__(1003),
	    getTag = __webpack_require__(1010),
	    isArray = __webpack_require__(898),
	    isBuffer = __webpack_require__(946),
	    isTypedArray = __webpack_require__(948);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(994),
	    arraySome = __webpack_require__(997),
	    cacheHas = __webpack_require__(998);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(976),
	    setCacheAdd = __webpack_require__(995),
	    setCacheHas = __webpack_require__(996);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 995 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 996 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 997 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 998 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(411),
	    Uint8Array = __webpack_require__(1000),
	    eq = __webpack_require__(966),
	    equalArrays = __webpack_require__(993),
	    mapToArray = __webpack_require__(1001),
	    setToArray = __webpack_require__(1002);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(412);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 1001 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1004);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1005),
	    getSymbols = __webpack_require__(1007),
	    keys = __webpack_require__(941);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1006),
	    isArray = __webpack_require__(898);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1008),
	    stubArray = __webpack_require__(1009);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 1009 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1011),
	    Map = __webpack_require__(975),
	    Promise = __webpack_require__(1012),
	    Set = __webpack_require__(1013),
	    WeakMap = __webpack_require__(879),
	    baseGetTag = __webpack_require__(410),
	    toSource = __webpack_require__(873);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(867),
	    root = __webpack_require__(412);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(867),
	    root = __webpack_require__(412);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(867),
	    root = __webpack_require__(412);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(1015),
	    keys = __webpack_require__(941);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(870);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(991),
	    get = __webpack_require__(1018),
	    hasIn = __webpack_require__(1029),
	    isKey = __webpack_require__(1021),
	    isStrictComparable = __webpack_require__(1015),
	    matchesStrictComparable = __webpack_require__(1016),
	    toKey = __webpack_require__(1028);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1019);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(1020),
	    toKey = __webpack_require__(1028);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(898),
	    isKey = __webpack_require__(1021),
	    stringToPath = __webpack_require__(1022),
	    toString = __webpack_require__(1025);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(898),
	    isSymbol = __webpack_require__(923);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1023);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1024);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(976);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1026);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(411),
	    arrayMap = __webpack_require__(1027),
	    isArray = __webpack_require__(898),
	    isSymbol = __webpack_require__(923);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(923);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1030),
	    hasPath = __webpack_require__(1031);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(1020),
	    isArguments = __webpack_require__(944),
	    isArray = __webpack_require__(898),
	    isIndex = __webpack_require__(914),
	    isLength = __webpack_require__(950),
	    toKey = __webpack_require__(1028);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1033),
	    basePropertyDeep = __webpack_require__(1034),
	    isKey = __webpack_require__(1021),
	    toKey = __webpack_require__(1028);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1019);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1035 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(906),
	    baseEach = __webpack_require__(937),
	    castFunction = __webpack_require__(1037),
	    isArray = __webpack_require__(898);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(860);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(1039);
	
	/**
	 * Converts the first character of `string` to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.lowerFirst('Fred');
	 * // => 'fred'
	 *
	 * _.lowerFirst('FRED');
	 * // => 'fRED'
	 */
	var lowerFirst = createCaseFirst('toLowerCase');
	
	module.exports = lowerFirst;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	var castSlice = __webpack_require__(1040),
	    hasUnicode = __webpack_require__(1042),
	    stringToArray = __webpack_require__(1043),
	    toString = __webpack_require__(1025);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(1041);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 1042 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(1044),
	    hasUnicode = __webpack_require__(1042),
	    unicodeToArray = __webpack_require__(1045);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 1044 */
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 1045 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(1047),
	    hasPath = __webpack_require__(1031);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ }),
/* 1047 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.Circle = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Circle`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var Circle = (exports.Circle = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Circle, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	   */
	  function Circle(props, context) {
	    ;(0, _classCallCheck3.default)(this, Circle)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Circle.__proto__ || (0, _getPrototypeOf2.default)(Circle)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var circle = new google.maps.Circle()
	    ;(0, _MapChildHelper.construct)(
	      Circle.propTypes,
	      updaterMap,
	      _this.props,
	      circle
	    )
	    circle.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)({}, _constants.CIRCLE, circle)
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Circle, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.CIRCLE],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.CIRCLE],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var circle = this.state[_constants.CIRCLE]
	        if (circle) {
	          circle.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	     * Gets the `LatLngBounds` of this Circle.
	     * @type LatLngBoundsLatLngBounds
	     * @public 
	     */
	    },
	    {
	      key: "getBounds",
	      value: function getBounds() {
	        return this.state[_constants.CIRCLE].getBounds()
	      },
	
	      /**
	     * Returns the center of this circle.
	     * @type LatLng
	     * @public 
	     */
	    },
	    {
	      key: "getCenter",
	      value: function getCenter() {
	        return this.state[_constants.CIRCLE].getCenter()
	      },
	
	      /**
	     * Returns whether this circle can be dragged by the user.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getDraggable",
	      value: function getDraggable() {
	        return this.state[_constants.CIRCLE].getDraggable()
	      },
	
	      /**
	     * Returns whether this circle can be edited by the user.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getEditable",
	      value: function getEditable() {
	        return this.state[_constants.CIRCLE].getEditable()
	      },
	
	      /**
	     * Returns the radius of this circle (in meters).
	     * @type number
	     * @public 
	     */
	    },
	    {
	      key: "getRadius",
	      value: function getRadius() {
	        return this.state[_constants.CIRCLE].getRadius()
	      },
	
	      /**
	     * Returns whether this circle is visible on the map.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.state[_constants.CIRCLE].getVisible()
	      },
	    },
	  ])
	  return Circle
	})(_react2.default.PureComponent))
	
	Circle.propTypes = {
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  defaultCenter: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultDraggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  defaultEditable: _propTypes2.default.bool,
	
	  /**
	   * @type CircleOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  defaultRadius: _propTypes2.default.number,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  center: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  draggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  editable: _propTypes2.default.bool,
	
	  /**
	   * @type CircleOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  radius: _propTypes2.default.number,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onCenterChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRadiusChanged: _propTypes2.default.func,
	}
	Circle.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = Circle
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMouseDown: "mousedown",
	  onMouseMove: "mousemove",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onMouseUp: "mouseup",
	  onRightClick: "rightclick",
	  onCenterChanged: "center_changed",
	  onClick: "click",
	  onDrag: "drag",
	  onRadiusChanged: "radius_changed",
	}
	
	var updaterMap = {
	  center: function center(instance, _center) {
	    instance.setCenter(_center)
	  },
	  draggable: function draggable(instance, _draggable) {
	    instance.setDraggable(_draggable)
	  },
	  editable: function editable(instance, _editable) {
	    instance.setEditable(_editable)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  radius: function radius(instance, _radius) {
	    instance.setRadius(_radius)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	}


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.Marker = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _Marker$contextTypes /*
	                           * -----------------------------------------------------------------------------
	                           * This file is auto-generated from the corresponding file at `src/macros/`.
	                           * Please **DO NOT** edit this file directly when creating PRs.
	                           * -----------------------------------------------------------------------------
	                           */
	/* global google */
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Marker`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	 */
	var Marker = (exports.Marker = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Marker, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	   */
	  function Marker(props, context) {
	    ;(0, _classCallCheck3.default)(this, Marker)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Marker.__proto__ || (0, _getPrototypeOf2.default)(Marker)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var marker = new google.maps.Marker()
	    ;(0, _MapChildHelper.construct)(
	      Marker.propTypes,
	      updaterMap,
	      _this.props,
	      marker
	    )
	    var markerClusterer = _this.context[_constants.MARKER_CLUSTERER]
	    if (markerClusterer) {
	      markerClusterer.addMarker(marker, !!_this.props.noRedraw)
	    } else {
	      marker.setMap(_this.context[_constants.MAP])
	    }
	    _this.state = (0, _defineProperty3.default)({}, _constants.MARKER, marker)
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Marker, [
	    {
	      key: "getChildContext",
	      value: function getChildContext() {
	        return (0, _defineProperty3.default)(
	          {},
	          _constants.ANCHOR,
	          this.context[_constants.ANCHOR] || this.state[_constants.MARKER]
	        )
	      },
	    },
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.MARKER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.MARKER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var marker = this.state[_constants.MARKER]
	        if (marker) {
	          var markerClusterer = this.context[_constants.MARKER_CLUSTERER]
	          if (markerClusterer) {
	            markerClusterer.removeMarker(marker, !!this.props.noRedraw)
	          }
	          marker.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        var children = this.props.children
	
	        return _react2.default.createElement("div", null, children)
	      },
	
	      /**
	     * 
	     * @type Animation
	     * @public 
	     */
	    },
	    {
	      key: "getAnimation",
	      value: function getAnimation() {
	        return this.state[_constants.MARKER].getAnimation()
	      },
	
	      /**
	     * 
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getClickable",
	      value: function getClickable() {
	        return this.state[_constants.MARKER].getClickable()
	      },
	
	      /**
	     * 
	     * @type string
	     * @public 
	     */
	    },
	    {
	      key: "getCursor",
	      value: function getCursor() {
	        return this.state[_constants.MARKER].getCursor()
	      },
	
	      /**
	     * 
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getDraggable",
	      value: function getDraggable() {
	        return this.state[_constants.MARKER].getDraggable()
	      },
	
	      /**
	     * 
	     * @type string|Icon|Symbol
	     * @public 
	     */
	    },
	    {
	      key: "getIcon",
	      value: function getIcon() {
	        return this.state[_constants.MARKER].getIcon()
	      },
	
	      /**
	     * 
	     * @type MarkerLabel
	     * @public 
	     */
	    },
	    {
	      key: "getLabel",
	      value: function getLabel() {
	        return this.state[_constants.MARKER].getLabel()
	      },
	
	      /**
	     * 
	     * @type number
	     * @public 
	     */
	    },
	    {
	      key: "getOpacity",
	      value: function getOpacity() {
	        return this.state[_constants.MARKER].getOpacity()
	      },
	
	      /**
	     * 
	     * @type MarkerPlace
	     * @public 
	     */
	    },
	    {
	      key: "getPlace",
	      value: function getPlace() {
	        return this.state[_constants.MARKER].getPlace()
	      },
	
	      /**
	     * 
	     * @type LatLng
	     * @public 
	     */
	    },
	    {
	      key: "getPosition",
	      value: function getPosition() {
	        return this.state[_constants.MARKER].getPosition()
	      },
	
	      /**
	     * 
	     * @type MarkerShape
	     * @public 
	     */
	    },
	    {
	      key: "getShape",
	      value: function getShape() {
	        return this.state[_constants.MARKER].getShape()
	      },
	
	      /**
	     * 
	     * @type string
	     * @public 
	     */
	    },
	    {
	      key: "getTitle",
	      value: function getTitle() {
	        return this.state[_constants.MARKER].getTitle()
	      },
	
	      /**
	     * 
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.state[_constants.MARKER].getVisible()
	      },
	
	      /**
	     * 
	     * @type number
	     * @public 
	     */
	    },
	    {
	      key: "getZIndex",
	      value: function getZIndex() {
	        return this.state[_constants.MARKER].getZIndex()
	      },
	    },
	  ])
	  return Marker
	})(_react2.default.PureComponent))
	
	Marker.propTypes = {
	  /**
	   * For the 2nd argument of `MarkerCluster#addMarker`
	   * @see https://github.com/mikesaidani/marker-clusterer-plus
	   */
	  noRedraw: _propTypes2.default.bool,
	
	  /**
	   * @type Animation
	   */
	  defaultAnimation: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultClickable: _propTypes2.default.bool,
	
	  /**
	   * @type string
	   */
	  defaultCursor: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  defaultDraggable: _propTypes2.default.bool,
	
	  /**
	   * @type string|Icon|Symbol
	   */
	  defaultIcon: _propTypes2.default.any,
	
	  /**
	   * @type string|MarkerLabel
	   */
	  defaultLabel: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  defaultOpacity: _propTypes2.default.number,
	
	  /**
	   * @type MarkerOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type MarkerPlace
	   */
	  defaultPlace: _propTypes2.default.any,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  defaultPosition: _propTypes2.default.any,
	
	  /**
	   * @type MarkerShape
	   */
	  defaultShape: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  defaultTitle: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  defaultZIndex: _propTypes2.default.number,
	
	  /**
	   * @type Animation
	   */
	  animation: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  clickable: _propTypes2.default.bool,
	
	  /**
	   * @type string
	   */
	  cursor: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  draggable: _propTypes2.default.bool,
	
	  /**
	   * @type string|Icon|Symbol
	   */
	  icon: _propTypes2.default.any,
	
	  /**
	   * @type string|MarkerLabel
	   */
	  label: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  opacity: _propTypes2.default.number,
	
	  /**
	   * @type MarkerOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type MarkerPlace
	   */
	  place: _propTypes2.default.any,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  position: _propTypes2.default.any,
	
	  /**
	   * @type MarkerShape
	   */
	  shape: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  title: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  zIndex: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onAnimationChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClickableChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onCursorChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDraggableChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onFlatChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onIconChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onPositionChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onShapeChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onTitleChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onVisibleChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onZindexChanged: _propTypes2.default.func,
	}
	Marker.contextTypes = ((_Marker$contextTypes = {}),
	(0, _defineProperty3.default)(
	  _Marker$contextTypes,
	  _constants.MAP,
	  _propTypes2.default.object
	),
	(0, _defineProperty3.default)(
	  _Marker$contextTypes,
	  _constants.MARKER_CLUSTERER,
	  _propTypes2.default.object
	),
	_Marker$contextTypes)
	Marker.childContextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.ANCHOR,
	  _propTypes2.default.object
	)
	exports.default = Marker
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMouseDown: "mousedown",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onMouseUp: "mouseup",
	  onRightClick: "rightclick",
	  onAnimationChanged: "animation_changed",
	  onClick: "click",
	  onClickableChanged: "clickable_changed",
	  onCursorChanged: "cursor_changed",
	  onDrag: "drag",
	  onDraggableChanged: "draggable_changed",
	  onFlatChanged: "flat_changed",
	  onIconChanged: "icon_changed",
	  onPositionChanged: "position_changed",
	  onShapeChanged: "shape_changed",
	  onTitleChanged: "title_changed",
	  onVisibleChanged: "visible_changed",
	  onZindexChanged: "zindex_changed",
	}
	
	var updaterMap = {
	  animation: function animation(instance, _animation) {
	    instance.setAnimation(_animation)
	  },
	  clickable: function clickable(instance, _clickable) {
	    instance.setClickable(_clickable)
	  },
	  cursor: function cursor(instance, _cursor) {
	    instance.setCursor(_cursor)
	  },
	  draggable: function draggable(instance, _draggable) {
	    instance.setDraggable(_draggable)
	  },
	  icon: function icon(instance, _icon) {
	    instance.setIcon(_icon)
	  },
	  label: function label(instance, _label) {
	    instance.setLabel(_label)
	  },
	  opacity: function opacity(instance, _opacity) {
	    instance.setOpacity(_opacity)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  place: function place(instance, _place) {
	    instance.setPlace(_place)
	  },
	  position: function position(instance, _position) {
	    instance.setPosition(_position)
	  },
	  shape: function shape(instance, _shape) {
	    instance.setShape(_shape)
	  },
	  title: function title(instance, _title) {
	    instance.setTitle(_title)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	  zIndex: function zIndex(instance, _zIndex) {
	    instance.setZIndex(_zIndex)
	  },
	}


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.Polyline = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Polyline`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var Polyline = (exports.Polyline = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Polyline, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	   */
	  function Polyline(props, context) {
	    ;(0, _classCallCheck3.default)(this, Polyline)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Polyline.__proto__ || (0, _getPrototypeOf2.default)(Polyline)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var polyline = new google.maps.Polyline()
	    ;(0, _MapChildHelper.construct)(
	      Polyline.propTypes,
	      updaterMap,
	      _this.props,
	      polyline
	    )
	    polyline.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.POLYLINE,
	      polyline
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Polyline, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.POLYLINE],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.POLYLINE],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var polyline = this.state[_constants.POLYLINE]
	        if (polyline) {
	          polyline.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	     * Returns whether this shape can be dragged by the user.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getDraggable",
	      value: function getDraggable() {
	        return this.state[_constants.POLYLINE].getDraggable()
	      },
	
	      /**
	     * Returns whether this shape can be edited by the user.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getEditable",
	      value: function getEditable() {
	        return this.state[_constants.POLYLINE].getEditable()
	      },
	
	      /**
	     * Retrieves the path.
	     * @type MVCArray<LatLng>
	     * @public 
	     */
	    },
	    {
	      key: "getPath",
	      value: function getPath() {
	        return this.state[_constants.POLYLINE].getPath()
	      },
	
	      /**
	     * Returns whether this poly is visible on the map.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.state[_constants.POLYLINE].getVisible()
	      },
	    },
	  ])
	  return Polyline
	})(_react2.default.PureComponent))
	
	Polyline.propTypes = {
	  /**
	   * @type boolean
	   */
	  defaultDraggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  defaultEditable: _propTypes2.default.bool,
	
	  /**
	   * @type PolylineOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
	   */
	  defaultPath: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  draggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  editable: _propTypes2.default.bool,
	
	  /**
	   * @type PolylineOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
	   */
	  path: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	}
	Polyline.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = Polyline
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMouseDown: "mousedown",
	  onMouseMove: "mousemove",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onMouseUp: "mouseup",
	  onRightClick: "rightclick",
	  onClick: "click",
	  onDrag: "drag",
	}
	
	var updaterMap = {
	  draggable: function draggable(instance, _draggable) {
	    instance.setDraggable(_draggable)
	  },
	  editable: function editable(instance, _editable) {
	    instance.setEditable(_editable)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  path: function path(instance, _path) {
	    instance.setPath(_path)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	}


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.Polygon = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Polygon`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var Polygon = (exports.Polygon = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Polygon, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	   */
	  function Polygon(props, context) {
	    ;(0, _classCallCheck3.default)(this, Polygon)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Polygon.__proto__ || (0, _getPrototypeOf2.default)(Polygon)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var polygon = new google.maps.Polygon()
	    ;(0, _MapChildHelper.construct)(
	      Polygon.propTypes,
	      updaterMap,
	      _this.props,
	      polygon
	    )
	    polygon.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)({}, _constants.POLYGON, polygon)
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Polygon, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.POLYGON],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.POLYGON],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var polygon = this.state[_constants.POLYGON]
	        if (polygon) {
	          polygon.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	     * Returns whether this shape can be dragged by the user.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getDraggable",
	      value: function getDraggable() {
	        return this.state[_constants.POLYGON].getDraggable()
	      },
	
	      /**
	     * Returns whether this shape can be edited by the user.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getEditable",
	      value: function getEditable() {
	        return this.state[_constants.POLYGON].getEditable()
	      },
	
	      /**
	     * Retrieves the first path.
	     * @type MVCArray<LatLng>
	     * @public 
	     */
	    },
	    {
	      key: "getPath",
	      value: function getPath() {
	        return this.state[_constants.POLYGON].getPath()
	      },
	
	      /**
	     * Retrieves the paths for this polygon.
	     * @type MVCArray<MVCArray<LatLng>>
	     * @public 
	     */
	    },
	    {
	      key: "getPaths",
	      value: function getPaths() {
	        return this.state[_constants.POLYGON].getPaths()
	      },
	
	      /**
	     * Returns whether this poly is visible on the map.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.state[_constants.POLYGON].getVisible()
	      },
	    },
	  ])
	  return Polygon
	})(_react2.default.PureComponent))
	
	Polygon.propTypes = {
	  /**
	   * @type boolean
	   */
	  defaultDraggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  defaultEditable: _propTypes2.default.bool,
	
	  /**
	   * @type PolygonOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
	   */
	  defaultPath: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
	   */
	  defaultPaths: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  draggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  editable: _propTypes2.default.bool,
	
	  /**
	   * @type PolygonOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
	   */
	  path: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
	   */
	  paths: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	}
	Polygon.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = Polygon
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMouseDown: "mousedown",
	  onMouseMove: "mousemove",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onMouseUp: "mouseup",
	  onRightClick: "rightclick",
	  onClick: "click",
	  onDrag: "drag",
	}
	
	var updaterMap = {
	  draggable: function draggable(instance, _draggable) {
	    instance.setDraggable(_draggable)
	  },
	  editable: function editable(instance, _editable) {
	    instance.setEditable(_editable)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  path: function path(instance, _path) {
	    instance.setPath(_path)
	  },
	  paths: function paths(instance, _paths) {
	    instance.setPaths(_paths)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	}


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.Rectangle = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Rectangle`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var Rectangle = (exports.Rectangle = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Rectangle, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	   */
	  function Rectangle(props, context) {
	    ;(0, _classCallCheck3.default)(this, Rectangle)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Rectangle.__proto__ || (0, _getPrototypeOf2.default)(Rectangle)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var rectangle = new google.maps.Rectangle()
	    ;(0, _MapChildHelper.construct)(
	      Rectangle.propTypes,
	      updaterMap,
	      _this.props,
	      rectangle
	    )
	    rectangle.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.RECTANGLE,
	      rectangle
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Rectangle, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.RECTANGLE],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.RECTANGLE],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var rectangle = this.state[_constants.RECTANGLE]
	        if (rectangle) {
	          rectangle.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	     * Returns the bounds of this rectangle.
	     * @type LatLngBounds
	     * @public 
	     */
	    },
	    {
	      key: "getBounds",
	      value: function getBounds() {
	        return this.state[_constants.RECTANGLE].getBounds()
	      },
	
	      /**
	     * Returns whether this rectangle can be dragged by the user.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getDraggable",
	      value: function getDraggable() {
	        return this.state[_constants.RECTANGLE].getDraggable()
	      },
	
	      /**
	     * Returns whether this rectangle can be edited by the user.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getEditable",
	      value: function getEditable() {
	        return this.state[_constants.RECTANGLE].getEditable()
	      },
	
	      /**
	     * Returns whether this rectangle is visible on the map.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.state[_constants.RECTANGLE].getVisible()
	      },
	    },
	  ])
	  return Rectangle
	})(_react2.default.PureComponent))
	
	Rectangle.propTypes = {
	  /**
	   * @type LatLngBounds|LatLngBoundsLiteral
	   */
	  defaultBounds: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultDraggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  defaultEditable: _propTypes2.default.bool,
	
	  /**
	   * @type RectangleOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type LatLngBounds|LatLngBoundsLiteral
	   */
	  bounds: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  draggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  editable: _propTypes2.default.bool,
	
	  /**
	   * @type RectangleOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onBoundsChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	}
	Rectangle.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = Rectangle
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMouseDown: "mousedown",
	  onMouseMove: "mousemove",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onMouseUp: "mouseup",
	  onRightClick: "rightclick",
	  onBoundsChanged: "bounds_changed",
	  onClick: "click",
	  onDrag: "drag",
	}
	
	var updaterMap = {
	  bounds: function bounds(instance, _bounds) {
	    instance.setBounds(_bounds)
	  },
	  draggable: function draggable(instance, _draggable) {
	    instance.setDraggable(_draggable)
	  },
	  editable: function editable(instance, _editable) {
	    instance.setEditable(_editable)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	}


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.InfoWindow = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _InfoWindow$contextTy /*
	                            * -----------------------------------------------------------------------------
	                            * This file is auto-generated from the corresponding file at `src/macros/`.
	                            * Please **DO NOT** edit this file directly when creating PRs.
	                            * -----------------------------------------------------------------------------
	                            */
	/* global google */
	
	var _invariant = __webpack_require__(352)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _reactDom = __webpack_require__(341)
	
	var _reactDom2 = _interopRequireDefault(_reactDom)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.InfoWindow`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	 */
	var InfoWindow = (exports.InfoWindow = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(InfoWindow, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	   */
	  function InfoWindow(props, context) {
	    ;(0, _classCallCheck3.default)(this, InfoWindow)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (InfoWindow.__proto__ || (0, _getPrototypeOf2.default)(InfoWindow)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var infoWindow = new google.maps.InfoWindow()
	    ;(0, _MapChildHelper.construct)(
	      InfoWindow.propTypes,
	      updaterMap,
	      _this.props,
	      infoWindow
	    )
	    infoWindow.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.INFO_WINDOW,
	      infoWindow
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(InfoWindow, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.INFO_WINDOW],
	          eventMap
	        )
	        var content = document.createElement("div")
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(
	          this,
	          _react2.default.Children.only(this.props.children),
	          content
	        )
	        this.state[_constants.INFO_WINDOW].setContent(content)
	        open(
	          this.state[_constants.INFO_WINDOW],
	          this.context[_constants.ANCHOR]
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.INFO_WINDOW],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	        if (this.props.children !== prevProps.children) {
	          _reactDom2.default.unstable_renderSubtreeIntoContainer(
	            this,
	            _react2.default.Children.only(this.props.children),
	            this.state[_constants.INFO_WINDOW].getContent()
	          )
	        }
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var infoWindow = this.state[_constants.INFO_WINDOW]
	        if (infoWindow) {
	          if (infoWindow.getContent()) {
	            _reactDom2.default.unmountComponentAtNode(infoWindow.getContent())
	          }
	          infoWindow.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	     * 
	     * @type LatLng
	     * @public 
	     */
	    },
	    {
	      key: "getPosition",
	      value: function getPosition() {
	        return this.state[_constants.INFO_WINDOW].getPosition()
	      },
	
	      /**
	     * 
	     * @type number
	     * @public 
	     */
	    },
	    {
	      key: "getZIndex",
	      value: function getZIndex() {
	        return this.state[_constants.INFO_WINDOW].getZIndex()
	      },
	    },
	  ])
	  return InfoWindow
	})(_react2.default.PureComponent))
	
	InfoWindow.propTypes = {
	  /**
	   * @type InfoWindowOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  defaultPosition: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  defaultZIndex: _propTypes2.default.number,
	
	  /**
	   * @type InfoWindowOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  position: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  zIndex: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onCloseClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDomReady: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onContentChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onPositionChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onZindexChanged: _propTypes2.default.func,
	}
	InfoWindow.contextTypes = ((_InfoWindow$contextTy = {}),
	(0, _defineProperty3.default)(
	  _InfoWindow$contextTy,
	  _constants.MAP,
	  _propTypes2.default.object
	),
	(0, _defineProperty3.default)(
	  _InfoWindow$contextTy,
	  _constants.ANCHOR,
	  _propTypes2.default.object
	),
	_InfoWindow$contextTy)
	exports.default = InfoWindow
	
	var open = function open(infoWindow, anchor) {
	  if (anchor) {
	    infoWindow.open(infoWindow.getMap(), anchor)
	  } else if (infoWindow.getPosition()) {
	    infoWindow.open(infoWindow.getMap())
	  } else {
	    ;(0, _invariant2.default)(
	      false,
	      "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."
	    )
	  }
	}
	
	var eventMap = {
	  onCloseClick: "closeclick",
	  onDomReady: "domready",
	  onContentChanged: "content_changed",
	  onPositionChanged: "position_changed",
	  onZindexChanged: "zindex_changed",
	}
	
	var updaterMap = {
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  position: function position(instance, _position) {
	    instance.setPosition(_position)
	  },
	  zIndex: function zIndex(instance, _zIndex) {
	    instance.setZIndex(_zIndex)
	  },
	}


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.OverlayView = undefined
	
	var _extends2 = __webpack_require__(493)
	
	var _extends3 = _interopRequireDefault(_extends2)
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _delay2 = __webpack_require__(1055)
	
	var _delay3 = _interopRequireDefault(_delay2)
	
	var _assign2 = __webpack_require__(1057)
	
	var _assign3 = _interopRequireDefault(_assign2)
	
	var _bind2 = __webpack_require__(858)
	
	var _bind3 = _interopRequireDefault(_bind2)
	
	var _OverlayView$contextT /*
	                            * -----------------------------------------------------------------------------
	                            * This file is auto-generated from the corresponding file at `src/macros/`.
	                            * Please **DO NOT** edit this file directly when creating PRs.
	                            * -----------------------------------------------------------------------------
	                            */
	/* global google */
	
	var _invariant = __webpack_require__(352)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _reactDom = __webpack_require__(341)
	
	var _reactDom2 = _interopRequireDefault(_reactDom)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _OverlayViewHelper = __webpack_require__(1063)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.OverlayView`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	 */
	var OverlayView = (exports.OverlayView = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(OverlayView, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  function OverlayView(props, context) {
	    ;(0, _classCallCheck3.default)(this, OverlayView)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (OverlayView.__proto__ || (0, _getPrototypeOf2.default)(OverlayView)
	      ).call(this, props, context)
	    )
	
	    var overlayView = new google.maps.OverlayView()
	    // You must implement three methods: onAdd(), draw(), and onRemove().
	    overlayView.onAdd = (0, _bind3.default)(_this.onAdd, _this)
	    overlayView.draw = (0, _bind3.default)(_this.draw, _this)
	    overlayView.onRemove = (0, _bind3.default)(_this.onRemove, _this)
	    _this.onPositionElement = (0, _bind3.default)(
	      _this.onPositionElement,
	      _this
	    )
	    // You must call setMap() with a valid Map object to trigger the call to
	    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
	    overlayView.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.OVERLAY_VIEW,
	      overlayView
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(OverlayView, [
	    {
	      key: "onAdd",
	      value: function onAdd() {
	        this.containerElement = document.createElement("div")
	        this.containerElement.style.position = "absolute"
	      },
	    },
	    {
	      key: "draw",
	      value: function draw() {
	        var mapPaneName = this.props.mapPaneName
	
	        ;(0, _invariant2.default)(
	          !!mapPaneName,
	          "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s",
	          mapPaneName
	        )
	        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
	        var mapPanes = this.state[_constants.OVERLAY_VIEW].getPanes()
	        mapPanes[mapPaneName].appendChild(this.containerElement)
	
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(
	          this,
	          _react2.default.Children.only(this.props.children),
	          this.containerElement,
	          this.onPositionElement
	        )
	      },
	    },
	    {
	      key: "onPositionElement",
	      value: function onPositionElement() {
	        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
	        var mapCanvasProjection = this.state[
	          _constants.OVERLAY_VIEW
	        ].getProjection()
	
	        var offset = (0, _extends3.default)(
	          {
	            x: 0,
	            y: 0,
	          },
	          (0, _OverlayViewHelper.getOffsetOverride)(
	            this.containerElement,
	            this.props
	          )
	        )
	        var layoutStyles = (0, _OverlayViewHelper.getLayoutStyles)(
	          mapCanvasProjection,
	          offset,
	          this.props
	        )
	        ;(0, _assign3.default)(this.containerElement.style, layoutStyles)
	      },
	    },
	    {
	      key: "onRemove",
	      value: function onRemove() {
	        this.containerElement.parentNode.removeChild(this.containerElement)
	        _reactDom2.default.unmountComponentAtNode(this.containerElement)
	        this.containerElement = null
	      },
	    },
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.OVERLAY_VIEW],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.OVERLAY_VIEW],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	        ;(0, _delay3.default)(this.state[_constants.OVERLAY_VIEW].draw)
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var overlayView = this.state[_constants.OVERLAY_VIEW]
	        if (overlayView) {
	          overlayView.setMap(null)
	          // You must implement three methods: onAdd(), draw(), and onRemove().
	          overlayView.onAdd = null
	          overlayView.draw = null
	          overlayView.onRemove = null
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	     * Returns the panes in which this OverlayView can be rendered. The panes are not initialized until `onAdd` is called by the API.
	     * @type MapPanesonAdd
	     * @public 
	     */
	    },
	    {
	      key: "getPanes",
	      value: function getPanes() {
	        return this.state[_constants.OVERLAY_VIEW].getPanes()
	      },
	
	      /**
	     * Returns the `MapCanvasProjection` object associated with this `OverlayView`. The projection is not initialized until `onAdd` is called by the API.
	     * @type MapCanvasProjectionMapCanvasProjectionOverlayViewonAdd
	     * @public 
	     */
	    },
	    {
	      key: "getProjection",
	      value: function getProjection() {
	        return this.state[_constants.OVERLAY_VIEW].getProjection()
	      },
	    },
	  ])
	  return OverlayView
	})(_react2.default.PureComponent))
	
	OverlayView.FLOAT_PANE = "floatPane"
	OverlayView.MAP_PANE = "mapPane"
	OverlayView.MARKER_LAYER = "markerLayer"
	OverlayView.OVERLAY_LAYER = "overlayLayer"
	OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget"
	OverlayView.propTypes = {
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  mapPaneName: _propTypes2.default.string,
	
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  position: _propTypes2.default.object,
	
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  bounds: _propTypes2.default.object,
	
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  children: _propTypes2.default.node.isRequired,
	
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  getPixelPositionOffset: _propTypes2.default.func,
	}
	OverlayView.contextTypes = ((_OverlayView$contextT = {}),
	(0, _defineProperty3.default)(
	  _OverlayView$contextT,
	  _constants.MAP,
	  _propTypes2.default.object
	),
	(0, _defineProperty3.default)(
	  _OverlayView$contextT,
	  _constants.ANCHOR,
	  _propTypes2.default.object
	),
	_OverlayView$contextT)
	exports.default = OverlayView
	
	var eventMap = {}
	
	var updaterMap = {}


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDelay = __webpack_require__(1056),
	    baseRest = __webpack_require__(859),
	    toNumber = __webpack_require__(920);
	
	/**
	 * Invokes `func` after `wait` milliseconds. Any additional arguments are
	 * provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {...*} [args] The arguments to invoke `func` with.
	 * @returns {number} Returns the timer id.
	 * @example
	 *
	 * _.delay(function(text) {
	 *   console.log(text);
	 * }, 1000, 'later');
	 * // => Logs 'later' after one second.
	 */
	var delay = baseRest(function(func, wait, args) {
	  return baseDelay(func, toNumber(wait) || 0, args);
	});
	
	module.exports = delay;


/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * The base implementation of `_.delay` and `_.defer` which accepts `args`
	 * to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {Array} args The arguments to provide to `func`.
	 * @returns {number|Object} Returns the timer id or timeout object.
	 */
	function baseDelay(func, wait, args) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return setTimeout(function() { func.apply(undefined, args); }, wait);
	}
	
	module.exports = baseDelay;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(1058),
	    copyObject = __webpack_require__(1060),
	    createAssigner = __webpack_require__(1061),
	    isArrayLike = __webpack_require__(956),
	    isPrototype = __webpack_require__(954),
	    keys = __webpack_require__(941);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(1059),
	    eq = __webpack_require__(966);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(866);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(1058),
	    baseAssignValue = __webpack_require__(1059);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(859),
	    isIterateeCall = __webpack_require__(1062);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(966),
	    isArrayLike = __webpack_require__(956),
	    isIndex = __webpack_require__(914),
	    isObject = __webpack_require__(870);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	
	var _isFunction2 = __webpack_require__(869)
	
	var _isFunction3 = _interopRequireDefault(_isFunction2)
	
	exports.getOffsetOverride = getOffsetOverride
	exports.getLayoutStyles = getLayoutStyles
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/* global google */
	function getOffsetOverride(containerElement, props) {
	  var getPixelPositionOffset = props.getPixelPositionOffset
	  //
	  // Allows the component to control the visual position of the OverlayView
	  // relative to the LatLng pixel position.
	  //
	
	  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
	    return getPixelPositionOffset(
	      containerElement.offsetWidth,
	      containerElement.offsetHeight
	    )
	  } else {
	    return {}
	  }
	}
	
	function createLatLng(inst, Type) {
	  return new Type(inst.lat, inst.lng)
	}
	
	function createLatLngBounds(inst, Type) {
	  return new Type(
	    new google.maps.LatLng(inst.ne.lat, inst.ne.lng),
	    new google.maps.LatLng(inst.sw.lat, inst.sw.lng)
	  )
	}
	
	function ensureOfType(inst, type, factory) {
	  if (inst instanceof type) {
	    return inst
	  } else {
	    return factory(inst, type)
	  }
	}
	
	function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
	  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast())
	  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest())
	  if (ne && sw) {
	    return {
	      left: sw.x + offset.x + "px",
	      top: ne.y + offset.y + "px",
	      width: ne.x - sw.x - offset.x + "px",
	      height: sw.y - ne.y - offset.y + "px",
	    }
	  }
	  return {
	    left: "-9999px",
	    top: "-9999px",
	  }
	}
	
	function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
	  var point = mapCanvasProjection.fromLatLngToDivPixel(position)
	  if (point) {
	    var x = point.x,
	      y = point.y
	
	    return {
	      left: x + offset.x + "px",
	      top: y + offset.y + "px",
	    }
	  }
	  return {
	    left: "-9999px",
	    top: "-9999px",
	  }
	}
	
	function getLayoutStyles(mapCanvasProjection, offset, props) {
	  if (props.bounds) {
	    var bounds = ensureOfType(
	      props.bounds,
	      google.maps.LatLngBounds,
	      createLatLngBounds
	    )
	    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds)
	  } else {
	    var position = ensureOfType(
	      props.position,
	      google.maps.LatLng,
	      createLatLng
	    )
	    return getLayoutStylesByPosition(mapCanvasProjection, offset, position)
	  }
	}


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.GroundOverlay = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _warning = __webpack_require__(358)
	
	var _warning2 = _interopRequireDefault(_warning)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.GroundOverlay`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
	 */
	var GroundOverlay = (exports.GroundOverlay = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(GroundOverlay, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#GroundOverlay
	   */
	  function GroundOverlay(props, context) {
	    ;(0, _classCallCheck3.default)(this, GroundOverlay)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (GroundOverlay.__proto__ || (0, _getPrototypeOf2.default)(GroundOverlay)
	      ).call(this, props, context)
	    )
	
	    ;(0, _warning2.default)(
	      !props.url || !props.bounds,
	      "\nFor GroundOveray, url and bounds are passed in to constructor and are immutable\n after iinstantiated. This is the behavior of Google Maps JavaScript API v3 (\n See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay)\n Hence, use the corresponding two props provided by `react-google-maps`.\n They're prefixed with _default_ (defaultUrl, defaultBounds).\n\n In some cases, you'll need the GroundOverlay component to reflect the changes\n of url and bounds. You can leverage the React's key property to remount the\n component. Typically, just `key={url}` would serve your need.\n See https://github.com/tomchentw/react-google-maps/issues/655\n"
	    )
	    var groundOverlay = new google.maps.GroundOverlay(
	      props.defaultUrl || props.url,
	      props.defaultBounds || props.bounds
	    )
	    ;(0, _MapChildHelper.construct)(
	      GroundOverlay.propTypes,
	      updaterMap,
	      _this.props,
	      groundOverlay
	    )
	    groundOverlay.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.GROUND_LAYER,
	      groundOverlay
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(GroundOverlay, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.GROUND_LAYER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.GROUND_LAYER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var GroundOverlay = this.state[_constants.GROUND_LAYER]
	        if (GroundOverlay) {
	          GroundOverlay.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	     * Gets the `LatLngBounds` of this overlay.
	     * @type LatLngBoundsLatLngBounds
	     * @public 
	     */
	    },
	    {
	      key: "getBounds",
	      value: function getBounds() {
	        return this.state[_constants.GROUND_LAYER].getBounds()
	      },
	
	      /**
	     * Returns the opacity of this ground overlay.
	     * @type number
	     * @public 
	     */
	    },
	    {
	      key: "getOpacity",
	      value: function getOpacity() {
	        return this.state[_constants.GROUND_LAYER].getOpacity()
	      },
	
	      /**
	     * Gets the url of the projected image.
	     * @type string
	     * @public 
	     */
	    },
	    {
	      key: "getUrl",
	      value: function getUrl() {
	        return this.state[_constants.GROUND_LAYER].getUrl()
	      },
	    },
	  ])
	  return GroundOverlay
	})(
	  _react2.default.PureComponent
	)) /*
	                                   * -----------------------------------------------------------------------------
	                                   * This file is auto-generated from the corresponding file at `src/macros/`.
	                                   * Please **DO NOT** edit this file directly when creating PRs.
	                                   * -----------------------------------------------------------------------------
	                                   */
	/* global google */
	
	GroundOverlay.propTypes = {
	  /**
	   * @type string
	   */
	  defaultUrl:
	    _propTypes2.default
	      .string /* v10.0.0 .isRequired */ /**
	     * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
	     */,
	
	  defaultBounds:
	    _propTypes2.default
	      .object /* v10.0.0 .isRequired */ /**
	     * @type string
	     * @deprecated use `defaultUrl` instead. It will be removed in v10.0.0
	     */,
	
	  url: _propTypes2.default.string,
	
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
	   * @deprecated use `defaultBounds` instead. It will be removed in v10.0.0
	   */
	  bounds: _propTypes2.default.object,
	
	  /**
	   * @type number
	   */
	  defaultOpacity: _propTypes2.default.number,
	
	  /**
	   * @type number
	   */
	  opacity: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	}
	GroundOverlay.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = GroundOverlay
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onClick: "click",
	}
	
	var updaterMap = {
	  opacity: function opacity(instance, _opacity) {
	    instance.setOpacity(_opacity)
	  },
	}


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.DirectionsRenderer = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.DirectionsRenderer`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var DirectionsRenderer = (exports.DirectionsRenderer = (function(
	  _React$PureComponent
	) {
	  ;(0, _inherits3.default)(DirectionsRenderer, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	   */
	  function DirectionsRenderer(props, context) {
	    ;(0, _classCallCheck3.default)(this, DirectionsRenderer)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (DirectionsRenderer.__proto__ ||
	        (0, _getPrototypeOf2.default)(DirectionsRenderer)
	      ).call(this, props, context)
	    )
	
	    var directionsRenderer = new google.maps.DirectionsRenderer()
	    ;(0, _MapChildHelper.construct)(
	      DirectionsRenderer.propTypes,
	      updaterMap,
	      _this.props,
	      directionsRenderer
	    )
	    directionsRenderer.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.DIRECTIONS_RENDERER,
	      directionsRenderer
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(DirectionsRenderer, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.DIRECTIONS_RENDERER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.DIRECTIONS_RENDERER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var directionsRenderer = this.state[_constants.DIRECTIONS_RENDERER]
	        if (directionsRenderer) {
	          directionsRenderer.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	     * Returns the renderer's current set of directions.
	     * @type DirectionsResult
	     * @public 
	     */
	    },
	    {
	      key: "getDirections",
	      value: function getDirections() {
	        return this.state[_constants.DIRECTIONS_RENDERER].getDirections()
	      },
	
	      /**
	     * Returns the panel `<div>` in which the `DirectionsResult` is rendered.
	     * @type Node<div>DirectionsResult
	     * @public 
	     */
	    },
	    {
	      key: "getPanel",
	      value: function getPanel() {
	        return this.state[_constants.DIRECTIONS_RENDERER].getPanel()
	      },
	
	      /**
	     * Returns the current (zero-based) route index in use by this `DirectionsRenderer` object.
	     * @type numberDirectionsRenderer
	     * @public 
	     */
	    },
	    {
	      key: "getRouteIndex",
	      value: function getRouteIndex() {
	        return this.state[_constants.DIRECTIONS_RENDERER].getRouteIndex()
	      },
	    },
	  ])
	  return DirectionsRenderer
	})(_react2.default.PureComponent))
	
	DirectionsRenderer.propTypes = {
	  /**
	   * @type DirectionsResult
	   */
	  defaultDirections: _propTypes2.default.any,
	
	  /**
	   * @type DirectionsRendererOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type Node
	   */
	  defaultPanel: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  defaultRouteIndex: _propTypes2.default.number,
	
	  /**
	   * @type DirectionsResult
	   */
	  directions: _propTypes2.default.any,
	
	  /**
	   * @type DirectionsRendererOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type Node
	   */
	  panel: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  routeIndex: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onDirectionsChanged: _propTypes2.default.func,
	}
	DirectionsRenderer.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = DirectionsRenderer
	
	var eventMap = {
	  onDirectionsChanged: "directions_changed",
	}
	
	var updaterMap = {
	  directions: function directions(instance, _directions) {
	    instance.setDirections(_directions)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  panel: function panel(instance, _panel) {
	    instance.setPanel(_panel)
	  },
	  routeIndex: function routeIndex(instance, _routeIndex) {
	    instance.setRouteIndex(_routeIndex)
	  },
	}


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.FusionTablesLayer = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.FusionTablesLayer`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var FusionTablesLayer = (exports.FusionTablesLayer = (function(
	  _React$PureComponent
	) {
	  ;(0, _inherits3.default)(FusionTablesLayer, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
	   */
	  function FusionTablesLayer(props, context) {
	    ;(0, _classCallCheck3.default)(this, FusionTablesLayer)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (FusionTablesLayer.__proto__ ||
	        (0, _getPrototypeOf2.default)(FusionTablesLayer)
	      ).call(this, props, context)
	    )
	
	    var fusionTablesLayer = new google.maps.FusionTablesLayer()
	    ;(0, _MapChildHelper.construct)(
	      FusionTablesLayer.propTypes,
	      updaterMap,
	      _this.props,
	      fusionTablesLayer
	    )
	    fusionTablesLayer.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.FUSION_TABLES_LAYER,
	      fusionTablesLayer
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(FusionTablesLayer, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.FUSION_TABLES_LAYER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.FUSION_TABLES_LAYER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var fusionTablesLayer = this.state[_constants.FUSION_TABLES_LAYER]
	        if (fusionTablesLayer) {
	          fusionTablesLayer.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	    },
	  ])
	  return FusionTablesLayer
	})(_react2.default.PureComponent))
	
	FusionTablesLayer.propTypes = {
	  /**
	   * @type FusionTablesLayerOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type FusionTablesLayerOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	}
	FusionTablesLayer.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = FusionTablesLayer
	
	var eventMap = {
	  onClick: "click",
	}
	
	var updaterMap = {
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	}


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.KmlLayer = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.KmlLayer`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var KmlLayer = (exports.KmlLayer = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(KmlLayer, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	   */
	  function KmlLayer(props, context) {
	    ;(0, _classCallCheck3.default)(this, KmlLayer)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (KmlLayer.__proto__ || (0, _getPrototypeOf2.default)(KmlLayer)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var kmlLayer = new google.maps.KmlLayer()
	    ;(0, _MapChildHelper.construct)(
	      KmlLayer.propTypes,
	      updaterMap,
	      _this.props,
	      kmlLayer
	    )
	    kmlLayer.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.KML_LAYER,
	      kmlLayer
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(KmlLayer, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.KML_LAYER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.KML_LAYER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var kmlLayer = this.state[_constants.KML_LAYER]
	        if (kmlLayer) {
	          kmlLayer.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	     * Get the default viewport for the layer being displayed.
	     * @type LatLngBounds
	     * @public 
	     */
	    },
	    {
	      key: "getDefaultViewport",
	      value: function getDefaultViewport() {
	        return this.state[_constants.KML_LAYER].getDefaultViewport()
	      },
	
	      /**
	     * Get the metadata associated with this layer, as specified in the layer markup.
	     * @type KmlLayerMetadata
	     * @public 
	     */
	    },
	    {
	      key: "getMetadata",
	      value: function getMetadata() {
	        return this.state[_constants.KML_LAYER].getMetadata()
	      },
	
	      /**
	     * Get the status of the layer, set once the requested document has loaded.
	     * @type KmlLayerStatus
	     * @public 
	     */
	    },
	    {
	      key: "getStatus",
	      value: function getStatus() {
	        return this.state[_constants.KML_LAYER].getStatus()
	      },
	
	      /**
	     * Gets the URL of the KML file being displayed.
	     * @type string
	     * @public 
	     */
	    },
	    {
	      key: "getUrl",
	      value: function getUrl() {
	        return this.state[_constants.KML_LAYER].getUrl()
	      },
	
	      /**
	     * Gets the z-index of the KML Layer.
	     * @type number
	     * @public 
	     */
	    },
	    {
	      key: "getZIndex",
	      value: function getZIndex() {
	        return this.state[_constants.KML_LAYER].getZIndex()
	      },
	    },
	  ])
	  return KmlLayer
	})(_react2.default.PureComponent))
	
	KmlLayer.propTypes = {
	  /**
	   * @type KmlLayerOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  defaultUrl: _propTypes2.default.string,
	
	  /**
	   * @type number
	   */
	  defaultZIndex: _propTypes2.default.number,
	
	  /**
	   * @type KmlLayerOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  url: _propTypes2.default.string,
	
	  /**
	   * @type number
	   */
	  zIndex: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onDefaultViewportChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onStatusChanged: _propTypes2.default.func,
	}
	KmlLayer.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = KmlLayer
	
	var eventMap = {
	  onDefaultViewportChanged: "defaultviewport_changed",
	  onClick: "click",
	  onStatusChanged: "status_changed",
	}
	
	var updaterMap = {
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  url: function url(instance, _url) {
	    instance.setUrl(_url)
	  },
	  zIndex: function zIndex(instance, _zIndex) {
	    instance.setZIndex(_zIndex)
	  },
	}


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.TrafficLayer = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.TrafficLayer`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var TrafficLayer = (exports.TrafficLayer = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(TrafficLayer, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
	   */
	  function TrafficLayer(props, context) {
	    ;(0, _classCallCheck3.default)(this, TrafficLayer)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (TrafficLayer.__proto__ || (0, _getPrototypeOf2.default)(TrafficLayer)
	      ).call(this, props, context)
	    )
	
	    var trafficLayer = new google.maps.TrafficLayer()
	    ;(0, _MapChildHelper.construct)(
	      TrafficLayer.propTypes,
	      updaterMap,
	      _this.props,
	      trafficLayer
	    )
	    trafficLayer.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.TRAFFIC_LAYER,
	      trafficLayer
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(TrafficLayer, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.TRAFFIC_LAYER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.TRAFFIC_LAYER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var trafficLayer = this.state[_constants.TRAFFIC_LAYER]
	        if (trafficLayer) {
	          trafficLayer.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	    },
	  ])
	  return TrafficLayer
	})(_react2.default.PureComponent))
	
	TrafficLayer.propTypes = {
	  /**
	   * @type TrafficLayerOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type TrafficLayerOptions
	   */
	  options: _propTypes2.default.any,
	}
	TrafficLayer.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = TrafficLayer
	
	var eventMap = {}
	
	var updaterMap = {
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	}


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.StreetViewPanorama = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _invariant = __webpack_require__(352)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.StreetViewPanorama`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
	 */
	var StreetViewPanorama = (exports.StreetViewPanorama = (function(
	  _React$PureComponent
	) {
	  ;(0, _inherits3.default)(StreetViewPanorama, _React$PureComponent)
	
	  function StreetViewPanorama(props, context) {
	    ;(0, _classCallCheck3.default)(this, StreetViewPanorama)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (StreetViewPanorama.__proto__ ||
	        (0, _getPrototypeOf2.default)(StreetViewPanorama)
	      ).call(this, props, context)
	    )
	
	    ;(0, _invariant2.default)(
	      !!_this.context[_constants.MAP],
	      "Did you render <StreetViewPanorama> as a child of <GoogleMap> with withGoogleMap() HOC?"
	    )
	    ;(0, _MapChildHelper.construct)(
	      StreetViewPanorama.propTypes,
	      updaterMap,
	      _this.props,
	      _this.context[_constants.MAP].getStreetView()
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(StreetViewPanorama, [
	    {
	      key: "getChildContext",
	      value: function getChildContext() {
	        return (0, _defineProperty3.default)(
	          {},
	          _constants.MAP,
	          this.context[_constants.MAP].getStreetView()
	        )
	      },
	    },
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.context[_constants.MAP].getStreetView(),
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.context[_constants.MAP].getStreetView(),
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var streetViewPanorama = this.context[_constants.MAP].getStreetView()
	        if (streetViewPanorama) {
	          streetViewPanorama.setVisible(false)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        var children = this.props.children
	
	        return _react2.default.createElement("div", null, children)
	      },
	
	      /**
	     * Returns the set of navigation links for the Street View panorama.
	     * @type Array<StreetViewLink>
	     * @public 
	     */
	    },
	    {
	      key: "getLinks",
	      value: function getLinks() {
	        return this.context[_constants.MAP].getLinks()
	      },
	
	      /**
	     * Returns the StreetViewLocation of the current panorama.
	     * @type StreetViewLocation
	     * @public 
	     */
	    },
	    {
	      key: "getLocation",
	      value: function getLocation() {
	        return this.context[_constants.MAP].getLocation()
	      },
	
	      /**
	     * Returns the state of motion tracker. If true when the user physically moves the device and the browser supports it, the Street View Panorama tracks the physical movements.
	     * @type boolean
	     * @public 
	     */
	    },
	    {
	      key: "getMotionTracking",
	      value: function getMotionTracking() {
	        return this.context[_constants.MAP].getMotionTracking()
	      },
	
	      /**
	     * Returns the current panorama ID for the Street View panorama. This id is stable within the browser's current session only.
	     * @type string
	     * @public 
	     */
	    },
	    {
	      key: "getPano",
	      value: function getPano() {
	        return this.context[_constants.MAP].getPano()
	      },
	
	      /**
	     * Returns the heading and pitch of the photographer when this panorama was taken. For Street View panoramas on the road, this also reveals in which direction the car was travelling. This data is available after the `pano_changed` event.
	     * @type StreetViewPovpano_changed
	     * @public 
	     */
	    },
	    {
	      key: "getPhotographerPov",
	      value: function getPhotographerPov() {
	        return this.context[_constants.MAP].getPhotographerPov()
	      },
	
	      /**
	     * Returns the current `LatLng` position for the Street View panorama.
	     * @type LatLngLatLng
	     * @public 
	     */
	    },
	    {
	      key: "getPosition",
	      value: function getPosition() {
	        return this.context[_constants.MAP].getPosition()
	      },
	
	      /**
	     * Returns the current point of view for the Street View panorama.
	     * @type StreetViewPov
	     * @public 
	     */
	    },
	    {
	      key: "getPov",
	      value: function getPov() {
	        return this.context[_constants.MAP].getPov()
	      },
	
	      /**
	     * Returns the status of the panorama on completion of the `setPosition()` or `setPano()` request.
	     * @type StreetViewStatussetPosition()setPano()
	     * @public 
	     */
	    },
	    {
	      key: "getStatus",
	      value: function getStatus() {
	        return this.context[_constants.MAP].getStatus()
	      },
	
	      /**
	     * Returns `true` if the panorama is visible. It does not specify whether Street View imagery is available at the specified position.
	     * @type booleantrue
	     * @public 
	     */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.context[_constants.MAP].getVisible()
	      },
	
	      /**
	     * Returns the zoom level of the panorama. Fully zoomed-out is level 0, where the field of view is 180 degrees. Zooming in increases the zoom level.
	     * @type number
	     * @public 
	     */
	    },
	    {
	      key: "getZoom",
	      value: function getZoom() {
	        return this.context[_constants.MAP].getZoom()
	      },
	    },
	  ])
	  return StreetViewPanorama
	})(
	  _react2.default.PureComponent
	)) /*
	                                   * -----------------------------------------------------------------------------
	                                   * This file is auto-generated from the corresponding file at `src/macros/`.
	                                   * Please **DO NOT** edit this file directly when creating PRs.
	                                   * -----------------------------------------------------------------------------
	                                   */
	
	StreetViewPanorama.propTypes = {
	  /**
	   * @type Array<StreetViewLink>
	   */
	  defaultLinks: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultMotionTracking: _propTypes2.default.bool,
	
	  /**
	   * @type StreetViewPanoramaOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  defaultPano: _propTypes2.default.string,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  defaultPosition: _propTypes2.default.any,
	
	  /**
	   * @type StreetViewPov
	   */
	  defaultPov: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  defaultZoom: _propTypes2.default.number,
	
	  /**
	   * @type Array<StreetViewLink>
	   */
	  links: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  motionTracking: _propTypes2.default.bool,
	
	  /**
	   * @type StreetViewPanoramaOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  pano: _propTypes2.default.string,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  position: _propTypes2.default.any,
	
	  /**
	   * @type StreetViewPov
	   */
	  pov: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  zoom: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onCloseClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onPanoChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onPositionChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onPovChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onResize: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onStatusChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onVisibleChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onZoomChanged: _propTypes2.default.func,
	}
	StreetViewPanorama.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	StreetViewPanorama.childContextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = StreetViewPanorama
	
	var eventMap = {
	  onCloseClick: "closeclick",
	  onPanoChanged: "pano_changed",
	  onPositionChanged: "position_changed",
	  onPovChanged: "pov_changed",
	  onResize: "resize",
	  onStatusChanged: "status_changed",
	  onVisibleChanged: "visible_changed",
	  onZoomChanged: "zoom_changed",
	}
	
	var updaterMap = {
	  links: function links(instance, _links) {
	    instance.setLinks(_links)
	  },
	  motionTracking: function motionTracking(instance, _motionTracking) {
	    instance.setMotionTracking(_motionTracking)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  pano: function pano(instance, _pano) {
	    instance.setPano(_pano)
	  },
	  position: function position(instance, _position) {
	    instance.setPosition(_position)
	  },
	  pov: function pov(instance, _pov) {
	    instance.setPov(_pov)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	  zoom: function zoom(instance, _zoom) {
	    instance.setZoom(_zoom)
	  },
	}


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.BicyclingLayer = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.BicyclingLayer`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var BicyclingLayer = (exports.BicyclingLayer = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(BicyclingLayer, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
	   */
	  function BicyclingLayer(props, context) {
	    ;(0, _classCallCheck3.default)(this, BicyclingLayer)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (BicyclingLayer.__proto__ || (0, _getPrototypeOf2.default)(BicyclingLayer)
	      ).call(this, props, context)
	    )
	
	    var bicyclingLayer = new google.maps.BicyclingLayer()
	    ;(0, _MapChildHelper.construct)(
	      BicyclingLayer.propTypes,
	      updaterMap,
	      _this.props,
	      bicyclingLayer
	    )
	    bicyclingLayer.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.BICYCLING_LAYER,
	      bicyclingLayer
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(BicyclingLayer, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.BICYCLING_LAYER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.BICYCLING_LAYER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var bicyclingLayer = this.state[_constants.BICYCLING_LAYER]
	        if (bicyclingLayer) {
	          bicyclingLayer.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	    },
	  ])
	  return BicyclingLayer
	})(_react2.default.PureComponent))
	
	BicyclingLayer.propTypes = {}
	BicyclingLayer.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = BicyclingLayer
	
	var eventMap = {}
	
	var updaterMap = {}


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PickupSitesMap = undefined;
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleMaps = __webpack_require__(848);
	
	var _SearchBox = __webpack_require__(1072);
	
	var _SearchBox2 = _interopRequireDefault(_SearchBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INPUT_STYLE = {
	    boxSizing: "border-box",
	    MozBoxSizing: "border-box",
	    border: "1px solid transparent",
	    width: "240px",
	    height: "30px",
	    marginTop: "10px",
	    padding: "0 12px",
	    borderRadius: "1px",
	    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
	    fontSize: "14px",
	    outline: "none",
	    textOverflow: "ellipses"
	};
	var INPUT_STYLE_MOBILE = {
	    boxSizing: "border-box",
	    MozBoxSizing: "border-box",
	    border: "1px solid transparent",
	    width: "105px",
	    height: "30px",
	    marginTop: "10px",
	    padding: "0 12px",
	    borderRadius: "2px",
	    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
	    fontSize: "14px",
	    outline: "none",
	    textOverflow: "ellipses"
	};
	
	var PickupSitesMap = exports.PickupSitesMap = (0, _reactGoogleMaps.withGoogleMap)(function (props) {
	    return _react2.default.createElement(
	        _reactGoogleMaps.GoogleMap,
	        {
	            ref: props.onMapMounted,
	            options: {
	                panControl: true,
	                zoomControl: true,
	                scaleControl: true,
	                mapTypeId: 'roadmap',
	                draggable: true,
	                animation: false },
	            zoom: !props.zoom ? 12 : props.zoom /*The zoom is relevant only if fitBounds not called*/
	            , center: props.center,
	            onZoomChanged: props.handleMapZoomChanged,
	            onCenterChanged: props.handleMapCenterChanged },
	        !props.onSearchBoxMounted ? undefined : _react2.default.createElement(
	            _SearchBox2.default,
	            {
	                ref: props.onSearchBoxMounted,
	                bounds: props.bounds,
	                controlPosition: google.maps.ControlPosition.TOP_LEFT,
	                onPlacesChanged: props.onPlacesChanged },
	            _react2.default.createElement("input", {
	                type: "text",
	                placeholder: "Zip, Address",
	                style: props.isXs ? INPUT_STYLE_MOBILE : INPUT_STYLE
	            })
	        ),
	        props.markers.map(function (marker, index) {
	            return _react2.default.createElement(
	                _reactGoogleMaps.Marker,
	                { key: index, position: marker.position,
	                    onClick: function onClick() {
	                        return props.handleMarkerClick(marker);
	                    },
	                    icon: marker.icon },
	                marker.showInfo ? props.renderInfoWindow(index, marker) : null
	            );
	        })
	    );
	});

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.SearchBox = undefined
	
	var _defineProperty2 = __webpack_require__(930)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(850)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(532)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(854)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(533)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(567)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _isNumber2 = __webpack_require__(1073)
	
	var _isNumber3 = _interopRequireDefault(_isNumber2)
	
	var _invariant = __webpack_require__(352)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _canUseDom = __webpack_require__(924)
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom)
	
	var _react = __webpack_require__(338)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _reactDom = __webpack_require__(341)
	
	var _reactDom2 = _interopRequireDefault(_reactDom)
	
	var _propTypes = __webpack_require__(348)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(934)
	
	var _constants = __webpack_require__(931)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.places.SearchBox` on the map
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#SearchBox
	 */
	var SearchBox = (exports.SearchBox = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(SearchBox, _React$PureComponent)
	
	  function SearchBox() {
	    var _ref
	
	    var _temp, _this, _ret
	
	    ;(0, _classCallCheck3.default)(this, SearchBox)
	
	    for (
	      var _len = arguments.length, args = Array(_len), _key = 0;
	      _key < _len;
	      _key++
	    ) {
	      args[_key] = arguments[_key]
	    }
	
	    return (
	      (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
	        this,
	        (_ref =
	          SearchBox.__proto__ ||
	          (0, _getPrototypeOf2.default)(SearchBox)).call.apply(
	          _ref,
	          [this].concat(args)
	        )
	      )),
	      _this)),
	      (_this.state = (0, _defineProperty3.default)(
	        {},
	        _constants.SEARCH_BOX,
	        null
	      )),
	      _temp)),
	      (0, _possibleConstructorReturn3.default)(_this, _ret)
	    )
	  }
	
	  ;(0, _createClass3.default)(SearchBox, [
	    {
	      key: "componentWillMount",
	      value: function componentWillMount() {
	        if (!_canUseDom2.default || this.containerElement) {
	          return
	        }
	        ;(0, _invariant2.default)(
	          google.maps.places,
	          'Did you include "libraries=places" in the URL?'
	        )
	        this.containerElement = document.createElement("div")
	        this.handleRenderChildToContainerElement()
	        if (_react2.default.version.match(/^16/)) {
	          return
	        }
	        this.handleInitializeSearchBox()
	      },
	    },
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var searchBox = this.state[_constants.SEARCH_BOX]
	        if (_react2.default.version.match(/^16/)) {
	          searchBox = this.handleInitializeSearchBox()
	        }
	        ;(0, _MapChildHelper.componentDidMount)(this, searchBox, eventMap)
	        this.handleMountAtControlPosition()
	      },
	    },
	    {
	      key: "componentWillUpdate",
	      value: function componentWillUpdate(nextProp) {
	        if (this.props.controlPosition !== nextProp.controlPosition) {
	          this.handleUnmountAtControlPosition()
	        }
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.SEARCH_BOX],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	        if (this.props.children !== prevProps.children) {
	          this.handleRenderChildToContainerElement()
	        }
	        if (this.props.controlPosition !== prevProps.controlPosition) {
	          this.handleMountAtControlPosition()
	        }
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        this.handleUnmountAtControlPosition()
	        if (_react2.default.version.match(/^16/)) {
	          return
	        }
	        if (this.containerElement) {
	          _reactDom2.default.unmountComponentAtNode(this.containerElement)
	          this.containerElement = null
	        }
	      },
	    },
	    {
	      key: "handleInitializeSearchBox",
	      value: function handleInitializeSearchBox() {
	        /*
	       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#SearchBox
	       */
	        var searchBox = new google.maps.places.SearchBox(
	          this.containerElement.querySelector("input")
	        )
	        ;(0, _MapChildHelper.construct)(
	          SearchBox.propTypes,
	          updaterMap,
	          this.props,
	          searchBox
	        )
	        this.setState(
	          (0, _defineProperty3.default)({}, _constants.SEARCH_BOX, searchBox)
	        )
	        return searchBox
	      },
	    },
	    {
	      key: "handleRenderChildToContainerElement",
	      value: function handleRenderChildToContainerElement() {
	        if (_react2.default.version.match(/^16/)) {
	          return
	        }
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(
	          this,
	          _react2.default.Children.only(this.props.children),
	          this.containerElement
	        )
	      },
	    },
	    {
	      key: "handleMountAtControlPosition",
	      value: function handleMountAtControlPosition() {
	        if (isValidControlPosition(this.props.controlPosition)) {
	          this.mountControlIndex =
	            -1 +
	            this.context[_constants.MAP].controls[
	              this.props.controlPosition
	            ].push(this.containerElement.firstChild)
	        }
	      },
	    },
	    {
	      key: "handleUnmountAtControlPosition",
	      value: function handleUnmountAtControlPosition() {
	        if (isValidControlPosition(this.props.controlPosition)) {
	          var child = this.context[_constants.MAP].controls[
	            this.props.controlPosition
	          ].removeAt(this.mountControlIndex)
	          this.containerElement.appendChild(child)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        if (_react2.default.version.match(/^16/)) {
	          return _reactDom2.default.createPortal(
	            _react2.default.Children.only(this.props.children),
	            this.containerElement
	          )
	        }
	        return false
	      },
	
	      /**
	     * Returns the bounds to which query predictions are biased.
	     * @type LatLngBounds
	     * @public 
	     */
	    },
	    {
	      key: "getBounds",
	      value: function getBounds() {
	        return this.state[_constants.SEARCH_BOX].getBounds()
	      },
	
	      /**
	     * Returns the query selected by the user, or `null` if no places have been found yet, to be used with `places_changed` event.
	     * @type Array<PlaceResult>nullplaces_changed
	     * @public 
	     */
	    },
	    {
	      key: "getPlaces",
	      value: function getPlaces() {
	        return this.state[_constants.SEARCH_BOX].getPlaces()
	      },
	    },
	  ])
	  return SearchBox
	})(
	  _react2.default.PureComponent
	)) /*
	                                   * -----------------------------------------------------------------------------
	                                   * This file is auto-generated from the corresponding file at `src/macros/`.
	                                   * Please **DO NOT** edit this file directly when creating PRs.
	                                   * -----------------------------------------------------------------------------
	                                   */
	/* global google */
	
	SearchBox.propTypes = {
	  /**
	   * Where to put `<SearchBox>` inside a `<GoogleMap>`
	   *
	   * @example google.maps.ControlPosition.TOP_LEFT
	   * @type number
	   */
	  controlPosition: _propTypes2.default.number,
	
	  /**
	   * @type LatLngBounds|LatLngBoundsLiteral
	   */
	  defaultBounds: _propTypes2.default.any,
	
	  /**
	   * @type LatLngBounds|LatLngBoundsLiteral
	   */
	  bounds: _propTypes2.default.any,
	
	  /**
	   * function
	   */
	  onPlacesChanged: _propTypes2.default.func,
	}
	SearchBox.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = SearchBox
	
	var isValidControlPosition = _isNumber3.default
	
	var eventMap = {
	  onPlacesChanged: "places_changed",
	}
	
	var updaterMap = {
	  bounds: function bounds(instance, _bounds) {
	    instance.setBounds(_bounds)
	  },
	}


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(410),
	    isObjectLike = __webpack_require__(418);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	var _constants = __webpack_require__(463);
	
	var _JoinItemCard = __webpack_require__(1076);
	
	var _JoinItemCard2 = _interopRequireDefault(_JoinItemCard);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _LoadingAnimation = __webpack_require__(834);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _joinActions = __webpack_require__(752);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _joinShareStep = __webpack_require__(1078);
	
	var _joinShareStep2 = _interopRequireDefault(_joinShareStep);
	
	var _basket = __webpack_require__(757);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinSharesOptionsStep = function (_React$Component) {
	    _inherits(JoinSharesOptionsStep, _React$Component);
	
	    function JoinSharesOptionsStep() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinSharesOptionsStep);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinSharesOptionsStep.__proto__ || Object.getPrototypeOf(JoinSharesOptionsStep)).call.apply(_ref, [this].concat(args))), _this), _this.getNoItemsMessage = function () {
	            return _this.props.step === _constants.JoinSteps.SHARES ? (0, _translate.translate)("_NoShares1") + _this.props.farmEmail + (0, _translate.translate)("_NoShares2") : (0, _translate.translate)("_ContinueNextToCompleteSignupProcess");
	        }, _this.getInvalidOptionScheduleMessage = function () {
	            if (_this.props.invalidOptionScheduleMessage) {
	                return _react2.default.createElement(_ModalPopup2.default, {
	                    message: _this.props.invalidOptionScheduleMessage,
	                    middle: { text: 'Close', callback: _this.props.setInvalidOptionSchedulesDialog } });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(JoinSharesOptionsStep, [{
	        key: 'render',
	        value: function render() {
	            if (this.props.isFetching) return _react2.default.createElement(_LoadingAnimation2.default, null);
	            var items = this.props.items;
	            if (items) {
	                if (!this.props.isSharesAvailable) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'no-available-item-message' },
	                        (0, _translate.translate)("_WaitListLabel")
	                    );
	                }
	                if (Object.keys(items).length > 0) {
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        this.props.isWaitListOnly ? _react2.default.createElement(
	                            'div',
	                            { className: 'no-available-item-message' },
	                            (0, _translate.translate)("_WaitListLabel")
	                        ) : undefined,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'join-item-row' },
	                            items
	                        ),
	                        this.getInvalidOptionScheduleMessage()
	                    );
	                } else {
	                    return _react2.default.createElement(
	                        'div',
	                        { id: 'notItemMessage',
	                            className: 'no-available-item-message' },
	                        this.getNoItemsMessage()
	                    );
	                }
	            } else {
	                return null;
	            }
	        }
	    }]);
	
	    return JoinSharesOptionsStep;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    var items = undefined;
	    var signupData = state.signupData || {};
	    var summary = state.summary || {};
	    var pickupSite = summary.pickupSite;
	    var isWaitListOnly = (signupData.data || {}).isWaitListOnly;
	    var sharesData = signupData.sharesData;
	    var step = ownProps.step ? ownProps.step : (state.signupData || {}).step;
	    if (sharesData) {
	        items = step === _constants.JoinSteps.SHARES ? sharesData.shares : sharesData.options;
	    }
	    var filteredItems = void 0;
	    var isSharesAvailable = true;
	    if (items) {
	        if (items.length === 0) {
	            isSharesAvailable = false;
	        } else {
	            var schedules = {};
	            if (ownProps.flow === _constants.JoinModes.CHANGE || ownProps.isAddSubscription) {
	                Object.keys(signupData.schedules).map(function (key) {
	                    var schedule = signupData.schedules[key];
	                    var keepSchedule = true;
	                    if (summary.farmStoreClosedEndDate) {
	                        var scheduleComingDate = Object.keys(sharesData.remainingScheduleDates || {}).length > 0 && sharesData.remainingScheduleDates.hasOwnProperty(key) ? sharesData.remainingScheduleDates[key][0] : undefined;
	                        if (scheduleComingDate <= summary.farmStoreClosedEndDate) {
	                            keepSchedule = false;
	                        }
	                    }
	                    if (keepSchedule) {
	                        schedules[key] = schedule;
	                    }
	                }.bind(schedules));
	            } else {
	                schedules = signupData.schedules;
	            }
	            var nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
	            if (nextDeliveryDates) {
	                Object.keys(signupData.schedules).map(function (key) {
	                    var schedule = signupData.schedules[key];
	                    schedule.nextDeliveryDate = (0, _basket.getNextDeliveryDate)(pickupSite, undefined, _defineProperty({}, schedule.key, schedule), nextDeliveryDates);
	                });
	            }
	            var showOnlyFreeOptions = ownProps.flow === _constants.JoinModes.CHANGE && state.staticData.allowChangeFreeOptions;
	
	            filteredItems = Object.keys(items).map(function (key) {
	                var item = items[key];
	
	                if ((!item.waitList || item.isWaitListAllowed) && (!showOnlyFreeOptions || item.price === 0)) return _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12, md: 6, key: key, className: 'join-item-col' },
	                    _react2.default.createElement(_JoinItemCard2.default, { item: item, schedules: schedules, isWaitListOnly: isWaitListOnly })
	                );
	            });
	        }
	    }
	    return {
	        isFetching: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOAD_SIGNUP_SHARES),
	        items: filteredItems,
	        schedules: signupData.schedules,
	        step: step,
	        farmEmail: (state.staticData || {}).farmEmail,
	        pickupSite: pickupSite,
	        isWaitListOnly: isWaitListOnly,
	        isSharesAvailable: isSharesAvailable,
	        invalidOptionScheduleMessage: signupData.invalidOptionScheduleMessage,
	        isAddSubscription: signupData.isAddSubscription
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setInvalidOptionSchedulesDialog: function setInvalidOptionSchedulesDialog() {
	            dispatch((0, _joinActions.setInvalidOptionSchedulesMessage)(undefined));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JoinSharesOptionsStep);

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTooltip = __webpack_require__(780);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _ItemDetails = __webpack_require__(781);
	
	var _ItemDetails2 = _interopRequireDefault(_ItemDetails);
	
	var _ItemUnitOrVariants = __webpack_require__(782);
	
	var _ItemUnitOrVariants2 = _interopRequireDefault(_ItemUnitOrVariants);
	
	var _JoinScheduleSelector = __webpack_require__(785);
	
	var _JoinScheduleSelector2 = _interopRequireDefault(_JoinScheduleSelector);
	
	var _joinActions = __webpack_require__(752);
	
	var _reactRedux = __webpack_require__(427);
	
	var _utils = __webpack_require__(485);
	
	var _joinItemCard = __webpack_require__(1077);
	
	var _joinItemCard2 = _interopRequireDefault(_joinItemCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinItemCard = function (_React$Component) {
	    _inherits(JoinItemCard, _React$Component);
	
	    function JoinItemCard() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinItemCard);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinItemCard.__proto__ || Object.getPrototypeOf(JoinItemCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showDetailsModal: false
	        }, _this.getSchedules = function () {
	            if (!_this.props.item.waitList) {
	                return _react2.default.createElement(_JoinScheduleSelector2.default, { item: _this.props.item,
	                    schedules: _this.props.schedules,
	                    clientViewPort: _this.props.clientViewPort,
	                    isFarmSeasonal: _this.props.isFarmSeasonal });
	            }
	        }, _this.openDetails = function () {
	            _this.setState({ showDetailsModal: true });
	        }, _this.onCloseClick = function () {
	            _this.setState({ showDetailsModal: false });
	        }, _this.getItemDetails = function () {
	            if (_this.state.showDetailsModal) {
	                return _react2.default.createElement(_ItemDetails2.default, { item: _this.props.item,
	                    staticData: _this.props.staticData,
	                    isJoinFlow: true,
	                    isFarmSeasonal: _this.props.isFarmSeasonal,
	                    schedules: _this.props.schedules,
	                    pickupSite: _this.props.pickupSite,
	                    clientViewPort: _this.props.clientViewPort,
	                    shouldShowQuantityUpdater: true,
	                    closeDetails: _this.onCloseClick });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    // onChangeSchedule: function(event){
	    //     this.props.setSelectedSchedule(this.props.item.key, event.target.value);
	    // },
	
	
	    _createClass(JoinItemCard, [{
	        key: 'render',
	        value: function render() {
	            var item = this.props.item;
	            return _react2.default.createElement(
	                'div',
	                { className: 'join-item-card', name: 'joinItemCard' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'item-title', name: 'item-title', onClick: this.openDetails },
	                    this.props.item.title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'item-image-wrapper', onClick: this.openDetails },
	                    _react2.default.createElement('img', { className: 'item-image', src: item.imageUrl, onError: _utils.setNoItemImage, 'data-tip': 'Click for more details' }),
	                    _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', offset: { top: -50 } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'item-info' },
	                    _react2.default.createElement(_ItemUnitOrVariants2.default, {
	                        clientViewPort: this.props.clientViewPort,
	                        item: item,
	                        staticData: this.props.staticData,
	                        isJoinFlow: true,
	                        schedules: this.getSchedules(),
	                        isFarmSeasonal: this.props.isFarmSeasonal,
	                        pickupSite: this.props.pickupSite })
	                ),
	                this.getItemDetails()
	            );
	        }
	    }]);
	
	    return JoinItemCard;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    var signupData = state.signupData || {};
	    var summary = state.summary || {};
	    var isWaitListOnly = (signupData.data || {}).isWaitListOnly;
	    var item = ownProps.item;
	    var weeksLeft = item.weeksLeft ? [] : undefined;
	    var schedules = item.schedules ? [] : undefined;
	    var isDeliveriesLeft = item.isDeliveriesLeft ? [] : undefined;
	    if (!isWaitListOnly && item.schedules) {
	        item.schedules.forEach(function (schedule, index) {
	            if (ownProps.schedules.hasOwnProperty(schedule)) {
	                schedules.push(schedule);
	                if (isDeliveriesLeft) {
	                    isDeliveriesLeft.push(ownProps.item.isDeliveriesLeft[index]);
	                }
	                if (weeksLeft) {
	                    weeksLeft.push(ownProps.item.weeksLeft[index]);
	                }
	            }
	        });
	        item.schedules = schedules;
	        if (weeksLeft) {
	            item.weeksLeft = weeksLeft;
	        }
	        if (isDeliveriesLeft) {
	            item.isDeliveriesLeft = isDeliveriesLeft;
	        }
	    }
	    return {
	        clientViewPort: state.clientViewPort || {},
	        staticData: state.staticData || {},
	        isFarmSeasonal: signupData.data.isFarmSeasonal,
	        pickupSite: (summary.pickupSite || {}).key,
	        item: item
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setSelectedSchedule: function setSelectedSchedule(itemKey, scheduleKey) {
	            dispatch((0, _joinActions.setSelectedSchedule)(itemKey, scheduleKey));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JoinItemCard);

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _basket = __webpack_require__(757);
	
	var _joinActions = __webpack_require__(752);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _Coupon = __webpack_require__(1080);
	
	var _Coupon2 = _interopRequireDefault(_Coupon);
	
	var _translate = __webpack_require__(464);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _joinTermsStep = __webpack_require__(1082);
	
	var _joinTermsStep2 = _interopRequireDefault(_joinTermsStep);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinTermsStep = function (_React$Component) {
	    _inherits(JoinTermsStep, _React$Component);
	
	    function JoinTermsStep() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinTermsStep);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinTermsStep.__proto__ || Object.getPrototypeOf(JoinTermsStep)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            disabledApply: true
	        }, _this.expendComment = function (e) {
	            var id = e.target.id;
	            _this.refs[id].style.display = "none";
	            id = id.replace("more_", "comment_");
	            _this.refs[id].style.maxHeight = "initial";
	        }, _this.getNote = function (plan) {
	            if (_this.props.clientViewPort.isXs) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { name: 'planNote', sm: 6, xs: 11, className: 'term-col plan-note' },
	                    _react2.default.createElement('div', { className: 'list-row-comment', id: "comment_" + plan.key, ref: "comment_" + plan.key,
	                        dangerouslySetInnerHTML: { __html: plan.note } })
	                );
	            } else {
	                return _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { name: 'planNote', sm: 6, xs: 11, className: 'term-col plan-note' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        plan.note
	                    )
	                );
	            }
	        }, _this.onPaymentPlanSelected = function (paymentPlan) {
	            if (_this.props.paymentPlan.key === paymentPlan) return;
	            _this.props.selectPaymentPlan(paymentPlan);
	        }, _this.onApplyCouponClicked = function (couponId) {
	            if (couponId.length > 0 || _this.props.couponStatus === _constants.CouponStatus.INVALID) {
	                _this.props.applyCoupon(couponId);
	            }
	        }, _this.onRemoveCouponClicked = function () {
	            _this.props.removeCoupon();
	        }, _this.onChangeCouponId = function (event) {
	            var couponId = event.target.value;
	            var invalidStatus = _this.state.invalidStatus;
	            if (invalidStatus && (0, _utils.isEmptyString)(couponId)) {
	                invalidStatus = undefined;
	            }
	            _this.setState({ disabledApply: (0, _utils.isEmptyString)(couponId), invalidStatus: invalidStatus });
	        }, _this.getColumns = function () {
	            if (_this.props.clientViewPort.isXs) {
	                return null;
	            } else {
	                return _react2.default.createElement(
	                    _reactBootstrap.Form,
	                    { horizontal: true, className: 'list-container term-titles' },
	                    _react2.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { className: 'columns-title', controlId: 'termsTitles' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { componentClass: _reactBootstrap.ControlLabel, className: 'title-column', sm: 4 },
	                            (0, _translate.translate)("Payment Plan")
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { componentClass: _reactBootstrap.ControlLabel, className: 'title-column', sm: 2 },
	                            (0, _translate.translate)("Price")
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { componentClass: _reactBootstrap.ControlLabel, className: 'title-column', sm: 6 },
	                            (0, _translate.translate)("Notes")
	                        )
	                    )
	                );
	            }
	        }, _this.getPaymentPlan = function (plan) {
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                { name: 'paymentRow', key: plan.key, className: 'list-row term-row' },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { onClick: _this.onPaymentPlanSelected.bind(_this, plan.key), className: 'term-row-click-container' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, xs: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'list-item-title' },
	                            _react2.default.createElement('input', { name: 'selectPayment', type: 'radio', value: plan.key,
	                                className: 'radio-select',
	                                onChange: _this.onPaymentPlanSelected.bind(_this, plan.key),
	                                checked: _this.props.paymentPlan.key === plan.key }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'item-title plan-title', name: 'planTitle' },
	                                plan.title
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { name: 'planPrice', className: 'term-col plan-title', xs: 8, sm: 2 },
	                        plan.type === _constants.PaymentPlans.OneWeekDebit ? '' : _this.props.paymentsPrice[plan.key]
	                    ),
	                    _this.getNote(plan)
	                ),
	                _this.props.clientViewPort.isXs ? _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { name: 'planNote', xs: 11, className: 'term-col plan-note' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'read-more-comment', id: "more_" + plan.key, ref: "more_" + plan.key,
	                            onClick: _this.expendComment },
	                        (0, _translate.translate)("More") + "..."
	                    )
	                ) : undefined
	            );
	        }, _this.getCoupon = function () {
	            if (_this.props.hasCoupons) {
	                return _react2.default.createElement(_Coupon2.default, { couponStatus: _this.props.couponStatus, invalidStatus: _this.state.invalidStatus,
	                    coupon: _this.props.coupon, removeCoupon: _this.onRemoveCouponClicked,
	                    onChangeCouponId: _this.onChangeCouponId, disabledApply: _this.state.disabledApply,
	                    onApplyCouponClicked: _this.onApplyCouponClicked });
	            } else {
	                return null;
	            }
	        }, _this.showCouponValidationPopup = function () {
	            if (_this.props.coupon && _this.props.coupon.status === _constants.CouponStatus.INVALID_COUPON_MINIMUM) {
	                return _react2.default.createElement(_ModalPopup2.default, {
	                    onClose: function onClose() {
	                        _this.props.setCouponStatus(undefined);
	                    },
	                    message: !_this.props.coupon.calculateOptions ? (0, _translate.translate)(_constants.CouponStatus.INVALID_COUPON_MINIMUM).replace("{0}", _this.props.coupon.minimumOrder) : (0, _translate.translate)(_constants.CouponStatus.INVALID_COUPON_MINIMUM_WITH_OPTIONS).replace("{0}", _this.props.coupon.minimumOrder),
	                    middle: {
	                        text: 'Close', callback: function callback() {
	                            _this.props.setCouponStatus(undefined);
	                        }
	                    } });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(JoinTermsStep, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            for (var ref in this.refs) {
	                if (this.refs.hasOwnProperty(ref)) {
	                    var elem = this.refs[ref];
	                    if (elem.className === "list-row-comment") if (elem.scrollHeight > 42) {
	                        ref = ref.replace("comment_", "more_");
	                        this.refs[ref].style.display = "block";
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.couponStatus !== this.props.couponStatus && this.props.couponStatus === _constants.CouponStatus.VALIDATING) {
	                var invalidStatus = void 0;
	                if (nextProps.coupon && !(0, _joinActions.isValidateCouponMinimum)(nextProps.coupon, this.props.signupData.sharesData, this.props.staticData)) {
	                    invalidStatus = !nextProps.coupon.calculateOptions ? (0, _translate.translate)(_constants.CouponStatus.INVALID_COUPON_MINIMUM).replace("{0}", nextProps.coupon.minimumOrder) : (0, _translate.translate)(_constants.CouponStatus.INVALID_COUPON_MINIMUM_WITH_OPTIONS).replace("{0}", nextProps.coupon.minimumOrder);
	                } else if (nextProps.couponStatus === _constants.CouponStatus.INVALID) {
	                    invalidStatus = (0, _translate.translate)(_constants.CouponStatus.INVALID_COUPON);
	                }
	                this.setState({ invalidStatus: invalidStatus });
	                if (nextProps.coupon && nextProps.coupon.couponType !== "Subscription" || nextProps.coupon && !nextProps.coupon.couponType || invalidStatus) {
	                    this.props.removeCoupon();
	                }
	                if (!nextProps.coupon && !invalidStatus) {
	                    (0, _joinActions.setCouponStatus)(_constants.CouponStatus.INVALID_COUPON);
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'table-container-selector' },
	                !this.props.clientViewPort.isXs ? _react2.default.createElement(
	                    'div',
	                    { className: 'select-title' },
	                    (0, _translate.translate)("PaymentPlanStep.heading")
	                ) : undefined,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'pay-container' },
	                    this.getColumns(),
	                    this.props.paymentPlans.map(function (plan) {
	                        {
	                            return _this2.getPaymentPlan(plan);
	                        }
	                    })
	                ),
	                this.getCoupon(),
	                this.showCouponValidationPopup()
	            );
	        }
	    }]);
	
	    return JoinTermsStep;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var signupData = state.signupData || {};
	    var staticData = state.staticData;
	    var summary = state.summary || {};
	    var selectedData = signupData.selectedData || {};
	    var paymentsPrice = {};
	    var selectedItems = (0, _basket.getJoinSelectedItems)(signupData.sharesData.shares, signupData.sharesData.options).items;
	    var nextDeliveryDate = (0, _basket.getNextDeliveryDate)(summary.pickupSite, selectedItems, signupData.schedules, signupData.pickupSitesData.nextDeliveryDates);
	    var itemsRemainingDates = (0, _basket.getAllItemsRemainingDeliveryDates)(selectedItems, signupData.sharesData.remainingScheduleDates);
	
	    signupData.paymentPlans.map(function (plan) {
	        paymentsPrice[plan.key] = (0, _basket.calcTotals)(signupData.data.isFarmSeasonal, summary.pickupSite, selectedItems, plan, selectedData.coupon, itemsRemainingDates, signupData.sharesData.remainingScheduleDates, nextDeliveryDate, signupData.isAddSubscription, summary.discount, staticData, selectedData.selectedMethod).priceText;
	        if (paymentsPrice[plan.key] === "$0") paymentsPrice[plan.key] = "";
	    });
	
	    //Since add subscription can't create token, in case of member without token we need to present only payment plans which works with standard (single) payment methods.
	    //Therefore the installments and the one week debit shouldn't be presented.
	    var paymentPlans = !signupData.isAddSubscription || summary.hasPreapproval ? signupData.paymentPlans : signupData.paymentPlans.filter(function (paymentPlan) {
	        return paymentPlan.type !== _constants.PaymentPlans.AutoRecurring && paymentPlan.type !== _constants.PaymentPlans.PresetRecurring && paymentPlan.type !== _constants.PaymentPlans.OneWeekDebit && paymentPlan.type !== _constants.PaymentPlans.DistributionDynamicPrePayment;
	    });
	
	    var paymentPlanSorted = paymentPlans.slice(0).sort(function (a, b) {
	        return a.order - b.order;
	    });
	    var couponStatus = state.fetching.isFetching && state.fetching.fetchingType === _constants.FetchingTypes.VALIDATE_COUPON ? _constants.CouponStatus.VALIDATING : !selectedData.coupon ? _constants.CouponStatus.NONE : selectedData.coupon.valid && (selectedData.coupon.couponType === "Subscription" || !selectedData.coupon.couponType) ? _constants.CouponStatus.VALID : _constants.CouponStatus.INVALID;
	    return {
	        clientViewPort: state.clientViewPort || {},
	        staticData: staticData,
	        signupData: signupData,
	        paymentPlan: selectedData.selectedPaymentPlan || {},
	        paymentPlans: paymentPlanSorted,
	        paymentsPrice: paymentsPrice,
	        hasCoupons: signupData.data.hasCoupons && !signupData.isAddSubscription,
	        coupon: selectedData.coupon,
	        couponStatus: couponStatus
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        selectPaymentPlan: function selectPaymentPlan(key) {
	            dispatch((0, _joinActions.selectPaymentPlan)(key));
	        },
	        applyCoupon: function applyCoupon(couponId) {
	            dispatch((0, _joinActions.applyCoupon)(couponId));
	        },
	        removeCoupon: function removeCoupon() {
	            dispatch((0, _joinActions.removeCoupon)());
	        },
	        setCouponStatus: function setCouponStatus(status) {
	            dispatch((0, _joinActions.setCouponStatus)(status));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JoinTermsStep);

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Coupon = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(463);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	var _coupon = __webpack_require__(1081);
	
	var _coupon2 = _interopRequireDefault(_coupon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Coupon = exports.Coupon = function (_React$Component) {
	    _inherits(Coupon, _React$Component);
	
	    function Coupon() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Coupon);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Coupon.__proto__ || Object.getPrototypeOf(Coupon)).call.apply(_ref, [this].concat(args))), _this), _this.onApplyCouponClicked = function () {
	            _this.props.onApplyCouponClicked(_this.refs.couponId.value);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Coupon, [{
	        key: "render",
	        value: function render() {
	            var isLoading = this.props.couponStatus === _constants.CouponStatus.VALIDATING;
	            var submitLoadingClass = isLoading ? " loading" : "";
	            var submitClasses = "submit-order coupon-btn button" + submitLoadingClass;
	            var inputClass = this.props.invalidStatus ? "coupon-code-input coupon-code-input-error" : "coupon-code-input";
	            return _react2.default.createElement(
	                "div",
	                { className: "optional-promotion-code" },
	                (0, _translate.translate)("promotionalCode"),
	                this.props.couponStatus === _constants.CouponStatus.VALID && !this.props.invalidStatus ? _react2.default.createElement(
	                    "div",
	                    { className: "coupon-code" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "coupon-code-title" },
	                        (0, _translate.translate)("Coupon Code")
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "coupon-code-exists" },
	                        this.props.coupon.id
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: "primary", className: submitClasses,
	                            onClick: this.props.removeCoupon },
	                        (0, _translate.translate)("Remove")
	                    )
	                ) : _react2.default.createElement(
	                    "div",
	                    { className: "coupon-code" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "coupon-code-title" },
	                        "Coupon Code"
	                    ),
	                    _react2.default.createElement("input", { type: "text", ref: "couponId", id: "inpCouponCode", onChange: this.props.onChangeCouponId,
	                        className: inputClass, disabled: isLoading }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { disabled: this.props.disabledApply || isLoading, bsStyle: "primary", className: submitClasses,
	                            id: "btnApplyCoupon",
	                            onClick: this.onApplyCouponClicked },
	                        (0, _translate.translate)("Apply")
	                    )
	                ),
	                this.props.invalidStatus ? _react2.default.createElement(
	                    "div",
	                    { className: "coupon-code-validation" },
	                    this.props.invalidStatus
	                ) : undefined
	            );
	        }
	    }]);
	
	    return Coupon;
	}(_react2.default.Component);
	
	exports.default = Coupon;

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _reactRedux = __webpack_require__(427);
	
	var _JoinCreateAccount = __webpack_require__(1084);
	
	var _JoinCreateAccount2 = _interopRequireDefault(_JoinCreateAccount);
	
	var _ContactDetailsForm = __webpack_require__(1086);
	
	var _ContactDetailsForm2 = _interopRequireDefault(_ContactDetailsForm);
	
	var _LogInScreen = __webpack_require__(823);
	
	var _LogInScreen2 = _interopRequireDefault(_LogInScreen);
	
	var _SelectionTabs = __webpack_require__(842);
	
	var _SelectionTabs2 = _interopRequireDefault(_SelectionTabs);
	
	var _SelectionPane = __webpack_require__(844);
	
	var _SelectionPane2 = _interopRequireDefault(_SelectionPane);
	
	var _constants = __webpack_require__(463);
	
	var _joinActions = __webpack_require__(752);
	
	var _logInActions = __webpack_require__(750);
	
	var _memberDetailsActions = __webpack_require__(751);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _joinCreateAccount = __webpack_require__(1085);
	
	var _joinCreateAccount2 = _interopRequireDefault(_joinCreateAccount);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CREATE_ACCOUNT_TAB = "Create Account";
	var LOGIN_TAB = "Login";
	
	var JoinContactInfoStep = function (_React$Component) {
	    _inherits(JoinContactInfoStep, _React$Component);
	
	    function JoinContactInfoStep() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinContactInfoStep);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinContactInfoStep.__proto__ || Object.getPrototypeOf(JoinContactInfoStep)).call.apply(_ref, [this].concat(args))), _this), _this.tabChange = function (selectedTab) {
	            if (selectedTab === LOGIN_TAB) {
	                _this.props.resetEmailSent();
	                _this.props.setCreateAccountPage(_constants.JoinCreateAccountConstants.LOGIN);
	            } else {
	                _this.props.setCreateAccountPage(_constants.JoinCreateAccountConstants.CREATE_CONTACT);
	            }
	        }, _this.joinCreateAccountView = function () {
	            return _react2.default.createElement(_JoinCreateAccount2.default, { setCreateAccountPage: _this.props.setCreateAccountPage,
	                facebookAppId: _this.props.staticData.facebookAppId,
	                setMemberData: _this.props.setMemberData,
	                createFacebookMember: _this.props.createFacebookMember,
	                isGuestUser: _this.props.isGuestUser,
	                getSubscriptionStatus: _this.props.getSubscriptionStatus,
	                showLoading: _this.props.showLoading,
	                flowType: _constants.URLs.JOIN,
	                clientViewPort: _this.props.clientViewPort,
	                fbButtonEnabled: _this.props.fbButtonEnabled });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(JoinContactInfoStep, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.memberKey && nextProps.memberKey !== this.props.memberKey) {
	                this.props.setCreateAccountPage(_constants.JoinCreateAccountConstants.CONTACT_DETAILS);
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.memberKey) {
	                this.props.setCreateAccountPage(_constants.JoinCreateAccountConstants.CONTACT_DETAILS);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var showLogin = !this.props.memberKey;
	            if (!showLogin) {
	                if (this.props.contactInfoPage === _constants.JoinCreateAccountConstants.CONTACT_DETAILS) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'border-container create-account-tabs' },
	                        _react2.default.createElement(_ContactDetailsForm2.default, { flowType: _constants.URLs.JOIN })
	                    );
	                } else {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'border-container create-account-tabs' },
	                        this.joinCreateAccountView()
	                    );
	                }
	            } else if (this.props.clientViewPort.isXs) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'join-contact-mobile' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Tabs,
	                        { className: 'join-mobile-tab', id: 'createAccountStep', defaultActiveKey: CREATE_ACCOUNT_TAB,
	                            animation: false, onSelect: this.tabChange },
	                        _react2.default.createElement(
	                            _reactBootstrap.Tab,
	                            { title: (0, _translate.translate)(CREATE_ACCOUNT_TAB), eventKey: CREATE_ACCOUNT_TAB },
	                            this.props.contactInfoPage === _constants.JoinCreateAccountConstants.CONTACT_DETAILS ? _react2.default.createElement(_ContactDetailsForm2.default, { flowType: _constants.URLs.JOIN }) : this.joinCreateAccountView()
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Tab,
	                            { title: (0, _translate.translate)(LOGIN_TAB), eventKey: LOGIN_TAB },
	                            _react2.default.createElement(_LogInScreen2.default, { flowType: _constants.URLs.JOIN })
	                        )
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'border-container create-account-tabs' },
	                    _react2.default.createElement(
	                        _SelectionTabs2.default,
	                        { update: this.tabChange },
	                        _react2.default.createElement(
	                            _SelectionPane2.default,
	                            { label: (0, _translate.translate)(CREATE_ACCOUNT_TAB) },
	                            this.props.contactInfoPage === _constants.JoinCreateAccountConstants.CONTACT_DETAILS ? _react2.default.createElement(_ContactDetailsForm2.default, { flowType: _constants.URLs.JOIN }) : this.joinCreateAccountView()
	                        ),
	                        _react2.default.createElement(
	                            _SelectionPane2.default,
	                            { label: (0, _translate.translate)(LOGIN_TAB) },
	                            _react2.default.createElement(_LogInScreen2.default, { flowType: _constants.URLs.JOIN })
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return JoinContactInfoStep;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var signupData = state.signupData || {};
	    return {
	        clientViewPort: state.clientViewPort || {},
	        memberKey: (state.memberDetails || {}).key,
	        contactInfoPage: signupData.contactInfoPage,
	        memberDetails: state.memberDetails || {},
	        isGuestUser: signupData.isGuestUser,
	        showLoading: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOGIN),
	        fbButtonEnabled: (state.loginStatus || {}).enableFBButton
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setCreateAccountPage: function setCreateAccountPage(contactInfoPage) {
	            dispatch((0, _joinActions.setCreateAccountPage)(contactInfoPage));
	        },
	        setMemberData: function setMemberData(member) {
	            dispatch((0, _memberDetailsActions.setMemberData)(member));
	        },
	        createFacebookMember: function createFacebookMember(member) {
	            dispatch((0, _logInActions.createFacebookMember)(member));
	        },
	        getSubscriptionStatus: function getSubscriptionStatus(memberKey) {
	            dispatch((0, _logInActions.getSubscriptionStatus)(memberKey));
	        },
	        resetEmailSent: function resetEmailSent() {
	            dispatch((0, _logInActions.resetEmailSent)());
	        }
	    };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JoinContactInfoStep);

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _reactRedux = __webpack_require__(427);
	
	var _constants = __webpack_require__(463);
	
	var _logInActions = __webpack_require__(750);
	
	var _utils = __webpack_require__(485);
	
	var _translate = __webpack_require__(464);
	
	var _joinCreateAccount = __webpack_require__(1085);
	
	var _joinCreateAccount2 = _interopRequireDefault(_joinCreateAccount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinCreateAccount = function (_React$Component) {
	    _inherits(JoinCreateAccount, _React$Component);
	
	    function JoinCreateAccount() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinCreateAccount);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinCreateAccount.__proto__ || Object.getPrototypeOf(JoinCreateAccount)).call.apply(_ref, [this].concat(args))), _this), _this.goToContactDetails = function () {
	            _this.props.setMemberData({ isFBLogin: false });
	            _this.props.setCreateAccountPage(_constants.JoinCreateAccountConstants.CONTACT_DETAILS);
	        }, _this.goToLogin = function () {
	            _this.props.setCreateAccountPage(_constants.JoinCreateAccountConstants.LOGIN);
	        }, _this.statusChangeCallback = function (response, logOut, shouldNotLogin) {
	            if (response.status === 'connected') {
	                if (response.authResponse) {
	                    FB.api('/me', { fields: 'id,first_name,last_name,email' }, function (response) {
	                        this.handleFBConnect(response);
	                    }.bind(_this));
	                } else {
	                    console.log('User cancelled login or did not fully authorize.');
	                }
	            } else if (!shouldNotLogin) {
	                FB.login(function (response) {
	                    this.statusChangeCallback(response, false, true);
	                }.bind(_this));
	            }
	        }, _this.handleFBConnect = function (response) {
	            var member = { email: response.email, firstName: response.first_name,
	                lastName: response.last_name, facebookId: response.id, isFBLogin: true };
	            _this.props.setMemberData(member);
	            _this.props.createFacebookMember(member, _this.props.isGuestUser);
	        }, _this.checkLoginState = function () {
	            if (!_this.isFBLoaded()) return;
	            var that = _this;
	            FB.getLoginStatus(function (response) {
	                that.statusChangeCallback(response);
	            });
	        }, _this.enableFBButton = function () {
	            _this.props.setEnableFbButton(true);
	        }, _this.isFBLoaded = function () {
	            if (typeof FB === 'undefined') {
	                (0, _utils.initFacebook)(_this.props.facebookAppId, true, _this.enableFBButton);
	                _this.props.showFBErrorMessage();
	                return false;
	            }
	            return true;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(JoinCreateAccount, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            (0, _utils.initFacebook)(this.props.facebookAppId, false, this.enableFBButton);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var styleClass = "login-button" + (this.props.showLoading ? " loading" : "");
	            return _react2.default.createElement(
	                "div",
	                { className: "border-container border-container-join" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "inner-container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "form-container container-fluid" },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: "sign-in-fb btn-fb-join" },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { className: "button fb-" + styleClass, onClick: this.checkLoginState, disabled: !this.props.fbButtonEnabled },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "btn-fb-text" },
	                                    _react2.default.createElement("div", { className: "fb-img" }),
	                                    (0, _translate.translate)("Create account with Facebook")
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: "email-log-in btn-email-join" },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { bsStyle: "primary", className: "button email-" + styleClass, id: "btnlogin",
	                                    onClick: this.goToContactDetails },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "btn-email-text" },
	                                    (0, _translate.translate)("Create account with Email")
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "create-account-text" },
	                        (0, _translate.translate)("_createAccountBottomNote")
	                    ),
	                    this.props.clientViewPort.isXs && this.props.flowType === _constants.URLs.JOIN ? undefined : _react2.default.createElement("div", { className: "bottom-container" })
	                )
	            );
	        }
	    }]);
	
	    return JoinCreateAccount;
	}(_react2.default.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        showFBErrorMessage: function showFBErrorMessage() {
	            dispatch((0, _logInActions.showFBErrorMessage)());
	        },
	        setEnableFbButton: function setEnableFbButton(enableFBButton) {
	            dispatch((0, _logInActions.setEnableFbButton)(enableFBButton));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(JoinCreateAccount);

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _utils = __webpack_require__(485);
	
	var _statesData = __webpack_require__(1087);
	
	var _statesData2 = _interopRequireDefault(_statesData);
	
	var _constants = __webpack_require__(463);
	
	var _commonActions = __webpack_require__(747);
	
	var _memberDetailsActions = __webpack_require__(751);
	
	var _contactDetailsConstants = __webpack_require__(1088);
	
	var _basket = __webpack_require__(757);
	
	var _translate = __webpack_require__(464);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _accountActions = __webpack_require__(1089);
	
	var _contactDetailsForm = __webpack_require__(1090);
	
	var _contactDetailsForm2 = _interopRequireDefault(_contactDetailsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactDetailsForm = function (_React$Component) {
	    _inherits(ContactDetailsForm, _React$Component);
	
	    function ContactDetailsForm(props) {
	        _classCallCheck(this, ContactDetailsForm);
	
	        var _this = _possibleConstructorReturn(this, (ContactDetailsForm.__proto__ || Object.getPrototypeOf(ContactDetailsForm)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var states = props.farmCountry === 'CA' ? _statesData2.default.CA : _statesData2.default.US;
	        var memberDetails = Object.assign({}, props.memberDetails, {});
	        memberDetails['state'] = !memberDetails.state ? props.farmState : memberDetails.state;
	        _this.addressErrorCounter = 0;
	
	        _this.state = {
	            states: states,
	            memberDetails: memberDetails,
	            contactValidation: {},
	            enableToContinue: false
	        };
	        return _this;
	    }
	
	    _createClass(ContactDetailsForm, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            if (!this.props.memberDetails.key && !this.props.showPassword) {
	                this.props.setShowPassword(true);
	            }
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.memberAction !== nextProps.memberAction && nextProps.memberAction === _constants.MemberActions.VALIDATE_MEMBER_DETAILS) {
	                this.accountSaveClicked();
	            }
	            if (nextProps.updateMemberError && this.props.updateMemberError !== nextProps.updateMemberError) {
	                var contactValidation = this.state.contactValidation;
	                contactValidation.invalidEmail = nextProps.updateMemberError;
	                this.setState({ contactValidation: contactValidation });
	            }
	            if (!(0, _utils.isEmptyObj)(this.state.contactValidation)) {
	                for (var key in this.state.contactValidation) {
	                    if (this.state.contactValidation.hasOwnProperty(key) && this.state.contactValidation[key]) {
	                        var fieldName = key.substr(7, key.length - 1);
	                        fieldName = fieldName.replace(fieldName.charAt(0), fieldName[0].toLowerCase());
	                        var dom = _reactDom2.default.findDOMNode(this.refs[fieldName].refs.frm);
	                        dom.scrollIntoView(false);
	                        break;
	                    }
	                }
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var innerContainerStyle = "inner-container-join" + (this.props.clientViewPort.isXs ? " inner-container-join-mobile" : "");
	            var separatorLineStyle = "create-contact-line" + (this.props.clientViewPort.isXs ? " create-contact-line-mobile" : "");
	            var inputDetailsRowStyle = "input-detail-row" + (this.props.clientViewPort.isXs ? " input-detail-row-mobile" : "");
	            var primaryPhoneLabel = this.props.showCellPhoneLabels ? 'Primary Cell Phone*' : 'Primary Phone';
	            return _react2.default.createElement(
	                _reactBootstrap.Grid,
	                { className: "border-container border-container-join" },
	                this.getTitleHeader(),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: innerContainerStyle },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: "form-container contact-details-container", disabled: this.props.showLoading },
	                        _react2.default.createElement(
	                            "fieldset",
	                            { disabled: this.props.showLoading || this.props.isPreview || this.props.memberAction === _constants.MemberActions.VALIDATE_MEMBER_DETAILS },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { md: 6, className: "contact-details-left" },
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.email, type: "email",
	                                        label: "Email Address", ref: "email",
	                                        update: this.updateField,
	                                        errorValue: this.state.contactValidation.invalidEmail, fieldName: "email",
	                                        isXs: this.props.clientViewPort.isXs }),
	                                    this.getPasswordFields(),
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.firstName, type: "text",
	                                        label: "First Name", ref: "firstName",
	                                        update: this.updateField,
	                                        errorValue: this.state.contactValidation.invalidFirstName,
	                                        fieldName: "firstName",
	                                        isXs: this.props.clientViewPort.isXs,
	                                        style: "name-input" }),
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.lastName, type: "text", label: "Last Name",
	                                        ref: "lastName",
	                                        update: this.updateField,
	                                        errorValue: this.state.contactValidation.invalidLastName,
	                                        fieldName: "lastName",
	                                        isXs: this.props.clientViewPort.isXs,
	                                        style: "name-input" }),
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.primaryPhone, type: "text",
	                                        label: primaryPhoneLabel, ref: "primaryPhone",
	                                        update: this.updateField,
	                                        errorValue: this.state.contactValidation.invalidPrimaryPhone,
	                                        fieldName: "primaryPhone",
	                                        isXs: this.props.clientViewPort.isXs }),
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.secondaryPhone, type: "text",
	                                        label: "Secondary Phone", ref: "secondaryPhone",
	                                        update: this.updateField,
	                                        errorValue: this.state.contactValidation.invalidSecondaryPhone,
	                                        fieldName: "secondaryPhone",
	                                        isXs: this.props.clientViewPort.isXs }),
	                                    this.props.flowType === _constants.URLs.ACCOUNT ? _react2.default.createElement(
	                                        _reactBootstrap.Form,
	                                        { inline: true, className: inputDetailsRowStyle + " contact-cbk" },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Checkbox,
	                                            { className: "input-detail-cbx",
	                                                checked: this.state.memberDetails.recieveEmailsReminders,
	                                                onChange: this.handleReceiveEmailsRemindersChange,
	                                                ref: "receiveEmailsReminders" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "input-detail-cbk-lbl" },
	                                                (0, _translate.translate)("_receiveReminders")
	                                            )
	                                        )
	                                    ) : undefined
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { md: 6, className: "contact-details-right" },
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.addressLine1, type: "text",
	                                        label: "Address Line 1", ref: "addressLine1",
	                                        update: this.updateField,
	                                        errorValue: this.state.contactValidation.invalidAddressLine1,
	                                        disabled: this.props.isHomeDelivery && this.props.flowType === _constants.URLs.ACCOUNT, fieldName: "addressLine1",
	                                        isXs: this.props.clientViewPort.isXs }),
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.addressLine2, type: "text",
	                                        label: "Address Line 2", ref: "addressLine2",
	                                        update: this.updateField, fieldName: "addressLine2",
	                                        disabled: this.props.isHomeDelivery && this.props.flowType === _constants.URLs.ACCOUNT,
	                                        isXs: this.props.clientViewPort.isXs }),
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.city, type: "text", label: "City",
	                                        ref: "city",
	                                        update: this.updateField,
	                                        errorValue: this.state.contactValidation.invalidCity,
	                                        disabled: this.props.isHomeDelivery && this.props.flowType === _constants.URLs.ACCOUNT, fieldName: "city",
	                                        isXs: this.props.clientViewPort.isXs,
	                                        style: "name-input" }),
	                                    this.statesSelection(),
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.zipCode, type: "text",
	                                        label: "Zip/Postal Code", ref: "zipCode",
	                                        update: this.updateField,
	                                        errorValue: this.state.contactValidation.invalidZipCode,
	                                        fieldName: "zipCode",
	                                        disabled: this.props.isHomeDelivery && this.props.flowType === _constants.URLs.ACCOUNT,
	                                        isXs: this.props.clientViewPort.isXs })
	                                )
	                            ),
	                            this.props.showCellPhoneLabels && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: inputDetailsRowStyle + " form-inline" },
	                                "* ",
	                                this.props.showCellPhoneLabels
	                            ),
	                            _react2.default.createElement(_reactBootstrap.Row, { className: separatorLineStyle }),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { md: 6, className: "additional-contact-details-lbl" },
	                                    (0, _translate.translate)("Additional Contact")
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { md: 6, className: "contact-details-left" },
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.partnerFirstName, type: "text",
	                                        label: "First Name", ref: "partnerFirstName",
	                                        update: this.updateField, fieldName: "partnerFirstName",
	                                        errorValue: this.state.contactValidation.invalidPartnerFirstName,
	                                        isXs: this.props.clientViewPort.isXs,
	                                        style: "name-input" }),
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.partnerLastName, type: "text",
	                                        label: "Last Name", ref: "partnerLastName",
	                                        update: this.updateField, fieldName: "partnerLastName",
	                                        errorValue: this.state.contactValidation.invalidPartnerLastName,
	                                        isXs: this.props.clientViewPort.isXs,
	                                        style: "name-input" })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { md: 6, className: "contact-details-right" },
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.partnerEmail, type: "email",
	                                        label: "Email Address", ref: "partnerEmail",
	                                        update: this.updateField,
	                                        errorValue: this.state.contactValidation.invalidPartnerEmail,
	                                        fieldName: "partnerEmail",
	                                        isXs: this.props.clientViewPort.isXs }),
	                                    _react2.default.createElement(InfoDetail, { value: this.state.memberDetails.partnerPhone, type: "text", label: "Phone",
	                                        ref: "partnerPhone",
	                                        update: this.updateField,
	                                        errorValue: this.state.contactValidation.invalidPartnerPhone,
	                                        fieldName: "partnerPhone", isXs: this.props.clientViewPort.isXs
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { md: 8, className: "contact-details-left" },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Form,
	                                        { inline: true, className: inputDetailsRowStyle + " contact-cbk" },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Checkbox,
	                                            { className: "input-detail-cbx",
	                                                checked: this.state.memberDetails.sendPartnerEmails,
	                                                onChange: this.handleSendPartnerEmailsChange,
	                                                ref: "sendPartnerEmails" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "input-detail-cbk-lbl" },
	                                                (0, _translate.translate)("alsoSendComEmail")
	                                            )
	                                        ),
	                                        this.state.contactValidation.invalidSendPartnerEmail ? _react2.default.createElement(
	                                            "div",
	                                            {
	                                                className: "validation-error send-email-error" },
	                                            this.state.contactValidation.invalidSendPartnerEmail
	                                        ) : undefined
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                this.props.showSendCancelSubscriptionRequest && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { md: 8 },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "cancel-request-link", onClick: this.sendCancelSubscriptionRequest },
	                            "Request to Cancel Subscription"
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ContactDetailsForm;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.updateField = function (fieldName, fieldValue) {
	        var memberDetails = _this3.state.memberDetails;
	        memberDetails[fieldName] = fieldValue;
	        _this3.setState({ memberDetails: memberDetails, enableToContinue: true });
	        if (!_this3.props.isDirty) {
	            _this3.props.setDirty(true);
	        }
	    };
	
	    this.handleFieldValidation = function (isValid, errorFieldName, errorMessage, contactValidation) {
	        if (!isValid) {
	            contactValidation[errorFieldName] = errorMessage;
	        } else {
	            contactValidation[errorFieldName] = undefined;
	        }
	    };
	
	    this.validateEmail = function (email) {
	        return (0, _utils.validateEmail)(email);
	    };
	
	    this.validatePassword = function (password) {
	        return password.length > 5;
	    };
	
	    this.validateRetypedPassword = function (retypedPassword) {
	        return retypedPassword === _this3.state.memberDetails.password;
	    };
	
	    this.validateLastName = function (lastName) {
	        return !(0, _utils.isEmptyString)(lastName);
	    };
	
	    this.validateFirstName = function (firstName) {
	        return !(0, _utils.isEmptyString)(firstName);
	    };
	
	    this.handleStateChange = function (value) {
	        var memberDetails = _this3.state.memberDetails;
	        memberDetails['state'] = value;
	        _this3.props.setMemberData(memberDetails);
	    };
	
	    this.validatePrimaryPhone = function (primaryPhone) {
	        return !(0, _utils.isEmptyString)(primaryPhone) && (0, _utils.isValidPhoneNumber)(primaryPhone);
	    };
	
	    this.validateSecondaryPhone = function (secondaryPhone) {
	        if (!(0, _utils.isEmptyString)(secondaryPhone)) {
	            return (0, _utils.isValidPhoneNumber)(secondaryPhone);
	        }
	        return true;
	    };
	
	    this.validateAddressLine1 = function (addressLine1) {
	        return !(0, _utils.isEmptyString)(addressLine1);
	    };
	
	    this.validateCity = function (city) {
	        return !(0, _utils.isEmptyString)(city);
	    };
	
	    this.validateZipCode = function (zipCode) {
	        return (0, _utils.validateZipCode)(zipCode, _this3.props.farmCountry) && !(0, _utils.isEmptyString)(zipCode);
	    };
	
	    this.validatePartnerEmail = function (partnerEmail) {
	        if (!(0, _utils.isEmptyString)(partnerEmail)) {
	            return (0, _utils.validateEmail)(partnerEmail);
	        }
	        return true;
	    };
	
	    this.validatePartnerPhone = function (partnerPhone) {
	        if (!(0, _utils.isEmptyString)(partnerPhone)) {
	            return (0, _utils.isValidPhoneNumber)(partnerPhone);
	        }
	        return true;
	    };
	
	    this.handleSendPartnerEmailsChange = function (event) {
	        _this3.updateField("sendPartnerEmails", event.target.checked);
	    };
	
	    this.handleReceiveEmailsRemindersChange = function (event) {
	        _this3.updateField("recieveEmailsReminders", event.target.checked);
	    };
	
	    this.createStateSelection = function () {
	        var inputDetailStyle = " state-selection" + (_this3.props.clientViewPort.isXs ? " mobile" : "");
	        var states = [];
	        for (var id in _this3.state.states) {
	            if (_this3.state.states.hasOwnProperty(id)) {
	                states.push(_react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { key: id, eventKey: id },
	                    _this3.state.states[id]
	                ));
	            }
	        }
	        return _react2.default.createElement(
	            _reactBootstrap.DropdownButton,
	            { dropup: true, className: "input-detail" + inputDetailStyle, noCaret: true,
	                id: "state-selection", onSelect: _this3.handleStateChange,
	                title: _this3.state.states[_this3.state.memberDetails.state],
	                disabled: _this3.props.isHomeDelivery && _this3.props.flowType === _constants.URLs.ACCOUNT },
	            states
	        );
	    };
	
	    this.statesSelection = function () {
	        var inputDetailsRowStyle = "input-detail-row" + (_this3.props.clientViewPort.isXs ? " input-detail-row-mobile" : "");
	        var contactValidation = "contact-details-validation" + (!_this3.props.clientViewPort.isXs ? "" : " mobile");
	        return _react2.default.createElement(
	            _reactBootstrap.Form,
	            { className: inputDetailsRowStyle, horizontal: true },
	            _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                { controlId: "formHorizontalInputstate", className: "form-group-contact-details" },
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { componentClass: _reactBootstrap.ControlLabel, sm: 4, className: "input-detail-lbl" },
	                    (0, _translate.translate)("State")
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 8, className: "input-details-col" },
	                    _this3.createStateSelection(),
	                    _react2.default.createElement(
	                        "div",
	                        { className: contactValidation },
	                        _react2.default.createElement("div", { className: "no-error-input" })
	                    )
	                )
	            )
	        );
	    };
	
	    this.validateFields = function (memberFields, contactValidation, mandatory) {
	        var isValid = true;
	        for (var memberField in memberFields) {
	            if (memberFields.hasOwnProperty(memberField)) {
	                var invalidField = 'invalid' + memberField;
	                var fieldName = memberField[0].toLowerCase() + memberField.substring(1);
	                var errorMessage = void 0;
	                var value = _this3.state.memberDetails[fieldName];
	                var isValidField = true;
	                if ((0, _utils.isEmptyString)(value) && mandatory) {
	                    isValidField = isValid = false;
	                    errorMessage = memberFields[memberField];
	                } else {
	                    if (_this3.hasOwnProperty("validate" + memberField) && !_this3["validate" + memberField](value)) {
	                        isValidField = isValid = false;
	                        errorMessage = _contactDetailsConstants.MEMBER_ERROR_VALIDATION_MESSAGE[invalidField];
	                    }
	                }
	                _this3.handleFieldValidation(isValidField, invalidField, errorMessage, contactValidation);
	            }
	        }
	        return isValid;
	    };
	
	    this.validateErrors = function () {
	        var contactValidation = {};
	        var isValid = _this3.validateFields(_contactDetailsConstants.MANDATORY_MEMBER_FIELDS, contactValidation, true);
	        if (!_this3.state.memberDetails.isFBLogin && _this3.props.showPassword) {
	            if (_this3.state.invalidPassword || _this3.state.invalidRetypedPassword) {
	                isValid = false;
	            }
	            isValid = _this3.validateFields(_contactDetailsConstants.MEMBER_FIELDS_NO_FB, contactValidation, true) && isValid;
	        }
	        isValid = _this3.validateFields(_contactDetailsConstants.NOT_MANDATORY_MEMBER_FIELDS, contactValidation) && isValid;
	        if (_this3.state.invalidSecondaryPhone || _this3.state.invalidPartnerEmail || _this3.state.invalidEmail || _this3.state.invalidPartnerPhone || _this3.state.invalidZipCode || _this3.state.invalidPrimaryPhone || _this3.state.invalidFirstName || _this3.state.invalidLastName || _this3.state.invalidCity) {
	            isValid = false;
	        }
	        var message = void 0;
	        if (_this3.state.memberDetails.sendPartnerEmails && (!_this3.state.memberDetails.partnerLastName || !_this3.state.memberDetails.partnerFirstName || !_this3.state.memberDetails.partnerEmail)) {
	            isValid = false;
	            message = _constants.INVALID_SEND_EMAIL_PARTNER_MESSAGE;
	            contactValidation.invalidPartnerEmail = " ";
	            contactValidation.invalidPartnerFirstName = " ";
	            contactValidation.invalidPartnerLastName = " ";
	        }
	        contactValidation.invalidSendPartnerEmail = message;
	        _this3.setState({ contactValidation: contactValidation });
	        return isValid;
	    };
	
	    this.invalidAddressHandler = function () {
	        _this3.state.memberDetails.lat = null;
	        _this3.state.memberDetails.lng = null;
	        var contactValidation = _this3.state.contactValidation;
	        if (!_this3.props.isHomeDelivery) {
	            contactValidation.invalidZipCode = (0, _translate.translate)('_AddressError');
	            contactValidation.invalidCity = (0, _translate.translate)('_AddressError');
	            _this3.props.setAddressValidationError(contactValidation.invalidZipCode);
	            //Temp reporting of error
	        } else {
	            contactValidation.invalidAddressLine1 = (0, _translate.translate)('_AddressError');
	            _this3.props.setAddressValidationError(contactValidation.invalidAddressLine1);
	        }
	        _this3.setState({ contactValidation: contactValidation });
	    };
	
	    this.validateAddress = function (delay) {
	        var address = "";
	        if (_this3.props.isHomeDelivery) {
	            address = _this3.state.memberDetails.addressLine1 + " ";
	        }
	        address += _this3.state.memberDetails.city + " " + _this3.state.memberDetails.state + " " + _this3.state.memberDetails.zipCode;
	        return (0, _utils.geocodeAddress)(address, delay).then(function (geoCode) {
	            switch (geoCode.status) {
	                case google.maps.GeocoderStatus.OK:
	                    {
	                        _this3.state.memberDetails.lat = geoCode.lat;
	                        _this3.state.memberDetails.lng = geoCode.lng;
	                        return true;
	                    }
	                case google.maps.GeocoderStatus.ZERO_RESULTS:
	                    {
	                        _this3.invalidAddressHandler();
	                        return false;
	                    }
	                default:
	                    throw geoCode;
	            }
	        }).catch(function (error) {
	            if (_this3.addressErrorCounter < 5) {
	                _this3.addressErrorCounter += 1;
	                _this3.props.setAddressValidationErrorNoAction(error);
	                return _this3.validateAddress(2000);
	            } else {
	                throw Error(_constants.GEOCODE_ERROR);
	            }
	        });
	    };
	
	    this.validateContactDetails = function () {
	        var isValid = _this3.validateErrors();
	        if (isValid) {
	            _this3.validateAddress().then(function (isValid) {
	                if (isValid) {
	                    _this3.props.setMemberData(_this3.state.memberDetails);
	                    if (!(0, _utils.isEmptyObj)(_this3.props.signupData) && _this3.props.signupData.steps) {
	                        var index = _this3.props.signupData.steps.indexOf(_constants.JoinSteps.CONTACT_INFO);
	                        var isWaitListOnly = (_this3.props.signupData.data || {}).isWaitListOnly;
	                        var waitListItems = !isWaitListOnly ? null : (0, _basket.getWaitlistItems)(_this3.props.signupData.sharesData.shares);
	                        var step = _this3.props.signupData.steps[++index];
	                        _this3.props.updateMember(_this3.state.memberDetails, step ? step : _constants.JoinSteps.THANK_YOU, waitListItems);
	                    } else {
	                        _this3.props.setDirty(false);
	                        _this3.props.updateMember(_this3.state.memberDetails, _constants.URLs.ACCOUNT);
	                    }
	                    _this3.props.setShowPassword(false);
	                }
	                if (_this3.props.clientViewPort.isXs) window.scrollTo(0, 0);
	                _this3.props.setMemberAction(_constants.MemberActions.NO_ACTION);
	                _this3.props.setUpdateMemberError(null);
	            }).catch(function (error) {
	                _this3.props.setDirty(false);
	                _this3.props.errorFetching(error);
	            });
	        } else {
	            _this3.props.setMemberAction(_constants.MemberActions.NO_ACTION);
	            _this3.props.setUpdateMemberError(null);
	        }
	    };
	
	    this.getPasswordFields = function () {
	        if (!_this3.state.memberDetails.isFBLogin && !_this3.state.memberDetails.key || _this3.props.showPassword) {
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(InfoDetail, { value: _this3.state.memberDetails.password, type: "password", label: "Choose a Password", ref: "password",
	                    update: _this3.updateField, errorValue: _this3.state.contactValidation.invalidPassword,
	                    fieldName: "password", isXs: _this3.props.clientViewPort.isXs }),
	                _react2.default.createElement(InfoDetail, { value: _this3.state.memberDetails.retypedPassword, type: "password", label: "Retype Password", ref: "retypedPassword",
	                    update: _this3.updateField, errorValue: _this3.state.contactValidation.invalidRetypedPassword,
	                    fieldName: "retypedPassword", isXs: _this3.props.clientViewPort.isXs })
	            );
	        } else if (!_this3.state.memberDetails.isFBLogin) {
	            if (_this3.props.clientViewPort.isXs) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Form,
	                    { className: "input-detail-row input-detail-row-mobile", horizontal: true },
	                    _react2.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { className: "form-group-contact-details change-password", controlId: "formHorizontalChangePasswordMobile" },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 3, className: "input-details-col" },
	                            _react2.default.createElement(
	                                "label",
	                                { className: "input-detail-lbl" },
	                                (0, _translate.translate)("Password")
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 3, className: "input-details-col" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "changePasswordLink", onClick: _this3.onClickChangePassword },
	                                (0, _translate.translate)("Change")
	                            )
	                        )
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    _reactBootstrap.Form,
	                    { className: "input-detail-row", horizontal: true },
	                    _react2.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { className: "form-group-contact-details form-group-change-password", controlId: "formHorizontalChangePassword" },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { componentClass: _reactBootstrap.ControlLabel, sm: 4, className: "input-detail-lbl" },
	                            (0, _translate.translate)("Password")
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 8, className: "input-details-col" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "changePasswordLink" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { onClick: _this3.onClickChangePassword },
	                                    (0, _translate.translate)("Change")
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    };
	
	    this.getTitleHeader = function () {
	        if (_this3.props.clientViewPort.isXs && _this3.props.flowType !== _constants.URLs.ACCOUNT) {
	            return null;
	        } else {
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: "contact-details-header-title account-header-title-container" },
	                _this3.props.clientViewPort.isXs ? _react2.default.createElement(
	                    "div",
	                    { className: "account-header-title" },
	                    (0, _translate.translate)("My Contact Information")
	                ) : _react2.default.createElement(
	                    "div",
	                    { className: "email-img-contact-form-title" },
	                    _react2.default.createElement("span", { className: "email-img" }),
	                    (0, _translate.translate)(!_this3.state.memberDetails.key ? "_enterContactInfo" : "Your contact information")
	                ),
	                _this3.props.flowType === _constants.URLs.ACCOUNT ? _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { disabled: !_this3.state.enableToContinue,
	                        onClick: _this3.accountSaveClicked,
	                        type: "submit",
	                        className: "submit-order button save-contact-btn" + (_this3.props.showLoading ? " loading" : ""),
	                        bsStyle: "primary" },
	                    (0, _translate.translate)("Save")
	                ) : undefined
	            );
	        }
	    };
	
	    this.onClickChangePassword = function () {
	        var memberDetails = _this3.state.memberDetails;
	        memberDetails.password = '';
	        memberDetails.retypedPassword = '';
	        _this3.props.setMemberData(memberDetails);
	        if (!_this3.props.isDirty) {
	            _this3.props.setDirty(true);
	        }
	        _this3.props.setShowPassword(true);
	    };
	
	    this.accountSaveClicked = function () {
	        _this3.validateContactDetails(_this3.state.memberDetails, true);
	        _this3.setState({ enableToContinue: false });
	    };
	
	    this.sendCancelSubscriptionRequest = function () {
	        _this3.props.sendCancelSubscriptionRequest();
	    };
	};
	
	var InfoDetail = function (_React$Component2) {
	    _inherits(InfoDetail, _React$Component2);
	
	    function InfoDetail() {
	        _classCallCheck(this, InfoDetail);
	
	        return _possibleConstructorReturn(this, (InfoDetail.__proto__ || Object.getPrototypeOf(InfoDetail)).apply(this, arguments));
	    }
	
	    _createClass(InfoDetail, [{
	        key: "onChangeField",
	        value: function onChangeField(event) {
	            this.props.update(this.props.fieldName, event.target.value);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var inputDetailsRowStyle = "input-detail-row" + (this.props.isXs ? " input-detail-row-mobile" : "");
	            var styleClass = "input-detail" + (this.props.style ? " " + this.props.style : "") + (!this.props.errorValue ? "" : " error");
	            var contactValidation = "contact-details-validation" + (!this.props.isXs ? "" : " mobile");
	            var errorStyle = "contact-details-validation-error" + (!this.props.isXs ? "" : " mobile");
	            return _react2.default.createElement(
	                _reactBootstrap.Form,
	                { className: inputDetailsRowStyle, horizontal: true, ref: "frm" },
	                _react2.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    { controlId: "formHorizontalInput" + this.props.fieldName, className: "form-group-contact-details" },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { componentClass: _reactBootstrap.ControlLabel, sm: 4, className: "input-detail-lbl", ref: "lbl" },
	                        (0, _translate.translate)(this.props.label)
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8, className: "input-details-col" },
	                        _react2.default.createElement(_reactBootstrap.FormControl, { className: styleClass, type: this.props.type,
	                            value: this.props.value ? this.props.value : '',
	                            disabled: this.props.disabled,
	                            ref: "inp", onChange: this.onChangeField.bind(this) }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: contactValidation },
	                            this.props.errorValue && this.props.errorValue !== " " ? _react2.default.createElement(
	                                "div",
	                                { className: "validation-error " + errorStyle },
	                                this.props.errorValue
	                            ) : _react2.default.createElement("div", { className: "no-error-input" })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InfoDetail;
	}(_react2.default.Component);
	
	InfoDetail.propTypes = {
	    update: _propTypes2.default.func.isRequired,
	    label: _propTypes2.default.string.isRequired,
	    type: _propTypes2.default.oneOf(["text", "email", "password"]),
	    value: _propTypes2.default.string,
	    errorValue: _propTypes2.default.string,
	    fieldName: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var memberDetails = state.memberDetails || {};
	    var summary = state.summary || {};
	    var pickupSiteType = (summary.pickupSite || {}).type;
	    var isHomeDelivery = pickupSiteType === _constants.PickupSiteTypes.HOME || pickupSiteType === _constants.PickupSiteTypes.ZONE;
	    return {
	        clientViewPort: state.clientViewPort || {},
	        memberDetails: memberDetails,
	        showPassword: memberDetails.showPassword,
	        updateMemberError: memberDetails.updateMemberError,
	        farmState: state.staticData.farmState,
	        farmCountry: state.staticData.farmCountry,
	        showLoading: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.VALIDATE_UPDATE_MEMBER),
	        memberAction: memberDetails.memberAction,
	        signupData: state.signupData,
	        isHomeDelivery: isHomeDelivery,
	        isPreview: (state.staticData || {}).isPreview,
	        isDirty: (state.orderStatus || {}).isChanged,
	        showCellPhoneLabels: state.staticData.contactInfoShowCellPhoneLabels,
	        showSendCancelSubscriptionRequest: state.staticData.allowMemberToSendCancelSubscriptionRequest && !(state.signupData && state.signupData.data)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setMemberData: function setMemberData(member) {
	            dispatch((0, _memberDetailsActions.setMemberData)(member));
	        },
	        setDirty: function setDirty(isDirty) {
	            dispatch((0, _commonActions.setDirty)(isDirty));
	        },
	        setUpdateMemberError: function setUpdateMemberError(updateMemberError) {
	            dispatch((0, _memberDetailsActions.setUpdateMemberError)(updateMemberError));
	        },
	        setShowPassword: function setShowPassword(showPassword) {
	            dispatch((0, _memberDetailsActions.setShowPassword)(showPassword));
	        },
	        updateMember: function updateMember(contactDetails, step, waitListItems) {
	            dispatch((0, _memberDetailsActions.updateMember)(contactDetails, step, waitListItems));
	        },
	        setMemberAction: function setMemberAction(memberAction) {
	            dispatch((0, _memberDetailsActions.setMemberAction)(memberAction));
	        },
	        setAddressValidationError: function setAddressValidationError(error) {
	            dispatch((0, _memberDetailsActions.setAddressValidationError)(error));
	        },
	        setAddressValidationErrorNoAction: function setAddressValidationErrorNoAction(error) {
	            dispatch((0, _memberDetailsActions.setAddressValidationErrorNoAction)(error));
	        },
	        errorFetching: function errorFetching(error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        },
	        sendCancelSubscriptionRequest: function sendCancelSubscriptionRequest() {
	            dispatch((0, _accountActions.sendCancelSubscriptionRequest)());
	        }
	    };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContactDetailsForm);

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var StateData = {
	    'US': {
	        AL: 'Alabama',
	        AK: 'Alaska',
	        AZ: 'Arizona',
	        AR: 'Arkansas',
	        CA: 'California',
	        CO: 'Colorado',
	        CT: 'Connecticut',
	        DC: 'District of Columbia',
	        DE: 'Delaware',
	        FL: 'Florida',
	        GA: 'Georgia',
	        HI: 'Hawaii',
	        ID: 'Idaho',
	        IL: 'Illinois',
	        IN: 'Indiana',
	        IA: 'Iowa',
	        KS: 'Kansas',
	        KY: 'Kentucky',
	        LA: 'Louisiana',
	        ME: 'Maine',
	        MD: 'Maryland',
	        MA: 'Massachusetts',
	        MI: 'Michigan',
	        MN: 'Minnesota',
	        MS: 'Mississippi',
	        MO: 'Missouri',
	        MT: 'Montana',
	        NE: 'Nebraska',
	        NV: 'Nevada',
	        NH: 'New Hampshire',
	        NJ: 'New Jersey',
	        NM: 'New Mexico',
	        NY: 'New York',
	        NC: 'North Carolina',
	        ND: 'North Dakota',
	        OH: 'Ohio',
	        OK: 'Oklahoma',
	        OR: 'Oregon',
	        PA: 'Pennsylvania',
	        RI: 'Rhode Island',
	        SC: 'South Carolina',
	        SD: 'South Dakota',
	        TN: 'Tennessee',
	        TX: 'Texas',
	        UT: 'Utah',
	        VT: 'Vermont',
	        VA: 'Virginia',
	        WA: 'Washington',
	        WV: 'West Virginia',
	        WI: 'Wisconsin',
	        WY: 'Wyoming'
	    },
	    'CA': {
	        AB: 'Alberta',
	        BC: 'British Columbia',
	        LB: 'Labrador',
	        MB: 'Manitoba',
	        NB: 'New Brunswick',
	        NF: 'Newfoundland',
	        NS: 'Nova Scotia',
	        NU: 'Nunavut',
	        NW: 'North West Terr.',
	        NT: 'Northwest Territories',
	        ON: 'Ontario',
	        PE: 'Prince Edward Is.',
	        PQ: 'Quebec',
	        SK: 'Saskatchewen',
	        YT: 'Yukon Territories'
	    }
	};
	
	exports.default = StateData;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NOT_MANDATORY_MEMBER_FIELDS = exports.MEMBER_ERROR_VALIDATION_MESSAGE = exports.MEMBER_FIELDS_NO_FB = exports.MANDATORY_MEMBER_FIELDS = undefined;
	
	var _constants = __webpack_require__(463);
	
	var _translate = __webpack_require__(464);
	
	var MANDATORY_MEMBER_FIELDS = exports.MANDATORY_MEMBER_FIELDS = {
	    'Email': (0, _translate.translate)('Please enter email address'),
	    'FirstName': (0, _translate.translate)('Please enter first name'),
	    'LastName': (0, _translate.translate)('Please enter last name'),
	    'PrimaryPhone': (0, _translate.translate)('Please enter primary phone'),
	    'AddressLine1': (0, _translate.translate)('Please enter address line'),
	    'ZipCode': (0, _translate.translate)('Please enter zip/postal code'),
	    'City': (0, _translate.translate)('Please enter city') };
	var MEMBER_FIELDS_NO_FB = exports.MEMBER_FIELDS_NO_FB = {
	    'Password': (0, _translate.translate)('Please enter at least 6 characters'),
	    'RetypedPassword': (0, _translate.translate)('Please retype your password') };
	
	var MEMBER_ERROR_VALIDATION_MESSAGE = exports.MEMBER_ERROR_VALIDATION_MESSAGE = {
	    "invalidEmail": (0, _translate.translate)("Invalid email"),
	    "invalidPassword": (0, _translate.translate)("Please enter at least 6 characters"),
	    "invalidRetypedPassword": (0, _translate.translate)("The password does not match"),
	    "invalidPrimaryPhone": _constants.INVALID_PHONE_NUMBER,
	    "invalidSecondaryPhone": _constants.INVALID_PHONE_NUMBER,
	    "invalidZipCode": (0, _translate.translate)("Invalid zip code"),
	    "invalidPartnerEmail": (0, _translate.translate)('Invalid email'),
	    'invalidPartnerPhone': _constants.INVALID_PHONE_NUMBER
	};
	
	var NOT_MANDATORY_MEMBER_FIELDS = exports.NOT_MANDATORY_MEMBER_FIELDS = {
	    "SecondaryPhone": _constants.INVALID_PHONE_NUMBER,
	    "PartnerPhone": "",
	    "PartnerEmail": ""
	};

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setAccountMode = setAccountMode;
	exports.getAccountData = getAccountData;
	exports.changeSeason = changeSeason;
	exports.openChangePickupSite = openChangePickupSite;
	exports.openChangeSubscription = openChangeSubscription;
	exports.openAddSubscription = openAddSubscription;
	exports.getOrderData = getOrderData;
	exports.updateVacations = updateVacations;
	exports.getPickupSiteAvailableForChange = getPickupSiteAvailableForChange;
	exports.updatePickupSite = updatePickupSite;
	exports.changeSubscription = changeSubscription;
	exports.getSubscriptionSummary = getSubscriptionSummary;
	exports.setShowAddressValidationMessage = setShowAddressValidationMessage;
	exports.deleteOrderAndUpdateVacation = deleteOrderAndUpdateVacation;
	exports.sendCancelSubscriptionRequest = sendCancelSubscriptionRequest;
	exports.setSeasonRolloverOptOut = setSeasonRolloverOptOut;
	exports.unsubscribeFlag = unsubscribeFlag;
	
	var _utils = __webpack_require__(485);
	
	var _actionTypes = __webpack_require__(459);
	
	var _constants = __webpack_require__(463);
	
	var _storeActions = __webpack_require__(766);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _commonActions = __webpack_require__(747);
	
	var _messagePageActions = __webpack_require__(760);
	
	var _memberDetailsActions = __webpack_require__(751);
	
	var _joinActions = __webpack_require__(752);
	
	var _subscription = __webpack_require__(759);
	
	var _fetchingActions = __webpack_require__(748);
	
	function setAccountData(accountData) {
	    return {
	        type: _actionTypes.SET_ACCOUNT_DATA,
	        accountData: accountData
	    };
	}
	
	function setAccountMode(mode, params) {
	    return {
	        type: _actionTypes.SET_ACCOUNT_MODE,
	        mode: mode,
	        params: params
	    };
	}
	
	function getAccountData() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.getAccountData';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            seasonKey: state.staticData.seasonKey,
	            memberKey: state.memberDetails.key
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOAD_ACCOUNT_DATA));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.error) {
	                throw json.error;
	            } else {
	                return parseAccountDataResponse(json, state.staticData);
	            }
	        }).then(function (accountData) {
	            var summary = accountData.data.subscriptionSummary;
	            if (isRedirectToFutureSeason(summary, state.staticData.farmUrl)) {
	                dispatch(changeSeason(summary.seasons[0]));
	            } else {
	                dispatch(setAccountData(accountData.data));
	                dispatch((0, _memberDetailsActions.setMemberData)(accountData.data.member));
	                dispatch((0, _subscriptionSummaryActions.setSummary)(summary));
	                dispatch((0, _messagePageActions.setMessageData)(accountData.messageData));
	                dispatch(setAccountMode(_constants.AccountModes.VIEW));
	                dispatch((0, _fetchingActions.dataFetched)());
	            }
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error, { action: getAccountData }));
	        });
	    };
	}
	
	function parseAccountDataResponse(json, staticData) {
	    var subscriptionSummary = (0, _subscriptionSummaryActions.subscriptionSummaryParser)(json, { staticData: staticData });
	    var messageData = (0, _messagePageActions.messageDataParser)(subscriptionSummary, { staticData: staticData, flowType: _constants.URLs.ACCOUNT });
	    return {
	        data: json,
	        messageData: messageData
	    };
	}
	
	function changeSeason(season) {
	    return function (dispatch, getState) {
	        var url = window.location.origin + "/" + _constants.URLs.ACCOUNT + "/" + getState().staticData.farmUrl + "/" + season.name;
	        window.location.assign(url);
	    };
	}
	
	function openChangePickupSite(onlyOnce) {
	    return function (dispatch) {
	        dispatch(setAccountMode(_constants.AccountModes.CHANGE_PICKUP_SITE, { changePickupSiteOnlyOnce: onlyOnce }));
	    };
	}
	
	function openChangeSubscription() {
	    return function (dispatch) {
	        dispatch(setAccountMode(_constants.AccountModes.CHANGE_SUBSCRIPTION));
	    };
	}
	
	function openAddSubscription() {
	    return function (dispatch, getState) {
	        var subscriptionKey = getState().summary.key;
	        var joinURL = (0, _utils.redirectPage)(_constants.URLs.JOIN, getState().staticData) + "?mode=add&s=" + subscriptionKey;
	        window.location.assign(joinURL);
	    };
	}
	
	function getOrderData(orderKey) {
	    return function (dispatch, getState) {
	        var fetchUrl = '/dispatcher/WebStoreService.getOrderData';
	        var data = {
	            orderKey: orderKey,
	            memberKey: getState().memberDetails.key,
	            includeTitles: true
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOAD_ORDER_DATA));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            return (0, _storeActions.activeOrderParser)(json);
	        }).then(function (webOrder) {
	            dispatch((0, _commonActions.setActiveOrder)(webOrder));
	            if (webOrder.usedFarmigoCredits) {
	                dispatch((0, _storeActions.setStoreCreditsData)({ credits: webOrder.usedFarmigoCredits }));
	            }
	            dispatch((0, _storeActions.setCoupon)((0, _commonActions.parseCouponData)(webOrder.coupon, true)));
	            dispatch((0, _storeActions.calculateOrdersTotals)(webOrder.items));
	        }).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            console.log(error);
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function updateVacations(vacationStart, vacationEnd, makeUpSchedules, makeUpDates) {
	    return function (dispatch, getState) {
	        var fetchUrl = '/dispatcher/WebStoreService.updateVacation';
	        var data = {
	            farmKey: getState().staticData.farmKey,
	            memberKey: getState().memberDetails.key,
	            subscriptionKey: getState().summary.key,
	            vacationStart: JSON.stringify(vacationStart),
	            vacationEnd: JSON.stringify(vacationEnd)
	        };
	        if (makeUpSchedules && makeUpDates) {
	            data.makeUpSchedules = JSON.stringify(makeUpSchedules);
	            data.makeUpDates = JSON.stringify(makeUpDates);
	        }
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.UPDATE_VACATION));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.requiredMakeUpSchedules) {
	                dispatch((0, _subscriptionSummaryActions.setRequiredMakeUpData)(json.requiredMakeUpSchedules, json.requiredMakeUpSchedulesCount, json.requiredMakeUpSchedulesDates));
	                throw { message: 'Your hold dates were not saved yet. To complete the operation please schedule your make up shares dates.' };
	            } else if (!json.isAllowed) {
	                throw { message: json.errorMessage };
	            } else {
	                if (json.reloadRequired) {
	                    dispatch(getAccountData());
	                    dispatch((0, _subscriptionSummaryActions.setNextDeliveryDate)(json.nextDeliveryDate));
	                    dispatch((0, _subscriptionSummaryActions.setVacations)(vacationStart, vacationEnd));
	                    dispatch((0, _subscriptionSummaryActions.setRequiredMakeUpData)());
	                } else {
	                    dispatch((0, _subscriptionSummaryActions.setNextDeliveryDate)(json.nextDeliveryDate));
	                    dispatch((0, _subscriptionSummaryActions.setVacations)(vacationStart, vacationEnd));
	                    dispatch((0, _subscriptionSummaryActions.setRequiredMakeUpData)());
	                }
	            }
	        }).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function getPickupSiteAvailableForChange() {
	    return function (dispatch, getState) {
	        var fetchUrl = '/dispatcher/WebStoreService.getPickupSiteAvailableForChange';
	        var state = getState();
	        var sharesKeys = state.summary.shareItems.map(function (share) {
	            return share.key;
	        });
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            seasonKey: state.staticData.seasonKey,
	            subscriptionKey: state.summary.key,
	            subscriptionShares: JSON.stringify(sharesKeys)
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.LOAD_SIGNUP_DATA));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            return dispatch(setPickupSiteForChange(json));
	        }).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error, { action: getPickupSiteAvailableForChange }));
	        });
	    };
	}
	
	function setPickupSiteForChange(json) {
	    return function (dispatch) {
	        dispatch((0, _joinActions.setSignupData)({ pickupSitesData: json }));
	    };
	}
	
	function updatePickupSite(pickupSite, pickupSiteWaitList) {
	    return function (dispatch, getState) {
	        if (!pickupSite) {
	            return;
	        }
	        var state = getState();
	        if (!isChangePickupSiteAllowed(pickupSite, state)) {
	            dispatch((0, _fetchingActions.errorFetching)({ message: 'Cannot change delivery day. Please contact us in order to make the change.' }));
	            return;
	        }
	
	        var fetchUrl = '/dispatcher/WebStoreService.updatePickupSite';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            subscriptionKey: state.summary.key,
	            pickupSiteKey: pickupSite ? pickupSite.key : state.summary.pickupSite.key,
	            pickupSiteWaitListKey: pickupSiteWaitList ? pickupSiteWaitList.key : null,
	            onlyOnce: state.account.params && state.account.params.changePickupSiteOnlyOnce
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.UPDATE_PICKUP_SITE));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.statusCode === "OK") {
	                dispatch((0, _subscriptionSummaryActions.setNextDeliveryDate)(json.message));
	                dispatch(setAccountMode(_constants.AccountModes.VIEW));
	            } else {
	                dispatch(setShowAddressValidationMessage("Failed to change pickup site."));
	            }
	        }).then(dispatch((0, _commonActions.setDirty)(false))).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function isChangePickupSiteAllowed(pickupSite, state) {
	    if (!pickupSite) {
	        return true;
	    }
	    var isOnce = false;
	    state.summary.shareSchedules.map(function (schedule) {
	        if (state.summary.schedules[schedule].isOnce) {
	            isOnce = true;
	        }
	    });
	    return !(isOnce && pickupSite.deliveryDays !== state.summary.origPickupSite.deliveryDays);
	}
	
	function changeSubscription() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.changeSubscription';
	        var subscription = (0, _subscription.buildSubscriptionFromState)(state);
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            subscriptionKey: state.summary.key,
	            shareItems: JSON.stringify(subscription.shareItems),
	            shareItemQuantities: JSON.stringify(subscription.shareItemQuantities),
	            shareItemSchedules: JSON.stringify(subscription.shareItemSchedules),
	            waitListItems: JSON.stringify(subscription.waitListItems)
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.CHANGE_SUBSCRIPTION));
	        return (0, _utils.ajax)(fetchUrl, data).then(function () {
	            return dispatch(setAccountMode(_constants.AccountModes.CHANGE_SUBSCRIPTION_THANKYOU));
	        }).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            return dispatch((0, _fetchingActions.errorFetching)(error, { action: changeSubscription }));
	        });
	    };
	}
	
	function getSubscriptionSummary(asAdmin, withBalance) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.getSubscriptionSummary';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            seasonKey: state.staticData.seasonKey,
	            memberKey: state.memberDetails.key,
	            asAdmin: asAdmin,
	            withBalance: withBalance
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.GET_STATUS));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (response) {
	            return (0, _subscriptionSummaryActions.subscriptionSummaryParser)({ subscriptionSummary: response }, { staticData: state.staticData });
	        }).then(function (summary) {
	            dispatch((0, _subscriptionSummaryActions.setSummary)(summary));
	        }).then(function () {
	            return dispatch((0, _fetchingActions.dataFetched)());
	        }).catch(function (error) {
	            console.error(error);
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function setShowAddressValidationMessage(showAddressValidationMessage) {
	    return {
	        type: _actionTypes.SET_SHOW_ADDRESS_VALIDATION_MESSAGE,
	        showAddressValidationMessage: showAddressValidationMessage
	    };
	}
	function isRedirectToFutureSeason(summary, farmUrl) {
	    var hasSeasonUrl = window.location.pathname.split(farmUrl).filter(function (param) {
	        return param !== "";
	    }).length > 1;
	    return !hasSeasonUrl && (summary || {}).status === _constants.SubscriptionStatuses.NO_SUBSCRIPTION && (summary.seasons || []).length > 1 && !summary.seasons[0].isActive;
	}
	
	function deleteOrderAndUpdateVacation(vacationStart, vacationEnd) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.deleteOrder';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            orderKey: state.summary.activeWebOrderKey
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.UPDATE_VACATION));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            dispatch((0, _commonActions.setDirty)(false));
	            if (json.statusCode !== "OK") {
	                dispatch((0, _fetchingActions.errorFetching)(json.message));
	            } else {
	                dispatch((0, _subscriptionSummaryActions.setWebOrder)(undefined));
	                if (!state.summary.isSetOnPermanentHold) {
	                    dispatch(updateVacations(vacationStart, vacationEnd));
	                } else {
	                    dispatch((0, _subscriptionSummaryActions.setSubscriptionOnPermanentHold)());
	                }
	                dispatch((0, _subscriptionSummaryActions.setCanSaveDeliveryHold)(false));
	                dispatch((0, _fetchingActions.dataFetched)());
	            }
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function sendCancelSubscriptionRequest() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.sendCancelSubscriptionRequest';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            seasonKey: state.staticData.seasonKey
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.statusCode !== "OK") {
	                dispatch((0, _fetchingActions.errorFetching)(json.message));
	            } else {
	                dispatch((0, _fetchingActions.dataFetched)());
	                alert("Your request was sent");
	            }
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function setSeasonRolloverOptOut(isOptOut) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var fetchUrl = '/dispatcher/WebStoreService.setSeasonRolloverOptOut';
	        var data = {
	            farmKey: state.staticData.farmKey,
	            memberKey: state.memberDetails.key,
	            seasonKey: state.staticData.seasonKey,
	            isOptOut: isOptOut
	        };
	        dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	        return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	            if (json.statusCode !== "OK") {
	                dispatch((0, _fetchingActions.errorFetching)(json.message));
	            } else {
	                dispatch((0, _fetchingActions.dataFetched)());
	                alert("Your selection was saved");
	                window.location.reload(true);
	            }
	        }).catch(function (error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        });
	    };
	}
	
	function unsubscribeFlag(flag) {
	    {
	        return function (dispatch, getState) {
	            var state = getState();
	            var fetchUrl = '/dispatcher/WebStoreService.setFlag';
	            var data = {
	                farmKey: state.staticData.farmKey,
	                memberKey: state.memberDetails.key,
	                flag: flag
	            };
	            dispatch((0, _fetchingActions.fetchingData)(_constants.FetchingTypes.SUBMIT));
	            return (0, _utils.ajax)(fetchUrl, data).then(function (json) {
	                if (json.statusCode !== "OK") {
	                    dispatch((0, _fetchingActions.errorFetching)(json.message));
	                } else {
	                    dispatch((0, _fetchingActions.dataFetched)());
	                    alert("Unsubscribed Successfully");
	                    window.location.replace(window.location.origin + window.location.pathname);
	                }
	            }).catch(function (error) {
	                dispatch((0, _fetchingActions.errorFetching)(error));
	            });
	        };
	    }
	}

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _PaymentMethods = __webpack_require__(820);
	
	var _PaymentMethods2 = _interopRequireDefault(_PaymentMethods);
	
	var _joinActions = __webpack_require__(752);
	
	var _constants = __webpack_require__(463);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _joinPayStep = __webpack_require__(1092);
	
	var _joinPayStep2 = _interopRequireDefault(_joinPayStep);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinPayStep = function (_React$Component) {
	    _inherits(JoinPayStep, _React$Component);
	
	    function JoinPayStep() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, JoinPayStep);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinPayStep.__proto__ || Object.getPrototypeOf(JoinPayStep)).call.apply(_ref, [this].concat(args))), _this), _this.state = { comments: _this.props.signupComments, homeDeliveryInstructions: _this.props.homeDeliveryInstructions }, _this.setSelectedMethod = function (key) {
	            _this.props.setSelectedMethod(key);
	        }, _this.setCommentsToState = function (event) {
	            _this.setState({ comments: event.target.value });
	            if (_this.props.staticData.mandatorySignupComments) {
	                _this.props.setComments(event.target.value);
	            }
	        }, _this.setCommentsToStore = function () {
	            _this.props.setComments(_this.state.comments);
	        }, _this.setHomeDeliveryInstructionsToState = function (event) {
	            _this.setState({ homeDeliveryInstructions: event.target.value });
	        }, _this.setHomeDeliveryInstructionsToStore = function () {
	            _this.props.setHomeDeliveryInstructions(_this.state.homeDeliveryInstructions);
	        }, _this.isTrialSignup = function (plan) {
	            return (plan.type === _constants.PaymentPlans.P || plan.type === _constants.PaymentPlans.DynamicPrePayment || plan.type == _constants.PaymentPlans.DistributionDynamicPrePayment) && !plan.isSupportAutomatic;
	        }, _this.filterPaymentMethodsByPaymentPlan = function () {
	            var isTrialSignup = _this.isTrialSignup(_this.props.selectedPaymentPlan);
	            var paymentPlanType = _this.props.selectedPaymentPlan.type;
	            var allowedPaymentMethods = _constants.PaymentPlanRestrictions[paymentPlanType];
	            if (allowedPaymentMethods) {
	                return _this.props.staticData.signupPaymentMethods.filter(function (paymentMethod) {
	                    //first check if the plan supports preapproval
	                    if (isTrialSignup && [_constants.PaymentMethod.PAYPAL_PREAPPROVE.key, _constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key, _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key].includes(paymentMethod)) return false;
	                    return allowedPaymentMethods.includes(paymentMethod);
	                });
	            }
	        }, _this.handleTermsChange = function (event) {
	            _this.props.setTermsSelected(event.target.checked);
	        }, _this.renderTerms = function () {
	            if (_this.props.staticData.joinTermsAgreement) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'join-pay-terms-agreement' },
	                    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: _this.props.staticData.joinTermsAgreement } })
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'join-pay-terms-agreement' },
	                _react2.default.createElement(
	                    _reactBootstrap.Checkbox,
	                    { inline: true,
	                        checked: _this.props.termsChecked,
	                        onChange: _this.handleTermsChange },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'I have read and agree to the ',
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'join-pay-terms-agreement-link', href: _this.props.staticData.termsUrl,
	                                target: '_blank' },
	                            'terms & conditions'
	                        ),
	                        ' of ',
	                        _this.props.staticData.farmName
	                    )
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(JoinPayStep, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.paymentMethod) {
	                this.setSelectedMethod(this.props.paymentMethod);
	            }
	        }
	
	        //Checks if payment plan properties look like it's a trial sign up and therefore member couldn't use automatic payment service
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var commentsLabel = this.props.staticData.signupCommentsLabel;
	            var paymentMethods = this.props.hasPreappvoal ? [this.props.preapprovalMethod] : this.filterPaymentMethodsByPaymentPlan();
	            return _react2.default.createElement(
	                'fieldset',
	                { disabled: this.props.showLoading, className: 'checkout-content join-pay-container' },
	                _react2.default.createElement(_PaymentMethods2.default, { paymentMethods: paymentMethods,
	                    setSelectedMethod: this.setSelectedMethod,
	                    hasPreapproval: this.props.hasPreappvoal,
	                    pageContext: _constants.URLs.JOIN,
	                    isAddSubscription: this.props.isAddSubscription,
	                    selectedMethod: this.props.selectedMethod }),
	                this.props.isHomeDelivery && !this.props.isAddSubscription && _react2.default.createElement(
	                    'div',
	                    { className: 'text-area' },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        'Special Home Delivery Instructions (If required include: gate code, where to leave your order, etc.)'
	                    ),
	                    _react2.default.createElement('textarea', { className: 'input-text', type: 'text', rows: '3', value: this.state.homeDeliveryInstructions,
	                        onChange: this.setHomeDeliveryInstructionsToState,
	                        onBlur: this.setHomeDeliveryInstructionsToStore })
	                ),
	                commentsLabel && commentsLabel !== 'null' && !this.props.isAddSubscription ? _react2.default.createElement(
	                    'div',
	                    { className: 'text-area' },
	                    _react2.default.createElement('h5', { dangerouslySetInnerHTML: { __html: commentsLabel } }),
	                    _react2.default.createElement('textarea', { className: 'input-text', type: 'text', rows: '3', value: this.state.comments,
	                        onChange: this.setCommentsToState, onBlur: this.setCommentsToStore })
	                ) : undefined,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'join-pay-terms-bottom' },
	                    this.renderTerms()
	                )
	            );
	        }
	    }]);
	
	    return JoinPayStep;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var signupData = state.signupData || {};
	    var selectedData = (signupData || {}).selectedData;
	    var summary = state.summary || {};
	    return {
	        staticData: state.staticData || {},
	        selectedMethod: selectedData.selectedMethod,
	        signupComments: selectedData.signupComments,
	        homeDeliveryInstructions: selectedData.homeDeliveryInstructions,
	        isHomeDelivery: summary.pickupSite && 'Zone' === summary.pickupSite.type,
	        selectedPaymentPlan: selectedData.selectedPaymentPlan,
	        isAddSubscription: signupData.isAddSubscription,
	        paymentMethod: summary.paymentMethod,
	        hasPreappvoal: summary.hasPreapproval,
	        preapprovalMethod: summary.paymentMethod,
	        showLoading: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT),
	        termsChecked: selectedData.termsChecked
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setSelectedMethod: function setSelectedMethod(key) {
	            dispatch((0, _joinActions.setSelectedMethod)(key));
	        },
	        setComments: function setComments(comments) {
	            dispatch((0, _joinActions.setComments)(comments));
	        },
	        setTermsSelected: function setTermsSelected(isSelected) {
	            dispatch((0, _joinActions.setTermsSelected)(isSelected));
	        },
	        setHomeDeliveryInstructions: function setHomeDeliveryInstructions(instructions) {
	            dispatch((0, _joinActions.setHomeDeliveryInstructions)(instructions));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JoinPayStep);

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _SummaryPickupSite = __webpack_require__(1094);
	
	var _SummaryPickupSite2 = _interopRequireDefault(_SummaryPickupSite);
	
	var _SummaryItems = __webpack_require__(1096);
	
	var _SummaryItems2 = _interopRequireDefault(_SummaryItems);
	
	var _SummaryPaymentPlan = __webpack_require__(1099);
	
	var _SummaryPaymentPlan2 = _interopRequireDefault(_SummaryPaymentPlan);
	
	var _SummaryTotals = __webpack_require__(1100);
	
	var _SummaryTotals2 = _interopRequireDefault(_SummaryTotals);
	
	var _SummaryDistributionDate = __webpack_require__(1101);
	
	var _SummaryDistributionDate2 = _interopRequireDefault(_SummaryDistributionDate);
	
	var _constants = __webpack_require__(463);
	
	var _joinActions = __webpack_require__(752);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _basket = __webpack_require__(757);
	
	var _gaActions = __webpack_require__(474);
	
	var GA = _interopRequireWildcard(_gaActions);
	
	var _summary = __webpack_require__(1098);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinSummary = function (_React$Component) {
	    _inherits(JoinSummary, _React$Component);
	
	    function JoinSummary() {
	        _classCallCheck(this, JoinSummary);
	
	        return _possibleConstructorReturn(this, (JoinSummary.__proto__ || Object.getPrototypeOf(JoinSummary)).apply(this, arguments));
	    }
	
	    _createClass(JoinSummary, [{
	        key: "render",
	        value: function render() {
	            var selectedItems = this.props.selectedItems.items.concat(this.props.selectedItems.waitlistItems);
	            return _react2.default.createElement(
	                "div",
	                { className: "summary-container" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "secured-and-summary-wrapper" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "secured-wrapper" },
	                        (0, _translate.translate)("Secured Payment & Privacy Protection")
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "summary-title" },
	                        (0, _translate.translate)("Summary")
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "summary-row", id: "joinSummaryContainer" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "scroll" },
	                        this.props.pickupSite ? _react2.default.createElement(_SummaryDistributionDate2.default, { nextDeliveryDate: this.props.nextDeliveryDate,
	                            deliveryDateLabel: (0, _translate.translate)("First Distribution") }) : undefined,
	                        !this.props.isWaitListOnly ? _react2.default.createElement(_SummaryPickupSite2.default, { isFirstDistribution: true,
	                            schedules: this.props.schedules,
	                            allowRemove: this.props.step === _constants.JoinSteps.PICKUP_SITES,
	                            nextDeliveryDates: this.props.nextDeliveryDates,
	                            pickupSiteLabel: this.props.pickupSiteLabel,
	                            pickupSite: this.props.pickupSite,
	                            waitListSite: this.props.waitListSite,
	                            onRemovePickupSite: this.props.removePickupSite }) : undefined,
	                        this.props.isAddSubscription && this.props.summaryItems && this.props.summaryItems.length > 0 && this.props.pickupSite ? _react2.default.createElement(_SummaryItems2.default, { staticData: this.props.staticData,
	                            readOnly: true,
	                            items: this.props.summaryItems,
	                            title: (0, _translate.translate)("Existing"),
	                            includeTax: true,
	                            isFarmSeasonal: this.props.isFarmSeasonal,
	                            schedules: this.props.schedules,
	                            pickupSite: this.props.pickupSite }) : undefined,
	                        selectedItems && selectedItems.length > 0 ? _react2.default.createElement(_SummaryItems2.default, { staticData: this.props.staticData,
	                            readOnly: this.props.step !== _constants.JoinSteps.SHARES && this.props.step !== _constants.JoinSteps.OPTIONS,
	                            allowChangeShares: this.props.step === _constants.JoinSteps.SHARES,
	                            allowChangeOptions: this.props.step === _constants.JoinSteps.SHARES || this.props.step === _constants.JoinSteps.OPTIONS,
	                            items: selectedItems,
	                            title: (0, _translate.translate)(this.props.isAddSubscription ? "Additional" : "Items"),
	                            isFarmSeasonal: this.props.isFarmSeasonal,
	                            schedules: this.props.schedules,
	                            pickupSite: this.props.pickupSite,
	                            onRemoveItem: this.props.removeItem }) : undefined,
	                        this.props.paymentPlan ? _react2.default.createElement(_SummaryPaymentPlan2.default, { paymentPlan: this.props.paymentPlan }) : undefined,
	                        this.props.totals ? _react2.default.createElement(_SummaryTotals2.default, { totals: this.props.totals }) : undefined
	                    )
	                )
	            );
	        }
	    }]);
	
	    return JoinSummary;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var signupData = state.signupData || {};
	    var summary = state.summary || {};
	    var sharesData = signupData.sharesData || {};
	    var selectedItems = (0, _basket.getJoinSelectedItems)(sharesData.shares, sharesData.options);
	    var selectedData = signupData.selectedData || {};
	    var schedules = signupData.schedules || {};
	    var nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
	    var exceptionalPickupSites = (signupData.pickupSitesData || {}).exceptionalPickupSites;
	    var isWaitListOnly = (signupData.data || {}).isWaitListOnly;
	    var summaryItems = summary.shareItems ? summary.shareItems.concat(summary.waitListItems) : [];
	
	    var nextDeliveryDate = void 0;
	    var pickupSite = summary.pickupSite;
	    var totals = void 0;
	    if (pickupSite && nextDeliveryDates) {
	
	        nextDeliveryDate = (0, _basket.getNextDeliveryDate)(summary.pickupSite, selectedItems.items.concat(summaryItems), schedules, nextDeliveryDates);
	        if (exceptionalPickupSites && exceptionalPickupSites.hasOwnProperty(summary.pickupSite.key)) {
	            nextDeliveryDate = exceptionalPickupSites[summary.pickupSite.key];
	        }
	        //Run this calc only if a payment plan is selected
	        if (selectedData.selectedPaymentPlan) {
	            var itemsRemainingDates = (0, _basket.getAllItemsRemainingDeliveryDates)(selectedItems.items, signupData.sharesData.remainingScheduleDates);
	
	            totals = (0, _basket.calcTotals)(state.signupData.data.isFarmSeasonal, summary.pickupSite, selectedItems.items, selectedData.selectedPaymentPlan, selectedData.coupon, itemsRemainingDates, signupData.sharesData.remainingScheduleDates, nextDeliveryDate, signupData.isAddSubscription, summary.discount, state.staticData, selectedData.selectedMethod).totals;
	        }
	    }
	
	    return {
	        signupData: signupData,
	        staticData: state.staticData || {},
	        pickupSiteLabel: state.staticData.pickupSiteLabel,
	        nextDeliveryDates: nextDeliveryDates,
	        selectedItems: selectedItems,
	        summaryItems: summaryItems,
	        schedules: schedules,
	        isWaitListOnly: isWaitListOnly,
	        waitListSite: summary.waitListSite,
	        step: signupData.step,
	        isFarmSeasonal: state.staticData.isFarmSeasonal,
	        nextDeliveryDate: nextDeliveryDate,
	        pickupSite: summary.pickupSite,
	        paymentPlan: selectedData.selectedPaymentPlan,
	        totals: totals
	    };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        removePickupSite: function removePickupSite(isWaitList) {
	            if (!isWaitList) {
	                dispatch((0, _subscriptionSummaryActions.setPickupSite)(null));
	            } else {
	                dispatch((0, _subscriptionSummaryActions.setWaitListPickupSite)(null));
	            }
	        },
	        removeItem: function removeItem(key, newQuantity) {
	            dispatch((0, _joinActions.joinChangeItemQuantity)(key, newQuantity));
	            // dispatch(GA.trackGAEvent(GA.GA_CATEGORIES.JOIN, GA.GA_ACTIONS.ITEM_REMOVED, GA.GA_LABELS.CART));
	        }
	    };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JoinSummary);

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(485);
	
	var _constants = __webpack_require__(463);
	
	var _translate = __webpack_require__(464);
	
	var _summaryPickupSite = __webpack_require__(1095);
	
	var _summaryPickupSite2 = _interopRequireDefault(_summaryPickupSite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SummaryPickupSite = function (_React$Component) {
	    _inherits(SummaryPickupSite, _React$Component);
	
	    function SummaryPickupSite() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SummaryPickupSite);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SummaryPickupSite.__proto__ || Object.getPrototypeOf(SummaryPickupSite)).call.apply(_ref, [this].concat(args))), _this), _this.onRemoveButtonClick = function () {
	            _this.props.onRemovePickupSite(false);
	        }, _this.onRemoveWaitListButtonClick = function () {
	            _this.props.onRemovePickupSite(true);
	        }, _this.onChangePickupSiteClick = function () {
	            if (_this.props.isChangeAllowed()) {
	                _this.props.onChangePickupSiteClick();
	            }
	        }, _this.onChangePickupSiteClickOnce = function () {
	            if (_this.props.isChangeAllowed()) {
	                _this.props.onChangePickupSiteClick(true);
	            }
	        }, _this.getEmptySummary = function () {
	            var pickupSiteLabel = (0, _utils.isEmptyString)(_this.props.pickupSiteLabel) || _this.props.pickupSiteLabel === 'null' ? (0, _translate.translate)("Pick-Up Site") : _this.props.pickupSiteLabel;
	            return _react2.default.createElement(
	                "div",
	                { className: "summary-pickupSite-no-selection" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "summary-section-title" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "summary-title-label pickup-site" },
	                        pickupSiteLabel
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "summary-content" },
	                    (0, _translate.translate)("selectPickupSiteSummary").replace("{0}", pickupSiteLabel)
	                ),
	                _this.getWaitListSite()
	            );
	        }, _this.renderDistributionDate = function (pickupSite) {
	            if (pickupSite.deliveryHours && pickupSite.deliveryHours.length > 0) {
	                return (0, _translate.translate)(pickupSite.deliveryDays) + ', ' + pickupSite.deliveryHours;
	            }
	            return (0, _translate.translate)(pickupSite.deliveryDays);
	        }, _this.getSelectedPickupSite = function () {
	            var pickupSiteLabel = (0, _utils.isEmptyString)(_this.props.pickupSiteLabel) || _this.props.pickupSiteLabel === 'null' ? (0, _translate.translate)("Pick-Up Site") : _this.props.pickupSiteLabel;
	            var distributionDate = _this.renderDistributionDate(_this.props.pickupSite);
	            var canChange = _this.props.allowChangePickupSite || _this.props.allowChangePickupSiteOneDelivery;
	            var canOnlyChangePermanent = _this.props.allowChangePickupSite && !_this.props.allowChangePickupSiteOneDelivery;
	            return _react2.default.createElement(
	                "div",
	                { className: "summary-selection" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "summary-section-title" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "summary-title-label pickup-site" },
	                        pickupSiteLabel + (canChange && !canOnlyChangePermanent ? ' | ' + (0, _translate.translate)('Change') : '')
	                    ),
	                    canOnlyChangePermanent ? _react2.default.createElement(
	                        "button",
	                        { id: "btnChangeLocation", type: "button", className: "button btn btn-primary summary-change-button", onClick: _this.onChangePickupSiteClick },
	                        (0, _translate.translate)("Change")
	                    ) : undefined,
	                    _this.props.allowChangePickupSite && !canOnlyChangePermanent ? _react2.default.createElement(
	                        "button",
	                        { id: "btnChangeLocation", type: "button", className: "button btn btn-primary summary-change-button", onClick: _this.onChangePickupSiteClick },
	                        (0, _translate.translate)("Permanent")
	                    ) : undefined,
	                    _this.props.allowChangePickupSiteOneDelivery ? _react2.default.createElement(
	                        "button",
	                        { id: "btnChangeLocation", type: "button", className: "button btn btn-primary summary-change-button", onClick: _this.onChangePickupSiteClickOnce },
	                        (0, _translate.translate)("Next Delivery")
	                    ) : undefined
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "summary-selected-pick-up-site-container" },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "label",
	                            { className: "summary-selected-pick-up-site-title" },
	                            _this.props.pickupSite.title
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "summary-selected-pick-up-site-day-hour" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "summary-selected-pick-up-site-day" },
	                                distributionDate
	                            )
	                        )
	                    ),
	                    !_this.props.readOnly && _this.props.flowType !== _constants.URLs.ACCOUNT ? _react2.default.createElement(
	                        "div",
	                        { className: "pick-up-site-close-wrapper" },
	                        _react2.default.createElement("button", { className: "close-button order-summary-item-remove", onClick: _this.onRemoveButtonClick, disabled: !_this.props.allowRemove })
	                    ) : undefined
	                ),
	                _this.getWaitListSite()
	            );
	        }, _this.getWaitListSite = function () {
	            if (!(0, _utils.isEmptyObj)(_this.props.waitListSite)) {
	                var waitListDistributionDate = (0, _translate.translate)(_this.props.waitListSite.deliveryDays) + ', ' + _this.props.waitListSite.deliveryHours;
	                return _react2.default.createElement(
	                    "div",
	                    { className: "summary-selected-pick-up-site-container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "summary-waitlist-site" },
	                        _react2.default.createElement(
	                            "label",
	                            { className: "summary-selected-pick-up-site-title" },
	                            _this.props.waitListSite.title
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "summary-selected-pick-up-site-day-hour" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "summary-selected-pick-up-site-day" },
	                                waitListDistributionDate
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "summary-waitlist-label-wrapper" },
	                        _react2.default.createElement(
	                            "label",
	                            { className: "summary-waitlist-label" },
	                            (0, _translate.translate)("Waitlist")
	                        )
	                    ),
	                    !_this.props.readOnly ? _react2.default.createElement(
	                        "div",
	                        { className: "pick-up-site-close-wrapper" },
	                        _react2.default.createElement("button", { className: "close-button order-summary-item-remove", onClick: _this.onRemoveWaitListButtonClick, disabled: !_this.props.allowRemove })
	                    ) : undefined
	                );
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SummaryPickupSite, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                null,
	                this.props.pickupSite ? this.getSelectedPickupSite() : this.getEmptySummary()
	            );
	        }
	    }]);
	
	    return SummaryPickupSite;
	}(_react2.default.Component);
	
	exports.default = SummaryPickupSite;

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SummaryItem = __webpack_require__(1097);
	
	var _SummaryItem2 = _interopRequireDefault(_SummaryItem);
	
	var _translate = __webpack_require__(464);
	
	var _constants = __webpack_require__(463);
	
	var _summary = __webpack_require__(1098);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SummaryItems = function (_React$Component) {
	    _inherits(SummaryItems, _React$Component);
	
	    function SummaryItems() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SummaryItems);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SummaryItems.__proto__ || Object.getPrototypeOf(SummaryItems)).call.apply(_ref, [this].concat(args))), _this), _this.onClickCallback = function () {
	            if (_this.props.isChangeAllowed()) {
	                _this.props.isFarmSeasonal ? _this.props.onAddSubscriptionClick() : _this.props.onChangeSubscriptionClick();
	            }
	        }, _this.onChangeFreeItemsClick = function () {
	            if (_this.props.isChangeAllowed()) {
	                _this.props.onChangeSubscriptionClick();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SummaryItems, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'join-summary-items-wrapper', name: 'joinSummaryItems' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'summary-section-title' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'summary-title-label items-label' },
	                        (0, _translate.translate)(this.props.title)
	                    ),
	                    this.props.isAllowModifySubscription ? _react2.default.createElement(
	                        'button',
	                        { id: 'btnAddChangeSubscription', type: 'button', className: 'button btn btn-primary summary-change-button',
	                            onClick: this.onClickCallback },
	                        (0, _translate.translate)(this.props.isFarmSeasonal ? "Add" : "Change")
	                    ) : undefined,
	                    this.props.isAllowModifySubscription && this.props.staticData.allowChangeFreeOptions ? _react2.default.createElement(
	                        'button',
	                        { id: 'btnChangeFreeOptions', type: 'button', className: 'button btn btn-primary summary-change-button',
	                            onClick: this.onChangeFreeItemsClick },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'hidden-xs' },
	                            (0, _translate.translate)("Select ")
	                        ),
	                        (0, _translate.translate)("Free")
	                    ) : undefined,
	                    (this.props.flowType !== _constants.URLs.ACCOUNT || !this.props.staticData.hideDeliveryPrice) && _react2.default.createElement(
	                        'div',
	                        { className: 'summary-title-label total-label' },
	                        (0, _translate.translate)("Total")
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'summary-title-label qty-label' },
	                        (0, _translate.translate)("Qty"),
	                        '.'
	                    )
	                ),
	                this.props.items.map(function (item, index) {
	                    var allowChange = !item.isAdditional && _this2.props.allowChangeShares || item.isAdditional && _this2.props.allowChangeOptions;
	                    return _react2.default.createElement(_SummaryItem2.default, { key: index, item: item,
	                        readOnly: _this2.props.readOnly || !allowChange,
	                        staticData: _this2.props.staticData,
	                        isFarmSeasonal: _this2.props.isFarmSeasonal,
	                        schedules: _this2.props.schedules,
	                        pickupSite: _this2.props.pickupSite,
	                        showItemDetailsLink: _this2.props.showItemDetailsLink,
	                        includeTax: _this2.props.includeTax,
	                        onRemoveItem: _this2.props.onRemoveItem,
	                        flowType: _this2.props.flowType
	                    });
	                })
	            );
	        }
	    }]);
	
	    return SummaryItems;
	}(_react2.default.Component);
	
	exports.default = SummaryItems;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemDetails = __webpack_require__(781);
	
	var _ItemDetails2 = _interopRequireDefault(_ItemDetails);
	
	var _QuantityUpdater = __webpack_require__(783);
	
	var _QuantityUpdater2 = _interopRequireDefault(_QuantityUpdater);
	
	var _basket = __webpack_require__(757);
	
	var _translate = __webpack_require__(464);
	
	var _constants = __webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SummaryItem = function (_React$Component) {
	    _inherits(SummaryItem, _React$Component);
	
	    function SummaryItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SummaryItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SummaryItem.__proto__ || Object.getPrototypeOf(SummaryItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showDetails: false
	        }, _this.getPrice = function (item) {
	            var itemPrice = (0, _basket.getItemPrice)(item, _this.props.staticData, (_this.props.pickupSite || {}).key);
	            //In Account and add-subscription need to show the price after tax
	            var calcPrice = _this.props.includeTax ? itemPrice.fullPrice : itemPrice.priceBeforeTax;
	            if (_this.props.isFarmSeasonal && _this.props.staticData.hideDeliveryPrice) {
	                var distributionsNumber = (0, _basket.getDistributionsNumber)(item, item.selectedSchedule);
	                calcPrice = item.selectedSchedule || item.schedules.length === 1 ? calcPrice * (distributionsNumber ? distributionsNumber : 1) : undefined;
	            }
	            return calcPrice;
	        }, _this.onRemoveButtonClick = function () {
	            _this.props.onRemoveItem(_this.props.item.key, _this.props.item.minQuantity || 0);
	        }, _this.setItemPriceView = function (item, distributionsNumber) {
	            var totalPrice = item.isCredit ? item.quantity * item.price : (0, _basket.formatMoney)(item.quantity * _this.getPrice(item) * distributionsNumber);
	            var noPrice = totalPrice === '$0.00';
	            var element = void 0;
	            if (item.waitList) {
	                element = _react2.default.createElement(
	                    "span",
	                    { className: "waitlist" },
	                    (0, _translate.translate)("Waitlist")
	                );
	            } else if (noPrice) {
	                element = _react2.default.createElement("span", { className: "no-price" });
	            } else {
	                element = _react2.default.createElement(
	                    "span",
	                    { className: "order-summary-item-total", name: "orderSummaryItemTotal" },
	                    totalPrice
	                );
	            }
	            if (_this.props.flowType !== _constants.URLs.ACCOUNT || !_this.props.staticData.hideDeliveryPrice) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "join-summary-item-total" + (noPrice ? " no-price" : "") },
	                    element
	                );
	            }
	        }, _this.closeDetails = function () {
	            _this.setState({ showDetails: false });
	        }, _this.getItemDetails = function () {
	            if (_this.state.showDetails) {
	                return _react2.default.createElement(_ItemDetails2.default, { item: _this.props.item,
	                    staticData: _this.props.staticData,
	                    clientViewPort: _this.props.clientViewPort,
	                    shouldShowQuantityUpdater: false,
	                    closeDetails: _this.closeDetails });
	            } else {
	                return '';
	            }
	        }, _this.openDetails = function () {
	            if (_this.props.showItemDetailsLink) _this.setState({ showDetails: true });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SummaryItem, [{
	        key: "render",
	        value: function render() {
	            var item = this.props.item || {};
	            var scheduleIndex = item.selectedSchedule ? item.schedules.indexOf(item.selectedSchedule) : 0;
	            var distributionsNumber = item.weeksLeft ? item.weeksLeft[scheduleIndex] : undefined;
	            var creditItemLabel = this.props.staticData.creditItemLabel;
	            var formattedPrice = (0, _basket.formatMoney)(this.getPrice(item));
	            var noPrice = formattedPrice === '$0.00';
	            var selectedSchedule = item.selectedSchedule ? this.props.schedules[item.selectedSchedule] || {} : {};
	            return _react2.default.createElement(
	                "div",
	                { className: "order-summary-item-wrapper" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "order-summary-item" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "title" + (this.props.showItemDetailsLink ? " details-link" : ""), onClick: this.openDetails, name: "orderSummaryItemName" },
	                        item.title
	                    ),
	                    noPrice ? undefined : _react2.default.createElement(
	                        "div",
	                        { className: "price", name: "orderSummaryItemPrice" },
	                        _react2.default.createElement(
	                            "b",
	                            null,
	                            formattedPrice
	                        ),
	                        "  /  ",
	                        item.unitQuantity === 1 ? '' : item.unitQuantity,
	                        " ",
	                        item.unit ? item.unit.replace("credits", creditItemLabel) : item.unit
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "text-left" },
	                        (item.schedules.length > 1 || selectedSchedule.isOnce) && item.selectedSchedule ? (this.props.schedules[item.selectedSchedule] || {}).title : ''
	                    ),
	                    distributionsNumber ? _react2.default.createElement(
	                        "div",
	                        { className: "text-left" },
	                        this.props.isFarmSeasonal && distributionsNumber && distributionsNumber > 1 ? distributionsNumber + " " + (0, _translate.translate)('Distributions') : ''
	                    ) : undefined
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "order-summary-item-qty" + (noPrice ? " no-price" : "") },
	                    this.props.readOnly ? _react2.default.createElement(
	                        "div",
	                        { className: "quantity read-only" },
	                        item.quantity
	                    ) : _react2.default.createElement(_QuantityUpdater2.default, { item: item, isOrderSummary: true, isJoinFlow: true, allowChange: true, staticData: this.props.staticData })
	                ),
	                this.setItemPriceView(item, distributionsNumber && this.props.isFarmSeasonal && !this.props.staticData.hideDeliveryPrice ? distributionsNumber : 1),
	                this.props.readOnly ? undefined : _react2.default.createElement("button", { className: "close-button order-summary-item-remove", name: "btnOrderSummaryItemRemove", onClick: this.onRemoveButtonClick }),
	                this.getItemDetails()
	            );
	        }
	    }]);
	
	    return SummaryItem;
	}(_react2.default.Component);
	
	exports.default = SummaryItem;

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _translate = __webpack_require__(464);
	
	var _summary = __webpack_require__(1098);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SummaryPaymentPlan = function (_React$Component) {
	    _inherits(SummaryPaymentPlan, _React$Component);
	
	    function SummaryPaymentPlan() {
	        _classCallCheck(this, SummaryPaymentPlan);
	
	        return _possibleConstructorReturn(this, (SummaryPaymentPlan.__proto__ || Object.getPrototypeOf(SummaryPaymentPlan)).apply(this, arguments));
	    }
	
	    _createClass(SummaryPaymentPlan, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "", name: "joinSummaryPaymentPlan" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "summary-section-title" },
	                    (0, _translate.translate)("Payment Plan")
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "summary-content" },
	                    this.props.paymentPlan.title
	                )
	            );
	        }
	    }]);
	
	    return SummaryPaymentPlan;
	}(_react2.default.Component);
	
	exports.default = SummaryPaymentPlan;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _translate = __webpack_require__(464);
	
	var _summary = __webpack_require__(1098);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SummaryTotals = function (_React$Component) {
	    _inherits(SummaryTotals, _React$Component);
	
	    function SummaryTotals() {
	        _classCallCheck(this, SummaryTotals);
	
	        return _possibleConstructorReturn(this, (SummaryTotals.__proto__ || Object.getPrototypeOf(SummaryTotals)).apply(this, arguments));
	    }
	
	    _createClass(SummaryTotals, [{
	        key: "render",
	        value: function render() {
	            var i = 0;
	            return _react2.default.createElement(
	                "div",
	                { className: "summary-total", name: "joinSummaryTotal" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "summary-section-title" },
	                    (0, _translate.translate)("Totals")
	                ),
	                this.props.totals.map(function (total) {
	                    return _react2.default.createElement(
	                        "div",
	                        { key: i++, className: "total-sum" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "summary-total-text" },
	                            total.text
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "summary-total-amount" },
	                            total.amount
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return SummaryTotals;
	}(_react2.default.Component);
	
	exports.default = SummaryTotals;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _utils = __webpack_require__(485);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SummaryDistributionDate = function (_React$Component) {
	    _inherits(SummaryDistributionDate, _React$Component);
	
	    function SummaryDistributionDate() {
	        _classCallCheck(this, SummaryDistributionDate);
	
	        return _possibleConstructorReturn(this, (SummaryDistributionDate.__proto__ || Object.getPrototypeOf(SummaryDistributionDate)).apply(this, arguments));
	    }
	
	    _createClass(SummaryDistributionDate, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { md: 12 },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "summary-section-title" },
	                        (0, _translate.translate)(this.props.deliveryDateLabel)
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "summary-content summary-distribution" },
	                        (0, _utils.getUsefulDate)(this.props.nextDeliveryDate)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SummaryDistributionDate;
	}(_react2.default.Component);
	
	exports.default = SummaryDistributionDate;

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _staticDataActions = __webpack_require__(749);
	
	var _accountActions = __webpack_require__(1089);
	
	var _AccountSummary = __webpack_require__(1104);
	
	var _AccountSummary2 = _interopRequireDefault(_AccountSummary);
	
	var _SelectionTabs = __webpack_require__(842);
	
	var _SelectionTabs2 = _interopRequireDefault(_SelectionTabs);
	
	var _SelectionPane = __webpack_require__(844);
	
	var _SelectionPane2 = _interopRequireDefault(_SelectionPane);
	
	var _AccountOverviewPane = __webpack_require__(1106);
	
	var _AccountOverviewPane2 = _interopRequireDefault(_AccountOverviewPane);
	
	var _AccountPickupDirectionsPane = __webpack_require__(1109);
	
	var _AccountSummaryManagePayments = __webpack_require__(1112);
	
	var _AccountSummaryManagePayments2 = _interopRequireDefault(_AccountSummaryManagePayments);
	
	var _memberDetailsActions = __webpack_require__(751);
	
	var _LogInScreen = __webpack_require__(823);
	
	var _LogInScreen2 = _interopRequireDefault(_LogInScreen);
	
	var _ContactDetailsForm = __webpack_require__(1086);
	
	var _ContactDetailsForm2 = _interopRequireDefault(_ContactDetailsForm);
	
	var _AccountChangePickupSite = __webpack_require__(1113);
	
	var _AccountChangePickupSite2 = _interopRequireDefault(_AccountChangePickupSite);
	
	var _AccountChangeSubscription = __webpack_require__(1116);
	
	var _AccountChangeSubscription2 = _interopRequireDefault(_AccountChangeSubscription);
	
	var _AccountDeliveryHoldPane = __webpack_require__(1117);
	
	var _AccountDeliveryHoldPane2 = _interopRequireDefault(_AccountDeliveryHoldPane);
	
	var _AccountReportsPane = __webpack_require__(1120);
	
	var _UserMenu = __webpack_require__(490);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	var _commonActions = __webpack_require__(747);
	
	var _constants = __webpack_require__(463);
	
	var _LoadingAnimation = __webpack_require__(834);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _ThankYouPage = __webpack_require__(832);
	
	var _ThankYouPage2 = _interopRequireDefault(_ThankYouPage);
	
	var _utils = __webpack_require__(485);
	
	var _translate = __webpack_require__(464);
	
	var _accountHomeScreen = __webpack_require__(1122);
	
	var _accountHomeScreen2 = _interopRequireDefault(_accountHomeScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountHomeScreen = (0, _createReactClass2.default)({
	    displayName: "AccountHomeScreen",
	    getInitialState: function getInitialState() {
	        return { showSummary: true, initialView: true };
	    },
	    componentWillMount: function componentWillMount() {
	        this.props.initServerStaticData();
	        if ((0, _utils.getUrlParams)().mode === 'preview') this.props.setMemberKey((0, _utils.getUrlParams)().m);else this.props.initMemberData();
	        this.props.setAndRemoveUrlParams(true);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.memberDetails.key && !this.props.memberDetails.key) {
	            this.props.getAccountData();
	            if ((0, _utils.getUrlParams)().unsubscribe) {
	                this.props.unsubscribeFlag(parseInt((0, _utils.getUrlParams)().unsubscribe));
	            }
	        }
	        if (!this.state.initialView && nextProps.mode !== _constants.AccountModes.VIEW) this.closeSummaryModal();
	        if (this.props.clientViewPort.isXs && (0, _utils.isEmptyObj)(this.props.messageData) && !(0, _utils.isEmptyObj)(nextProps.messageData)) {
	            this.showSummaryModal();
	        }
	        if (this.state.initialView && nextProps.mode === _constants.AccountModes.VIEW && nextProps.staticData.hideSummaryAccountMobile) {
	            this.closeSummaryModal();
	        }
	    },
	    showSummaryModal: function showSummaryModal() {
	        this.setState({ showSummary: true });
	    },
	    closeSummaryModal: function closeSummaryModal() {
	        if (this.state.showSummary) this.setState({ showSummary: false, initialView: false });
	    },
	    changeSeason: function changeSeason(eventKey) {
	        var season = this.props.seasons.find(function (season) {
	            return season.key == eventKey;
	        });
	        if (season) this.props.changeSeason(season);
	    },
	    onStoreClick: function onStoreClick() {
	        this.props.checkIsDirty(function () {
	            this.props.goToStore(this.props.staticData);
	        }.bind(this));
	    },
	    getSeasonsHeader: function getSeasonsHeader() {
	        if (!this.props.currentSeason || !this.props.isFarmSeasonal) return undefined;
	        if (this.props.seasons.length === 1) return _react2.default.createElement(
	            "div",
	            { className: "season-title" },
	            this.props.seasons[0].title
	        );
	        this.props.seasons.sort(function (a, b) {
	            return b.startDateStr.localeCompare(a.startDateStr);
	        });
	        return _react2.default.createElement(
	            "div",
	            { className: "season-row" },
	            _react2.default.createElement(
	                "div",
	                { className: "season-title-label hidden-xs" },
	                (0, _translate.translate)("Season")
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.DropdownButton,
	                { title: this.props.currentSeason.title, className: "season-dropdown", onSelect: this.changeSeason, id: "season-dropdown-btn", bsStyle: "default", disabled: this.props.isPreview },
	                this.props.seasons.map(function (season) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { key: season.key, eventKey: season.key },
	                        season.title
	                    );
	                })
	            )
	        );
	    },
	    getTabsData: function getTabsData() {
	        var tabs = [];
	        if (this.props.subscriptionSummary.status !== "NoSubscription") tabs.push({ title: "Overview", key: "overview", content: _react2.default.createElement(_AccountOverviewPane2.default, { history: this.props.history,
	                staticData: this.props.staticData,
	                clientViewPort: this.props.clientViewPort }) });
	        tabs.push({ title: "Contact Info", key: "contact-info", content: _react2.default.createElement(_ContactDetailsForm2.default, { flowType: _constants.URLs.ACCOUNT, setDirty: this.props.setDirty }) });
	        if (!this.props.subscriptionSummary.hasMultiplePickupSites && this.props.pickupSite.type && this.props.pickupSite.type !== _constants.PickupSiteTypes.HOME && !this.props.subscriptionSummary.status !== _constants.SubscriptionStatuses.NO_SUBSCRIPTION) tabs.push({ title: (0, _translate.translate)("Pick-up Directions"), key: "directions",
	            content: _react2.default.createElement(_AccountPickupDirectionsPane.AccountPickupDirectionsPane, { pickupSite: this.props.pickupSite,
	                clientViewPort: this.props.clientViewPort, errorFetching: this.props.errorFetching }) });
	        if (!this.props.subscriptionSummary.hasMultiplePickupSites && this.props.staticData.allowUpdateVacation && this.props.subscriptionSummary.holdReason !== _constants.SubscriptionHoldReason.NEW && this.props.subscriptionSummary.status !== "NoSubscription" && !this.props.staticData.isPastSeason) tabs.push({ title: (0, _translate.translate)("Delivery Hold"), key: "delivery-hold", content: _react2.default.createElement(_AccountDeliveryHoldPane2.default, null) });
	        if (this.props.staticData.allowReportsToHost && this.props.subscriptionSummary.contactListReportURL) tabs.push({ title: (0, _translate.translate)("Reports"), key: "reports", content: _react2.default.createElement(_AccountReportsPane.AccountReportsPane, { subscriptionSummary: this.props.subscriptionSummary,
	                clientViewPort: this.props.clientViewPort }) });
	        return tabs;
	    },
	    onExit: function onExit() {
	        this.props.setShowPassword(false);
	        this.props.setDirty(false);
	    },
	    onMobileTabsSelect: function onMobileTabsSelect(eventKey) {
	        var _this = this;
	
	        this.props.checkIsDirty(function () {
	            _this.setState({ tabActiveKey: eventKey });
	        });
	    },
	    getTabsMobile: function getTabsMobile() {
	        var _this2 = this;
	
	        var tabs = this.getTabsData();
	        return _react2.default.createElement(
	            _reactBootstrap.Tabs,
	            { id: "account-tabs", className: "account-tabs", activeKey: this.state.tabActiveKey, defaultActiveKey: tabs[0].key, onSelect: this.onMobileTabsSelect },
	            tabs.map(function (tab) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { title: " ", eventKey: tab.key, key: tab.key, tabClassName: tab.key + " _" + tabs.length,
	                        unmountOnExit: true, onExiting: _this2.onExit.bind(_this2, tab.key) },
	                    tab.content
	                );
	            })
	        );
	    },
	    getTabs: function getTabs() {
	        var tabs = this.getTabsData();
	        return _react2.default.createElement(
	            _SelectionTabs2.default,
	            { checkDirty: true, update: this.onExit, selectedTabTitle: this.props.defaultTab },
	            tabs.map(function (tab) {
	                return _react2.default.createElement(
	                    _SelectionPane2.default,
	                    { label: tab.title, key: tab.key },
	                    tab.content
	                );
	            })
	        );
	    },
	    isShowManagePaymentButton: function isShowManagePaymentButton() {
	        var summary = this.props.subscriptionSummary;
	        return (summary.singlePaymentMethods || {}).length > 0 && (summary.singlePaymentPlans || {}).length > 0 || summary.autoPaymentMethods && summary.autoPaymentMethods.length > 0 && (summary.autoPaymentPlans || {}).length > 0 || summary.hasToken && summary.autoPaymentMethods && summary.autoPaymentMethods.length > 0;
	    },
	    getAccountHeaderMobile: function getAccountHeaderMobile() {
	        var seasonHeader = this.getSeasonsHeader();
	        return _react2.default.createElement(
	            "div",
	            { className: "title-row" },
	            seasonHeader ? seasonHeader : _react2.default.createElement(
	                "div",
	                { className: "title" },
	                (0, _translate.translate)("My Account")
	            ),
	            this.isShowManagePaymentButton() ? _react2.default.createElement(_AccountSummaryManagePayments2.default, null) : undefined,
	            this.props.subscriptionSummary.hasMultiplePickupSites ? undefined : _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: "primary", className: "summary-btn button",
	                    onClick: this.showSummaryModal },
	                (0, _translate.translate)("Summary")
	            )
	        );
	    },
	    getAccountHeader: function getAccountHeader() {
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: "title-row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "title" },
	                    (0, _translate.translate)("My Account")
	                ),
	                this.isShowManagePaymentButton() ? _react2.default.createElement(_AccountSummaryManagePayments2.default, null) : undefined
	            ),
	            _react2.default.createElement(
	                "div",
	                null,
	                this.getSeasonsHeader()
	            )
	        );
	    },
	    getAccountScreenMobile: function getAccountScreenMobile() {
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: "account-screen-mobile" },
	                this.getAccountHeaderMobile(),
	                this.getTabsMobile()
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { show: this.state.showSummary, onHide: this.closeSummaryModal, className: "summary-modal" },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_AccountSummary2.default, { season: this.props.currentSeason && this.props.isFarmSeasonal ? this.props.currentSeason : undefined })
	                ),
	                _react2.default.createElement("button", { className: "close-button order-summary-popup visible-xs", onClick: this.closeSummaryModal })
	            )
	        );
	    },
	    getAccountScreen: function getAccountScreen() {
	        if (this.props.mode == _constants.AccountModes.CHANGE_PICKUP_SITE) {
	            return _react2.default.createElement(_AccountChangePickupSite2.default, null);
	        }
	        if (this.props.mode == _constants.AccountModes.CHANGE_SUBSCRIPTION || this.props.mode == _constants.AccountModes.CHANGE_SUBSCRIPTION_THANKYOU) {
	            return _react2.default.createElement(_AccountChangeSubscription2.default, null);
	        }
	        if (this.props.clientViewPort.isXs) {
	            return this.getAccountScreenMobile();
	        }
	        return _react2.default.createElement(
	            "div",
	            null,
	            this.getAccountHeader(),
	            this.getTabs()
	        );
	    },
	    getScreen: function getScreen() {
	        if (this.props.isFetching) return _react2.default.createElement(_LoadingAnimation2.default, null);
	        if (!this.props.memberDetails.key) return _react2.default.createElement(_LogInScreen2.default, null);
	        if (this.props.location.pathname.endsWith('/thankyou')) return _react2.default.createElement(_ThankYouPage2.default, { pageContext: _constants.URLs.PAY, seasonUrl: this.props.staticData.seasonUrl,
	            memberKey: this.props.memberDetails.key,
	            mode: this.props.paymentType,
	            extraMessage: (this.props.staticData.params || {}).message,
	            farmUrl: this.props.staticData.farmUrl });
	        if (this.props.clientViewPort.isXs) return this.getAccountScreen();
	
	        return _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { className: "account-screen" },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 8, md: 10, sm: 10 },
	                    this.getAccountScreen()
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: "summary-col", lg: 4, md: 2, sm: 2 },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "user-menu-wrapper" },
	                        _react2.default.createElement(_UserMenu2.default, { disabled: this.props.isPreview }),
	                        this.props.isPreview ? _react2.default.createElement(
	                            "div",
	                            { className: "preview-label" },
	                            (0, _translate.translate)("Preview")
	                        ) : undefined,
	                        this.props.staticData.storeButtonLabel && _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { bsStyle: "primary", className: "go-to-store-btn button", onClick: this.onStoreClick },
	                            (0, _translate.translate)(this.props.staticData.storeButtonLabel)
	                        )
	                    ),
	                    this.props.clientViewPort.isLg ? _react2.default.createElement(_AccountSummary2.default, null) : _react2.default.createElement(
	                        _reactBootstrap.DropdownButton,
	                        { id: "summary-dropdown", defaultOpen: true, title: (0, _translate.translate)("Summary"), pullRight: true, noCaret: true,
	                            bsStyle: "default" },
	                        _react2.default.createElement(_AccountSummary2.default, null)
	                    )
	                )
	            )
	        );
	    },
	    render: function render() {
	        return this.getScreen();
	    }
	});
	
	var mapStateToProps = function mapStateToProps(state) {
	    var account = state.account || {};
	    var summary = state.summary || {};
	    var mode = account.mode;
	    var seasons = (summary || {}).seasons || [];
	    var currentSeason = seasons.find(function (season) {
	        return season.key == state.staticData.seasonKey;
	    });
	    var defaultTab = ((0, _utils.getUrlParams)() || {}).tab;
	    return {
	        clientViewPort: state.clientViewPort || {},
	        mode: mode,
	        isPreview: (state.staticData || {}).isPreview,
	        history: account.history || {},
	        subscriptionSummary: summary,
	        pickupSite: summary.pickupSite || {},
	        memberDetails: state.memberDetails || {},
	        currentSeason: currentSeason,
	        seasons: seasons,
	        staticData: state.staticData,
	        isFarmSeasonal: summary.isFarmSeasonal,
	        isFetching: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOAD_ACCOUNT_DATA),
	        messageData: state.messageData,
	        hasToken: summary.hasToken,
	        defaultTab: defaultTab
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        initServerStaticData: function initServerStaticData() {
	            dispatch((0, _staticDataActions.initServerStaticData)());
	        },
	        initMemberData: function initMemberData() {
	            dispatch((0, _memberDetailsActions.initMemberData)());
	        },
	        setAndRemoveUrlParams: function setAndRemoveUrlParams(onlyHidden) {
	            dispatch((0, _commonActions.setAndRemoveUrlParams)(onlyHidden));
	        },
	        setMemberKey: function setMemberKey(memberKey) {
	            dispatch((0, _memberDetailsActions.setMemberKey)(memberKey));
	        },
	        getAccountData: function getAccountData() {
	            dispatch((0, _accountActions.getAccountData)());
	        },
	        changeSeason: function changeSeason(season) {
	            dispatch((0, _accountActions.changeSeason)(season));
	        },
	        setDirty: function setDirty(isDirty) {
	            dispatch((0, _commonActions.setDirty)(isDirty));
	        },
	        checkIsDirty: function checkIsDirty(onLeaveCallBack) {
	            dispatch((0, _commonActions.checkIsDirty)(onLeaveCallBack));
	        },
	        setShowPassword: function setShowPassword(showPassword) {
	            dispatch((0, _memberDetailsActions.setShowPassword)(showPassword));
	        },
	        goToStore: function goToStore(staticData) {
	            dispatch((0, _commonActions.setDirty)(false));
	            window.location.href = (0, _utils.redirectPage)(_constants.URLs.STORE, staticData);
	        },
	        errorFetching: function errorFetching(error) {
	            dispatch((0, _fetchingActions.errorFetching)(error));
	        },
	        unsubscribeFlag: function unsubscribeFlag(flag) {
	            dispatch((0, _accountActions.unsubscribeFlag)(flag));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountHomeScreen);

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(463);
	
	var _SummaryPickupSite = __webpack_require__(1094);
	
	var _SummaryPickupSite2 = _interopRequireDefault(_SummaryPickupSite);
	
	var _SummaryItems = __webpack_require__(1096);
	
	var _SummaryItems2 = _interopRequireDefault(_SummaryItems);
	
	var _SummaryDistributionDate = __webpack_require__(1101);
	
	var _SummaryDistributionDate2 = _interopRequireDefault(_SummaryDistributionDate);
	
	var _AccountSummaryMessage = __webpack_require__(1105);
	
	var _AccountSummaryMessage2 = _interopRequireDefault(_AccountSummaryMessage);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _accountActions = __webpack_require__(1089);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _basket = __webpack_require__(757);
	
	var _joinActions = __webpack_require__(752);
	
	var _utils = __webpack_require__(485);
	
	var _commonActions = __webpack_require__(747);
	
	var _translate = __webpack_require__(464);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _summary = __webpack_require__(1098);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountSummary = (0, _createReactClass2.default)({
	    displayName: "AccountSummary",
	    getInitialState: function getInitialState() {
	        return {
	            changeError: undefined
	        };
	    },
	    isAllowedToChangeLocation: function isAllowedToChangeLocation() {
	        return this.props.staticData.allowChangePickupSite && this.props.pickupSite && (this.props.staticData.allowChangePickupSiteHomeDelivery || this.props.pickupSite.type === _constants.PickupSiteTypes.REGULAR) && this.isAllowActions();
	    },
	    isAllowedToChangeLocationOneDelivery: function isAllowedToChangeLocationOneDelivery() {
	        return this.props.staticData.allowChangePickupSiteOneDelivery && this.props.pickupSite && (this.props.staticData.allowChangePickupSiteHomeDelivery || this.props.pickupSite.type === _constants.PickupSiteTypes.REGULAR) && this.isAllowActions();
	    },
	    isAllowAddSubscription: function isAllowAddSubscription() {
	        var allow = true;
	        var props = this.props;
	        if (!this.props.isFarmSeasonal) {
	            allow = !this.props.shareSchedules.some(function (share) {
	                return props.schedules.hasOwnProperty(share) && props.schedules[share].isOnce;
	            });
	        }
	        return this.props.staticData.allowAddSubscription && this.isAllowActions() && allow;
	    },
	    isAllowActions: function isAllowActions() {
	        return this.props.mode == _constants.AccountModes.VIEW && !this.props.staticData.isPastSeason && (0, _utils.isEmptyObj)(this.props.messageData);
	    },
	    getMessageOrDataView: function getMessageOrDataView() {
	        if (!(0, _utils.isEmptyObj)(this.props.messageData)) {
	            if (this.props.messageData.status === _constants.SubscriptionStatuses.ROLLOVER_ENABLED) {
	                return this.getRolloverView();
	            }
	            return _react2.default.createElement(_AccountSummaryMessage2.default, { messageData: this.props.messageData });
	        } else {
	            return _react2.default.createElement(
	                "div",
	                null,
	                this.props.nextDeliveryDate ? _react2.default.createElement(_SummaryDistributionDate2.default, { nextDeliveryDate: this.props.nextDeliveryDate,
	                    deliveryDateLabel: "Next Distribution" }) : undefined
	            );
	        }
	    },
	    onAddSubscriptionClick: function onAddSubscriptionClick() {
	        if (!this.props.isPreview) this.props.onAddSubscriptionClick();
	    },
	    getPreApprovalText: function getPreApprovalText() {
	        var preApprovalText = (0, _translate.translate)("You are") + " " + (0, _translate.translate)("_assignedAutomaticPayment");
	        switch (this.props.paymentMethodToken) {
	            case _constants.PaymentMethod.PAYPAL_PREAPPROVE.key:
	                return preApprovalText + "PayPal";
	            case _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key:
	                return preApprovalText + (0, _translate.translate)("AUTHORIZE_DOT_NET");
	            case _constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key:
	                return preApprovalText + (0, _translate.translate)("ELECTRONIC_CHECK");
	            default:
	                return undefined;
	        }
	    },
	    getPaymentPlanText: function getPaymentPlanText() {
	        if (!this.props.subscriptionPaymentPlan || [_constants.PaymentPlans.F, _constants.PaymentPlans.AutoRecurring, _constants.PaymentPlans.PresetRecurring].includes(this.props.subscriptionPaymentPlan.type)) {
	            return undefined;
	        }
	        return "Payment plan: " + this.props.subscriptionPaymentPlan.title;
	    },
	    getAdditionsRow: function getAdditionsRow() {
	        var showAdditions = this.props.extraCost && (0, _utils.isEmptyObj)(this.props.messageData) || this.props.discount && (0, _utils.isEmptyObj)(this.props.messageData);
	        var preapprovalText = this.props.staticData.accountSummaryShowPaymentDetails && this.getPreApprovalText();
	        var paymentPlanText = this.props.staticData.accountSummaryShowPaymentDetails && this.getPaymentPlanText();
	        if (!showAdditions && !preapprovalText && !paymentPlanText) return undefined;
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: "summary-section-title" },
	                (0, _translate.translate)("Additions")
	            ),
	            this.props.extraCost ? _react2.default.createElement(
	                "div",
	                { className: "summary-content" },
	                this.props.extraCost
	            ) : undefined,
	            this.props.discount ? _react2.default.createElement(
	                "div",
	                { className: "summary-content" },
	                (0, _translate.translate)("Special Discount"),
	                " (",
	                this.props.discount,
	                "%)"
	            ) : undefined,
	            paymentPlanText && _react2.default.createElement(
	                "div",
	                { className: "summary-content" },
	                paymentPlanText
	            ),
	            preapprovalText && _react2.default.createElement(
	                "div",
	                { className: "summary-content summary-content-slim" },
	                preapprovalText
	            )
	        );
	    },
	    getSummaryView: function getSummaryView() {
	        return _react2.default.createElement(
	            "div",
	            { className: "scroll" },
	            this.getMessageOrDataView(),
	            this.props.pickupSite || this.props.mode === _constants.AccountModes.CHANGE_PICKUP_SITE ? _react2.default.createElement(_SummaryPickupSite2.default, { pickupSiteLabel: this.props.pickupSiteLabel,
	                readOnly: this.props.mode !== _constants.AccountModes.CHANGE_PICKUP_SITE,
	                allowRemove: this.props.mode === _constants.AccountModes.CHANGE_PICKUP_SITE,
	                pickupSite: this.props.pickupSite,
	                waitListSite: this.props.waitListSite,
	                onChangePickupSiteClick: this.props.onChangePickupSiteClick,
	                onRemovePickupSite: this.props.onRemovePickupSite,
	                allowChangePickupSite: this.isAllowedToChangeLocation(),
	                allowChangePickupSiteOneDelivery: this.isAllowedToChangeLocationOneDelivery(),
	                isChangeAllowed: this.isChangeAllowed,
	                flowType: _constants.URLs.ACCOUNT }) : undefined,
	            this.props.selectedItems && this.props.selectedItems.length > 0 ? _react2.default.createElement(_SummaryItems2.default, { staticData: this.props.staticData,
	                readOnly: this.props.mode !== _constants.AccountModes.CHANGE_SUBSCRIPTION || this.props.staticData.allowChangeFreeOptions,
	                allowChangeShares: this.props.step === _constants.JoinSteps.SHARES,
	                allowChangeOptions: this.props.step === _constants.JoinSteps.SHARES || this.props.step === _constants.JoinSteps.OPTIONS,
	                items: this.props.selectedItems,
	                isFarmSeasonal: this.props.isFarmSeasonal,
	                schedules: this.props.schedules,
	                pickupSite: this.props.pickupSite,
	                showItemDetailsLink: true,
	                includeTax: true,
	                title: "Subscription",
	                flowType: _constants.URLs.ACCOUNT,
	                isAllowModifySubscription: this.isAllowAddSubscription(),
	                onAddSubscriptionClick: this.onAddSubscriptionClick,
	                onChangeSubscriptionClick: this.props.onChangeSubscriptionClick,
	                isChangeAllowed: this.isChangeAllowed,
	                onRemoveItem: this.props.removeItem }) : undefined,
	            this.getAdditionsRow()
	        );
	    },
	    showPopupChangeError: function showPopupChangeError() {
	        var _this = this;
	
	        return _react2.default.createElement(_ModalPopup2.default, {
	            onClose: function onClose() {
	                _this.setState({ changeError: undefined });
	            },
	            message: this.state.changeError,
	            middle: {
	                text: 'Close', callback: function callback() {
	                    _this.setState({ changeError: undefined });
	                }
	            } });
	    },
	    isChangeAllowed: function isChangeAllowed() {
	        if (!this.props.storeClosedEndDate) {
	            this.setState({ changeError: undefined });
	            return true;
	        } else {
	            var nextDeliveryDate = (0, _utils.getUsefulDate)(this.props.storeClosedEndDate);
	            var error = (0, _translate.translate)("noChangeAllowed1").replace("{0}", nextDeliveryDate).replace("{1}", this.props.staticData.farmEmail).replace("{2}", this.props.staticData.farmPhone);
	
	            this.setState({ changeError: error });
	            return false;
	        }
	    },
	    handleOptOutChange: function handleOptOutChange(event) {
	        this.props.setSeasonRolloverOptOut(event.target.checked);
	    },
	    getRolloverView: function getRolloverView() {
	        if (this.props.member) {
	            var seasonRollOverMessageParts = (this.props.staticData.seasonRollOverMessage || 'Your 2024 subscription is set for automatic renewal in 2025.|Check the box to turn OFF automatic renewal.|Turn OFF automatic renewal').split('|');
	            return _react2.default.createElement(
	                "div",
	                { className: "account-summary-message" },
	                seasonRollOverMessageParts[0],
	                _react2.default.createElement("br", null),
	                seasonRollOverMessageParts[1],
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                    _reactBootstrap.Checkbox,
	                    { className: "input-detail-cbx",
	                        checked: this.props.member.rolloverOptOut,
	                        onChange: this.handleOptOutChange },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "input-detail-cbk-lbl" },
	                        seasonRollOverMessageParts[2]
	                    )
	                )
	            );
	        }
	    },
	    render: function render() {
	        return this.props.hasMultiplePickupSites ? null : _react2.default.createElement(
	            "div",
	            { className: "summary-container" },
	            _react2.default.createElement(
	                "div",
	                { className: "summary-row", id: "joinSummaryContainer" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "secured-and-summary-wrapper" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "secured-wrapper" },
	                        (0, _translate.translate)("Secured Payment & Privacy Protection")
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "summary-title" },
	                        (0, _translate.translate)("Summary"),
	                        this.props.season ? ' - ' + this.props.season.title : ''
	                    )
	                ),
	                this.getSummaryView()
	            ),
	            !this.state.changeError ? undefined : this.showPopupChangeError()
	        );
	    }
	});
	
	var mapStateToProps = function mapStateToProps(state) {
	    var account = state.account || {};
	    var subscriptionSummary = state.summary || {};
	    var signupData = state.signupData || {};
	    var mode = account.mode;
	    var extraCost = undefined;
	    var items = void 0;
	    var nextDeliveryDate = void 0;
	    var selectedItems = {};
	    var schedules = void 0;
	    var nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
	    //Next delivery date should be set by the new selection of items
	    if ((mode === _constants.AccountModes.CHANGE_SUBSCRIPTION || mode === _constants.AccountModes.CHANGE_SUBSCRIPTION_THANKYOU) && signupData.sharesData) {
	        if (subscriptionSummary.waitListItems && signupData.sharesData.shares && signupData.sharesData.options) {
	            subscriptionSummary.waitListItems.map(function (waitlistItem) {
	                var item = signupData.sharesData.shares[waitlistItem.key] || signupData.sharesData.options[waitlistItem.key];
	                if (item) item.waitList = true;
	            });
	        }
	        selectedItems = (0, _basket.getJoinSelectedItems)(signupData.sharesData.shares, signupData.sharesData.options);
	        items = selectedItems.items;
	        schedules = signupData.schedules || {};
	        if (items) {
	            items = items.concat(selectedItems.waitlistItems);
	        }
	    } else {
	        items = subscriptionSummary.shareItems;
	        if (items) {
	            items = items.concat(subscriptionSummary.waitListItems);
	        }
	        schedules = subscriptionSummary.schedules || {};
	    }
	    if (nextDeliveryDates) {
	        nextDeliveryDate = (0, _basket.getNextDeliveryDate)(subscriptionSummary.pickupSite, items, schedules, nextDeliveryDates);
	    } else {
	        nextDeliveryDate = subscriptionSummary.nextDeliveryDate;
	    }
	    if ((mode == _constants.AccountModes.VIEW || mode == _constants.AccountModes.CHANGE_PICKUP_SITE) && subscriptionSummary.pickupSite && subscriptionSummary.pickupSite.extraCost > 0) {
	        var extraCostLabel = (state.staticData || {}).extraCostLabel || "Extra Fuel Charge";
	        var extraCostText = subscriptionSummary.pickupSite.extraCostType === 'Fixed' ? '$' + subscriptionSummary.pickupSite.extraCost + " " + (0, _translate.translate)("per delivery") : subscriptionSummary.pickupSite.extraCost + '%';
	        extraCost = extraCostLabel + " : " + extraCostText;
	    }
	
	    var pickupSite = subscriptionSummary.pickupSite;
	    if (state.staticData.joinHideRegularPickupSiteHours && pickupSite && pickupSite.type === _constants.PickupSiteTypes.REGULAR) {
	        pickupSite.deliveryHours = '';
	    }
	
	    return {
	        mode: mode,
	        step: signupData.step,
	        isPreview: (state.staticData || {}).isPreview,
	        storeClosedEndDate: subscriptionSummary.storeClosedEndDate,
	        isStoreOpen: subscriptionSummary.isStoreOpen,
	        staticData: state.staticData,
	        isFarmSeasonal: subscriptionSummary.isFarmSeasonal,
	        nextDeliveryDate: nextDeliveryDate,
	        pickupSiteLabel: state.staticData.pickupSiteLabel,
	        pickupSite: pickupSite,
	        schedules: subscriptionSummary.schedules,
	        shareSchedules: subscriptionSummary.shareSchedules,
	        waitListSite: subscriptionSummary.waitListSite,
	        subscriptionStatus: subscriptionSummary.status,
	        subscriptionHoldReason: subscriptionSummary.holdReason,
	        selectedItems: items,
	        messageData: state.messageData,
	        extraCost: extraCost,
	        discount: subscriptionSummary.discount,
	        seasons: subscriptionSummary.seasons || [],
	        singlePaymentPlans: subscriptionSummary.singlePaymentPlans,
	        autoPaymentPlans: subscriptionSummary.autoPaymentPlans,
	        singlePaymentMethods: subscriptionSummary.singlePaymentMethods,
	        autoPaymentMethods: subscriptionSummary.autoPaymentMethods,
	        hasToken: subscriptionSummary.hasToken,
	        paymentMethodToken: subscriptionSummary.paymentMethodToken,
	        subscriptionPaymentPlan: subscriptionSummary.paymentPlan,
	        hasMultiplePickupSites: subscriptionSummary.hasMultiplePickupSites,
	        member: state.memberDetails
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        onChangePickupSiteClick: function onChangePickupSiteClick(onlyOnce) {
	            dispatch((0, _accountActions.openChangePickupSite)(onlyOnce));
	        },
	        onRemovePickupSite: function onRemovePickupSite(isWaitList) {
	            if (!isWaitList) {
	                dispatch((0, _subscriptionSummaryActions.setPickupSite)(null));
	            } else {
	                dispatch((0, _subscriptionSummaryActions.setWaitListPickupSite)(null));
	            }
	        },
	        onAddSubscriptionClick: function onAddSubscriptionClick() {
	            dispatch((0, _accountActions.openAddSubscription)());
	        },
	        onChangeSubscriptionClick: function onChangeSubscriptionClick() {
	            dispatch((0, _accountActions.openChangeSubscription)());
	        },
	        removeItem: function removeItem(key, newQuantity) {
	            dispatch((0, _joinActions.joinChangeItemQuantity)(key, newQuantity));
	            dispatch((0, _commonActions.setDirty)(true));
	        },
	        setSeasonRolloverOptOut: function setSeasonRolloverOptOut(isOptOt) {
	            dispatch((0, _accountActions.setSeasonRolloverOptOut)(isOptOt));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountSummary);

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountSummaryMessage = function (_React$Component) {
	    _inherits(AccountSummaryMessage, _React$Component);
	
	    function AccountSummaryMessage(props) {
	        _classCallCheck(this, AccountSummaryMessage);
	
	        return _possibleConstructorReturn(this, (AccountSummaryMessage.__proto__ || Object.getPrototypeOf(AccountSummaryMessage)).call(this, props));
	    }
	
	    _createClass(AccountSummaryMessage, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement("div", { className: "account-summary-message", dangerouslySetInnerHTML: { __html: this.props.messageData.messageBody } });
	        }
	    }]);
	
	    return AccountSummaryMessage;
	}(_react2.default.Component);
	
	exports.default = AccountSummaryMessage;
	;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _AccountWebOrderView = __webpack_require__(1107);
	
	var _AccountWebOrderView2 = _interopRequireDefault(_AccountWebOrderView);
	
	var _LoadingAnimation = __webpack_require__(834);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _translate = __webpack_require__(464);
	
	var _accountOverviewPane = __webpack_require__(1108);
	
	var _accountOverviewPane2 = _interopRequireDefault(_accountOverviewPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountOverviewPane = function (_React$Component) {
	    _inherits(AccountOverviewPane, _React$Component);
	
	    function AccountOverviewPane(props) {
	        _classCallCheck(this, AccountOverviewPane);
	
	        var _this = _possibleConstructorReturn(this, (AccountOverviewPane.__proto__ || Object.getPrototypeOf(AccountOverviewPane)).call(this, props));
	
	        _this.state = { description: undefined, webOrder: undefined, historyList: [], loadingHistory: true };
	        _this.hasBalance = _this.props.staticData.farmBalanceType === _constants.FarmBalanceTypes.BALANCE_ON_ACCOUNT;
	        _this.desktopDescriptionColSize = _this.hasBalance ? 4 : 5;
	        _this.mobileDebitAmountColSize = _this.hasBalance ? 2 : 3;
	        _this.isMobile = props.clientViewPort.isXs;
	        return _this;
	    }
	
	    _createClass(AccountOverviewPane, [{
	        key: "setShowWebOrder",
	        value: function setShowWebOrder(orderKey, orderDate) {
	            this.setState({ webOrder: { orderKey: orderKey, orderDate: orderDate } });
	        }
	    }, {
	        key: "setShowDescription",
	        value: function setShowDescription(type, description) {
	            this.setState({ description: { type: type, content: description } });
	        }
	    }, {
	        key: "closeWebOrder",
	        value: function closeWebOrder() {
	            this.setState({ webOrder: undefined });
	        }
	    }, {
	        key: "closeDescription",
	        value: function closeDescription() {
	            this.setState({ description: undefined });
	        }
	    }, {
	        key: "showWebOrder",
	        value: function showWebOrder() {
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { show: true, onHide: this.closeWebOrder.bind(this), dialogClassName: "history-web-order" },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_AccountWebOrderView2.default, {
	                        webOrder: this.state.webOrder,
	                        onClose: this.closeWebOrder.bind(this) })
	                )
	            );
	        }
	    }, {
	        key: "showDescription",
	        value: function showDescription() {
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { show: true, dialogClassName: "history-description" },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Title,
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "history-description-title" },
	                        this.state.description.type,
	                        _react2.default.createElement(
	                            "div",
	                            { className: "history-description-close", onClick: this.closeDescription.bind(this) },
	                            "X"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    this.state.description.content
	                )
	            );
	        }
	    }, {
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.getHistory(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.history.historyList && !this.props.history.historyList) {
	                this.getHistory(nextProps);
	            }
	        }
	    }, {
	        key: "getDescription",
	        value: function getDescription(historyItem) {
	            if (_constants.OverviewHistoryTypes.ORDER === historyItem.type) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "history-item-link",
	                        onClick: this.setShowWebOrder.bind(this, historyItem.key, historyItem.date) },
	                    historyItem.description
	                );
	            } else if (this.isMobile && _constants.OverviewHistoryTypes.SUBSCRIPTION === historyItem.type) {
	                var typeName = historyItem.type === _constants.OverviewHistoryTypes.SUBSCRIPTION ? "Delivery" : historyItem.type;
	                return _react2.default.createElement(
	                    "div",
	                    { className: "history-item-link",
	                        onClick: this.setShowDescription.bind(this, typeName, historyItem.description) },
	                    typeName
	                );
	            } else if (_constants.OverviewHistoryTypes.PAYMENT === historyItem.type && historyItem.status !== "COMPLIMENTARY" && historyItem.status !== "PROCESSING") {
	                return historyItem.type;
	            } else {
	                return historyItem.description;
	            }
	        }
	    }, {
	        key: "getHistory",
	        value: function getHistory(props) {
	            var _this2 = this;
	
	            if (props.history.historyList) {
	                var rowIndex = 0;
	                var historyList = props.history.historyList.map(function (historyItem) {
	                    var balance = historyItem.balance ? historyItem.balance.toFixed(2) : "";
	                    var debit = historyItem.debit ? historyItem.debit.toFixed(2) : "";
	                    var credit = historyItem.credit ? historyItem.credit.toFixed(2) : "";
	                    var pastDate = new Date() > new Date(historyItem.date + "T12:00:00");
	                    var styleClassName = _constants.OverviewHistoryTypes.PENDING_PAYMENT === historyItem.type && pastDate ? ' pending-description' : '';
	                    var description = _this2.getDescription(historyItem);
	                    var hasBalanceStyle = !_this2.hasBalance ? "-without-balance" : "";
	                    var showBalance = !_this2.props.staticData.accountHideRunningBalance;
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { key: rowIndex++, className: "list-row account-history-row" + styleClassName },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { md: 2, xs: 3,
	                                className: "history-data-col account-history-col-date" + hasBalanceStyle },
	                            (0, _utils.getUsefulDateWithYear)(historyItem.date, _this2.isMobile)
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { md: _this2.desktopDescriptionColSize, xs: 3, className: "history-data-col account-history-col-description" + hasBalanceStyle },
	                            description
	                        ),
	                        showBalance && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { md: 2, xs: _this2.mobileDebitAmountColSize,
	                                className: "history-data-col account-history-col-debit" + hasBalanceStyle },
	                            debit
	                        ),
	                        showBalance && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { md: 2, xs: _this2.mobileDebitAmountColSize,
	                                className: "history-data-col account-history-col-credit" + hasBalanceStyle },
	                            credit
	                        ),
	                        showBalance && _this2.hasBalance ? _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: "history-data-col history-data-col-balance", md: 1, xs: 2 },
	                            balance
	                        ) : undefined
	                    );
	                });
	                this.setState({ historyList: historyList, loadingHistory: false });
	            }
	        }
	    }, {
	        key: "formatBalance",
	        value: function formatBalance(balance, dollarSign) {
	            var formattedBalance = balance && (balance >= 1 || balance <= -1) ? balance.toFixed(2) : 0 .toFixed(2);
	            if (formattedBalance < 0) {
	                formattedBalance = (dollarSign ? '-$' : '-') + formattedBalance * -1;
	            } else {
	                formattedBalance = (dollarSign ? '$' : '') + formattedBalance;
	            }
	            return formattedBalance;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (this.state.loadingHistory) {
	                return _react2.default.createElement(_LoadingAnimation2.default, null);
	            }
	            var balance = this.formatBalance(this.props.history.balance, true);
	            var creditBalance = this.formatBalance(this.props.history.creditBalance);
	            var hasBalanceStyle = !this.hasBalance ? "-without-balance" : "";
	            var showBalance = !this.props.staticData.accountHideRunningBalance;
	            var showTotals = !this.props.staticData.accountHideBalanceTotals;
	            var balanceLabels = this.props.staticData.accountBalanceLabel.split('|');
	            var balanceLabel = balanceLabels[0];
	            var creditBalanceLabel = balanceLabels.length > 1 ? balanceLabels[1] : '';
	            return _react2.default.createElement(
	                "div",
	                { className: "account-overview-container" },
	                this.isMobile ? _react2.default.createElement(
	                    "div",
	                    { className: "account-header-title-container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "account-header-title" },
	                        (0, _translate.translate)("Overview")
	                    )
	                ) : undefined,
	                showTotals && _react2.default.createElement(
	                    "div",
	                    { className: "account-overview-balance-row" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "account-overview-balance-container" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "account-overview-balance-title" },
	                            balanceLabel || (0, _translate.translate)("Balance"),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "account-overview-balance" },
	                                balance
	                            )
	                        )
	                    ),
	                    this.props.staticData.hasFarmigoCredits && creditBalance > 0 && _react2.default.createElement(
	                        "div",
	                        { className: "account-overview-balance-container" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "account-overview-balance-title" },
	                            creditBalanceLabel || (0, _translate.translate)("Credit Balance"),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "account-overview-balance" },
	                                creditBalance
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "table-container-selector" },
	                    _react2.default.createElement(
	                        _reactBootstrap.Form,
	                        { horizontal: true, className: "list-container account-overview-list-container" },
	                        _react2.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { className: "columns-title", controlId: "accountOverviewTitles" },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { md: 2, xs: 3, className: "title-column date-col" + hasBalanceStyle },
	                                (0, _translate.translate)("Date")
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { md: this.desktopDescriptionColSize, xs: 3, className: "title-column description-col" + hasBalanceStyle },
	                                (0, _translate.translate)(this.isMobile ? "Info" : "Description")
	                            ),
	                            showBalance && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { md: 2, xs: this.mobileDebitAmountColSize, className: "title-column debit-col" + hasBalanceStyle },
	                                (0, _translate.translate)("Debit")
	                            ),
	                            showBalance && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { md: 2, xs: this.mobileDebitAmountColSize, className: "title-column credit-col" + hasBalanceStyle },
	                                (0, _translate.translate)("Credit")
	                            ),
	                            this.hasBalance && showBalance ? _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { md: 1, xs: 2, className: "title-column balance-col" },
	                                (0, _translate.translate)("Balance")
	                            ) : undefined
	                        ),
	                        this.state.historyList
	                    )
	                ),
	                !this.state.webOrder ? undefined : this.showWebOrder(),
	                this.isMobile && this.state.description ? this.showDescription() : undefined
	            );
	        }
	    }]);
	
	    return AccountOverviewPane;
	}(_react2.default.Component);
	
	exports.default = AccountOverviewPane;
	;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _OrderSummary = __webpack_require__(793);
	
	var _OrderSummary2 = _interopRequireDefault(_OrderSummary);
	
	var _accountActions = __webpack_require__(1089);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _LoadingAnimation = __webpack_require__(834);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _constants = __webpack_require__(463);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountWebOrderView = function (_React$Component) {
	    _inherits(AccountWebOrderView, _React$Component);
	
	    function AccountWebOrderView() {
	        _classCallCheck(this, AccountWebOrderView);
	
	        return _possibleConstructorReturn(this, (AccountWebOrderView.__proto__ || Object.getPrototypeOf(AccountWebOrderView)).apply(this, arguments));
	    }
	
	    _createClass(AccountWebOrderView, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.getOrderData(this.props.webOrder.orderKey);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (!this.props.isFetching) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "summary-order-wrapper" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "order-summary-header-container" },
	                        _react2.default.createElement("i", { className: "cart-icon" }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "order-title" },
	                            (0, _translate.translate)("Web Order")
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "close-modal", onClick: this.props.onClose },
	                            "X"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "order-summary-container" },
	                        _react2.default.createElement(_OrderSummary2.default, { orderDate: (this.props.webOrder || {}).orderDate, hideRecurring: true })
	                    )
	                );
	            } else {
	                return _react2.default.createElement(_LoadingAnimation2.default, null);
	            }
	        }
	    }]);
	
	    return AccountWebOrderView;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isFetching: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOAD_ORDER_DATA)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        getOrderData: function getOrderData(orderKey) {
	            dispatch((0, _accountActions.getOrderData)(orderKey));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountWebOrderView);

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AccountPickupDirectionsPane = undefined;
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AccountMap = __webpack_require__(1110);
	
	var _AccountMap2 = _interopRequireDefault(_AccountMap);
	
	var _accountPickupDirectionsPane = __webpack_require__(1111);
	
	var _accountPickupDirectionsPane2 = _interopRequireDefault(_accountPickupDirectionsPane);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountPickupDirectionsPane = exports.AccountPickupDirectionsPane = function AccountPickupDirectionsPane(props) {
	    return _react2.default.createElement(
	        "div",
	        { className: "account-pickup-directions-container" },
	        props.clientViewPort.isXs ? _react2.default.createElement(
	            "div",
	            { className: "account-header-title-container" },
	            _react2.default.createElement(
	                "div",
	                { className: "account-header-title" },
	                (0, _translate.translate)("Pickup Directions")
	            )
	        ) : undefined,
	        _react2.default.createElement(
	            "div",
	            { className: "account-pickup-site-instructions-container" },
	            props.pickupSite.siteHosts && props.pickupSite.siteHosts.length > 0 ? _react2.default.createElement(
	                "div",
	                { className: "account-pick-site-host" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "account-pickup-site-directions-title" },
	                    (0, _translate.translate)("Site Host Contact Information")
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "account-pickup-site-directions-details" },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        props.pickupSite.siteHosts[0].firstName + " " + props.pickupSite.siteHosts[0].lastName
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        props.pickupSite.siteHosts[0].primaryPhone
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        props.pickupSite.siteHosts[0].email
	                    )
	                )
	            ) : _react2.default.createElement("div", { className: "account-pick-site-host-empty" }),
	            props.pickupSite.instructions || props.pickupSite.instructionsLink ? _react2.default.createElement(
	                "div",
	                { className: "account-pickup-site-directions" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "account-pickup-site-directions-title" },
	                    (0, _translate.translate)("Site Instructions")
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "account-pickup-site-directions-details" },
	                    props.pickupSite.instructions ? _react2.default.createElement(
	                        "div",
	                        null,
	                        props.pickupSite.instructions
	                    ) : undefined,
	                    props.pickupSite.instructionsLink ? _react2.default.createElement(
	                        "a",
	                        { className: "account-pickup-site-directions-more-info", href: props.pickupSite.instructionsLink,
	                            target: "_blank" },
	                        (0, _translate.translate)("More Info")
	                    ) : undefined
	                )
	            ) : undefined,
	            _react2.default.createElement(
	                "div",
	                { className: "account-pickup-site-directions" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "account-pickup-site-directions-title" },
	                    (0, _translate.translate)("Directions to Your Site")
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "account-pickup-site-directions-details" },
	                    props.pickupSite.directions ? _react2.default.createElement(
	                        "div",
	                        null,
	                        props.pickupSite.directions
	                    ) : undefined,
	                    props.pickupSite.directionsLink ? _react2.default.createElement(
	                        "a",
	                        { className: "account-pickup-site-directions-more-info", href: props.pickupSite.directionsLink,
	                            target: "_blank" },
	                        (0, _translate.translate)("More Info")
	                    ) : undefined
	                )
	            )
	        ),
	        _react2.default.createElement(_AccountMap2.default, { pickupSite: props.pickupSite, errorFetching: props.errorFetching })
	    );
	};

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleMaps = __webpack_require__(848);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _PickupSitesMap = __webpack_require__(1071);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountMap = function (_React$Component) {
	    _inherits(AccountMap, _React$Component);
	
	    function AccountMap() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AccountMap);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccountMap.__proto__ || Object.getPrototypeOf(AccountMap)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            center: {},
	            marker: {}
	        }, _this.handleMarkerClick = function (marker) {
	            marker.showInfo = true;
	            _this.setState({ marker: marker });
	        }, _this.handleMarkerClose = function (marker) {
	            marker.showInfo = false;
	            _this.setState({ marker: marker });
	        }, _this.renderInfoWindow = function (index, marker) {
	            var pickupSite = marker.pickupSite;
	            var deliveryDetails = pickupSite.deliveryDays + ', ' + pickupSite.deliveryHours;
	            return _react2.default.createElement(
	                _reactGoogleMaps.InfoWindow,
	                { key: pickupSite.key, onCloseClick: function onCloseClick() {
	                        return _this.handleMarkerClose(marker);
	                    } },
	                _react2.default.createElement(
	                    "div",
	                    { className: "account-pick-up-site-info-container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "account-pick-up-site-map-info-title" },
	                        pickupSite.title
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "pick-up-site-info-address" },
	                        pickupSite.shortAddress
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "pick-up-site-info-day-hour" },
	                        deliveryDetails
	                    )
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AccountMap, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            var pickupSite = this.props.pickupSite;
	            var lat = void 0;
	            var lng = void 0;
	            if (pickupSite.type === _constants.PickupSiteTypes.ZONE) {
	                lat = pickupSite.privateLat;
	                lng = pickupSite.privateLng;
	            } else {
	                lat = pickupSite.lat;
	                lng = pickupSite.lng;
	            }
	            var position = void 0;
	            try {
	                position = new google.maps.LatLng(lat, lng);
	            } catch (error) {
	                this.props.errorFetching(_constants.GOOGLE_UNDEFINED_ERROR_MESSAGE);
	                return;
	            }
	            var marker = {
	                position: position,
	                showInfo: true,
	                icon: _utils.PATH_IMAGES + "site-large.png",
	                title: pickupSite.title,
	                key: pickupSite.key,
	                pickupSite: pickupSite
	            };
	            this.setState({ marker: marker, center: marker.position });
	        }
	
	        //Toggle to 'true' to show InfoWindow and re-renders component
	
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_PickupSitesMap.PickupSitesMap, { containerElement: _react2.default.createElement("div", { className: "google-map-container" }),
	                mapElement: _react2.default.createElement("div", { style: { height: "100%" } }),
	                options: this.props.options,
	                center: this.state.center,
	                markers: [this.state.marker],
	                zoom: 14,
	                bounds: this.state.bounds,
	                handleMarkerClick: this.handleMarkerClick,
	                handleMarkerClose: this.handleMarkerClose,
	                renderInfoWindow: this.renderInfoWindow,
	                handleMapZoomChanged: function handleMapZoomChanged() {},
	                handleMapCenterChanged: function handleMapCenterChanged() {},
	                onMapMounted: function onMapMounted() {} });
	        }
	    }]);
	
	    return AccountMap;
	}(_react2.default.Component);
	
	exports.default = AccountMap;

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _constants = __webpack_require__(463);
	
	var _utils = __webpack_require__(485);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountSummaryManagePayments = (0, _createReactClass2.default)({
	    displayName: "AccountSummaryManagePayments",
	    onManage: function onManage() {
	        var url = (0, _utils.redirectPage)(_constants.URLs.PAY, this.props.staticData) + "?source=account";
	        if (this.props.isPreview && this.props.memberKey) url += "&mode=preview&m=" + this.props.memberKey;
	        window.location.assign(url);
	    },
	    allowManagePayments: function allowManagePayments() {
	        return this.props.mode === _constants.AccountModes.VIEW && (this.props.singlePaymentPlans || {}).length > 0 && this.props.singlePaymentMethods && this.props.singlePaymentMethods.length > 0 || !this.props.hasToken && this.props.autoPaymentMethods && this.props.autoPaymentMethods.length > 0 && (this.props.autoPaymentPlans || {}).length > 0 || this.props.hasToken && this.props.autoPaymentMethods && this.props.autoPaymentMethods.length > 0;
	    },
	    render: function render() {
	        var label = this.props.clientViewPort.isXs ? (0, _translate.translate)("Payments") : (0, _translate.translate)("Manage Payments");
	        return _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: "primary", className: "manage-payments-btn button", onClick: this.onManage },
	            label
	        );
	    }
	});
	
	var mapStateToProps = function mapStateToProps(state) {
	    var account = state.account || {};
	    var subscriptionSummary = state.summary || {};
	    return {
	        clientViewPort: state.clientViewPort || {},
	        mode: account.mode,
	        isPreview: (state.staticData || {}).isPreview,
	        memberKey: (state.memberDetails || {}).key,
	        staticData: state.staticData,
	        singlePaymentPlans: subscriptionSummary.singlePaymentPlans,
	        autoPaymentPlans: subscriptionSummary.autoPaymentPlans,
	        singlePaymentMethods: subscriptionSummary.singlePaymentMethods,
	        autoPaymentMethods: subscriptionSummary.autoPaymentMethods
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(AccountSummaryManagePayments);

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _constants = __webpack_require__(463);
	
	var _accountActions = __webpack_require__(1089);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _commonActions = __webpack_require__(747);
	
	var _AccountNavigationHeader = __webpack_require__(1114);
	
	var _AccountNavigationHeader2 = _interopRequireDefault(_AccountNavigationHeader);
	
	var _PickupSiteSelection = __webpack_require__(841);
	
	var _PickupSiteSelection2 = _interopRequireDefault(_PickupSiteSelection);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _LoadingAnimation = __webpack_require__(834);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _utils = __webpack_require__(485);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _memberDetailsActions = __webpack_require__(751);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountChangePickupSite = (0, _createReactClass2.default)({
	    displayName: 'AccountChangePickupSite',
	    getInitialState: function getInitialState() {
	        return {
	            buttons: {
	                left: {
	                    label: (0, _translate.translate)("CANCEL"),
	                    onClick: this.onCancel
	                },
	                right: {
	                    label: (0, _translate.translate)("SAVE"),
	                    onClick: this.onSave,
	                    disabled: true
	                }
	            },
	            oldPickupSite: this.props.pickupSite,
	            oldWaitListSite: this.props.waitListSite,
	            oldNextDeliveryDateActual: this.props.nextDeliveryDateActual
	        };
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            showAddressValidationMessage: false
	        };
	    },
	    componentWillMount: function componentWillMount() {
	        this.props.getPickupSiteAvailableForChange();
	    },
	    onCancel: function onCancel() {
	        this.props.checkIsDirty(!this.props.isPreview, function () {
	            this.props.cancel(this.state.oldPickupSite, this.state.oldWaitListSite, this.state.oldNextDeliveryDateActual);
	        }.bind(this));
	    },
	    onSave: function onSave() {
	        var _this = this;
	
	        if (this.props.pickupSite.type === _constants.PickupSiteTypes.ZONE || this.props.pickupSite === _constants.PickupSiteTypes.HOME) {
	            var member = this.props.memberDetails;
	            var address = member.addressLine1 + " " + member.city + " " + member.state + " " + member.zipCode;
	            (0, _utils.geocodeAddress)(address).then(function (geoCode) {
	                if (geoCode.lat) {
	                    if (!_this.props.memberDetails.lat || !_this.props.memberDetails.lng) {
	                        _this.props.updateMemberLatLng(geoCode.lat, geoCode.lng);
	                    }
	                    _this.props.save(_this.props.pickupSite, _this.props.waitListSite);
	                } else {
	                    _this.props.setShowAddressValidationMessage(_constants.INVALID_ADDRESS_HOME_DELIVERY);
	                }
	            });
	        } else {
	            this.props.save(this.props.pickupSite, this.props.waitListSite);
	        }
	    },
	    closeModal: function closeModal() {
	        this.props.setShowAddressValidationMessage(undefined);
	    },
	    getValidateAddressModal: function getValidateAddressModal() {
	        if (this.props.showAddressValidationMessage) {
	            return _react2.default.createElement(_ModalPopup2.default, {
	                onClose: this.closeModal,
	                message: this.props.showAddressValidationMessage,
	                middle: { text: 'Close', callback: this.closeModal } });
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.pickupSite.key && (this.props.pickupSite.key != nextProps.pickupSite.key || nextProps.waitListSite.key && this.props.waitListSite.key != nextProps.waitListSite.key) || !(0, _utils.isEmptyObj)(this.props.waitListSite) && (0, _utils.isEmptyObj)(nextProps.waitListSite.key)) {
	            var buttons = Object.assign({}, this.state.buttons);
	            buttons.right.disabled = this.props.isPreview;
	            this.setState({ buttons: buttons });
	        }
	        if (!this.props.isSaving && nextProps.isSaving || this.props.isSaving && !nextProps.isSaving) {
	            var _buttons = Object.assign({}, this.state.buttons);
	            _buttons.right.className = nextProps.isSaving ? " loading" : "";
	            this.setState({ buttons: _buttons });
	        }
	    },
	    render: function render() {
	        if (this.props.isFetching) {
	            return _react2.default.createElement(_LoadingAnimation2.default, null);
	        }
	        var pickupSiteLabel = (0, _utils.isEmptyString)(this.props.pickupSiteLabel) || this.props.pickupSiteLabel === 'null' ? (0, _translate.translate)("Pick-up site") : this.props.pickupSiteLabel;
	        return _react2.default.createElement(
	            'fieldset',
	            { disabled: this.props.isSaving },
	            _react2.default.createElement(_AccountNavigationHeader2.default, { buttons: this.state.buttons, title: (0, _translate.translate)("Change") + " " + pickupSiteLabel }),
	            _react2.default.createElement(_PickupSiteSelection2.default, { flowType: _constants.URLs.ACCOUNT }),
	            this.getValidateAddressModal()
	        );
	    }
	});
	
	var mapStateToProps = function mapStateToProps(state) {
	    var summary = state.summary || {};
	    return {
	        pickupSiteLabel: state.staticData.pickupSiteLabel,
	        pickupSite: summary.pickupSite || {},
	        waitListSite: summary.waitListSite || {},
	        nextDeliveryDateActual: summary.nextDeliveryDate,
	        isFetching: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOAD_SIGNUP_DATA),
	        isSaving: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.UPDATE_PICKUP_SITE),
	        isPreview: (state.staticData || {}).isPreview,
	        memberDetails: state.memberDetails,
	        showAddressValidationMessage: state.account.showAddressValidationMessage
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        checkIsDirty: function checkIsDirty(check, onLeaveCallBack) {
	            if (check) dispatch((0, _commonActions.checkIsDirty)(onLeaveCallBack));else onLeaveCallBack();
	        },
	        cancel: function cancel(pickupSite, waitListSite, nextDeliveryDate) {
	            dispatch((0, _subscriptionSummaryActions.setPickupSitesAndDeliveryDate)(nextDeliveryDate, pickupSite, waitListSite));
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _accountActions.setAccountMode)(_constants.AccountModes.VIEW));
	        },
	        getPickupSiteAvailableForChange: function getPickupSiteAvailableForChange() {
	            dispatch((0, _accountActions.getPickupSiteAvailableForChange)());
	        },
	        save: function save(pickupSite, waitListSite) {
	            dispatch((0, _accountActions.updatePickupSite)(pickupSite, waitListSite));
	        },
	        updateMemberLatLng: function updateMemberLatLng(lat, lng) {
	            dispatch((0, _memberDetailsActions.setLatLng)(lat, lng));
	            dispatch((0, _memberDetailsActions.updateMemberLatLng)(lat, lng));
	        },
	        setShowAddressValidationMessage: function setShowAddressValidationMessage(showAddressValidationMessage) {
	            dispatch((0, _accountActions.setShowAddressValidationMessage)(showAddressValidationMessage));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountChangePickupSite);

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	var _accountNavigationHeader = __webpack_require__(1115);
	
	var _accountNavigationHeader2 = _interopRequireDefault(_accountNavigationHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountNavigationHeader = function (_React$Component) {
	    _inherits(AccountNavigationHeader, _React$Component);
	
	    function AccountNavigationHeader() {
	        _classCallCheck(this, AccountNavigationHeader);
	
	        return _possibleConstructorReturn(this, (AccountNavigationHeader.__proto__ || Object.getPrototypeOf(AccountNavigationHeader)).apply(this, arguments));
	    }
	
	    _createClass(AccountNavigationHeader, [{
	        key: "render",
	        value: function render() {
	            var buttons = this.props.buttons;
	            var left = buttons.left;
	            var right = buttons.right;
	            return _react2.default.createElement(
	                "div",
	                { className: "account-navigation-header" + (this.props.fullWidth ? " full-width" : "") },
	                _react2.default.createElement(
	                    "div",
	                    { className: "title" },
	                    (0, _translate.translate)(this.props.title)
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "navigation-buttons" },
	                    left && !left.invisible ? _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: "primary", className: "button " + left.className, onClick: left.onClick, disabled: left.disabled },
	                        (0, _translate.translate)(left.label)
	                    ) : undefined,
	                    right && !right.invisible ? _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: "primary", className: "button " + right.className, onClick: right.onClick, disabled: right.disabled },
	                        (0, _translate.translate)(right.label)
	                    ) : undefined
	                )
	            );
	        }
	    }]);
	
	    return AccountNavigationHeader;
	}(_react2.default.Component);
	
	exports.default = AccountNavigationHeader;

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _constants = __webpack_require__(463);
	
	var _accountActions = __webpack_require__(1089);
	
	var _joinActions = __webpack_require__(752);
	
	var _basket = __webpack_require__(757);
	
	var _commonActions = __webpack_require__(747);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _AccountNavigationHeader = __webpack_require__(1114);
	
	var _AccountNavigationHeader2 = _interopRequireDefault(_AccountNavigationHeader);
	
	var _SelectionTabs = __webpack_require__(842);
	
	var _SelectionTabs2 = _interopRequireDefault(_SelectionTabs);
	
	var _SelectionPane = __webpack_require__(844);
	
	var _SelectionPane2 = _interopRequireDefault(_SelectionPane);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _JoinSharesOptionsStep = __webpack_require__(1075);
	
	var _JoinSharesOptionsStep2 = _interopRequireDefault(_JoinSharesOptionsStep);
	
	var _LoadingAnimation = __webpack_require__(834);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _translate = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountChangeSubscription = (0, _createReactClass2.default)({
	    displayName: 'AccountChangeSubscription',
	    getInitialState: function getInitialState() {
	        this.nextDeliveryDate = this.props.nextDeliveryDate;
	        return {
	            showNoSharesDialog: false,
	            closeScheduledDistributionInProcessDialog: false
	        };
	    },
	    componentWillMount: function componentWillMount() {
	        if (this.props.shouldReloadData) this.props.getSignupData();
	    },
	    onCancel: function onCancel() {
	        this.props.checkIsDirty(!this.props.isPreview, function () {
	            this.props.cancel();
	        }.bind(this));
	    },
	    onSave: function onSave() {
	        if (this.props.activeWebOrderKey && this.props.nextDeliveryDate !== this.nextDeliveryDate) {
	            this.setState({ showScheduledDistributionInProcessDialog: true });
	            return;
	        }
	        if (this.props.allowChangeFreeOptions) {
	            var selectedOptions = (0, _basket.getJoinSelectedItems)(this.props.sharesData.options, {});
	            var freeItems = selectedOptions.items.filter(function (item) {
	                return item.price === 0;
	            });
	            if (freeItems.length > 1) {
	                this.props.setInvalidOptionSchedulesDialog("You cannot select more than one free item.");
	                return;
	            }
	        }
	        if (this.props.syncOptionSchedules) {
	            var storeAccessShare = this.props.summary.seasons && this.props.summary.seasons[0].storeAccessShare;
	            var message = (0, _joinActions.isValidOptionScheduleMessage)(this.props.sharesData, this.props.signupData.schedules, storeAccessShare);
	            if (message) {
	                this.props.setInvalidOptionSchedulesDialog(message);
	                return;
	            }
	        }
	        var currentShares = (0, _basket.getJoinSelectedItems)(this.props.summary.shareItems, {});
	        var selectedShares = (0, _basket.getJoinSelectedItems)(this.props.sharesData.shares, {});
	        var currentCredits = currentShares.items.reduce(function (sum, item) {
	            return sum + (item.unit === 'credits' ? item.quantity * item.unitQuantity : 0);
	        }, 0);
	        var selectedCredits = selectedShares.items.reduce(function (sum, item) {
	            return sum + (item.unit === 'credits' ? item.quantity * item.unitQuantity : 0);
	        }, 0);
	        if (selectedCredits < currentCredits && this.props.activeWebOrderKey) {
	            this.props.setInvalidOptionSchedulesDialog('You can’t change subscription to smaller size while having a web order in place. Please contact the farm admin for further assistance.');
	            return;
	        }
	        if (selectedShares.items.length > 0) {
	            this.props.save();
	        } else {
	            this.setState({ showNoSharesDialog: true });
	        }
	    },
	    closeDialog: function closeDialog() {
	        this.setState({ showNoSharesDialog: false });
	    },
	    closeScheduledDistributionInProcessDialog: function closeScheduledDistributionInProcessDialog() {
	        this.setState({ showScheduledDistributionInProcessDialog: false });
	    },
	    getButtons: function getButtons(allowSave) {
	        return {
	            left: {
	                label: (0, _translate.translate)("CANCEL"),
	                onClick: this.onCancel
	            },
	            right: {
	                label: (0, _translate.translate)("SAVE"),
	                onClick: this.onSave,
	                disabled: !allowSave || this.props.isPreview,
	                className: this.props.isUpdating ? " loading" : ""
	            }
	        };
	    },
	    renderScreen: function renderScreen() {
	        if (this.props.allowChangeFreeOptions) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'account-change-subscription-no-tabs' },
	                _react2.default.createElement(_JoinSharesOptionsStep2.default, { step: _constants.JoinSteps.OPTIONS, flow: _constants.JoinModes.CHANGE })
	            );
	        }
	        if (!this.props.hasOptions) return _react2.default.createElement(
	            'div',
	            { className: 'account-change-subscription-no-tabs' },
	            _react2.default.createElement(_JoinSharesOptionsStep2.default, { step: _constants.JoinSteps.SHARES, flow: _constants.JoinModes.CHANGE })
	        );
	        if (this.props.clientViewPort.isXs) return _react2.default.createElement(
	            _reactBootstrap.Tabs,
	            { defaultEventKey: 'shares', className: 'account-change-subscription-tabs' },
	            _react2.default.createElement(
	                _reactBootstrap.Tab,
	                { title: (0, _translate.translate)("Shares"), eventKey: 'shares' },
	                _react2.default.createElement(_JoinSharesOptionsStep2.default, { step: _constants.JoinSteps.SHARES, flow: _constants.JoinModes.CHANGE })
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Tab,
	                { title: 'Options', eventKey: 'options' },
	                _react2.default.createElement(_JoinSharesOptionsStep2.default, { step: _constants.JoinSteps.OPTIONS, flow: _constants.JoinModes.CHANGE })
	            )
	        );
	        return _react2.default.createElement(
	            _SelectionTabs2.default,
	            { disableCheckDirty: true },
	            _react2.default.createElement(
	                _SelectionPane2.default,
	                { label: (0, _translate.translate)("Shares"), styleClass: 'tabs-line-separator' },
	                _react2.default.createElement(_JoinSharesOptionsStep2.default, { step: _constants.JoinSteps.SHARES, flow: _constants.JoinModes.CHANGE })
	            ),
	            _react2.default.createElement(
	                _SelectionPane2.default,
	                { label: 'Options', styleClass: 'tabs-line-separator' },
	                _react2.default.createElement(_JoinSharesOptionsStep2.default, { step: _constants.JoinSteps.OPTIONS, flow: _constants.JoinModes.CHANGE })
	            )
	        );
	    },
	    closeInvalidOptionSchedulesDialog: function closeInvalidOptionSchedulesDialog() {
	        this.props.setInvalidOptionSchedulesDialog(undefined);
	    },
	    render: function render() {
	        if (this.props.isFetching) {
	            return _react2.default.createElement(_LoadingAnimation2.default, null);
	        }
	        var buttons = this.getButtons(this.props.isChanged);
	
	        return _react2.default.createElement(
	            'fieldset',
	            { disabled: this.props.isUpdating },
	            _react2.default.createElement(_AccountNavigationHeader2.default, { buttons: buttons, title: this.props.allowChangeFreeOptions ? (0, _translate.translate)("Select Free Item") : (0, _translate.translate)("Change Subscription") }),
	            this.renderScreen(),
	            this.props.mode == _constants.AccountModes.CHANGE_SUBSCRIPTION_THANKYOU ? _react2.default.createElement(_ModalPopup2.default, {
	                title: '_thankYouChangeSubscriptionTitle',
	                message: '_thankYouChangeSubscriptionBody',
	                middle: { text: 'Close', callback: this.props.backFromThankYou } }) : undefined,
	            this.state.showNoSharesDialog ? _react2.default.createElement(_ModalPopup2.default, {
	                title: 'selectShare',
	                middle: { text: 'Continue', callback: this.closeDialog } }) : undefined,
	            this.state.showScheduledDistributionInProcessDialog ? _react2.default.createElement(_ModalPopup2.default, {
	                message: (0, _translate.translate)("_ScheduledDistributionInProcess"),
	                middle: { text: 'Close', callback: this.closeScheduledDistributionInProcessDialog } }) : undefined,
	            this.props.invalidOptionScheduleMessage ? _react2.default.createElement(_ModalPopup2.default, {
	                message: this.props.invalidOptionScheduleMessage,
	                middle: { text: 'Close', callback: this.closeInvalidOptionSchedulesDialog } }) : undefined
	        );
	    }
	});
	
	var mapStateToProps = function mapStateToProps(state) {
	    var summary = state.summary || {};
	    var signupData = state.signupData || {};
	    var nextDeliveryDate = void 0;
	    var selectedItems = signupData.sharesData ? (0, _basket.getJoinSelectedItems)(signupData.sharesData.shares, signupData.sharesData.options) : {};
	    var items = selectedItems.items;
	    var schedules = signupData.schedules || {};
	    var nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
	    if (nextDeliveryDates) {
	        nextDeliveryDate = (0, _basket.getNextDeliveryDate)(summary.pickupSite, items, schedules, nextDeliveryDates);
	    } else {
	        nextDeliveryDate = summary.nextDeliveryDate;
	    }
	
	    return {
	        clientViewPort: state.clientViewPort || {},
	        mode: state.account.mode,
	        isFetching: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOAD_SIGNUP_DATA) || (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.LOAD_SIGNUP_SHARES),
	        isPreview: (state.staticData || {}).isPreview,
	        shouldReloadData: !signupData.data,
	        deliveryDay: (summary.pickupSite || {}).deliveryDays,
	        isChanged: state.orderStatus.isChanged,
	        hasOptions: (signupData.data || {}).hasOptions,
	        sharesData: signupData.sharesData,
	        isUpdating: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.CHANGE_SUBSCRIPTION),
	        nextDeliveryDate: nextDeliveryDate,
	        activeWebOrderKey: summary.activeWebOrderKey,
	        summary: summary,
	        syncOptionSchedules: state.staticData.syncOptionSchedules,
	        invalidOptionScheduleMessage: signupData.invalidOptionScheduleMessage,
	        signupData: signupData,
	        allowChangeFreeOptions: state.staticData.allowChangeFreeOptions
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        checkIsDirty: function checkIsDirty(check, onLeaveCallBack) {
	            if (check) dispatch((0, _commonActions.checkIsDirty)(onLeaveCallBack));else onLeaveCallBack();
	        },
	        getSignupData: function getSignupData() {
	            dispatch((0, _joinActions.getSignupData)(_constants.JoinModes.CHANGE));
	        },
	        cancel: function cancel() {
	            dispatch((0, _joinActions.clearSignupData)());
	            dispatch((0, _commonActions.setDirty)(false));
	            dispatch((0, _accountActions.setAccountMode)(_constants.AccountModes.VIEW));
	        },
	        save: function save() {
	            dispatch((0, _accountActions.changeSubscription)());
	            dispatch((0, _commonActions.setDirty)(false));
	        },
	        backFromThankYou: function backFromThankYou() {
	            window.location.reload();
	        },
	        setInvalidOptionSchedulesDialog: function setInvalidOptionSchedulesDialog(message) {
	            dispatch((0, _joinActions.setInvalidOptionSchedulesMessage)(message));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountChangeSubscription);

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _reactBootstrapDatePicker = __webpack_require__(1118);
	
	var _reactBootstrapDatePicker2 = _interopRequireDefault(_reactBootstrapDatePicker);
	
	var _constants = __webpack_require__(463);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _utils = __webpack_require__(485);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _commonActions = __webpack_require__(747);
	
	var _accountActions = __webpack_require__(1089);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _translate = __webpack_require__(464);
	
	var _accountDeliveryHoldPane = __webpack_require__(1119);
	
	var _accountDeliveryHoldPane2 = _interopRequireDefault(_accountDeliveryHoldPane);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountDeliveryHoldPane = function (_React$Component) {
	    _inherits(AccountDeliveryHoldPane, _React$Component);
	
	    function AccountDeliveryHoldPane() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AccountDeliveryHoldPane);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccountDeliveryHoldPane.__proto__ || Object.getPrototypeOf(AccountDeliveryHoldPane)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            vacationStart: _this.props.vacationStart || [],
	            vacationEnd: _this.props.vacationEnd || [],
	            updatePermanentHold: false,
	            initIsSetPermanentHold: _this.props.staticData.allowChangePermanentHold ? _this.props.isSetOnPermanentHold : undefined,
	            requiredMakeUpData: _this.props.requiredMakeUpData
	        }, _this.saveClicked = function () {
	            if (_this.state.updatePermanentHold) {
	                _this.props.setSubscriptionOnPermanentHold();
	            } else {
	                var makeUpSchedules = [],
	                    makeUpDates = [];
	                if (_this.state.requiredMakeUpData) {
	                    _this.state.requiredMakeUpData.forEach(function (makeUpData) {
	                        makeUpSchedules.push(makeUpData.schedule);
	                        makeUpDates.push(makeUpData.date);
	                    });
	                }
	                _this.props.updateVacations(_this.state.vacationStart, _this.state.vacationEnd, makeUpSchedules.length > 0 ? makeUpSchedules : undefined, makeUpDates.length > 0 ? makeUpDates : undefined);
	            }
	            _this.props.setDirty(false);
	            _this.props.setCanSaveDeliveryHold(false);
	        }, _this.isDateOnHoldPeriodCannotBeApplied = function (date, startVacation, endVacation) {
	            if (date) {
	                for (var i = 0; i < startVacation.length; i++) {
	                    if (startVacation[i].localeCompare(date) <= 0 && endVacation[i].localeCompare(date) >= 0) {
	                        return true;
	                    }
	                }
	            }
	        }, _this.isCancelWebOrder = function (vacationStart, vacationEnd) {
	            return _this.props.activeWebOrderKey && vacationStart <= _this.props.nextDeliveryDate && vacationEnd >= _this.props.nextDeliveryDate;
	        }, _this.validateEnableSaving = function (vacationStart, vacationEnd, isRemoved, validateMakeUp) {
	            _this.props.setOnPermanentHold(false);
	            var today = (0, _utils.formatToServerDate)(new Date());
	            if ((_this.props.vacationStart === undefined && vacationStart.length === 0 || _this.props.vacationEnd === undefined && vacationEnd.length === 0 || vacationStart.length !== vacationEnd.length) && !isRemoved) {
	                _this.props.setCanSaveDeliveryHold(false);
	                _this.props.setDirty(true);
	                _this.setState({ vacationStart: vacationStart, vacationEnd: vacationEnd, errorMessage: undefined });
	                return;
	            }
	            var errorMessage = void 0;
	            var canSave = true;
	            for (var index = 0; index < vacationStart.length; index++) {
	                var currentVacationStart = vacationStart[index];
	                var currentVacationEnd = vacationEnd[index];
	                if ((!currentVacationStart || !currentVacationEnd) && (currentVacationStart && (0, _utils.isEmptyString)(currentVacationEnd) || (0, _utils.isEmptyString)(currentVacationStart) && currentVacationEnd)) {
	                    canSave = false;
	                    break;
	                }
	                if (currentVacationStart > currentVacationEnd) {
	                    canSave = false;
	                    errorMessage = constants.DELIVERY_HOLD_DATES_END_BEFORE_START_DATE_ERROR;
	                    break;
	                } else if (currentVacationEnd < today || currentVacationStart < today && _this.props.vacationStart !== undefined && !_this.props.vacationStart.includes(currentVacationStart)) {
	                    canSave = false;
	                    errorMessage = constants.DELIVERY_HOLD_DATES_IN_PAST_ERROR;
	                    break;
	                } else if (_this.isDateOnHoldPeriodCannotBeApplied(_this.props.farmStoreClosedEndDate, vacationStart, vacationEnd)) {
	                    canSave = false;
	                    errorMessage = constants.DELIVERY_HOLD_DATES_VACATION_CANNOT_BE_APPLIED + (0, _utils.getUsefulDate)(_this.props.farmStoreClosedEndDate) + ".";
	                    break;
	                } else if (vacationStart.length > 0 && vacationEnd.length > 0) {
	                    for (var i = 0; i < vacationStart.length; i++) {
	                        var periodValueStart = currentVacationStart;
	                        var periodValueEnd = currentVacationEnd;
	                        if (i !== index) {
	                            var otherPeriodValueStart = vacationStart.length >= i ? vacationStart[i] : null;
	                            var otherPeriodValueEnd = vacationEnd.length >= i ? vacationEnd[i] : null;
	                            if (!otherPeriodValueEnd && !otherPeriodValueStart) {
	                                continue;
	                            }
	                            if (periodValueStart <= otherPeriodValueStart && otherPeriodValueStart <= periodValueEnd || periodValueStart <= otherPeriodValueEnd && otherPeriodValueEnd <= periodValueEnd) {
	                                canSave = false;
	                                errorMessage = constants.DELIVERY_HOLD_OVERLAP_ERROR;
	                                break;
	                            }
	                        }
	                    }
	                }
	                if (canSave && _this.isCancelWebOrder(currentVacationStart, currentVacationEnd)) {
	                    if (_this.props.staticData.storePaymentMethods.includes(constants.PaymentMethod.BALANCE.key) || _this.props.staticData.storePaymentMethods.includes(constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key) || _this.props.staticData.storePaymentMethods.includes(constants.PaymentMethod.PAYPAL_PREAPPROVE.key) || _this.props.staticData.storePaymentMethods.includes(constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key)) {
	                        _this.setState({ showCancelOrderMessageRemoveIndex: index });
	                    } else {
	                        _this.setState({ showCancelOrderMessageNoBalanceRemoveIndex: index });
	                    }
	                }
	            }
	            if (_this.state.requiredMakeUpData && validateMakeUp) {
	                var missingDate = _this.state.requiredMakeUpData.find(function (makeUpData) {
	                    return !makeUpData.date;
	                });
	                canSave = canSave && !missingDate;
	            }
	            _this.props.setDirty(true);
	            _this.props.setCanSaveDeliveryHold(canSave);
	            if (_this.props.staticData.allowChangePermanentHold) {
	                _this.props.setOnPermanentHold(false);
	            }
	            _this.setState({ vacationStart: vacationStart, vacationEnd: vacationEnd, errorMessage: errorMessage });
	        }, _this.validateDeletion = function (vacations) {
	            if (vacations) {
	                for (var index = 0; index < vacations.length; index++) {
	                    if (_this.isDateOnHoldPeriodCannotBeApplied(_this.props.farmStoreClosedEndDate, _this.props.vacationStart, _this.props.vacationEnd)) {
	                        _this.props.setCanSaveDeliveryHold(false);
	                        _this.setState({
	                            vacationStart: _this.props.vacationStart, vacationEnd: _this.props.vacationEnd,
	                            errorMessage: constants.DELIVERY_HOLD_DATES_VACATION_CANNOT_BE_APPLIED + (0, _utils.getUsefulDate)(_this.props.farmStoreClosedEndDate) + "."
	                        });
	                        return false;
	                    }
	                }
	            }
	            return true;
	        }, _this.onRemoveButtonClick = function (index) {
	            var vacationStart = _this.state.vacationStart.slice();
	            var vacationEnd = _this.state.vacationEnd.slice();
	            vacationStart.splice(index, 1);
	            vacationEnd.splice(index, 1);
	            _this.clearMakeUpData();
	            if (_this.validateDeletion(_this.props.vacationStart)) {
	                _this.validateEnableSaving(vacationStart, vacationEnd, true);
	            }
	        }, _this.handleFromChangeMobile = function (index, event) {
	            _this.handleFromChange(index, event.target.value);
	        }, _this.handleFromChange = function (index, value) {
	            var vacationStart = _this.state.vacationStart.slice();
	            if ((0, _utils.isEmptyString)(value)) {
	                vacationStart.splice(index, 1);
	            } else {
	                var val = value.split("T")[0];
	                if (vacationStart.length >= index) {
	                    vacationStart[index] = val;
	                } else {
	                    vacationStart.push(val);
	                }
	            }
	            _this.clearMakeUpData();
	            if (_this.validateDeletion(_this.props.vacationStart)) {
	                _this.validateEnableSaving(vacationStart, _this.state.vacationEnd);
	            }
	        }, _this.handleToChangeMobile = function (index, event) {
	            _this.handleToChange(index, event.target.value);
	        }, _this.handleToChange = function (index, value) {
	            var vacationEnd = _this.state.vacationEnd.slice();
	            if ((0, _utils.isEmptyString)(value)) {
	                vacationEnd.splice(index, 1);
	            } else {
	                var val = value.split("T")[0];
	                if (vacationEnd.length >= index) {
	                    vacationEnd[index] = val;
	                } else {
	                    vacationEnd.push(val);
	                }
	            }
	            _this.clearMakeUpData();
	            if (_this.validateDeletion(_this.props.vacationEnd)) {
	                _this.validateEnableSaving(_this.state.vacationStart, vacationEnd);
	            }
	        }, _this.clearMakeUpData = function () {
	            _this.setState({ requiredMakeUpData: undefined });
	        }, _this.getDatePicker = function (vacationArray, index, onChangeFunction, onChangeMobileFunction) {
	            if (!_this.props.clientViewPort.isXs) {
	                return _react2.default.createElement(_reactBootstrapDatePicker2.default, { placeholder: " ", key: "from_" + index,
	                    weekStartsOn: 0,
	                    disabled: _this.props.isFetching || _this.props.isSetOnPermanentHold,
	                    value: vacationArray,
	                    onChange: onChangeFunction.bind(_this, index),
	                    clearButtonElement: "x",
	                    showTodayButton: true,
	                    showClearButton: false,
	                    calendarPlacement: "top" });
	            } else {
	                return _react2.default.createElement("input", { type: "date", name: "from", onChange: onChangeMobileFunction.bind(_this, index),
	                    className: "account-delivery-hold-date-picker-from-mobile",
	                    disabled: _this.props.isFetching, value: vacationArray });
	            }
	        }, _this.getDeliveryHold = function (index) {
	            var vacationStart = "";
	            var vacationEnd = "";
	            if (_this.state.vacationStart.length >= index) {
	                if (_this.state.vacationStart[index]) {
	                    vacationStart = _this.state.vacationStart[index];
	                }
	            }
	            if (_this.state.vacationEnd.length >= index) {
	                if (_this.state.vacationEnd[index]) {
	                    vacationEnd = _this.state.vacationEnd[index];
	                }
	            }
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: "account-delivery-hold-date-picker-row", key: index },
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 1, xs: 1, className: "account-delivery-hold-date-from-label" },
	                    (0, _translate.translate)("From")
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 3, xs: 5, className: "account-delivery-hold-date-picker-from" },
	                    _this.getDatePicker(vacationStart, index, _this.handleFromChange, _this.handleFromChangeMobile)
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 1, xs: 1, className: "account-delivery-hold-date-to-label" },
	                    (0, _translate.translate)("To")
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 3, xs: 4, className: "account-delivery-hold-date-picker-to" },
	                    _this.getDatePicker(vacationEnd, index, _this.handleToChange, _this.handleToChangeMobile)
	                ),
	                (_this.state.vacationStart || {}).length >= index && _this.state.vacationStart[index] && _this.state.vacationEnd[index] ? _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 1, xs: 1 },
	                    _react2.default.createElement("div", { className: "delivery-hold-remove",
	                        name: "btnDeliveryHoldRemove",
	                        disabled: _this.props.isFetching,
	                        onClick: _this.onRemoveButtonClick.bind(_this, index) })
	                ) : undefined
	            );
	        }, _this.getDatesSelections = function () {
	            var deliveryHolds = [];
	            for (var index = 0; index < 3; index++) {
	                deliveryHolds.push(_this.getDeliveryHold(index));
	            }
	            return _react2.default.createElement(
	                "div",
	                { className: "account-delivery-hold-inner-container" },
	                deliveryHolds
	            );
	        }, _this.clearPartialDates = function () {
	            var vacationStart = _this.state.vacationStart;
	            var vacationEnd = _this.state.vacationEnd;
	            var update = false;
	            for (var i = vacationStart.length - 1; i > 0; i--) {
	                if (vacationStart[i] && !vacationEnd[i] || !vacationStart[i] && vacationEnd[i]) {
	                    vacationStart.splice(i, 1);
	                    vacationEnd.splice(i, 1);
	                    update = true;
	                }
	            }
	            if (update) _this.setState({ vacationStart: vacationStart, vacationEnd: vacationEnd });
	        }, _this.setOnPermanentHold = function (val) {
	            _this.props.setOnPermanentHold(val.target.checked);
	            var today = (0, _utils.formatToServerDate)(new Date());
	            if (_this.props.farmStoreClosedEndDate && today.localeCompare(_this.props.farmStoreClosedEndDate) <= 0) {
	                var errorMessage = (0, _translate.translate)("cantUpdatePermanentHold").replace("{0}", (0, _utils.getUsefulDate)(_this.props.farmStoreClosedEndDate) + ".");
	                if (val.target.checked === _this.state.initIsSetPermanentHold) {
	                    errorMessage = undefined;
	                }
	                _this.setState({
	                    errorMessage: errorMessage,
	                    updatePermanentHold: false
	                });
	                return;
	            }
	            if (val.target.checked && _this.props.activeWebOrderKey) {
	                if (_this.props.staticData.storePaymentMethods.includes(constants.PaymentMethod.BALANCE.key)) {
	                    _this.setState({ showCancelOrderMessageRemoveIndex: 0 });
	                } else {
	                    _this.setState({ showCancelOrderMessageNoBalanceRemoveIndex: 0 });
	                }
	                return;
	            }
	            _this.props.setDirty(true);
	            var updatePermanentHold = val.target.checked && _this.props.holdReason !== _constants.SubscriptionHoldReason.ADMIN || !val.target.checked && _this.props.holdReason === _constants.SubscriptionHoldReason.ADMIN;
	            _this.props.setCanSaveDeliveryHold(updatePermanentHold);
	            _this.setState({ updatePermanentHold: updatePermanentHold, errorMessage: undefined });
	        }, _this.sendCancelSubscriptionRequest = function () {
	            _this.props.sendCancelSubscriptionRequest();
	        }, _this.getSetPermanentHold = function () {
	            if (_this.props.staticData.allowChangePermanentHold) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: "account-delivery-hold-date-picker-row" },
	                    _react2.default.createElement(
	                        _reactBootstrap.Checkbox,
	                        { className: "account-delivery-hold-date-from-cb",
	                            checked: _this.props.isSetOnPermanentHold,
	                            onChange: _this.setOnPermanentHold,
	                            ref: "isSetOnPermanentHold" },
	                        (0, _translate.translate)("_setSubscriptionOnPermanentHold")
	                    )
	                );
	            }
	        }, _this.deleteDateOnPopupMessage = function () {
	            _this.onRemoveButtonClick(_this.state.showCancelOrderMessageRemoveIndex);
	            _this.setState({ showCancelOrderMessageRemoveIndex: undefined });
	        }, _this.deleteDateNoBalanceOnPopupMessage = function () {
	            _this.onRemoveButtonClick(_this.state.showCancelOrderMessageNoBalanceRemoveIndex);
	            _this.setState({ showCancelOrderMessageNoBalanceRemoveIndex: undefined });
	        }, _this.deleteOrder = function () {
	            if (_this.state.deleteOrderInProgress) return;
	            _this.setState({ deleteOrderInProgress: true });
	            _this.props.deleteOrderAndUpdateVacation(_this.state.vacationStart, _this.state.vacationEnd);
	            _this.clearPartialDates();
	            var that = _this;
	            setTimeout(function () {
	                that.setState({ showCancelOrderMessageRemoveIndex: undefined, deleteOrderInProgress: false });
	            }, 1000);
	        }, _this.setRequiredMakeUpScheduleDate = function (index, date) {
	            var requiredMakeUpData = _this.state.requiredMakeUpData;
	            requiredMakeUpData[index].date = date;
	            _this.setState({ requiredMakeUpData: requiredMakeUpData });
	            _this.validateEnableSaving(_this.state.vacationStart, _this.state.vacationEnd, false, true);
	        }, _this.getSharesTitleBySchedule = function (schedule) {
	            var title = [];
	            for (var i = 0; i < _this.props.shareItems.length; i++) {
	                var share = _this.props.shareItems[i];
	                if (share.selectedSchedule === schedule) {
	                    title.push(_react2.default.createElement(
	                        "div",
	                        null,
	                        (share.quantity === 1 ? '' : share.quantity + ' ') + share.title
	                    ));
	                }
	            }
	            return title;
	        }, _this.renderRequiredMakeUpDataRow = function (makeUpData, index) {
	            var title = _this.getSharesTitleBySchedule(makeUpData.schedule);
	            var dates = makeUpData.dates.map(function (date, index) {
	                return _react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { key: "menuItem" + index, eventKey: date },
	                    (0, _utils.getUsefulDateWithYear)(date)
	                );
	            });
	
	            var dropdownTitle = _this.state.requiredMakeUpData[index].date ? (0, _utils.getUsefulDateWithYear)(_this.state.requiredMakeUpData[index].date) : '';
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                { index: index, key: "makeupRow" + index, className: "account-delivery-holds-make-up-schedule-row" },
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6, xs: 6, className: "account-delivery-holds-make-up-subscription" },
	                    title
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 4, xs: 4 },
	                    _react2.default.createElement(
	                        _reactBootstrap.DropdownButton,
	                        { dropup: true, className: "account-delivery-holds-make-up-date", noCaret: true,
	                            title: dropdownTitle,
	                            id: 'dropdownDate' + index,
	                            onSelect: function onSelect(value) {
	                                _this.setRequiredMakeUpScheduleDate(index, value);
	                            },
	                            key: _this.state.requiredMakeUpData[index].date
	                        },
	                        dates
	                    )
	                )
	            );
	        }, _this.renderRequiredMakeUpData = function () {
	            if (_this.state.requiredMakeUpData) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "account-delivery-holds-make-up-container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "account-delivery-holds-make-up-title" },
	                        "Make Up Dates - Please choose dates"
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { key: 'header', className: "account-delivery-holds-make-up-header-row" },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6, xs: 6, className: "account-delivery-holds-make-up-header-label" },
	                            "Subscription"
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4, xs: 4, className: "account-delivery-holds-make-up-header-label" },
	                            "Date"
	                        )
	                    ),
	                    _this.state.requiredMakeUpData.map(function (makeUpData, index) {
	                        return _this.renderRequiredMakeUpDataRow(makeUpData, index);
	                    })
	                );
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AccountDeliveryHoldPane, [{
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.requiredMakeUpData !== this.props.requiredMakeUpData) {
	                this.setState({ requiredMakeUpData: this.props.requiredMakeUpData });
	            } else if (prevProps.requiredMakeUpData && !this.props.requiredMakeUpData) {
	                this.setState({ requiredMakeUpData: undefined });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "fieldset",
	                { disabled: this.props.isFetching || this.props.isPreview },
	                _react2.default.createElement(
	                    "div",
	                    { className: "account-delivery-hold-box" },
	                    this.props.clientViewPort.isXs ? _react2.default.createElement(
	                        "div",
	                        { className: "account-header-title-container" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "account-header-title" },
	                            "Delivery Hold"
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { disabled: !this.props.canSaveDeliveryHold,
	                                onClick: this.saveClicked,
	                                type: "submit",
	                                className: "submit-order button account-delivery-hold-save-btn" + (this.props.isFetching ? " loading" : ""),
	                                bsStyle: "primary" },
	                            (0, _translate.translate)("Save")
	                        )
	                    ) : undefined,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: "account-delivery-hold-description-container" },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { md: 10, sm: 9, className: "account-delivery-hold-title" },
	                            (0, _translate.translate)('VacationHoldTopLine'),
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement(
	                                "span",
	                                { className: "account-delivery-hold-title-distribution" },
	                                this.props.nextDeliveryDate && (0, _translate.translate)('VacationHold2ndLine') + ' ' + (0, _utils.getUsefulDate)(this.props.nextDeliveryDate)
	                            )
	                        ),
	                        !this.props.clientViewPort.isXs ? _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { md: 2, sm: 3 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { disabled: !this.props.canSaveDeliveryHold,
	                                    onClick: this.saveClicked,
	                                    type: "submit",
	                                    className: "submit-order button account-delivery-hold-save-btn" + (this.props.isFetching ? " loading" : ""),
	                                    bsStyle: "primary" },
	                                (0, _translate.translate)("Save")
	                            )
	                        ) : undefined
	                    ),
	                    this.getDatesSelections(),
	                    this.getSetPermanentHold(),
	                    this.renderRequiredMakeUpData(),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "account-delivery-bottom-container" },
	                        !this.state.errorMessage ? undefined : _react2.default.createElement("div", { className: "delivery-holds-error", dangerouslySetInnerHTML: { __html: this.state.errorMessage } })
	                    )
	                ),
	                this.state.showCancelOrderMessageRemoveIndex !== undefined ? _react2.default.createElement(_ModalPopup2.default, {
	                    message: constants.DELIVERY_HOLD_DATES_CANCEL_ORDER + (this.props.staticData.hasRecurringItems ? constants.DELIVERY_HOLD_RECURRING_ORDERS_ALERT : ''),
	                    right: { text: 'Save', callback: this.deleteOrder },
	                    left: { text: "Cancel", callback: this.deleteDateOnPopupMessage } }) : undefined,
	                this.state.showCancelOrderMessageNoBalanceRemoveIndex !== undefined ? _react2.default.createElement(_ModalPopup2.default, {
	                    message: constants.DELIVERY_HOLD_DATES_BLOCK_DATE_NO_BALANCE,
	                    middle: { text: "Cancel", callback: this.deleteDateNoBalanceOnPopupMessage } }) : undefined
	            );
	        }
	    }]);
	
	    return AccountDeliveryHoldPane;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var summary = state.summary || {};
	
	    return {
	        staticData: state.staticData,
	        clientViewPort: state.clientViewPort,
	        vacationStart: summary.vacationStart,
	        vacationEnd: summary.vacationEnd,
	        isFetching: (0, _fetchingActions.isFetching)(state, constants.FetchingTypes.UPDATE_VACATION),
	        isPreview: (state.staticData || {}).isPreview,
	        canSaveDeliveryHold: summary.canSaveDeliveryHold,
	        isStoreOpen: summary.isStoreOpen,
	        nextDeliveryDate: summary.nextDeliveryDate,
	        activeWebOrderKey: summary.activeWebOrderKey,
	        farmStoreClosedEndDate: summary.farmStoreClosedEndDate,
	        isSetOnPermanentHold: summary.isSetOnPermanentHold,
	        holdReason: summary.holdReason,
	        shareItems: summary.shareItems,
	        requiredMakeUpData: summary.requiredMakeUpData
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        updateVacations: function updateVacations(vacationStart, vacationEnd, makeUpSchedules, makeUpDates) {
	            dispatch((0, _accountActions.updateVacations)(vacationStart, vacationEnd, makeUpSchedules, makeUpDates));
	        },
	        setDirty: function setDirty(isDirty) {
	            dispatch((0, _commonActions.setDirty)(isDirty));
	        },
	        setCanSaveDeliveryHold: function setCanSaveDeliveryHold(canSaveDeliveryHold) {
	            dispatch((0, _subscriptionSummaryActions.setCanSaveDeliveryHold)(canSaveDeliveryHold));
	        },
	        deleteOrderAndUpdateVacation: function deleteOrderAndUpdateVacation(vacationStart, vacationEnd) {
	            dispatch((0, _accountActions.deleteOrderAndUpdateVacation)(vacationStart, vacationEnd));
	        },
	        setOnPermanentHold: function setOnPermanentHold(isSetOnPermanentHold) {
	            dispatch((0, _subscriptionSummaryActions.setOnPermanentHold)(isSetOnPermanentHold));
	        },
	        setSubscriptionOnPermanentHold: function setSubscriptionOnPermanentHold() {
	            dispatch((0, _subscriptionSummaryActions.setSubscriptionOnPermanentHold)());
	        }
	    };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountDeliveryHoldPane);

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(341);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Button = __webpack_require__(597);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormControl = __webpack_require__(653);
	
	var _FormControl2 = _interopRequireDefault(_FormControl);
	
	var _InputGroup = __webpack_require__(660);
	
	var _InputGroup2 = _interopRequireDefault(_InputGroup);
	
	var _Overlay = __webpack_require__(710);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Popover = __webpack_require__(728);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _propTypes = __webpack_require__(348);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(354);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instanceCount = 0; // See http://jszen.blogspot.com/2007/03/how-to-build-simple-calendar-with.html for calendar logic.
	
	var CalendarHeader = (0, _createReactClass2.default)({
	  displayName: 'DatePickerHeader',
	
	  propTypes: {
	    displayDate: _propTypes2.default.object.isRequired,
	    minDate: _propTypes2.default.string,
	    maxDate: _propTypes2.default.string,
	    onChange: _propTypes2.default.func.isRequired,
	    monthLabels: _propTypes2.default.array.isRequired,
	    previousButtonElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	    nextButtonElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	  },
	
	  displayingMinMonth: function displayingMinMonth() {
	    if (!this.props.minDate) return false;
	
	    var displayDate = new Date(this.props.displayDate);
	    var minDate = new Date(this.props.minDate);
	    return minDate.getFullYear() == displayDate.getFullYear() && minDate.getMonth() == displayDate.getMonth();
	  },
	  displayingMaxMonth: function displayingMaxMonth() {
	    if (!this.props.maxDate) return false;
	
	    var displayDate = new Date(this.props.displayDate);
	    var maxDate = new Date(this.props.maxDate);
	    return maxDate.getFullYear() == displayDate.getFullYear() && maxDate.getMonth() == displayDate.getMonth();
	  },
	  handleClickPrevious: function handleClickPrevious() {
	    var newDisplayDate = new Date(this.props.displayDate);
	    newDisplayDate.setDate(1);
	    newDisplayDate.setMonth(newDisplayDate.getMonth() - 1);
	    this.props.onChange(newDisplayDate);
	  },
	  handleClickNext: function handleClickNext() {
	    var newDisplayDate = new Date(this.props.displayDate);
	    newDisplayDate.setDate(1);
	    newDisplayDate.setMonth(newDisplayDate.getMonth() + 1);
	    this.props.onChange(newDisplayDate);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'text-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'text-muted pull-left datepicker-previous-wrapper', onClick: this.handleClickPrevious, style: { cursor: 'pointer' } },
	        this.displayingMinMonth() ? null : this.props.previousButtonElement
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        this.props.monthLabels[this.props.displayDate.getMonth()],
	        ' ',
	        this.props.displayDate.getFullYear()
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-muted pull-right datepicker-next-wrapper', onClick: this.handleClickNext, style: { cursor: 'pointer' } },
	        this.displayingMaxMonth() ? null : this.props.nextButtonElement
	      )
	    );
	  }
	});
	
	var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	var Calendar = (0, _createReactClass2.default)({
	  displayName: 'DatePickerCalendar',
	
	  propTypes: {
	    selectedDate: _propTypes2.default.object,
	    displayDate: _propTypes2.default.object.isRequired,
	    minDate: _propTypes2.default.string,
	    maxDate: _propTypes2.default.string,
	    onChange: _propTypes2.default.func.isRequired,
	    dayLabels: _propTypes2.default.array.isRequired,
	    cellPadding: _propTypes2.default.string.isRequired,
	    weekStartsOn: _propTypes2.default.number,
	    showTodayButton: _propTypes2.default.bool,
	    todayButtonLabel: _propTypes2.default.string,
	    roundedCorners: _propTypes2.default.bool,
	    showWeeks: _propTypes2.default.bool
	  },
	
	  handleClick: function handleClick(e) {
	    var day = e.currentTarget.getAttribute('data-day');
	    var newSelectedDate = this.setTimeToNoon(new Date(this.props.displayDate));
	    newSelectedDate.setDate(day);
	    this.props.onChange(newSelectedDate);
	  },
	  handleClickToday: function handleClickToday() {
	    var newSelectedDate = this.setTimeToNoon(new Date());
	    this.props.onChange(newSelectedDate);
	  },
	  setTimeToNoon: function setTimeToNoon(date) {
	    date.setHours(12);
	    date.setMinutes(0);
	    date.setSeconds(0);
	    date.setMilliseconds(0);
	    return date;
	  },
	  getWeekNumber: function getWeekNumber(date) {
	    var target = new Date(date.valueOf());
	    var dayNr = (date.getDay() + 6) % 7;
	    target.setDate(target.getDate() - dayNr + 3);
	    var firstThursday = target.valueOf();
	    target.setMonth(0, 1);
	    if (target.getDay() !== 4) {
	      target.setMonth(0, 1 + (4 - target.getDay() + 7) % 7);
	    }
	    return 1 + Math.ceil((firstThursday - target) / 604800000);
	  },
	  render: function render() {
	    var _this = this;
	
	    var currentDate = this.setTimeToNoon(new Date());
	    var selectedDate = this.props.selectedDate ? this.setTimeToNoon(new Date(this.props.selectedDate)) : null;
	    var minDate = this.props.minDate ? this.setTimeToNoon(new Date(this.props.minDate)) : null;
	    var maxDate = this.props.maxDate ? this.setTimeToNoon(new Date(this.props.maxDate)) : null;
	    var year = this.props.displayDate.getFullYear();
	    var month = this.props.displayDate.getMonth();
	    var firstDay = new Date(year, month, 1);
	    var startingDay = this.props.weekStartsOn > 1 ? firstDay.getDay() - this.props.weekStartsOn + 7 : this.props.weekStartsOn === 1 ? firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1 : firstDay.getDay();
	    var showWeeks = this.props.showWeeks;
	
	    var monthLength = daysInMonth[month];
	    if (month == 1) {
	      if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
	        monthLength = 29;
	      }
	    }
	
	    var weeks = [];
	    var day = 1;
	    for (var i = 0; i < 9; i++) {
	      var week = [];
	      for (var j = 0; j <= 6; j++) {
	        if (day <= monthLength && (i > 0 || j >= startingDay)) {
	          var className = null;
	          var date = new Date(year, month, day, 12, 0, 0, 0).toISOString();
	          var beforeMinDate = minDate && Date.parse(date) < Date.parse(minDate);
	          var afterMinDate = maxDate && Date.parse(date) > Date.parse(maxDate);
	          var clickHandler = this.handleClick;
	          var style = { cursor: 'pointer', padding: this.props.cellPadding, borderRadius: this.props.roundedCorners ? 5 : 0 };
	
	          if (beforeMinDate || afterMinDate) {
	            className = 'text-muted';
	            clickHandler = null;
	            style.cursor = 'default';
	          } else if (Date.parse(date) === Date.parse(selectedDate)) {
	            className = 'bg-primary';
	          } else if (Date.parse(date) === Date.parse(currentDate)) {
	            className = 'text-primary';
	          }
	
	          week.push(_react2.default.createElement(
	            'td',
	            {
	              key: j,
	              'data-day': day,
	              onClick: clickHandler,
	              style: style,
	              className: className
	            },
	            day
	          ));
	          day++;
	        } else {
	          week.push(_react2.default.createElement('td', { key: j }));
	        }
	      }
	
	      if (showWeeks) {
	        var weekNum = this.getWeekNumber(new Date(year, month, day - 1, 12, 0, 0, 0));
	        week.unshift(_react2.default.createElement(
	          'td',
	          {
	            key: 7,
	            style: { padding: this.props.cellPadding, fontSize: '0.8em', color: 'darkgrey' },
	            className: 'text-muted'
	          },
	          weekNum
	        ));
	      }
	
	      weeks.push(_react2.default.createElement(
	        'tr',
	        { key: i },
	        week
	      ));
	      if (day > monthLength) {
	        break;
	      }
	    }
	
	    var weekColumn = showWeeks ? _react2.default.createElement('td', {
	      className: 'text-muted current-week',
	      style: { padding: this.props.cellPadding } }) : null;
	
	    return _react2.default.createElement(
	      'table',
	      { className: 'text-center' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          weekColumn,
	          this.props.dayLabels.map(function (label, index) {
	            return _react2.default.createElement(
	              'td',
	              {
	                key: index,
	                className: 'text-muted',
	                style: { padding: _this.props.cellPadding } },
	              _react2.default.createElement(
	                'small',
	                null,
	                label
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        weeks
	      ),
	      this.props.showTodayButton && _react2.default.createElement(
	        'tfoot',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            { colSpan: this.props.dayLabels.length, style: { paddingTop: '9px' } },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                block: true,
	                bsSize: 'xsmall',
	                className: 'u-today-button',
	                onClick: this.handleClickToday },
	              this.props.todayButtonLabel
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = (0, _createReactClass2.default)({
	  displayName: 'DatePicker',
	
	  propTypes: {
	    defaultValue: _propTypes2.default.string,
	    value: _propTypes2.default.string,
	    required: _propTypes2.default.bool,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    minDate: _propTypes2.default.string,
	    maxDate: _propTypes2.default.string,
	    cellPadding: _propTypes2.default.string,
	    autoComplete: _propTypes2.default.string,
	    placeholder: _propTypes2.default.string,
	    dayLabels: _propTypes2.default.array,
	    monthLabels: _propTypes2.default.array,
	    onChange: _propTypes2.default.func,
	    onClear: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    autoFocus: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    weekStartsOnMonday: function weekStartsOnMonday(props, propName, componentName) {
	      if (props[propName]) {
	        return new Error('Prop \'' + propName + '\' supplied to \'' + componentName + '\' is obsolete. Use \'weekStartsOn\' instead.');
	      }
	    },
	    weekStartsOn: _propTypes2.default.number,
	    clearButtonElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    showClearButton: _propTypes2.default.bool,
	    previousButtonElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    nextButtonElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    calendarPlacement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    dateFormat: _propTypes2.default.string, // 'MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD', 'DD-MM-YYYY'
	    bsClass: _propTypes2.default.string,
	    bsSize: _propTypes2.default.string,
	    calendarContainer: _propTypes2.default.object,
	    id: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    showTodayButton: _propTypes2.default.bool,
	    todayButtonLabel: _propTypes2.default.string,
	    instanceCount: _propTypes2.default.number,
	    customControl: _propTypes2.default.object,
	    roundedCorners: _propTypes2.default.bool,
	    showWeeks: _propTypes2.default.bool,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    onInvalid: _propTypes2.default.func,
	    noValidate: _propTypes2.default.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    var language = typeof window !== 'undefined' && window.navigator ? (window.navigator.userLanguage || window.navigator.language || '').toLowerCase() : '';
	    var dateFormat = !language || language === 'en-us' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
	    return {
	      cellPadding: '5px',
	      dayLabels: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	      monthLabels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	      clearButtonElement: '×',
	      previousButtonElement: '<',
	      nextButtonElement: '>',
	      calendarPlacement: 'bottom',
	      dateFormat: dateFormat,
	      showClearButton: true,
	      autoFocus: false,
	      disabled: false,
	      showTodayButton: false,
	      todayButtonLabel: 'Today',
	      autoComplete: 'on',
	      showWeeks: false,
	      instanceCount: instanceCount++,
	      style: {
	        width: '100%'
	      },
	      roundedCorners: false,
	      noValidate: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    if (this.props.value && this.props.defaultValue) {
	      throw new Error('Conflicting DatePicker properties \'value\' and \'defaultValue\'');
	    }
	    var state = this.makeDateValues(this.props.value || this.props.defaultValue);
	    if (this.props.weekStartsOn > 1) {
	      state.dayLabels = this.props.dayLabels.slice(this.props.weekStartsOn).concat(this.props.dayLabels.slice(0, this.props.weekStartsOn));
	    } else if (this.props.weekStartsOn === 1) {
	      state.dayLabels = this.props.dayLabels.slice(1).concat(this.props.dayLabels.slice(0, 1));
	    } else {
	      state.dayLabels = this.props.dayLabels;
	    }
	    state.focused = false;
	    state.inputFocused = false;
	    state.placeholder = this.props.placeholder || this.props.dateFormat;
	    state.separator = this.props.dateFormat.match(/[^A-Z]/)[0];
	    return state;
	  },
	  makeDateValues: function makeDateValues(isoString) {
	    var displayDate = void 0;
	    var selectedDate = isoString ? new Date(isoString.slice(0, 10) + 'T12:00:00.000Z') : null;
	    var minDate = this.props.minDate ? new Date(this.props.minDate.slice(0, 10) + 'T12:00:00.000Z') : null;
	    var maxDate = this.props.maxDate ? new Date(this.props.maxDate.slice(0, 10) + 'T12:00:00.000Z') : null;
	
	    var inputValue = isoString ? this.makeInputValueString(selectedDate) : null;
	    if (selectedDate) {
	      displayDate = new Date(selectedDate);
	    } else {
	      var today = new Date(new Date().toISOString().slice(0, 10) + 'T12:00:00.000Z');
	      if (minDate && Date.parse(minDate) >= Date.parse(today)) {
	        displayDate = minDate;
	      } else if (maxDate && Date.parse(maxDate) <= Date.parse(today)) {
	        displayDate = maxDate;
	      } else {
	        displayDate = today;
	      }
	    }
	
	    return {
	      value: selectedDate ? selectedDate.toISOString() : null,
	      displayDate: displayDate,
	      selectedDate: selectedDate,
	      inputValue: inputValue
	    };
	  },
	  clear: function clear() {
	    if (this.props.onClear) {
	      this.props.onClear();
	    } else {
	      this.setState(this.makeDateValues(null));
	    }
	
	    if (this.props.onChange) {
	      this.props.onChange(null, null);
	    }
	  },
	  handleHide: function handleHide() {
	    if (this.state.inputFocused) {
	      return;
	    }
	    this.setState({
	      focused: false
	    });
	    if (this.props.onBlur) {
	      var event = document.createEvent('CustomEvent');
	      event.initEvent('Change Date', true, false);
	      _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	      this.props.onBlur(event);
	    }
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    if (e.which === 9 && this.state.inputFocused) {
	      this.setState({
	        focused: false
	      });
	
	      if (this.props.onBlur) {
	        var event = document.createEvent('CustomEvent');
	        event.initEvent('Change Date', true, false);
	        _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	        this.props.onBlur(event);
	      }
	    }
	  },
	  handleFocus: function handleFocus() {
	    if (this.state.focused === true) {
	      return;
	    }
	
	    var placement = this.getCalendarPlacement();
	
	    this.setState({
	      inputFocused: true,
	      focused: true,
	      calendarPlacement: placement
	    });
	
	    if (this.props.onFocus) {
	      var event = document.createEvent('CustomEvent');
	      event.initEvent('Change Date', true, false);
	      _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	      this.props.onFocus(event);
	    }
	  },
	  handleBlur: function handleBlur() {
	    this.setState({
	      inputFocused: false
	    });
	  },
	
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !(this.state.inputFocused === true && nextState.inputFocused === false);
	  },
	
	  getValue: function getValue() {
	    return this.state.selectedDate ? this.state.selectedDate.toISOString() : null;
	  },
	  getFormattedValue: function getFormattedValue() {
	    return this.state.displayDate ? this.state.inputValue : null;
	  },
	  getCalendarPlacement: function getCalendarPlacement() {
	    var tag = Object.prototype.toString.call(this.props.calendarPlacement);
	    var isFunction = tag === '[object AsyncFunction]' || tag === '[object Function]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';
	    if (isFunction) {
	      return this.props.calendarPlacement();
	    } else {
	      return this.props.calendarPlacement;
	    }
	  },
	  makeInputValueString: function makeInputValueString(date) {
	    var month = date.getMonth() + 1;
	    var day = date.getDate();
	
	    //this method is executed during intialState setup... handle a missing state properly
	    var separator = this.state ? this.state.separator : this.props.dateFormat.match(/[^A-Z]/)[0];
	    if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
	      return (month > 9 ? month : '0' + month) + separator + (day > 9 ? day : '0' + day) + separator + date.getFullYear();
	    } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
	      return (day > 9 ? day : '0' + day) + separator + (month > 9 ? month : '0' + month) + separator + date.getFullYear();
	    } else {
	      return date.getFullYear() + separator + (month > 9 ? month : '0' + month) + separator + (day > 9 ? day : '0' + day);
	    }
	  },
	  handleBadInput: function handleBadInput(originalValue) {
	    var parts = originalValue.replace(new RegExp('[^0-9' + this.state.separator + ']'), '').split(this.state.separator);
	    if (this.props.dateFormat.match(/MM.DD.YYYY/) || this.props.dateFormat.match(/DD.MM.YYYY/)) {
	      if (parts[0] && parts[0].length > 2) {
	        parts[1] = parts[0].slice(2) + (parts[1] || '');
	        parts[0] = parts[0].slice(0, 2);
	      }
	      if (parts[1] && parts[1].length > 2) {
	        parts[2] = parts[1].slice(2) + (parts[2] || '');
	        parts[1] = parts[1].slice(0, 2);
	      }
	      if (parts[2]) {
	        parts[2] = parts[2].slice(0, 4);
	      }
	    } else {
	      if (parts[0] && parts[0].length > 4) {
	        parts[1] = parts[0].slice(4) + (parts[1] || '');
	        parts[0] = parts[0].slice(0, 4);
	      }
	      if (parts[1] && parts[1].length > 2) {
	        parts[2] = parts[1].slice(2) + (parts[2] || '');
	        parts[1] = parts[1].slice(0, 2);
	      }
	      if (parts[2]) {
	        parts[2] = parts[2].slice(0, 2);
	      }
	    }
	    this.setState({
	      inputValue: parts.join(this.state.separator)
	    });
	  },
	  handleInputChange: function handleInputChange() {
	
	    var originalValue = _reactDom2.default.findDOMNode(this.refs.input).value;
	    var inputValue = originalValue.replace(/(-|\/\/)/g, this.state.separator).slice(0, 10);
	
	    if (!inputValue) {
	      this.clear();
	      return;
	    }
	
	    var month = void 0,
	        day = void 0,
	        year = void 0;
	    if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
	      if (!inputValue.match(/[0-1][0-9].[0-3][0-9].[1-2][0-9][0-9][0-9]/)) {
	        return this.handleBadInput(originalValue);
	      }
	
	      month = inputValue.slice(0, 2).replace(/[^0-9]/g, '');
	      day = inputValue.slice(3, 5).replace(/[^0-9]/g, '');
	      year = inputValue.slice(6, 10).replace(/[^0-9]/g, '');
	    } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
	      if (!inputValue.match(/[0-3][0-9].[0-1][0-9].[1-2][0-9][0-9][0-9]/)) {
	        return this.handleBadInput(originalValue);
	      }
	
	      day = inputValue.slice(0, 2).replace(/[^0-9]/g, '');
	      month = inputValue.slice(3, 5).replace(/[^0-9]/g, '');
	      year = inputValue.slice(6, 10).replace(/[^0-9]/g, '');
	    } else {
	      if (!inputValue.match(/[1-2][0-9][0-9][0-9].[0-1][0-9].[0-3][0-9]/)) {
	        return this.handleBadInput(originalValue);
	      }
	
	      year = inputValue.slice(0, 4).replace(/[^0-9]/g, '');
	      month = inputValue.slice(5, 7).replace(/[^0-9]/g, '');
	      day = inputValue.slice(8, 10).replace(/[^0-9]/g, '');
	    }
	
	    var monthInteger = parseInt(month, 10);
	    var dayInteger = parseInt(day, 10);
	    var yearInteger = parseInt(year, 10);
	    if (monthInteger > 12 || dayInteger > 31) {
	      return this.handleBadInput(originalValue);
	    }
	
	    if (!isNaN(monthInteger) && !isNaN(dayInteger) && !isNaN(yearInteger) && monthInteger <= 12 && dayInteger <= 31 && yearInteger > 999) {
	      var selectedDate = new Date(yearInteger, monthInteger - 1, dayInteger, 12, 0, 0, 0);
	      this.setState({
	        selectedDate: selectedDate,
	        displayDate: selectedDate,
	        value: selectedDate.toISOString()
	      });
	
	      if (this.props.onChange) {
	        this.props.onChange(selectedDate.toISOString(), inputValue);
	      }
	    }
	
	    this.setState({
	      inputValue: inputValue
	    });
	  },
	  onChangeMonth: function onChangeMonth(newDisplayDate) {
	    this.setState({
	      displayDate: newDisplayDate
	    });
	  },
	  onChangeDate: function onChangeDate(newSelectedDate) {
	    var inputValue = this.makeInputValueString(newSelectedDate);
	    this.setState({
	      inputValue: inputValue,
	      selectedDate: newSelectedDate,
	      displayDate: newSelectedDate,
	      value: newSelectedDate.toISOString(),
	      focused: false
	    });
	
	    if (this.props.onBlur) {
	      var event = document.createEvent('CustomEvent');
	      event.initEvent('Change Date', true, false);
	      _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	      this.props.onBlur(event);
	    }
	
	    if (this.props.onChange) {
	      this.props.onChange(newSelectedDate.toISOString(), inputValue);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var value = newProps.value;
	    if (this.getValue() !== value) {
	      this.setState(this.makeDateValues(value));
	    }
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var calendarHeader = _react2.default.createElement(CalendarHeader, {
	      previousButtonElement: this.props.previousButtonElement,
	      nextButtonElement: this.props.nextButtonElement,
	      displayDate: this.state.displayDate,
	      minDate: this.props.minDate,
	      maxDate: this.props.maxDate,
	      onChange: this.onChangeMonth,
	      monthLabels: this.props.monthLabels,
	      dateFormat: this.props.dateFormat });
	
	    var control = this.props.customControl ? _react2.default.cloneElement(this.props.customControl, {
	      onKeyDown: this.handleKeyDown,
	      value: this.state.inputValue || '',
	      required: this.props.required,
	      placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
	      ref: 'input',
	      disabled: this.props.disabled,
	      onFocus: this.handleFocus,
	      onBlur: this.handleBlur,
	      onChange: this.handleInputChange,
	      className: this.props.className,
	      style: this.props.style,
	      autoComplete: this.props.autoComplete,
	      onInvalid: this.props.onInvalid,
	      noValidate: this.props.noValidate
	    }) : _react2.default.createElement(_FormControl2.default, {
	      onKeyDown: this.handleKeyDown,
	      value: this.state.inputValue || '',
	      required: this.props.required,
	      ref: 'input',
	      type: 'text',
	      className: this.props.className,
	      style: this.props.style,
	      autoFocus: this.props.autoFocus,
	      disabled: this.props.disabled,
	      placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
	      onFocus: this.handleFocus,
	      onBlur: this.handleBlur,
	      onChange: this.handleInputChange,
	      autoComplete: this.props.autoComplete,
	      onInvalid: this.props.onInvalid,
	      noValidate: this.props.noValidate
	    });
	
	    return _react2.default.createElement(
	      _InputGroup2.default,
	      {
	        ref: 'inputGroup',
	        bsClass: this.props.showClearButton ? this.props.bsClass : '',
	        bsSize: this.props.bsSize,
	        id: this.props.id ? this.props.id + '_group' : null },
	      control,
	      _react2.default.createElement(
	        _Overlay2.default,
	        {
	          rootClose: true,
	          onHide: this.handleHide,
	          show: this.state.focused,
	          container: function container() {
	            return _this2.props.calendarContainer || _reactDom2.default.findDOMNode(_this2.refs.overlayContainer);
	          },
	          target: function target() {
	            return _reactDom2.default.findDOMNode(_this2.refs.input);
	          },
	          placement: this.state.calendarPlacement,
	          delayHide: 200 },
	        _react2.default.createElement(
	          _Popover2.default,
	          { id: 'date-picker-popover-' + this.props.instanceCount, className: 'date-picker-popover', title: calendarHeader },
	          _react2.default.createElement(Calendar, {
	            cellPadding: this.props.cellPadding,
	            selectedDate: this.state.selectedDate,
	            displayDate: this.state.displayDate,
	            onChange: this.onChangeDate,
	            dayLabels: this.state.dayLabels,
	            weekStartsOn: this.props.weekStartsOn,
	            showTodayButton: this.props.showTodayButton,
	            todayButtonLabel: this.props.todayButtonLabel,
	            minDate: this.props.minDate,
	            maxDate: this.props.maxDate,
	            roundedCorners: this.props.roundedCorners,
	            showWeeks: this.props.showWeeks
	          })
	        )
	      ),
	      _react2.default.createElement('div', { ref: 'overlayContainer', style: { position: 'relative' } }),
	      _react2.default.createElement('input', { ref: 'hiddenInput', type: 'hidden', id: this.props.id, name: this.props.name, value: this.state.value || '', 'data-formattedvalue': this.state.value ? this.state.inputValue : '' }),
	      this.props.showClearButton && !this.props.customControl && _react2.default.createElement(
	        _InputGroup2.default.Addon,
	        {
	          onClick: this.props.disabled ? null : this.clear,
	          style: { cursor: this.state.inputValue && !this.props.disabled ? 'pointer' : 'not-allowed' } },
	        _react2.default.createElement(
	          'div',
	          { style: { opacity: this.state.inputValue && !this.props.disabled ? 1 : 0.5 } },
	          this.props.clearButtonElement
	        )
	      ),
	      this.props.children
	    );
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AccountReportsPane = undefined;
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _translate = __webpack_require__(464);
	
	var _accountReportsPane = __webpack_require__(1121);
	
	var _accountReportsPane2 = _interopRequireDefault(_accountReportsPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountReportsPane = exports.AccountReportsPane = function AccountReportsPane(props) {
	    var subscriptionSummary = props.subscriptionSummary;
	    return _react2.default.createElement(
	        _reactBootstrap.Form,
	        { className: "account-reports-container" },
	        props.clientViewPort.isXs ? _react2.default.createElement(
	            "div",
	            { className: "account-header-title-container" },
	            _react2.default.createElement(
	                "div",
	                { className: "account-header-title" },
	                (0, _translate.translate)("Reports")
	            )
	        ) : undefined,
	        _react2.default.createElement(
	            _reactBootstrap.FormGroup,
	            { className: "account-reports-inner-container" },
	            !subscriptionSummary.pickupSiteReporURL ? undefined : _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { md: 12 },
	                    _react2.default.createElement(
	                        "a",
	                        { className: "report-row", target: "_blank",
	                            href: subscriptionSummary.pickupSiteReporURL },
	                        (0, _translate.translate)("Member Pick-up details")
	                    )
	                )
	            ),
	            !subscriptionSummary.contactListReportURL ? undefined : _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { md: 12 },
	                    _react2.default.createElement(
	                        "a",
	                        { className: "report-row", target: "_blank",
	                            href: subscriptionSummary.contactListReportURL },
	                        (0, _translate.translate)("Member Contact Info")
	                    )
	                )
	            ),
	            !subscriptionSummary.contactListReportURL ? undefined : _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { md: 12 },
	                    _react2.default.createElement(
	                        "a",
	                        { className: "report-row", target: "_blank",
	                            href: subscriptionSummary.contactListReportURL + "&includeSubscriptions=true" },
	                        (0, _translate.translate)("Member Share Details")
	                    )
	                )
	            ),
	            !subscriptionSummary.orderDistributionReporURL ? undefined : _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { md: 12 },
	                    _react2.default.createElement(
	                        "a",
	                        { className: "report-row",
	                            href: subscriptionSummary.orderDistributionReporURL ? subscriptionSummary.orderDistributionReporURL : "" },
	                        (0, _translate.translate)("_StoreOrderDistribution")
	                    )
	                )
	            )
	        )
	    );
	};

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _reactRouterRedux = __webpack_require__(451);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _utils = __webpack_require__(485);
	
	var _LogInScreen = __webpack_require__(823);
	
	var _LogInScreen2 = _interopRequireDefault(_LogInScreen);
	
	var _staticDataActions = __webpack_require__(749);
	
	var _memberDetailsActions = __webpack_require__(751);
	
	var _accountActions = __webpack_require__(1089);
	
	var _commonActions = __webpack_require__(747);
	
	var _UserMenu = __webpack_require__(490);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	var _ModalPopup = __webpack_require__(762);
	
	var _ModalPopup2 = _interopRequireDefault(_ModalPopup);
	
	var _SelectionTabs = __webpack_require__(842);
	
	var _SelectionTabs2 = _interopRequireDefault(_SelectionTabs);
	
	var _SelectionPane = __webpack_require__(844);
	
	var _SelectionPane2 = _interopRequireDefault(_SelectionPane);
	
	var _AccountNavigationHeader = __webpack_require__(1114);
	
	var _AccountNavigationHeader2 = _interopRequireDefault(_AccountNavigationHeader);
	
	var _PaymentPane = __webpack_require__(1124);
	
	var _PaymentPane2 = _interopRequireDefault(_PaymentPane);
	
	var _paymentActions = __webpack_require__(754);
	
	var _constants = __webpack_require__(463);
	
	var _ThankYouPage = __webpack_require__(832);
	
	var _ThankYouPage2 = _interopRequireDefault(_ThankYouPage);
	
	var _PaymentsHost = __webpack_require__(833);
	
	var _PaymentsHost2 = _interopRequireDefault(_PaymentsHost);
	
	var _EcheckForm = __webpack_require__(829);
	
	var _EcheckForm2 = _interopRequireDefault(_EcheckForm);
	
	var _EBTForm = __webpack_require__(831);
	
	var _EBTForm2 = _interopRequireDefault(_EBTForm);
	
	var _LoadingAnimation = __webpack_require__(834);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _fetchingActions = __webpack_require__(748);
	
	var _translate = __webpack_require__(464);
	
	var _payHomeScreen = __webpack_require__(1126);
	
	var _payHomeScreen2 = _interopRequireDefault(_payHomeScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PayHomeScreen = function (_React$Component) {
	    _inherits(PayHomeScreen, _React$Component);
	
	    function PayHomeScreen(props) {
	        _classCallCheck(this, PayHomeScreen);
	
	        var _this = _possibleConstructorReturn(this, (PayHomeScreen.__proto__ || Object.getPrototypeOf(PayHomeScreen)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var page = props.staticData.farmKey ? props.location.pathname.includes('/ebt') && props.allowContinue ? "EBTForm" : props.location.pathname.includes('/thankyou') ? "ThankYouPage" : "Tabs" : "LoadingAnimation";
	
	        _this.state = {
	            page: page
	        };
	        return _this;
	    }
	
	    _createClass(PayHomeScreen, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            if (this.props.staticData.farmKey) {
	                this.props.setAndRemoveUrlParams(true);
	                return;
	            }
	            this.props.initServerStaticData();
	            if ((0, _utils.getPageContext)() === _constants.URLs.CHARGE) this.props.setMemberKey((0, _utils.getUrlParams)().memberKey);else if ((0, _utils.getUrlParams)().mode === 'preview') this.props.setMemberKey((0, _utils.getUrlParams)().m);else this.props.initMemberData();
	            if ((0, _utils.getUrlParams)().type === 'single') {
	                this.props.setPaymentType(_constants.PaymentTypes.SINGLE_PAYMENT.type);
	            }
	            this.props.setAndRemoveUrlParams(true);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            this.getPage(nextProps);
	            if (nextProps.memberDetails.key && !this.props.memberDetails.key) {
	                this.props.getSubscriptionSummary(this.props.isAdminPayments, true);
	            }
	            if (nextProps.paymentType === _constants.PaymentTypes.SINGLE_PAYMENT.type && nextProps.singlePaymentPlan && nextProps.singlePaymentMethod || nextProps.paymentType === _constants.PaymentTypes.AUTO_PAYMENT.type && nextProps.autoPaymentPlan || nextProps.paymentType === _constants.PaymentTypes.UPDATE_PAYMENT.type && nextProps.updatePaymentMethod) {
	                if (nextProps.paymentType === _constants.PaymentTypes.SINGLE_PAYMENT.type && nextProps.singlePaymentPlan.type === _constants.PaymentPlans.CustomPrePayment && nextProps.paymentPlanAmount === 0) {
	                    this.props.setAllowContinuePayment(false);
	                } else if (nextProps.paymentType === _constants.PaymentTypes.AUTO_PAYMENT.type && !nextProps.autoPaymentMethod && !nextProps.hasToken) {
	                    this.props.setAllowContinuePayment(false);
	                } else {
	                    this.props.setAllowContinuePayment(!this.props.isPreview);
	                }
	            } else if (nextProps.paymentType === _constants.PaymentTypes.CHARGE.type && nextProps.chargePaymentPlan && nextProps.chargePaymentMethod) {
	                this.props.setAllowContinuePayment(nextProps.paymentPlanAmount > 0);
	            } else if (nextProps.paymentType === _constants.PaymentTypes.PAYMENT_PLAN.type && nextProps.planPaymentPlan) {
	                this.props.setAllowContinuePayment(true);
	            } else if (nextProps.paymentType === _constants.PaymentTypes.PAYMENT_TOKEN.type) {
	                this.props.setAllowContinuePayment(nextProps.tokenPaymentMethod);
	            } else if (nextProps.allowContinue) {
	                this.props.setAllowContinuePayment(false);
	            }
	            if (nextProps.paymentPlans && !this.props.paymentPlans && !nextProps.paymentType) {
	                var tabs = this.props.isAdminPayments ? this.getAdminTabsData(nextProps) : this.getTabsData(nextProps);
	                if (tabs.length > 0) {
	                    this.props.setPaymentType(tabs[0].key);
	                }
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return this.renderPage();
	        }
	    }]);
	
	    return PayHomeScreen;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.getPath = function () {
	        _this2.props.getPath("/" + _constants.URLs.PAY + "/" + _this2.props.params.splat.split("/")[1] + "?source=account");
	    };
	
	    this.getPage = function (props) {
	        var path = props.location.pathname.split(";")[0];
	        if (path.endsWith('/thankyou')) {
	            _this2.setState({ page: "ThankYouPage" });
	        } else if (!props.memberDetails.key) {
	            _this2.setState({ page: "LogInScreen" });
	        } else if (path.endsWith('/echeck')) {
	            if (_this2.props.allowContinue) {
	                _this2.setState({ page: "EcheckForm" });
	            } else {
	                _this2.props.getPath((0, _utils.removePath)('/echeck'));
	            }
	        } else if (path.endsWith('/ebt')) {
	            if (_this2.props.allowContinue) {
	                _this2.setState({ page: "EBTForm" });
	            } else {
	                _this2.props.getPath((0, _utils.removePath)('/ebt'));
	            }
	        } else if (path.endsWith('/payments')) {
	            if (_this2.props.allowContinue) {
	                _this2.setState({ page: "PaymentsHost" });
	            } else {
	                _this2.props.getPath((0, _utils.removePath)('/payments'));
	            }
	        } else if (props.paymentMethods && props.paymentPlans) {
	            _this2.setState({ page: "Tabs" });
	        } else {
	            _this2.setState({ page: "LoadingAnimation" });
	        }
	    };
	
	    this.getButtons = function () {
	        var submitLoadingClass = _this2.props.showLoading ? " loading" : "";
	        var submitClasses = "submit-order button" + submitLoadingClass;
	        return {
	            left: {
	                label: (0, _translate.translate)("BACK"),
	                onClick: _this2.onBack,
	                invisible: !_this2.props.showBack,
	                className: "back button"
	            },
	            right: {
	                label: (0, _translate.translate)("CONTINUE"),
	                onClick: _this2.onContinue,
	                disabled: !_this2.props.allowContinue,
	                className: submitClasses
	            }
	        };
	    };
	
	    this.onBack = function () {
	        _this2.props.checkIsDirty(!_this2.props.isPreview, function () {
	            this.props.goBack();
	        }.bind(_this2));
	    };
	
	    this.onContinue = function () {
	        _this2.props.setAllowContinuePayment(_this2.props.paymentType === _constants.PaymentTypes.CHARGE.type);
	        if (_this2.props.paymentType === _constants.PaymentTypes.SINGLE_PAYMENT.type) {
	            //Positive amount should be sent only for custom payment
	            var amount = _this2.isCustomPayment(_this2.props.singlePaymentPlan.key) ? _this2.props.singlePaymentPlan.amount : 0;
	            _this2.props.makeExtraPayment("ACCOUNT", amount, _this2.props.singlePaymentMethod, _this2.props.singlePaymentPlan);
	        } else if (_this2.props.hasToken && _this2.props.paymentType === _constants.PaymentTypes.AUTO_PAYMENT.type) {
	            _this2.props.updatePaymentPlan(_this2.props.autoPaymentPlan);
	        } else if (_this2.props.paymentType === _constants.PaymentTypes.CHARGE.type) {
	            if (_this2.hasTokenForAdminCharge()) _this2.props.adminChargeWithToken();else _this2.props.adminChargeWithoutToken();
	        } else if (_this2.props.paymentType === _constants.PaymentTypes.PAYMENT_PLAN.type) {
	            _this2.props.updatePaymentPlan(_this2.props.planPaymentPlan);
	        } else if (_this2.props.paymentType === _constants.PaymentTypes.PAYMENT_TOKEN.type && _this2.props.tokenPaymentMethod === _constants.PaymentMethod.NONE.key || _this2.props.paymentType === _constants.PaymentTypes.UPDATE_PAYMENT.type && _this2.props.updatePaymentMethod === _constants.PaymentMethod.NONE.key && _this2.props.staticData.allowMemberToRemoveToken) {
	            _this2.openRemoveTokenPopup();
	        } else {
	            var paymentPlan = !_this2.props.hasToken ? _this2.props.autoPaymentPlan : undefined;
	            _this2.props.redirectToPaymentDetails("UPDATE_PAYMENT_DETAILS", _this2.props[_this2.props.paymentType + "PaymentMethod"], paymentPlan);
	        }
	    };
	
	    this.isCustomPayment = function (paymentPlanKey) {
	        return _this2.props.paymentPlans.some(function (plan) {
	            return plan.key === paymentPlanKey && plan.type === _constants.PaymentPlans.CustomPrePayment;
	        });
	    };
	
	    this.getPreApprovalText = function () {
	        var preApprovalText = (_this2.props.isAdminPayments ? (0, _translate.translate)("Member is") : (0, _translate.translate)("You are")) + " " + (0, _translate.translate)("_assignedAutomaticPayment");
	        switch (_this2.props.paymentMethodToken) {
	            case _constants.PaymentMethod.PAYPAL_PREAPPROVE.key:
	                return preApprovalText + "PayPal";
	            case _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key:
	                return preApprovalText + (0, _translate.translate)("AUTHORIZE_DOT_NET");
	            case _constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key:
	                return preApprovalText + (0, _translate.translate)("ELECTRONIC_CHECK");
	            default:
	                return "";
	        }
	    };
	
	    this.getPaymentPlanText = function () {
	        if (!_this2.props.subscriptionPaymentPlan || [_constants.PaymentPlans.F, _constants.PaymentPlans.AutoRecurring, _constants.PaymentPlans.PresetRecurring].includes(_this2.props.subscriptionPaymentPlan.type)) {
	            return '';
	        }
	        return (0, _translate.translate)("Your current payment plan") + " : " + _this2.props.subscriptionPaymentPlan.title;
	    };
	
	    this.setSelectedTab = function (tabLabel) {
	        for (var payment in _constants.PaymentTypes) {
	            if (_constants.PaymentTypes.hasOwnProperty(payment) && _constants.PaymentTypes[payment].label === tabLabel) {
	                _this2.props.setPaymentType(_constants.PaymentTypes[payment].type);
	                return;
	            }
	        }
	    };
	
	    this.openRemoveTokenPopup = function () {
	        _this2.setState({ showRemoveTokenPopup: true });
	    };
	
	    this.closeRemoveTokenPopup = function () {
	        _this2.setState({ showRemoveTokenPopup: false });
	    };
	
	    this.getRemoveTokenPopup = function () {
	        if (_this2.state.showRemoveTokenPopup) {
	            return _react2.default.createElement(_ModalPopup2.default, {
	                onClose: _this2.closeRemoveTokenPopup,
	                message: "removeAutomaticPaymentConfirmation",
	                right: { text: 'Remove', callback: _this2.props.removeAutomaticPayment },
	                left: { text: 'Cancel', callback: _this2.closeRemoveTokenPopup } });
	        }
	    };
	
	    this.hasTokenForAdminCharge = function () {
	        return _this2.props.hasToken && (_this2.props.paymentMethodToken === _constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key || _this2.props.paymentMethodToken === _constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key);
	    };
	
	    this.getAdminChargePaymentMethods = function (nextProps) {
	        var props = nextProps ? nextProps : _this2.props;
	        if (_this2.hasTokenForAdminCharge()) return [props.paymentMethodToken];
	
	        var paymentMethods = [];
	        var allPaymentMethods = props.staticData.signupPaymentMethods.concat(props.staticData.makePaymentPaymentMethods);
	        if (allPaymentMethods.includes(_constants.PaymentMethod.AUTHORIZE_DOT_NET.key) || allPaymentMethods.includes(_constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key)) paymentMethods.push(_constants.PaymentMethod.AUTHORIZE_DOT_NET.key);
	        if (allPaymentMethods.includes(_constants.PaymentMethod.ELECTRONIC_CHECK.key) || allPaymentMethods.includes(_constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key)) paymentMethods.push(_constants.PaymentMethod.ELECTRONIC_CHECK.key);
	        if (allPaymentMethods.includes(_constants.PaymentMethod.EBT_ONLINE.key)) paymentMethods.push(_constants.PaymentMethod.EBT_ONLINE.key);
	
	        return paymentMethods;
	    };
	
	    this.getAdminAutoPaymentMethods = function (nextProps) {
	        var props = nextProps ? nextProps : _this2.props;
	        var paymentMethods = [];
	        var allPaymentMethods = props.staticData.signupPaymentMethods.concat(props.staticData.makePaymentPaymentMethods);
	        if (allPaymentMethods.includes(_constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key)) paymentMethods.push(_constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key);
	        if (allPaymentMethods.includes(_constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key)) paymentMethods.push(_constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key);
	
	        return paymentMethods;
	    };
	
	    this.getAdminPaymentPlans = function (nextProps) {
	        return nextProps ? nextProps.paymentPlans : _this2.props.paymentPlans;
	    };
	
	    this.getAdminMemberName = function () {
	        var params = (0, _utils.getUrlParams)();
	        if (params) return params.firstName + " " + params.lastName;
	        return "";
	    };
	
	    this.getPaymentPane = function (paymentType) {
	        var paymentMethods = paymentType === _constants.PaymentTypes.PAYMENT_PLAN.type ? [] : paymentType === _constants.PaymentTypes.CHARGE.type ? _this2.getAdminChargePaymentMethods() : paymentType === _constants.PaymentTypes.PAYMENT_TOKEN.type ? _this2.getAdminAutoPaymentMethods() : paymentType === _constants.PaymentTypes.UPDATE_PAYMENT.type ? _this2.props.autoPaymentMethods : _this2.props[paymentType + "PaymentMethods"];
	        var paymentPlans = paymentType === _constants.PaymentTypes.PAYMENT_TOKEN.type ? [] : paymentType === _constants.PaymentTypes.PAYMENT_PLAN.type ? _this2.getAdminPaymentPlans() : paymentType === _constants.PaymentTypes.CHARGE.type ? [{ type: _constants.PaymentPlans.CustomPrePayment, key: "_custom_prepayment" }] : _this2.props[paymentType + "PaymentPlans"];
	
	        return _react2.default.createElement(_PaymentPane2.default, { paymentMethods: paymentMethods,
	            staticData: _this2.props.staticData,
	            paymentPlans: paymentPlans,
	            paymentType: paymentType,
	            allowNone: _this2.props.isAdminPayments || _this2.props.staticData.allowMemberToRemovePaymentPlan && _this2.props.hasToken && _this2.props.subscriptionPaymentPlan && paymentType === _constants.PaymentTypes.AUTO_PAYMENT.type,
	            hasToken: _this2.props.hasToken });
	    };
	
	    this.getPaymentTitle = function () {
	        if (!_this2.props.paymentType) {
	            return undefined;
	        }
	        switch (_this2.props.paymentType) {
	            case _constants.PaymentTypes.SINGLE_PAYMENT.type:
	                return _constants.PaymentTypes.SINGLE_PAYMENT.label;
	            case _constants.PaymentTypes.AUTO_PAYMENT.type:
	                return _constants.PaymentTypes.AUTO_PAYMENT.label;
	            case _constants.PaymentTypes.UPDATE_PAYMENT.type:
	                return _constants.PaymentTypes.UPDATE_PAYMENT.label;
	        }
	    };
	
	    this.getUserMenu = function () {
	        if (!_this2.props.clientViewPort.isXs && !_this2.props.isAdminPayments && !_this2.props.isPreview) return _react2.default.createElement(_UserMenu2.default, null);
	        if (!_this2.props.clientViewPort.isXs && _this2.props.isPreview) return _react2.default.createElement(
	            "div",
	            { className: "preview-label" },
	            (0, _translate.translate)("Preview")
	        );
	    };
	
	    this.getTabsData = function (nextprops) {
	        var props = nextprops ? nextprops : _this2.props;
	        var tabs = [];
	        if (props.autoPaymentMethods.length > 0 && (props.autoPaymentPlans || {}).length > 0) {
	            tabs.push({
	                title: _constants.PaymentTypes.AUTO_PAYMENT.label,
	                shortTitle: _constants.PaymentTypes.AUTO_PAYMENT.shortLabel,
	                key: _constants.PaymentTypes.AUTO_PAYMENT.type,
	                content: _this2.getPaymentPane(_constants.PaymentTypes.AUTO_PAYMENT.type)
	            });
	        }
	        if (props.singlePaymentMethods.length > 0 && (props.singlePaymentPlans || {}).length > 0) {
	            var singlePaymentTab = {
	                title: _constants.PaymentTypes.SINGLE_PAYMENT.label,
	                shortTitle: _constants.PaymentTypes.SINGLE_PAYMENT.shortLabel,
	                key: _constants.PaymentTypes.SINGLE_PAYMENT.type,
	                content: _this2.getPaymentPane(_constants.PaymentTypes.SINGLE_PAYMENT.type)
	            };
	            if (_this2.props.staticData.makePaymentSinglePaymentFirst) {
	                tabs.unshift(singlePaymentTab);
	            } else {
	                tabs.push(singlePaymentTab);
	            }
	        }
	        if (props.hasToken && props.autoPaymentMethods.length > 0) {
	            tabs.push({
	                title: _constants.PaymentTypes.UPDATE_PAYMENT.label,
	                shortTitle: _constants.PaymentTypes.UPDATE_PAYMENT.shortLabel,
	                key: _constants.PaymentTypes.UPDATE_PAYMENT.type,
	                content: _this2.getPaymentPane(_constants.PaymentTypes.UPDATE_PAYMENT.type)
	            });
	        }
	        return tabs;
	    };
	
	    this.getAdminTabsData = function (nextProps) {
	        var props = nextProps ? nextProps : _this2.props;
	        var tabs = [];
	        if (_this2.getAdminChargePaymentMethods(props).length > 0) tabs.push({
	            title: _constants.PaymentTypes.CHARGE.label,
	            shortTitle: _constants.PaymentTypes.CHARGE.shortLabel,
	            key: _constants.PaymentTypes.CHARGE.type,
	            content: _this2.getPaymentPane(_constants.PaymentTypes.CHARGE.type) });
	        if (_this2.getAdminPaymentPlans(props).length > 0) tabs.push({
	            title: _constants.PaymentTypes.PAYMENT_PLAN.label,
	            shortTitle: _constants.PaymentTypes.PAYMENT_PLAN.shortLabel,
	            key: _constants.PaymentTypes.PAYMENT_PLAN.type,
	            content: _this2.getPaymentPane(_constants.PaymentTypes.PAYMENT_PLAN.type) });
	        if (_this2.getAdminAutoPaymentMethods(props).length > 0 || props.hasToken) tabs.push({ title: _constants.PaymentTypes.PAYMENT_TOKEN.label,
	            shortTitle: _constants.PaymentTypes.PAYMENT_TOKEN.shortLabel,
	            key: _constants.PaymentTypes.PAYMENT_TOKEN.type,
	            content: _this2.getPaymentPane(_constants.PaymentTypes.PAYMENT_TOKEN.type) });
	        return tabs;
	    };
	
	    this.getTabsMobile = function (hasToken) {
	        var tabs = _this2.props.isAdminPayments ? _this2.getAdminTabsData() : _this2.getTabsData();
	        if (tabs.length === 0) return null;
	        return _react2.default.createElement(
	            _reactBootstrap.Tabs,
	            { id: "payments-tab",
	                defaultActiveKey: tabs[0].title, className: hasToken ? "has-token" : "",
	                onSelect: _this2.setSelectedTab },
	            tabs.map(function (tab) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { title: tab.shortTitle, unmountOnExit: true, eventKey: tab.title,
	                        key: tab.title, tabClassName: "_" + tabs.length },
	                    tab.content
	                );
	            })
	        );
	    };
	
	    this.getTabs = function () {
	        var tabs = _this2.props.isAdminPayments ? _this2.getAdminTabsData() : _this2.getTabsData();
	        if (tabs.length === 0) return null;
	        return _react2.default.createElement(
	            _SelectionTabs2.default,
	            { update: _this2.setSelectedTab, selectedTabTitle: _this2.getPaymentTitle() },
	            tabs.map(function (tab) {
	                return _react2.default.createElement(
	                    _SelectionPane2.default,
	                    { label: tab.title, key: tab.key },
	                    tab.content
	                );
	            })
	        );
	    };
	
	    this.renderPage = function () {
	        switch (_this2.state.page) {
	            case "ThankYouPage":
	                return _react2.default.createElement(_ThankYouPage2.default, { pageContext: (0, _utils.getPageContext)(), seasonUrl: _this2.props.staticData.seasonUrl,
	                    memberKey: _this2.props.memberDetails.key,
	                    mode: _this2.props.paymentType,
	                    extraMessage: (_this2.props.staticData.params || {}).message,
	                    farmUrl: _this2.props.staticData.farmUrl });
	            case "LogInScreen":
	                return _react2.default.createElement(_LogInScreen2.default, null);
	            case "EcheckForm":
	                var totalToPay = _this2.props.paymentType !== _constants.PaymentTypes.PAYMENT_TOKEN.type ? _this2.props[_this2.props.paymentType + "PaymentPlan"].totalToPay : undefined;
	                return _react2.default.createElement(_EcheckForm2.default, { pageContext: _constants.URLs.PAY, amount: _this2.props.paymentPlanAmount, totalToPay: totalToPay });
	            case "EBTForm":
	                var totalToCharge = _this2.props.paymentType !== _constants.PaymentTypes.PAYMENT_TOKEN.type ? _this2.props[_this2.props.paymentType + "PaymentPlan"].totalToPay : undefined;
	                return _react2.default.createElement(_EBTForm2.default, { pageContext: _constants.URLs.PAY, amount: _this2.props.paymentPlanAmount, totalToPay: totalToCharge });
	            case "PaymentsHost":
	                return _react2.default.createElement(_PaymentsHost2.default, { pageContext: _this2.props.isAdminPayments ? _constants.URLs.CHARGE : _constants.URLs.PAY });
	            case "LoadingAnimation":
	                return _react2.default.createElement(_LoadingAnimation2.default, null);
	            case "Tabs":
	                var title = !_this2.props.isAdminPayments ? (0, _translate.translate)("Manage Payments") : (!_this2.props.clientViewPort.isXs ? "Manage Payments | " : "") + _this2.getAdminMemberName();
	                var showPreApprovalHeader = _this2.props.hasPreapproval && _this2.props.subscriptionPaymentPlan;
	                return _react2.default.createElement(
	                    "div",
	                    { className: "manage-payment-screen" + (_this2.props.clientViewPort.isXs ? "-mobile" : "") },
	                    _react2.default.createElement(
	                        "fieldset",
	                        { disabled: _this2.props.showLoading },
	                        _react2.default.createElement(_AccountNavigationHeader2.default, { buttons: _this2.getButtons(), title: title,
	                            fullWidth: _this2.props.isAdminPayments }),
	                        _this2.getUserMenu(),
	                        _this2.props.hasPreapproval || _this2.props.subscriptionPaymentPlan ? _react2.default.createElement(
	                            "div",
	                            { className: "preapproval-text" },
	                            showPreApprovalHeader && _this2.getPreApprovalText(),
	                            !showPreApprovalHeader ? undefined : _this2.props.clientViewPort.isXs ? '; ' : _react2.default.createElement("br", null),
	                            _this2.props.subscriptionPaymentPlan && _this2.getPaymentPlanText()
	                        ) : undefined,
	                        _this2.props.clientViewPort.isXs ? _this2.getTabsMobile(_this2.props.hasPreapproval || _this2.props.subscriptionPaymentPlan) : _this2.getTabs()
	                    ),
	                    _this2.getRemoveTokenPopup()
	                );
	        }
	    };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var summary = state.summary;
	    var isAdminPayments = (0, _utils.getPageContext)() === _constants.URLs.CHARGE;
	    return {
	        clientViewPort: state.clientViewPort || {},
	        staticData: state.staticData,
	        isAdminPayments: isAdminPayments,
	        isPreview: (state.staticData || {}).isPreview,
	        memberDetails: state.memberDetails || {},
	        hasPreapproval: summary.hasPreapproval,
	        singlePaymentPlan: summary.singlePaymentPlan,
	        singlePaymentMethod: summary.singlePaymentMethod,
	        autoPaymentPlan: summary.autoPaymentPlan,
	        autoPaymentMethod: summary.autoPaymentMethod,
	        updatePaymentMethod: summary.updatePaymentMethod,
	        chargePaymentPlan: summary.chargePaymentPlan,
	        chargePaymentMethod: summary.chargePaymentMethod,
	        planPaymentPlan: summary.planPaymentPlan,
	        tokenPaymentMethod: summary.tokenPaymentMethod,
	        paymentMethodToken: summary.paymentMethodToken,
	        paymentPlans: summary.makePaymentPaymentPlans,
	        paymentMethods: summary.makePaymentPaymentMethods,
	        singlePaymentMethods: summary.singlePaymentMethods || {},
	        autoPaymentMethods: summary.autoPaymentMethods || {},
	        singlePaymentPlans: summary.singlePaymentPlans,
	        autoPaymentPlans: summary.autoPaymentPlans,
	        subscriptionPaymentPlan: summary.paymentPlan,
	        paymentPlanAmount: isAdminPayments ? (summary.chargePaymentPlan || {}).amount : (summary.singlePaymentPlan || {}).amount,
	        showBack: (0, _utils.getUrlParams)().source === 'account',
	        paymentType: summary.paymentType,
	        hasToken: summary.hasToken,
	        allowContinue: summary.allowContinuePayment,
	        showLoading: (0, _fetchingActions.isFetching)(state, _constants.FetchingTypes.SUBMIT)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        initServerStaticData: function initServerStaticData() {
	            dispatch((0, _staticDataActions.initServerStaticData)());
	        },
	        initMemberData: function initMemberData() {
	            dispatch((0, _memberDetailsActions.initMemberData)());
	        },
	        setAndRemoveUrlParams: function setAndRemoveUrlParams(onlyHidden) {
	            dispatch((0, _commonActions.setAndRemoveUrlParams)(onlyHidden));
	        },
	        setMemberKey: function setMemberKey(memberKey) {
	            dispatch((0, _memberDetailsActions.setMemberKey)(memberKey));
	        },
	        getSubscriptionSummary: function getSubscriptionSummary(asAdmin, withBalance) {
	            dispatch((0, _accountActions.getSubscriptionSummary)(asAdmin, withBalance));
	        },
	        checkIsDirty: function checkIsDirty(check, onLeaveCallBack) {
	            if (check) dispatch((0, _commonActions.checkIsDirty)(onLeaveCallBack));else onLeaveCallBack();
	        },
	        goBack: function goBack() {
	            dispatch((0, _commonActions.setDirty)(false));
	            window.history.back();
	        },
	        makeExtraPayment: function makeExtraPayment(clientMode, amount, paymentMethod, paymentPlan) {
	            dispatch((0, _paymentActions.makeExtraPayment)(clientMode, amount, paymentMethod, paymentPlan));
	        },
	        redirectToPaymentDetails: function redirectToPaymentDetails(clientMode, paymentMethod, paymentPlan) {
	            dispatch((0, _paymentActions.redirectToPaymentDetails)(clientMode, paymentMethod, paymentPlan));
	        },
	        updatePaymentPlan: function updatePaymentPlan(paymentPlan) {
	            dispatch((0, _paymentActions.updatePaymentPlan)(paymentPlan.key !== 'none' ? paymentPlan : undefined));
	        },
	        getPath: function getPath(path) {
	            dispatch((0, _reactRouterRedux.replace)(path));
	        },
	        setPaymentType: function setPaymentType(paymentType) {
	            dispatch((0, _subscriptionSummaryActions.setPaymentType)(paymentType));
	        },
	        setAllowContinuePayment: function setAllowContinuePayment(allowContinuePayment) {
	            dispatch((0, _subscriptionSummaryActions.setAllowContinuePayment)(allowContinuePayment));
	        },
	        adminChargeWithToken: function adminChargeWithToken() {
	            dispatch((0, _paymentActions.adminChargeWithToken)());
	        },
	        removeAutomaticPayment: function removeAutomaticPayment() {
	            dispatch((0, _paymentActions.removeAutomaticPayment)());
	        },
	        adminChargeWithoutToken: function adminChargeWithoutToken() {
	            dispatch((0, _paymentActions.adminChargeWithoutToken)());
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PayHomeScreen);

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(427);
	
	var _PaymentMethods = __webpack_require__(820);
	
	var _PaymentMethods2 = _interopRequireDefault(_PaymentMethods);
	
	var _PaymentPlansSelection = __webpack_require__(1125);
	
	var _PaymentPlansSelection2 = _interopRequireDefault(_PaymentPlansSelection);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _constants = __webpack_require__(463);
	
	var _subscriptionSummaryActions = __webpack_require__(758);
	
	var _commonActions = __webpack_require__(747);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentPane = function (_React$Component) {
	    _inherits(PaymentPane, _React$Component);
	
	    function PaymentPane() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PaymentPane);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentPane.__proto__ || Object.getPrototypeOf(PaymentPane)).call.apply(_ref, [this].concat(args))), _this), _this.setPaymentMethod = function (paymentMethod) {
	            _this.props.setPaymentMethod(paymentMethod, _this.props.paymentType);
	        }, _this.setPaymentPlan = function (paymentPlan) {
	            _this.props.setPaymentPlan(paymentPlan, _this.props.paymentType);
	        }, _this.showPaymentMethods = function () {
	            if (_this.props.hasToken && _this.props.paymentType === _constants.PaymentTypes.AUTO_PAYMENT.type) {
	                return null;
	            } else if (!_this.props.hasToken && _this.props.paymentType === _constants.PaymentTypes.UPDATE_PAYMENT.type) {
	                return null;
	            } else {
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { key: "payment-methods" },
	                    _react2.default.createElement(_PaymentMethods2.default, { paymentMethods: _this.props.paymentMethods,
	                        setSelectedMethod: _this.setPaymentMethod,
	                        pageContext: _constants.URLs.PAY,
	                        selectedMethod: _this.props[_this.props.paymentType + "PaymentMethod"],
	                        paymentType: _this.props.paymentType,
	                        hasToken: _this.props.hasToken })
	                );
	            }
	        }, _this.showPaymentPlans = function () {
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                { key: "payment-plans" },
	                _react2.default.createElement(_PaymentPlansSelection2.default, { paymentPlans: _this.props.paymentPlans,
	                    paymentPlan: _this.props[_this.props.paymentType + "PaymentPlan"],
	                    setPaymentPlan: _this.setPaymentPlan,
	                    customAmount: _this.props.customAmount,
	                    setCustomAmount: _this.props.setCustomAmount,
	                    paymentType: _this.props.paymentType,
	                    allowNone: _this.props.allowNone,
	                    balance: _this.props.balance })
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PaymentPane, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _reactBootstrap.Grid,
	                null,
	                this.showPaymentPlans(),
	                this.showPaymentMethods()
	            );
	        }
	    }]);
	
	    return PaymentPane;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var summary = state.summary;
	    return {
	        singlePaymentPlan: summary.singlePaymentPlan,
	        singlePaymentMethod: summary.singlePaymentMethod,
	        autoPaymentPlan: summary.autoPaymentPlan,
	        autoPaymentMethod: summary.autoPaymentMethod,
	        updatePaymentMethod: summary.updatePaymentMethod,
	        chargePaymentPlan: summary.chargePaymentPlan,
	        chargePaymentMethod: summary.chargePaymentMethod,
	        planPaymentPlan: summary.planPaymentPlan,
	        tokenPaymentMethod: summary.tokenPaymentMethod,
	        customAmount: summary.customAmount,
	        balance: summary.balance
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setPaymentMethod: function setPaymentMethod(paymentMethod, paymentType) {
	            dispatch((0, _subscriptionSummaryActions.setPaymentMethod)(paymentMethod, paymentType));
	            dispatch((0, _commonActions.setDirty)(true));
	        },
	        setPaymentPlan: function setPaymentPlan(paymentPlan, paymentType) {
	            dispatch((0, _subscriptionSummaryActions.setPaymentPlan)(paymentPlan, paymentType));
	            dispatch((0, _commonActions.setDirty)(true));
	        },
	        setCustomAmount: function setCustomAmount(customAmount) {
	            dispatch((0, _subscriptionSummaryActions.setCustomAmount)(customAmount));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PaymentPane);

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(338);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _constants = __webpack_require__(463);
	
	var _basket = __webpack_require__(757);
	
	var _translate = __webpack_require__(464);
	
	var _utils = __webpack_require__(485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentPlansSelection = function (_React$Component) {
	    _inherits(PaymentPlansSelection, _React$Component);
	
	    function PaymentPlansSelection() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PaymentPlansSelection);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentPlansSelection.__proto__ || Object.getPrototypeOf(PaymentPlansSelection)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelected = function (plan) {
	            _this.props.setPaymentPlan(plan);
	        }, _this.handleChangeAmount = function (plan, event) {
	            var amount = event.target.value;
	            if (!/^\d+(?:[.]\d*?)?$/.test(amount) && amount !== "") {
	                return;
	            }
	            if (amount === '') amount = 0;
	            _this.props.setCustomAmount(amount);
	            amount = parseFloat(amount);
	            if (isNaN(amount)) {
	                return;
	            }
	            _this.handleSelected(Object.assign({}, plan, { amount: amount }));
	        }, _this.getAmount = function (plan) {
	            if (plan.type === _constants.PaymentPlans.DynamicPrePayment || plan.type === _constants.PaymentPlans.DistributionDynamicPrePayment) return plan.totalToPay;
	            return plan.amount;
	        }, _this.getPlan = function (plan) {
	            var selected = _this.props.paymentPlan ? plan.key === _this.props.paymentPlan.key : false;
	            if (plan.isPayMyDebit && _this.props.balance < -0.1) {
	                plan.amount = _this.props.balance * -1;
	            }
	            var amount = _this.getAmount(plan);
	            if (plan.type === _constants.PaymentPlans.CustomPrePayment && plan.isPayMyDebit && _this.props.balance > -0.1) {
	                return null;
	            }
	            return _react2.default.createElement(
	                _reactBootstrap.Radio,
	                { name: "methodPlan", checked: selected, key: plan.key, onChange: _this.handleSelected.bind(_this, plan) },
	                plan.type === _constants.PaymentPlans.CustomPrePayment && !plan.isPayMyDebit ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement("input", { type: "text", className: "payment-amount-input", placeholder: "Enter Amount",
	                        onChange: _this.handleChangeAmount.bind(_this, plan),
	                        value: _this.props.customAmount === 0 ? "" : _this.props.customAmount }),
	                    _react2.default.createElement("div", { className: "payment-amount-description",
	                        dangerouslySetInnerHTML: { __html: plan.note } })
	                ) : _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "b",
	                        { name: "paymentAmount" },
	                        _this.props.paymentType === _constants.PaymentTypes.PAYMENT_PLAN.type || plan.type === _constants.PaymentPlans.OneWeekDebit || plan.key === 'none' ? plan.title : (0, _basket.formatMoney)(amount)
	                    ),
	                    _react2.default.createElement("div", { className: "payment-amount-description",
	                        dangerouslySetInnerHTML: { __html: plan.note } })
	                )
	            );
	        }, _this.getPlans = function () {
	            var plans = [];
	            for (var key in _this.props.paymentPlans) {
	                if (_this.props.paymentPlans.hasOwnProperty(key)) {
	                    var plan = _this.props.paymentPlans[key];
	                    if (plan.type === _constants.PaymentPlans.CustomPrePayment) {
	                        plans.unshift(_this.getPlan(plan));
	                    } else {
	                        plans.push(_this.getPlan(plan));
	                    }
	                }
	            }
	            var isAdminPayments = (0, _utils.getPageContext)() === _constants.URLs.CHARGE;
	            if (_this.props.allowNone) {
	                plans.push(_this.getPlan({ key: 'none', title: 'Cancel', note: isAdminPayments ? 'Remove payment plan' : 'Cancel automatic charges' }));
	            }
	            return plans;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PaymentPlansSelection, [{
	        key: "render",
	        value: function render() {
	            if (this.props.paymentType === _constants.PaymentTypes.PAYMENT_TOKEN.type || this.props.paymentType === _constants.PaymentTypes.UPDATE_PAYMENT.type) return null;
	            var title = this.props.paymentType === _constants.PaymentTypes.CHARGE.type ? "Enter Charge Amount" : this.props.paymentType === _constants.PaymentTypes.PAYMENT_PLAN.type ? "Select Payment Plan" : "Select Payment Amount";
	
	            return _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                    "h4",
	                    null,
	                    (0, _translate.translate)(title)
	                ),
	                this.getPlans()
	            );
	        }
	    }]);
	
	    return PaymentPlansSelection;
	}(_react2.default.Component);
	
	PaymentPlansSelection.defaultProps = {
	    customAmount: ""
	};
	exports.default = PaymentPlansSelection;

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js